module.exports={
"label_emailtocloudcc_department":`支部`,
"label.wei.weiresearch":`Micro Vote`,
"message.error.appsecret.null":`暗号化キー（パスワード）は空にしてはいけません。`,
"label.file.orderbylastmodifydate":`前回の更新日に基づき、並び替えます`,
"label.minus":`-マイナス`,
"label.horizontalbar":`レコードレベル`,
"label.emailobject.emailsentfailed":`メールの送信に失敗しました！`,
"assignedresource.check":`このサービスリソースは、サービス予約に割り当てられています。繰り返して追加しないでください。`,
"label.finish":`完了`,
"label.document.history":`ダウンロード履歴`,
"label.customfields.number.numberLengthHelpText":`1.入力する数字の長さと小数点以下桁数：数字の長さが8、小数点以下桁数が2であれば、可能な最大桁数は12345678.90になります。`,
"label.standard.buttonandlink.info":`標準ボタンとリンクのリライトで、CloudCC URL 及び当該URLに対するすべての転用（例えばCloudCCページ、ブラウザーのショートカット、外部システム）が変更されました。CloudCCのカスタマページで標準ボタン及びリンクのCloudCC URLを置き換えることもできます。`,
"front-epwechat-module-v1-contacts-desc":`有効にすると、CloudCCシステムにWeCom Contactsのオブジェクトが追加され、WeComの顧客情報がこのオブジェクトに同期されます。`,
"label.mr.caption.contact.result":`重複検索&マージ：取引先責任者の重複データの検索結果`,
"label.ems.selectaccount":`アカウントの選択`,
"label.group.no.activity":`一致する活動チームはありません`,
"label.call.for":`招待者`,
"label.newreportguide":`新規レポートウィザードを作成`,
"component.telerecord.label.name":`名前`,
"vue.add.dashboard.component":`コンポーネント{titleName}の追加`,
"label.chatter.sendEmailToGroupMember.check.V":`投票を見る`,
"UG.ST.002":`確認`,
"label.setting.intergrationmanage":`統合管理`,
"label.field.apiname.validate":`0から6までの1桁数字を入力してください`,
"label.emailmerge.list.deletefolder":`ファイルを削除`,
"vue_label_pool_received":`受取済み`,
"label_emailtocloudcc_step1_case1":`Email to Case`,
"message.sumlength":`長さと小数以下桁数との和は18位を超えてはいけません`,
"vue_label_approve_reassignapproval":`{name}は承認を{people}に再度割り当てました`,
"label.specify.time":`時間：2016年6月21日 13:00`,
"vue_label_report_sortdown":`降順で並び替える`,
"chatter.login.now":`アップロード中`,
"label.import.page2.notsuited":`対応付けされていない`,
"label.please.fill.out":`記入してください`,
"label.recordtype.edit.description":`使用可能なリスクからあるオプションを選択し、このレコードタイプの選択リスク値として、選択した値リスクに追加します。ご注意：選択リスクからあるオプションを削除しても、いずれの既存レコードからこのオプションを削除することができません。最後にこのレコードタイプにデフォルト選択リスク値を選択します。`,
"label.customer.tab.new":`新規カスタマタブ`,
"label.sameas":`同じ`,
"front-filter-module-v1-filter-a-week-ago":`一週間前`,
"label.processsetting.disable.process.failed":`プロセスの無効化に失敗しました。`,
"label.summaryreport.2018.step4":`ステップ4.レポート標準の選択`,
"label.secrecyinfo":`秘密情報-漏らさないでください`,
"label.custom.page.component.general.settings":`コンポーネントの一般設定`,
"label.ccpeak.folder":`ファイリングされていないフォルダ`,
"vue_label_homepage_select_button_operation":`ボタン操作項目の選択`,
"message.pleaseinputrightdistance":`正しい間隔（日数）を入力してください`,
"label.mobile.phone.required.short":`需要`,
"vue_label_account_equityseructure":`持分構成図`,
"label.file.library.error1":`このファイルはすでにこのライブラリ内にあります。`,
"fliter.nextmonth":`来月`,
"label.mr.descreption.oneGroupNote2":`企業情報、共有`,
"label.allfolderdashboard":`すべてのダッシュボードファイル`,
"lable.opppdt.selPdt.bykeywords":`キーワードに基づく`,
"setup_layout_label_selectedfield":`項目の選択`,
"label.file.preview.convert.firstpage.failure":`プレビューの時、エラーが発生し、プレビューの詳細情報をクリックし、またはダウンロードして参照してください`,
"vue_label_systemSettings_companie":`会社設立`,
"label.loginhis.recently":`最近のログイン履歴`,
"label.permission.visualpagepermission.edit":`カスタマページの割り当て`,
"label.ccservice.validate.email":`オブジェクトAPIは{0}の下の{1}項目で対応値が{2}です。その表示形式がエラーで、正しいメールアドレスを入力してください。`,
"label.sms.companyname.gm":`創明網絡SMSインターフェス`,
"lable.opppdt.addpdt.table.discount":`割引(%off)`,
"Lead.Scoring.Setting.LevelSetting":`リード人気の設定`,
"message.duplication.label.duplicationremark":`レコードの新規作成あるいは編集に対する重複データの検索アクションです`,
"label.file.preview.error":`プレビューの時、エラーが発生し、ダウンロードして参照してください`,
"label.imgfield.type.input":`画像の入力`,
"label.file.share.email.content1":`ファイル名：#filename`,
"vue_label_notice_batchedit_fail":`{0} であるIDのデータ更新に失敗しました。失敗の理由は {1}です。`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`四週間目`,
"label.view.sortview.printview":`ビューをプリンター
`,
"label.projectManagement.Addposttask":`ポストタスクの追加`,
"vue_label_commonobjects_view_fail":`デフォルトビューの設定に失敗しました`,
"label.dayinweek":`週間の`,
"label.layout.notexist":`レイアウトは存在しません。`,
"label.brief.total":`レコード{total}件`,
"label.dashboardSetup.tz.bb":`レポートにスキップ`,
"label_emailtocloudcc_select3":`レコードの所有者を選択してください`,
"label.input.least.string":`少なくとも{0} 文字を入力してください`,
"label.app.step2":`ステップ2.詳細情報の入力`,
"lable.account.LastWeek":`先週`,
"label.notifications":`お知らせ`,
"label.tabpage.viewname":`ビュー名`,
"label.knowledge.language.italian":`イタリア語`,
"label.sendmail.step2.introduce":`使用するメールテンプレートの選択`,
"label_enable_or_no":`有効化しますか`,
"pagecreator_button_save":`保存`,
"template.chart.cplb":`製品カテゴリー`,
"label.knowledge.publish":`要求に合っていないため公開できません。`,
"label.name.required":`名前の欄は必須です。`,
"component.chatter.label.myfans":`私のフォロワー`,
"label.rejectoperate":`却下アクション`,
"label.report.action.addtodashboard3":`ダッシュボードの選択`,
"label.icon.101":`教科書`,
"label.data.exp.su.ok":`システムはエクスポート中`,
"label.appupload.component.type.layout":`ページレイアウト`,
"template.chart.yscb":`予算コスト`,
"label.tabularreport.selectorder":`各レポートの表示順番を確定`,
"email.title.one":`パスワードを取り戻す`,
"label.case.copy.link":`ウェブリンクのコピー`,
"label.mr.descreption.oneGroupReData4":`チーム、まだ残っています`,
"label.newprocess5.error.des":`数字のみ入力可能`,
"label.partnerCloud.loginButton":`ログインボタン`,
"label.interfaceconstraint.adminonly":`管理者のみがこのインターフェースを使用することができます`,
"label.campaign.channel.input.date":`2、販売チャンネルの有効期限を設定してください`,
"label.clientwebsiteentranceprofile":`取引先のサイト入口　プロファイル`,
"UG.opportunity.011":`取引のインポート`,
"label.page.copy.value.paste.template":`差し込み項目値をコピーし以下のテンプレート内に貼り付けてください。`,
"label.notselect":`選択されていない`,
"label.weixin.input.password":`パスワードを入力してください`,
"label.email.select.template":`テンプレートの選択`,
"label_chatter_ok":`確認`,
"permissionService.error":`権限セットの割り当てに失敗しました。アプリケーションの許可が期限切れかどうか、または上限に達しているかどうか確認してください。`,
"label.webtocloudcc.sorry":`ごめんなさい、WEBページで異常が発生しました。改めて試して、または管理者に連絡してください。`,
"UG.opportunity.007":`取引先の役割`,
"label.manageAll.forapproval":`承認待ち`,
"label.imgfield.type.ref":`数式画像`,
"label.profile.setcustomtab":`カスタマタブの設定`,
"label.tabpage.datatyoez":`データタイプ`,
"label.partnerCloud.basicSetting.editPersonal":`パートナークラウドのユーザーが個人情報を編集できるようにする`,
"label.mr.caption.account":`重複検索&マージ：取引先の重複データの検索条件`,
"message.serviceterritoryMe.time.violation":`送信時間の違反：送信時間がエリアメンバーの時間範囲内ではありません`,
"pagecreator_page_message_publish_success":`ページのリリースに成功しました`,
"label.field.formula.timezonetip":`日付関数の複数タイムゾーンのサポートにご注意ください。数式にはSYCO ATEなどのシステム関数で現在の時間を取得する場合には、CURRENT_DATEのような複数タイムゾーンがサポートできる関数を使用すべきです。`,
"label.marketseamemset.specialuser":`スペシャルメンバー`,
"label.staticresource.message":`静的リソースの詳細情報`,
"label.workflow.rulecondition":`ルール条件`,
"component_salesperformance_label_nodata":`商談を追加してから、ここに戻して業績情報を参照してください。`,
"label.customfields.textarea.tip":`複数行にわたって、4000 文字まで入力できます。`,
"font-evaluate-module-v1-template":`カスタムテンプレート`,
"label.step3.total5":`ステップ 3/5`,
"label.customfields.formula.percent.tip":`パーセンテージを計算し、また自動的に数字にパーセント記号を追加します`,
"label.sortdesc":`降順`,
"lable.PowerProcess.edit":`エンタイトルメントプロセスの編集`,
"label.dongshifang.description":`東時方のSMSインタフェース情報を設定して、組織のショートメッセージの送受信業務の需要を満たします。`,
"label.chatter.addressee":`受信者`,
"vue_label_systemSettings_obj2":`オブジェクト管理コンソール`,
"label.selectreporttype.tip":`レポートのデータタイプを選択`,
"label.version.enterprise":`企業版`,
"label.area.add":`エリアの追加`,
"label.h5.bookmarked":`ブックマーク`,
"label.step5.total7":`ステップ 5/7`,
"front-lightning-module-v1-title-quotation":`プレビュー引用`,
"label.search.onlymyrecords":`私が持つプロジェクトに限ります`,
"vue_label_commonobjects_noduplication":`{记录}の{字段}と重複しています`,
"label.customerpage.edit":`カスタマページタブの編集`,
"message.please.choose.user":`ユーザを選択してください`,
"label.approval.his.currentactor":`現在の承認者`,
"label.field.duplicate.error.msg3":`3ユニークプロパティ項目まで作成します`,
"label.page_url":`ページURL`,
"label.permission.goback":`権限セットサマリーに戻る`,
"vue_label_commonobjects_view_kanban_notice2":`すべてのレコードを表示するには、リストビューまたはスプリットスクリーンビューを使用してください`,
"label.group.no.recent.searchs":`マッチした最近表示のチームはありません`,
"label.event.fiducial.point":`時間通り`,
"label.integrations.mailchimp.addtolist":`CloudCCのリードと取引先責任者をMailchimpの受信者に追加する`,
"label.workflow.configrule.introduce":`ルール名、説明、ルールを起動させる条件を入力してください。その後、当該ワークフロールールにアクションを関連付けてください。`,
"label.icon.161":`スーツケース`,
"label.recordtype.enable":`有効化`,
"label_mailboxes_limit":`メールアドレスの数が上限を超えています。`,
"label.notification.time3":`{0}時間前`,
"label.setsharerule.step2":`ステップ 2: 共有するレコードを選択します`,
"vue_label_homepage_somecomponents":`ご注意ください。コンポーネントを追加したら高さがオーバーして表示が不完全になりました。一部のコンポーネントを削除してください。`,
"label.icon.63":`地下井戸`,
"label.use.standard.sharerules":`標準シェアルールの使用`,
"label.button.step2.select.required.field":`ステップ2.必須項目の選択`,
"lable.Confirm.collect.potential.customers":`リード{name}の受取を確認します`,
"label.version.sum.custompage":`カスタマページ`,
"label.file.ccchat.changefile":`ファイルの更新`,
"label.mobile.phone.phone.call":`コール`,
"label.appupload.managed.img":`マネージド`,
"vue_label_chatter_comment":`コメント`,
"label.central.european.time":`中央ヨーロッパ時間`,
"label.three.quarter":`第3四半期`,
"label.service.newBuildDialog.filter.editor":`フィルターエディター`,
"pagecreator_systemstyle_funcpath":`/ページビルダー/ブランド化のスタイルライブリー`,
"label_chatter_collect":`ブックマーク`,
"label.custom.page.component.window.settings":`コンポーネントウィンドウの設定`,
"component_chatter_file_label_title":`ファイルのアップロード`,
"label.marketsea.button.discard":`廃棄`,
"label.Batch.input":`バッチ入力`,
"vue_label_campaign_market_members":`既存のキャンペーンメンバー`,
"label.salescloud.salesdashboard":`セールスボード`,
"message.summaryconditionrepeated":`集計条件は重複で、再選択してください。`,
"label.tianyancha.h5.companycode":`会社コード`,
"label.quickbooks.description":`QuickBookアカウント情報を設定して、オンラインでの請求と支払状況を追跡します。`,
"label.colombia.time":`コロンビア時間`,
"label.usermanage.unknown.license":`知らないライセンスで、ユーザを作成することができません。システム管理者に連絡してください。`,
"label.operatedata.selectoperateandobject":`アクション（インポートORエクスポート）とオブジェクトの選択`,
"message.setup.field.picklist.valuerepeated":`リスク値は重複できません。再入力してください。`,
"label.editerror.list":`未編集のデータリスト`,
"pagecreator_page_message_save_success":`ページの保存に成功しました`,
"label.icon.154":`コンピューター`,
"label.emailsync.setting":`個人用メールの設定`,
"label.startuploadfile.step2":`ステップ3.［アップロードを開始］をクリックして、ファイルをアップロードします`,
"label.dashboard.notmeet.conditions":`条件に一致する情報はありません。ダッシュボードをまだ配置していません。`,
"label.temp.del.conf":`確かに削除しますか。`,
"label.sms.authkey":`パスワードの認証`,
"lable.oppt.jieduan.choosejieduan":`完了済み段階の選択`,
"label.tabpage.viewNamez":`ビュー名を入力してください`,
"label.totalQuotation":`見積りの総額`,
"label.tabpage.hoursagoz":`時間前`,
"label.receiveadminnews":`管理者のニュースダイジェストの受取`,
"label.field.is.lookup":`項目は検索項目に関連付けますか`,
"label.any_changes":`ここで行われた変更は、以下のようにフッターも更新されます。`,
"lable.products.to.assets":`製品から資産への移行を確認しますか？`,
"label.dashboard.compare":`比較`,
"vue_label_chatter_notice1":`グループを削除すると、グループ内のすべての情報が削除されますが、グループのファイルは削除されません。`,
"label_tabpage_exitz":`ログアウト`,
"label.potentialcustomerflow":`リードプロセス`,
"label.longtext":`ロングテキストエリア`,
"october":`十月`,
"label.customer.email":`メール`,
"label.partnerCloud.productSet.addChildren":`サブレベルの追加`,
"label.defaultline.cannot.greater":`デフォルト行数は30行を超えてはいけません`,
"front-detail-module-v1-view-report":`レポートを見る`,
"label.knowledge.setting.hint.sixteen":`知識を蓄え、発信し続ける`,
"label.page.use.merged.field":`差し込み項目の使用`,
"label.salescloud.salescloud.continuerecover":`続くなら、削除アクションを執行し、復元することができません。`,
"front-project-module-v1-from-template-create":`テンプレートからの作成`,
"label.exportall":`すべてエクスポート`,
"label.weixin.recalculate.shared.results":`共有ルールの結果を再集計`,
"label.components.isTemplate":`テンプレートデータ`,
"label_emailsync_status":`ユーザメールのステータス`,
"label.file.library.delete":`{librayrname}を削除しますか?`,
"label.integrations.username":`ユーザ名`,
"front-lightningset-module-v1-detail-page-report-chart":`詳細ページのレポートグラフ`,
"label_tabular":`リストtタイプ`,
"label.approverecords":`承認レコード`,
"vue_label_helpcenter_topic":`lightningバージョンの使い方とヘルプ`,
"label.h5.date.none":`なし`,
"lable.outlook.mcto.allrecord":`すべてのレコード`,
"label.readandwrite":`参照/更新`,
"label.allfold":`すべて折り畳む`,
"AD":`住所`,
"message.custom.field.donotdelete.reporttype":`この項目はレポートタイプに参照されている`,
"label.escalation.setup.newaction.title":`グレードアップアクションの編集`,
"label.dashboard.snapshot.settings":`ダッシュボードスナップショットの設定`,
"label.attendance.inner":`内勤`,
"chatter.ns":`新しメッセージ`,
"label.validate.nowork":`エラー：無効な項目で、改めて間違っている位置情報を選択してください`,
"label.custom.EmptyCanvas":`クリアキャンバス`,
"label.service.miniProgram.fillImageOrder":`カルーセルの順番を入力してください。`,
"label.icon.16":`サービス`,
"label.selected":`選択済み`,
"component_chatter_link_label_name":`リンク名`,
"label.reportsSubscriptionPage.schedulereport.starttime":`開始日`,
"label.file.uploadNewVersion":`新規バージョンのアップロード`,
"chatter.group.theMembership":`メンバーリレーションシップ`,
"label.knowledge.recommended.articles":`おすすめ記事`,
"label.appupload.install.parentobj":`所属のオブジェクト`,
"label.file.recent":`最近`,
"vue_label_helpcenter_quote":`見積書は、御社の製品やサービスの希望価格を表しています。商談とその製品から見積をすることができます。<br>詳細情報の右上にあるボタンを使って、商談から見積書を同期させたり、見積書を商談に同期させたりすることができます。見積書を商談に同期させると、見積書の行のいかなる変更でも商談の製品に同期し、その逆も同様です。各商談には、複数の関連見積書を持つことができ、いずれの見積は商談に同期することができます。<br>詳細情報の右上では、見積書をPDFに生成してプレビューし、また直接に印刷、ダウンロード、保存を行うことができます。`,
"message.error.field.default":`デフォルト値は必ず正整数です`,
"label.campaignmember.main.importmember.contacts.desc":`ファイルのデータをこのキャンペーン取引先責任者にインポートします`,
"vue_label_calendar_show_only_this_calendar":`このカレンダーのみ表示`,
"vue_label_quot_syncfrom":`商談からの同期`,
"label.data.expnode.e_desc2":`2、テンプレートによるエクスポート：ユーザはテンプレートを選択してデータをエクスポートすることができます。`,
"label.login.verification.mfa.desc1":`操作を引き続き行うため、まずスマートデバイスにMFAアプリケーションをインストールします。スマートデバイスのMFAアプリケーションにはTor Browser、Google Aushencatorがあります。`,
"label.jiandangfenpei.desc":`プロファイルの現在カスタマページへのアクセス権を割り当てします。システム管理者はすべてのカスタマページを訪問することができます。`,
"label_tabpage_thisrecord":`このレコード`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`代金受取の累計金額`,
"message.error.object.notvalidcurrency":`無効な通貨種類`,
"label.edit.discount":`エディットディスカウント`,
"label.setup.mobile.offlinecache.setenable":`モバイル端末のオフライン機能を有効化`,
"UG.ST.005":`わかりました。このページが再表示されずに、次回直接にログインします。`,
"label.assignedapprover":`割り当てされた承認者`,
"template.chart.htlx":`契約タイプ別統計`,
"scope":`範囲内にあります`,
"label.workmate.search":`同僚の検索`,
"message.validation.isnotdigits":`正しい数値を入力`,
"label.ccpeak.use.class.time.page":`カスタマページがこのクラスを転用するなら、PageClsInvokerクラスのinvoker(）方法を転用する必要があります。`,
"setup_mainpage_label_welcome27":`CloudCC クラウドプラットフォームでは、すべてのオブジェクトデータのインポート、エクスポート、データの一括削除、一括移行などができます。`,
"front-epwechat-module-v1-epwechat-integrate":`ウィーコム・インテグレーション`,
"label.file.publiclink":`公開リンク`,
"front-epwechat-module-v1-input-name":`企業の名前を入力してください。`,
"lable.Number.of.columns":`コラム`,
"message.error.dev.service.duplicateparameter":`サービスパラメータは重複しました。`,
"label.projectManagement.percent.complete":`完成のパーセンテージ`,
"label.chatter.nextSevenday":`これからの7日間`,
"chatter.feed.myfollowers":`私をフォローしている人`,
"label.bacchtransfer.pleaseselecttouser":`ユーザへの移行を選択`,
"label_partner_workspace_member_memo":`選定されたプロファイル、権限セットのすべてのユーザはこのパートナークラウドをアクセスすることできます。`,
"label.marketsea.chosen.member":`選択したメンバー`,
"label.marketsea.assignment.setup":`割当ての設定`,
"label.myaccount":`私の取引先`,
"label.schedulejob.setup.schedule.executedate":`執行時間`,
"label.uploadaccessory":`ファイルをアップロード`,
"Homepage.News.004":`ニュースはありません。`,
"label.marketsea.name":`プール名`,
"label.pending.task":`処理待ちのToDo`,
"label.report.details":`詳細情報`,
"UG.homepage.008":`現在のビジネス状況の把握（セールスブリーフィング、ランキング、セールスファネルなど）、問題となりそうな商談の表示、将来のパフォーマンスの予測、重要な問題のタイムリーな受け入れと割り当て、十分な情報に基づいた意思決定を行うことができます。`,
"label.h5.similar.opportunity.clear.all":`すべてのクリア`,
"label.tabpage.noz":`いいえ`,
"label.report.recent.all.reports":`すべてのレポート`,
"vue_label_lead_to_score":`スコアリングをクリックして、既存ビューでのリードをスコアリングします。`,
"vue_label_normal_receivable_sf":`代金受取計画`,
"label.layout.edittabdistribute":`タブレイアウトの編集`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(field)`,
"label.salescloud.field.editoptionlist":`選択リストの編集`,
"APPIntegration.Dropbox.01":`Dropboxからファイルを選択します`,
"label.campaign.channel.step2":`ステップ2.販売チャンネルのリード項目デフォルト値の設定`,
"label_partner_new_function":`機能説明`,
"vue_label_chat_no_search_results":`検索結果なし`,
"vue_label_commonobjects_detail_visitstate":`訪問状態`,
"label.sendemail.send.testemail":`これはテストメールで、このメールを受け取れば、このメールボックスでメールを送信するができることが分かります。`,
"label.attendance.clear.position":`ランドマークのクリア`,
"chatter.write.n":`コメントの編集`,
"label_chatter_sendmail":`メールの送信`,
"label.remindertime":`アラーム`,
"label.app.elegantgray":`グレー`,
"label.tabpage.ownedz":`共有`,
"label.select.approval":`承認者の選択`,
"UG.Lead.007":`Google同期`,
"chatter.emailSetUp":`私のメール受信の設定`,
"label.default.censor":`デフォルト承認者`,
"vue_label_notice_uploadavatar_success":`アバターのアップロードに成功しました`,
"label.sms.title":`SMSインターフェス情報`,
"front-console-choose-contact":`連絡先の選択`,
"label.field.edit.des":`最大評価は星アイコンで表示された数で、最大で100です`,
"label.pw.big.letter":`アッパーケース`,
"label.select.time.dimension":`時間軸を選択してください。`,
"UG_Campaign_004":`キャンペーンのインポート`,
"label.dashboard.summary":`総計値`,
"label.ems.yahoo":`ヤフー`,
"label.leadscore.rule.name":`スコアリール名`,
"vue_label_calendar_object_name":`オブジェクト名`,
"label.icon.69":`機械`,
"label.reporttotal":`合計`,
"lable.SalesCommitmentKanBan.theActualContract":`実際の契約金額`,
"label.project.member.data":`このユーザーはすでに現在のプロジェクトのメンバーです。`,
"label.cloudccclass.list.viewremark":`マニュアルを表示`,
"label.deleteObject.isNotAdministrator":`システム管理者ではないと、オブジェクトを削除することができません`,
"lable.edit.queue.nameandemail":`キュー名とメールアドレス`,
"label.recordtype.tabname":`レコードタイプ`,
"label.file.is.ok":`確定`,
"label.knowledge.language.german":`ドイツ語`,
"label.layout.realityapprover":`実際の承認者`,
"label.ems.with7day":`7日間以内`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`設定`,
"label.weixin.edit.polls":`投票の更新`,
"label.layout.mobile.default.tab":`携帯電話のデフォルトタブを選択`,
"vue_label_report_deletegroupcolumn":`グループ列の削除`,
"label.group.archived.success":`ファイリングに成功しました`,
"label.customfields.formula.returntype":`数式の戻り値型`,
"label.file.followers":`フォローされている`,
"label.textmessage.new.templates.message1":`テンプレート名を空にすることはできません。`,
"label.selected.field.length":`選択した項目は10つを超えてはいけません`,
"ObjectDetailed_ViewKeyInformation_Layout":`キー情報の編集`,
"label.paging.totalofpage":`{0}ページ`,
"label.ccchat.message.new.error41":`より多くの人と会話するなら、チームを使ってみてください`,
"message.recordtype.detail.noselectlist":`表示可能な選択リストがありません`,
"label.conditiontag.lookup.title":`追加する選択リスト値を選択してください`,
"label_partner_setup":`パートナークラウドの設定`,
"front-epwechat-module-v1-android-packname":`Androidのパッケージ名です。`,
"lable.custom.Current.CY":`現在のカスタマ年度`,
"label.newprocess2.desc":`割引が0.3 %以上である場合、評価がtureです。`,
"label.operatedata.selectobjectfields":`エクスポートするオブジェクト項目の選択`,
"report_reportdatasource_label":`レポートデータのソース`,
"label.chosesubject.others":`その他の活動`,
"label.list.desc2":`Web to CloudCC ページにPC版とモバイル版の2種類があります。PC版はパソコンによるアクセスに応じることに対して、モバイル版は携帯によるアクセス（例えば：Wechat）に応じます。`,
"vue_group_several_groups":`合計サイズ}グループ`,
"label.page.button.linkurl":`ボタンとリンクURL`,
"show.week":`週末を表示`,
"label.gotocalendar.new":`カレンダーで行動を作成する`,
"button.reset.advancedsearch":`高度な検索条件のクリア`,
"label.h5.chatter.feedandcomnum":`投稿とコメント`,
"lable.opppdt.addpdt.table.unitprice":`販売価格`,
"label.dataimport.validate":`執行する入力規則の選択`,
"label.lead.score":`リードスコアリング`,
"vue_label_help_product":`製品と価格表`,
"label.role.select":`選択済みのロール`,
"lable.opppdt.selPdt.searchproduct":`商品の検索`,
"component_event_label_newevent":`新規行動`,
"front-invoice-online-payment-setup-configure-button":`今すぐ設定`,
"label.stdashbord.xsld.business.img2":`可能性が1%―99%の段階にある総金額`,
"label.event.moveup.2week":`2週間`,
"label.partnerCloud.priceOfManual.allCustomer":`すべてのアカウント`,
"lable.account.dep":`［新規］をクリックして、新規会計年度を定義します`,
"label.dataimport.insertdata.error.null.update":`このレコードでの$schemefield_name$値はNULLであるため、更新アクションは執行できません。このレコードのエクスポートが見落とされています。`,
"label_component_helper_businesschange_0activity":`30日以内に何の活動もありません`,
"lable.account.NextbbDays":`これからの60日`,
"label_scope_length":`範囲-長さ`,
"label.customfields.operation":`データのエクスポートアクションを運用`,
"serviceappointment.save.workorder":`ワークオーダーのラインアイテムに関連するワークオーダーを選択してください。`,
"label.field.update.hide.editor":`フォーミュラエディターを隠す`,
"button.partner.new":`パートナークラウドの新規`,
"label.stdashbord.xsld.business.oppdetails":`業績詳細情報リスク`,
"message.pleasewaitingnextversion":`この機能は次のバージョンで追加されます。しばらくお待ちください。`,
"label_tabpage_potentialcustomersz":`リード`,
"label_emailtocloudcc_step2":`ステップ2`,
"label.weixin.username":`名前`,
"label.quickbooks.viewlist.type":`タイプ`,
"front-kefu-moudle-v1-Select-seats":`エージェントの選択`,
"label.customsetting.manage":`管理`,
"label.tabpage.field":`項目`,
"label.custom.page.button.icon.URL":`ボタンアイコンURL`,
"font-evaluate-module-v1-evaluation-link":`評価リンクの追加`,
"vue_label_salesfunnel_notice3":`1%～99%の確率で発生する商談の総件数`,
"front-email-payment-describe":`日頃より弊社事業にご協力いただきありがとうございます。以下のリンクからオンラインでお支払いいただけます。また、PDF形式の請求書の表示、印刷、ダウンロードも可能です。`,
"label.productsales.today.noevttskaddevt":`今日、行動予定あるいは期限切れのToDoがありません。右上の「＋」をクリックして行動を追加することができます。`,
"component.setup.iframe.label.memo":`設定アイコンをクリックして、埋め込みURLアドレスを入力します。`,
"front-email-payment-select-country":`国を入力してください。`,
"label.ems.starred":`星マークが付いているメール`,
"component_setup_label_object":`オブジェクト`,
"label.query.detail.viewpartneruser":`パートナーユーザを表示`,
"this.year":`本年`,
"serviceresource.isactive.notactive":`このサービスのリソースは有効されていません`,
"label.marketing.message.recipientisnull":`受信者は空であってはいけません`,
"label.unfold":`展開`,
"label.service.assetBOM.view.tip":`アセットBOMを閲覧する権限がありません。管理者にお問い合わせください。`,
"label.validate.function.funcExplain.ISCHANGED":`項目値は前の値と同じかどうかチェックし、同じではないと、TRUEを返し。そうでなければFALSEを返します。`,
"label.validate.function.funcExplain.NOW":`現在時刻を表示する日付/時間を返します`,
"label.phoenix.islands.time":`フェニックス諸島時間`,
"vue_label_checkduplicate_complete_filter_rules":`フィルター条件を記入してください`,
"vue_label_report_rowcount":`行数`,
"chatter.p":`個人`,
"label.umeng.activity.distributetask":`割り当てされたToDo`,
"UG_quota_05":`商談の双方向の同期`,
"june":`六月`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`火曜日`,
"vue_label_commonobjects_view_chart_upto5":`最大5つまでのグループを表示します`,
"vue_label_opportunity_contactrole_searchallcontacts":`すべての取引先責任者から検索します`,
"label.custom.field.task.notice":`ToDo通知`,
"label.weixin.insert.address":`挿入場所`,
"label.attachementNew.desc":`ファイルはフォルダに保存されると、削除できません`,
"setup_mainpage_label_welcome18":`CloudCC の企業レベルの権限設定では、データやモジュールを処理する際に、各ユーザの使用権限をコントロールすることができます。役割に基づく権限の設置は、ユーザの職場、グループ、ロール、データ共有ルール、項目レベルのセキュリティーコントロールも含み、企業の社員、部門の間のデータ共有を実現します。`,
"front-kefu-instance-noarea":`このエリアにはインスタンスが作成されていませんので、再選択してください。`,
"label.please.ChooseMax":`商品の選択肢は{a}までお選びください。`,
"label.businesschance":`商談`,
"label.verticalline-group":`カラムレベル-グループ化`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`価格表を選択してください`,
"vue_label_norm_addcomponent":`コンポーネントの追加`,
"label.ServiceCloud.Installation.address":`インストールのアドレス`,
"vue_label_report_groupcolumn":`グループ列`,
"label.ccchat.person.invite.notallsucc":`{ 0 }件のメールアドレスは保存されましたが、送信されていません。案内所を送信するなら、以下のエラーを修正して送信をクリックします。`,
"label.customfields.optionlist.tip":`あらかじめ設定されたリストから値を選択する項目です。`,
"UG.activity.07":`ToDo作成`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`最後の一週間`,
"label.permission.accessname":`権限セット名`,
"lable.custom.year.stadate":`カスタム年度の開始日`,
"label.ems.inputmails":`ポスト?オフィス?プロトコル（I）`,
"label.cpq.quote.transfer.order.already":`この見積書は注文に引き継がれます。元の注文を削除してから、注文を再作成してください。`,
"label.sendletter.status":`キャンペーンメンバーの状況`,
"vue_label_commonobjects_view_save_as_view":`ビューとして保存`,
"message.mobilechooseatmostfive":`5の項目まで選択します`,
"label.errormessage.batchedit.nopermission":`編集権限があるレコードタイプはありません`,
"label.dataoperate.tip":`行うアクションとアクションのオブジェクトを選択してください`,
"label.enableoperate":`使用可能なアクション`,
"label.ems.usernamepassword.error":`メールボックスまたはパスワードが間違っています。`,
"label.campaignmember.selectmember.deletemember":`メンバーの削除`,
"label.Tab":`タブ`,
"label.emailobject.template.message1":`項目を選択し、[挿入]をクリックしてください。[>]が付く表示ラベルはより多い使用可能な項目があると表します。`,
"label.approvalstep3.tip":`このステップの入るユーザのレコードを指定します。任意選択：承認代理を許可するかどうか選択でき、またこれらの申請を承認することもできます。`,
"label.inusing":`有効`,
"label.edit.select.tre":`チェックボックスリスト`,
"label.appointmentconfirmail.wizard.title1":`{0} こんにちは`,
"label.partnerCloud.financeSetting.setAlipay":`Alipayの設定`,
"lable.edit.queue.avobj":`利用可能なオブジェクト`,
"vue_label_checkduplicate_verify_all_characters":`すべての文字を検証する`,
"label.huntingzone":`検索範囲`,
"label.request.approved":`当該申請は承認済みで、重複承認をしないでください`,
"label.sharerule.msgerror":`サーバエラーメッセージ`,
"front-epwechat-module-v1-tick-unbound":`上記の拘束力のない情報に同意し、受け入れることにチェックを入れてください。`,
"label.console.step6":`ステップ6.リスト配置の選択`,
"label.multilang.micropost.vote":`{0}票`,
"message.error.appid.null":`暗号化キーは空にしてはいけません。`,
"lable.product.delq":`問題を削除`,
"label.h5.approval.leixing":`承認種別`,
"label.edit.field.select.style1":`タイトル表示`,
"label.passwordPolicy.setup.alpandnum":`必ず英字の数字の組み合わせです`,
"label.ems.close2":`クローズ`,
"label.report.reporttypetitle":`レポートタイプ名`,
"label.umeng.approval.approvalsuccess":`承認は提出済み`,
"label.page.showamount":`ページ毎に表示されるレコード件数：`,
"label.copy.asset.successfully":`アセットBOMのコピーに成功しました。`,
"vue_label_homepage_bigscreen_dark":`ダーク`,
"vue_label_email_selected_members":`選択済みののメンバー`,
"label.file.preview":`プレビュー`,
"label.partner.new.step3.name":`名称`,
"label.forecast.settings.periods.ago":`週間前`,
"label.evaluation.praise":`良い`,
"label.cloudccsite.edit":`サイトの編集`,
"label.knowledgebase.advanced.filtering":`アドバンストフィルター`,
"label.knowledgebase.framework":`フレーム`,
"vue_label_pool_ownedpool":`マスタープール`,
"label.exchange.sync.setting.license":`この機能を有効化すると、一部の組織データは内部配置やクラウドの形で、Microsoft Exchangeサーバに保存し、Microsoft Exchangeサーバを通じて処理を行います。CloudCC.comはExchangeまたはOffice 365など第3者のアプリケーションやシステムのプライバシーとセキュリティー対して責任を負いません。`,
"front-console-conversation-btn2":`返信メール`,
"label.projectManagement.thelastone":`すでに最後のレコードです`,
"message.duplication.confirmscript.mergeoperation":`選択した値を通じて1つレコードにマージします。ご注意：マージアクションはキャンセルできません。レコードのマージアクションを続いて執行しますか。`,
"lable.outlook.detail.nosyn":`同期しない`,
"label.iscopy":`コピーを許可しますか`,
"message.matrixReportSetupStage.row":`[行タイトルの指定]サブトータルの根拠を選択してください。2つから少なくとも1つを選びます。`,
"label.forecast.forehistory.possibility":`可能性`,
"label.timetrigger.validate":`入力する値は必ず正整数で、このワークフローの連動トリガ時間を満たしたとき、システムは自動的にワークフロー操作を執行します。`,
"member.name.choice.field":`メンバーの名前は必須項目です。`,
"label.undone_external page":`これは元に戻せないので、確認してください。このフォームは、どのログインページでも使用されていませんが、他の場所で使用されている可能性があります。例えば、埋め込みコードを使って外部のページに挿入した場合などです。`,
"UG_Lead_012":`手がかりのインポート`,
"component_chatter_label_fans":`フォローされている`,
"label.systeminfo":`システム情報`,
"label.mr.descreption.oneGroupNote1":`2つのデータをチェックし、[選択した情報のアップロード]をクリックして、データマージページに入ります。`,
"label.wtd.changefields.selfields":`web to cloudccに含む項目の選択`,
"message.error.fileinfoid.null":`fileinfoidは空にしてはいけません。ファイル情報ID`,
"label_tabpage_cownerz":`所有者の更新`,
"setup_layout_button_save":`保存`,
"Dashboard.View.Createdbyme":`私が作成したダッシュボード`,
"label.escalation.setup.detail.order":`番号`,
"button.partner.start":`使用開始`,
"label.htyj.remark1":`現在のバージョンは契約対象をサポートしません`,
"component.event.label.person":`任命先`,
"label.appointmentconfirmail.wizard.subtitle3":`場所`,
"label.emailtocloudcc.filed.username":`メールユーザー名`,
"label.vlidaterule.remark":`エラー条件と、対応するエラーメッセージを指定して、入力規則を定義します。ユーザは、エラーを修正してもう一度やり直すことができます。`,
"message.duplication.label.insertoption":`新規作成時のアクション`,
"front-web-module-v1-detail-comment-toast":`すべての評価を完了してください。`,
"label.import.page2.notsuitedfiledwillbenotimport":`注：対応付けされていない項目はインポートされません。`,
"label.h5.similar.opportunity.enable":`類似商談を有効化`,
"label.allunfold":`すべて展開`,
"component_setup_iframe_label_inputurl":`URLアドレスを入力します`,
"label.manage.all":`すべてを管理`,
"label.mobile.side.tab.cs":`常用機能`,
"label.datamanage.contact.information":`取引先情報`,
"lable.outlook.edit.sel":`選択値`,
"label.imgfield.type.url.tip2":`例えば：http://www.cloudcc.com/images/logo.png&cimgSize=50,50。`,
"setup.layout.label.areasetup":`エリアプロパティの設定`,
"label.date":`日付`,
"vue_label_commonobjects_detail_openfilter":`フィルターの拡張`,
"label.loginip.pagecue":`当該プロファイルのユーザがログイン可能な IP アドレスの範囲を指定します。`,
"vue_label_email_not_valid":`入力したメールが有効なものではありません。`,
"label.page.step5.add.application":`ステップ5.カスタマアプリケーションの追加`,
"label.dashboard.donot.delete":`ダッシュボードファイルにダッシュボードがあるため、削除できません。`,
"label.visitAPPexchange":`Appexchange にアクセス（新規ウィンドウ）`,
"label.generate.location":`ユーザの緯度経度データを生成`,
"lable.quote.syncing.syncingbutton":`同期`,
"label.pw.error.text":`入力した2つのパスワードが一致しません。`,
"label_partner_setup_Enable":`ベリファイ`,
"label.file.preview.unav":`プレビューできません`,
"label.sms.tip":`サイトより`,
"setup.mainpage.label.welcome21":`クラウドプラットフォーム「CloudCC」では、ユーザーのカスタマメールテンプレート機能を提供しており、ユーザーの利便性を高め、作業効率を向上させることができます。`,
"label.trigger.for.example":`例えば、取引先のupdateトリガーで商談を更新し、商談のupdateトリガーで取引先を更新する同時に取引先のupdateトリガーを起動させ、トリガーで条件を加えてコントロールしない場合は、システムが最大で3回までこのような循環を行うことができます。`,
"setup.layout.button.layoutprop":`レイアウトのプロパティー`,
"component.chatter.label.fans":`フォロワー`,
"lable.PowerProcess.event.edit":`重大行動の編集`,
"label.detailintro":`明細説明`,
"vue_label_report_nosearchresults":`検索結果なし`,
"error.name.repeat":`名前は重複してはいけません`,
"label.emailEncoding":`メールのコード`,
"label.partnerCloud.financeSetting.enableAccount":`Rebateアカウントの有効化`,
"label_emailtocloudcc_clear":`クリア`,
"setup_mainpage_label_welcome12":`ユーザはプログラミングを行わなく、マウスをクリックし、システムの表示ステップに基づいて、レポートを定義することができます。一目瞭然にするために、システムでは表形式レポート、集計レポート、マトリックスレポートが選択可能で、すべての項目の表示選択が提供されており、また必要がない項目情報を除去して、縞状、折れ線、環状、ファネル、餅状などの多種類の図形が使用可能です。`,
"lable.SalesCommitmentKanBan.contractStartDate":`契約の開始日`,
"front-starter-v1-potential-customer-tips-success":`リードプールの活性化に成功`,
"UG_Forcast_02":`予測は指定された段階での販売予定の試算で、予測モードは期間内の製品需要と販売収入の状況を確定することができます。管理者は予測によって、目標を設定し、チームの進捗状況を測定することができます。組織の全体的な予測は販売代表によってすべての販売状況を反映することができます（販売はパイプラインステージからクローズドステージまでのどんな完了段階にもかかわらないです）。`,
"label.escalation.setup.detail.ruleentries":`ルールエントリー`,
"lable.SalesCommitmentKanBan.allComplete":`完了した総金額`,
"label.appupload.install.apicanuse":`api名前は使用可能です`,
"label.organiza.field":`組織項目`,
"button.partner.workspace.manage":`管理`,
"lable.PowerProcess.setevent":`重大行動の設定`,
"label.emailobject.groupemail.msg2":`メールアドレスがないため、受信者にこのメールを送信することができません。`,
"label.h5.orderbyname":`名前に基づき、並び替えます`,
"vue_label_salesadvance_opportunities":`商談数`,
"label.appointment.disable.cancel":`無効化されたキャンセル`,
"label.trigger.folder.edit":`トリガーページ：フォルダの編集`,
"label.customfields.new.step2.opration.unique.info.v2":`ABCをabcと同じ値とします（大文字と小文字は区別されます）`,
"label.icon.40":`ポジショニング`,
"label.eventmenuandlink":`行動のボタンとリンク`,
"label.service.gantt.candidate":`候補者`,
"label.top.userphoto":`ユーザのアバター`,
"label.appointmentconfirmail.wizard.btn2":`会議のキャンセル`,
"label.print":`プリント`,
"saveandreturn":`保存&戻る`,
"lable.account.CurrentandNextCY":`現在と次回のカレンダー年度`,
"label.group.no.recent1":`有効になっているチームをいずれも参照していません。`,
"lable.Asset.conversion":`資産を移行する際に、注文製品の「資産移行」に従って資産を生成する。`,
"label.emailtocloudcc.button.sure":`確認`,
"label.Path.List":`プロセスリスト`,
"label.please.rule.name":`ルールの名称を入力してください。`,
"label.knowledge.category.hint.six":`利用可能なカテゴリーグループ`,
"setup_mainpage_label_welcome28":`アクションガイド：このページの右側のメニュー → 管理の設定 → データの管理 → データのインポートとエクスポート、一括移行、一括削除をクリックしてください。`,
"vue_label_commonobjects_view_chart_editchart":`図表の編集`,
"label.permission.detail.app.object":`オブジェクトのセットアップ`,
"label.multilang.totalpage":`合計`,
"label.marketsea.button.return":`戻る`,
"Click.to.load.more":`更なるアップロードをクリック`,
"label.validate.globalvariable":`グローバル変数`,
"label.marketsea.iseditseabymanager":`管理者による所属プールの変更を許可します`,
"label.price.yuan":`価格（元`,
"label.service.resource.uesr.tip":`ユーザーを選択してサービスリソースを作成します。リソースタイプはグループを選択することができません。`,
"vue_label_help_viewusageguide":`lightningバージョンのユーザーガイドの表示`,
"label.autoRegister.changepwd.setpwd.too.long":`長すぎる`,
"label.campagin.roi.fwsl":`アクセス量`,
"label.campaign.mobile":`モバイル端末`,
"UG.Lead.012":`クルーのインポート`,
"link.recordtype.detail.backtoobject":`カスタマオブジェクトに戻る`,
"front-kefu-moudle-callcentrt-hasclose":`コールセンターの閉鎖について`,
"label.category.5":`ITハイテク`,
"label.import.page1.selectwayofdealdata":`データ処理モードの選択`,
"chatter.emailReceiveEmail":`メール受信`,
"vue_label_file_manage_lib_members":`ファイルライブラリメンバーの管理`,
"label.appupload.upload.overview":`サマリー`,
"label.service.miniProgram.inputNumber":`0～999の数字を記入してください`,
"label.emailtemplate.finishdetailinfo":`メールテンプレート詳細情報の記入`,
"label.weixin.fmu.before.day":`0日`,
"label.integrations.login":`ログイン`,
"label.dashboard.setUpHomePage":`表示するホームページは設定済みです`,
"label_partner_common_webSit":`ドメイン名`,
"front-epwechat-module-v1-unbound-user":`アンバウンドユーザー`,
"label.partnerCloud.basicSetting.offline":`オフラインでの支払いを有効にする`,
"label.start.loginip":`開始 IP アドレス`,
"label.projectManagement.delete.subtasks":`このサブタスクを削除すると、このサブタスクの関連情報もすべて削除され、データを復元することはできません。削除を確定してよろしいですか？`,
"label.message.batchapp":`一括承認`,
"message.duplication.label.ruletitle":`重複検索条件ルール`,
"label.all_networks":`すべてのネットワーク`,
"label.select_columns":`フォーム投稿に表示する列を選択してください。`,
"vue_label_notice_uploadavatar_exceed":`アップロードするアバターのサイズは2MBを超えることはできません。`,
"message.error.get.failed":`情報の取得に失敗しました`,
"label.quickbooks.viewlist.duedate":`期日`,
"label.ccchat.topic.search":`トピックの検索`,
"label.forecast.shre.manager":`マネージャーの割り当て`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`木曜日`,
"lable.product.pricebooks.copy":`既存の価格表からコピー`,
"label.instrumentPanel.minLabelname":`この値は正の値で、しかもブレークポイント1の値よりも小さい必要があります`,
"front-market-form-createdsecond":`登録ページの自動入力欄`,
"label.submission_detail":`投稿内容`,
"label.customfields.checkbox.tip":`True (チェック) また False (チェックなし) の値を入力できます。`,
"label.escalation.setup.list.description":`ケースがグレードアップされるタイミングと、実行されるアクションが自動的に決まります。ケースがグレードアップされるとき、自動的にユーザに通知することを選択して、ケースをその他のユーザに再割り当てします。`,
"UG.Forcast.05":`予測の設定：ステップ{0}/{1}。`,
"label.data.import":`データインポート`,
"label.upload.error.cause":`アップロード失敗、その原因は`,
"label.search.change.remark":`フロントエンドの左欄の検索で表示されるオブジェクト設定に応用します`,
"serviceappointment.edit.status.limitwithstatus":`サービス予約の状態を{0}から{1}に変更することはできません`,
"label.department.operation":`操作`,
"label.textmessage.vonage.message3":`APIキーとAPIシークレットを確認するには、Vonage APIアカウントにログインし、アカウント名の下にある「設定」にアクセスしてください。Vonage APIアカウントに登録されている電話番号を確認するには、「製品」の「番号」から「お客様の番号」をクリックすると、登録されているすべての電話番号が表示されます。`,
"label.privacystatement.dialog":`プライバシーに関する声明（新規ウィンドウ）`,
"label.datamanage.import.leadfield":`下記のリストで、インポートするファイルでリードにインポートする項目を選択します。完了したら、[次へ]をクリックします。`,
"label.appupload.upload.install.failar":`インストール失敗`,
"label.viewall":`すべて参照`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat ブークマークしたマイクロポストを返事`,
"lable.custom.dp":`このページでは、カスタム年度を定義することができます。`,
"label.mobile.more.share":`同僚あるいはチームと共有`,
"lable.name.cannot.be.empty":`名前を空にしてはいけません`,
"label.autoRegister.changepwd.setpwd.password":`パスワード`,
"label.multipleactivity.aevents":`行動（件）`,
"label.many.dayline.lastday":`前の日`,
"lable.Please.bind.the.QuickBooks.record.first":`クイックブックのレコードを先にバインドしてください`,
"vue_no_related_dashboards":`関連するダッシュボードがない!`,
"label.newdashboardpage.name":`ダッシュボード名`,
"vue_label_commonobjects_detail_network":`リレーションネット`,
"label.tianyancha.reginstitute":`登録機関`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`ブロック単位で価格を設定する場合、各レベルの下限値は上位レベルの上限値と必ず同じです。`,
"label.chat.file.upload.info":`ファイルのアップロード`,
"label.appexchange.vlidaterule":`入力規制`,
"label.salescloud.salesdashboard.current.business":`現在のビジネスチャンス`,
"label.app.step4.homeisfrist":`ホームページは必ず一番目のタブで、しかも削除できません。`,
"label.weixin.micro.research.optionname":`Micro researchのオプション名`,
"label.paging.totalofnbsp":`{0}件`,
"label.opportunity.perm.title":`アクセス権の申請`,
"front-kefu-moudle-v1-zhyzcw-reinput":`賃借人確認のエラーです。再入力してください。`,
"label.unsaved_changes":`操作を続行すると、保存されていない変更点は失われます。`,
"label_partner_all_description":`説明`,
"lable.account.Next.CQ":`次回のカレンダー年度`,
"chatter.feed.menutype.feed.me":`私に関する更新`,
"label.sourcetranstemp":`ソース - 翻訳可能なすべてのテキストを含むファイルを 1 つ生成します`,
"label.apply.newuser.validate":`CloudCCの新規ユーザ登録、確認コード：`,
"label.user.password.error":`ユーザパスワードにエラーが発生し、あるいはユーザは無用です。`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`この見積ライングループには、見積ラインアイテムがありません。追加するには「製品の追加」をクリックしてください。`,
"lable.PowerProcess.time.filed":`{detailInterestType}の日付項目に基づく`,
"label.file.default.value.is.integer":`整数しか入力できません`,
"label.processsetting.please.select.field":`項目を選択してください`,
"label.app.step3.introduce":`カスタムアプリケーションロゴは、20 KB 未満にしてください 。画像サイズは、最大で横 300 ピクセル、縦 55 ピクセルが最適です。その他のサイズの画像は、サイズ変更されて歪んで表示される可能性があります。また保存してから、新しい画像が有効になります。`,
"button_partner_save":`保存`,
"label.marketingmanagement":`市場販売`,
"label.isEnableVisualpage_new.leftlist":`使用可能なカスタム権限`,
"label.salescloud.teamrole.optionlist.choose.correct":`リスクに同じ項目がありますが、修正してください`,
"System_ChangeUser_Info_001":`所有者の更新に成功しました。このレコードを参照する権限がないですが、クリックして前のページに戻ってください。`,
"front-console-no-contact":`連絡なし`,
"component.assistant.label.overduetask":`商談は期限切れのToDoを含む`,
"label.roleofpartner":`パートナーのロール`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`あなたと{0}`,
"front-template-V1-Please-select-a-picture":`画像を選択してください`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`契約の承諾率`,
"label.h5.similar.opportunity.step2.conment":`類似商談の検索時に照合する項目または関連リストを 3 ～ 10 個の間で選択します。`,
"label.projectManagement.alert.frequency.will.not.work":`「いいえ」を選択した場合、リマインダーは有効化されません。`,
"vue_label_fllscreen":`フルスクリーンで表示する`,
"label.customfields.selectcontainfieldlayout":`この項目を含むページレイアウトを選択します`,
"label.appointment.wizard.subtitle1-4":`45分`,
"label.tianyancha.businessverify.unagree":`同意しない`,
"label.unique":`ユニーク`,
"setup_mainpage_label_welcome10":`アクションガイド：このページの右側のメニュー → アプリケーションの設定 → 作成 → オブジェクト → オブジェクト名 → カスタマレイアウトをクリックしてください。`,
"vue_label_account_subsidiary":`子会社`,
"label.dataimport.format.error":`表示形式エラー、MM/DD/YYYY あるいは YYYY-MM-DDの書式を使用してください。`,
"label.email.new":`新規メール`,
"label.log.descri":`アクションの詳細`,
"vue_label_dashboard_componentname":`コンポーネント名を入力してください。`,
"label.weixin.quick.reply":`クイック返事`,
"label.productsales.payment.badversion":`現在のバージョンは契約対象をサポートしないため、代金受取業績のランキングを表示することができません。`,
"label.position":`位置`,
"label.Annex.Conditions":`追加条件の論理フィルタを追加します（例：1 And 2 Or 3 ）`,
"label_tabpage_endz":`終わり`,
"label.setup.mobile.bottombutton.prompt":`お知らせです。これらの設定を保存すると、モバイルアプリのファーストレベルのユーザーの元の設定が変更されます。`,
"lable.Edit.template":`サービスレポートテンプレートの編集`,
"vue_label_report_onlydisplay2000":`2000個のデータのみ表示`,
"label.salescloud.salesdashboard.sign.account.top5":`取引先トップ5`,
"label.weixin.ontime":`時間通り`,
"font-evaluate-module-v1-disappoint":`期待を裏切って申し訳ありません。`,
"chatter.sel.addre":`最大5人までの受信者を選択できます`,
"label.mobile.phone.month.summary":`今月のまとめ`,
"label.partnerCloud.priceOfManual.selected":`選択されたアカウント`,
"label.south.georgia.time":`南ジョージア標準時`,
"label.create.ccdocument":`ファイルを追加`,
"label.chatter.to":`まで`,
"label.ems.minute":`分間`,
"label.mobile.phone.submit.tome":`私のレポートに提出`,
"label.approvalstep1":`ステップ：名称と説明の入力`,
"label.h5.similar.opportunity.last.months9":`直近の6-9か月`,
"Opportunity_Detailed_Phase_Label_003":`階段の変更`,
"lable.PowerProcess.time.input":`時間を入力してください`,
"label.stdashbord.xsld.business.yqzsr":`期待総収益`,
"label.icon.64":`サーチライト`,
"label.data.choses.i_desc":`ご要望に基づいて、インポートするオブジェクトのデータを選択してください。`,
"label.integrations.mainlandchinaleads":`中国本土のリード`,
"vue_label_notice_savemenu_success":`メニューの保存に成功しました`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Easemobのオンラインサービスを選ぶ`,
"label_chatter_name":`名称`,
"label.Viewon_Linkedin":`LinkedInからの眺め`,
"lable.PowerProcess.chioce.event":`重大行動を選択してください。`,
"component.chatter.file.label.maxsize":`ファイルの最大サイズは20Mです`,
"label.validate.function.funcExplain.SECOND":`日付/时间項目のの秒数に戻る`,
"label.data.downpage.i.title.num4":`4、インポートするオブジェクトにルックアップ関係の項目とマスター・ディテイル関係の項目がある場合、その項目値はIDでなければならず、そうでなければ無効です。`,
"label.icon.139":`通貨`,
"label.app.step4.atleastone":`ホームページタブは削除できません。`,
"label.weixin.input.telephone":`携帯電話番号をご入力ください`,
"label.setup.mobile.bottombutton.remark":`組織は、ビジネスプロセスに応じて、第1階層のページの初期設定を行うことができます。`,
"label.file.searchs":`ファイルの検索`,
"vue_label_email_there_is_no_draft_yet":`下書きはありません`,
"front-kefu-moudle-v1-bind-seats":`バインドエージェント`,
"label.customfields.lookupmuti.tip":`当該オブジェクトと別のオブジェクトをリンクするリレーションを作成します。この項目によって、ユーザはルックアップアイコンをクリックして表示されるポップアップリストから複数のレコードを選択できます。別のオブジェクトはリスクの値のソースとなります。`,
"label.integrations.password":`パスワード`,
"label.data.newtemplate.t_conditions":`テンプレートの条件`,
"message.error.repeatsubmit":`この提出には重複提出または同じページに複数のウィンドウが開いていることがあり、後者の場合、新しく開いたウィンドウで提出してください。`,
"label.umeng.approval.approvalreassign":`#objの承認は再割り当てされました#objname`,
"lable.edit.queue.selobj":`エラー：キューは1つの選択したオブジェクトが含まなければなりません。`,
"label.compact.layout.frame":`ページレイアウトのフレーム`,
"label.sms.companyname.dsf.infor":`東時方のSMSインターフェス情報`,
"template.report.individual.case.source":`ケースソース`,
"pagecreator.button.pcpage":`PC端末`,
"vue_label_commonobject_selectdatatime":`日付と時間の選択`,
"label.icon.181":`ファイル`,
"label.loginip.setup.please":`IP アドレス範囲の指定`,
"vue_label_dashboard_?secondarygroup":`二段階グループを選択してください`,
"lable.outlook.mcto.pleasedes":`関連したくないメールドメインを読点で仕切りって入力してください。`,
"DetailedInfo_Activity_EmailMessage_01":`{0} は {1}にメールを送信しました`,
"label.sendmail.step4":`ステップ4.メールを提出して処理を行っている`,
"label.monitorsys.delete.source":`アクションの詳細`,
"label.monitorsys.log.datetime":`検索範囲内のシステムの重要な監査ログをダウンロード（ファイルExcel.xls)`,
"component_chatter_label_myfans":`私をフォローしている人`,
"label.tianyancha.h5.registereddate":`登録時間`,
"label.multilang.feedtrack.operatecreate":`{0}のレコードを作成しました`,
"label.console.step6.no":`リスク配置の選択`,
"four":`四`,
"message.confirmsetpwdforuser":`ユーザにパスワードをリセットしますか`,
"label.cape.verde.time":`カーボベルデ時間`,
"label.queue.new":`新規キュー`,
"label.cloudccsite.start":`サイトページを有効化`,
"label.data.exp.way":`エクスポート方法`,
"label.lock.record.donot.delete":`レコードがロックされたため、削除できません。`,
"label_emailtocloudcc_filed_type":`種別`,
"frame_personinfo_label_minipic":`サムネイル画像`,
"label.checkfield.choosetab":`重複チェック項目の選択`,
"component.setup.tabs.label.default":`デフォルトページ`,
"page.404.button.toknowmore":`さらに詳しい`,
"vue_label_SMS_message_sent_cannot_be_empty":`メッセージ内容は空にしてはいけません`,
"label.lookupreplaceselectvalue":`選択リスト値の表示と置換`,
"pagecreator_layout_button_new":`新規のレイアウト`,
"label.mobile.more.upload":`新規バージョンのアップロード`,
"front-kefu-moudle-v1-Connection-failure":`接続に失敗しました。`,
"label.version.support.unlimited":`制限されないことをサポートします`,
"message.error.notmarketseamember":`このプールのメンバーではない`,
"label.taskandincident":`ToDo&行動`,
"label.report.export.print.title":`レポートビューの印刷`,
"label.file.publicview.error2":`公開リンクの情報は間違っており、新しい公開リンクを使用してください。`,
"label_chatter_cancel":`キャンセル`,
"front-web-module-v1-detail-comment-satisfied":`満足度`,
"label.knowledge.delete.topic":`この知識記事だけで使用されているサブジェクトの削除にエラーが発生しました。`,
"label.forecast.forehistory.all":`すべて`,
"label.displaybutton":`表示されたボタン`,
"label.icon.148":`ロボット`,
"label_tabpage_ok":`確定`,
"label.checkfield.merge.mainrecord":`主レコード`,
"label.notification.arketsea.restored":`5}は{2}{0}を復元した：{1}`,
"setup.mainpage.label.welcome31":`手順は以下の通りです。このページの左側のメニュー → 設定管理 → 作成 → アプリケーションをクリックする。`,
"front-kefu-moudle-v1-jtrrt-connect":`CloudCCのユーザーとTRRTのエクステンションの関連付け`,
"vue_label_calendar_please_select":`表示される項目を選択してください。`,
"setup.layout.label.pagename":`ページレイアウト名`,
"template.chart.schdywjhz":`キャンペーンオポチュニティ値`,
"label.access_report":`誰がこのレポートにアクセスできますか？`,
"label.assignment.layout.section.optional":`選択可能`,
"label_chatter_recently":`最新`,
"lable.chat.advanced.setting":`アドバンスド・セットアップ`,
"label.knowledge.category.hint.eight":`カテゴリーグループ`,
"message.error.facebookuid.null":`FacebookのユーザーIDは空にできません。`,
"label.step5.total6":`ステップ　5/6`,
"label.is.cancel.delete":`復元しますか`,
"setup_mainpage_label_welcome11":`カスタマレポート`,
"label.answers":`回答`,
"label.approvalstep1.tip":`新規承認されたステップに名前、説明とステップ番号を入力してください。`,
"template.chart.htjeph":`契約金額 ランキング`,
"label.campaigns.onsiteregistration":`オンサイト登録`,
"front-epwechat-module-v1-input-agentid":`agentIdを入力してください。`,
"label.emailobject.wizard.desc2":`メールが開かれているか、または開かれた回数を追跡します。`,
"label.multilang.chatterdetial.vote":`{0}票`,
"label.customsetting.manage.value":`カスタマデータ`,
"front-electronic-export-listCount":`{totalView}現在のビューで合計したデータを、インポートしたデータを選択する`,
"label.dashboard.create.prompt":`リスト形式のレポートではダッシュボードを作成することはできません。`,
"label_tabpage_askz":`ご質問はありますか`,
"label.ems.sentmail":`送信トレイ`,
"label.reportlist.untop":`固定を解除`,
"label.owner.h5.plzchose":`所有者を選択して、確認ボタンをクリックしてください`,
"label.callcenter.addup.10.pieces":`最大で1回、10個のデータを追加`,
"label.ccdocument.save":`フォルダの保存`,
"label.productcannotnull":`商品は空であってはいけません`,
"label_tabpage_enabletomobile":`モバイル端末を有効化しますか`,
"lable.account.CYAgo":`2つのカレンダー年度の前`,
"lable.Select.the.returned.high.seas.pool":`戻るプールを選択`,
"tuesday":`火曜日`,
"label.partnerCloud.basicSetting.partnerPayment":`アクティベート・パートナー・ファンド`,
"label.validate.function.funcExplain.WEEKDAY":`曜日に戻る。1は日曜日、7は土曜日を表します`,
"label.query.detail.manageexuser":`外部アカウントの管理`,
"vue_label_systemSettings_environment":`環境`,
"component_setup_tabs_label_delete":`削除`,
"label.weixin.delete.ccchat":`確かにこの書き込みを削除しますか。`,
"label.lanxin.title":`Lanxin-H5マイクロアプリ`,
"label.layout.editcondition.morethanten":`検索条件は10つを超えてはいけません`,
"label.project.hit.fourteen":`マイルストーン更新のお知らせ`,
"label.createby":`作成者`,
"label.moreoperation":`さらなるアクション`,
"label.lock.tip":`編集しないよう、レコードをロックします。`,
"label.check.input.condition.three":`数式のフィールドタイプとロールアップサマリーの挿入はサポートされていません。`,
"label.quote.dingjia":`定価`,
"label.currentuseremail":`現在ユーザのメールアドレス`,
"UG_homepage_004":`自動化`,
"chatter.link":`リンク`,
"label.new.zealand.standard.time":`ニュージーランド夏時間`,
"APPIntegration.Dropbox.setting.02":`無効化`,
"label.version.searchandmerge":`チェックの複製とマージ`,
"label.allmenus.showmsg.nomenu":`検索するメニューは見つかりません`,
"front-template-V1-Enable-disable":`アクティベート｜ディアクティベート`,
"label.marketing.setting4":`登録に成功し、ウェブサイトのデフォルトに戻ります。`,
"UG.Forcast.07":`予測の許可`,
"vue_label_systemSettings_correlation":`関連リスト 表示モード`,
"label.cloudccsite.remark.length":`サイト説明は225文字を超えてはいけません`,
"label.favorite":`このページをブックマークします`,
"template.report.converted.leads":`コンバートされたリード`,
"label.campaignmember.main.description":`当該ページでこのキャンペーンのメンバーを管理します。新しいメンバーを追加したり、既存メンバーのキャンペーンメンバー状況を更新したりすることができます。`,
"label.salescloud.teamrole.account.organization":`チームメンバーが取引先へのアクセスレベルは、組織によるデフォルトのアクセス設定定より高いかもしれません。`,
"label.permission.modifyAppPermission.canselectapp":`選択可能なアプリケーション`,
"front-epwechat-module-v1-self":`自分で作ったアプリの設定`,
"message.duplication.label.matchexactletters":`高度な一致`,
"label.appointmentdetail.wizard.title18":`金曜日のスケジュール`,
"label.area":`エリア`,
"label.sso.saml.sp.username":`ユーザ名`,
"lable.outlook.new":`新規Exchange Syncの更新`,
"label.custom.field.close.conversion":`クローズ：置換済み`,
"lable.outlook.detail.tmaping":`ToDo項目の対応付け`,
"label.emailobject.emaildetail.nextactivity.event":`行動の追加`,
"vue_label_commonobjects_detail_date":`終了日が開始日を下回ることはできません。`,
"vue_label_email_mark?as":`としてマークする`,
"label.guestgroup":`取引先チーム`,
"label_emailtocloudcc_filed_server":`サーバー`,
"label.icon.186":`助言`,
"label.department.user.edit":`編集`,
"label.custom.page.component.button.settings":`コンポーネントボタンの設定`,
"label.partnerCloud.orderingPlatform.nextProduct":`現在の製品の設定を保存して、次の製品の設定を行いますか？`,
"vue_label_appstore_cloud_platform":`cloudオフィシャル・プラットフォーム`,
"label.page.previous":`前のページ`,
"label.direct.dashboard.week.report":`新規週報の作成`,
"label.ServiceCloud.prompt.warning":`住所別のリソース配分統計はありません。`,
"label.emailtocloudcc.position":`職位`,
"vue_label_email_please_enter_the_message_content":`メールの内容を入力してください`,
"labal_About_to_jump":`間もなくスキップします`,
"label_profile_mobile_setup_stand":`スタンダードページ`,
"label.visualpage.component.n3":`3.パラメータ　パラメータはargsプロパティに記入`,
"vue_label_report_operationmode":`レポートの運行方式`,
"label.reportsSubscription.select.attached.file":`添付ファイルの種類を選択してください。`,
"label.afghanistan.time":`アフガニスタン時間`,
"label.vlidaterule.formulatrue":`この数式が True の場合には、エラーメッセージエリアで定義されたテキストを表示します`,
"label.ccchat.person.invite.erroremail":`メールアドレスの形式は不正確です。`,
"label.viewDashboard":`ダッシュボードリスクに切り替え`,
"label.at":`において`,
"label.notification.arketsea.beforeretrieve":`あなたの{0}：{1}は間もなく{2}までに回収される，残りは{6}日です。`,
"label.field.update.show.editor":`公式エディターの表示`,
"label.weixin.polls.time":`投票時間`,
"vue_label_commonobjects_detail_activity_nostarttime":`開始日なし`,
"label.direct.dashboard.me.not.approval70":`私が提出した未承認のプロジェクト`,
"label.data.setok.t_desc3":`、操作します。`,
"label.view.edit.search.describe":`キーワードを入力して検索`,
"label.importsourcefiletip":`翻訳済みのタグ区切りファイルをインポートする前に、次のことを確認してください。
1. 目的の言語ごとに個別のファイルを作成し、キーと翻訳のみを含むファイルをインポートします。
2. 各ファイルの最上部で言語属性が指定されている必要があります。言語属性は次のとおりです。Language = "en_US"`,
"UG.Case.01":`ケース`,
"label.weixin.report.filters":`検索条件`,
"vue_label_homepage_profilehomepageassignment":`プロファイル ホームページの割当て`,
"label_tabpage_editview":`ビューの編集`,
"label.tabpage.allpotentialcustomers":`すべてのリード`,
"label.sendemail.send.standbyemail":`（代替の送信トレイ）`,
"errormessage.email.atleastonereceiver.z":`受信先を少なくとも1つ選択または記入する必要があります。`,
"workflow.action.tasks.assignortype.ownertype":`所有者の種別`,
"label.list.userinterface.new.page.setup":`新版インターフェース`,
"chatter.seladress":`以下のいずれかの受信者を選択してください`,
"Pagelayout_Setup_004":`最大4つまでの項目を設定することができます`,
"label.mobile.home.page.tenbig.opp":`これから30日のトップ30の商談`,
"label.wtd.changefields.newpc":`PC版ページの生成`,
"label.opportunity.perm.remark":`これは専用の商談で、商談の所有者と連絡して、アクセス権を獲得します。`,
"label.data.exp.tempdes":`テンプレート説明`,
"label.appointment.wizard.subtitle2-1":`から`,
"lable.currencyManage.button.manageexchangeRate":`期限切れの為替の管理`,
"label.file.viewinfo":`ファイルの詳細情報の表示`,
"label.integrations.mailchimp.export.failed":`データのエクスポートに失敗し、インターネットの接続にチェックして、後ほど再度試してください。`,
"pagecreator_page_button_edit":`編集`,
"label.icon.86":`ブリーフケース`,
"label.exchange.sync.reset":`同期の再設定`,
"label.customfields.lookupfilter":`検索条件を作成し、検索項目での使用可能なレコードを制限します。`,
"label.component.hotdeal.nopermission":`商談関連データを取得するには、CloudCCの管理者に連絡してください。`,
"label.address.province":`都道府県`,
"lable.PowerProcess.3digit.input":`3桁を超えてはいけません`,
"label.asset":`資産`,
"label.passwordPolicy.setup.nopwdremember":`レコードしない`,
"front-electronic-signature-setting-intro2":`契約書を作成する前に、DocuSignプラットフォーム上にテンプレートをプリセットしてください。契約を開始する際には、あらかじめ設定された契約書のテンプレートを選択することができます。`,
"pagecreator.page.button.new":`新規ページ`,
"label.tabpage.step2":`ステップ2 ：検索条件の指定`,
"label_switch_two_column_or_responsive_layout":`標準レイアウトまたはレスポンシブレイアウトへの切り替え`,
"label.batchDelete":`一括削除`,
"chatter.edit.ct":`連絡先の編集`,
"UG_ST_003":`{0}を作成する権限がないため、管理者に連絡してください。確定をクリックしてインターフェースに入ります`,
"label.timzone.tip.info2":`SimpleDateFmatを使用しデータをフォーマットする場合、SimpleDateFmatクラスの実例にタイムゾーンを設定すべきです。例えば：SimpleDateFormat myDateForma`,
"label.ems.firstsynchistory":`0`,
"label.currency.invalid":`無効な追加種別`,
"label.mask.custom":`カスタマ`,
"lable.opppdt.addpdt.title":`商品の選択`,
"label.appointment.wizard.subtitle3-3":`水曜日`,
"label.weixin.report.criteria":`グループ化の条件`,
"label.appupload.upload.install.uninstall":`インストールできません`,
"label.compact.layout.frame.split":`スプリットスクリーン`,
"label.email.attach.complete.info":`インストールした後、ファイルは下記のファイルリストで表示されます。`,
"label.Receivables":`代金受取の計画`,
"label.linkedin.title.setting":`LinkedIn情報の統合`,
"label.companynotice":`会社リリース`,
"label.emailobject.discard":`取消し`,
"label.selected.searchfield":`選択済みの検索結果項目`,
"front-electronic-signature-explainDocusign":`DocuSign Esignatureの説明です。`,
"chatter.link.name":`リンク名`,
"label.low":`低`,
"label.verticalline":`カラムレベル`,
"label.approval.isallowed.reject.label":`単一データの承認時に拒否ができますか。`,
"label.emailtocloudcc.button.enable":`有効化`,
"label.dashboardSetup.showdw.d5":`整数の単位`,
"label.usermanage.not.authority":`当該アクションを執行する権限はありません`,
"label.customobjects.track.introduce0":`このページでは、{0}で「項目追跡」の関連リストで追跡する項目を選択することができます。ユーザが以下の選択済みのいずれの項目を修正しても、古い項目値と新しい項目値、および日付、時間、プロパティの変更、変更を行うユーザは「項目追跡」の関連リストに追加されます。`,
"canlendarmonth":`カレンダー月`,
"vue_label_dashboard_minimum":`最小値を入力してください。`,
"label.salescloud.optionlist.inputname.linealone":`以下の 1 つ以上の選択リスト値を追加します。値は 1 行につき 1 つ存在する必要がある。`,
"message.error.organuzation.information.null":`組織情報が存在していません`,
"label.tabpage.maxfilez":`ファイルの最大サイズ`,
"message.validation.apiname":`文字から始まり、アンダースコアと英数字しか使用できません。最大文字数は50、最小文字数は2になります。`,
"report.type.label.contractPayment":`契約と代金受取`,
"label.limiting.choose.three.files":`現在、3つのファイルだけ選択できます。今回は選択しました。`,
"label.reportTypeFocus":`レポートタイプフォーカス`,
"Report_Delete_Confirm_Title":`確認してください`,
"front-gantt-module-reorder-milestones":`マイルストーンの並び替え`,
"front-starter-v1-customer-tips-success":`アカウントプールの有効化に成功`,
"label.tabpage.isdeleteview":`このビューを確かに削除しますか。`,
"label.favorite.title":`CloudCCクラウドプラットフォーム`,
"page.layout.sysinfo":`システム情報`,
"label.tabpage.pleaseSelectz":`選択してください`,
"label.smsnotice":`SMSアラート`,
"label.forecast.customforecast.foretype.Pipeline":`Pipeline`,
"label.rejectbehaviour":`却下行為`,
"label.searchlayout.view.example.new":`サンプルを表示（新規ウィンドウ）`,
"vue_label_homepage_notice2":`社員に日々の仕事を効率的にさせるように、手動でホームページのレイアウトを割り当てることができます`,
"label.import.index.chooseidorother":`3、IDまたは名前のマッチングレコードと検索項目を選択することができます。対応するレコードIDなどの情報を取得すると、レポートを作成し、レコード名とレコードIDをグループ列に設定し、レポートをエクスポートします。`,
"label.westem.european.summer.time":`西ヨーロッパ時間`,
"label.brackets":`括弧`,
"asset.serialnumber.unique":`アセットのシリアル番号はすでに存在しているので、繰り返し追加しないでください。`,
"label.callcenter.access.keyID":`アクセスシークレットキーID`,
"label.calendar.month.view":`月のビュー`,
"label.realdelete":`完全削除`,
"label.partnerCloud.orderingPlatform.amountPaid:":`支払うこと。`,
"label.reportTypName":`レポートタイプ名`,
"lable.newtabpage.opensearchresult":`検索結果を展開`,
"front-kefu-moudle-v1-Session-duration":`セッションの時間`,
"label.import.index.ignore":`無視`,
"label.customfields.url.tip":`Web サイトのアドレスを入力できます。ユーザがこの項目をクリックすると、その URL が、別のブラウザのウィンドウに表示されます。`,
"label.projectManagement.editMilestone":`マイルストーンの編集`,
"front-gantt-module-v1-project-gantt-list":`プロジェクト一覧`,
"label.validate.remark":`入力規則により、ユーザが誤ったデータを保存するのを防ぎ、データの質を改善できます。エラー条件とエラー時のメッセージを指定した入力規則を定義できます。入力規則は、レコード保存時に実行されます。エラー条件に一致すると、保存が中止され、エラーメッセージが表示されます。`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`電話番号の形式が正しくありません。再度入力してください。`,
"label.channel.name":`チャンネル名`,
"label.weixin.cloudcc.user.message":`CloudCCユーザ情報`,
"label.icon.59":`ワークショップ`,
"label.ccpeak.function":`方法`,
"lable.opppdt.selPdt.leastten.fields":`最大5つまでの項目を選択してください`,
"label.deadline":`締切日`,
"label.product.sel":`価格表の選択`,
"vue_label_helpcenter_detail2":`すべての活動：自分が参加していなくても、アクセス権限があるすべての行動が表示されます。<br>    日付の範囲と活動の種類によって、表示する行動レコードをフィルタすることもできます。<br>4、动态<br>    このレコードが参照できるすべての人は、このレコードの「ダイナミック」コラムにメッセージや投稿をすることができ、このレコードに関するすべての情報変更、最新活動、他の人のコメントや投稿を参照することもできます。このコラムはオンラインおける同僚との仕事上のコミュニケーションとコラボレーションを促進し、チームワークと効率の向上に役立ちます。<br>投稿<br>   Step 1: 投稿コラムをクリックして、投稿内容を入力する<br>   Step 2: ファイル/リンクボタンをクリックして、必要に応じてファイル/リンクを追加する<br>    Step 3: 「共有」をクリックして、投稿を終了する。<br>View post<br>    投稿が正常に公開されると、先ほど公開したマイクロポストが下記に表示されます。マイクロポストは、アバター、人名、マイクロポストの内容、インタラクション方法（いいね！/コメント/編集/削除）などのパーツで構成されています。<br>投稿の並べ替えと検索<br>    「並べ替え」の右にあるドロップダウンリストをクリックすると、投稿の並べ替えを変更することができます。<br>   <br>「最新活動」の並べ替え：マイクロポストの最新のインタラクション時間で並べ替えます。<br>   <br>「最新ポスト」の並べ替え：マイクロポストの最新のインタラクション時間で並べ替えます。マイクロポストの公開時間で並び替える;<br>   異なるタイプのマイクロポストを表示する<br>   プレーンテキストのマイクロポスト。<br>    ファイルを含むマイクロポスト：ファイルのダウンロードボタンをクリックして、ファイルをローカルにダウンロードして参照することができます。<br>    リンクを含むマイクロポスト：マイクロポスト内のリンクをクリックして開くことができます。<br>    リンクを含むマイクロポスト：マイクロポスト内のリンクをクリックして開くことができます。マイクロポストにコメントや「いいね！」をする<br>   コメントする<br>  ステップ1: 各マイクロポストの下にある「コメント」をクリックする<br>   ステップ2: 開いたテキストボックスにコメントを入力する<br>  ステップ3: 需要に応じて、コメントのファイルやリンクを追加する<br>  ステップ4: テキストボックスの下にある「コメント」をクリックして操作を完了する<br>   コメントの削除<br>   コメントの投稿者は、コメントの内容を削除することができます。コメントの右側にあるボタンをクリックし、ドロップダウンボックスで「削除」を選択してください。`,
"pagecreator_layout_button_mergecell":`セルの結合`,
"Lead_Scoring_Setting_Rule_Setup_Active":`有効`,
"label.query.detail.loginbypartneruser":`ユーザでパートナークラウドWebサイドにログインします`,
"label.view.selectrenderfields":`表示する項目を選択`,
"label.code.add":`QRコードリンク情報の追加`,
"label.appointmentconfirmpage.wizard.title1":`会議は既に予約されました`,
"label.timzone.tip.title":`日付?時間データの複数タイムゾーンのサポートに関しては、new Date()またはCaloerで日付を処理するとき、対応する複数タイムゾーンの問題に注意しなければならない。また、TimeUtilツールクラスでは、複数タイムゾーンをサポートするツールを多く提供されています。`,
"label.tag.addtags.visibility":`表示`,
"label.appointmentconfirmpage.wizard.title3":`既存の予約をキャンセルして、新しい予約を作成しますか。`,
"lable.outlook.detail.oldest":`最も古い`,
"label.account.custom.quarter.timeerror":`カスタム四半期の開始日または終了日が、履歴のカスタム四半期以内にあるので、確認してリセットしてください。`,
"label.sendsms.idea":`親愛な`,
"label.manageAll.pagenum2":`現在は最後のページになりました`,
"serviceterritory.isactive.notactive":`このサービス地域は有効されていません`,
"label.userinfo.newpwd.notnull":`新しいパスワードは空であってはいけません`,
"vue_label_dashboard_nolinkagedashboard":`連動するダッシュボードがありません`,
"message.cannotdeleteapproval":`承認プロセスを削除できません`,
"label.wtd.detail.m":`モバイル版`,
"label.app.step4.introduce":`当該アプリケーションに表示するタブを選択してください。`,
"label.ccchat.error.permission":`権限なし`,
"UG_opportunity_009":`或は`,
"label.Receivables.TheActualAmountOfMoney":`実際の受取金額`,
"label.callcenter.no.search":`情報の関連クエリはありません`,
"label.user.introduce":`ユーザ`,
"message.datalocked.addpdt":`この商談がロックされたため、商品の追加ができません。`,
"label.sendsms.step1":`ステップ1：SMS受信者の指定`,
"label.brief.contracts":`契約数`,
"label.setup.mini.swap":`カルーセルの設定`,
"label.emailobject.wizard.desc1":`個人のメールボックスに関連付けて、ここでメールを送信し、レコードに自動的に同期します。`,
"label.login.verification.mfa.desc2":`ある原因（携帯の紛失やMFAアプリケーションの誤削除など）で認証できない場合、管理者を通じてMFAのバンティングを解除することができます。`,
"label.notification.receiveSms.message":`{!fromaddress}からショートメッセージが届きました。クリックして表示してください。`,
"label.emailmerge.mergeFolder.publicfolder":`ファイリングされない公開メールテンプレート`,
"label.password.update.false":`パスワードの変更に失敗しました、管理者に連絡してください。`,
"label_tabpage_systemz":`つのシステム`,
"label.dataimport.objectid.null":`オブジェクトIDがないため、インポートすることができません。`,
"label.currency.type":`通貨種別`,
"component_setup_button_appurl":`本システムURL`,
"label.appointmentconfirmail.wizard.title2":`{0}を既に予約しました`,
"lable.product.please.enter":`ご記入ください`,
"label.escalation.setup.title":`ケースグレードアップのルール`,
"label.create_failure":`フォームの作成に失敗しました`,
"label.weixin.brand.model":`メーカーの型番`,
"label.layout.nameoftestobj2":`テストオブジェクト2の名前`,
"vue_label_filters_number":`各レポートは最大10のフィルタをサポートします`,
"label.file.following":`フォローしている`,
"vue_label_account_all_contracts":`取引先の所有者のすべての契約を置換える`,
"label.service.please.select.cycle.type":`サイクルタイプを選択してください`,
"label.weixin.weipoll.optionname":`Micro Voteのオプション名`,
"label.data.newtemplate.null":`なし`,
"message.passwordPolicy.validate.complexReq1":`エラー：英字と数字を組み合わせは必須です`,
"label.forecast.shre.editmanager":`マネジャーを編集`,
"label.emailtemplate.tip":`選択したフォルダ内のメールテンプレートは以下のとおりです。テキスト、HTML、カスタム、または Visualforce のテンプレートを新規作成する場合は [新規] をクリックします。 メールテンプレートは、メールを送信するときに利用します。［ろーつリンク］をクリックして、より詳しい情報を獲得することできます。`,
"label.tag.manage.button":`表示ラベルの管理`,
"label.changepw":`パスワードの更新`,
"label.sso.saml.sp.idsource.nameid":`アイデンティティはサブジェクトステートメントのnameidentifier要素にあります`,
"label.salescloud.teamrole.addmember":`商談チームメンバー CloudCCを追加`,
"label.h5.similar.opportunity.last.months6":`直近の3-6か月`,
"message.save.opportunity.role.save.failed":`取引先責任者の役割の保存に失敗しました`,
"vue_label_report_formulainformation":`数式情報`,
"label.area.assignuser.remark":`エリアにユーザを割り当てます`,
"label.multilang.viewlist.total":`{0}件のレコードを選択しました`,
"label.newprocessstep4":`ステップ4.メールアラートのテンプレートを選択`,
"label.permission.objectpermission.open":`開く`,
"label.service.gantt.close.list":`リストを閉じる`,
"label.standarduserfield":`標準ユーザ項目`,
"vue_label_commonobjects_detail_the_administrator":`このレコードがロックされているので、管理者に連絡してください。`,
"label.exchange.sync.account":`Exchange サービスアカウントの証明書`,
"label.mr.title.button.back":`戻って、検索条件をリセットします`,
"label.notsetup.operation":`行の条件にエラーが発生し、演算子が設定されていません。`,
"label.notifications_center":`通知センター`,
"label.event.moveup.5hour":`5時間`,
"report_label_pleaseinput":`検索内容を入力してください`,
"label.batchadd.newbatchpage.errorlist":`データ追加失敗（件）`,
"label.quickbooks.invoices":`請求書`,
"chatter.feed.usingchatter":`CCChatを有効化してから、人とレコードを追跡し、投稿&コメントをすることができます。`,
"label.all.marketing.activities":`キャンペーンの所有者`,
"label.lookup.finish":`ルックアップオートコンプリート`,
"label.weixin.unbind":`バインディングを解除`,
"front-console-closeTime":`クローズタイム`,
"label.service.rest.time":`残りの時間`,
"label.mr.descreption.condition1":`重複データの検索の範囲とルールを入力してください。[重複データの検索]をクリックして、条件に一致する重複データを獲得します。`,
"label.group.new":`新規グループ`,
"vue_label_SMS_sending_please_wait":`送信中で、お待ちください`,
"label.Standardobj.tab":`標準オブジェクトタブ`,
"label_chatter_pastEvents":`過去の活動`,
"label.chatter.priority":`優先順位`,
"select.nullvalue":`なし`,
"setup_layout_group_pagecomponent":`ページの要素`,
"label.dataimport.dataerror.check":`データにエラーが発生し、このデータをよくチェックしてください。`,
"label.permission.detail.app.pagesetting.tip":`カスタマページ権限の設定を実行`,
"label.knowledge.language.polish":`ポーランド語`,
"label.project.hit.two":`サブタスクの期限切れリマインダー`,
"label.customerapp":`カスタマアプリケーション`,
"label.reportsSubscriptionPage.condition.value":`値`,
"label.tabpage.no2z":`いいえ2`,
"lable.system.administrator":`申し訳ありませんが、操作するためのアクセス権がありません。管理者にお問い合わせください。`,
"homepage.layout.buttion":`ページレイアウトの割り当て`,
"label.notification.event.overlapEvent":`委任先は、{begintime}-{endtime}に{subject}を計画していますが、続いて作成しまをすか。`,
"label.customfields":`カスタマ項目`,
"label.data.downpage.e.title":`データエクスポートの手順`,
"label.notification.serviceappointment.remove":`発送された作業指示{0}はキャンセルされましたので、合理的に作業を手配してください。`,
"label.campagin.roi.zhuangtai":`キャンペーン状況`,
"label.applt.updown":`ミニプログラムQRコードのダウンロード`,
"label.customfields.new.step1.tip":`カスタマ項目に含む情報種別の指定`,
"label.staticresource.upload.limit":`以下のような形式のファイルのみアップロードできます。png、jpg、gif、js、css、zip.`,
"chatter.edit.user.p":`ユーザアバターの更新`,
"label.icon.32":`コンピューター`,
"vue_label_homepage_notice_cantset":`このプロファイルはホームページが設定されていないため、プロファイルのデフォルトホームページを変更することができない。`,
"front-epwechat-module-v1-agree-unbound":`上記の拘束力のない情報に同意・承諾すること`,
"label.version.chatter.cooperation":`Chat`,
"label.customer.tab.step1.selectstyle":`タブスタイルを選択してください`,
"label.select.an.asset":`アセットを選択してください。`,
"label.search.sizer.field":`絞り込み検索条件項目`,
"label.emailmerge.mergeFolder.lastone":`以下のいずれかのテンプレートを選択してください。`,
"label_tabpage_step2":`ステップ 2.検索条件の指定`,
"label.version.lead.automatic.allocation":`リードの自動的な割り当て`,
"label.projectManagement.update.succeeded":`アップデートが完了しました`,
"label_tabpage_bar":`件`,
"label.appupload.component.type.tab":`タブ`,
"label.pigeonhole.sel.f":`アーカイブするフォルダの選択`,
"homepage.components.status":`コンポーネントの状態`,
"label.currency.edit.new":`通貨種別の編集：新規通貨種別`,
"label.input.new.password":`正しい新しいパスワードを入力してください。`,
"chatter.group.membersName":`メンバー名`,
"label.myinfo.modify":`わたしの情報を編集`,
"label_tabpage_next":`次のステップ`,
"vue_label_homepage_card_closedopportunities":`期限切れの商談`,
"label.permission.edit":`プロパティの編集`,
"message.error.searchfield.objid.null":`クエリー項目が必要とするオブジェクトIDをにしてはいけません`,
"label.partnerCloud.productSet":`製品のセットアップ`,
"label.emailtocloudcc.filed.emailto":`メールの送信先`,
"label.service.miniProgram.uploadingImage":`カルーセルの画像をアップロードしてください。`,
"label.sso.saml.idp.description1":`連続したアプリケーション`,
"label.event.moveup.10minutes":`10分`,
"label.quote.createby":`準備者`,
"label.workflow.baseontimeoparate":`時間ベースのアクション`,
"label.searchall.r":`再検索`,
"vue_label_homepage_differentprofiles":`プロファイルごとに異なるホームページを割り当てる`,
"label.campaign.channel.step1":`ステップ1.一般情報`,
"label.event.moveup.2hour":`2時間`,
"font-evaluate-module-v1-cancle-reply":`自動応答のキャンセル`,
"message.datalocked.delete":`レコードはロック済み：削除しようとするレコードはロックされました。このアクションを執行する必要あがあれば、管理者に連絡してください。`,
"label.sso.listOfKey":`秘密鍵リスト`,
"label_chatter_newtask":`新規ToDo`,
"label_emailsync_form_seversetting":`設定`,
"label.partner.new.function":`機能説明`,
"vue_label_notice_homepage_pleaceentername":`ホームページ名を入力してください。`,
"message.please.choose.opportunity":`商談を選択してください`,
"label_file_use_most_user":`メモリスペースを最も多く使うユーザ`,
"label.htyj.remark2":`契約ランキングを表示することができません`,
"label.formula.message":`数式評価がfalseであるときに提出したメッセージ`,
"UG_Case_04":`ケースの割り当て`,
"label.displaycolumn":`列を表示`,
"vue_label_campaign_selected_member_status":`選択したメンバーのステータスに更新します`,
"label.workflow.operate":`ワークフローアクション`,
"label_chatter_mail":`メール`,
"label.setup.mini.setting":`ミニプログラムのバックグラウンド設定`,
"vue_label_chat_invitetojoin":`あなたは"{invite}"をグループチャットに招待しました。`,
"setup.object.field.dependency.label.linkedfieldvalue":`連動項目`,
"vue_label_email_update_template":`テンプレートの更新`,
"label.email.template.private.mail":`専用メールテンプレートフォルダ`,
"lable.Confirm .potential.customers":`リード{name}の回収を確認します`,
"vue_label_leadpool":`リードプール`,
"label.ems.hostorpost.error":`サーバとポートの設定にエラーが発生し、チェックしてください。`,
"label.search.saveok":`保存成功`,
"label.custom.field.cannot.maping":`この項目に数回に対応付けができませんん`,
"label.projectManagement.dispatched":`発送済み`,
"time":`時間`,
"label.choose_socialnetwork":`開始するソーシャルネットワークを選ぶ`,
"label.vlidaterule.checkedtrue":`チェックボックス項目ならばこのように判断し、引用符を加える必要はありません`,
"label.appointmentconfirmail.wizard.btn1":`再予約`,
"front-kefu-moudle-v1-maxchars-input":`最大{0}文字まで入力可能`,
"setup.mainpage.label.welcome10":`手順は以下の通りです。ページ左側のメニュー→アプリケーション設定→作成→オブジェクト→オブジェクト名→カスタムレイアウトをクリックする。`,
"label.ems.company.setup.title":`会社送信トレイの設定`,
"label.channel":`販売チャンネル`,
"label.textmessage.groupsms":`グループSMS`,
"label.asset.deleted.successfully":`アセットBOMの削除に成功しました。`,
"label.knowledgebase.new.workspace":`新しいワークスペース`,
"label.ServiceCloud.diliweizhi":`位置情報`,
"label.private_me":`オーナー（私）へのプライベート`,
"label.service.miniProgram.imageLink":`カルーセルリンク`,
"label.area.assigned":`割り当てられたユーザ`,
"label.weixin..xsld.name":`商談名`,
"label.campaign.matchway.select.name":`名前`,
"label.installedsoft":`インストール済みのパッケージ`,
"label.projectManagement.spare.time":`利用可能な時間`,
"label.user.select.custom.text.sendemail":`カスタマテキスト形式を選択して、メールを送信します。`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`承認中`,
"startdate.enddate.time.illegal":`開始日は終了日より小さいべきです。`,
"label.project.hit.eight":`デイリータスクリマインダー`,
"message.duplication.label.uncheck":`校正しない`,
"label.allocation.role":`ユーザの割り当て`,
"label.sendemail.lead.scoreinfo":`尊敬的#userName:\r\n    システムはリードスコアリングを利用して、選択したリードビュー「#viewlabel」でのすべてのリードに対してスコアリングし、#timestrかかり、\r\n システムにログインして、ビューを開き参照してください。\r\n    ご注意：\r\n リードのスコアを参照することができない場合、ビューを編集して、表示する項目にリードスコアリングを追加し、スコアを参照してください。\r\n ご利用いただき、ありがとうございます。\r\n                                                          #orgName\r\n`,
"lable.oppt.jieduan.closejieduan":`当該商談を終了`,
"label.ems.verify":`認証`,
"message.error.startdate":`開始時刻は必ず終了時刻より小さいです。`,
"label.campaignmember.main.deletelead":`メンバーの削除‐既存リード`,
"label.partnerCloud.financeSetting.account":`パートナーファンドを有効化すると、パートナーファンドのオブジェクトとファンドステートメントが追加されます。パートナーユーザーは、CloudCCのアカウントを使って注文の支払いができるようになります。`,
"message.datalocked":`レコードはロック済み：編集しようとするレコードはロックされました。このアクションをどうしても執行するなら、管理者に連絡してください。`,
"lable.opppdt.selPbk.pricebook":`価格表`,
"label.knowledgebase.restore.article":`記事の復元？`,
"label.object.batchadd":`バッチ追加{objName}。`,
"label.what_happen":`フォーム送信後のページ`,
"label.roleandunderling":`ロールと下位ロール`,
"label.knowledge.language.russian":`ロシア語`,
"front-electronic-signature-explain-first":`Esignatureをバインドする前に、Fadadaプラットフォームへの登録と認証を行うことをお勧めします。`,
"component.sendmail.label.subject":`テーマ`,
"month":`月`,
"label_chatter_save":`保存`,
"label.view.sortview.sectiontitle":`ビューは選択した順番に基づき出力されます。`,
"label.mobile.home.page.major.project":`重要なプロジェクト`,
"label.weixin.input.filename":`ファイル名を記入してください`,
"label.pagelayout.remark":`当該ページでは、さまざまなページのレイアウトを作成します。`,
"label.service.miniProgram.store":`ブランドストーリー`,
"label.recordtype.edit.selected":`選択済みの値`,
"message.selectgroupcondition":`グループ化の条件を選択してください`,
"label.y.axis.cannot.empty":`Y軸は空であってはいけません。`,
"label.textmessage.vonage.connected.count":`連絡を受けた数`,
"setup.layout.label.readonly":`読み取り専用`,
"front-kefu-moudle-service-agent":`顧客サービス`,
"message.login.mfaverification.page.invalid":`ページの有効期限が切れています。ページを再表示してください。`,
"label.central.standard.time":`中央標準時`,
"label.processnoticepic":`承認プロセスで画像に注意してください`,
"vue_label_helpcenter_calendar1.2":`カレンダーエントリの表示ルール：カレンダーエントリは、カレンダーグリッドに表示され、カレンダーエントリが配置されているグリッド領域は、レコードの時間範囲を表します。24時間以上にわたるカレンダーエントリは、日、週、稼働率の各ビューの時間軸の最上部に表示されます。月ビューのグリッド内に複数のカレンダーエントリがある場合、「さらに」をクリックすると、それらを表示することができます。カレンダーエントリの左端または右端が半円になっているのは、グリッドの前後の日にそのような記録がないことを意味しています。カレンダーエントリの左側または右側が直角に丸くなっているのは、グリッドの前または次の日にまだこのレコードがあることを示しています。<br> カレンダー表示で日付を素早く探す。カレンダーページの右側にある小さなカレンダーで時間を選択すると、左側のカレンダービューに表示されている日付範囲を見つけることができます。また、カレンダーページの右上にある「＜」と「＞」のアイコンをクリックすると、日付を素早く切り替えることができます。カレンダービューの時刻が現在の時刻でない場合は、カレンダーページの右上にある「今日」アイコンをクリックすると、今日に素早く切り替えることができます。<br> リストビュー<br> カレンダービューからリストビューに切り替えることができます。カレンダービューの右上にある「カレンダー」アイコンをクリックし、「テーブル」を選択すると、行動のリストビューに切り替えます。<br> リストビューの使い方。特定の行動や複数の行動を同時に表示するには、テーブルビューを開きます。リストビューにはプリセットのリストビューがあります。リストビューの左上にある「ドロップダウンボタン」アイコンをクリックすると、アクセス可能なすべてのリストビューが表示されます。また、行動のリストビューをニーズに合わせてカスタマイズすることもできます。<br> 2.私のカレンダーと他のカレンダー<br> 私のカレンダー<br> 私のカレンダーには、私の行動カレンダーとオブジェクトカレンダーが含まれています。<br> 私の行動カレンダー。割り当てられた人が自分のものになっているすべての行動レコードをカレンダービューに表示します。「私の行動カレンダー」は、削除、編集、色の変更はできません。「私の行動カレンダー」は、同僚と共有することができます。`,
"label.approval.end":`プロセスの終了`,
"vue_label_report_notice_cannotdelete":`このフォルダには削除できないレポートがある`,
"label.sso.saml.idp.loginurl":`IDプロバイダ登録URL`,
"label.emailtocloudcc.filed.port":`ポート`,
"label.directdashboard.righttitle":`販売分析ダッシュボード`,
"label.knowledge.case.suggest.article":`ケースで関連文章を推薦します`,
"label.version.maxcount":`上限を超えています。`,
"label.weixin..xsld.yjqyrq":`契約締結予定日`,
"front-project-module-v1-unmarket-is-template":`アンマーク・テンプレート`,
"label.mobile.quickcreate.default.map":`マップ`,
"chatter.click.p":`クリックしてプレビュー`,
"label.chat.topic.all.topic":`すべてのトピック`,
"label.channel.head":`チャンネル責任者`,
"lable.edit.queue.emaildes":`通知を発送する際（例えば、ケースがキューに割り当てられたときに）、キュー名とメールアドレスを入力します。メールアドレスは、個人のアドレスでもメーリングリストのアドレスでも構いません。キューに割り当てられると、キューメンバーのみに通知します。`,
"label.tag.filter":`タグフィルター`,
"label_chatter_filterTimeLine":`タイムラインの絞り込み`,
"label.dashboard.show.value":`表示値`,
"vue_label_normal_solution_sf":`ソリューション`,
"label.customfields.location.tip":`ユーザーが位置を定義することを許可します。経度と緯度のコンポーネントを含めて、距離の計算することができます。`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com, inc.　著作権の所有者は北京神州雲動科技股份有限公司です。`,
"label.icon.33":`コンピューター`,
"label.mr.title.opportunityName":`商談名`,
"template.report.sales.month":`今月の販売実績`,
"chatter.group.lookingForPeople":`人の検索`,
"label_tabpage_userz":`ユーザ`,
"label.reportsSubscriptionPage.email.formatselection":`メールで送信するレポート形式を選択してください。`,
"lable.product.plist":`リスト価格`,
"label.multilang.activity.monthline":`第{0}週`,
"label.ccchat.whose.name.contains2":`のいずれの活動チームのメンバー`,
"label.mobile.phone.day.report":`日報`,
"label.processsetting.set.files":`項目の設定`,
"label.systemlog.s":`成功`,
"label.tabpage.uploadsz":`アップロード`,
"serviceterritory.member.time.conflict":`この時間の範囲内で、サービスリソースは他のサービスエリアのメンバーになりました`,
"label_chatter_startDate":`開始時刻`,
"label.search.at.least.two":`検索ワードは2文字以上です`,
"label.approval.ressign.project":`割り当て待ちのプロジェクト`,
"lable.custom.Previous.CY":`前のカスタマ年度`,
"label_chatter_link":`リンク`,
"label.weixin.group.name":`名称`,
"label.partnerCloud.basicSetting.domainName":`この操作は不可逆的で、初期化後はドメイン名を変更することはできません。本当にこの操作でよろしいですか？`,
"lable.SalesCommitmentKanBan.targetContract":`契約の目標金額`,
"label.currency.new":`新しい会社の通貨種別`,
"message.passwordPolicy.validate.complexReq3":`エラー：パスワードは必ず数字と英字の組み合わせ及び記号です。`,
"label.icon.127":`医師`,
"label.customfields.fieldname.tip":`項目名はAPIインテグレーションのみに使用します`,
"chatter.feed.menutype.feed":`フィード`,
"label.home.standard.dashboard.role":`ロール情報がないため、販売承諾ボードを参照することができません`,
"label.customfields.fielddependency.button":`このボタンをクリックして、連動選択リスクで選択した値を含めるかあるいは排除します。`,
"label.recentprojects":`最近アクセスしたレコード`,
"label.appupload.logo.introduce":`AppExchangeパッケージのサイズは必ず20 Kより小さいです。最適な効果を得るために、画像サイズが幅60ピクセル、高60ピクセルのほうが最もいいです。その他のサイズであれば、システムはそのサイズを調整することができますが、歪みになる可能性があります。また保存してさえ、新しい画像は有効になります。`,
"label.integrations.northamericanleads":`北アメリカのリード`,
"label.sms.balance":`残高（元）`,
"label.ccchat.message.num":`件のメッセージ`,
"label.embed_website":`このフォームを埋め込むには、以下のコードをコピーして、あなたのウェブサイトのHTMLコードに貼り付けてください。`,
"label.trigger.check.error":`トリガー構文チェックに失敗しました`,
"label.bmap.baidu.maps":`百度地図`,
"label.nextapproverauto":`次回の承認者の自動的な確認方法`,
"label.customfields.date.tip":`日付を直接入力することも、ポップアップのカレンダーから選択することもできます。`,
"button.partner.back":`戻す`,
"label.layout.editcondition.tip":`検索条件とする項目を選択します。ご注意：ここでは最大10文字まで選択できます。`,
"label.stacked.area":`積み重ねた図形－エリア`,
"font-evaluate-module-v1-case-closed":`事件が解決したときのみ`,
"label_emailsync_status_log":`ログの関連付け`,
"label.version.area.and.sales":`テリトリーの管理と販売チーム`,
"label.service.booking.sessions":`サービス予約の時間帯`,
"label.untransfile":`翻訳されていな言語ファイル`,
"label.textmessage.sentfail":`送信に失敗しました。`,
"label.emailtemplate.detailinfo":`メールテンプレートの詳細情報`,
"setup_mainpage_label_welcome13":`アクションガイド：トップのメニュー → レポート → 作成をクリックしてください。`,
"label.ccchat.error.nullid":`IDは必須項目です`,
"label.partnerCloud.partnerAccount.rebate":`Rebate Revenu`,
"label.appupload.component.type.scheme":`項目`,
"front-kefu-moudle-phonein":`インカミングコール`,
"label.emailmerge.list.description":`差し込み印刷テンプレートは、Cloudcc 項目を参照する差し込み項目のある Microsoft Word ドキュメントです。[新規テンプレート] をクリックすると、新しい差し込み印刷テンプレートをアップロードできます。`,
"vue_label_commonobjects_detail_select_first":`まず関連項目を選択してください`,
"label_emailsync_form_action":`アクション`,
"label.customfieldrelation":`スタム項目 & リレーション`,
"label.ems.other.msg":`Cloudcc管理者に連絡してください`,
"label.appointment.wizard.subtitle4-3-4":`1時間`,
"label.service.miniProgram.isOpen":`有効`,
"equal":`イコール`,
"label.partnerCloud.financeSetting.merchantInformation":`アクセスパスマーチャントプラットフォーム  アカウントセンター  マーチャント情報`,
"vue_label_calendar_displayed_field_name":`表示される項目名`,
"UG_opportunity_002":`販売サイクル、設定段階を定義します`,
"label.tag.addtags.button1":`確認`,
"label.explain":`説明`,
"label.icon.166":`パビリオン`,
"label.exchange.sync.setting.use":`Exchange Sync を有効化`,
"label.chatter.assignPerson":`任命先`,
"lable.PowerProcess.event.condition":`重大行動の条件`,
"label.addattachment.step1":`ステップ1.ファイルを選択してください`,
"label.account.fiscal.quarter.timeerror":`四半期開始日または四半期終了日が過去の会計年度以内にあるので、確認してリセットしてください。`,
"label.URL":`URLパス`,
"label.icon.134":`データ`,
"label.forecast.customforecast.foredis.sq":`数千`,
"label.custom.field.number.decimal":`数値の桁は不正確です`,
"label.version.history.track.error":`現在のバージョンは5つ以下の項目しか選択でませんが、これ以上選べないです。`,
"label.log.os":`アクションシステム`,
"label.partner.workspace.tab.option":`選択可能なタブ`,
"label.partnerCloud.partnerAccount.accountWater":`ファンド・ステートメント`,
"setup_layout_label_norelatedlist":`関連リスクがありません`,
"label.import.page1.nextstep":`次のステップ`,
"label.emailobject.view.attached":`添付ファイルあり`,
"label.SalesCommitmentKanBan.allTask":`ノルマの合計金額`,
"label.eastem.daylight.time":`東部夏時間`,
"label.create_engaging":`世界につながる魅力的なポストを作る。`,
"label.area.adduser":`ユーザの追加あるいは削除`,
"label.timezone.importtimezone.user":`現在のユーザのタイムゾーンを使用`,
"label.passwordPolicy.setup.pwdremember1":`1つのパスワードを記憶`,
"label.query.detail.openpartneruser":`パートナーユーザを有効化`,
"label.senduser":`送信者`,
"Pagelayout_Setup_001":`フロートページレイアウトで表示される関連リスクを選択`,
"label.mobile.parameter.setup":`モバイル端末パラメータの設定`,
"message.device.not.bound.mfa":`バインディングされていないMFAデバイス`,
"setup.layout.label.buttonarea":`ボタンエリア`,
"chatter.email.reply.like":`私がいいね! と言った投稿にコメントした`,
"label.chatter.day":`日`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat お気に入りの書き込みを返事`,
"label.field.remark2":`ページに表示された項目`,
"label.ggReleaseRange.release":`発行範囲`,
"lebel.alreadyback":`呼び戻し済み`,
"label.appupload.install.appname":`アプリケーション名`,
"label.selectnewadeckertag":`新規階層項目の表示ラベルを選択`,
"label.cliententrancewebsiteadmin":`取引先のWebサイト入口の管理者`,
"label.checkbox.checked":`選択済みの`,
"UG.Case.03":`ケースの自動的なアップグレード`,
"vue_label_dashboard_group":`グループを選択してください`,
"label.import.index.preparedata":`インポートするデータの準備`,
"vue_label_member_notice1":`JPG、GIF、PNGのファイルをアップロードすることができ、最大ファイルサイズは2Mです。`,
"message.modify.success":`更新に成功しました`,
"label.userquotas":`定額`,
"label.appointmentpage.wizard.subtitle3-1":`名前`,
"label.import.index.maxdata2":`2、インポートする前に、まずすべての関連レコードをインポートしてください。例えば、現在インポートしているオブジェクトと連絡先の間にルックアップ関係がある場合は、まずその取引先責任者をインポートしてからデータをインポートしてください。関連レコードIDなどを取得する必要がある場合は、レポートを作成し、レコード名とレコードIDをグループカラムとして設定してから、レポートをエクスポートしてください。`,
"label.pc.sectionpart":`PCセクション`,
"template.chart.wcldqzkh":`未処理のリード`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`現在の価格表のブロック価格情報を保存しますか？`,
"label.partnerCloud.financeSetting.payments":`オンラインでのお支払いについて`,
"lable.account.ThisWeek":`今週`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`背景色の選択`,
"label.planned.work":`スケジュール済みジョブ`,
"label.passwordPolicy.setup.nolimit":`制限なし`,
"label.vlidaterule.s":`ユーザが使用する通貨種別の使用を禁止するなら、ユーザの通貨種別は会社の通貨種別として設定されます。`,
"label.paging.totalofrecords":`{0}件のレコード`,
"label.customobjects.behaviour":`行為`,
"vue_label_ccchat_notice_deletecommentsuccess":`コメント削除に成功しました`,
"label.lock.record.dele":`現在のレコードはロックされたため、削除できません。`,
"label.data.expnode.e.desc3":`3、テンプレートの作成：ユーザーはニーズに合わせて、エクスポートする項目や条件に応じ、テンプレートを作成することができます。`,
"label.button.step3.create.page":`ステップ3：ページの生成`,
"label.sharer":`共有者`,
"label.service.cycle.type":`サイクルタイプ`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`代金受取の承諾率`,
"label.formuladate":`日付の表示形式：yyyy-MM-DD hh:mm:ss 例えば、 2007-12-25 12:25:30  、today()あるいはnow()を使ってもいいです;`,
"front-template-V1-addImg":`画像の追加`,
"label.basecontrol":`基本アクセス`,
"label.forecast.settings.lable1":`予測データのアグリゲーター`,
"message.error.file.null":`アップロードファイルを空にできない`,
"label.multiply":`*かける`,
"message.duplication.label.targetobject":`目標オブジェクト`,
"label.addattachment":`ファイルの追加`,
"vue_label_dashboard_notice_editcertification":`コンポーネント{name}を編集しますか。`,
"label.notification.tip2":`新しい通知はありません`,
"lable.quote.syncingfrom.firstsync":`初期同期：商談は見積書に同期します`,
"label.createtasktip":`ToDo を作成し、1 つ以上のワークフロールール、承認プロセス、またはエンタイトルメントプロセスと関連付けます。ToDo を変更すると、変更はそれに関連付けられているすべてのルール、承認、またはエンタイトルメントプロセスにも適用されます。`,
"label.leave":`Leave`,
"front-invoice-online-payment-setup-china":`中国語アカウントへの応募`,
"label.appointment.wizard.subtitle4-1-2":`30分`,
"label.projectManagement.the.person.not.be.informed":`「いいえ」を選択した場合、責任者に通知することはできません。`,
"label.campagin.roi.name":`キャンペーン名`,
"label.import.page1.newcreate":`新規`,
"label.data.downpage.i.title.num2":`2、インポートを開始する前に、インポートするファイルの項目名とCloudCCのオブジェクト項目名が一致していることを確認してください。`,
"label.callcenter.call.in":`コールイン`,
"label.weixin.activity.phone":`活動：電話`,
"label.forecast.customforecast.type.role":`ロールに基づく`,
"label.moscow.standard.time":`モスクワ標準時`,
"label.profile.setcustomobjectrecordtype":`カスタマオブジェクのレコードタイプの設定`,
"lable.edit.queue.new":`新規キュー`,
"label.newAPPexchange":`新規アプリケーション`,
"message.custom.field.donotdelete.fieldupdate":`この項目はその他のワークフローあるいは承認プロセスの項目更新に参照されます`,
"label.chatter.state":`ステータス`,
"label.subject_line":`課題`,
"template.report.folder.active":`キャンペーンとアクションの分析`,
"label.icon.114":`家`,
"label.assignment.setup.newentries.step3":`ステップ3.割り当てられたユーザの選択`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`個人‐行為‐一覧`,
"label.weixin.optiontwo":`選択肢 2`,
"label.sso.saml.idp.config.sp":`サービスプロバイダ`,
"System_TimeField_Description":`ユーザがローカル時刻を入力できます。たとえば、「2:40 PM」、「14:40」および「14:40:00」はすべてこの項目で有効な時刻です。`,
"label.knowledgebase.draft":`ドラフト`,
"label.chat.topic.no.more.suggestions":`異議なし`,
"label.quote.product":`商品`,
"label.cryptographictext":`暗号化テクスト`,
"label.custom.unlock":`ロック解除`,
"label.assignment.setup.newentries.step2":`ステップ2.当該ルールエントリーの条件を選択`,
"label.tabularreport.selectline":`レポートに含む列をご選択ください`,
"label.exchange.sync.state.contact.m2":`最後60分間の同期レコード`,
"label.codeType":`コードタイプ`,
"saturday":`土曜日`,
"label.mask.type":`サブネットマスク種別`,
"label.schedulejob.setup.schedule.Monthly":`毎月`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`ファイルに項目 が{{20}}あり、残りの｛{20}}が対応付けされていない`,
"label.projectManagement.delete.item":`このプロジェクトを削除すると、このプロジェクトの関連情報はすべて削除され、データの復元はできません。確かに削除しますか。`,
"label.page.general.us.and.western.europe":`通用するアメリカ英語と西欧言語`,
"label.reportsSubscription.status":`購読済み`,
"label.discount.baifenbi":`割引率(%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`ウェブ評価の設定`,
"message.error.searchwork":`キーワードは2文字以上です。`,
"label.weixin.option.setting":`オプションの設定（10つのオプションまで設定可能）`,
"label.lead.score.prompt1":`単一リードシステムに対しては、リードの作成と編集をする際に自動的にスコアリングすることができますが、一括インポートされたり、インターフェースを通じて作成されたりするリードに対しては、手動で一括スコアリングする必要があります。`,
"label.exception.must.try.throw":`ステートメントブロックで例外をスローします`,
"label.activity.plan":`計画`,
"label.partnerCloud.productSet.editor":`編集オプション`,
"label.mobile.quickcreate.default.signinnew":`サインイン`,
"label.summaryreport.2018.step6.new":`ステップ6：画像種別とレポート強調表示の選択`,
"vue_label_homepage_owner":`のホームページ`,
"vue_label_dashboard_editfoldersuccessfully":`フォルダの編集に成功しました`,
"label.quickbooks.view.overdueinvoices":`期限切れの請求書`,
"label.emailtocloudcc.redmessage4":`ポート情報を入力してください。`,
"label.tabpage.equalz":`等しい`,
"lable.quote.syncing.firstsync":`初期同期：見積書を商談に同期します`,
"label.download.CloudCCAPP":`CloudCCアプリのダウンロード`,
"label.icon.6":`通貨`,
"label.list.serial.number":`シリアルナンバー`,
"label.profile.setstandardobjectrecordtype":`標準オブジェクト?レコードタイプの設定`,
"label.customize.memory.function.sorting.error":`クエリの応答時間が長すぎて、ページのタイムアウトが発生します。ヘッダーソートのメモリが有効になっていることが原因と考えられます。個人設定で、この機能を無効にしてください。`,
"message.view.addtoallusers":`関連者が参照可能`,
"label.globaloperation.operationtype.record.phone":`通話履歴`,
"lable.opppdt.selPdt.searchresult":`検索結果`,
"label.import":`インポート`,
"label.service.gantt.work.based.resources":`労働時間に基づくリソース`,
"label_partner_template_detailimage":`詳細の図`,
"label.cpq.product.feature.option.count":`製品オプションの最小値が製品オプションの最大値を超えることはできません。`,
"label.chatter.newtask":`新規ToDo`,
"font-trade-module-v1-invoice-total-price":`予定総支払額`,
"setup_mainpage_label_welcome29":`スタンダートAPIと第三者の製品のイングレーション`,
"label.data.exportall.all.btn":`すべてのデータのエクスポート`,
"front-epwechat-module-v1-unbound-WeChat":`アンバインド・ウィーコム`,
"label.salescloud.salesdashboard.performance.rankings":`全体‐販売契約業績のランキング`,
"label.import.page1.newcreateandupdate":`更新して新規作成`,
"component.chatter.post.button.file":`添付ファイルの追加`,
"label.partnerCloud.orderingPlatform.createOrder":`ニューオーダー`,
"label.lookup.multiple.data":`複数のデータを検索し、手動で選択してください。`,
"button.partner.save":`保存`,
"label.service.add.timeslot":`タイムスロットの追加`,
"label.campaign.matchway.select.email":`メール`,
"front-sales-button-fromQB":`QuickBooksからのお知らせ`,
"label.icon.108":`矢`,
"lable.outlook.edit.efmapping":`項目の対応付けの編集`,
"label_tabpage_refreshz":`更新`,
"chatter.follow.cancel":`フォローをキャンセル`,
"label.totals.sum":`統計トータル`,
"label.noRequest":`要求なし`,
"vue_label_homepage_fixedcomponent":`スタンダードコンポーネントを選択してください`,
"label.knowledge.delete.case":`ケース記事の削除にエラーが発生しました`,
"label.weixin..xsld.yjwc":`期待収益`,
"label.customcomponent.page.index.console.btn":`開発者のコンソール`,
"label.sendsms.batch":`SMSの一括送信`,
"vue_label_chat_onlychosechat":`チームのユーザーチャットのみが選択可能です`,
"label.tabpage.page":`ページ`,
"label.cyen.note":`通貨種別の有効化。有効化した後に復元できないことをご注意ください。`,
"label.weixin.againsend":`再送信`,
"label.processnumber":`ステップ番号`,
"label.emailobject.to":`受信者：`,
"label.event.today":`今日の行動`,
"label.dashboard.dispalyPosition":`位置の表示`,
"message.error.recalculate.dupoperate":`再適用しており、頻繁に操作しないでください`,
"vue_label_email_linkrecordsuccess":`レコードの関連付けに成功しました`,
"label.updateoutboundnews":`アウトバウンドメッセージの更新`,
"label_emailtocloudcc_exists2":`このメールボックスは既にEmail to Case．に設定されていますので、重複な設定をしないでください。`,
"label.tag.addtags.button2":`キャンセル`,
"label.stdashbord.xsld.business.role":`当該ロールは予測階層で有効化されたユーザのロールです。`,
"label.commonnew":`一般的な新規作成`,
"label.validate.remark2":`使用例：`,
"label.reportsSubscriptionPage.condition.checkbox":`このレポートに条件を追加する`,
"label.globalselect":`グローバルオプションリスク値セット`,
"label.partnerCloud.partnerAccount.available":`利用可能な金額`,
"label_tabpage_nothingz":`なし`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`ヒートマップ`,
"message.error.pleasecorrectdata":`下記のエラーメッセージをチェックし、データを更新します。`,
"label.hight.tip":`高度な検索を有効化しないとき、それぞれの条件の間が「AND」で、つまり1と2の共通の特徴を満たすレコードを検索します。`,
"label.workflow.estimatecondition3":`作成されたとき、および編集されるたび`,
"AssetRelationship.time.limit.error":`開始日は、期日よりも早いか同じでなければならない。`,
"label.multilang.workflow.dayinmonth":`{0}カ月{1}置きの第{1}日`,
"label.reportsSubscriptionPage.schedulereport.daily":`毎日`,
"label.emailtocloudcc.step1.name":`機能の選択`,
"label.follow_up":`フォローアップメール`,
"label.price.list.price.cannot.be.empty":`リストプライスは空にはできません。`,
"label.chatter.link":`リンク`,
"label.ccpeak.condition.return.record":`条件基づきレコードに返し、where条件をサポートします。`,
"pagecreator.layout.message.canntdelete":`現在のレイアウトは削除ができません。`,
"label.compact.layout.main":`主なキー情報レイアウト`,
"label.testandupdate":`更新のチェック`,
"button_partner_cancel":`キャンセル`,
"label.activity":`活動`,
"label.knowledge.setting.hint.fourteen":`書く準備をしましょう`,
"vue_label_commonobjects_view_open_from_list":`リストから開いて、使用を開始します`,
"front-electronic-export-intro":`一度に2000レコードをMailchimpにエクスポートすることができます。`,
"label.chosen.all":`すべての項目`,
"label.file.extension":`ファイル拡張子`,
"vue_label_systemSettings_server_miniprogram":`サービスミニプログラム`,
"label.weixin.no.pending.wdgz.qin.today":`今日は仕事の計画がありません`,
"label_tabpage_issuez":`問題`,
"label.staticresource.tip":`静的リソースを使用して、.zip ファイル、.jar ファイル、画像、スタイルシートなどのファイルを含む、カスタマページで参照するコンテンツをアップロードします。`,
"label.approvalstep":`承認プロセス`,
"label.china.standard.time":`中国標準時`,
"label.appexchange.download.tiaoguo":`スキップ`,
"label.callcenter.link.Amazon.connect":`Amazon Connect`,
"vue.dashboard.notRequired.notConformToTheRules":`必要項目が記入されていないか、またはルールに適合していませんので、送信できません。`,
"label.appointment.wizard.title1":`利用可能な時間を設定してください`,
"label.chat.remove.bookmark":`ブックマークを解除`,
"label.tabpage.advancedsearch":`高度な検索`,
"batch.ranf.f":`一括移行に失敗しました`,
"label.appointment.wizard.subtitle4-1-4":`1時間`,
"label.brief.account":`ユーザ`,
"component.chatter.link.label.url":`リンクURL`,
"label_emailtocloudcc_redmessage8":`パラメータが間違っています。管理者に連絡してください。`,
"label.object.create.two.number.field":`オブジェクト毎に最大2つまでのカスタマ自動採番項目を作成することができます。`,
"label.salecommit.not.roleinformation":`ロール情報がないため、販売承諾ボードを参照することができません。`,
"label.defautline.cannot.less":`デフォルト行数は必ず1行以上です`,
"label.selectedproducts":`選択済みの商品件数`,
"label.productsales.today.notskadd":`今日、期限切れのToDoがありません。右上の「＋」をクリックしてToDoを追加することができます。`,
"lable.account.year.stadate":`会計年度の開始日`,
"label.mobile.phone.month.plan2":`今月の計画`,
"label.ccpeakfolder":`クラスフォルダ`,
"setup_mainpage_label_welcome21":`CloudCC クラウドプラットフォームはユーザにカスタマイズメールテンプレート機能を提供しており、利用の便利さを図り、仕事の効率を向上させます。`,
"label.modify.layout":`レイアウトの編集`,
"report.label.folder":`フォルダー`,
"label.tianyancha.businessverify.rewritename":`取引先名の記入`,
"lable.currencyAdv.dao":`まで`,
"label.mobilelayout":`モバイル端末のレイアウト`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`このモデルはすでに有効化になっており、編集はできません。`,
"label_partner_all_disable":`使用禁止`,
"label.ownerapproverfield":`所有者の承認者項目`,
"label.emailobject.template.message4":`現在のメールの本文に挿入されている項目にはNull値があります。編集後に再送信してください。`,
"label.productsales.today.notsk":`今日、期限切れのToDoがありません。`,
"label.multilang.document.upload.success":`{0}個のファイルのアップロードに成功し、{1}個のファイルのアップロードに失敗しました。`,
"label.manageAll.sta3":`承認却下`,
"vue_label_calendar_week_view":`カレンダー-週表示`,
"setup_layout_label_nocustompage":`カスタマページはありません`,
"label.weixin.wdyj.jxdcl":`個人‐パフォーマンスの達成率`,
"label.donot.update":`更新権限がありません`,
"setup.mainpage.label.welcome14":`ワークフローのカスタマイズ、承認プロセスの管理`,
"UG_Campaign_002":`キャンペーンを計画?実行し、またをモニターします。`,
"label.layout2":`レイアウト2`,
"label.app.looup":`アプリケーションを検索`,
"label.projectManagement.selectitem":`プロジェクトを選択してください`,
"label.field.relating.rule":`項目の関連ルールを検索`,
"vue_label_commonobjects_detail_selectname":`先ず名前を選択してください`,
"front-email-payment-Invoice-select-pay":`Pay By」を選択します。`,
"label.customfields.formula.numberexample":`Fahrenheit（華氏）`,
"component_event_label_enddate":`*終了時刻`,
"label.partnerCloud.partnerAccount.lineOfCredit":`クレジットリミット`,
"label.chatter.newpost":`最新の投稿`,
"label.report_dashboard":`このレポートは、あなたのレポートに保存されます。また、ダッシュボードに追加することもできます。`,
"label.assigned":`任命先`,
"Homepage_News_002":`現在ニュースコンポーネントは使用不可能です`,
"label.approval.select.relatedobj":`関連先を選択する場合、1つの種別を選択しなければなりません。`,
"label.service.miniProgram.isTop":`トップにしますか`,
"message.error.object.datatoolang":`データは長すぎで、最大{!length}文字までです。`,
"label.importsourcetip":`インポートはエクスポートプロセスから生成されたファイルを受け入れるように設計されています。エクスポートを実行していない場合、すぐにエクスポートページに移動してください。`,
"label.select.deadlineplease.deadline":`締め切り日を選択してください`,
"vue_label_account_equityrelationship":`持分関係`,
"label.account.Calendar.month":`カレンダー月`,
"label.appointment.wizard.subtitle3-4":`木曜日`,
"font-evaluate-module-v1-smaller-500":`500KB以下のファイルであること`,
"label.reportsSubscriptionPage.email.tome":`私のみに送信します`,
"label.ccchat.person.invite.existpers":`追跡中`,
"label.appointment.wizard.subtitle1-3":`30分`,
"front-kefu-moudle-connected":`コネクテッド`,
"label.campaignmember.main.duplicatelist.tip":`システムはここの設定により、リードとキャンペンメンバーの重複排除を有効化します。`,
"label.visualpage.such.tags.double":`タグはペアで表示されます`,
"label.sendsms.batch.step2.introduce":`SMSテンプレートにより送信：SMSテンプレートをを選択してください。`,
"Account_News_Setting_002":`下記の取引先設定を使用して、組織のデフォルト取引モードを指定します`,
"message.encryptchange.alert":`{{!fieldapi}}を暗号化項目（メモリの暗号化）から暗号化テキスト（暗号化を表示）に置き換えます。置き換えた後に、この項目はクリアテキストでデータベースに保存し、プロファイルの設定に応じてクリアテキストあるいは暗号化で表示されます。項目は検索できます。このアクションは元に戻せないですが、確かに執行しますか。`,
"label.mainpageset.description":`実際のビジネスニーズに基づき、組織レベルのホームページを構成してください<br>デフォルト構成では企業業務と関連しないコンポーネントを無効にするかまたはオフします。<br>有効化：有効化されたコンポーネントはすべてのメンバーのホームページで表示されます。`,
"label_tabpage_linknamez":`リンク名`,
"label.companyname":`北京神州雲動科技有限公司`,
"label.currency.current":`現在の会社通貨種別`,
"label.campaignmember.main.duplicatelist.html.title":`スキャンして重複削除を設定する`,
"label.sendsms.batch.step3.plan":`予定交付日`,
"label.profile":`プロファイル`,
"label.canceluploadfile.step":`[アップロードのキャンセル]をクリックして、上記エリアで表示されたすべてのファイルをキャンセルします。`,
"message.newreport":`新規レポート`,
"label.service.newBuildDialog.date.selection":`日付の選択`,
"label.lookup":`検索`,
"label.file.editinfo":`ファイルの詳細情報を編集`,
"component_assistant_label_nodata":`今日は事項がありません。後ほどチェックしてください。`,
"label.tianyancha.businessverify.msg4":`この機能は第3者のデータクエリインターフェースで提供されるサービスを利用しており、現在は無料ですが、CloudCCは第三者が引き続き無料で提供するか確保できません。有料になる場合、CloudCC はユーザーに料金を徴収する権利があり、またはユーザはこの機能を使用しないようにします。`,
"label.noequal":`!=等しくない`,
"vue_label_metric_column":`テーブルには少なくとも1つの評価カラムが必要です。`,
"label_reportType_chose_and_form":`レポートデータソースとレポート表示形式の選択`,
"vue_label_pool_reasondescription":`{0}理由の説明`,
"label.isusing":`有効`,
"label.passwordPolicy.setup.pwdremember5":`5つのパスワードを記憶`,
"label.cancel":`キャンセル`,
"vue_label_helpcenter_detail1.1":`lightningバージョンのデータ詳細ページでは、シングルレコードの基本情報、関連アクティビティ、ダイナミックを表示し、モジュールの右上に対応情報を折り畳んだり広げたりすることができます。また、関連リストを通じて、レコードに関連データを表示・管理することができます。<br> 1.シングルデータを表示し管理します<br>右上のボタンで他の担当者のデータを編集・コピー・削除・共有することができます。<br>ユーザーの詳細情報を表示し、ページ上のいくつかの項目を直接に編集して、データの所有者やレコードタイプを変更することができます。<br>関連リストを通じてレコードに関連するデータを表示して管理することができます。ファイルの関連リストでは、記録されたファイルをアップロードするか、またはファイル名をクリックして対応ファイルをダウンロードして表示します。<br> 2.関連リスト<br>関連リストから素早く接続し、フローティングウィンドウを使って最大10件までの関連レコードを表示することができます。クリックするとリストビューに移り、すべての関連レコードが表示され、インラインで編集することができます。<br>カードレイアウトを使用して、下の関連レコードを表示・管理することができます。<br> 3.アクティビティ<br> 記録の詳細ページでは、Lightning版では「未処理のアクティビティ」や「アクティビティの履歴」といった2つの関連リストは表示されません。<br>アクティビティのタイムライン表示内容<br>アクティビティのタイムラインには、既存レコードの未来から過去までのすべてのアクティビティを表示することができます。期限切れのToDoや今後予定されているToDoや行動は、タイムラインの「期限切れと間もなく」モジュールに表示されます。過去または現在完了済みのToDo、行動、通話履歴、メール、ショートメッセージは、該当月に表示されます。<br>`,
"registration.page.preview":`登録ページのプレビュー`,
"label.quickbooks.search":`検索`,
"label.setup.mobile.bottombutton.tab.show":`下部のタブ表示`,
"lable.want.to.delete.tem":`サービスレポートテンプレート{currentTelmplateName}を削除してよろしいですか？`,
"label.multilang.fielddtrack.dealkey":`{0}を{1}から{2}に変更します`,
"vue_label_pool_return":`戻る`,
"vue_label_calendar_failed_to_share_calendar":`カレンダーの共有に失敗しました。`,
"label.less":`<より小さい`,
"label.email.form.html":`HTML`,
"label.tag.nodata":`レコードなし`,
"label.setarticlecon":`プロジェクト条件の指定`,
"label.searchlayout.displayrow":`表示される列`,
"label.change.task":`ToDoビューに切り替え`,
"lable.quote.editqtpdt.title":`見積書明細の編集`,
"label.appointment.wizard.subtitle4-4":`予約はいつからできますか。`,
"label.custom.page.button.css":`ボタンCSS`,
"label.input.documentmessage":`詳細情報の入力`,
"vue_label_commonobjects_detail_email_address":`受信者のアドレス`,
"label.chatter.filterTimeLine":`タイムラインのフィルター`,
"label.must.select.twoorthree.records":`2つあるいは3つのマージするレコードを選択する必要があります。`,
"label.mobile.setup":`モバイル端末の設定`,
"vue_label_commonobjects_detail_key_field":`キー項目`,
"label.chatter.relateitem":`関連先`,
"label.customobjects.tip":`カスタムオブジェクトを作成すると、カスタムタブ、カスタム関連リスト、レポート、ダッシュボードを作成して、カスタムオブジェクトデータと対話できるようになります。 CloudCC.com API を使用して、カスタムオブジェクトデータにアクセスすることも可能です。`,
"label.sso.saml.idp.config":`IDプロバイダの設定`,
"label.knowledgebase.affect.article.version":`その修正は既存の翻訳に影響を与えますか？そうであれば、貴重な翻訳に「期限切れ」のマークを付けて、翻訳会社に「翻訳待ち」のリストを作成することができます。`,
"message.error.record":`対応するレコードが見つかりませんでした。`,
"message.duplication.label.fieldname":`目標項目`,
"setup.layout.button.cancel":`キャンセル`,
"label_radar_map_function":`レーダー図と複数の指標を利用して、取引先責任者の販売決定チェーンにおける役割を測定する`,
"label.campagin.roi.fss":`送信件数`,
"label.emailobject.template.giveup":`キャンセル`,
"label.apiname.exists":`Api名は存在済みです`,
"message.failtoreaddata":`データの読み取りに失敗しました`,
"label.file.versionedit":`内容の修正者`,
"template.report.lost.business.opportunity":`機会損失`,
"label.ccchat.group.allowgd":`チームのファイリングを許可`,
"label.fieldaccesslimit":`項目のアクセス可能性`,
"label_target_model":`ターゲットモデル`,
"message.validation.isnoturl":`正しいURLをご入力ください`,
"servicecrew.member.time.conflict":`この時間の範囲内で、サービスリソースは他のサービスグループのメンバーになりました`,
"label.knowledgebase.delete.details":`課題情報が削除されます。`,
"vue_label_normal_bottom":`ボトム`,
"label.custombutton.editerror":`編集失敗`,
"label.dashboardSetup.showdw.d6":`自動`,
"message.error.field.decimalPlaces":`小数点以下桁数の入力形式は間違っています`,
"label.tabpage.busoppnamez":`商談名`,
"label.insertfield.intro":`項目を選択し、[挿入]をクリックしてください。[>]が付く表示ラベルはより多い使用可能な項目があると表します。`,
"setup.layout.label.nocustompage":`カスタムページがありません`,
"front-gantt-module-project-has-only":`このプロジェクトには{n}個のマイルストーンしかありません。`,
"label.weixin.fmu.am":`午前`,
"label.emailsync.status.connectaccounts":`メールアカウントの関連付け`,
"label.customcomponent.check.name.same":`名前は存在済みです`,
"label.validate.function.funcFormat.HOUR":`HOUR(日付)`,
"label.approvepagelayout4":`前のページのレイアウトをコピーします`,
"label.knowledge.category.hint.nine":`カテゴリーグループの活性化`,
"label.report.sorting.column":`並び替え`,
"label.hours":`時`,
"label.email.clearAllemail":`このメールと同期ているメールをすべて削除しますか。`,
"font-evaluate-module-v1-satisfaction":`満足のいく評価`,
"label.service.hide.more.info":`更なる情報の非表示`,
"label.area.list.intro":`ここではエリア情報をアクションすることができます`,
"label.sendemail.chat.addPostat":`#name様:\n\n    こんにちは。#userName様が発信した書き込みで私に関する内容を書き込みました。`,
"label.data.newtemplate.e_seltype.desc":`データエクスポートの方法に二種類があります：`,
"message.passwordPolicy.validate.minlengths":`エラー：パスワードの長さは`,
"message.save":`確かに保存しますか`,
"label.marketsea.notfollowdays1":`獲得後`,
"label.app.step1":`ステップ1.種別の選択`,
"message.error.pageid.null":`FacebookのソーシャルメディアIDは空にできません`,
"label.weixin.input.lookupfield":`キーワードを入力して、一致するMicro Voteを検索します`,
"label.whChatAccount":`Wechatアカウント`,
"label.tabpage.groupingitem":`グループ化のアイテム`,
"label.callboard.introduce":`以下は御社のすべてのリリースが表示されます。`,
"label.financial.services.seminar":`金融資産管理セミナー`,
"label.data.file.i_title.num1":`1.導入するファイルは必ずCSV形式で、CSVファイルはタイトルを含む必要で、タイトルがないとインポートできません。`,
"label.visualpage.filename.exist":`ファイル名は存在済み`,
"front-kefu-moudle-v1-new-chats":`新しいエージェント`,
"label.console.step5.tab":`タブを開く`,
"vue_label_opportunity_contactrole_edit":`取引先責任者の管理役割`,
"label.projectManagement.delete.return":`最後のデータです。これを削除すると、前のページに戻ります。`,
"registration.page.designs":`登録ページの外観設定`,
"label.console.step6.heigth":`高さ`,
"label.objectRelationshipAtLeast":`少なくとも1つの関連レコードがあります`,
"label.knowledge.delete.viewstat":`知識記事の閲覧データを削除するにはエラーが発生しました`,
"label.direct.dashboard.month.report":`新規月報の作成`,
"label_tabpage_lookatmorez":`さらに表示`,
"label.setup.rights.management":`権限の管理`,
"label.campaign.channel.clear.img":`画像のクリア`,
"label.calendar":`カレンダー`,
"label.biaoqingfaxian.username":`アカウント`,
"label.weixin.wdyj.jxht":`個人‐セールスパフォーマンス－契約`,
"label.emailtocloudcc.exists1":`このメールボックスは「Email to Lead」に設定されています。設定を繰り返さないでください。`,
"label.emailtocloudcc.filed.password":`パスワード`,
"label.what_create":`どのような形にしたいのか？`,
"vue_label_report_onlydisplaypart":`最大50個までのデータ。実行後、すべてのデータが表示されます。`,
"label.up":`上へ`,
"label.addattachment.edit":`ファイルの編集`,
"label.ccchat.message.search.desc5":`検索ワードは2文字以上です`,
"label.chose.nonotice":`まず通知しないレコードを選択してください`,
"UG_activity_06":`取引先をフォローしたい`,
"label.set_contactsmarketing":`キャンペーンの連絡先として設定`,
"pagecreator.layout.button.horizontal":`横分割`,
"label.brief.opportunity2":`機会`,
"label.ems.nomsg":`未設定`,
"label.fieldupdate.tip":`項目自動更新により、項目値を指定した値に自動的に変更できます。項目自動更新は、ワークフロールールおよび承認プロセスに関連付けられているアクションです。`,
"label.sso.saml.sp.federationid":`フェデレーションID`,
"label.import.page2.suited":`対応付けされた`,
"message.error.appexchange.integrity":`アップロードするパッケージでのコンポーネントの完全性を確保してください。`,
"label.fielddatatype":`項目のデータ型`,
"message.approval.cannotsubmit.detail2":`このレコードは下記オプションの条件の1つを満たすかあるいは数式評価がtureです。そうでなければ申請を提出することができません。修正してから再提出してください。`,
"vue_label_commonobjects_detail_cloud_as_a_user":`ユーザーとしてパートナークラウドにログインします。`,
"label.summaryreport.selectlinetogroup":`レポートのグループ化の根拠とする列を選択`,
"label.tabpage.norecordtypez":`使用不可能なレコードタイプ`,
"label.icon.141":`通貨`,
"label.addattachment.step3.intruduce":`アップロード中であれば、進行中のアップロードをキャンセルします。`,
"label.trigger.recursive.call.three":`トリガーは3回まで繰り返し転用できます。3回を超えると、システムはエラーメッセージを出します。`,
"maintenanceplan.workorder.type.asset.workorder":`作業注文の生成方法は「資産ごとに作業注文書を作成する」を選択してください`,
"label.emailtocloudcc.select1":`選択してください`,
"label.system.log":`システムの配置監査ログ`,
"vue_homepage_dashboard_not_support_fullscreen":`申し訳ありませんが、お使いのブラウザはフルスクリーンをサポートしていません。`,
"label.projectManagement.nodata.resource":`まだいずれのプロジェクトに参加していません。メンバーに「私」のプロジェクト情報を追加すると、チームメンバーの時間配分を確認することができます。`,
"label.exchange.sync.state.contact":`連絡先`,
"label.field.type":`項目種別`,
"label.selected.object":`選択済みのオブジェクト`,
"label.customfields.new.step2":`ステップ2.詳細情報の入力`,
"label.monitorsys.delete.style":`アクション種別`,
"label.projectcondition":`プロジェクト条件`,
"potential.customers.field.default":`リード項目のデフォルト設定`,
"message.password.nosame":`2度入力したパスワードは一致していませんが、再入力してください。`,
"label.validate.function.funcExplain.MONTH":`月を返します。1（一月）～12（十二月）の範囲の整数になります。`,
"label.project.user.project.count":`ユーザーが参加したプロジェクト数`,
"chatter.to":`に更新`,
"vue_label_commonobjects_detail_activity_owntask":`ToDoあり`,
"label.generate.mobile.page":`モバイル端末ページの生成が完了した`,
"label.escalation.setup.newentries.step1":`ステップ1.当該ルールエントリーの順番を設定`,
"label.email_footer":`メールフッター`,
"label_partner_workspace_member_profile":`選択可能なプロファイル`,
"label.loginhis.between":`開始時刻は終了時刻まで2か月間を超えてはいけません`,
"label.user.verficationcode.error":`入力規則は不正確です`,
"label.email_notifications":`投稿のお知らせメールの送信`,
"APPIntegration_Dropbox_01":`Dropboxからファイルを選択`,
"label.projectManagement.Selectweek":`週を選択`,
"wednesday":`水曜日`,
"message.atleastonereceiver":`少なくとも一人の受信者がいます`,
"label.applt.link.text":`ポータルのミニプログラムに御社をリンクしました。御社専用のミニプログラムのポータルアドレスをコピーして、御社の公式アカウントメニューのジャンプリンクにミニプログラムのアドレスを配置すると、お客様はそのメニューをクリックしてミニプログラムを利用することができます。(公式アカウントのカスタムメニュー < ミニプログラムへのジャンプ < ミニプログラムのパス)`,
"label.wait.for.a.moment":`言語設定中はしばらくお待ちください...。`,
"vue_label_chatter_only_group_members_look":`グループのメンバーのみが参照できるので、グループへの加入を申請してみてください。`,
"label.knowledgebase.last.release":`最終発行日`,
"component.setup.label.pagesize":`1ページあたりの項目`,
"label.paging.totalofpages":`すべて{0}ページ`,
"label.globaloperation.successmessage":`成功メッセージ`,
"label.logout":`ログアウト`,
"label.partner.common.enable":`パートナークラウドの有効化`,
"label.permission.objectpermission.goback":`権限セットのオブジェクトリスクに戻る`,
"label.approvalstep5.required":`必須情報`,
"component_chatter_label_to":`まで`,
"message.please.choose.role":`ロールを選択してください`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`メンテナンス計画に関連するサービス契約で、契約行の項目を選択する必要があります。`,
"label.projectManagement.Resource.usage.view":`リソース使用ビュー`,
"label.smsmainbody":`ショートメッセージテキスト`,
"label.ccchat.error.nullname":`名前は必須項目です`,
"label.appupload.upload.version":`バージョン番号`,
"label.data.setok.t_desc2":`データテンプレートページに戻る`,
"vue_label_pool_allocationstatus":`割当て状況`,
"label.tianyancha.orgapprovedinstitute":`承認機関`,
"label.quickbooks.searchlist.startdate":`開始日`,
"label.setapp":`アプリケーションの設定`,
"chatter.about":`私に関して`,
"label.layoutname":`ページレイアウト名`,
"label.icon.160":`地球`,
"label.tabpage.Rolesz":`役割と部下`,
"label.console.step5.introduce":`下記の表示方法を選択`,
"label.customfields.totalsummary.gettogetherfield":`フィールドからアグリゲートへ`,
"message.appexchange.addtopackage.profile":`1つのソフトパッケージにプロファイルコンポーネントを1つのみ追加できます。`,
"vue_label_file_user_header_pic":`アバター`,
"font-trade-module-v1-invoice-detail-price":`詳細な支払い`,
"homepage.components.three":`ステップ3：カスタマコンポーネントの表示内容を記入します。`,
"nine":`九`,
"label.marketsea.button.restore":`リストア`,
"label.forecast.editshrepage.desc2":`個別共有は、データにより広いアクセス権を付与するだけで、アクセス権を制限することができません`,
"label.cloudccsite.list":`サイト`,
"label.icon.35":`雲`,
"vue_label_pricebook_price":`スタンダード価格の追加`,
"label.version.sum.addressfield":`件の住所項目`,
"label.projectManagement.Gotomilestone":`マイルストーンへスキップ`,
"label.dataimport.name.length":`エラー：名前は長すぎます`,
"label_alculation_method":`計算方法`,
"label.uploadfile":`ファイルのアップロード`,
"label.ems.otheraccount":`その他のアカウント`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`このチーム加入しますか`,
"message.error.chatter.img.nodata":`画像ファイルは存在しないため、アバターのスクリーンショットができません。`,
"component.chatter.file.button.files":`ファイルの選択`,
"label.salescloud.teamrole.optionlist.choose.null":`ロール名は空であってはいけません`,
"label.yourexportsuc":`エクスポート申請が処理されており、メールを参照してください。`,
"pagecreator_systemstyle_label_modifycolor":`編集色`,
"label_partner_setup_title":`設定`,
"label.chat.topic.topic":`トピック`,
"file.error.nottype":`エラー：無効な種別で、アップロードできるファイル種別はtxt、doc、excel、ppt、pdf、jpg、jpegです。`,
"label.all_time":`オールタイム`,
"homepage_componet_approval_label":`承認センター`,
"label.partnerCloud.financeSetting.merchantNumber":`WeChat PayマーチャントNo.`,
"label.user.resetpw":`パスワードの変更`,
"label.exchange.sync1":`Microsoft© Exchange で、ユーザーにシミュレーションができるサービスアカウントを設定した後、サービスアカウントの証拠を入力し、CloudCC とExchange サーバの通信を許可します。`,
"label.import.index.editfield":`項目対応付けの編集`,
"and":`と`,
"label.partnerCloud.cloudInfrastructure":`パートナークラウドの基本設定`,
"label.escalation.setup.newentries.createdate":`ケース作成時間に基づく`,
"Pagelayout.Setup.002":`3つの関連リストを選択していますが、さらに関連リストを追加すると、ページのレイアウトに影響します。`,
"label.customfields.file.tip":`ユーザが1-Nのファイルをアップロードすることができます`,
"label.tianyancha.businessverify.accname":`ユーザ名のリアルタイム検索`,
"label.Additional.Conditions":`追加条件でサービスの予約を絞り込みます`,
"label.emailtocloudcc.filed.type":`タイプ`,
"vue_label_homepage_fixedcomponents":`スタンダードコンポーネント`,
"label.visualpage.delerror":`削除が失敗し、改めて試してください。`,
"label.tabpage.filetypez":`ファイルタイプ`,
"label.emailobject.search.input":`検索内容を入力してください`,
"label.createprocessstep2":`ステップ2.プロジェクト条件の指定`,
"label.weixin.inhead":`処理中`,
"component.recdetail.label.title":`詳細情報`,
"label.weixin.telephone":`携帯番号`,
"label.web.link":`ウェブリンク`,
"label.partnerCloud.paySuccess":`支払い完了`,
"label.case.adress.link":`顧客サービスポータルのウェブ`,
"label.emailobject.view.connectopp":`オープンチャンスと連動したメール`,
"front-kefu-moudle-think-again":`もう一度考えてみよう`,
"label.Button":`ボタン`,
"chatter.pt.most":`ファイルの最大サイズは20Mです。`,
"label.service.newBuildDialog.numberdays.horizontal":`水平日付前の日数`,
"label.ems.relatedobj":`関連レコード`,
"label.notification.insert.approval":`[提交人] は [对象] をあなたの承認のために提出します。`,
"label.setting.codeSet":`コードセット`,
"vue_label_report_rowlevelformula":`行レベルの数式`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`© 2008-2022 CloudCC Inc. 著作権の所有者は北京神州雲動科技股份有限公司です。カスタマサービスの電話番号は400-642-2008です。`,
"component.setup.button.save":`保存`,
"label.emailsync.button.sure":`確認`,
"label.multilang.dupicatecheck.getdatalist":`{0}番目の重複データで、{1}件のレコードがあります`,
"label.ccchat.person.invite.tochat":`Chatに人を招待`,
"label_partner_all_maxNum":`パートナークラウドの最大データ：`,
"label.checkfield":`重複チェック項目の設定`,
"label.sales.dashboard.income":`収入目標`,
"label.setup":`設定`,
"label.dashboardSetup.center":`中`,
"lable.quote.syncing.finished":`同期は完了済み`,
"vue_label_helpcenter_dashboard1":`    統計データをより直感的に表示できるように、CloudCC Sales Cloud Lightning版ダッシュボードは強力なチャート作成機能を提供します。<br>CloudCC Sales Cloud Lightning版ダッシュボードには以下のような特徴があります<br>異なるデータソースを使用可能：オブジェクトの下のビューにある元のデータをデータソースとして選択することや、レポートが処理された後のデータをデータソースとして選択することなどもできます。<br>13種類ものチャートテンプレートが選択可能：セールスファネル、ポインターメーター、円グラフ、二次グループ化されたヒストグラムなどをサポートします。<br> <br> チャートのサイズや位置を自由にドラッグ＆ドロップで変更可能： ダッシュボードでは、異なるチャートの位置やサイズを配置することで、重要なデータと補助的なデータを区別することができます。ダッシュボードは、時間範囲やユーザーごとに設定されたフィルターフィールドを使って、内蔵されたチャートデータのフィルタリングをサポートします<br>データのキャッシング: ダッシュボードのチャートデータは、最初に作成されたときにキャッシュすることができ、二次的な読み込み時間を短縮します。<br>コンポーネントの貫入。コンポーネントをクリックすることで、対応するレポートの詳細や、オブジェクトの対応するビューのレコードリストにジャンプすることができます<br>コンポーネントの連結: 同じダッシュボードで、コンポーネントは同じデータソースの他のコンポーネントを設定して、自分自身と対話することができます。コンポーネントのデータ領域をクリックすることで、他のコンポーネントがこのデータ領域のフィルタリング条件に従ってデータを再集計するように設定することができます<br> 1.新しいダッシュボードを作成する<br> 営業担当者や営業部のマネージャーとして、ダッシュボードを作ることで営業データを表示することができます。CloudCC Sales Cloud Lightningバージョンでは、ダッシュボードを作るための豊富な機能が提供されています<br>注：Lightningバージョンのダッシュボードと旧バージョンのダッシュボードのデータは相互に利用できません。<br>「ダッシュボード」タブをクリックし、「新規ダッシュボード」をクリックし、ダッシュボード名を入力し、このダッシュボードを保存するフォルダを選択します。新しいダッシュボードを入力することができます。`,
"label.layout.availabletab.trackrecord":`追跡記録`,
"label.campaignmember.main.deletecontact":`メンバーの削除‐既存の取引先責任者`,
"lable.outlook.mcto.emaltoc":`CloudCC.comにメールを送信したとき`,
"label.setup.mobile.offlinecache.savesuccess":`モバイル端末のオフラインキャッシュの設定に成功しました`,
"label.timezone.default":`デフォルトのタイムゾーン`,
"label.noRules.have.been.enabled":`有効なルールはありません。`,
"label.ccchat.person.invite.existsend":`入力したメールアドレスの一部は既存ユーザとマッチングします。`,
"label.work":`仕事`,
"actualstarttime.actualendtime.time.illegal":`サービス予約の実際の開始時刻は実際の終了時刻より小さいべきです。`,
"lable.product.stsp":`標準価格の設定`,
"vue_label_normal_account_sf":`取引先`,
"label.finishpic":`生成済みの図表`,
"label.h5.similar.opportunity.step3":`ステップ3.類似商談で表示される項目の選択`,
"label.relateobjDefault":`関連レコードのデフォルト`,
"label.customcomponent.check.tag.endwith":`コンポーネントは&lt;/cc:component&gt;で終了します`,
"label.related.organization":`関連する機会`,
"label.recordtype.edit.selectvalue.orderby":`選択リスト値の順番`,
"vue_label_homepage_enter_name":`名前を入力してください`,
"label.permission.group":`権限セット`,
"label.emailobject.send":`送信`,
"label.ralateuser":`関連ユーザ`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(date,num)`,
"label.tablayoutedit.remark2":`フロントエンドタブで表示する項目を選択`,
"setup_mainpage_label_welcome3":`CloudCC クラウドプラットフォームでは、カスタマデータベースに基づきリストを作成し、ユーザが定義するオブジェクトがデータベースのリスクで、組織の特有のデータを格納するために使用されます。プログラムを開発せずに、リスク間のリレーションシップを簡単に作ることができます。`,
"label.user.notallowed.login.scope":`ログインできる時間帯ではないかあるいはログインIP アドレスの範囲が制限されています。`,
"label.tel.ten.case":`最大10つまでの通知送信の電話番号を入力し、携帯電話番号の間に`,
"front-kefu-moudle-v1-user-info":`ユーザー情報`,
"label.aboutme":`私に関して`,
"label.setfieldediting.tip":`承認プロセスを定義するとき、異なるユーザに承認申請を割り当てることができます。その中の1つのオプションはユーザー項目を使用するために、自動的にこれらの申請を転送します。このオプションをすべての承認プロセスに応用するなら、下記の選択リスクから項目を1つ選択してください。そしてレコードは承認中の場合、ずっとロックされています（管理者のみ編集できます）。しかし、現在割り当てられた承認者によるこのレコードの編集を許可するかを設定することができます。`,
"label.existing_dashboard":`既存のダッシュボードへの追加`,
"label.sendemail.spotsign":`#name様:#activity活動に招待したお客さんはすでに到着してサインインしました。ご了承ください。`,
"UG_solution_01":`ソリューションの提供`,
"label.tianyancha.estiblishtime":`設立日`,
"label.pc.lightningpage":`アプリケーションのベータ版`,
"label.saveAndSync":`保存して同期`,
"label.state.end":`完了済み`,
"label.sendemail.queue.assigninfo":`キュー：[#queueName]様は #objectName ：#recordNameを割り当てしました。`,
"label.approvalprocessname":`承認プロセス名`,
"label.view.conditions.message":`{!conditions}によって検索します`,
"label.partnerCloud.financeSetting.alipayCorporate":`アリペイビジネスアカウント`,
"label.forecast.detailforecast.de":`の`,
"label.savepayset.failure.nopay":`少なくとも1つのオンライン決済アカウントを設定してください`,
"label.step1.total6":`ステップ 1/6`,
"label.appointment.wizard.subtitle4-1-3":`45分`,
"label.emailobject.markasread":`既読にする`,
"message.error.orgid.null":`orgidは空にしてはいけません。`,
"label.emailtemplate.mergefield":`差し込み項目値`,
"label.weixin.recent.list":`最近参照したリスト`,
"label.emailsync.form.email":`電子メール`,
"label.funnel":`ファネル`,
"label.logintime.clear":`時刻を解除`,
"label.chatter.followed":`フォロー済み`,
"label.ccpeak.function.field.spack":`関数での項目の両側は必ずスペースを入れます。`,
"label.setup.mobile.offlinecache.remark":`この機能を有効化すると、組織内のメンバーはモバイル端末がオフラインの時でも、新規作成、参照、編集、レコードの削除ができます。`,
"label.product.function":`パッケージカテゴリー`,
"label.icon.14":`ハンマー`,
"message.report.nodata":`レポートはデータを戻していません`,
"label.please.ChooseMin":`商品の選択肢を{a}以上お選びください。`,
"label.tabpage.releaseTourz":`ガイドの発行`,
"vue_label_chat_opportunity":`機会チーム`,
"vue_label_chatter_refucecertification":`"{name}"のグループへの加入を拒否しますか。`,
"label.version.unlimited":`限らない`,
"label.processsetting.enable.prompt":`有効にすると、ライトニングバージョンに対応する詳細ページに設定のパスが表示されます。先に設定を保存し、後で有効にすることもできます。`,
"label.page.display.property":`プロパティを表示`,
"label.service.appointmentList.thisOption":`チェックを入れていない`,
"label.register.date":`登録日付`,
"label.brief.contract.amount":`契約の金額`,
"setup.object.field.dependency.label.actionfieldnotnull":`まずコントロール項目を1つ選択して設定してください。`,
"UG_homepage_009":`CRMへアクセスする`,
"label.icon.98":`フォルダ`,
"label.weixin.datacount":`データ合計`,
"label.mobile.hasbind":`この携帯電話番号は使われています。最後の縛りは、続けて縛ると解放されます。`,
"label.emailtemplate.choosemorecontacts":`送信する他の人を選択してください`,
"setup_layout_button_deleteitem":`選択したオプションを削除`,
"vue_label_account_collection_plan":`未処理の代金受取計画`,
"label_chatter_maturiyDate":`期限日`,
"label.emailtocloudcc.license":`ライセンス`,
"vue_label_checkduplicate_complete_check_rules":`重複チェックルールを記入してください。`,
"chatter.up.type":`JPG、GIF または PNG ファイルをアップロードできます。`,
"label.attendance.nocheckout":`サインアウトしていない`,
"label.setup.mobile.offlinecache.remark2":`選択したタブは、デフォルトのオフラインキャッシュタブとして全員のモバイル端末で使用されます。ユーザーは需要に応じて、モバイル端末の設定でタブのオフラインキャッシュをオフし、またはほかのタブに切り替えることができます。`,
"template.report.count.marketing.activities":`トータルキャンペーン`,
"label.multilingual.tip4":`マルチランゲージを無効にした場合、会社のアドレスに基づいて、デフォルトの会社の言語が中国語または英語に設定され、すべてのユーザーの言語がデフォルトの会社の言語に設定されます。`,
"label.settings_area":`設定エリア`,
"label_assessment_content":`審査内容`,
"label.top":`トップ`,
"UG.Account.06":`取引先の作成`,
"label.emailtocloudcc.step1.case2":`設定すると、このメールボックスに届いたメールは、ケースとして自動的に生成され、送信先に応じて取引先責任者と取引先を照合して、対応する連絡先と取引先責任者にケースを関連付けさせることで、ケースの受付と追跡を更に容易にさせます。`,
"label.forecast.forehistory.best.remark":`ベストケースの説明`,
"label.project.problem.date":`発行日はマイルストーンやプロジェクトの日付範囲内でなければなりません。`,
"label.forecast.customforecast.foredis.wzs":`完全数`,
"message.setup.field.name.value.notexists":`入力したチームロールのリスク値は存在しません。再入力してください。`,
"label.salescloud.teamrole.opportunity.organization":`チームメンバーのこの商談へのアクセスレベルは組織がデフォルトで設定した商談へのアクセスレベルより高いです。`,
"label.sms.message.input":`SMS内容をご入力ください`,
"label.document.type.not.allow":`当該フォルダ種別はサポートされません。`,
"label.customfields.totalsummary.tip":`関連リストに表示されるレコードにある項目の合計値、最小値、最大値、あるいはレコードの件数を表示する参照のみ項目です。`,
"label.tabpage.filesizez":`ファイルサイズ`,
"label.import.page2.filedname":`ファイル名`,
"label.same.analyze":`私の衝突分析`,
"label.service.gantt.refreshData":`ページを更新するとデータが更新されます。`,
"label.sendsms.batch.step2.sendbycontext":`カスタマSMS内容により送信します`,
"UG_Account_05":`取引先責任者構造図`,
"label_emailtocloudcc_step1total3":`ステップ 1/3`,
"label.weixin.no.history":`レコードされていません`,
"label.datamanage.queryfield.error":`項目の検索にエラーが発生しました`,
"label.emailmerge.mergeFolder.emailmerge":`メールテンプレートのマージ`,
"label.workflow.estimatecondition":`評価条件`,
"label.autonumberfield.wrong":`0-{0}中の数字を入力してください`,
"label.data.setok.t.desc1":`このテンプレートでデータをエクスポートする場合、クリックしてください`,
"label.data.downpage.i.title":`データ手順のインポート`,
"label.data.downpage.i_list.desc2":`データをインポートした後に、成功したかどうかという通知メールを受け取ることができます。`,
"label.opportunity.jieduan":`現在の段階`,
"vue_label_commonobjects_view_sumby":`まとめ方式`,
"label.knowledge.setting.hint.three":`運用のための準備を行います。設定に必要なものをご紹介します。`,
"page.activity.history":`活動履歴`,
"label.cancelQuoteLineGroup":`見積り行のグループの取消し`,
"label.addattachment.batch.step3":`ステップ3.「完了」をクリックして、前のページに戻ります`,
"label.chat.topic.follow":`フォロー`,
"label.import.page1.uploadcsvfiled":`ドラッグ＆クリックでCSVファイルをアップロードする`,
"label.batchtransfer.datetype.tip":`日付項目については、次のような書式で記入します。`,
"vue_label_systemSettings_application_util":`アプリケーションマネジメントコンソール`,
"label.partner.workspace.member.selectedpermission":`選択可能な権限セット`,
"label.service.appointmentList.plansToEnd":`プラン終了`,
"label.industrialandcommercialverification.contactinformation":`ご_入やお_い合わせには 400-642-2008にご__ください。`,
"chatter.del.p":`この投稿を削除`,
"label.forecast.customforecast.replacefirst":`私に優先される`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`スコアリングルール名`,
"label.weixin.appr.applicant":`発起人`,
"component_event_label_calendar":`カレンダーの表示`,
"step":`ステップ`,
"label.attendance.setting.position.alert":`内勤は必ずランドマークを設定します`,
"label.end":`完了済み`,
"label.mobile.change.owner.success":`新しい所有者に変更済み`,
"label.chinese":`中国語`,
"label.textmessage.vonage.account":`アカウント情報`,
"front-console-no-related-contact":`まずは連絡先を連想してください。`,
"label.dashboardSetup.seltype":`選択可能なコンポーネントタイプ`,
"chatter.follow.user":`このユーザをフォローする`,
"label.textmessage.sentsuccess":`送信成功`,
"label.australian.gentral.standard.time":`中央ヨーロッパ夏時間（南オーストラリア州）`,
"label.validate.function.funcFormat.AND":`AND(logical1,logical3,...)`,
"lable.SalesCommitmentKanBan.contract":`契約締結`,
"label.processsetting.basic.settings":`基本設定`,
"label.escalation.setup.newentries.ifcondtions":`以下の条件を満たしたら、このルールを運行します.`,
"label.lookup.nofound.data":`値は存在しないか、または検索条件は一致していません。`,
"vue_label_commonobjects_view_chart_chartname":`図表名`,
"label.dashboard.show.percent":`表示%`,
"label.sso.saml.sp.userid":`ユーザID`,
"label_tabpage_minutesagoz":`分間前`,
"vue_label_chatter_comment_content":`コメント内容を入力してください`,
"label.campaign.channel.step6.mobilepc":`モバイル端末とPC端末のページを生成`,
"vue_label_homepage_editprofilepage":`名前の編集`,
"label.tabpage.crecordtypez":`レコードタイプの変更`,
"label.social.posts.type.null":`ポストタイプは空ではありません。`,
"label.projectManagement.groupbyuser":`ユーザーによるグループ化`,
"vue_label_email_new_template":`新規テンプレートとして保存します`,
"label.ems.close":`キャンセル`,
"label.ccdocument.noauthority.folder":`フォルダをアクションする権限はありません`,
"message.filterconditionerror":`エラー：間違っている検索条件を使っています`,
"label.User.Interface":`ユーザーインターフェース`,
"label_tabpage_greaterz":`より大きい`,
"vue_label_CCChat_unfollow":`フォローの取消し`,
"label.selectandcontinue":`選択&続き`,
"vue_label_commonobjects_detail_influence":`影響力`,
"label.total.have.priority":`の優先`,
"label.manageAll.sta4":`呼び戻し`,
"label.setup.mobile.offlinecache.setup":`モバイル端末のオフラインキャッシュの設定`,
"vue_label_chatter_cancel_adding":`追加の取消し`,
"vue_label_lead_select_existing":`既存の選択`,
"front-epwechat-module-v1-contacts-sync":`WeCom Contactsの同期`,
"label.appupload.component.type.recordtype":`レコードタイプのラベル`,
"label.layout.hint":`このページはプレビューに対応していません。保存してフォアグラウンドのページでご覧ください。`,
"label.change":`クリーンアップ`,
"setup_layout_label_detailpage":`詳細情報ページ`,
"label.imgfield.use.tip":`img(docid,width,height)、この関数は画像の出力に使用されており、docidはドキュメントidで、widthは画像の幅（Integer種別で、空にしてもいい）を設定し、heightは画像の高さ（Integer種別で、空にしてもいい）を設定します。`,
"pagecreator.systemstyle.button.edit":`編集スタイル`,
"label.delete_externalpage":`削除したい''を取り消すことができません。もう一度確認してください。このフォームは、どのログインページでも使用されていませんが、他の場所で使用されている可能性があります。例えば、埋め込みコードを使って外部のページに挿入した場合などです。`,
"font-evaluate-module-v1-open-case":`ケースを再開する`,
"label_not_adjust":`調整なし`,
"vue_label_title_ordernow":`今すぐ購読する
`,
"label.notification.serviceappointment.allocation":`新しい作業指示書{0}が発送されましたので、ご確認ください。`,
"label.objectRelationshipDescription2":`このレポートタイプは、取引先責任者に関するレポートを生成します。リレーションを選択して、レポート結果として返す関連オブジェクトを定義します。`,
"vue_label_calendar_notice_createfail":`カレンダーの作成に失敗しました。`,
"label.ems.step1":`ステップ1`,
"label.ems.password":`パスワード`,
"label.icon.143":`貯金箱`,
"label.select.year":`年を選択`,
"label.termsforusage.dialog":`使用条項（新規ウィンドウ）`,
"label.tag.addtags.create":`新規`,
"label.emailobject.groupemail.msg4":`メールアドレスがないため、受信者にこのメールを送信することができません。`,
"label.version.sum.autonumberfield":`自動採番項目（個）`,
"label.projectManagement.unallocated.time":`未割当の時間`,
"PageLayout.Search.MultiSearch.002":`検索項目の展開表示（単一項目検索）`,
"label.icon.150":`VR`,
"label.SMS.edit":`SMSアラートの編集`,
"Opportunity.Detailed.Phase.Label.003":`変更ステージ`,
"vue_label_helpcenter_all":`1.グローバル検索<br> グローバル検索は、必要なものを素早く見つけるためのツールです。<br>ページ上部のナビゲーションバーにある検索入力ボックスにキーワードを入力します。入力している時、入力内容に応じて、関連するコンテンツをリアルタイムで推薦してもらえます。<br>「検索」をクリックするか、キーボードのEnterキーを直接的に押すと、検索結果ページが表示されます。<br>検索結果ページでは、左のオブジェクトをフィルタリングすると、そのオブジェクトの下にある検索結果のリストが表示されます。結果リストには最大10件のレコードが推薦されています。また、「更に表示」をクリックすると、このオブジェクトのリストページに入り、さらに多くの検索結果を表示することができます。<br>注：システムはデフォルトで「見積書」、「取引先」、「リード」、「商談」、「キャンペーン」、「契約」、「製品」、「サービスリクエスト」、「ToDo」、「行動」を検索します。<br> 2.クリック作成<br> ナビゲーションバーの「＋ 」をクリックすると、ドロップダウンウィンドウで作成するオブジェクトを選択することができます。<br> 3.私のセンター<br> ナビゲーションバーの右側にあるアバターをクリックすると、私のセンターウィンドウが開きます。以下のような機能があります。<br>個人設定ページ、一括インポート、ごみ箱に素早く移動することができます。<br>試用期間中であれば、「今すぐ注文」をクリックして、Cloud CCの注文ページに素早く移動することができます。<br>バージョンをクリックして素早く切り替えることができます。<br>ログアウト<br> 4.メニュー<br> メニューバーでいくつかのメニューオブジェクトを推薦してもらえます。メニューをクリックすると、そのページに素早く移動することができます。また、すべてのメニューを表示したり、よく使うメニューをメニューバーに表示するように設定することもできます。<br>すべてのメニューを表示します。「更に」をクリックし、ドロップダウンボックスの下部にある「すべてメニュー」をクリックします。<br>メニューのカスタマイズ:メニューの右側にあるボタンをクリックして、カスタムメニューウィンドウを開き、メニューバーに表示する必要のある共通メニューをすべてのメニューに設定します。<br> 5.アプリケーション起動センター<br>メニューバーの右側のアイコンをクリックすると、システム管理者に素早く切り替え、他のアプリケーションサービスまでに配置されることができます。<br>注：アプリケーションとは、特定のビジネスニーズを満たすために使用できる一連の機能モジュール（リード管理、商談、契約管理など）を統合したものです。`,
"label.summaryreport.2018.step5.new":`ステップ5：レポート標準の選択`,
"label.weixin.id":`番号`,
"chatter.pu.mess":`投稿とコメント（件）`,
"label.weixin.lookup.record":`レコードの検索`,
"label.ServiceCloud.statistics.by.address":`住所別の統計`,
"label.jixiaoswitchoff":`崩壊`,
"label.savealipay.failure":`Alipay加盟店の情報の保存に失敗しました。`,
"template.chart.khdqfb":`アカウント 地域別分布`,
"front-email-payment-immediate-payment":`今すぐ支払う`,
"label.dashboard.unit5":`単位：億`,
"label.tabpage.greaterz":`より大きい`,
"vue_label_calendar_stop_sharing_calendar":`カレンダー共有の停止`,
"label.projectManagement.allhours":`すべて（時間）`,
"label.currency":`通貨種類`,
"label_vue_create_edit_obj_create_event_dialog_title":`繰り返しのあるスケジュールのリマインダー`,
"front-template-V1-templateSetting":`テンプレート設定`,
"label.dashboard.away.condition":`崩壊状態`,
"label.replacelayout":`ページレイアウトの置換`,
"label.permission.detail.system.setting.tip":`アプリケーションに適用するアクションを実行します。例えば、すべてのデータの権限を修正します。`,
"label.customfield.delete.prompt":`カスタマ項目の表示ラベル`,
"label.add":`追加`,
"label.deputationalsoapprove":`代理承認者もこの申請を承認することができます`,
"label.leave_nosave":`退出後、現在のデータは保存されません。`,
"label.tianyancha.title":`天眼査`,
"vue_label_pool_restore":`リストア`,
"chatter.feed.menutype.feed.markcom":`ブックマークされた書き込み`,
"label.query.data.error":`関連リスクデータの検索に失敗しました`,
"label.pc.ui.2018.unpin":`ピンを解除`,
"label.partner.template.memo":`説明`,
"label.weixin.cannot.gain.userinformation":`ユーザ情報を獲得することができません`,
"label.stdashbord.xsld.department":`部門`,
"label.service.ganttBaiduMap.scheduled.starttime":`開始予定日`,
"label.documentforms":`ドキュメント`,
"label.operator.insert":`演算子の挿入`,
"label.processsetting.select.five.fields":`最大5つまでの項目を選択することができます`,
"label.weixin.password":`パスワード`,
"vue_label_chatter_share_followers":`フォロワーとの共有`,
"label.brief.baifang":`チェックイン&訪問`,
"label.emailobject.track.unopen":`開いていません`,
"label.sendmail.immediately":`すぐ送信`,
"label.partnerCloud.payTheAmount":`支払額`,
"label.integrations.mailchimp.connect":`CloudCCをあなたのアカウントに接続します`,
"label.datamove.record.sucessfully":`移行に成功したレコード（件）`,
"lable.outlook.edit.allocation":`ユーザとプロフィルの割り当て`,
"label.chosesubject.talk":`会談を約束します`,
"label.escalation.setup.entrydetail.escalation.time":`グレードアップ時間`,
"label.projectManagement.must.be.less.than.24.hours":`24時間以内でなければなりまｓん`,
"setup_mainpage_label_welcome15":`CloudCC クラウドプラットフォームのワークフロールールでは、販売、市場など様々なオブジェクトの支援プロセスを自動化することができます。あらかじめ定義されたルールに基づき、ユーザにレコードを自動的に割り当て、1つユーザから別のユーザに置き換えることができます。ワークフロー管理によって、レコードの更新をする際に、必要がないアクションを除去して、仕事効率の向上、標準化の作業方法、操作コストの削減、業務処理レベルの向上、コントロールフローの最適化が行われます。オブジェクトの承認審査を無制限に行うとともに、メールとSMSの通知、ToDo、項目更新などの機能を自動的に起動することができます。`,
"label.mobile.phone.week.plan2":`今週の計画`,
"label.add.newAsset":`ニューアセット`,
"vue_label_salesadvance_losts":`流失率`,
"vue_label_report_editcolumn":`列の編集`,
"vue_label_homepage_assignedtasks":`割り当て済みのToDo`,
"label.posting_from":`発行者`,
"year":`年`,
"label.autoRegister.changepwd.setpwd.tip.letter":`少なくとも1つの英字があります`,
"label.version.nonsupport.feature.staticresource":`この機能を暫くサポートしません。グレードアップ後に使用してください。`,
"label.toleadmyclientandlinkman":`私の取引先と取引先責任者のエクスポート`,
"label.appupload.install.processcrash":`衝突の処理`,
"label.profile.setstandardtab":`標準タブの設定`,
"template.chart.khhyfx":`アカウントの業界分析`,
"label.reportTypcrtC":`関連オブジェクト（C） 関連オブジェクトをクリックして選択してください`,
"vue_label_report_mayormaynothave":`上位オブジェクトは、このオブジェクトに関連するレコードを持っている場合と持っていない場合があります。`,
"label.service.gantt.plan.recommendation":`プランは推薦済み`,
"label.version.sum.lookupfield":`検索項目（個）`,
"label.builder":`ページビルダー`,
"label.sharerule.remark":`レコードの共有を指定します。ユーザー、ロール、ロールと下位ロール、エリア、エリアと下位エリアが対応したユーザーと当該レコード及び関連データを共有することができます。個別共有はアクセス権を制限するのではなく、より広いデータのアクセス権を付与するのです。`,
"vue_label_email_benn_added":`メールボックスが追加済みです`,
"label.version.allow.sum":`、上限に達しました。需要に応じて、CloudCC をバージョンアップしてください。`,
"label.icon.130":`通貨`,
"label.custom.new":`新規`,
"label.see_allfields":`すべての分野を見る`,
"front-marketing-module-v1-share-poster":`シェアポスター`,
"label.service.one":`定義されない検索条件を参照しました`,
"lable.outlook.edit.alprec":`CloudCC.comをいつも優先的に選択します`,
"Account_News_Setting_001":`取引先の設定`,
"label.mr.caption.opportunity.result":`重複検索&マージ：商談の重複データの検索条件`,
"label.forbidden":`使用禁止`,
"label.query.detail.openpartner":`パートナーとして有効化します`,
"label.session_date":`セッション日時`,
"label.forecast.customforecast.submit.deyuce":`の予測`,
"label.emailtocloudcc.filed.server":`サーバー`,
"label.emailtocloudcc.tip2":`削除すると、Email to CloudCC機能が失効しますが、確かに削除しますか。`,
"pagecreator_layout_message_delete_fail":`レイアウトの削除に失敗しました`,
"front-lightning-module-v1-dashborad-export-PDF":`PDFのエクスポート`,
"lable.quote.syncing.syncingto":`商談商品に価格表エントリーを同期しました`,
"message.error.view.lastview.update":`最後の公開リスクビューを削除することができません</br>すべてのユーザーが参照可能な最後のリストビューを自分のみが参照可能に変更することができません<br><br>`,
"label.weixin.select.one":`少なくとも1つを選択してください`,
"label.projectManagement.Pleaseenterprojectname":`プロジェクト名を入力してください...`,
"label.data.downpage.e_list.desc1":`当該ページでは、エクスポートに成功したファイルが表示されます。通知メール本文に記載されたリンクからアクセスして、ファイルをダウンロードしてください。`,
"label_tabpage_notexceed25":`選択したレコードは25件を超えてはいけません`,
"label.campaign.channel.step5.remark":`ログインページの設定を完了しました`,
"label.setup.mobile.bottombutton.profile.prompt":`Tips:カスタマイズされたプロファイルのボトムメニューは、会社のボトムメニューの統一された設定よりも優先されます。`,
"label.stdashbord.xsld.business.knx":`可能性`,
"label.setemailtip":`メールアラートを作成し、1 つ以上のワークフロールール、承認プロセス、またはエンタイトルメントプロセスと関連付けます。メールアラートを変更すると、変更はそれに関連付けられているすべてのルール、承認、またはエンタイトルメントプロセスにも適用されます。`,
"report.button.go":`移動する`,
"lable.the.united.arab.emirates":`レコードは受取済みです`,
"label.writer. name.file":`見積もりファイル名を記入してください`,
"label.validate.function.funcExplain.ADDMONTHS":`入力したdate（日付項目）にnum（月）を追加し、新しい日付に値を戻します。最初の月の日数が当月の最後の日に等しいか、または新しい日付の月の日数が以前に入力した日付の月の日数より少ない場合は、1ヶ月の日数を当月の最後の日付に戻します。`,
"vue_label_chatter_enter_shared_content":`共有内容を入力してください`,
"message.lookup.condition":`検索条件は1つ以上の文字を入力してください。`,
"vue_label_commonobjects_detail_customers":`外部ユーザーを永久に無効にした取引先は、その取引先に関連するすべての外部ユーザーが無効になります。しかもその取引先に関連するすべてのコミュニティ、グループ、チーム、権限セット、および共有ルールから削除されます。またその取引先に関連するロールとグループも削除され、ごみ箱にも表示されませんが、よろしいでしょうか。`,
"label.emailobject.view.all":`すべて`,
"vue_label_file_size_limit_new":`添付ファイルが{size}Mを超えています。アップロードに失敗しました。`,
"front-gantt-module-please-reorder-milestones":`マイルストーンを再注文するには、有効な番号を入力してください。`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`メール`,
"label.namespaceprefix":`名前空間接頭辞`,
"label.ems.delete.success":`削除に成功しました`,
"label.partnerCloud.financeSetting.setWechatPay":`WeChat Payの設定`,
"front-epwechat-module-v1-input-token":`トークンを入力してください。`,
"setup_object_field_dependency_button_setdependency":`項目連動の設定`,
"chatter.group.request01":`申請`,
"message.error.field.number.length":`長さの入力形式は間違っています`,
"label.tabpage.lessz":`未満`,
"vue_label_notice_uploadavatar_format":`アップロードするアバターは、JPG/PNG/GIF形式のみです`,
"label.project.hit.thirteen":`デイリーマイルストーンリマインダー`,
"frame_personinfo_label_usethisimage":`アプリケーションの周りに、このサムネイル画像のバリエーションを使用します。`,
"label.startuploadfile.step":`アップロードに失敗したファイルは上記エリアで表示され、またメッセージが送られます。これらのファイルをすべて削除してから、改めてファイルを選択できるようになります。`,
"component_assistant_label_overduetask":`商談は期限切れのToDoを含みます`,
"label.partnerCloud.financeSetting.information":`Alipayの登録情報を設定する方法は？`,
"label.appupload.install.package.component":`パッケージコンポーネント`,
"label.emailobject.emaildetail.nextactivity.task":`タスクの追加`,
"vue_label_chatter_edit_post":`編集後記`,
"label.appupload.upload.logo":`アイコン`,
"label.role.selecteduser":`選択済みのユーザ`,
"label.letter.assign":`案内状内容の指定`,
"label.forecast.shrepage.title":`共有詳細情報の予測`,
"lable.Generate.service.appointment":`作業指示書のラインアイテムによって生成されたサービスアポイントメント`,
"label.productsales.nodata":`データなし`,
"vue_label_email_Please_select_at_least_one_email":`メールを少なくとも1つ選択してください`,
"label.data.downpage.i_title.num4":`4、インポートするオブジェクトに参照項目と主な詳細項目があれば、当該項目が対応する値は必ずIDでなければならない。そうでなければ無効になります。`,
"label.new.exchagecurrency":`新しい為替`,
"label.layout.listtip":`以下のテーブルは、プロファイルごとに割り当てられたページレイアウトを表示しています。`,
"label.icon.2":`財布`,
"label.chat.topic.delete.prompt3":`確かにこのトピックスを削除しますか`,
"UG_Lead_008":`QRコードを名刺に使う`,
"label.multilang.databatchadd.fail":`{0}件のデータが追加に失敗しました：`,
"front-kefu-moudle-v1-chzx-confirm":`本当にエージェントを削除してもいいのですか？`,
"label.import.page1.matchlabel":`{{$store.state.labelName}}にマッチする方法`,
"label.dashboardSetup.showdw.d3":`百万`,
"label.version.ifnecessary":`需要に応じて、CloudCC をバージョンアップしてください。`,
"label.confirm.delete.default.tab":`確かにデフォルトログインタブを削除しますか。`,
"label.emailtemplate.mergefields.tip":`差し込み項目には、代替テキストを追加できます。代替テキストは、その項目用の差し込みレコードにデータがない場合にのみ表示されます。例:{!Contact.Name}。メールを使用するとき、テンプレートのメール本文に {Contact.Name} の構文で表示されます。`,
"vue_label_chatter_decline_members_join":`メンバーのグループへの加入を拒否します`,
"label.role.no":`ロールなし`,
"label.service.gantt.resources":`のリソース`,
"label.knowledge.language.simplified":`簡体字中国語`,
"label.eidt.queue.length.cannot.than":`名前の長さは50文字を超えてはいけません`,
"label.mobile.quickcreate.default.tasks":`ToDo`,
"label.discount.yuan":`割引（元`,
"message.error.delete.pending":`レコードは審査中で、削除できません。`,
"chatter.show.mostnews":`情報をさらに表示`,
"label.optionlist":`選択リスト`,
"template.chart.cpdj":`製品価格`,
"label.user.usernamepassword.error":`ユーザなまたはパスワードが間違っています`,
"label.file.sharetype.check":`参照者`,
"label.completed.generated.page":`PC端末ページの生成が完了した`,
"label.martrixcross":`マトリックスのクロッシング`,
"label_tabpage_entercusnamez":`取引先名を入力してください`,
"lable.account.NextwDays":`これからの30日`,
"label.list.userinterface.dashboard.hint":`新しいダッシュボードは携帯、PADなどの端末で迅速に表示されることができます。`,
"message.fieldtrack.operatecreate":`作成済み`,
"label.service.gantt.available.plan":`予約可能な時間帯`,
"label.activity.setting":`活動の設定`,
"label.tag.manage.record":`レコード数`,
"label.customcomponent.page.edit.title":`カスタマコンポーネントの編集`,
"label.import.index.creationrecord":`レコードの作成`,
"label.tabpage.printz":`プリント`,
"label.appointment.wizard.subtitle4-1-5":`1.5時間`,
"label.partnerCloud.orderingPlatform.discountUnit":`割引ユニット。`,
"label.weixin.micro.message.profile.associated":`Wechat公式アカウントと組織プロファイルのリレーション`,
"label.cpq.opportunity.pricebook.change":`このオポチュニティは一次見積にリンクされており、プライスブックの変更はできません。`,
"vue_label_opportunity_business_opportunity":`クローズドしかも獲得済みの商談には、既存商談と1つ以上の同じ項目のレコードがあります。`,
"message.standardreport":`標準レポート`,
"vue_label_account_outstanding_business":`ほかの人のすべての未処理商談を置換える`,
"vue_label_commonobjects_detail_field":`フィルター項目の選択`,
"pagecreator_page_button_delete":`削除`,
"label.leadconvers.permisson":`{!objectname}の{!operator}権限がありません。システム管理者に連絡してください。`,
"vue_label_systemSettings_customcode":`カスタムコード`,
"button.partner.cancel":`キャンセル`,
"label.whChatBindingState":`Wechata アカウントのバインディング状況`,
"label.appointmentconfirmail.wizard.subtitle6":`電話番号`,
"label.recycle.dis.tip2":`ユーザは［ゴミ箱を空にする］あるいは［組織のゴミ箱を空にする］をクリックして、ゴミ箱を空にします。ゴミ箱を空にするには時間がかかりますが、完了したら通知のメールを送信します。`,
"batch.transfer.succ":`データの一括移行の成功条件：`,
"label.chat.add.bookmark":`ブックマーク`,
"label.mr.object.contact":`取引先責任者`,
"component_setup_label_parentobject":`上位オブジェクト`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`火曜日`,
"vue_label_report_list":`リストタイトルに表示する項目を選択する`,
"label.checkbox.false":`いいえ`,
"label.chatter.followers":`フォローされた`,
"label.mr.loadReDate":`選択した情報のアップロード`,
"label.versiontype.Essential":`基本版`,
"front-project-module-v1-input-actual_working_hours":`工数を入力してください`,
"label.visualpage.staticresource.p2":`2.ご注意：サポートされる静的リソースのファイル種別はpng、jpg、gif、js、cssです。`,
"label.query.clone.detail.choose":`コピーする明細レコードを選択してください`,
"component.assistant.label.30daysnoact":`30日間キャンペーンなし`,
"label.tianyancha.businessverify.relation":`対応付け済み`,
"vue_label_email_havent_received_the_email_yet":`メールは届いていません。`,
"label.isEnableVisualpage_new.title":`カスタムページのアクセスを有効化`,
"lable.SalesCommitmentKanBan.allContractAmount":`契約件数`,
"label.searchall":`すべて検索`,
"label.h5.similar.opportunity.select.all":`すべて選択`,
"label.area.tree.intro":`ここで直観的にエリアとエリアとの関係を参照することができます。`,
"label.select.up.three.fields":`注意選択できる項目は最大3つです。`,
"label.leadscore.doing":`スコアリング中で、繰り返しスコアリングしないでください。`,
"message.choosereportobj":`レポートオブジェクトをご選択ください`,
"button_partner_start":`使用開始`,
"label.quote.print":`見積書のプリント`,
"label.workflowoperateselect":`ステップ 3: ワークフローアクションの指定`,
"label.greate":`>より大きい`,
"lable.setting.qrcodeOrbarcode.rule":`QRコード/バーコードのルール設定`,
"label.partnerCloud.orderingPlatform.discounts":`割引スケジュール`,
"label.ems.save2draft":`下書きを保存`,
"vue_label_homepage_editname":`ホームページ名の編集`,
"label.ccdocument.save.error":`保存失敗、エラーコードは`,
"label.samoa.standard.time":`サモア諸島標準時`,
"label.tianyancha.businessverify.msg7":`三：データサービス範囲：`,
"vue_label_commonobjects_view_up_to_data":`このアクションは最大200個のデータをサポートします`,
"label.manage":`管理`,
"label.tooltip":`レポートタイプは使用済みで、オブジェクトリレーションを編集することができません。`,
"vue_label_calendar_edit_calendar":`カレンダーの編集`,
"label.attendance.keywords":`キーワードを記入してください`,
"label.otherinfo":`その他の情報`,
"System_TAB_SeeViewAmount":`総数を表示`,
"label.recordtype.remark":`説明`,
"label.object.cannot.delete":`オブジェクトはその他のオブジェクトの下記のリレーションシップと関連しているため、削除ができません。`,
"label.setup.mobile.bottombutton.saveprompt":`4つのファーストレベルページを選択してください`,
"label.department.lastpage":`最後のページです。`,
"label.emailtemplate.mergefield.use":`差し込み項目値をコピーし以下のメールテキストに貼り付けてください。`,
"vue_label_salesfunnel_notice8":`このステージから次のステージへの転換が成功した割合`,
"lable.opppdt.addpdt.table.product":`商品`,
"vue_label_helpcenter_report2.2":`ステップ2：列の集計方法を選択します。合計、平均、最大値、最小値。<br>・レポートのデータを昇順または降順に並べ替える<br> プレビューレポートのヘッダーにあるいずれの項目の横にある「↑」または「↓」のマークをクリックします。レポートのデータは、この項目に従って昇順または降順に並べ替えられます。<br>・詳細行の表示または非表示<br>グループ化した後、レポートの右上にある「詳細情報行」ボタンをプレビューすることで、詳細情報行の表示または非表示を切り替えることができます。「詳細情報行」はデフォルトでオフになっています。<br>・自動更新プレビューのオン/オフ<br> プレビューレポートの右上にある「自動更新プレビュー」で、自動更新プレビューのオン/オフを切り替えることができます。オンにすると、各ステップでのデータへの影響がプレビューレポートに自動的に表示されます。・レポートのレコードをフィルタリングするには、フィルタをクリックします<br>フィルタは、標準フィルタと項目フィルタに分かれています。<br>標準フィルターには、「役割」フィルター、「私に表示」フィルター、「日付」フィルターがあります。<br> A. 「役割」フィルターは、現在の役割と直属の役割でデータを分割し、役割名をクリックすることで役割を切り替えることができます。<br> B. 「私に表示」フィルターは、「私に表示」と「すべての人に表示」でデータを分け、「私に表示」は所有者が現在のユーザーであるデータを表示し、「すべてに表示」は現在のユーザーが参照権限を持っているすべてのデータを表示します。<br> C. 「日付範囲」フィルターは、「日付作成」、「終了日」のように、時間の範囲内の日付でデータを分割します。<br> 項目フィルターには、項目フィルターと高度フィルター含まれています。<br>`,
"label.validate.function.funcFormat.YEAR":`YEAR(date)`,
"label.service.gantt.timeScale":`ガントで表示する時間軸を選択する`,
"label.data.dataexptemplate.desc1":`1、データエクスポートのファイルに2つの形式があり、1つはCSV形式で、もう1つはパック形式です。CSV形式はデフォルト形式とされています。`,
"template.chart.btjbkhqk":`お客様のレベルの違い`,
"label.role.assign.select":`選択したユーザリスクから削除されるユーザは、上記選択したロールに割り当てられます。`,
"label.event.lookupmulti.assigner":`任命先`,
"label.appexchange.fieldupdata":`ワークフロー項目の更新`,
"label.lookup.page.notexists":`ページは存在しません。`,
"label.appupload.install.error.choice3":`コンフリクトがあるコンポーネントを1つにマージします`,
"vue_label_commonobjects_detail_team":`グループの管理`,
"label.approvereqiest":`承認申請`,
"message.error.id.replace":`{0}に対応するカレンダー情報が見つかりませんでした。`,
"font-evaluate-module-v1-general":`評価の種類は「ニュートラル`,
"vue_label_report_whatweek":`何曜日`,
"vue_label_chatter_img_upload":`アップロードできるファイルは、JPG、GIF、PNG形式で、最大サイズは2Mです。`,
"label.checkbox":`チェックボックス`,
"label.visualpage.component.n5":`5.実例　転用: &lt:component:c1 args`,
"chatter.updat":`アップロード時間`,
"label.ems.emailaccount":`メールボックスのアカウント`,
"label.autoRegister.changepwd.setpwd.tip1":`パスワードをCloudCCアカウントに設定します`,
"label.import.step1.matchway":`{ labelNameshow }マッチングモード`,
"label.manageAll.sel.one4":`私が却下したプロジェクト`,
"label.tabpage.lookatmorez":`更に表示`,
"label_tabpage_addadvancedoptions":`高度なオプションの選択`,
"message.validation.accept":`有効な表示形式の入力`,
"label.handlingnooperate":`データは処理中です。処理失敗にならないように、その他のアクションを行わないでください。`,
"label.mobile.buttom.homepage":`ホームページ`,
"lable.account.LastaDays":`過去の7日`,
"label.user.notexists":`ユーザーは存在しません。`,
"front-electronic-signature-isclose":`活動休止中`,
"label.optional.groups":`任意の見積もりライングループ`,
"pagecreator.layout.label.layoutname":`レイアウト名`,
"label.error404":`アクセスするページは存在しません。しばらく経ってから、また試してください。`,
"label.eventtrigger":`行動トリガー`,
"label.projectManagement.next.page":`次のページ`,
"vue_label_SMS_chosen":`選択済み`,
"label.part.cannot.empty":`段は空であってはいけません。`,
"label.call.center.jilu":`通話の記録`,
"front-kefu-moudle-v1-tenant-reinput":`賃借人IDを入力してください`,
"label.projectManagement.you.want.to.delete.this.data":`確かにこのレコードを削除しますか`,
"label.projectManagement.nocharge":`無料`,
"System_TAB_SeeViewPageAmount":`ページの表示`,
"label.password.query.error":`ユーザ検索にエラーは発生しました`,
"message.chooseatleastone":`以下のいずれかのデータ型を選択してください。`,
"label.sortasc":`昇順`,
"label.stdashbord.xsld.business.jinezhb":`金額の割合`,
"label.attendance.add":`勤怠の追加`,
"vue_label_account_invoices":`取引先所有者のすべての請求書を移行します`,
"label_delete _model":`モデルを削除すると、関連するターゲットデータも削除され、元に戻ることはできません。確かに削除しますか。`,
"label.folder.sort。discreption":`フォルダは選択した順番に基づき、エクスポートされます`,
"label.partnerCloud.financeSetting.merchantPlatform":`Acces Path:Merchant Platform  Account Center  API Safety  API SecretKey`,
"label.equal":`=等しい`,
"lable.PowerProcess.Workorder":`作業注文書`,
"front-docusign-setting-error-tips":`カスタムフィールドを選択してください。`,
"template.report.lead.status":`リードの状況`,
"label.create.remark":`新規メモ`,
"font-evaluate-module-v1-one-points":`ネガティブマーク：1点`,
"label.validate.function.funcExplain.DATETIMEVALUE":`年、月、日及びグリニッジ標準時に戻る（日付/时间 項目）`,
"label.report.select.group.mode":`グループ化の方式を選択`,
"label.h5.editmydetails":`個人情報の編集`,
"front-epwechat-module-v1-authorize":`認定コールバックドメイン`,
"label.tabpage.kanban":`ビューボードの設定`,
"label.emailobject.emaildetail.button.addtocontact":`取引先に追加します`,
"lable.opppdt.selPbk.description":`この商談に価格表を選択します。個別価格表しかから商品を追加できません。選択した価格表を更新すると、この商談からすべての既存商品を削除します。`,
"component.event.button.save":`保存`,
"vue_label_homepage_homepage_assigned_success":`ホームページの割当てに成功しました`,
"message.duplication.label.blankmatch":`NULL 値は一致されますか`,
"label.icon.24":`応急処置キット`,
"label.mobile.same":`新しい電話番号は、古い電話番号と同じです。`,
"label.file.library.managemembers.addmember":`メンバーの追加`,
"chatter.sp":`書き込みの表示`,
"label.user.notlogin.range":`ログインの時間範囲内にありません。`,
"label.step3.total7":`ステップ　3/7`,
"label.user.fullname":`フル‐ネーム`,
"label.button.menubar":`メニューバー`,
"#label.importfilestep3":`ステップ3.ファイルを選択してアップロード`,
"label.appointment.wizard.subtitle6":`説明`,
"message.lostnextapprover":`提出するには関連ユーザ項目が確定する次回の承認者が必要ですが、この値はNULLになります。詳細については、管理者に連絡してください。`,
"label.sso.saml.sp.logoutUrl":`IDプロバイダのシングルログアウトURL`,
"label.weixin.isgoon":`会員情報は既に存在していますが、続ければ、この携帯電話番号がバインディングされたWechatアカウントは愛馬社のWechat公式アカウントを利用することができません。確かに続きますか。`,
"vue_label_notice_homepage1":`12桁以内の正しい目標値を入力してください`,
"label.umeng.activity.event.will":`間もなく`,
"label.insertURL":`URLの挿入`,
"label.partnerCloud.orderingPlatform.administrator":`利用可能な価格表はありません。管理者にお問い合わせください。`,
"vue_label_systemSettings_emailtemplate":`電子メール`,
"template.dashboard.market.analysis":`キャンペーン分析`,
"message.deleteapproval.tip":`データがないレコードに関連する承認プロセスしか削除できません。`,
"pagecreator_page_message_delete":`選択したページを削除しますか。`,
"component.telerecord.label.message":`コメント`,
"front-email-payment-Invoice-preview-opening":`システム管理者に連絡して、オンライン決済機能を有効にし、対応する決済方法のパラメーターを設定してください。`,
"noless":`より大きいorイコール`,
"label_emailtocloudcc_button_back":`キャンセル`,
"lable.Please.select.a.template":`既存のテンプレートを選択してください。`,
"front-lightning-module-v1-details-page-chart-relevant":` 現在のオブジェクトを含む選択されたレポートの関連オブジェクトは、あなたが現在のレコードに応じてレポートのデータをフィルタリングすることができますが、かどうかを設定するユーザーが手動でカシェのデータを更新することができます。`,
"label.object.page.head":`ページの最上位へ`,
"label.notification.time1":`先ほど`,
"label.weixin.optionnine":`選択肢 9`,
"label.approval.content.tolang":`入力する内相は長すぎ、改めて入力してください`,
"label.leadconvers":`リードの置換`,
"label.compact.layout.frame.tabseq":`TABページの表示順番：`,
"label.permission":`権限セット`,
"vue_label_notice_new_success":`作成に成功しました`,
"label.money":`通貨`,
"label.ccchat.person.invite.unsuppem":`入力したメールアドレスは{0}をサポートしません`,
"message.profile.del":`当該プロファイルはシステム管理者のプロファイルで、削除できません。`,
"vue_label_report_savelocation":`保存先`,
"label.knowledgebase.select.lighting.target":`ライトニングターゲットを選択してください。`,
"label.visualpage.labelname":`ページの表示ラベル名`,
"label.notification.ccchat2":`【いいねをクリックしたのユーザ名】あなたの書き込みにいいね！と言いました`,
"label.htyj.wanchenglv":`完成率`,
"label.weixin.report.generatedchart":`生成済みの図表`,
"label.customer.tab.please.label":`タブの表示ラベルをご入力ください`,
"label.template.lookup":`テンプレートを表示`,
"label.attendance.setting.wucha":`誤差は200メートル以内です`,
"vue_label_opportunity_product_addproduct":`製品の追加`,
"label.data.setok.t.desc3":`操作を行う`,
"label.emailobject.template.public":`公開`,
"label.setsubmit":`提出の設定`,
"chatter.feed.menutype.feed.companycom":`すべての書き込み`,
"label.Generate.Document":`ドキュメントの生成`,
"label.knowledge.setting.hint.six":`データの分類ごとに記事を整理する。`,
"label.dashboard.show.total":`表示件数`,
"attachment.select.warning.001":`アーカイブされた添付ファイルを選択して、アーカイブボタンは利用できませんので、添付ファイルをもう一度選択してください。`,
"message.schedulejob.error.delete":`ジョブベースを削除する際にエラーが発生しました。`,
"setup.layout.group.pagecomponent":`ページ構成`,
"label_partner_new_step3_meno":`何を入力するか確認できくても大丈夫です。随時に更新できますから。`,
"label.partnerCloud.orderingPlatform.mutex":`ミューテックス`,
"label.subtotalrely":`サブトータルの根拠`,
"label.file.library.selectFile2Lib":`ファイルを追加`,
"label.lock.record":`レコードはロック済みです`,
"label.multilang.addcustomreporttypestage2.description":`このデータソースは{0}関連のレポートを生成します。リレーションを選択して、データソース結果として返す関連オブジェクトを定義します。`,
"message.duplication.errorinscript.greaterthan10":`最大10つまでのマージするレコードを選択できます`,
"label.encd":`暗号化の表示`,
"UG.Account.03":`重複する取引先をチェックしてマージする`,
"label.salescloud.teamrole.main2":`主要`,
"label.email.to":`受信者`,
"label.members.sign.notify":`スーパーバイザーに通知する`,
"template.report.individual.case.priority":`ケースの優先順位`,
"vue_label_report_selectfolder":`フォルダの選択`,
"label_partner_all":`すべてのパートナークラウド`,
"lable.custom.year":`カスタム年度`,
"label.ispigeonhole":`ファイリング`,
"label.campaignmember.selectmember.steptotal":`ステップ 2/2`,
"label.userphoto.save":`保存`,
"label.knowledgebase.published.version.online":`あなたがこのドラフトを公開するまで、公開されたバージョンはまだオンラインです。`,
"template.report.customer.level.statistics":`アカウントレベルの統計`,
"label.mobile.phone.day.plan":`明日の計画`,
"label.icon.95":`教える`,
"label.recordphone":`電話のレコード`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`高度な通貨種別管理の使用を禁止するなら、期限切れの為替レートを使用することができません。商談、商談商品及び関連するレポートの通貨は特定の期日範囲内の為替レートに対応付けることができません。すべての通貨項目は固定為替レートを使用します。`,
"label.service.gantt.is.candidate":`の候補者`,
"label.ruleofchecktask":`ToDoの入力規則`,
"label.whole.page.show":`フルスクリーンの表示`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(expression)`,
"label.ccdocument.template.set":`テンプレートセット機能`,
"label.icon.103":`スケジュール`,
"lable.no.products.to.assets":`製品を資産に移すことはできません。`,
"label.fristname":`名前`,
"label.appointmentconfirmail.wizard.subtitle5":`組織者`,
"label.partner.workspace.myspace":`私のワークエリア`,
"label.tabpage.optionsz":`オプション`,
"component_chatter_link_button_save":`発表`,
"label.validate.function.funcFormat.NOW":`NOW()`,
"label.discountPlanEditor":`割引プランのエディタ`,
"label.weixin.fmu.pm":`午後`,
"front-gantt-module-milestone-sorting":`マイルストーンの仕分け`,
"label.partnerCloud.maximumNumber":`パートナーサイトの最大数です。`,
"label.mobile.place.record.interval.setup":`位置情報共有間隔`,
"label.visiblelinenumber":`参照可能な行数`,
"front-kefu-moudle-nopower-calluser":`許可されていないので、管理者に連絡してください`,
"label.field":`項目`,
"label.projectManagement.groupbydate":`日付でグループ分け`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`予定`,
"label.operation.monitoring.history":`ジョブの監視履歴`,
"label.data.dataexpalltype.all_desc1":`1、すべてのパックファイルをエクスポートするには、パスワードは自動的に生成され、あるいは手動で入力されます。自動的に生成された暗証番号はデータのエクスポートが完了した後に、ユーザのメールボックスに送信されます。手動で入力した暗証番号はユーザのメールボックスに送信されないため、ユーザはしっかりと覚えなければなりません。入力しない場合、パスワードがないと認識されます。`,
"front-web-module-v1-detail-comment-proposal":`皆様からの貴重なご意見をお待ちしております。`,
"label_partner_workspace_member_selectedpermission":`選択可能な権限セット`,
"vue_label_helpcenter_view1":`lightingバージョンのビューでは、アクセスしたデータを直感的かつ柔軟に表示・管理することができます。ビューを通して、データの分類表示、複数の方法でのデータ表示、データの追加、修正、削除などの基本的な機能を実現し、さらにデータ分析のためのレポートやチャートを容易に参照することができます。<br> 1.ビューの管理<br> ビューの左上にあるドロップダウンメニューで、表示するビューを選択し、固定設定でデフォルトのビューを選択します。<br> リストビューのコントロールメニューを使って、ビューの作成、編集、削除、並び替えを行います。同時に、右上のフィルター機能を使って、ビューの編集や新規作成を素早く行うことができます。<br> 2.複数のビューでデータを表示します<br> データをさまざまな方法で表示することができます。右上では、リスト、看板、分割画面を切り替えてデータを表示ことができます。<br>リストビューでは、いくつかのタイプの項目は、単一または複数のデータを直接的に修正することができます。編集するセルをダブルクリックするか、編集ボタンをクリックすると、ポップアップウィンドウに表示されるデータを直接的に編集することができます。複数のデータを編集するには、まず複数のデータを選択してから、編集ポップアップウィンドウで「選択したデータに適用」を選択すればいいです。<br> リストビューでは、左上に表示される列を直接的に編集したり、テーブルのヘッダをクリックして並び替えたり、ドロップダウンのフローティングウィンドウからロックする列を選択したりすることができます。<br> 看板ビューを設定すると、データをグループに分けて表示したり、グループごとの集計値を表示したりすることができます。看板ビューの設定では、看板ビューのグループ化基準、集計基準、集計方法を編集することができるだけではなく、表示する項目を4つまで選択することができます。データのグループ化は、ドラッグ＆ドロップで素早く変更できます。<br>`,
"component.task.label.priority":`優先順位`,
"label.datamanage.field.error":`検索オブジェクト項目にエラーは発生しました`,
"label.console.step3":`ステップ3.コンソールログの画像ソースの選択`,
"label.ems.emailsyncsetup":`メール同期の設定`,
"label_tabpage_placeenterz":`入力してください`,
"label.getontocolumn":`列に切り替え`,
"label.file.down.e":`現在のファイルタイプは、ダウンロードが許可されていません。`,
"vue_label_notificationcenter_unreadonly":`未読のみ表示`,
"label.login.access.change":`変更`,
"label.globaloperation.operationtype.send_e-mail":`メールの送信`,
"label.dashboard.refresh.hint":`ダッシュボードを更新して、すべてのソースリストを再実行するには、時間がかかりますが、続きますか。`,
"front-kefu-moudle-open-free":`イネーブル（トライアル）`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`注文の管理`,
"label.chatter.maturiyDate":`有効期限`,
"message.mobilechooseatmostthree":`携帯電話のフロントエンドタブは最大で3つまでの項目を選択します`,
"label.customfields.formula.tip":`定義した数式のエクスプレッションから値を抽出する参照のみの項目です。この計算項目は、いずれかのソース項目が変更されたときに更新されます。`,
"lable.PowerProcess.start.time":`開始日を選択してください。`,
"label.mr.title.button.group2":`重複データ、共有`,
"label.atlantic.standard.time":`大西洋標準時`,
"label.account.LengthofTime":`持続時間`,
"label.ccchat.message.search.desc2":`のメッセージ`,
"label.pigeonhole.desc":`ファイリングはファイリングされていないファイルのみに有効で、ファイリングされたファイルに無効です。ファイルはファイリングされると、削除できません。`,
"label.partnerCloud.orderingPlatform.sure":`スイッチ {alias} でカートを空にします。操作を確認してもよろしいですか？`,
"label.default.value.is.positive.integer":`デフォルト値は必ず正整数です`,
"label.partnerCloud.selectOne":`最低でも1つのメニューを選択`,
"label.dashboard.more.condition":`より多くの条件`,
"component.event.label.enddate":`*終了日`,
"label.forecast.settings.type":`予測の種別`,
"com.cloudcc.login.error.message.licensenotstart":`ライセンスが起動していない`,
"lable.list.queue":`キュー`,
"label.mobile.app.isdisablum":`サインインの時、携帯のアルバムから写真を選択することを禁止しますか`,
"label.service.gantt.filter":`スキルフィルタを使用すると、選択したスキルのリソースのみがガントマップに表示されます`,
"label.potentialcustomeronline":`オンラインリード`,
"label.campaignmember.main.deletecontactdesc":`キャンペーンからすべての取引先責任者を一括削除します`,
"label.list.desc1":`web to cloudcc 機能を通じて、webページを生成します。Webアクセスを通じて、データをcloudccシステムにキャップチャーします。`,
"label.generatepage.title.desc3":`名前は一意で、文字から始まり、アンダースコアと英数字しか使用できません。最大の長さを30文字する必要です。`,
"label.emailtocloudcc.step2total3":`ステップ2/3`,
"label.movablemenu":`活動ボタン`,
"label.partnerCloud.partnerAccount.topUp":`トップアップ`,
"label.data.standobject":`標準オブジェクト`,
"label.frequency":`頻度`,
"label.schedulejob.setup.schedule.end":`完了`,
"label.chat.topic.following":`フォローしている`,
"label.martrixreport.2018.step2":`ステップ2.集計する情報の選択`,
"label.event.moveup.11hour":`11時間`,
"label.forecast.customforecast.directorcommit":`直接部下の承諾率`,
"vue_label_homepage_card_view":`カードビュー`,
"vue_labenl_applauncher_notice_closecertification":`電源を切るとデータが消えてしまいます。本当にそうしてもいいのですか？`,
"component_setup_button_weburl":`外部URL`,
"label_emailtocloudcc_button_addemailaddress":`企業メールボックスの追加`,
"vue_label_campaign_added_campaign_members":`キャンペーンメンバーの追加に成功しました`,
"label_tabpage_rtemptyz":`レコードタイプは空であってはいけません`,
"label.martrixreport.2018.step5":`ステップ5.画像種別とレポート強調表示の選択`,
"label.moverecord":`レコードの移行`,
"pagecreator_layout_label_layoutdesc":`レイアウトの説明`,
"label.knowledge.setting.data.nine":`はい、このカテゴリーグループとその下のカテゴリーを削除したいです。`,
"label.icon.90":`人`,
"label.weixin.micro.research.name":`Micro research名`,
"label.ccchat.micropost.allowedit":`投稿とコメントの修正ができます`,
"vue_label_homepage_fixed_components":`スタンダードコンポーネント`,
"label.version.document":`フォルダベース`,
"label_assessment":`評価（商談-金額）`,
"label.appupload.component.type.lookuplayout":`検索レイアウト`,
"label_chatter_loadmore":`更にアップロード`,
"component_setup_tabs_label_memo":`Tab表示ラベル名の設定`,
"label.icon.167":`方位磁針`,
"vue_label_chatter_enter_content_sharing":`共有内容と共有グループを入力してください`,
"vue_label_notice_modify_success":`修正に成功しました。`,
"label.sharerules":`共有ルール`,
"label.field.api.exists":`項目APIは存在済みです`,
"label.icon.83":`ペイント`,
"label.file":`ファイル`,
"vue_label_report_foldernameisrequired":`フォルダ名が必須項目です`,
"label.emailobject.wizard.btn2":`関連済みで、メールを発送します`,
"label.data.downpage.i_title.num3":`3、データをインポートする前、すべての関連レコードのインポートを確認してください。例えば、インポートしたオブジェクトが取引先責任者の間に参照関係があれば、まずこれらの取引先責任者をインポートする必要があります。`,
"label.email.original.content":`参考コンテンツ`,
"vue_label_campaign_add_to_campaign":`キャンペーンに追加`,
"label.dashboard.new":`新規ダッシュボード`,
"label.console.detail":`コンソールの参照`,
"label.view.desc":`日付項目はイコールのとき、「昨日」、「今日」「明日」、「先月」、「今月」、「来月」、「先週」、「今週」、「来週」あるいは 「YYYY-MM-DD、MM/DD/YYYY」という書式を使用することができます。`,
"label.emailobject.template.insert.continue":`追加の継続`,
"label.notification.appointment.overlapEvent":`この時間帯は既に予約されたので、別の時間を選択してください。`,
"label.console.step6.top":`トップに固定します。リスクはいつでも参照可能です。`,
"label.data.file.the_trigger":`トリガーの執行`,
"message.report.error.operation":`アクション失敗、改めてレポートを設定してください。`,
"vue_label_helpcenter_detail3":`<br>   いいね！といいね！の解除<br>  いいね！は、マイクロポストのコメントにも、マイクロポストだけにもつけることができます。いいね！にすると、その投稿に対する「いいね！」の数が表示され、また「いいね！」を解除こともできます。<br>投稿の編集・削除<br>    投稿者は、投稿を再編集したり、削除したりすることができます。<br>    ステップ1: 投稿の右にあるボタンをクリックし、ドロップダウンボックスで編集または削除を選択する<br>   ステップ2: 編集/削除確認のポップアップを開く<br>    ステップ3: 保存/確認をクリックして操作を完了する<br>5.承認履歴<br>承認申請を提出する<br>    新規レコードを作成し、承認申請が撤回され、または最終却下された時に「承認申請提出」ボタンが表示されます。<br>   Step 1: 「承認申請提出」をクリックします。システムはレコードと提出者が、承認プロセスで設定されたプロジェクトと初期提出者の条件を満たしているかどうかを判断し、これらの条件がすべて満たされていれば、提出に成功します。<br>   承認プロセス設定における次の承認ステップで、承認者を手動で選択する必要がある場合は、「承認待ち提出」の後にステップ2が実行されます。<br>  ステップ2：次の承認者を選択し、提出を完成させます。<br>承認履歴<br>   A.提出前：<br>    「承認プロセスのプレビュー」をクリックすると、システムはレコードと提出者が承認プロセスで設定された項目を満たしているかどうかを判断し、これらの条件がすべて満たされた場合、承認プロセスを表示します。<br>    B.提出後：<br>   承認履歴では、承認履歴のステップやレコードの現在の承認状況を確認することができるだけでなく、次の承認プロセスをプレビューすることもできます。<br>プルバック承認申請の撤回<br>   この承認プロセスが承認申請の撤回に設定されている場合、承認申請を提出した後、いつでも撤回することができます。<br>   Step 1: レコードの詳細ページにある「承認申請の撤回」をクリックします <br>  Step 2: 承認申請撤回ページを開き、「承認申請撤回」をクリックして操作を完成させます。`,
"Opportunity_Detailed_Phase_Label_004":`日`,
"PageLayout_Search_MultiSearch_001":`3つ以下の_目を__することができます`,
"vue_label_systemSettings_set_business":`ビジネスに合わせて、オブジェクトのレイアウトやフィールドを設定します。`,
"label.compact.layout.frame.select":`ページレイアウトフレームを選択`,
"label.tabpage.rolez":`役割`,
"label.weixin.appr.currentauditor":`任命先`,
"label.knowledgebase.verification.status":`検証状況`,
"UG_Case_05":`ケースの作成`,
"label.service.marking.completed":`完了にする`,
"label.notification.ccchat1":`【@のユーザ名を送信】私に関する内容を書き込みました`,
"label.knowledgebase.no.action.available":`アクションはありません`,
"label.tabpage.newlybuildz":`カスタマレポートデータソースの新規作成`,
"label.appupload.install.error.choice2":`ソフトパッケージとコンフリクトしたローカルのコンポーネントをリネームします`,
"label_tabpage_as":`例えば`,
"Opportunity.Detailed.Phase.Label.Popup.001":`現行ステージの開始日`,
"vue_label_homepage_singlepage":`単一ページに最大10個までのコンポーネントを追加することができます`,
"font-evaluate-module-v1-fair-and-bad":`評価のタイプがNeutralとNegativeの場合`,
"label.partnerCloud.orderingPlatform.orderInformation":`ご注文内容の確認`,
"label.custom.lead.conversion.notice":`リード置換の通知`,
"label.re.upload":`改めてアップロードします`,
"label.knowledgebase.top.window":`トップウィンドウ`,
"label.h5.allmarkedasread":`すべて既読にする`,
"vue_label_SMS_open_record_from_start_activation":`リストからレコードを開いて、有効化します。`,
"label.customer.tab.step2":`ステップ 2. プロファイルに追加`,
"label.campaign.channel.input.owner.select2":`当該販売チャンネルの招待人`,
"component.task.button.save":`保存`,
"front-kefu-moudle-v1-phone-type":`電話タイプ`,
"label.wedge-shapearrows":`上昇ウェッジ型矢じり`,
"vue_label_homepage_todaysevent":`本日の行動`,
"label.data.exp.way.sel":`エクスポート方法の選択`,
"label.setting.intergrationlist.status1":`このイングレーションはまだインストールされていない`,
"button_partner_workspace_disable":`有効化を解除`,
"label.customfields.reference":`公式、選択リスト、検索などのその他の項目に参照される可能性があります。`,
"label.publicgroups.new":`公開グループの作成`,
"label.data.setok.e_desc3":`エクスポートするデータのダウンロード`,
"vue_label_commonobjects_view_chart_countmode":`合計方式`,
"label.service.appointmentList.earliest.allowedStart":`最も早い開始日`,
"label.data.choses.e.desc":`需要に応じてすべてのデータをエクスポートするか、または単一オブジェクトデータをエクスポートすることができます。`,
"label.multilang.common.fieldlist.fieldremark":`{0}ページで表示する項目に応用されます。`,
"label.umeng.activity.event":`行動`,
"label.project.hit.ten":`号機アップデートのお知らせ`,
"label.c_d_least":`レコード「C」に少なくとも1つの関連レコード「D」があります。`,
"label.emailobject.wizard.btn1":`個人メールボックスの関連付け`,
"lable.product.pricebooks.info":`価格表の詳細情報`,
"component_telerecord_label_message":`コメント`,
"lable.total.of.estimates":`全部0件の見積もりです`,
"label.stdashbord.xsld.business.oppcounts":`商談数`,
"vue_label_commonobject_duplicatewith":`{0}の{1}に重複しています`,
"label.setpicandreport":`図表の設定`,
"label.category.2":`一般的な`,
"label.emailtocloudcc.reauthorization":`再認証`,
"label.chatter.vote":`投票`,
"label_emailtocloudcc_edit":`編集`,
"label.pleaseinput":`入力`,
"vue_label_homepage_user_particular_application":`ユーザーが特定のアプリケーションホームページを使用することで、これらの割り当ては標準のホームページを上書きされます。`,
"label.allianceID":`連盟ID`,
"label.h5.homepage.cannot.applied.mobile.terminal":`このプロフィールには、プロフィール・ホームページが設定されていません。モバイルアプリでは利用できません。`,
"label.appointmentpage.wizard.notif2":`名前を記入してください`,
"label_emailsync_status_email":`メールのアクション`,
"label.icon.179":`人`,
"UG_Contract_03":`契約の作成`,
"label.cy.new":`新しい通貨種類`,
"label.version.setup.controllist":`バックグランド設定のコントロールリスク`,
"label.vlidaterule":`入力規則`,
"label.customer.tab.name":`タブ名`,
"label.recentview.seloption1":`最近参照したデータ`,
"vue_label_report_notice_nameisrequired":`レポート名は必須項目です。`,
"label.createapproveprocessstep":`<li>1.ヘルプトピックを参照する</li><li>2.メールテンプレートを作成する</li><li>3.SMSテンプレートを作成します</li><li>4.ジャンプスタートウィザードまたは標準ウィザードを使用して承認プロセスを作成する</li><li>5.承認履歴関連リストをすべてのページレイアウトに追加する</li><li>6.ユーザにリリースするプロセスを有効にする`,
"label.gotocalendar":`カレンダーへ`,
"label.import.page1.pleaseselectobj":`先ずオブジェクトを選択してください`,
"label_tabpage_messagez":`コメントを入力してください`,
"vue_label_homepage_profilepage":`プロファイルのホームページ`,
"label.tabpage.choose":`選択`,
"label.campaignmember.setup.lead.field":`リード項目`,
"label.setalipay.null":`Alipay設定のための必須項目は空です。`,
"label.custom.Current.and.NextCQ":`現在と次回のカスタマ四半期`,
"label.knowledgebase.needto.publish.articles":`アーカイブされた記事を再開すると、ドラフト版が作成されます。記事を公開しますか？`,
"pagecreator.layout.message.save.success":`レイアウトの保存に成功しました`,
"homepage.componet.approval.label":`承認センター`,
"label.last_submission":`最終投稿時刻`,
"lable.outlook.detail.prefo":`Exchangeを優先的に選択します`,
"label.projectManagement.new.subtask":`新規サブToDo`,
"label.service.appointmentList.checkThe":`チェック`,
"message.error.searchlayoutselectdefields":`削除できません。しかも検索レイアウトの一番目の項目でなければなりません。`,
"label.ems.normal":`正常`,
"vue_label_notice_pleaseselectobject":`オブジェクトを選択してください`,
"component.sendmail.button.send":`送信`,
"label.relevant.records":`関連記録`,
"label.weixin.login.CloudCC":`CloudCCにログイン`,
"label.tag.addtags.private":`プライベート`,
"label.appointment.disable.remark":`申し訳ありませんが、現在この機能は無効になっています。予定変更・キャンセルの場合は、担当者｛邮箱地址｝までご連絡ください。`,
"label.campaignmember.main.addMember1":`メンバーの追加`,
"message.error.objectnofound":`オブジェクトは定義されていません`,
"label.employeenum":`従業員番号`,
"label.search.applyfilter":`アプリケーションの絞り込み`,
"label.version.history.track.nonsupport":`無線版のみが項目追跡履歴機能をサポートします`,
"label.ccpeak.direction.for.use.time":`CloudCC プラットホームスケジュール済みクラスのマニュアル[2.1版本]`,
"label.ems.settings":`設定`,
"label_tabpage_arecordtypez":`使用可能なレコードタイプ`,
"vue_label_pool_assign1":`{0}{1}`,
"label.customcomponent.direction.for.use":`プラットフォームカスタマコンポーネントのマニュアル[バージョン2.0]`,
"label.appupload.appname":`ソフトパッケージ名`,
"label.cpq.order.status.no.active":`契約書を作成できるのは、ステータスがアクティブな注文のみ`,
"label.dashboard.maxlength":`最大255までの文字を入力してください`,
"label.customize.memory.function.sorting.title2":`ヘッダーソートの記憶`,
"label.report.chose.obj":`オブジェクト関係とレポートデータソースを選択してください。`,
"label.partner.step3":`ステップ3.一般情報`,
"message.report.type.error.fail":`レポートタイプが間違っています。`,
"pagecreator.page.message.publish.fail":`ページ公開に失敗しました`,
"label.minimun":`最小値`,
"label.state":`状況`,
"label.customcomponent.referencetype":`参照種別`,
"label.nameandemailtemplate":`下記のボックスでプロセス名を入力してから、メールテンプレートを選択し、承認者に追加します（選択可能）。`,
"label.customobjects.track.introduce":`0`,
"label.campaign.matchway.label":`一致する方法：`,
"label.redistribution":`再割り当て`,
"label.groupmanage":`組織管理`,
"label.icon.157":`カメラ`,
"label.quickbooks.viewlist.total":`合計`,
"label.file.copy.file.fail":`コピーに失敗し、主導的にコピーしてください`,
"label.outline.selectfield":`概要に選択した項目：`,
"label.datetime.maxsize":`検索の周期は3か月間より大きくなってはいけません`,
"label.dashboard.CustomDashboardMyHomePage":`私のホームページダッシュボードのカスタマイズ`,
"label.data.customobject":`カスタマオブジェクト`,
"vue_label_SMS_noselected":`レコードが選択していない`,
"label_tabpage_value":`値`,
"label.quote.qianming":`署名`,
"label.view.source":`ソースコードの表示`,
"label_popup_infoz":`メッセージ`,
"label.emailtocloudcc.redmessage8":`パラメータがエラーで、管理者に連絡してください。`,
"label.tianyancha.Search.business":`企業登録情報を検索`,
"vue_label_systemSettings_server":`サービス`,
"vue_label_homepage_dashboard_components":`ダッシュボードコンポーネント`,
"label.search.listview":`リスクビュー`,
"label.service.gantt.distribution.success":`割り当てに成功しました`,
"label.icon.4":`財布`,
"label.partnerCloud.orderingPlatform.calculate":`価格の算出`,
"label.forecast.edittotal.ycyx":`予測優先`,
"vue_label_commonobjects_detail_to_precise_search":`精確な検索へ`,
"label.order.number":`番号`,
"setup.mainpage.label.welcome7":`手順は以下の通りです。ページ左側のメニュー → アプリケーション設定 → 作成 → オブジェクト → オブジェクト名 → カスタムフィールド をクリックする。`,
"label.weixin.user.binding":`ユーザのバインディング`,
"label.custom.canvas.size":`キャンバスサイズ`,
"label.projectManagement.recent.projects":`最近のプロジェクト`,
"vue_label_helpcenter_lead":`Cloud CCを通じてリードを追跡・管理します。設定されたルールを使用して、リードをスコアリングして割当て、適切なタイミングで取引先や取引先責任者、商談に置換えます。<br>スコアリング<br> ビューの右上にある一括スコアリング ボタンで、ビューにあるリードをスコアリングします。<br>割当て<br> リードを作成または編集する際に、ページ下部の割当てを選択すると、既存ルールに従って担当者にリードを割り当て処理させることができます。<br>置換え<br> 適切なタイミングで、詳細ページの右上にある置換えボタンをクリックして、リードを取引先や取引先責任者に置換えることができます。同時に商談やToDoを作成して、商談のフォローに便利です。`,
"label.enabledprocess":`有効になっている承認プロセス`,
"label.emailobject.noemail":`メールはありません。メールを発送しましょう。`,
"label.validate.remark3":`別の項目の値に応じて必須項目にする`,
"vue_label_salesadvance_retention":`滞留`,
"label.product.managep":`価格表を管理`,
"font-evaluate-module-v1-not-report":`再開しないこと`,
"label.emailmerge.mergepage.step1":`1．マージするレコードの選択：`,
"front-epwechat-module-v1-epwechat-describe":`CloudCCはWeComとの統合を提供し、WeComの強力な機能と軽量なH5バージョンのCloudCCシステムを組み合わせることで、顧客関係を便利に管理し、プライベートドメインのトラフィックを操作し、企業の収益を向上させることができます。`,
"label.partner.template.detailimage":`詳細の図`,
"label.recycle.clearall":`組織のゴミ箱を空にする`,
"chatter.error.nottype":`エラー：無効な種別で、アップロードできるファイル種別はJPG、GID、PNGです。`,
"pagecreator.button.cancel":`キャンセル`,
"front-market-form-quired-ziduan":`登録ページの必須項目`,
"vue_label_report_columnname":`列の名前`,
"message.notdelete.type":`当該レコードタイプは以下のプロファイルのデフォルト値とされているため、削除できません。`,
"label.ccpeak.folder.all.time":`すべてのスケジュール済みジョブフォルダ`,
"label.quickbooks.searchlist.total3":`{0}件の関連されていない見積記録を検索しており、この総金額は{1}です`,
"label.forecast.detailforecast.quantity":`数値予測`,
"label.knowledge.language.british":`イギリス英語`,
"label.vlidaterule.example.messagelocation":`このエラーメッセージは、ページ上部か、特定項目の下に表示されます`,
"front-kefu-moudle-chf-success":`分割成功`,
"vue_label_jihui_yi":`機会1`,
"label.import.step1.null":`オプションはありません`,
"label.console.step5.tab.subtab":`子タブとする`,
"batch.edit.permission":`編集権限なし`,
"label.weixin.fmu.before.min":`0分`,
"chatter.up.file":`ファイルサイズによって、ファイルのアップロードに多少時間がかかります。しばらくお待ちください。`,
"setup.layout.group.field":`項目`,
"label.chat.unlike":`お気に入りを解除`,
"vue_label_dashboard_updatefrequency":`頻度の更新`,
"label.trigger.folder.new":`トリガーページ：新規フォルダの作成`,
"label.process.des.app":`現在レコードの詳細情報を参照するなら、右側のリンクをクリックして入ってください。`,
"vue_label_pool_assignselect":`割当てるメンバーの選択`,
"label.lookup.user":`人の検索`,
"label.mobilescreentablayoutedit.remark2":`携帯電話のフロントエンドタブのページ検索で表示する項目を選択`,
"label.data.exp.objtemp":`以下の条件により、当該条件をエクスポートするテンプレートを作成します。`,
"label.weixin.moreselect.error":`10つのレコードしか選択できません`,
"label.icon.25":`包帯`,
"lable.sample.text":`サンプルテキスト`,
"label.most.setup.obj":`10のオブジェクトまで設定します`,
"label.weixin.coming":`これから`,
"label.editdescription":`メモの編集`,
"label.multipleactivity.multiple":`複数のユーザ`,
"label.sso.saml.idp.entityid":`エンティティID`,
"label.SMS.pho.filed":`電話項目`,
"message.serviceabsence.violation":`割り当て時間の違反：この時間帯は欠席レコードと一致していません`,
"label.forecast.settings.type.clist":`商品ファミリの使用`,
"label.state.noend":`未完了`,
"label.sourcetemp":`ソース`,
"vue_label_chatter_name_link":`名前とリンクを記入してください`,
"label.emailobject.attach":`ファイルの添付`,
"label.everyother":`毎に`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`まだチャットアカウントを有効化していません。今すぐしますか。`,
"pagecreator_layout_button_delete":`レイアウトの削除`,
"label.transfer.temporarily":`転用`,
"label.service.dispatchingUnits.search.services":`サービスの予約の検索`,
"customer.message.fail.chat":`メッセージレコードの取得に失敗しました、管理者に問い合わせてください`,
"label.apiname.toolong":`Api名は長すぎます`,
"label.empty.filter":`クリアフィルター`,
"label_tabpage_personalCenterz":`個人センター`,
"label.minutes":`分`,
"label.multipleactivity.atasks":`ToDo`,
"label_tabpage_deleteview":`ビューの削除`,
"pagecreator_layout_message_save_success":`レイアウトの保存に成功しました`,
"label.reportlineorder":`レポートリスクの順番`,
"label.total.forecast.have.priority":`のいずれの予測優先、その他の部下の予測優先を受取ります`,
"label.custom.quarter.subtitle":`カスタム四半期`,
"label.icon.79":`印刷する`,
"label.hiddenoperate":`アクションの非表示`,
"label.project.hit.six":`タスクアサインメントのお知らせ`,
"label.visualpageaction.errordesc":`当該アクションを執行する権限はありません。アクセスが必要があれば、レコードの所有者あるいは管理者に連絡してください。`,
"label.chat.unmute":`通知の鳴動制限を解除`,
"label.zhaiyao":`フィード`,
"vue_label_commonobjects_detail_bcc":`BCC`,
"label.customcomponent.page.index.table.version":`APIバージョン`,
"UG.quota.06":`見積もりの作成`,
"label.icon.152":`ロボット`,
"label.partnerCloud.partnerAccount.account":`ユーザー名`,
"label.file.sharewith":`共有者`,
"label.data.dataexptemplate.desc2":`2、パック形式は2種類に分けています。1つは自動的にパックファイルの暗証番号を生成します。自動的に生成された暗証番号はデータのエクスポートが完了した後に、ユーザのメールボックスに送信されます。もう1つは手動でパックファイルの暗証番号を入力します。手動で入力した暗証番号はユーザのメールボックスに送信されないため、ユーザはしっかりと覚えなければなりません。入力しない場合、パスワードがないと認識されます。`,
"vue_label_dashboard_newfoldersuccessfully":`新規フォルダの作成に成功しました`,
"label.campaignmember.main.importmember":`キャンペーンメンバーの一括インポート`,
"label.htyj.completed":`完了済み`,
"label.reportTypeLabel":`レポートの表示ラベル`,
"label.customer.tab.label":`タブの表示ラベル`,
"label.dashboard.component":`コンポーネント`,
"label.safetystatement.dialog":`セキュリティに関する声明（新規ウィンドウ）`,
"label.forecast.settings.data":`予測日付`,
"label.knowledgebase.modifiedby":`修正方法`,
"label.batchadd.remark":`複数のレコードを追加することができます`,
"button.partner.delete":`削除`,
"Pagelayout_Setup_005":`名前は最初の位置に置かないといけません`,
"label.forecast.edit.wcpxl":`商品ファミリなし`,
"lable.PowerProcess.seq.input":`順番を入力してください。`,
"pagecreator.layout.message.delete.fail":`レイアウト削除に失敗しました`,
"label.emailobject.edit":`編集`,
"label.weixin.million":`万元`,
"setup.mainpage.button.manageobject":`オブジェクト管理`,
"label.weixin.participants.perfect.information":`参加者は情報の改善が必要ですか`,
"vue_label_campaign_campaign_members":`キャンペーンメンバーの追加`,
"label.ccchat.person.invite.emplaceholder":`メードアドレスを入力し、セミコロンで仕切ってください。`,
"label.mobile.phone.new":`新規`,
"font-evaluate-module-v1-small-program-evaluation-settings":`ミニプログラムの評価設定`,
"UG.opportunity.005":`複数の販売プロセス`,
"vue_label_report_polymerization":`アグリゲート`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`第{0}行の条件にエラーが発生し、項目種別は一致していません。`,
"label.knowledgebase.delete.draft":`ドラフトの削除？`,
"label.mr.descreption.condition3":`ルール‐完全一致ですか。当該オプションをチェックして、項目の同じデータにより重複データを検索します。当該オプションをチェックした後に、前の文字により入力するのは無効になります。`,
"Lead.Auto.Scoring.Setting":`リードスコアリングの設定`,
"label.marketing.channel.default":`マーケティングチャネル（デフォルトで有効）`,
"front-project-module-v1-select-projecttemplate":`プロジェクトテンプレートの選択`,
"front-email-payment-select-area":`地区を入力してください。`,
"lable.PowerProcess.message":`エンタイトルメントプロセスの情報`,
"label.weixin.free.get.captcha":`無料で確認コードを獲得します`,
"label.projectManagement.please.select.task.or.question":`ToDo/課題を選択してください`,
"label.pacific.daylight.time":`太平洋夏時間`,
"label.sendsms.batch.step1.introduce":`以下のビューの1つを選択（当該メールの受信者を含む）`,
"label.same.analyze.account.name":`取引先名`,
"Homepage.Contract.FieldMissed.DoesntSupport":`契約オブジェクトに "qdrq "と "htje "の項目が見つからないため、データを表示することができません。`,
"label.partnerCloud.orderingPlatform.noProduct":`本製品の製品オプションの設定は必要ありません。`,
"label.totalsummary":`積み上げ集計`,
"label.partner.workspace.tab":`タブ`,
"label.entitlement.process.name.unique":`この名前はすでに存在しています。再入力してください。`,
"report.label.norole":`権限がないので、管理者に連絡してください。`,
"label.password.old.error":`現在のパスワードは不正解です`,
"lable.account.quarter.stadate":`四半期決算の開始日`,
"label.salescloud.contactrole.choose.correct":`重複取引先を選択しました。修正してください。`,
"label.schedulejob.setup.schedule.day":`日`,
"label.communalusergroup":`公開ユーザチーム`,
"label.Display.Fields":`サービス予約リストで表示する項目`,
"label.marketsea":`プール`,
"label_partner_setup_address":`パートナークラウドのアドレス`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`データエクスポートとテンプレートの作成`,
"label.pc.ui.2018":`縦メニュー`,
"label.version.free":`無料版`,
"label.dataimport.contact.length":`エラー：取引先名は長すぎます。`,
"label.cy.vlidate":`通貨種別を有効化すると変更できませんが、通貨種別管理機能を有効化しますか。`,
"label.recycle.all":`すべてのゴミ箱`,
"label.message.changeaccount.isnot":`取引先責任者はパートナークラウドユーザを有効化しており、ユーザ情報を修正することができません`,
"label.searchlayout.exactsearch":`メッセージ：検索項目の後方のチェックボックスにチェックを入れると、この項目は正確に検索されます。`,
"label.file.size.limit":`ご注意：ファイルサイズは10Mまでです`,
"label.mobileapp.modelsetting1":`モバイル端末の推薦機能モジュールの設定`,
"template.report.overall.sales.opportunities":`全体の販売期間（オポチュニティタイプ別）`,
"label.password.update.success":`パスワードの変更は成功しました。`,
"label.import.page3.gobackhome":`ホームに戻る`,
"label.phone":`電話`,
"label.detail.vlidaterule":`入力規則を表示`,
"label.weixin.input.usernames":`ユーザ名をご入力ください`,
"label.icon.85":`変成器`,
"vue_label_systemSettings_partner":`パートナー`,
"label.processsetting.new.process":`新規プロセス`,
"Lead_Scoring_Setting_Rule_Setup_01":`リードのスコアリングルールリスト`,
"setup.layout.component.area":`エリア`,
"label.createnewpwdinformuser":`新しいパスワードを生成して、すぐユーザにお知らせします。`,
"label.pwinfo":`パスワード情報`,
"label.imgfield.type.url":`画像の参照`,
"label.attendance.sxccheckincy":`キャンペーンメンバーのサインイン`,
"lable.PowerProcess.condition.input":`条件を選択してください。`,
"label.partnerCloud.partnerAccount.topUpFailure":`トップアップフィアルド`,
"label.document.size.too.long":`フォルダは大きすぎます`,
"label.link":`リンクにアクセス`,
"label.partnerproduct.sort.repeat":`製品ファミリーの名前を取ります。`,
"label.data.setok.e_desc2":`データエクスポートのリスクページ`,
"front-project-module-v1-plase-input-project-name":`プロジェクト名を入力してください`,
"label.export":`エクスポート`,
"label.icon.45":`ボイラー`,
"label.autoRegister.changepwd.title":`登録パスワードを設定してください`,
"label_clear_adjust":`調整の取消し`,
"front-kefu-moudle-return-visit":`レビュー`,
"label.ems.compose":`メールの作成`,
"Pagelayout_Setup_002":`すでに3つの関連リストを選択しましたが、再度選択するとページのレイアウトに影響を与えます。`,
"label.service.gantt.skill.screening":`スキルフィルターの使用`,
"label.partnerCloud.basicSetting.enable":`パートナークラウドが停止されます。あなたの組織でのログインと編集のアクションは、システムによって自動的にオフになります。`,
"label.workbanch.setup.description":`私のワークベンチで以下のビューが表示されるかどうか、設定することができます。`,
"label.category.1":`すべて`,
"label.foldername":`フォルダ名`,
"label.forecast.settings.shuliang":`予測数値`,
"label.emailmerge.newtemplate.word":`wordフォルダをアップロードしてください`,
"message.error.type":`タイプを空にしてはいけません。パブリックタイプかパーソナルプライベートを転送する必要です。`,
"label.manualallocation":`手動で割り当てる`,
"label.addattachment.step2":`ステップ3.「ファイルのアップロード」をクリックして、ファイルをアップロードします。`,
"label.company":`会社`,
"label_emailsync_status_export":`Excel_csv形式のファイルとしてエクスポートします`,
"label.eventreminder":`行動のリマインダー`,
"label.emailtemplate.lookup":`メールテンプレートを表示`,
"label.customsetting.touse.getCustomSetting":`[階層]種別のカスタマ設定データを検索し、対応するapiNameと権限（idはプロファイルidあるいはユーザid）の個別データマップを返します。`,
"label.projectManagement.Resourceuse":`リソースの利用`,
"label.appointment.wizard.subtitle4":`バッファーと時間の設定`,
"label.donot.close.your.browser":`このプロセスで、その他のリンクをクリックし、またはWebブラウザを閉めないでください。`,
"label.multilang.customforcast.target":`{0}の目標`,
"setup_layout_label_newarea":`新規エリア`,
"component.timeline.button.more":`より多くのステップ`,
"label.appointmentdetail.wizard.title3":`持続時間`,
"label.help.new.features.pc":`PC端末の新しい機能の操作ガイド`,
"label.mr.record":`レコード`,
"label.trigger.wgd":`ファイリングされないトリガー`,
"label.icon.72":`ツールボックス`,
"setup.layout.label.detailpage":`詳細ページ`,
"frame.personinfo.label.usethisimage":`アプリの周辺にこのサムネイル画像のバリエーションを使用します。`,
"label.multilingual.confirm.open":`本当に有効にしていますか？有効にすると、多言語での使用が可能になります。`,
"label.recordcreater":`作成者のレコード`,
"label.afterfinish":`完了した後に、保存&新規をクリックして、より多いカスタマ項目を作成します。作成が完了したら、保存をクリックしてください。`,
"label.companyinformation":`会社情報`,
"step1":`ステップ1`,
"label.sales.page.dashboard.add":`ホームページのダッシュボードを追加`,
"label.processsetting.process.enabled.failed":`プロセスの削除に失敗しました。`,
"label.document.history.date":`日付`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`すべてのユーザーがこのフォルダーにアクセスできます`,
"april":`四月`,
"label_emailsync_form_disconnect":`関連付けの解除`,
"label.appointment.wizard.subtitle4-2-6":`2日間`,
"vue_label_notice_follow_success":`フォローした`,
"label.startuploadfile.success":`[アップロードを開始]をクリックして、プログレスバーは100%まで表示されると、ファイルのアップロードが成功したことが分かり、また上記エリアで消えてきます。`,
"message.accesstoken.acquisition.failed":`アクセストークンの取得に失敗しました。`,
"label.quickbooks.fieldlabel.fistname":`名`,
"label.appointment.wizard.subtitle1-5":`1時間`,
"2018UI.Homepage.DataNoAccess.Info":`このレコードにアクセスする権限がありません。クリックして前のステップに戻ってください。`,
"label.batchaddattachments":`ファイルの一括追加`,
"label.ems.next":`次のステップ`,
"label.quote.zhekou":`割引`,
"lable.product.notdel":`の削除、その他の価格表のレコードと関連付けられています。関連レコードは以下通りです。`,
"label.ems.action":`アクション`,
"message.error.chart.type":`図表種別は空であってはいけません`,
"label.conditiontag.lookup.value":`値`,
"label.chatter.allactivity":`すべての活動`,
"label.summaryreport":`集計レポート`,
"label.textmessage.vonage.action":`アクション`,
"label.ccpeak.must.result":`必ずasを使って、結果からフェッチしなければなりません`,
"label.data.newtemplate.savetemp.desc":`うまく使用するために、テンプレート名とテンプレート説明をきちんと記入してください。`,
"label.projectManagement.search.for.users":`ユーザーの検索`,
"component.milestones.label.title":`マイルストーン`,
"vue_label_applauncher_description_accountpool":`取引先プールを使うことで、組織内のフォロー状況を簡単に管理し、成約できるように担当者のモチベーションを高めます。`,
"label.import.index.startimport":`インポート開始`,
"page.field.masterinput2":`マスター/ディテール入力`,
"label.mobile.change.owner.permission":`新規所有者はこの種別のレコードに対する読み取り権限を必ず持っています。`,
"label_partner_common_enable":`パートナークラウドの公有化`,
"label.log.browser":`ブラウザー`,
"label.app.step4":`ステップ 4. タブの選択`,
"lable.quote.syncing.opportunity":`商談`,
"label.forecast.customforecast.foredis.jqz":`正確な値`,
"label.forecast.forecastroleuserpage.title":`予測マネージャーの割り当て`,
"label.starting.quarter":`スターティングクォーター`,
"label-combination-record":`レコード{index}。`,
"label.here":`ここ`,
"label.weixin.underfind.error":`知らないエラー`,
"label.cloudccclass.list.tip.time":`開発者はCloudcc.com プラットフォームでケジュール済みプロシージャに使うスケジュール済みクラスを開発することが許可されます。`,
"label.data.setok.t_desc1":`当該テンプレートでデータをエクスポートするなら、クリックしてください。`,
"label.service.gantt.break.rules":`ルール違反`,
"label.weixin.no.pending.ywjh.qin":`これからの30日に商談データがありません`,
"label.view.atleastone":`選択リストには少なくとも1つの値があります`,
"label.attendance.sxccheckin":`キャンペーンのサインイン`,
"label.custom.split":`スプリット`,
"front-kefu-moudle-v1-yesorno-delete-templete":`このテンプレートを削除してよろしいですか？`,
"label_chatter_theme":`トピック`,
"label.partner.new.step1":`ステップ1.好きなテンプレートの選択`,
"vue_label_commonobjects_view_settings":`看板ビューの設定`,
"UG_Contract_02":`契約は各当事者よる合意です。多くの会社は契約を通じて他社との業務条項を定義します。 CloudCC では、取引先と商談の既存契約を作成し、これにフォルダを提供します。また承認プロセスを通じて契約をフォローし、ワークフローの通知を利用して、契約の期限を知らせます。`,
"label.setup.mobilesetup.isenableh5newandedit":`モバイル端末はH5の新規編集を有効化しますか。`,
"label.attendance.edit":`勤怠の修正`,
"label.service.miniProgram.fillImageLink":`カルーセルのリンクを記入してください。`,
"label.b.c.without":`Bレコードには関連Cレコードがある場合とない場合があります。`,
"label.sso.key":`承認コード`,
"label.star_click":`クリックしてクリアします`,
"vue_label_SMS_name_or_phone_number_lookup":`レコード名の検索`,
"label.case.copre.text":`また、自社専用のWebポータルのQRコードをダウンロードしてWebサイトや端末に設置すると、お客様はQRコードを読み取ってWeb版の顧客ポータルを利用することができます。`,
"label.salescloud.forbidden.confirm":`チームセリングの使用禁止を続けますか。`,
"vue_label_chat_conformactivation":`有効化の確認`,
"label.emailtocloudcc.redmessage9":`データベースがエラーで、管理者に連絡してください。`,
"label.sahreto":`共有先`,
"label.recordtype.sort":`レコードタイプは保存の順番に基づき、表示されます`,
"label.allreport":`すべてのレポート`,
"front-gantt-module-drag-and-drop-subtask":`ドラッグ（タスクに入れる）すると、サブタスクとして作成されます`,
"label.permission.objlist.nopermission":`アクセス権限なし`,
"label_file_num":`数値`,
"chatter.mostword":`最大500文字まで入力でき、削除した後に発表してください。`,
"label.h5.chatter.comment":`コメントのテキスト`,
"vue_label_calendar_notice_havecreated":`カレンダーをすでに作成しました。`,
"label.tabpage.loadz":`ページがアップロードしており、お待ちください...`,
"chatter.w.p":`会社電話`,
"label.chat.topic.name.desc":`トピックスの英字と間隔のみ修正できます。`,
"label_partner_template_name":`テンプレート名`,
"label.mobile.phone.required.examines.people":`レビュー者は必須項目`,
"message.error.view.notexists":`ビューは存在しません。ビューは他の人に修正されるかもしれません。<a hrefをクリックしてください。`,
"label.custom_time":`カスタムタイム`,
"label_partner_workspace_member_all":`すべて`,
"lable.custom.year.name":`カスタム年度の名前`,
"label.account.previous.M":`先月`,
"vue_label_commonobjects_detail_locking":`ロック`,
"label.brief.lead":`リード`,
"label.linkedin.setting.appsecret":`暗号化キー（パスワード）`,
"label.query.detail.closepartner":`パートナーの使用を禁止`,
"label.isEnableVisualpage_new.rightlist":`有効になっているカスタムページ`,
"front-epwechat-module-v1-unbound-item3":` 許可された情報のデータ`,
"label.exchange.sync.setting.info":`Microsoft© Exchange で、ユーザーにシミュレーションができるサービスアカウントを設定した後、サービスアカウントの証拠を入力し、CloudCC とExchange サーバの通信を許可します。サービスアカウントの証拠を保存しても、ユーザーがレコードをまだ同期できない場合、Exchange Syncを正しく設定するように確認してください。`,
"label.emailobject.groupemail.fail.title":`CloudCC一括送信で送信失敗のメールボックス`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`各レベルの割引を編集する際の上限値は、下限値よりも大きくしなければならない。`,
"label.visualpage.list.vpname":`カスタムページ名`,
"label.mask.length.error.message":`暗号化テキスト項目は255文字を超えてはいけません`,
"label.h5.approval.actorname":`発起人`,
"label.knowledgebase.view.translation":`翻訳を見る`,
"label.ems.edit":`編集`,
"vue_label_commonobjects_view_reset_width":`列幅のリセット`,
"label.version.feature.controllist":`機能コントロールリスク`,
"label.setuppagelayout":`ページレイアウト`,
"vue_label_commonobjects_view_new_view":`新着情報`,
"label_tabpage_queuez":`キュー`,
"label.direct.dashboard.wait.me.approval":`私に承認されるプロジェクト`,
"message.report.error.noRelatedField":`レポートに関連項目がありません。削除される可能性があるため、システム管理者に連絡してください。`,
"label.ccchat.person.invite.notme":`自分のメールアドレスに案内状を送ることができません。`,
"label.weixin.jieduan.finish":`現在の段階にマ完了済みのマークが付いています`,
"vue_label_commonobjects_detail_?enter_subject":`件名を入力してください`,
"label_starting_month":`開始月`,
"label.address_linetwo":`アドレスライン2`,
"message.error.select.contiguous.item":`選択した関連先はすでに`,
"vue_label_pricebook_enterbookname":`価格表の名称を入力してください`,
"label.cycleworkflowoperate":`周期性ベースのアクション`,
"label.ems.withoneday":`当日`,
"component.todaytask.label.notask":`今日は期限切れのToDoがありません。どうぞコーヒーを飲んでください。`,
"label.tianyancha.id":`会社ID`,
"label.user.illegal.login":`無効なログイン`,
"label.withgathercondition":`集計条件に基づく`,
"label.foldervisitlimit":`アクセス権`,
"label.ccchat.search.conversation":`この会話を検索`,
"lable.annual.project.report":`本年度のプロジェクト収支報告`,
"template.chart.qzkhzhfx":`リードコンバージョン分析`,
"label.my":`私の`,
"label.sendsms.batch.chosetemplate":`SMSの一括送信：テンプレートの選択あるいはSMS内容の編集`,
"label.callcenter.enterprise.number":`エンタープライズNo.`,
"label_last_modified_by_time":`最終の修正者と時間`,
"message.fieldtrack.operaterecord":`<b>operatefield</b>を<b>operateold</b>から<b>operatenew</b>に更新`,
"label.mobile.more.openin":`開く方法`,
"label.multilingual.tip2":`マルチランゲージを有効にしたり無効にしたりすることができます。`,
"label.datamanage.lead.novalue":`ご注意：今回のインポートアクションは[リード名]項目に割り当てないため、取引先責任者レコードはインポートされることができません。`,
"label.custom.revoke":`Undo`,
"label_chatter_leaveword":`コメント`,
"vue_label_ccchat_group_deletedgroup":`グループは削除済みです`,
"label.tabpage.operationz":`項目、アクションは空にしてはいけません`,
"label.user.organization.permit.overdue":`組織ライセンスは期限切れになりました。管理者に連絡してください。`,
"label.log.datetimeoruser.value":`検索時間とユーザ名を入力してください`,
"lable.product.stsp.noavailable":`使用可能な標準価格はありません`,
"label.appservice.cannot.delete.app":`カスタマアプリケーションを削除することができません。あるプリファイルは当該カスタマアプリケーションをデフォルトアプリケーションとしています。`,
"component.event.label.newevent":`新規行動`,
"label.view.sortview.exportview":`ビューをエクスポート
`,
"label.uploadfilemaxsize":`ファイルの最大アップロードサイズは`,
"label.event.weekview":`週のビュー`,
"label.conversion_rate":`コンバージョン率`,
"label.partnerCloud.partnerAccount.useWechat":`決済にはWeChat scanを使用します。`,
"UG_Forcast_05":`予測の設定：ステップ{0}/{1}`,
"label.service.gantt.jobresour":`ワークリソースのみの表示`,
"vue_label_campaign_fromopprotunities":`ソース{dsrjine} 件の商談`,
"label.app.skyblue":`ブルー`,
"label.chinacloudcc":`中国クラウドコンピューティング`,
"label.connectOtherFinalNumber":`オブジェクトの上限に達しました。/最大4つまでのオブジェクトをカスタマレポートに関連付けすることができます。`,
"label.redistributionrequest":`再割り当ての承認申請`,
"label.knowledge.category.button.one":`サブカテゴリーの追加`,
"label.campagin.pcandmo":`PCとモバイル端末`,
"label.project.milestone.date":`マイルストーンの日付は、属するプロジェクトの日付範囲内でなければなりません。`,
"assetbom.transfer.notpermission":`アセットBOMを移行する権限がありません。管理者に連絡してください。`,
"label.marketing.setting1":`キャンペーン販売チャンネル`,
"label.select.file":`ファイルの選択`,
"message.error.object.contactadministrators":`システムが異常ですので、システム管理者にお問い合わせください。`,
"label.custom.quarter.title":`カスタム四半期`,
"label.knowledge.case.settings":`ケースの設定`,
"front-service-cloud-transfer-title":`トランスファー アセット BOM オーナー`,
"label.group.search.searchthisfeed":`検索内容を入力してください`,
"label.report.action.addtodashboard5":`新しいダッシュボードの追加`,
"label.mobile.side.tab.remark2":`スライダーを設定するとき、最もよく使われるオプションを前に置きます。通話記録やメニューはCloudCCのモバイル端末とAndroidシステムのみ使用できます。`,
"contain":`含む`,
"label.select.template":`テンプレートを選択`,
"label.addattachment.step3.weixin":`ステップ3.［完了］ボタンをクリックして、前のページに戻る`,
"lable.Order.successfully":`アセットへの注文を成功させる。`,
"label.user.title":`職務`,
"label.weixin.check.agreement":`関連協議をチェック`,
"label.SMS.pfi":`電話番号項目`,
"label.weixin.micro.research":`Micro research`,
"label.projectManagement.assigned.work":`割り当てられた仕事`,
"label.document.login.error":`ログインにエラーが発生し、改めて試してください。`,
"label.mobile.phone.examines.people":`レビュー者`,
"label.safetyset":`セキュリティの設定`,
"label_function_tip":`中国本土のユーザーはこの機能を利用することができません。ご理解ください。`,
"label.app.sort":`アプリケーションの並び替え`,
"component.sendmail.label.cc":`CC`,
"label.titlename":`タイトル`,
"label.event.moveup.3day":`3日`,
"label.condition":`条件`,
"label.description.message":`説明文字は500を超えてはいけません`,
"label.ems.detailedsettings":`詳細配置`,
"label.repeat.condition.field.prompt":`「文字の長さに基づく」項目に数字を記入してください。`,
"label.validate.function.funcExplain.OR":`すべてのパラメータはTUREであるかどうかチェックし、TUREあるいはFALSEを返します。すべてのパラメータはFALSEであるとき、FALSEを返します。`,
"label.salecommit.allow.prediction.query":`[設定]>[私の個人情報]>[個人情報]で[予測を許可]をチェックしていないため、販売承諾ボードを参照することができません。`,
"front-kefu-moudle-soft-phone":`ソフトフォン`,
"label.view":`ビュー`,
"front-gantt-module-quick-create-task":`タスクを素早く作成`,
"label.all_forms":`すべてのフォーム`,
"front-lightning-module-v1-dashborad-statistical-dimension":`統計的次元`,
"label.forecast.settings.data.chanpin":`商品日付`,
"label.appointment.wizard.subtitle4-2-7":`3日間`,
"front-web-module-v1-detail-comment-please":`フィードバックを入力してください`,
"label_chatter_nextSevenday":`これからの7日`,
"homepage.components.desctiption":`当該ページでは、ホームページで表示されるコンポーネントの作成と編集が許可されます。`,
"label.customcomponent.page.index.table.namespace":`名前空間接頭辞`,
"label_emailtocloudcc_exists":`メールアドレスはすでに存在しています`,
"label_tabpage_save":`保存`,
"label.mergeRechecking":`チェックの複製とマージ`,
"vue_label_helpcenter_view2":`分割画面表示では、各データの詳細情報の表示に素早く切り替えることができます。<br> 3.売上データの迅速な分析<br>ビューの右上では、ビュー内のチャートを開き、ビュー内のデータの簡単な視覚的分析を行うことができます。同時に、ビューのデータに関連するダッシュボードやレポートリストを表示して、さらなる分析を行うことができます。<br>右上のチャートボタンをクリックすると、ビューデータで作成されたシンプルなチャートを表示、作成、編集したり、現在のビューに関連するダッシュボードを表示することができます。<br> Step 1: 右上のチャートボタンをクリックすると、ページ上にチャートが展開されます。権限に応じて既存のチャートを表示・管理したり、ビューデータに関連するダッシュボードの一覧を表示したりすることができます。<br> ステップ2：「設定」ボタンをクリックすると、権限に応じてチャートの作成、編集、削除ができます。縦列チャート、横列チャート、円グラフ、ファネルチャートの四種類のチャートを作成することができます。<br>レポートボタンをクリックすると、現在のビューに関連するレポートが表示されます。<br> 4.ビューでデータを管理する<br>ビューでは、自分の権限に応じて、ビューの右上、または各データの横にあるボタンから、データの追加、編集、削除、所有者の変更ができます。<br>タグを使って、データ管理をサポートします。右側のボタンでタグ管理リストを展開すると、タグに基づいてビューのデータをフィルタリングすることができます。「タグの管理」をクリックした後、タグライブラリを維持・管理することもできます。データを選択した後、右上の「タグの追加」ボタンを使って、データにタグを一括追加することができます。`,
"label.app.ismobile":`モバイル表示に応用`,
"chatter.group.changeTheGroupPicture":`チームアバターの更新`,
"label.mr.descreption.reDataList2":`レコードで検索された条件を満たした重複データ（件）`,
"vue_label_chatter_agree_join":`加入の同意`,
"label.planned.nextrun":`次回計画の運行`,
"Homepage.News.003":`取引先データがないので、ニュースは表示できません。新規取引先を作成すると、ここで取引ニュースが表示されます。`,
"label.summaryreport.selectpictype":`図表種別とその他の図表オプションを選択`,
"label.app":`アプリケーション`,
"label.trigger.name":`トリガー名`,
"vue_label_email_private_template":`プライベートテンプレート`,
"label.appointmentpage.wizard.subtitle1":`日付と時間を選んでください。招待者のタイムゾーンは{0}です`,
"label.partnerCloud.orderingPlatform.payment":`注文決済`,
"label.stdashbord.xsld.title":`セールスファネル`,
"vue_label_pool_poolname":`プール名`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`サービスアポイントメント分布図`,
"front-lightning-module-v1-dashborad-target-value":`目標値`,
"label.reportsSubscriptionPage.email.keywords":`キーワード入力して検索`,
"label.appointmentconfirmail.wizard.subtitle1":`行動の名前`,
"label.limited_scanning":`入場券は、会場での登録のためのスキャンのみとなります。`,
"label.weixin.nomore":`もうないです`,
"february":`二月`,
"label.view.filterbyowner":`所有者別に絞り込み`,
"label.contentType":`フォルダ拡張子`,
"label.customobjdel.master.hsiang":`オブジェクトの主な詳細リレーション項目は削除できません。`,
"lable.Removal.succeeded":`正常に削除されました。`,
"label.weixin.end.incorrect":`終了日付の表示形式は不正確です。`,
"label.email.cc.recipients":`CCの宛先`,
"label.taskevent.list":`ToDO&行動のリスト`,
"label.formula":`数式`,
"label.h5.new.errorheader":`このページのエラーをチェックします`,
"label.emailobject.template.private":`プライベート`,
"label.visualpage.component.n4":`4.変数　引用符なしで直接的に変数を使用することができます。`,
"label.newemailnotice.step1":`ステップ1.オブジェクトを選択します`,
"label.chatter.file":`ファイル`,
"vue_label_checkduplicate_rules":`重複チェックルールの設定`,
"label.appointment.wizard.subtitle1-6":`1.5時間`,
"label.customReportType":`カスタマレポートタイプ`,
"vue_label_email_with_accessories":`添付ファイル付き電子メール`,
"label_efine_assessment_cycle":`審査期間を定義する`,
"label_emailtocloudcc_button_sure":`確認`,
"label.forecast.userenablepage.isusing":`有効になっているユーザ`,
"lable.goal.description":`目標の説明`,
"message.error.serviceresource.relatedrecordid":`各ユーザは1つの｛0｝タイプのサービスリソースだけに追加することができます`,
"label.weixin.addbus.information":`車両情報の追加`,
"label.emailtocloudcc.button.view":`ビュー`,
"label.detail.workflow":`ワークフローを表示`,
"label.standardfilter":`標準条件`,
"label.mobile.phone.results":`業績`,
"chatter.feed.unavailabled":`有効になっていません`,
"label.view.sortview":`ビューのソーティング`,
"label.availabilityobject.wizard.title":`有効時間`,
"Main_Menu_Mobiledownload":`に使う`,
"chatter.sticker":`追跡済み`,
"label.workflow.intruduce":`ワークフロールールを作成することにより、組織のワークフローを設定します。各ワークフロールールは、次の要素から構成されます。`,
"label.customfields.richtext.tip":`ユーザに、書式設定済みテキストの入力、画像とリンクの追加を許可します。`,
"label.new.cy.select":`選択リストから新しい通貨種別を選択`,
"template.chart.schdzqzkhzhqk":`キャンペーンでのリードコンバージョン`,
"label.forecast.customforecast.cpxl":`商品ファミリ`,
"front-electronic-signature-open-service":`Esignatureを有効にする`,
"label.datamanage.import.field":`項目のインポート`,
"chatter.email.sendMessageToMe":`メッセージを自分に送信するとき`,
"message.cannotusebefore":`有効化されるまで、この承認プロセスを使用できません。`,
"label.textmessage.vonage.api.secret":`APIシークレット`,
"label_chatter_newEvent":`新規行動`,
"label.ji.year":`{a}年`,
"label.sendmail.step2":`ステップ2：メールテンプレートの選択`,
"label.console.step5.record":`レコードを開く`,
"label.customfields.totalsummary.gettogetherfield.isnull":`アグリゲーターする項目を選択してください`,
"vue_label_commonobjects_detail_current_recorder":`新規所有者はこのプロジェクトに関連するレコードの所有者にもなりますが、これらの記録は既存記録者が所有しています`,
"label.SMS":`SMSアラート`,
"label.reconfigure.bundle":`パッケージの再構成`,
"front-kefu-select-region":`インスタンスが設置されているエリアを選択してください`,
"chatter.feed.deletefeeds":`確かにこの投稿及びコメントを削除しますか`,
"label.customsetting.manage.introduce.h":`カスタマが階層として設定されると、ユーザ、プロファイルにデータを追加することができます。`,
"label.product.name":`商品名称`,
"vue_label_commonobjects_view_saveas":`名前を付けて保存`,
"label.group.my.archived":`私のファイリングしたチーム`,
"vue_label_pool_coflictmethods":`既存の販売方式に抵触する`,
"label.appupload.upload":`パッケージのアップロード`,
"lable.SalesCommitmentKanBan.signedTaskRate":`契約の目標額`,
"label.dashboardStandard":`標準ダッシュボード`,
"label.niboer.time":`ネパール時間`,
"label.emailtocloudcc.filed.email":`電子メール`,
"market.name.social.post":`ソーシャルポスト`,
"evaluation.detail.notfound":`コメントの詳細が見つかりません`,
"label.layoutoftestobj":`テストオブジェクト　レイアウト`,
"label.example":`例`,
"label.campaign.channel.step6.remark6":`ここにアクセスしてください`,
"chatter.emailLike":`好き`,
"label.knowledge.category.button.two":`カテゴリの編集`,
"label.alluser":`すべてのユーザ`,
"addadvancedconditions":`高度なオプションの追加`,
"message.selectgsummarycondition":`集計条件を選択してください`,
"message.duplication.label.sectionremar2":`ご注意：関連レコードが含むメモ、ファイルと活動は新しくマージされるレコードに関連づけられています。`,
"vue_label_helpcenter_product&pricebook":`製品は、販売するすべてのアイテムやサービスとその標準価格を掲載した基本的なカタログです。価格表は、特定のユーザー向けに製品と関連するリスト価格のカスタマイズされたコレクションを作成することができます。`,
"message.duplication.label.isprofile":`権限を通過しますか`,
"component_setup_label_milestonesfield":`里程標項目`,
"setup_layout_label_required":`必須項目`,
"component_chatter_label_title":`新規の書き込み`,
"label.assignment.setup.detail.order":`番号`,
"vue_label_pool_unassigned":`未割当て`,
"UG_Lead_007":`Google同期`,
"label.knowledge.record":`関連データは存在しません`,
"label_tabpage_filetypez":`ファイル種別`,
"label.ccpeak.if.error.message":`エラーメッセージを返すなら：使用`,
"label.intialsubmitter":`初期提出者`,
"label.wei.icon":`アイコン`,
"label.mask.show.last.4":`マスクは最後の4ビットを表示します`,
"lable.PowerProcess.time.trigger":`タイムトリガー（分）`,
"july":`七月`,
"label.usestandardwizard":`標準設定ウィザードの使用`,
"label.two.quarter":`第2四半期`,
"label.size":`大きさ`,
"label.integrations.mailchimp.massage4":`Mailchimpはインストールされていません。インテグレーションでMailchimpをインストールしてください`,
"label_emailtocloudcc_step2total3":`ステップ　2/3`,
"vue_label_chat_customer_group_strategy":`取引先チーム`,
"label.searchvalue":`値の検索`,
"label.sendemail.birthday.title":`誕生日のリマインダー`,
"label.projectManagement.planned.days":`計画日数（日）`,
"label.service.gantt.workhours":`労働時間に基づく`,
"label.notification.approval5":`代理承認：【提出者】は【オブジェクト】の承認を申請しています。`,
"label.service.miniProgram.bindAddressDesc":`CloudCCスタンダートカスタマーサービスのミニプログラムのアドレス：`,
"chatter.error.wt":`エラー：ファイル種別は不正確です。`,
"vue_label_calendar_my_calendar":`私のカレンダー`,
"label.customername":`取引先名`,
"label.salescloud.salesdashboard.huikuan.rankings":`全体‐代金受取業績のランキング`,
"message.query.opportunity.contactrole.error":`商談の取引先責任者のデフォルトロールの検索に失敗し、管理者に連絡してください`,
"noequal":`一致しない`,
"label.document.searchcustominfo":`キーワードを入力して該当するドキュメントを検索してください。`,
"label.account.PreviousFQ":`前回の四半期決算`,
"label.file.f":`ファイル`,
"label.dashboard":`ダッシュボード`,
"label.report.folder":`レポートファイル`,
"batch.edit.permission.list":`データリスクを編集する権限がありません`,
"label.file.orderbyowner":`所有者に基づき並び替える`,
"label.exchange.sync.account.password":`サービスアカウントのパスワードは`,
"pagecreator.button.publish":`公表`,
"label.modify":`編集`,
"label.exchange.sync4":`状況`,
"label.remark.information":`メモ情報`,
"label.service.without.major.event":`表示する重大行動がありません`,
"label.knowledgebase.release.status":`公開状況`,
"label.tabpage.ok":`確認`,
"label_screening_assessment_content":`審査内容を絞り込む`,
"label_partner":`パートナークラウド`,
"label.user.detail":`ユーザの参照`,
"front-kefu-moudle-or-this":`それとも、こんな感じ？`,
"label.unselect.object":`選択可能なオブジェクト`,
"label.quote.contactfax":`FAX`,
"label.weixin.appmanage.alert":`{0}をクリックすると私のアプリケーションから移行できます。{1}をクリックすると私のアプリケーションに追加できます。`,
"vue_label_dashboard_thisfolder":`このフォルダにパブリックダッシュボードを追加します`,
"label.delete":`削除`,
"label.appexchange.installedpage.message1":`CloudCC.com AppExchange ページでは、開発済みのアプリケーションを参照したり、ダウンロードして、お客様の  cloudcc.com 環境に直接インストールしたりすることができます。`,
"label.mobile.phone.required.summary":`まとめは必須項目です`,
"label.batchadd.newbatchpage.addtr":`30のレコードまで追加します`,
"label.partnerCloud.partnerAccount.lockLine":`ロックされた量`,
"label.emailsync.status.connectstatus":`関連付けの状況`,
"label.campaignmember.main.importmember.lead":`メンバーのインポート‐既存のリード`,
"message.username.isnull":`ユーザ名は空であってはいけません。`,
"label.forecast.tree.enableuser":`ユーザを有効化`,
"label.multilang.view.viewmessage":`このビューはモバイル端末に応用され、最大10つまでの項目が選択できます。現在{0}件の項目を選択しました。`,
"friday":`金曜日`,
"label.sendemail.activity.neweventtitle":`新規行動の通知`,
"label.page.addtabto.user":`タブをユーザの既存個人カスタマ設定に追加します`,
"front-kefu-moudle-v1-connect-phone":`アソシエイトの電話番号`,
"label.wei.pollis":`投票先`,
"lable.opppdt.editPdt.title":`商談商品の編集`,
"label.permission.objectpermission.recordfenpei":`レコードタイプの割り当て`,
"pagecreator.layout.message.delete.success":`レイアウト削除に成功しました`,
"label.dataimport.isdupecatcher":`重複検索条件の執行`,
"label.deletelayout.tip":`ページレイアウトを削除するなら、置き換えるその他のページレイアウトを必ず選択します。`,
"label.projectManagement.No.matching.data":`該当するデータはありません。`,
"pagecreator_page_message_delete_success":`ページの削除に成功しました`,
"label_tabpage_equalz":`イコール`,
"label.ems.emailsetup":`メールの設定`,
"label.decimaldigits":`小数点以下桁数`,
"component.chatter.button.delete":`削除`,
"label.isallowreport":`レポートを許可しますか`,
"label.view.appliedMobile.message":`この選択肢をチェックしてください。ステップ3.最大6つまでの表示する項目を選択`,
"label.must.positive.integer":`正整数は必須です`,
"label.preview.print.template":`印刷テンプレートのプレビュー`,
"label.schedulejob.setup.schedule.start":`開始`,
"UG.Case.04":`ケースの割当て`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`詳細をフロート表示を有効化`,
"vue_label_email_alltemplates":`すべてのテンプレート`,
"label_report_chose_obj":`オブジェクトリレーションシップとレポートデータソースの選択`,
"label.partnerCloud.productSet.del":`アイテムの削除`,
"label.quote.shrdz":`納入先`,
"page.approval.history":`承認履歴`,
"lable.outlook.detail.prefc":`CloudCC.comを優先的に選択します`,
"label.translation.unable.display.view":`ビューの表示ができません`,
"label.encrypt.change":`暗号化項目の置換`,
"button.partner.workspace.login.logo.upload":`画像のアップロード`,
"label.batchadd.mustinput2":`のは必須項目で、必須項目は記入されないと、保存されません。`,
"label.dataimport.update.error.check":`データの更新にエラーが発生し、このデータをよくチェックしてください。`,
"label.staticresource.name.already.exists":`静的リソースの一意の名前は存在済みです。`,
"label.appupload.upload.install.success":`インストールに成功しました`,
"label.conditiontag.lookup.true":`TRUE`,
"label.quickbooks.viewlist.customer":`取引先`,
"label.field.edit.change2":`最大評価は1以上です。`,
"label.fianalrejectoperate":`最終却下アクション`,
"label.ccpeak.wgd":`ファイリングされないクラス`,
"label.reportsSubscriptionPage.condition.emailreport":`まとめ＋レポート`,
"label.detailinf":`詳細情報`,
"label.eastem.standard.time":`オーストラリア東部標準時`,
"chatter.group.manager":`管理者`,
"label.manage_columns":`ヘッダーの管理`,
"label.daylight.time":`サマータイム`,
"label.weixin.mycar.information":`私の車両情報`,
"label.ccpeak.help":`クラス　ヘルプ`,
"lable.outlook.detail.match":`一致条件を指定`,
"label.version.nonsupport.approval":`承認プロセスを暫くサポートしません`,
"label.custom-tailor":`取引先のカスタマイズ`,
"label.showoperate":`アクションの表示`,
"label.view_edit":`表示と編集`,
"label.lead.score.prompt2":`スコアリングするリードの範囲を選択し、「リードスコアリング」をクリックして、アクティブにしたスコアリングルールに基づき、選択したリードにスコアリングを実施します。`,
"label.datamanage.savetemplate.error":`テンプレートの保存に失敗しました`,
"label.source":`ソース`,
"label.multilang.customfieldsetup.reference":`この項目は{0}に参照されました`,
"chatter.poll.option7":`選択肢 7`,
"label.login.access.day":`日`,
"label.icon.66":`装置`,
"label.tabpage.kanbansetup":`ビューボードの設定`,
"label_emailtocloudcc_step1_lead2":`設定後、このメールボックスで受信したメールは、リードレコードを自動的に生成することができます。`,
"label.partnerCloud.partnerAccount.numericValue":`上乗せ額は、数値とします。`,
"label.permission.detail.app.object.tip":`アクセスオブジェクトと項目の権限及びタブの使用可能性の設定`,
"label.emailobject.template.subject":`トピックス`,
"template.report.month.customer":`今月のアカウント`,
"label.weixin.formerly":`過去`,
"label.contract":`契約`,
"label.help":`ヘルプ`,
"vue_label_homepage_setdefault":`デフォルトホームページの設定`,
"label.icon.52":`発電`,
"label.customfields.file.count":`ファイル数`,
"UG_Account_07":`取引先のインポート`,
"label.addattachment.ntko":`オンライン編集`,
"label.service.ganttBaiduMap.assign.service":`この人にサービス予約を割り当てる`,
"vue_label_file_my_file":`私のファイル`,
"label.custom.page.hide":`非表示`,
"label.addexistoperate":`既存アクションの追加`,
"label.already.startdate":`開始時刻`,
"label.partnerCloud.financeSetting.alipay":`アリペイのビジネスアカウントを開設する必要があります。受取口座としてサポートされるのはビジネスアカウントのみです。取引手数料はAlipayから受取人に請求されます。`,
"label.dashboard.summary.editPageFooter":`フッターの編集`,
"label.category.8":`消費財`,
"label.forecast.customforecast.foretype.best":`ベストケース`,
"message.validation.isnull":`値をご入力ください`,
"label.savewxpay.failure":`WeChat決済加盟店の情報の保存に失敗しました。`,
"label.file.stop.sharing.desc1":`にストップ`,
"label.opportunity.setting.showstage。read.info":`チャンスステージは、チェックを入れた後、手動で変更することはできません。`,
"UG_Campaign_003":`キャンペーンの作成`,
"label.edit.field.select.showoptions":`すべてのオプションの表示`,
"message.inputplatformpwd":`プラットフォーム管理者のパスワードを入力`,
"vue_label_systemSettings_mobel_set":`モバイルアプリのセットアップ`,
"label.projectManagement.thefirstone":`すでに最初のレコードです`,
"label.data.newtemplate":`データエクスポートテンプレートの作成`,
"label.monitorsys.delete.log":`システムの重要なアクション監査ログ`,
"label.template":`テンプレート`,
"Lead.Auto.Scoring.Setting.001":`リードの編集・保存時に自動的にスコアリングされる。（一括インポートとインターフェース作成を除く）`,
"label.operatesuccess":`アクション成功`,
"label.send":`送信`,
"chatter.yp":`書き込みを非表示`,
"label.overall_responses":`全体の反応`,
"vue_label_systemSettings_server_report":`サービスレポート`,
"label.icon.113":`家`,
"label.partnerCloud.basicSetting.domainSet":`ドメイン名の設定`,
"label.login.access.text":`サポートするためには、管理者にログインしてデータを閲覧する権限を与えることができます。`,
"vue_label_report_addrowlevelformula":`行レベルの数式の追加`,
"message.duplication.label.mergeTitle":`私のマージ`,
"label.event.add":`行動の追加`,
"vue_label_homepage_bigscreen_light":`ライト`,
"setup.chatter.enabled":`有効化されていません。管理者に連絡して書込みを有効化してください。`,
"label.inputreceiver":`通知するメールアドレスを 5 つまで入力できます。メール毎に";"を入力してください。`,
"label.custom.page.custom.page":`カスタマページ`,
"label.data.exp.csv":`CSV形式`,
"label.searchlayout.view.example":`サンプルを表示`,
"label_tabpage_fullscreenz":`フルスクリーン`,
"label.tabpage.last":`前のステップ`,
"lable.outlook.mcto.accepemail":`受信可能なメールアドレス`,
"front-electronic-signature-isopen":`アクティブ`,
"vue_label_commonobjects_detail_earlier":`もっと前のを表示`,
"label.name.cannot.greater.str":`名称は255文字を超えてはいけません`,
"label.weixin.activity.email":`活動：メール`,
"label.tabpage.unequalz":`等しくない`,
"label_calendar_year":`カレンダー年度`,
"label.appupload.upload.installor":`インストール者`,
"label.jixiaoswitchon":`パフォーマンスの展開`,
"label.user.congratulations.send.finish":`おめでとうございます。メール一括送信の申請アクションを完成しました。`,
"label.customsetting.touse.getListCustomSetting2":`[リスク]種別のカスタマ設定データを検索し、対応するapiNameとNameの個別マップを返します`,
"label.recordtype.masterrecordtype.selectedTip":`すでにレコードタイプが割り当てられているプロファイルに、マスターレコードタイプを割り当てることはできません。`,
"label.tippage.li3":`削除したレポートに基づくすべてのダッシュボードコンポーネントは無効になります。`,
"label.weixin.no.name":`トピックなし`,
"label.tabpage.viewz":`当該ビューを印刷する`,
"label.create_contacts":`連絡先リストの作成`,
"vue_label_homepage_operationitem":`ボタン操作項目を選択してください`,
"label.pc.ui.2018.switch.version":`バージョンの切り替え`,
"label.salescloud.teamrole.main":`主な取引先責任者`,
"label.reportsSubscription.format.report":`フォーマットされたレポート (Excel 形式 .xlsx)`,
"label.forecast.customforecast.total":`総額`,
"label.quickbooks.fieldlabel.lastname":`姓`,
"label.appointment.wizard.title2":`会議の詳細情報`,
"label.project.template.one":`プロジェクトテンプレートからプロジェクトを作成するには2～3分かかります。お待たせいたしました。`,
"label.timetrigger.workflow":`当該ワークフローを有効化したとき`,
"label.projectManagement.creator":`作成者`,
"label.customfields.formula.selectreturnfieldtype":`数式の返し項目を選択してください`,
"label.list.userinterface.dashboard.enable":`新規ダッシュボードコンポーネントを有効化`,
"label.email.delete.html.format":`すべてのHTML表示形式を削除しますが、確かにしますか。`,
"label.appupload.install.modifyapi":`コンフリクトがあるapi名を修正：`,
"label.chat.add.topics":`トピックの追加`,
"label.savepartner.fail":`パートナークラウド設定の保存に失敗しました。`,
"label.pc.query.new":`最新の表示`,
"message.duplication.label.editfiltertitle":`重複検索条件の編集`,
"label.task":`ToDo`,
"label.emailobject.emaildetail.title.toaddress":`送信先：`,
"label.setup.mobile.bottombutton.select":`モバイルアプリで表示させたい4つのファーストレベルページを選択する`,
"label.loginip.pagecue.invalido":`無効なInternetアドレス`,
"label_tabpage_listshow":`リスクの表示`,
"component.newrecords.label.10records":`10件のレコード`,
"label_chatter_file":`ファイル`,
"pagecreator.systemstyle.label.detailcolor":`詳細文字の色`,
"label.forecast.userenablepage.title":`予測ユーザ`,
"front-project-module-v1-actual_working_hours":`報告されたマンアワー`,
"vue_label_systemSettings_Security":`セキュリティコンテインメント`,
"label.processsetting.two.select.key.fields":`ステップ2： プロセスの各ステップでキーとなる項目を選択し、ガイダンスを行う`,
"label.page.display1":`レコード`,
"label.appointmentpage.wizard.subtitle1.2":`招待者のタイムゾーンは{0}です。`,
"label.ggReleaseRange.searchTeam":`公開グループの検索`,
"chatter.group.searchGroup":`チームの検索`,
"label_card_type":`カードタイプ`,
"label.appupload.managed.tip":`マネージドでは、あるプロパティしか編集できません`,
"label.changemyshow":`私の表示を更新`,
"label.custom.CustomQuarter":`カスタム四半期`,
"label.tobedelete":`削除するもの`,
"label.newPage.unuse":`ページはなくなりました`,
"label.product.pricebooks":`価格表`,
"label.mobile.layout":`モバイルページレイアウト`,
"label.multilang.file.items":`{0}件のオブジェクト`,
"label.app.step4.tabused":`選択されたタブ`,
"label_ccchat_create_account":`アカウントの開通`,
"message.startusingprocess":`このプロセスを有効化したら、承認プロセスの追加あるいは削除ができません。あるプロセスステップのプロパティも編集できません。確かに続きますか。`,
"vue_label_email_please_add_a_theme":`件名をほ追加してから、テンプレートとして保存してください`,
"label.please.create.a.target.record.first.":`まずはインジケーターレコードを作成してください`,
"label.processsetting.set.objandfile":`ステップ 1: プロセスを設定するオブジェクトと項目を選択する`,
"label.newreport.group.data":`グループ化（個）`,
"label.notcreatenew":`置換時に新規商談を作成しないでください。`,
"lable.custom.CurrentandPreviousCY":`現在と過去のカスタマ年度`,
"front-epwechat-module-v1-input-androidschema":`Androidスキーマを入力してください。`,
"label.projectManagement.unfinished.quantity":`未完成数`,
"label.visualpage.idandname":`ページIDと名前は`,
"label.approvingprojects":`承認待ちのプロジェクト`,
"label.partnerCloud.financeSetting.weChat":`WeChatのサービスを開始し、Tencentとの集金サービス契約が必要です。取引手数料はTencentから受取人に請求されます。`,
"label.quickbooks.viewlist.view":`表示`,
"label.knowledge.category.hint.ten":`非活性化されたカテゴリーグループ`,
"report_type_label_productPricebooks":`商品と価格表`,
"label.fenbeitong.description":`FenBeiTongの出張申請書をチェックして有効にすることで、社員の出張申請や旅費の精算をサポートします。`,
"label.ccchat.upload.change":`何の変更がありましたか。（選択可能）`,
"label.emailsync.status.log":`関連ログ`,
"label.addnew":`追加`,
"UG_contact_05":`取引先責任者の作成`,
"label.appupload.componet.queryerror":`コンポーネントの検索にエラーが発生し、システム管理者に連絡してください。`,
"label.salescloud.setting":`チームセリングの設定`,
"label.recurrencetimetriggeroperate":`周期性タイムトリガーのアクション`,
"label.event.moveup.4day":`4日`,
"No.Hisitory.Activity":`過去の活動はありません`,
"label.validate.function.funcFormat.MINUTE":`MINUTE(日付)`,
"label.recentview.seloption3":`最近更新したデータ`,
"label.login.access.nopermission":`アクセス権なし`,
"label.taskmenuandlink":`ToDoボタンとリンク`,
"label.forecast.customforecast.foredis.sbw":`数百万`,
"lable.PowerProcess.created.event":`重大行動の作成`,
"label.stdashbord.xsld.funnelchat":`セールスファネル図`,
"label.step1.total7":`ステップ　1/7`,
"label.sendsms.batch.chosepersion":`SMSの一括送信：SMSの受信者を選択`,
"Lead.Scoring.Setting.Rule.Setup.Value":`スコア`,
"label.ccdocument.isdel.folder":`このフォルダを削除しますか。`,
"label.discard_change":`はい、変更を破棄します。`,
"label.knowledgebase.assign":`アサイン`,
"PersonalInfo_LoginHistory_001":`ブラウザがメールボックスの登録リンクを検証する`,
"label.globalselect.deletedvlaue":`グローバル値セットはすでに削除されました`,
"label.ems.lookup2":`検索`,
"label.dataimport.system.unable.determine":`、システムはどれの_目がなくなったのか__できません`,
"label.weixin.invitation.consultant":`招聘されたコンサルタント`,
"label.salescloud.salesdashboard.phone.rankings":`電話ランキング`,
"label.knowledgebase.plan.release":`出版までの流れ`,
"label.integrations.first.half":`トータルで見たときの現状`,
"label.icon.123":`応急処置キット`,
"label.leadscore.isactivity":`アクティブにしますか`,
"front-epwechat-module-v1-corpid":`ウィーコムID（Corpld）`,
"label.createnewcustomer":`新規取引先を作成`,
"front-lightning-module-v1-details-page-chart-tittle":`詳細ページでは、チャートやダイアグラムのモジュールを挿入することができ、最大10個のレポートチャートを挿入することができます。例えば、AccountsオブジェクトのレコードタイプがAgentであるレコードにレポートチャートモジュールを追加し、モジュールにエージェント注文の売上金額とエージェント四半期売上レポートのチャートを追加し、アカウント名でフィルタリングしてエージェントアカウントの詳細ページで関連データを直接表示することができます。`,
"label.customobjects.fieldsrelation":`カスタム項目 & リレーション`,
"label.dashboardSetup.left":`左`,
"label.mobile.app.sectionpart":`モバイル端末セクション`,
"setup.mainpage.label.welcome25":`手順は以下の通りです。このページの左側にあるメニュー→「設定の管理」→「セキュリティコントロール」→「共有設定」をクリックする。`,
"label.custombutton.edit.error":`エラー：この名前は使用済み、その他の名前を選択してください。`,
"label.icon.48":`換気扇`,
"label.tabularreport.step2":`ステップ2：レポートの列を選択`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`二週間目`,
"UG_quota_01":`取引先の見積を管理`,
"label.customcomponent.btn.usewhere":`どこに使いますか。`,
"label.quickbooks.searchresault.email":`メール`,
"label.emailobject.appointment.urltext2":`都合の良い時間を選んでください。`,
"label.tianyancha.field.relation.error":`先ず天眼査項目とユーザ項目の対応付け関係を設定してください`,
"APPIntegration_Social_facebookerror":`有効なfacebook.comのURLでなければなりません`,
"label.notification.arketsea.transfer":`5}は{0}：{1}を{2}から{3}に移した。`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`代金受取の目標総額`,
"UG.Account.04":`取引先フィルタリング`,
"this.week":`今週`,
"label.email.track.attachment.num.control1":`アップロード中のファイルは10つを超えているため、引き続きアップロードできません。`,
"label.exchange.sync.state.event":`行動`,
"vue_label_systemSettings_websitesetting":`Webセットアップ`,
"vue_label_file_replace_reason":`置換えの理由`,
"label.version.feature":`機能`,
"E":`メール`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`通知テンプレート`,
"label.chosesubject.meet":`会議`,
"UG.ST.003":`あなたには{0}を作成する権限がないので、管理者に連絡してください。確認をクリックすると、{0}のインターフェースに直接に移動します。`,
"label.authorization.failure":`認証に失敗しました。再度認証してください。`,
"label.newprocessstep3":`ステップ3.承認者項目の指定と編集可能なプロパティのレコード`,
"lable.outlook.mcto.mostrecord":`最多の活動レコードを持っています`,
"vue_label_normal_select":`選択した`,
"label.partner.workspace.login.buttontext":`ボタンテキスト`,
"template.chart.ydschdtj":`月間キャンペーン統計`,
"label.ServiceCloud.zichanmingcheng":`資産名`,
"label.productsales.oppor.nooverdue":`いいですね。期限切れの商談がありません。`,
"label.appointment.wizard.subtitle3-5":`金曜日`,
"label.payment.the.current.version":`現在のバージョン`,
"label.reportlist.top":`トップに固定します`,
"label.emailobject.emaildetail.prompt":`メッセージ`,
"label.weixin.endst":`終了時刻は必ず開始時刻より遅いです`,
"report_label_knowcreatehighlevelreport":`高度なレポート作成に関して`,
"label.quickbooks.view.openestimates":`行われている見積`,
"label.url.cannot.empty":`URLは空であってはいけません`,
"label.emailnoticetemplate":`メールアラートのテンプレート`,
"calendar.tips.task":`今日はタスクなし`,
"label_partner_all_operate":`操作`,
"message.duplication.label.cancelbutton":`キャンセル`,
"vue_label_SMS_addcontact":`取引先責任者の追加`,
"label.martrixreport.setsumfield2":`マトリックスレポートで列を集計する項目を選択して下さい`,
"approval_request_email_body":`こんにちは、下記のプロジェクトを承認してください：\n 　　　　　下記のリンクをクリックしてください：\n`,
"label.emailobject.emaildetail.field.record":`レコード`,
"label.tab.page":`ページ`,
"label_tabpage_prepagez":`ページ毎に表示`,
"label.iran.daylight.time":`イラン標準時`,
"label.event.nextweek":`来週`,
"fliter.lastmonth":`先月`,
"label.group.no.recent.search":`一致する最近に表示したチームはありません`,
"label.h5.act.confirm":`確定`,
"label_tabpage_mypotentialcustomers":`私のリード`,
"label.tabpage.queuez":`キュー`,
"label.batch.edit.description":`編集する項目を選択してください。少なくとも1つの項目、最大で5つの項目まで選択できます。`,
"label.batchadd.newbatchpage.deltr":`少なくとも1行が保留されます`,
"label.industrialandcommercialverification.instructions2":`ご使用の_料版では、_索の最大数は1日に1万回です。_索回数を__する必要がある_合は、サ_ビスを_入することをお_めします。サ_ビスを_入した後に、ベンダ_からト_クンを取得して、このペ_ジで_定します。ベンダ_はそれに__する有料サ_ビスを提供します。`,
"label.rejectrequestbehaviour":`このステップのすべての却下アクションとすべての最終却下アクションを執行します。`,
"label.batchCopy":`バッチークローン`,
"label.service.two":`ある検索条件は定義されていますが、［高度な検索条件］に参照されていません。`,
"label.data.import.setup.detail.remark":`下記の選択肢をチェックした後、データをエクスポートするときに執行されます。`,
"vue_label_file_delete_lib":`ファイルライブラリの削除`,
"label.integerdigit":`小数点の左側の桁数`,
"label.profile.standardobjcontrol":`標準オブジェクト権限`,
"label.reportrecords":`レコード`,
"label.noplan":`7 日先までの行動予定はありません。`,
"label.visualpage.ytype":`ダッシュボード`,
"label.branch":`;`,
"label.knowledgebase.new.article":`新しい記事`,
"label.Addressbook":`連絡先`,
"label.delete.reward.groups":`見積り行グループの削除`,
"label.appexchange.uninstallpage.message1":`当該パッケージのすべてのコンポーネントを完全に削除します（事例は以下の通りです）`,
"chatter.group.everyone":`すべてのユーザ`,
"label.cooperation":`コラボレーション`,
"label.uploadfail":`アップロード失敗`,
"to":`まで`,
"button_partner_delete":`削除`,
"attachment_select_warning_001":`ファイリングされたファイルをチェックしましたが、ファイリングボタンは使用できません。改めてファイルを選択してください。`,
"label.step4.total4":`ステップ　4/4`,
"label.login.access.avalid":`今日は無効になります`,
"label.defaultview2":`デフォルトのビュー`,
"vue_label_commonobjects_detail_style":`購買スタイル`,
"label.selectfield":`項目の選択`,
"label.report.select.column.collect":`集計する列の選択`,
"lable.currencyAdv.newdaterate.existeddate":`この時間は存在済みです`,
"pagecreator_systemstyle_button_new":`スタイルの作成`,
"label.ccchat.person.invite":`同僚の招待`,
"label.sendemail.recycle.clear":`ゴミ箱を空にします`,
"label.usermanage.view.notexist":`ビューは存在しません。`,
"setup_chatter_enabled":`有効化になっていないが、管理者に連絡して書き込みを有効化してください。`,
"UG.Contract.01":`契約の管理`,
"label.martrixreport.2018.step4":`ステップ4.レポート標準の選択`,
"message.errorinscript":`シナリオの実行に問題が発生しました。`,
"label.knowledgebase.modification.date":`修正日`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`費用は最大10桁まで入力が可能です`,
"label.list.isActiveNewApproval":`新規トップページの承認ページを有効化しますか`,
"label.mobile.main.page.icon.setup":`モバイル端末のデスクトップアイコンの設定`,
"label.select.customer":`取引先の選択`,
"label.sharerule":`共有設定`,
"label.fiscal.FY":`会計年度`,
"label.appupload.component.type.customfield":`カスタマ項目`,
"label.emailobject.emailsend.sendindividually":`個別に送信します`,
"label.new_formname":`新しいフォーム名`,
"label.appointment.wizard.notif1":`終了時刻は開始時刻より早くしてはいけません`,
"front-console-conversation-evaluate-desc":`EVALUATEInfoName}からの評価応答`,
"homepage.components.lasttime":`最終更新日`,
"vue_label_commonobjects_view_chart_deletechart":`図表の削除`,
"label.multilang.document.upload.fail":`{0}個のファイルのアップロードに成功し、{1}個のファイルのアップロードに失敗しました。`,
"UG_contact_03":`同じ場所で取引先責任者をフォローする　セールスシグナル`,
"label.marketsea.istoseafromother":`他のリードプールからの置換えが許可される`,
"label.datamanage":`データ管理`,
"label.globaloperation.operationtype.create.data":`レコード作成`,
"label.customer.tab.step2.see":`タブ表示`,
"label.wtd.changefields.desc":`ユーザーがリスクを提出した後、ウェブサイトが指定した戻り先URL（「まことにありがとうございます」ページなど）を参照することができます。`,
"label.ems.eamilinfo":`メール情報`,
"label.recordtypeselect.new":`新しいレコードタイプ`,
"vue_label_report_output":`数式の出力タイプ`,
"label.emailnotice":`メールアラート`,
"label.icon.196":`トイレットペーパー`,
"label.emailsync.status.disabel":`使用禁止`,
"label.tabpage.isdeleterecord":`選択したレコードを削除しますか`,
"message.selectoneoftypes":`以下から1つの種別を選択してください`,
"label.import.index.createid":`ID作成`,
"vue_label_systemSettings_social2":`ソーシャルメディアアカウントの設定`,
"label.ccpeak.sel.time":`当該ファイルのスケジュール済みクラス`,
"label.data.downpage.i_list.desc1":`インポートするときに、データ形式が正しくない、あるいはトリガーか入力規則の校正が失敗したため、データをインポートすることができなかった場合、当該ページにCVSファイルが形成して表示されます。データをインポートすることができた場合、当該にページに表示されません。`,
"label_adjust_forecast":`予測の修正`,
"vue_label_normal_lead_sf":`リード`,
"vue_label_report_notice1":`レポートには保存されていない変更が含まれています。レポートを閉じると、これらの変更は失われます。下記の「保存して閉じる」ボタンをクリックして、変更内容を保存してください。`,
"label.notfiledpublicreport":`ファイリングされていない公開レポート`,
"one":`一`,
"UG.Lead.008":`名刺のスキャン`,
"label.archived":`ファイリング済み`,
"label.standardabstractfield":`標準フィード項目`,
"vue_label_notice_add_fail":`失敗を追加しました`,
"label.sendemail.registIMUser.addresserror":`受信者のメールアドレスは間違っています`,
"label.ccdocument.toolbar.switch":`ツ—ルバ—の切り替え`,
"first":`一番目`,
"label.icon.147":`マウス`,
"vue_label_jihui_er":`機会2`,
"label.ccchat.micropost.isedit":`投稿とコメントの修正`,
"label.department.next":`次のページ`,
"front-kefu-moudle-confirm-disable-phone-user":`ユーザー{0}のダイヤルアウトを無効にしてよろしいですか？`,
"label.reportsSubscription.time.meets.subscription.frequency":`開始日と終了日が購読頻度を満たしていません。`,
"lable.account.NextpDays":`これからの120日`,
"UG_opportunity_007":`取引先責任者の役割`,
"label.encrypt":`暗号化`,
"label.knowledge.category.hint.three":`既存のカテゴリーを削除または置換すると、記事に関連するすべてのカテゴリーが削除されます。`,
"label.customcomponent.usewhere.info":`以下はこのコンポーネントに対する参照です。参照の表示ラベルをクリックして、定義をご覧ください。`,
"vue_label_import_addandupdate":`追加して更新`,
"label.email.all.members":`グループメンバー全員にメールで送信`,
"component_task_button_save":`保存`,
"label.file.deleted.unavailable.desc":`このファイルは削除されたか、存在しないかあるいはプレビューできません。`,
"label.emailsync.status.viewlog":`ログの表示`,
"label.marketsea.othersetup":`その他の設定`,
"label.data.exp.newtemppage":`テンプレート作成ページ`,
"vue_label_lead_score_successsful":`スコアリング成功`,
"label.sendemail.activity.newtask":`#belongtoidccname様、こんにちは。\r\n  同僚の#createbyidccname様は#createdateに新しい行動を割り当てました。内容は以下の通りです。\r\n  トピックス：#subject\r\n  開始時刻：#begintime\r\n  終了時刻：#expireDate\r\n  関連先：#relatedstr\r\n  内容：#remark\r\n  詳細情報については、\r\n #path\r\n にアクセスしてください。                     #orgNameCRMシステム`,
"component.event.label.soon":`すぐに`,
"label.forecast.shrepage.getlist":`予測階層に戻る`,
"UG.solution.02":`ソリューションは、取引先が発生した関連問題を解決するための機構内部の解決案です。`,
"label.weixin.data.approval":`レコードは承認中`,
"label.build.pagelist":`ページビルダーページのリスト`,
"label.customsetting.type.hiberarchy":`階層`,
"label.forecast.ccfh":`ベストケース`,
"label.Current.Window":`既存ウィンドウ`,
"label.appointmentdetail.wizard.title20":`日曜日のスケジュール`,
"label.emailaddress":`メールアドレス`,
"label.qetting_notifications":`メールが届かない？CloudCCのメールアドレスを許可リストに追加し、エクスポート通知をオンにしていることを確認してください。`,
"Homepage.News.001":`ニュース`,
"label.runreport":`レポートの運行`,
"label.customer.tab.step3":`ステップ 3. カスタムアプリケーションに追加`,
"label.dashboard.snapshot.refresh":`更新`,
"label.approvepagelayout3":`レイアウトの設定`,
"vue_label_SMS_send_messages":`ショートメッセージの送信`,
"label.executestate.old":`執行済み`,
"label.approvalstep3":`ステップ3.割り当てる承認者の選択`,
"label.step3.total6":`ステップ　3/6`,
"front-kefu-moudle-v1-delete-templete":`テンプレートの削除`,
"label.data.downpage.e.title.num3":`3、ユーザーが需要に応じてエクスポートテンプレートを作成することができます。「テンプレートでエクスポート」を選択して、より簡単にエクスポートできます。`,
"label.attendance.outer":`外勤`,
"setup_layout_button_selectall":`すべて選択`,
"chatter.photo.img":`最大ファイルサイズは 2M です。`,
"front-dynamiclayout-module-v1-required":`required}のフィールドは必須に設定されています。`,
"label.mytask":`私のToDo`,
"label.edit.customerinfo":`組織プロファイルの更新`,
"label.processsetting.process.explain":`設定と使用プロセスを通じて、ユーザーは最も重要な事項に専念し、適切な時間にキーワードとヒントをユーザーに展示し、ユーザーの流れを完成させます。`,
"label.emailobject.subject":`サブジェクト`,
"label.mobileapp.scansetting.message":`実際のシーンに応じて、名刺をスキャンして画像形式でレコードの関連リスト「備考と添付ファイル」に保存するかどうかを選択します。<br/>有効：チェックした後、レコードを保存すると同時に、名刺を自動的にレコードの添付ファイルに保存します。<br/>無効：チェックした後、レコードだけを保存します。`,
"front-epwechat-module-v1-android-autograph":`Androidアプリの署名`,
"label_component_helper_potentialcustom":`今日割り当てされたリード`,
"label.projectManagement.nodata.week.work":`今週の仕事をうまく完成させるために、ToDoを追加しましょう`,
"label_tabpage_rolez":`ロール`,
"label.importsourcestep4":`ステップ3.ファイルのインポート`,
"label.icon.50":`方位磁針`,
"lable.service.prompt":`項目数はすでに制限を超えたため、削除できません。`,
"label.campaign.channel.input.page":`ホームページを指定し、活動のホームページを感謝ページとして設定することができます。`,
"UG.homepage.001":`より多くのケースを短時間で獲得する`,
"label.step4.total6":`ステップ4、合計で6つのステップ`,
"label.partner.required":`エラー：ドメイン名は空であってはいけません`,
"label.tag.manage.title":`管理タブ-{0}`,
"label.data.downpage.i_title.num1":`1、システムはるCSV形式のみが適用されます。`,
"label.custom.quarter.end":`カスタム四半期の終了日`,
"label.layout.distribute":`ページレイアウトの割り当て`,
"label.version.allsms":`SMSの一括送信`,
"label.tolead":`インポート`,
"label.texttemplate.usemergefields":`SMSテンプレートに組み込まれたフィールドを使用します。`,
"label.emailobject.sure":`確認`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`モバイル端末はH5作成?編集を有効化しますか`,
"label.tabpage.messagez":`コメントを入力してください。`,
"label.mobile.phone.write.day.report":`日報の作成`,
"label.data.setok.e.desc2":`データリストページのエクスポート`,
"label.emailsync.message":`プロンプト`,
"label.sales.page.mubiao":`目標達成`,
"label.ccdocument.list":`最新のフォルダを表示`,
"label.tabpage.userGuidez":`ユーザーガイド`,
"label.report.fields":`レポートで選択可能な項目`,
"vue_label_checkduplicate_at_same_time":`同時にすべて満足させる`,
"label.sms.phone":`SMSゲートウェイのカスタマーサポートの電話番号`,
"UG_ST_004":`データ管理-》データインポートの権限がないため、管理者に連絡してください。確定をクリックして{0}インターフェースに入ります。`,
"label.mobile.nobindmobile":`この携帯電話番号は現在存在しません。ユーザー情報から携帯電話番号を登録してください。`,
"label.partnerCloud.basicSetting.intro":`CloudCCでは、種類の異なるパートナーに対して複数のサイトを設定し、ログインページやメニュー、権限などを個別に設定することができます。例えば、小売店では、地域の代理店や広告のパートナーなど、さまざまなサイトを作成することができます。`,
"label.trigger.targetobject":`目標オブジェクト`,
"label.ems.emailsyncperiod":`メールの同期間隔`,
"lable.Transformation.mode":`変形モード`,
"label.emailobject.new.template":`テンプレートの作成`,
"label.System.Setting":`システム設定`,
"label.emailtocloudcc.button.addemailaddress":`企業メールの追加`,
"lable.a.total.of.invoices":`全部0件の請求書です`,
"label.multilang.customforcast.forecasthistory":`{0}の予測履歴`,
"label.role":`ロール`,
"advancedconditions":`高度な絞り込む条件`,
"label.tabpage.beginz":`開始`,
"label.campagin.roi.khzhsl":`取引先の置換件数`,
"chatter.poll.option5":`選択肢 5`,
"label.weixin.horse.club.registered":`愛馬社のユーザ登録`,
"frame_personinfo_label_resizeimage":`サムネイルを調整するには、プロファイル写真の上の虚線をドラッグして調整してください`,
"label.file.share.select.warning":`共有するように設定されています`,
"label.event.this.week":`今週の行動`,
"label.data.import.object.label":`オブジェクトの表示ラベル`,
"label.visualpage.folder":`ファイリングされないページフォルダ`,
"vue_label_report_saveandclose":`保存して閉じる`,
"label.newdashboardpage.saveto":`保存先`,
"label.partnerCloud.financeSetting.developerIDTwo":`デベロッパーID`,
"lable.PowerProcess.created.ago.please":`プロセスを作成する前には`,
"label.chatter.myfollowers":`私のフォロワー`,
"label.campaignmember.main.duplicatelist.title":`キャンペーンメンバー：スキャンして重複削除を設定する`,
"label.group.no.recent2":`検索したチームは加入済み`,
"label.icon.110":`本`,
"label.merge.my.account":`私の取引先のマージ`,
"setup.layout.button.quicksave":`クイック保存`,
"pagecreator.page.message.canntdelete":`当該ページは削除できません`,
"label.report.printable.view":`プリント可能なビュー`,
"ccchat_fieldtrack_fieldchange":`{0}から{1}に変更します`,
"label.email.bcc":`BCC`,
"label.sso.saml.sp.idpcert":`IDプロバイダのライセンス`,
"label.step2.total2":`ステップ　2/2`,
"lable.product.pricebooks.isn":`有効になっている価格表`,
"labal.emailtemplate.namemassage":`メールテンプレートの一意の名前は既に存在しており、再編集してください`,
"only.one.field":`1つの項目のみ選択できます`,
"label.weixin.appr.audittime":`承認時間`,
"pagecreator.page.button.delete":`削除`,
"front-kefu-moudle-v1-Session-start-time":`セッション開始時間`,
"label_chatter_state":`状況`,
"vue_label_systemSettings_lightningcustom":`LightningのカスタムUI`,
"label.searchs":`検索`,
"label.mobile.phone.not.read":`未レビュー`,
"label_chatter_allweather":`一日中`,
"label.enter.number":`0から6までの整数を記入してください`,
"front-epwechat-module-v1-addressbook-desc":`有効にすると、WeComの連絡先や部署は、CloudCCのユーザーや役割に同期されます。`,
"label.emailfield":`メール項目`,
"pagecreator_button_next":`次のステップ`,
"label.more.select.merge.records":`最大3つまでのマージするレコードを選択することができます`,
"lable.edit.queue.selobjct":`選択されたオブジェクト`,
"label.reportsSubscription.editsubscribe":`購読の編集`,
"label.selectfieldtoautotransmit":`自動的的な転送に使う承認項目を選択します`,
"label.ccpeak.need.topass":`導入が必要です`,
"label.checkfield.merge":`マージ`,
"front-lighting-module-v1-detail-file-downlaodInfo":`このレコードはロックされており、ファイルのダウンロードができません。ロックを解除するには管理者に連絡してください。`,
"vue.please.enter.a.chart.name":`図表の名前を入力してください`,
"label.data.dataexptemplate.desc3":`3、エクスポート方式はデータのエクスポートのみに有効で、テンプレートのエクスポート無効です。テンプレート?エクスポートのファイルフォーマットはCSV形式です。`,
"label.setup.mobile.homepageshortcuts.setting":`モバイル端末ホームページのショートカット機能の設定`,
"label.ems.connect.success":`メールボックスのテストに成功しました`,
"label.applet.text":`ミニプログラムを通じて提出された修理依頼に対して、システム内にケースレコードを作成することができます。ケースレコードの作成者としてユーザーを選択してください。選択されたユーザーは、ケースオブジェクトの作成権限を持っている必要があります。また、所有者を変更した後、ミニプログラムに再度ログインし、レポートフォームを送信することで有効になります。`,
"label.knowledgebase.parent.window":`ペアレントウィンドウ`,
"label_file_size":`占有スペース`,
"label.allocation.department":`ユーザーの割当て`,
"label.browser":`ブラウザ`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`水曜日`,
"label.integrations.description1":`現在のビューのすべてのデータをエクスポート`,
"label.project360":`プロジェクト360`,
"label.choose_formtype":`フォームタイプの選択`,
"label_emailsync_status_connectstatus":`関連状況`,
"label.bmap.beijing.city":`北京市`,
"label.mask.encryption.scheme":`暗号化形式`,
"label.imgfield.type":`画像種別`,
"label.person.target.responsible":`目標責任者を選択します`,
"label.appexchange.installedpage.installdate":`インストール日付`,
"label.partnerCloud.orderingPlatform.partnerUsers":`この機能は、パートナーユーザーにのみ提供されます。`,
"label.profile.customfieldsafety":`カスタマ項目レベルセキュリティ`,
"label.no.target.models.available.":`利用可能なインジケータモデルがありません。指標モデルを作成するか、管理者にお問い合わせください。`,
"label.process.execute.tip":`申請を処理しており、一括申請が時間がかかりますが、完了したら通知メールは送信されます。`,
"label.app.step2.introduce":`下記の項目を入力して、カスタマアプリケーションを定義します。`,
"label.loginip.cue":`ログイン IP の制限はありません。ユーザはどの IP アドレスからでもログインできます。`,
"label.step1.select.tablayout":`ステップ1.タブレイアウトの選択`,
"mainpage.setup.chosecomponent.leastone":`ホームページにコンポーネントを少なくとも1つ選択する必要があります。`,
"label.custom.quarter.name":`カスタム四半期の名前`,
"chatter.ptup.link":`投稿&コメントリンク`,
"label.compact.layout.frame.error2":`詳細情報と関連リストは画面の左側に必ずあります`,
"vue_label_salesfunnel_notice7":`可能性が100%である商談の総数/可能性が0%或いは100%である商談の総数`,
"label.multilang.datamanage.dataimport.lostmsg":`タイトルの長さは&nbsp;{0}&nbsp;で、データの長さは&nbsp;{1}&nbsp;です。システムはどれ&nbsp;{2}&nbsp;の項目がなくなったのか確認できません。`,
"label.owner.notnull":`所有者は空であってはいけません。`,
"label.logintime.pagecue.invalidt":`開始時刻は終了時刻より大きくなってはいけません`,
"vue_label_file_checked_num_limit":`選択したファイルの数が制限を超えている`,
"front-email-payment-repayments":`ペイ・アゲイン`,
"template.report.today.prospects":`今日のリード`,
"label.weixin.appr.status":`承認状況`,
"label.knowledge.language.japanese":`日本語`,
"label.event.reminder.lead.time":`行動のアラーム`,
"lable.custom.dep":`新規ボタンをクリックして、新しいカスタム年を定義します。`,
"Dashboard_View_Createdbyme":`私が作成したダッシュボード`,
"label.file.upload.fail":`ファイルのアップロードに失敗しました`,
"label.manager":`マネージャー`,
"label.stdashbord.xsld.business.jine":`金額`,
"label.tag.manage.tag":`表示ラベル`,
"chatter.nlk":`よくない`,
"label.file.search.people":`人の検索`,
"message.error.domain.format":`ドメイン名は英語と数字のみで構成できます`,
"label.firstisdefault":`一番目の値をデフォルト値とします`,
"label.discount":`割引`,
"label.mobile.phone.have.read":`レビュー済み`,
"label.field_selected":`このフィールドが選択されました`,
"label.payment.renew.now":`すぐリニュー`,
"label.multilang.lookfiltercondition.notsetup":`第{0}行の条件にエラーが発生し、演算子が設定されていません。`,
"label.projectManagement.Selectionday":`日を選択`,
"label.user.organization.permit.licensenotstart":`組織のライセンスは有効化されていません。有効化してから再度試してください`,
"label.download.save.attachment":`ダウンロードして添付ファイルに保存`,
"lable.outlook.mcto.must":`メール形式は必須です`,
"vue_label_notice_unfollow_success":`フォローの取消しに成功しました`,
"label.taskinfo":`ToDo情報`,
"label.other.SMS":`その他の携帯番号`,
"label_partner_workspace_login_logo":`フッターロゴ`,
"label.weixin.data.lock":`レコードはロックされた`,
"label.Yaxis":`Y 軸`,
"lable.edit.queue.selobjdes":`当該キューに割り当てるオブジェクトを選択してください。それにより、選択したオブジェクトの個々のレコードの所有者をこのキューにすることができます。`,
"label.campagin.roi.dcfezb":`来場者割合`,
"label.marketseamemset.maximum":`最大数量`,
"label.owner":`所有者`,
"label.reportsubscribe.error.noview":`「以下のユーザー視点でレポートを実行する」からレポート実行の視点を選択してください`,
"label.icon.133":`フォルダ`,
"vue_label_file_share_files":`共有ファイル`,
"label.searchlayoutfilterfields.remark":`タブ検索あるいはフロントエンド左側ボックス検索のときに表示する検索条件項目を選択します`,
"vue_label_help_contract":`契約と代金受取計画`,
"component.chatter.button.message":`コメント`,
"label.marketsea.recyclereminddays2":`日のリマインダー（取得後のフォローしていない日数より少ないことが必要です）`,
"label.webtocloudcc.input.information":`当該情報をご記入ください`,
"vue_label_chatter_exit_group":`グループから退出`,
"vue_label_lead_notcreatetask":`ToDoを作成しない`,
"front-lightning-module-v1-dashborad-date-dimension":`日付 日付 日付 日付`,
"setup.layout.label.fieldlist":`利用可能な項目`,
"label.leadscore.charname":`項目名`,
"label.forecast.customforecast.mybest":`私のベストケース`,
"setup_mainpage_label_welcome24":`CloudCC クラウドプラットフォームでは、すべてのオブジェクトデータのアクセスのセキュリティー設定ができ、各種のルールや条件の設定を通じて、データの共有とアクセス権限のコントロールを行えます。`,
"label.queue":`キュー`,
"label.icon.159":`チップ`,
"label.path":`参照パス`,
"label.app.message.failtoget":`アプリケーションリストの取得に失敗しました。`,
"label.returntoprocess":`承認プロセスリスクに戻る`,
"vue_label_commonobjects_detail_more_data":`これ以上のデータがありません`,
"label.number":`数値`,
"label.product.find":`価格表の検索`,
"label.legend":`図例`,
"label.partner.workspace.member.profile":`選択可能なプロファイル`,
"label.service.gantt.sum.appointments":`完了済みのサービス予約数/すべてのサービス予約数`,
"label.partnerCloud.financeSetting.paymentAllowed":`オンライン・トップアップの許可`,
"label.integrations.upgrate":`アップグレード`,
"label.timzone.tip.info3":`Calendarクラスを使用して、日付を処理するとき、Calendar実例にタイムゾーンを設定し、Calendarオブジェクトを獲得するには下記の2つの方法を選択することができます。Calendar cal`,
"label.ems.addaccount2":`メールボックスのアカウントの追加`,
"label.partneruser":`パートナーユーザ`,
"label.validate.globalvariable.user.roleId":`ロールID`,
"pagecreator.layout.button.mergecell":`セルの結合`,
"label.evacuantvalue":`排除する値`,
"label.setup.mini.msg":`ブランドストーリー/メッセージ設定`,
"label.icon.178":`人`,
"vue_label_pricebook_notice_cantbedeleted":`価格表エントリーはすでにレコードが適用されているため、削除できません。価格表エントリーを無効に変えてもいいです。`,
"vue_label_appstore_application_recommendation":`人気があるおすすめアプリ`,
"label.version.createlimit":`現在のCloudCCバージョンは {0}で、オブジェクト毎に{1} 件の{2}を作成することができますが、既に上限に達しました。CloudCC をバージョンアップしてください。`,
"message.duplication.label.sectionremar1":`マージされた後のレコードに残る値を選択してください。強調表示された行は項目にコンフリクトデータを含むことを示します。選択済みのマスターレコードは読み取り専用と非表示の項目値を引き続き保有します。`,
"label.icon.1":`雲`,
"label.salescloud.salesdashboard.sales.performance":`全体‐販売契約の業績`,
"System_AddressFieldType_Post":`郵便番号`,
"setup_object_field_dependency_label_mustone":`1つ以上の連動項目の値を選択して下さい`,
"label.appointmentdetail.wizard.title6":`場所`,
"label.layout.testobj2":`テストオブジェクト2`,
"label.searchlayout.dupcacher.field":`タブの重複検索&マージリンクで表示される重複項目をクリックします。`,
"label.attendance.persons.title":`勤怠管理の対象を選択してください`,
"template.report.product.sales":`製品販売`,
"label.editCustomReportType":`カスタマレポートタイプの編集`,
"label.multilang.ui.setup.profile.alltime":`すべての時間は{0}です。`,
"label.service.dispatchingUnits.noservice.booking":`サービス予約なし`,
"label.validate.remark4":`割引率を 30% 未満にするなど、数字を指定範囲内に収める`,
"front-kefu-moudle-v1-Waiting-time":`ウェイティングタイム。`,
"label.weipagelayout.remark":`Webchatのホームページとモバイル端末のが表示するレイアウトに応用します`,
"vue_label_wang_er":`マイケル`,
"label.pw.text":`user}のパスワードを入力してください。また、そのパスワードには少なくとも`,
"message.error.user.data.null":`ユーザー情報を空にしてはいけません。`,
"chatter.like.p":`コメントにいいね`,
"label.page.double.column.style.cloudcc":`2列のスタイルは組み込みコンテンツと同じページで最も使われているCloudCC機能を提供します。例えば、「検索」、「最近のアイテム」です。`,
"label.h5.iscloseaccount":`ログアウトしますか`,
"label.dataimport.insertdata.id.error":`表示形式にエラーが発生し、数字と英字の組み合わせにしてください。`,
"label_tabpage_sum":`合計`,
"front-epwechat-module-v1-addressbook-sync":`連絡帳の同期`,
"label.setup.mobile.offlinecache.mostsave":`プラットフォームがデフォルトで有効化になるモバイル端末のオフラインタブは最大で10個までです。`,
"label.weixin.quickcreate":`クイック新規`,
"label.forecast.edittotal.de.mubiao":`の目標`,
"label.icon.144":`保証`,
"label.icon.155":`画像`,
"label.In.the.search":`検索中`,
"message.validation.isnotdateISO":`有効な日付の入力（ISO)`,
"label.service.appointmentList.send.successfully":`派遣に成功しました`,
"label.dynamicpage.error.exist":`ダイナミックページレイアウトデータが存在しない`,
"vue_label_SMS_otherpeople":`等{0}人`,
"label.cloudccsite.url":`サイトURL`,
"label.tabpage.contactsz":`取引先責任者`,
"vue_label_commonobject_notice_clickthename":`アップロード済みのファイルをダウンロードする必要がある場合は、ファイル名をクリックしてください。`,
"vue_label_file_new_lib":`新しいファイルライブラリ`,
"label.chatter.card":`カード`,
"chatter.feed.menutype.user.allusercom":`すべての人`,
"label.exchange.sync2":`設定`,
"template.report.year.income":`今年度の収入`,
"label.partner.template.detail":`機能説明`,
"label.setup.service.template":`サービスレポートテンプレート`,
"label.dataimport.insertdata.id.length":`長さは20桁以下で、表示形式にエラーが発生しました。このレコードをチェックして修正してください。`,
"label.partnerCloud.financeSetting.collaborator":`協力者ID`,
"label.processskipwizard":`承認プロセスのジャンプスタートウィザード`,
"label.weixin.inputbusnumber":`自動車ナンバープレートを入力してください`,
"label.dashboardSetup.d1":`区切りの1つの値`,
"template.report.conversions.number.industry":`リードのコンバージョン数（業界別）`,
"vue_label_chat_group_chat":`グループチャット`,
"label.file.publicview.error":`このファイルは削除されたか、存在しないかあるいはプレビューできません。`,
"label.customfields.location.locationHelpText":`「本社」のように、説明性と特定性を持つ位置名を入力してください。しかも、「西海岸販売事務所」と「東海岸営業事務所」のように、1つのレコードに複数の住所があるかもしれません。`,
"message.duplication.label.blankmatchtip":`NULL 値は一致されますか。デフォルトはfalseです。`,
"message.appexchange.addtopackage":`1つまたは多数のコンポーネントを選択して、このパッケージに追加します。`,
"label.ems.return2query":`アカウント追加の検索ページに戻る`,
"label_model_name":`モデル名`,
"label.apiname.retainapi":`nameはシステムに保留される名前で、その他の項目Api名を使用してください。`,
"lable.Cancel.the.search":`検索のキャンセル`,
"label.custom.viewport":`視点`,
"label.weixin.polls.type":`投票種別`,
"label.opportunity.setting.showstage.label":`自動的に推進します`,
"label_component_helper_businesschange_expiredtask":`商談は期限切れのToDoを含みます`,
"label.operator":`演算子`,
"label.ccpeak.use.class.time.listmap":`List<Map>への導入を通じてセットでアクセスします`,
"component_timeline_label_past":`過去の活動`,
"label.mobile.phone.submit":`私の提出したレポート`,
"message.recordtype.new.subtip":`新しいレコードタイプに名称とメモを入力します。新しいレコードタイプは、以下の選択した既存レコードタイプのすべての選択リスト値を含みます。新しいレコードを保存すると、オプションリスト値をカスタマイズすることができます。`,
"UG_product_05":`商品のインポート`,
"label.validate.globalvariable.user.id":`ユーザID`,
"label.umeng.activity.distribute":`割り当てた`,
"label.weixin.avote":`投票の発起`,
"label.weixin.already.sign":`サインイン済み`,
"label.emailmerge.mergepage.generator":`オーストラリア東部標準時`,
"label.batchtransfer.transferto":`移行先`,
"label.tianyancha.industry":`業界`,
"label.addattachment.name":`ファイル名`,
"label.customfields.formula.date.tip":`日付を計算します。例えば、他の日付に一定の日数をプラスまたはマイナスします`,
"label.partnerCloud.orderingPlatform.noPayment":`Not to Pay`,
"label.emailobject.failedtosend":`送信に失敗しました`,
"label.knowledge.setting.data.three":`カテゴリグループのデータは、最大{count}個まで選択できます。`,
"label.weixin.input.maxlength.langtext":`ここで最大32000文字まで入力することができます`,
"vue_label_calendar_delete_calendar":`カレンダーの削除`,
"vue_label_commonobjects_detail_filter":`折りたたみフィルター`,
"setup.layout.group.custompage":`ページのカスタマイズ`,
"component_sendmail_label_subject":`トピック`,
"label_tabpage_maxfilez":`ファイルの最大サイズは`,
"label.logintime.pagecue":`このプロファイルのユーザがログイン可能な日時を選択してください。ログイン時間帯の制限は、異なるタイムゾーンに属するユーザに対しても、該当する正確な時間で適用されます。`,
"label.salescloud.salesdashboard.datetime":`契約締結予定日`,
"label.format":`形式`,
"label.newfoundland.daylight.time":`ニューファンドランド夏時間`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`マージフィールドの値をコピーしてSMSのコンテンツに貼り付ける`,
"message.chooseatleastoneforshare":`以下のいずれかの共有ユーザを選択してください`,
"label.multilang.datamanage.importobjfield":`第{0}列`,
"label.denglu":`ログイン`,
"label.popup.infoz":`プロンプト`,
"label.schedulejob.setup.schedule.onday":`毎月に`,
"label.appointmentdetail.wizard.title16":`水曜日のスケジュール`,
"label.userphoto.dragtoadjust":`ドラッグしてサムネイルを_整します`,
"label.product.series":`商品ファミリ`,
"message.view.kanban.not.set.group.summary.field":`ビューボードはグループ化集計項目を設定していません`,
"page.un.activities":`活動予定`,
"label.exchange.sync3":`配置`,
"label.login.activityExpired":`ユーザの貢献度は期限切れになりました。システム管理者に連絡してください。`,
"component_chatter_file_button_files":`ファイルの選択`,
"message.onlydelete.type":`非アクティブなレコードタイプだけは削除することができます。削除を許可するよう、レコードタイプの使用を禁止してください。`,
"message.recordtype.selectlayouttouse":`使用するページレイアウトの選択`,
"label.knowledgebase.unable.restore.draft":`削除したドラフトは復元できません。`,
"label.shangqing.name":`ビジネス情報`,
"label.weixin.target.payment":`代金受取のの目標金額`,
"label.chatter.sendEmailToGroupMember.check":`投稿を見る`,
"front-kefu-moudle-v1-input-single-login-area":`シングルサインオンのドメイン名を入力してください。`,
"vue_label_zhang_yi":`アリス`,
"label.icon.190":`ヘアドライヤー`,
"label.quickbooks.fieldlabel.company":`取引先名`,
"vue_label_email_are_you_sure_to_delete":`メールを確かに削除しますか。`,
"Pagelayout.Setup.005":`名前は最初の場所に置かなければならない。`,
"label.object.name.two":`オブジェクト名2`,
"label.tabpage.completez":`選択した状態に完了のマークをします`,
"label.setup.mobile.bottombutton.saveerror":`第1階層のページ設定の保存に失敗しました`,
"label.report.action.addtodashboard8":`ダッシュボードファイルの選択`,
"label.data.downpage.i_list.desc3":`ユーザはダウンロードした後に、ファイルの最後の列でインポートの失敗原因を調べることができます。`,
"label.layout":`レイアウト`,
"label.marketsea.button.assign":`割当て`,
"UG.solution.03":`ソリューションの作成`,
"label.ccchat.person.invited":`同僚の招待`,
"label.ccchat.person.invite.address":`受信者`,
"label.displaytype1":`詳細情報ページリンク`,
"label.tianyancha.h5.ziranrengudong":`個人株主`,
"lable.SalesCommitmentKanBan.targetReceipts":`代金受取の目標金額`,
"message.error.getitems.type":`getItems:typeは空にしてはいけません`,
"label.addattachment.list":`下記のファイルはアップロード済み`,
"label.datamanage.export.false":`エクスポートにエラーが発生しました`,
"pagecreator.systemstyle.label.buttonfontcolor":`ボタンテキスト`,
"label.emailtocloudcc.redmessage1":`正しいメールアドレスを入力してください`,
"label.weixin.polls.closed":`投票はすでに完了し、締め切り時間`,
"label.icon.165":`帽子`,
"vue_label_report_detailsonly":`詳細情報のみ`,
"component.salesperformance.label.100finish":`完了済み`,
"november":`十一月`,
"label.data.file.generatejwd":`ユーザ住所による緯度経度データの生成を執行`,
"label.salescloud.opportunity.access":`商談のアクセス権`,
"label.isremider.remider":`通知`,
"vue_label_total":`合計`,
"label.email.prompt.using.lightning.link":`システム通知のメールリンクをLightningのリンクと一致するように設定する。`,
"label.knowledgebase.cancel.attached.articles":`添付記事をカンペキに`,
"label.version.custom.xslc":`カスタマイズ可能な販売プロセス`,
"component_setup_button_save":`保存`,
"label.ems.cc":`CCに追加`,
"label.edit.user":`ユーザーの更新`,
"label.emailtocloudcc.select2":`タイプを選択してください`,
"label.industrialandcommercialverification.fieldnumber":`__付け_目：4つ`,
"label.ccchat.havenot.joined.group":`いずれの活動チームにも加入していません`,
"pagecreator_page_label_pagename":`ページ名`,
"setup.layout.button.save":`保存`,
"label.campaignmember.main.updatestatus":`キャンペーンメンバー状況の一括更新`,
"label.tab.web.edit":`Webタブの編集`,
"label.ring_chart":`ドーナツ・チャート`,
"label.usermanage.resetpwd.error":`ユーザが存在しないため、パスワードの更新に失敗しましｔ。`,
"label.Xaxisscope":`X 軸範囲`,
"label.app.new":`新規アプリケーション`,
"message.modifythereport":`レポートはダッシュボードに使用されています。修正すると、このレポートを参照するダッシュボードは無効になります。`,
"label.component.helper.businesschange.0activity":`30日間活動がありません`,
"label.weixin.fmu.noon":`お昼`,
"label.enter.rule.name":`ルール名の入力`,
"lable.Confirm.recovery.potential.customers":`リード{name}の回復を確認します`,
"lable.PowerProcess.type.created":`どんなタイプのエンタイトルメントプロセスを作るでしょうか。`,
"front-lightning-module-v1-dashbord-rectangle-size":`オルソゴンサイズ`,
"label.projectManagement.new.service.appointment":`新規サービス予約`,
"label.multilang.totalpage2":`合計`,
"pagecreator.systemstyle.label.styledesc":`スタイル説明`,
"chatter.up":`アップロード中`,
"2018UI_Homepage_DataDeleted_Info":`データは削除ずみで、クリックして前のステップの戻る。`,
"label.knowledge.draft.recordid":`下書きIDは空にしてはいけません`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`すべてのイングレーションを表示`,
"vue_label_file_num_limit_tip":`ファイル数がプリセット数を超えています。ファイルの入れ替えが必要な場合は、先ずアップロードしたファイルを削除してください`,
"vue_label_commonobjects_view_refreshat":`{timeInterval}前に既に更新しました`,
"laebe.data.exp.save.success":`当該テンプレートでデータをエクスポートするなら、戻って［テンプレートエクスポート］をクリックして、アクションしてください。`,
"label.mr.caption.contact":`重複検索&マージ：取引先責任者の重複データの検索条件`,
"label.webtocloudcc.submit.error":`提出失敗`,
"label.multilang.datadelete.delmessage":`レコード（{0}件）がロックされたため、削除できません`,
"label.quickbooks.searchlist.total2":`{0}件の関連されていない支払記録を検索しており、この総金額は{1}です`,
"label.createnew":`新規…`,
"component.milestones.label.choicestate":`この状態を確認する`,
"lable.outlook.edit.exist":`項目は存在済みで、一意の項目名を入力してください。`,
"vue_label_dashboard_eachother":`同じレポートまたは同じオブジェクトからのビューのみリンク可能`,
"label.new.role":`新規ロール`,
"message.error.operationType":`サービスを転用すると際に、アクション列が定義されないことが分かりました。`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`送信する人を選択してください`,
"label.attendance.thanks":`ご参加いただき、ありがとうございます`,
"label.invoice.message.statusupdatefailed":`Invoiceステ_ラスの更新に失_し、後ほど再度_してください。`,
"template.chart.yzhqzkhlyfx":`コンバートされたリードのソース分析`,
"chatter.feed.menutype.user.alluser":`すべての人`,
"UG_Forcast_04":`試用の開始`,
"label.appupload.upload.tips.profile":`ご注意：このソフトパッケージにプロファイルコンポーネントがすでに追加されており、再追加できません（ソフトパッケージにプロファイルコンポーネントを1つのみ追加することができます）。`,
"lable.PowerProcess.leave.the.process":`{describeName} プロセスの終了`,
"template.report.sales.cycle.opportunities":`セールスサイクル期間（オポチュニティタイプ別）`,
"vue_label_calendar_please_fill_in_the_calendar":`カレンダー名を記入してください`,
"label.salescloud.unit.wanyuan":`単位（元）`,
"label.fileAPI":`ドキュメントの一意の名前`,
"label.weixin.link":`関連`,
"label.service.seconds":`秒`,
"label.encd.visible":`暗号化項目値が参照可能`,
"label.tianyancha.regstatus":`経営状況`,
"label.event.moveup.18hour":`18時間`,
"label.upper.bound":`上限`,
"label.please.insertURL":`挿入するURLを入力してください。`,
"label.approval.notallowed.reject":`拒否することはできません`,
"label.permission.fieldpermission":`項目権限の設定`,
"label.customcomponent.page.index.title":`カスタマコンポーネント`,
"label.quickbooks.viewlist.number":`番号`,
"lable.list.queue.sendemail":`メンバーへのメールの送信`,
"label.productsales.today.noevtadd":`今日、行動予定がありません。右上の「＋」をクリックして行動を追加することができます。`,
"label.report.line.daixuan":`選択待ちのレポート列`,
"label.reportsSubscription.select.start.endtime":`開始日と終了日を選択してください。`,
"template.chart.schdyscb":`キャンペーン費用の予算化`,
"label.sendemail.chat.addPostatsubject":`CloudCC CCChat 書き込みで私に関する内容を書き込みました`,
"label.RelatedList":`関連リスト`,
"label.knowledgebase.delete.translation.associated.with.draft":`既存のドラフト翻訳は、マスター言語の記事の最終公開バージョンにリンクされます。公開されたバージョンが存在しない場合は、すべての翻訳が削除されます。`,
"vue_label_chatter_submitted_review":`加入申請を提出しました。管理者の承認をお待ちください。`,
"label.layout.list2":`リスト2`,
"label.manage.area":`テリトリーの管理`,
"label.manageapproveprocess":`承認プロセスのの管理`,
"workflow.action.tasks.assignortype.created":`作成者`,
"label.custombutton.nonsupport.operation":`現在のバージョンはアクション標準ボタンとリンクをサポートしません。`,
"label.ip":`IPアドレス`,
"label.chat.topic.desc.error.info":`トピックス説明は1000文字を超えてはいけません。さらに短い文章で説明してください。`,
"label_tabpage_cue":`情報メッセージ`,
"label.integrations.mailchimp1":`CloudCCとMailchimpを統合することで、ユーザーはCloudCCアカウントから選択したリードとコンタクトをMailchimpにインポートできるようになります。`,
"label.email.track.required":`必須情報`,
"label.set.case":`まずは、ケースのオーナーを設定してください。`,
"label.weixin.newspaper.coverage.number":`リスクシートナンバー`,
"vue_label_approve_submitreason":`提出の理由`,
"message.oppdt.noenabledpricebook":`有効化されていない価格表`,
"label.partner.workspace.setup":`設定`,
"label.version.nonsupport.feature":`当該機能を暫くサポートしません。需要に応じて、CloudCCバージョンをグレードアップしてください。`,
"com.cloudcc.login.error.message.licenseexpired":`ライセンスの有効期限が切れている`,
"label.emailsync.form.signin":`ログイン`,
"label.campaign.channel.input.to.chooselanguage":`言語を選択してください`,
"label.tabpage.gotit":`わかった`,
"front-console-no-contact-tip":`データがありません。関係者に連絡してご覧ください。`,
"label.approval.apiname":`APIとマネージドソフトパッケージで使用する一意の名前です。名前は文字から始まり、アンダースコアと英数字しか使用できません。名称はアンダースコアで終えることができなく、または2つの連続したアンダースコアを持ってはいけません。`,
"label_emailtocloudcc_filed_ssl":`安全な接続`,
"component_sendmail_label_fromuser":`送信者`,
"front-kefu-moudle-v1-new-online-chats":`新しいオンラインエージェント`,
"label.searchlayout.merge.duplicated.results":`重複検索&マージをしますか`,
"label.weixin.input.maxlength.remark":`ここで最大500文字まで入力してください`,
"component.telerecord.label.related":`関連項目`,
"label.note":`コメント`,
"message.duplication.label.nletters":`文字`,
"label.productsales.payment.phb":`代金受取ランキング`,
"label.forecast.editshrepage.desc":`Forecast:このレコードの共有を指定します。個別ユーザ、特定ロールのユーザまたはその下位ロールのユーザーはこのレコードと関連データを共有します。`,
"vue.dashboard.setPenetrationSuccessful":`ペネトレーションの設定に成功しました。`,
"label.tabpage.noOperationz":`このコンテンツは固定されたアイテムであり、操作することはできません`,
"label.email.jump":`サードリンクにジャンプ`,
"label.appointmentpage.wizard.btn1":`予約の確認`,
"label.umeng.approval.pass":`#approverは#objの承認を通過しました`,
"label.project.hit.twelve":`マイルストーンの有効期限のお知らせ`,
"two":`二`,
"label.approvedinfo":`承認情報`,
"label.import.step1.choosecsv":`csvファイルを選択してください`,
"vue.please.select.the.expansion.method":`展開方法を選択してください`,
"UG.homepage.005":`セールス・インテリジェンス`,
"Account.News.Setting.003":`一般設定`,
"label.quickbooks.button.actions":`アクション`,
"lable.list.queue.email":`キューメール`,
"label.name.lastname":`姓`,
"message.confirm":`確認できますか`,
"Opportunity.Detailed.Phase.Label.Popup.002":`現行ステージの終了日`,
"label.knowledge.setting.title":`ライブラリの設定`,
"label.helptocreateprocess":`新しい承_プロセスを作成するには、「新しい承_プロセスを作成」をクリックし、「ジャンプスタ_トウィザ_ド」を__してください。または、すべての承_オプションを_定するには、「__ウィザ_ドを使用」を__して下さい。`,
"label.batcheditor.remark":`複数のレコードに対して、編集することができます。`,
"label.page":`ページ`,
"label.newfolder":`新規フォルダ`,
"label.version.interceptor.api":`APIインターフェス`,
"label.sms.toaddress":`SMSの受信`,
"front-kefu-moudle-noopen-callcenter":`組織がコールセンター機能を有効にしていないので、管理者に連絡してください。`,
"label.data.exp.zip":`パック形式`,
"lable.account.LastcDays":`過去の60日`,
"label.import.index.starttime":`開始日`,
"label.dashboardall":`すべてのダッシュボード`,
"label.create_socialpost":`新しい投稿`,
"label.searchlayoutedit.remark":`フロントエンドの左欄またはタブをクリックして検索する場合に、表示される項目とボタンを選択します。`,
"message.servicecrew.violation":`リソース割り当ての違反：サービスリソースはこの時間帯においてチームメンバーとします。`,
"label.email.attrach.file":`ファイルの添付`,
"report.label.folderandreport":`レポートとフォルダ`,
"label.list.userinterface.sales.setup":`販売ホームページの設定`,
"label.martrixreport.2018.step1":`ステップ1.集計条件のグループ化方式を選択`,
"label.campaignmember.selectmember.memberstatus":`キャンペーンメンバー状況`,
"label.textmessage.vonage.api.key":`APIキー`,
"label.tabpage.next":`次のステップ`,
"UG_Lead_006":`Webサイトの訪問客`,
"label.salescloud.salesdashboard.visit.rankings":`訪問ランキング`,
"label.myevent":`私の行動`,
"label.activity.history":`履歴`,
"label_tabpage_kanban":`ボードの設定`,
"label.weixin.allapp":`すべてのアプリケーション`,
"label.query.clone.detail.choose.choosed":`選択済みの明細オブジェクト`,
"message.error.view.errvalid":`エラー：ビューの一意の名前はアンダースコアと英数字しか含めません。しかも一意で英字から始まり、スペースなしで、アンダースコアで終わってはいけません。また連続する2つのアンダースコアを含んではいけません。`,
"label.customfields.searchrelation.dependobject.tip":`当該オブジェクトが関連するその他のオブジェクトを選択`,
"label.appointment.wizard.subtitle4-4-3":`3週間`,
"label.setup.mobile.offlinecache.saveerror":`モバイル端末のオフラインキャッシュ設定の保存に失敗しました。`,
"label.planned.started":`開始済み`,
"label.page.step4.of.step5":`ステップ　4/5`,
"label.tabpage.value":`値`,
"label.reportlist.allfolder":`すべてのフォルダ`,
"label.callcenter.sure.disable.center":`現在のコールセンターを停止してもいいのか？`,
"vue_label_commonobjects_detail_activity_tocalendar":`カレンダーへ`,
"label.setup.mobile.bottombutton.recovery.default":`デフォルトに戻す`,
"label.appointmentdetail.wizard.title15":`火曜日のスケジュール`,
"label.icon.15":`修理注文`,
"component_sendmail_label_touser":`受信者`,
"template.report.all.owner":`リードのオーナー`,
"front-Partner-email-tips":`ユーザー名にはEメールを入力してください。`,
"vue_label_systemSettings_mobelhomepagesetting":`モバイルアプリのホームページ設定`,
"label.service.newBuildDialog.aswellas":`及び`,
"label.name":`名前`,
"label.tag.search.taglist":`表示ラベルリスト`,
"label.partnerCloud.priceOfManual.theOnly":`各パートナーユーザーに唯一の価格表を設定することをお勧めします。または、注文時に複数の価格表から1つを選択することができます。特定の価格表が設定されていない場合は、標準価格表が適用されます。`,
"label.knowledge.field.update":`{1}を{2}から{3}に変更します。`,
"label.emailobject.save":`保存`,
"label.top.changeVersion":`新版のインターフェース`,
"label.recordtype.edit.unselected":`使用可能な値`,
"label.knowledgebase.additional.articles":`記事の添付`,
"label.lead.score.confirm":`スコアリングするリードの範囲を選択し、「リードスコアリング」をクリックして、アクティブにしたスコアリングルールに基づき、選択したリードにスコアリングを実施します。
スコアリングが長い時間をかかるかもしれません。完成したら、確認のメールを受け取ることができます。`,
"label.projectManagement.pleaseselectadate":`日付を選択してください`,
"label.appointment.wizard.subtitle5":`会議の名前`,
"label_setup_failed":`設定に失敗しました`,
"label.chatter.collect":`ブックマーク`,
"label.appointment.cancelappointment":`キャンセル`,
"front-console-response":`応答時間`,
"message.delete":`確かに削除しますか`,
"label.dataimport.type.selected":`エクスポートタイプを選択してください`,
"label.new.target":`新しい指標`,
"vue_label_report_autoupdatepreview":`自動更新のプレビュー`,
"label.knowledgebase.guidance":`ガイダンス`,
"label.chatter.mail":`メール`,
"label.login.verification.scan.code.acquisition":`QRコードを読み取る`,
"label.customsetting.changefieldtype":`項目種別の更新`,
"label.data.dataexpalltype.all_desc2":`2、すべてのデータをエクスポートするには、時間がかかります。完了したら、エクスポート成功のの通知メールを送信します。`,
"label.opportunity.contactisnull":`ユーザ情報はNULLで、表示できません`,
"pagecreator_layout_button_upload":`レイアウトのアップロード`,
"label.dashboard.noRecord":`レコードはありません`,
"label.SMS.template":`SMSテンプレート名`,
"label.c.d.without":`Cレコードには関連Dレコードがある場合とない場合があります。`,
"UG.Case.05":`ケースの作成`,
"front-epwechat-module-v1-edit-selfapp":`Seflで作成したアプリの編集`,
"label.role.createrole.tip":`このページに表示された既存のロール階層に追加して作成できます。新規ロールを作成する場合は、[ロールの追加] をクリックしてください。`,
"label.grouping":`グループ化`,
"vue_label_email_upload_new_file":`新規ファイルのアップロード`,
"label.notification.event3":`あなたの行動は【開始時刻】に開始します`,
"labe_benchmark_objects":`標準オブジェクト`,
"component.chatter.button.collect":`ブックマーク`,
"front-QBtoCC-sinchronies":`Synchronizing...`,
"message.submitpage.sms":`おめでとうございます。SMSの送信申請は成功しました。`,
"label.imgfield.width":`幅`,
"label.send_email":`投稿メール通知の送信先`,
"label.queue.list":`キューリスト`,
"label.tabpage.fieldoptions":`レコードタイプ項目、オプションリスト項目、オプションリスト（複数選択）項目は、最大10個のキーワードを入力することをお勧めします。例えば"北京,上海 ,広州"のように、"または関係 "を実現するためにカンマで区切ります。`,
"component.chatter.post.button.save":`発表`,
"chatter.group.groupDescriptionInformation":`説明情報`,
"label_setup_mobilesetup_isenableh5newandedit":`モバイル端末ではH5新規編集を有効化しますか`,
"lable.Confirm.recallpotential.customers":`{num}個のリードの回収を確認します`,
"label.knowledge.setting.hint.seven":`以下の中からお名前をお選びいただき、書き込み権限を付与してご投稿ください。`,
"label.emailtocloudcc.redmessage2":`正しいメールのパスワードを入力してください`,
"message.validation.equalTo":`同じ値を入力`,
"vue_label_help_golbal":`グローバルナビゲーション`,
"vue_label_chatter_delete_group_title":`グループの削除`,
"label.user.login.success":`ログイン成功`,
"label.chatham.standard.time":`チャタム夏時間`,
"label.vlidaterule.example.percent":`割引率が 30% を超えてはいけません`,
"label.group.field":`グループ化項目の指定`,
"label.trigger.operation.sharetab":`トリガーアクションの共有リスト：`,
"label.mobile.phone.write.month.report":`月報の作成`,
"label.statusofconvers":`置換済み状況`,
"label.version.emailtemplate.track":`メールテンプレート`,
"label.customobjects.onlytrackforupdate":`追跡更新のみ`,
"label_tabpage_enterviewname":`ステップ1.ビュー名を入力してください`,
"label.processsetting.three.enable":`ステップ3：有効化`,
"label.service.show.more.info":`更なる情報を表示する`,
"front-epwechat-module-v1-input-iosschema":`Please enter iOS schema`,
"label.dataimport.datatype.error":`データ種別にエラーが発生し、データとタイトルが一致するかどうかチェックしてください。`,
"label.staticresource":`静的リソース`,
"label.weixin.customize":`個性化`,
"label.product.edit.sel":`選択した内容の編集`,
"label.appointmentpage.wizard.notif5":`無効な携帯電話番号の形式`,
"label.marketsea.basicsetup":`基本設定`,
"label.workflow.supplyintruduce":`1.ワークフロールールを実行する条件。
2.レコードが条件に一致したときに実行するルール適用時のアクション。たとえば、新しい重要商談が作成されると、cloudcc から取引先チームを通知するメールを自動的に送信できます。
3.レコードが条件に一致するとキューに入り、タイムトリガーに従って実行される時間ベースのアクション。`,
"label_report_line_tuozhuai":`ドラッグ&ドロップし、またはダブルクリックして、リストの列を選んで、その順番を調整してください`,
"label.add.new.rule":`新世代ルールの追加`,
"label.marketing.setting2":`チャネルの設定`,
"vue_label_chatter_delete_some_group":`グループ"{groupInfoList}"を削除しますか。`,
"label.appupload.uploading.wait":`お待ちください`,
"label.linecondition.error":`行の条件にエラーが発生し、項目種別は一致していません。`,
"chatter.group.request":`申請`,
"label.recordtype.tabname.remark":`このページでは、レコードタイプを保守?編集することができます。レコードタイプに基づき、ページレイアウトと選択リスト値が表示されます。レコードタイプを使用するには、「レコードタイプ」項目をページレイアウトに追加してください。`,
"setup_mainpage_label_welcome4":`アクションガイド：このページの右側のメニュー → アプリケーションの設定 → 作成 → オブジェクトをクリックしてください。`,
"vue_label_salesadvance":`販売段階の推進`,
"vue_label_campaign_of_existing_campaign_members":`既存のキャンペーンメンバーの状況を設定してください。`,
"label.report.object.detail.no.permission":`レポートタイプが変更または移動されています。管理者に問い合わせてください。`,
"label.weixin.untreated":`未処理`,
"label.service.miniProgram.bindSetOwnerDesc":`ミニプログラム上で提出された修理依頼書に対して、システム上でケースレコードを作成することができます。  ケースレコードの作成者としてユーザーを選択してください。このユーザーは、ケースオブジェクトにレコードを作成するための作成権限を持っている必要があります。そして、作成者を変更した後、ミニプログラムに再度ログインして報告依頼を提出すると有効になります。`,
"label.autoassigntoapprover":`承認者のに自動的に割り当てる`,
"label.marketseamemset.containself":`自作のレコードを含む`,
"vue_label_report_drill":`ドリル`,
"label.order.products.to.assets":`注文製品を資産に変換`,
"label.recordtype.list":`既存のレコードタイプ`,
"lable.outlook.detail.conflict":`利益相反行為`,
"pagecreator.page.label.layoutpreview":`レイアウトプレビュー`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`エージェントチャットはEasemobでサポートされています。まずはEasemobのアカウントをご購入ください。`,
"label.convers":`置換`,
"serviceappointment.worktype.isnot.father.worktype":`このサービス予約では、親レコードに関連付けられたワークタイプを選択する必要があります。`,
"lable.tianyancha.h5.relatedcom":`関連会社`,
"label.reportsSubscriptionPage.schedulereport":`レポートのスケージュール`,
"label.workbanch.setup.showinworkbanch":`私のワークベンチで表示されますか`,
"label_emailsync_connectaccount":`メールアカウントの関連付け`,
"label.usermanage.license.not.qualified":`システムがこれは非準拠のライセンスであることを検出しました、ベンダーに連絡して再度ライセンスを取得してください`,
"component_setup_label_displayfield":`項目表示`,
"setup_layout_label_buttonarea":`ボタンエリア`,
"label.weixin.input.content":`内容をご入力ください`,
"label.operatedata.importsuc":`インポートに成功しました。オブジェクトを開いて、インポート状況を参照してください。`,
"label_tabpage_yes1z":`はい1`,
"front-electronic-signature-describe":`Esignatureにアクセスして、いつでもどこでも契約書にサインすることができます。ワンクリックで安全かつ効率的にサインできます。`,
"label.event.this.month":`今月の行動`,
"label.document.replaces":`置換`,
"label.email.cc":`CC`,
"chatter.feed.sticker":`書き込みの追跡`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`図表を追加してください`,
"label.cpq.main.quote.transfer.order":`プライマリークォーテーションのみがオーダーを生成できます。`,
"label.partnerCloud.partnerAccount.topUpSuccess":`トップアップ成功`,
"label.appexchange.uninstallpage.uninstall":`アンインストール`,
"label.campagin.roi.channel":`販売チャンネル`,
"label.multilang.versioncontrol.checkversion":`_在のCloudCCバ_ジョンは{0}で、{1}件の{2}を作成することができますが、既に上限に_しました。需要に_じて、CloudCC をバ_ジョンアップしてください。`,
"label.emailobject.my.template":`私のテンプレートのみ表示されます`,
"label.edittimetrigger":`タイムトリガーの編集`,
"label.setup.mobile.homepageshortcuts.saveerror":`モバイル端末ホームページのショートカット機能設定の保存に失敗しました。`,
"label.address.street":`町名番地`,
"label.workflow.estimatecondition2":`作成されたとき`,
"label.wei.expiresdate":`締切日`,
"label.quickbooks.viewlist.date":`日付`,
"label.page.select.field.type":`項目種別の選択`,
"label.tabpage.mypotentialcustomers":`私のリード`,
"label.file.library.editlib":`ライブラリの詳細の編集`,
"label.weixin.message.operateexception":`情報メッセージ（問題があればシステム管理者に連絡してください）`,
"label.visualpage.staticresource.p1":`1.転用方法　静的リソーしボタンの導入を通じて、選択する静的リソースを導入します。`,
"label.icon.175":`航空券`,
"chatter.edit.r":`返事の編集`,
"label.examinationandapproval.flow":`承認フロー`,
"label.mr.descreption.reDataList5":`データ`,
"label.edit.field.select.showstyle":`スタイルの表示`,
"label.reportsSubscriptionPage.condition.and":`そして`,
"label.please.associations":`関連するオブジェクトを選択してください。`,
"label.service.dispatchingUnits.displays.service.appointments":`エリアに関連付けられていないサービス予約の表示`,
"label.addcurrent":`既存の追加`,
"label.search.change":`検索可能なオブジェクトの設定`,
"message.schedulejob.error.modify":`配置されたスケジュール表に基づき、割り当てされた作業は永遠に触発されません。データをチェックして再提出してください`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} {1}内のすべての人に公開されたリンク`,
"label.weixin.micro.oldid":`Wechat公式アカウントの最初ID`,
"label.employees.only.invitation.code":`システムは従業員のために唯一の招待コードを生成し、従業員はこのコードを使って招待し、個人の業績に計上することができます。リードの所有者は現在のキャンペーンの所有者またはマーケティングチャネルの招待者となりますので、ご注意ください。リードの割当てルールによって、新たに割り当てることができます。割当てルールについて`,
"lable.PowerProcess.event.msg":`エンタイトルメント プロセスの各ステップ (重大行動) で発生する時間に依存したワークフロー アクションを追加できます。たとえば、重大行動の期限が切れる 1 時間前にケース所有者にメールを送信し、または重大行動への最初の対応が完了したときに特定のケース項目を自動的に更新するようにアクションを設定することができます。`,
"label.file.share.email.content2":`共有情報：共有は現在のファイルに#sharerole権限を付与します`,
"label.querydetailservice.datalayout.notexist":`レコードのレイアウトは存在しません`,
"label.group.items":`グループ化項目`,
"label.istouse":`有効`,
"front-electronic-signature-explain":`Fadada Esignatureの説明です。`,
"label.partner.template.thumbnail":`サムネイル`,
"registration.page.selected.fields":`登録ページは項目選択を選択しなければなりません`,
"label.reportTypeCategoryLabel":`レポートタイプの表示ラベル`,
"vue_label_email_You_have_not_activated_the_mailbox":`メールボックスを有効化していない`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`ToDoの完成率`,
"label.forecast.detailforecast.program":`予測プロジェクト`,
"label.page.display":`ページの毎に表示`,
"label.passwordPolicy.setup.minute":`分`,
"label.emailtocloudcc.step1total3":`ステップ1/3`,
"label.file.title":`タイトル`,
"label.callcenter.private.key":`プライベートアクセスシークレットキー`,
"com.cloudcc.login.error.message.loginerror":`ユーザー名またはパスワードが正しくありません。`,
"UG_Lead_004":`Webフォーム`,
"label_tabpage_recordsz":`レコード`,
"label.shangqing.discovery":`ビジネス情報の発見`,
"vue_label_notice_change_success":`変更完了`,
"label.ems.other":`その他`,
"loading":`データアップロード中`,
"label.committedtoapprove":`提出済みの承認申請`,
"label.category.4":`財政的`,
"template.report.folder.customer.situation":`アカウント状況の分析`,
"label.quickbooks.searchresault.phone":`電話`,
"label.ccpeak.ccobj.save":`CCobjectをデータベースに保存します。転用方法`,
"label.knowledge.delete.linked":`関連記事の削除にエラーが発生しました`,
"label.forecast.settings.future2":`これからの二週間`,
"message.error.displaytype.detail":`表示タイプは空してはいけません。日：day、月：month、曜日：week、利用可能性：availability！`,
"front-template-V1-search-template-name":`オブジェクト名を入力して検索`,
"label.sendsms.batch.step3.introduce":`各メールの活動を保存`,
"UG.Forcast.08":`前のステップ`,
"label.inputnameandintro":`名前と説明の入力`,
"label.redistributioned":`再割り当て済み`,
"label.service.dispatchingUnits.left.right.total":`現在{left}-{right}件のデータで、合計{totalCount}件のデータです。`,
"label.projectManagement.Pleaseentertheactualworkinghours":`実際の労働時間を入力してください`,
"label.exporttemplate":`テンプレートのエクスポート`,
"label.data.downpage":`データダウンロードページ`,
"message.please.choose.contact":`取引先責任者を選択してください`,
"message.error.dataformat.error":`データフォーマットエラー`,
"label.customsetting.changefieldtype.losevalue":`選択したデータ種別に変更すると、項目でのすべての既存データはなくなります。`,
"label.sendemail.chat.chattype":`トピックの種別：`,
"label.ccdocument.upload.error":`フォルダのアップロードにエラーが発生しました。`,
"label.quickbooks.view.all":`すべて`,
"label.data.downpage.e_title":`データエクスポートのステップ：`,
"lable.data.lock":`データはロックされており、まずロックを解除してください。`,
"label.locked":`ロック済み`,
"label.customfields.beforedeletedata":`このカスタマ項目を削除する前に、データ管理を設定してクリックしてください。`,
"label.productsales.oppor.noapproach":`契約予定期間<30 日の商談がありません`,
"label.input.notmore.than.number":`{0} より大きいか等しい数字を入力してください`,
"label.list.userinterface.isenable":`インライン編集を有効化`,
"label.listofshare":`シェア情報一覧`,
"label.emailsync.status.role":`役割`,
"label.staticresource.useful.realtion":`当該静的リソースの位置を使用`,
"label.sharerule.tip":`当該ページには組織の共有設定が表示されます。この設定では、ユーザの互いのデータへのアクセス権のレベルを指定します。`,
"label.qrcodelogin.message.expired":`QRコードは無効になりました`,
"label.marketing.setting3":`キャンペーン販売チャンネルの設定`,
"vue_label_statistical_field":`項目の統計`,
"message.view.addtomyhomepage":`トップページのワークベンチに追加`,
"label.customfields.percent.tip":`「10」などのパーセントを表す数値を入力できます。また、パーセント記号が自動的に数値に追加されます。`,
"component_newrecords_label_10records":`10件のレコード`,
"Lead_Scoring_Warning_001":`単一リードシステムに対しては、リードの作成と編集をする際に自動的にスコアリングすることができますが、一括インポートされたり、インターフェースを通じて作成されたりするリードに対しては、手動で一括スコアリングする必要があります。`,
"label.project.planing":`派遣工数と報告工数の比較(今年)`,
"label.data.exp.pwdverif":`パスワードは英字あるいは数字しか使用できません`,
"coderules.notEnable":`QRコードやバーコードを生成するためのルールを有効にするには、管理者にお問い合わせください。`,
"label.weixin.wdyj.jxhk":`個人‐セールスパフォーマンス‐代金受取`,
"label.data.expnode.e_desc3":`3、テンプレートの作成：ユーザは需要に応じて、エクスポートする項目及び条件をテンプレートに作成できます。`,
"chatter.group.join":`加入`,
"vue_label_systemSettings_monitoring":`モニター`,
"front-kefu-moudle-v1-yesorno-delete-folder":`本当にこのフォルダを削除していいのか？`,
"label.exchange.sync.state.info":`システム状況をチェックして、Exchange と CloudCC の間でレコードを常に同期します。`,
"lable.outlook.mcto.emaildes":`メール送信に使うリードと取引先責任者ののすべてのメールアドレスを読点で仕切りって入力してください。指定された下記のメールアドレスから送信するメールしか、関連レコードの活動履歴に追加できます。`,
"label.ems.save":`保存`,
"vue_label_dashboard_maximumvalue":`表示する最大値を入力してください`,
"label.passwordPolicy.setup.norestriction":`要求なし`,
"label.multilang.customforcast.total":`{0}の累計`,
"label_partner_all_memo":`リスクで御社のすべてのパートナークラウドが表示されています。URLをクリックして、登録ページにスキップします。`,
"Account.News.Setting.002":`下記のアカウント設定で、貴社にデフォルトアカウント行為を指定します。`,
"label.essential":`必須`,
"label.nonotice":`もう通知しない`,
"vue_label_calendar_calendar_deleted_successfully":`カレンダーの削除に成功しました`,
"message.huanxinagent.disable":`アクティブでないエージェント`,
"label.goto":`切り替え`,
"label.chat.topic.add.favorite":`お気に入りに追加`,
"label.trigger.targetobj":`目標オブジェクト`,
"label.form_fields":`フォームフィールド`,
"this.month":`今月`,
"vue_label_homepage_select_view":`ビューの選択`,
"label.weixin.input.subject":`トピックを記入してください`,
"label.ems.emailType":`メール種別`,
"vue_label_file_safe_type_file":`ファイルに機密情報が含まれていないか確認してください。特定のユーザーやレコードとの共有ファイルを検討してください。`,
"label.version.case.automatic.upgrade":`ケースの自動的なグレードアップと割り当て`,
"label.input.invalid.credit.card.number":`有効なクレジットカード番号を入力してください`,
"component_timeline_label_future":`後続ステップ`,
"label.emailtemplate.cannotsupporthtml":`現在HTML種別をサポートしません`,
"label.appupload.install.error.info2":`{1}  “{1}”           既存のコンポーネントとコンフリクトが発生します。`,
"label.custom.field.maping":`当該項目に対応付け`,
"encd":`暗号化テキスト（暗号化表示）`,
"label.service.newBuildDialog.filter.logic":`フィルターロジック`,
"label.customerinfo":`組織プロファイル`,
"vue_label_applauncher_notice_activepoolsuccess":`リードプールの有効化に成功しました`,
"label.partner.workspace.member.choicepermission":`権限セットの選択`,
"front-gantt-module-this-task-of-other-tasks":`このタスクはサブタスクとして存在し、他のタスクのサブタスクになることはできません。`,
"label_chatter_publish":`発表`,
"label.forecast.settings.mrfw":`デフォルト範囲の起点`,
"label.Named.Filter":`フィルターの名前付け`,
"label.department.email":`メールアドレス`,
"label.updatingfield":`更新する項目`,
"label_partner_template_detail":`機能説明`,
"front-epwechat-module-v1-unbound-item":` すべての企業の結合`,
"vue_label_file_lib_name":`ファイルライブラリ名`,
"label.notification.arketsea.distribution":`5}は{2}{0}：{1}をあなたに割り当てました。`,
"vue_label_norm_removecomponent":`コンポーネントの削除`,
"component.event.label.begindate":`*開始日`,
"chatter.note":`受信したコメント（件）`,
"label.forecast.settings.type.all":`全体予測の使用`,
"label.compact.layout.frame.full":`フルスクリーン表示`,
"label.approvalstep3intro":`下記のオプションを使用して、承認申請が割り当てられるユーザを指定します。`,
"label.notification.approval6":`【委任者名】はあなたの代わりに【提出者が請求した【オブジェクト】【オブジェクト名】の申請を承認しました。`,
"setup.object.field.dependency.label.actionfieldvalue":`コントロール項目値`,
"label.multilang.page2":`ページ`,
"vue_label_email_submitted":`提出が通過した`,
"label.Standard.button":`標準ボタン`,
"vue_label_report_emailchoose":`メールオプション`,
"page.field.masterinput.list":`マスター/ディテールのデータリスク`,
"label.martrixdown":`マトリックスのシフトダウン`,
"vue_label_helpcenter_opportunity":`ビューの右上の「セールスファネル」アイコンをクリックすると、セールスファネルが表示されます。<br>直観的なプログレスバーで商談の進捗状況を確認し、ボタンをクリックすると、現在のステージが完了したことマークしたり、現在のステージを調整したりすることができます。また、商談に障害が発生した場合、プログレスバーを拡大して、現在の段階でより注意すべき情報やいくつかのヒントを表示することができます。<br>商談グループの関連リストを通じて、商談データを参照する権限がない他の人と共有し、共同作業を促進することができます。<br>商談にある取引先責任者の役割の関連リストで、商談の役割を対応する取引先責任者に素早く追加し、ネットワークを通じて取引先責任者の上下関係を表示し、レーダーチャートを使用して既存取引先責任者を評価します。 商談の価値、フォロー、キーパーソンを見つけ、取引先責任を表示します。役割、訪問状況、関係の程度、購入スタイル、訪問時間<br>商談商品の関連リストを通じて、商談と同じ価格帯の商品を追加し、商品の価格や数量を編集することができます。`,
"label.sso.ssoKeyMan":`クリックして秘密鍵管理にログインします`,
"label.forecast.edit.desc":`あるユーザーの以下の期間にある定額を設定`,
"label.weixin.newspaper.coverage.time":`リスクの登録時間`,
"label.pleaseselectpro":`商品を選択してください`,
"label.bottonandlink":`ボタンとリンク`,
"label.donot.know.error":`知らないエラーが発生し、管理者に連絡してください。`,
"label.account_noordab":`お客様のアカウントには、0個のカスタムレポートと2個のダッシュボードがあります。`,
"label.partnerCloud.orderingPlatform.toPay":`パートナーファンドによる支払い`,
"label.many.dayline.nextday":`次の日`,
"lable.showmorerecords":`レコードをさらに表示`,
"front-lightning-module-v1-details-page-chart-record-type":`レコードタイプを選択してください`,
"label.ccpeak.query.record":`レコードの検索`,
"pagecreator.systemstyle.message.save.fail":`スタイル保存に失敗しました`,
"label.weixin.share.file":`ファイルの共有`,
"errormessage.email.relatedorreceivermusthaveone.z":`受信者と関連先を少なくとも1つ選択する必要があります`,
"chatter.save.f":`保存に失敗しました`,
"button.partner.create":`作成`,
"label.marketseamemset.lead.title2":`すべてメンバーに影響するリードの数に上限を設けてください。上限はプールとは関係ありません`,
"label.service.major.event.new":`新規重大行動`,
"label.version.custom.site":`カスタマWebサイト`,
"label.permission.visualpagepermission":`割り当てされたカスタマページ`,
"lable.product.zongjia":`総価格`,
"label.viewchart":`図表を表示`,
"label.alaska.daylight.time":`アラスカ夏時間`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`より多くのユーザーがエージェントとなり、訪問者にサービスを提供することで、顧客サービスを向上させることができます。`,
"component_assistant_label_todaylead":`今日に割り当てられたリード`,
"label.sendemail.chat.addComentsfavorite":`#name様:\n\n    こんにちは。#userName様はあなたがブックマークしたの書き込みを返事しました。`,
"label.smstemplate.tip":`選択したフォルダーのすべてのSMSテンプレートは下記に表示されています。新規ボタンをクリックすると、新しいテキストまたはHTMLのSMSテンプレートを作成することができます。これらのSMSテンプレートは、メッセージを送信する際に使用することができます。ロールリンクをクリックすると、より詳細な情報が表示されます。`,
"label.documentname":`ドキュメント名`,
"label.icon.162":`風景`,
"label.salescloud.wanyuan":`元`,
"label.view.desc1":`レコードタイプ項目、選択リスト項目及び選択リスト（複数選択）項目は、最大10のキーワードまで入力し、また英文の読点で仕切ること（例えば、「北京、上海、広州」）をお勧めします。`,
"label.searchlayout.lookup.newfield":`ルックアップダイアログで新規ボタンをクリックして表示される項目。`,
"label.emailobject.bcc":`Bcc:`,
"label.manageAll.pagenum1":`現在はすでに1ページ目になりました`,
"vue_label_appstore_crm_used_companies":`上場企業はCRMを利用しています`,
"label.document.replace":`置換`,
"label.assignment.setup.newrule.title":`新規ケース割り当てルールの作成`,
"component.chatter.label.mygroup":`私のグループ`,
"lable.currencyAdv.exchangedate":`日付範囲`,
"label.quickbooks.button.viewinqb":`QuickBooksで表示する`,
"UG.homepage.004":`オートメーション`,
"label.currencyName":`通貨種類名称`,
"Homepage_News_001":`ニュース`,
"front-lightning-module-v1-details-page-chart-refresh-button":`リフレッシュボタンの表示`,
"label.list.projectSetting.isenable":`プロジェクトタイマーの有効化（マイルストーン、タスク、サブToDo、問題を含む）`,
"setup.layout.message.relatedlistbutton":`関連リスクに表示するスタンダードボタンを選択します。`,
"vue_label_homepage_homepageassignment":`アプリケーションのホームページの割当て`,
"label.pending":`処理待ち`,
"component.timeline.label.today":`今日`,
"front-kefu-moudle-free-hasexpire":`無料トライアルの期限が切れました。`,
"homepage.layout.customlayout":`カスタマホームページレイアウト`,
"label.service.miniProgram.content":`内容を記入してください`,
"label.defaultline.must.int":`デフォルト行数は正精数しかできません`,
"label.mirror_issues":`このフォームがあなたの側で表示されているものと異なる場合は、一般的なディスプレイの問題のトラブルシューティング方法についての記事をご覧ください。`,
"label.edit.select.two":`ラジオボタンリスク`,
"label.emailmerge.mergeFolder.tip":`テンプレートのマージに多少時間がかかります。マージプロセスで、その他のリンクをクリックし、またはWebブラウザを閉めないでください。`,
"label.ServiceCloud.zichan.distributionMap":`資産分布図`,
"label.selectfile":`ファイルの選択`,
"vue_label_account_equitymanage":`持分関係の管理`,
"label.email.clearAll":`すべてクリア`,
"label.selecting.parent.assets":`親機の選択`,
"component.setup.tabs.label.delete":`削除`,
"label.visualpage.top.must.is":`ページの第一行目は必ず`,
"label.SalesCommitmentDashboard":`販売承諾ダッシュボード`,
"chatter.group.changeTheRole":`ロールの更新`,
"label.dataimport.insertdata.error":`新規データの挿入にエラーが発生し、当該データをよくチェックしてください。`,
"label.partner":`パートナークラウド`,
"label.process.async.execute.tip":`あなたのリクエストは処理中です。承認には一定の時間がかかり、結果は詳細ページに表示されます。しばらくお待ちください。`,
"label.service.newBuildDialog.additional.conditions":`追加条件`,
"label.name_copy":`この既存のフォームをコピーしようとしています。コピーの名前を入力してください。`,
"label.integrations.install":`権限の付与`,
"label.edit.ccpeakfolder.time":`スケジュール済みクラス：フォルダの編集`,
"label.knowledgebase.filing.time":`アーカイヴの時間`,
"vue_label_chatter_success_exit_group":`グループからの退出に成功しました`,
"font.market.module.v1.save.name":`会議名を記入してください`,
"label.a.b.without":`Aレコードには関連“B”レコードがある可能性もあるし、ない可能性もあります。`,
"label.chat.topic.desc":`説明`,
"label.field.editoptionlist.introduce":`下記で選択リスク値の名称を入力します。当該チェックボックスを選択して、この値をデフォルト値とします。`,
"label.versiontype.Enterprise":`企業版`,
"message.selectrulecondition":`ルール条件を指定ください`,
"label.custombutton.unknown.operation":`知らないアクション`,
"label.pricecannotnull":`価格は空であってはいけません`,
"component_salesperformance_label_target":`目標`,
"pagecreator.page.message.delete.success":`ページ削除に成功しました`,
"label.help.new.features":`CloudCC R7.1 新規機能ウィザード`,
"label.weixin.vehicle.owner.information":`車両情報`,
"label.exchange.sync.state.user.info":`ユーザの同期状況をチェックして、 Exhange と CloudCC との間のレコードの同期を確保します。Exchange と CloudCC との間の同期に問題が発生するなら、ユーザの同期プロセスをリセットすることができます。リセットは CloudCC for Exchange の利用情報のみ削除し、 Microsoft Exchange サーバ或は CloudCC の中からデータを削除しません。`,
"label.batcheditor":`一括編集`,
"report.label.knowcreatehighlevelreport":`高度なレポート作成を理解する`,
"label.dataimport.title.length":`タイトルの長さは`,
"label_model_description":`モデル説明`,
"label.tabpage.ctbtsftcz":`後ろをクリックしてコンテンツを検索・選択してください`,
"label.channel.activity.member.owner":`チャンネルイベントメンバーの所有者`,
"label.ems.serverinfo":`サーバー情報`,
"tjinvilid":`条件は無効です`,
"label.nameofreport":`レポート名`,
"label.ifapproverreject":`承認者はこの申請を却下したらどうしますか。`,
"label.wtd.changefields.title.desc2":`モバイル端末  Web to CloudCC のレコードをリードに関連するなら、現在のオブジェクトにリード項目を検索?作成する必要があり、しまもAPIは`,
"label_emailsync_form_connecttime":`関連時間`,
"label.visualpage":`カスタマページ`,
"label.customlink":`カスタマリンク`,
"label.lead.score.doing.remark":`要求を処理しており、リードスコラリングに時間がかかりますので、システムは処理が完了したら通知メールを送ります。`,
"label.h5.act.details":`活動情報`,
"label.profile.setrecordtype":`レコードタイプの設定`,
"label.processsetting.process.enabled.successfully":`プロセスの有効化に成功しました。`,
"label.campaign.url.overtime":`このリンクは期限切れです`,
"label.structureChart.notFiled":`記入していない`,
"label.h5.chatter.something":`何か話しますか`,
"label.pm":`午後`,
"template.chart.rwlx":`タスクタイプ`,
"label.icon.42":`雲`,
"label.project.hit.one":`サブタスク割り当てのお知らせ`,
"label.martrixreport.2018.step3":`ステップ3.レポートリスクの選択`,
"label.wtd.changefields.newmo":`モバイル版ページの生成`,
"label.downloadTheTemplate":`テンプレートのダウンロード`,
"label_chatter_assignPerson":`委任先`,
"label_emailtocloudcc_license":`ライセンス`,
"label.willdeletedlayout":`削除するページレオアウト`,
"label.projectManagement.delete.question":`この課題を削除すると、この課題の関連情報もすべて削除され、データを復元することはできません。削除の確認はよろしいですか？`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`名刺のスキャンは入力ルールを有効化します`,
"label.salescloud.opportunity.addandedit.contactrole.note":`ご注意：空の取引先責任者をダブルクリックして、空のレコードを1本増やすことができます`,
"label.step6.total6":`ステップ　6/6`,
"label.knowledge.setting.hint.one":`ナレッジでは、お客様やサービス担当者がナレッジの記事を最大限に活用することができます。`,
"label.usefieldautoassign":`標準あるいはカスタマ階層項目を使用して、自動的に承認者を割り当てます。`,
"label.partnerCloud.orderingPlatform.orderAmount":`注文金額。`,
"chatter.fieldtrack.operateupdate":`1件を更新した`,
"chatter.del.com":`当該コメントを削除`,
"report.reportdatasource.label":`レポートデータソース`,
"label.text":`テキスト`,
"label.marketsea.select.member":`選択可能なメンバー`,
"label.typeofreceivers":`受信者種別`,
"label.knowledgebase.affect.existing.translations":`はい、私の修正は既存の翻訳に影響を与えます。"Expired "にする`,
"label.marketing.invitationmail":`私たちの活動へようこそ。招待状のリンクは`,
"label.version.quotation.management":`見積管理`,
"label.dataimport.insertdata.error.unique":`新規データを挿入する際、一意制約を違反しました。`,
"label.emailmerge.list.newtemplate":`新規テンプレート`,
"label.salescloud.salescloud.allteam":`商談でのすべてのチーム`,
"vue_label_commonobjects_detail_record_changes":`項目レコードの変更`,
"label.file.delete.info":`ファイルの削除`,
"vue_label_calendar_name":`カレンダー名`,
"label.version.support":`サポート`,
"label.event":`行動`,
"label.searchlayout.lookup.searchdialog":`参照項目で虫眼鏡をクリックしたときにポップアップするルックアップダイアログです。`,
"label.data.downpage.e_list.desc2":`データエクスポートが成功したら、通知メールを受け取ることができます。`,
"label.partnerCloud.productSet.delIsTrue":`この製品を削除しますか？`,
"label.tianyancha.businessverify.msg2":`本「協議」はあなた（以下はユーザという」とCloudCC との間で企業データ検証機能を使用することに関して締結された協議です。本「協議」はCloud CC とユーザとの間における企業データ検証機能の使用及びサービス関連の権利?義務を述べています。本「協議」は Cloud CCにより随時に更新され、新しい協議条項がリリースされるとすぐ履行されますが、別途に通知しません。`,
"label.customobjects.cancleselectallfield":`すべて項目の選択をキャンセル`,
"image.up.maxsize":`アップロードしたファイルは大きすぎて、2Mを超えないでください。`,
"label.icon.8":`ファイル`,
"label.donot.delete":`削除する権限がありません。`,
"label.version.profile.and.layoutpage":`プロファイルとページレイアウト`,
"chatter.coll.s":`この投稿のブックマークを解除`,
"label.icon.163":`地球`,
"label_chatter_myfollowers":`私をフォローしている人`,
"label.multilang.customforecast.refuse":`{0}のいずれの予測優先を拒否しますが、その他の部下の予測優先を許可します。`,
"label.tabpage.findz":`検索`,
"label.smstemplate.detailinfo":`SMSテンプレートの詳細情報`,
"label.knowledge.setting.hint.nineteen":`さあ、始めよう`,
"label.mr.tip":`{0}行目のルールを全部記入してください。`,
"label.icon.132":`保証`,
"label.customobjects.track.introduce2":`「項目追跡」関連リスクに追跡する項目です。ユーザが以下の選択したいずれの項目、古い項目値、新しい項目値、日付、時間、プロパティを修正するとき、「項目追跡」関連リスクに追加します。`,
"label_emailtocloudcc_redmessage5":`知らないステータスで、管理者に連絡してください。`,
"label.must.select.field":`行の条件にエラーが発生し、1つの項目を必ず選択してください。`,
"label.tag.manage.modifiedby":`最終更新者`,
"label.translation.start1":`言語を選択します (複数の言語の翻訳を行う場合)。`,
"label.ccchat.topic.searchs":`トピックの検索`,
"label.mask.custom.example":`{AAAA}{****}{AAAA}は5番目から8番目までの文字`,
"setup_object_field_dependency_label_addtolist":`選択された値の追加`,
"label.view.total.record":`0件のレコードを選択しました`,
"label.service.without.right":`関連権限がありません`,
"template.chart.wxqzkhyy":`無効なリードの理由`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`ブレークポイント1の値を入力してください`,
"message.pleaseinputmouthdistance":`正しい間隔（月間）を入力してください`,
"label.forgetPsd.tip":`パスワードを忘れました。管理者に連絡してください`,
"label.projectManagement.planned":`計画済み`,
"lable.Product.conversion.asset.operation":`製品を資産に移す`,
"label.search_forms":`フォームの検索`,
"label.sendemail.chat.addPostmainPagesubject":`CloudCC CCChat ホームページのコメント`,
"label_tabpage_viewNamez":`ビュー名を入力してください`,
"label_chatter_addresser":`送信者`,
"Opportunity_Detailed_Phase_Change_Text_001":`商談階段の変更`,
"label.what":`目`,
"vue_label_systemSettings_set_android":`AndroidとIOSのメニューや機能を設定し、ビジネスユーザーにも対応できるようにする。`,
"label.sell":`販売`,
"template.report.folder.case":`事例分析`,
"label.customfields.profilefieldsafety":`プロファイルの項目レベルセキュリティ`,
"label.industrialandcommercialverification.label.token":`Token`,
"label.finished":`完了済み`,
"label.sendmail.step3.introduce1":`現在選択済み`,
"vue_label_calendar_other_calendars":`その他のカレンダー`,
"label.donot.know.validate.field":`知らない校正項目`,
"label.exportdetail":`詳細情報のエクスポート`,
"label.step.filter":`絞り込み条件の指定`,
"label.campaignmember.main.hasMember":`既存のメンバー`,
"label.updown.suess":`ダウンロード成功`,
"label.ems.browse":`検索`,
"front-email-payment-Invoice-login-account-describe":`続ける」をクリックすると、AlipayのQRコードを読み取るか、Alipayにログインして請求書の支払いが完了します。`,
"label.copyCustomReportType":`カスタマレポートタイプのコピー`,
"label.visualpage.write.class":`ページでClassコードを編集します。コードと文法はJavaと同じです。`,
"label.setsharerule.tip":`<br>共有ルールを使用して、定義されたユーザーのセットに対して組織全体の共有設定の自動的な例外を設定します。<br>注：「ロールと部下」には、ロールに属するすべてのユーザーとそのロールの下のロールが含まれます。`,
"label.report.action.addtodashboard9":`ダッシュボードリストページ`,
"label.cloudccsite.remark":`サイトの説明`,
"label_tabpage_noz":`いいえ`,
"chatter.up.limit":`アップロードするファイルは大きすぎて、？を超えないでください。`,
"label.leadmarketsea.grouplist.title":`プールグループの設定`,
"label.pc.user.help":`ユーザガイド`,
"label.partnerCloud.orderingPlatform.relyOn":`依存関係`,
"label.appointmentpage.wizard.subtitle2":`時間の選択`,
"label.deleteoneormore":`1つ以上を削除`,
"january":`一月`,
"label.delete.profile":`プロファイルを削除`,
"label.appointment.wizard.subtitle1-7":`2時間`,
"label.icon.188":`化粧品`,
"vue_label_file_already_in_lib":`このファイルライブラリに既に存在している`,
"label.icon.151":`VR`,
"label.withvalue":`値に基づく`,
"label.tianyancha.businseeverify.opererror":`企業データの有効化に失敗し、改めて試して、またはシステム管理者に連絡してください。`,
"label.tabpage.individual":`単一選択`,
"label.layout.editdistribute":`ページレイアウト割り当ての編集`,
"label.smstemplate.lookup":`SMSテンプレートの表示`,
"pagecreator.systemstyle.button.delete":`スタイルの削除`,
"label.customer.tab.step2.same.option1":`デフォルト表示`,
"label.knowledgebase.no.results.knowledge":`知識では結果なし`,
"label.data.exp.newtemporexp":`データエクスポートの方式あるいはテ作成ンプレートを選択`,
"vue_label_chatter_refuse_join":`加入の拒否`,
"Homepage.News.002":`現在、ニュースコンポーネントは利用できません。`,
"label.log.requesttype":`申請方法`,
"vue_label_dashboard_generatefromreport":`レポートからの生成`,
"label.knowledge.create.version":`クリエイトバージョン`,
"label.emailtocloudcc.description2":`企業メールボックスの関連付け`,
"label.partnerCloud.partnerAccount.recharge":`上乗せ額は0.1から{上限}の間である必要があります。`,
"label.customobjects":`カスタマオブジェクト`,
"label.schedulableprg.endtime":`終了時刻は必ず現在時刻よち大きいです`,
"message.error.viewreport.confirmdelete":`今のビュー/レポートをデータソースとして使用しているグラフがあります。図表と一緒に削除しますか。`,
"label.marketing.social.seting":`ソーシャルメディアの設定`,
"chatter.follow.stop":`このユーザをフォローすることを解除します`,
"label.notification.arketsea.return":`5}は{0}：{1}を{2}に戻しました。`,
"label.conditionsofnextapprover":`1つあるいは複数の選択した承認申請は、次回の承認者を指定する必要があります。下記の検索ボックスを使用して、次回の承認人を指定します。`,
"label.partner.all.state":`状況`,
"mobel_web_closed":`閉鎖`,
"label.icon.65":`装置`,
"label.stdashbord.xsld.business.jinehj":`合計金額`,
"label.selectobject":`オブジェクトの選択`,
"label.account.CurrentFQ":`現在の四半期決算`,
"label.workflow.estimaterule":`評価ルール`,
"label.list.userinterface.shownewrecordssetup":`最新レコードの設定`,
"label.tianyancha.businessverify.msg3":`一、費用：`,
"label.weixin..xsld.jieduan":`階段`,
"label.first.quarter":`第1四半期`,
"Opportunity.Detailed.Phase.Label.002":`現在の状態はもう{0}日間変わっていない`,
"label_tabpage_page":`ページ`,
"label_emailsync_status_time":`時間`,
"label.pleaseselectaapprover":`承認者をご選択ください`,
"label.emailtocloudcc.redmessage5":`不明な点は、管理者にお問い合わせください。`,
"label.four.quarter":`第4四半期`,
"label_chatter_relateList":`関連リスト`,
"label.customfields.new.step2.opration.exid.info":`この項目は外部システムの一意のレコード識別子として設定されています。`,
"label.projectManagement.nodata.overdue.tasks":`素晴らしい！期限切れのToDoがありません`,
"label.sendemail.activity.task.statuscompleted":`#createbyidccname様、こんにちは。\r\n  #createdateに#belongtoidccname様にToDoを割り当て、ToDoの詳細情報は以下の通りです。\r\n  トピックス：#subject\r\n  期日：#expireDate\r\n  関連先：#relatedstr\r\n  内容：#remark\r\n  詳細情報については\r\n #path\r\nにアクセスしてください。 #belongtoidccnameは「完了」にメークされましたが、ご了承ください。          #orgNameCRM系统`,
"label.sso.saml.idp.config.issuer":`発行者`,
"label.cannot.delete":`削除禁止`,
"label.pigeonhole.sel_f":`ファイリングされるフォルダの選択`,
"label.customfields.text.tip":`いずれの文字列と数字の組み合わせを入力できます。`,
"message.error.user.service.common":`アクションに失敗し、システム管理者に連絡してください。`,
"label.datamanage.account.information":`取引先情報`,
"vue_label_homepage_deleteprofilepage":`プロファイルページの削除`,
"label.sendmail.step3.introduce3":`当該SMSの收件人（人）`,
"label.pc.ui.2018.recentitem":`最近のプロジェクト`,
"label.report.loading":`読み込み待ち`,
"vue_label_globalsearch_adjustment":`調整方法`,
"label_report_line_yixuan":`選択済みのレポートリスト`,
"label.h5.similar.opportunity.only.view":`表示のみ`,
"label.marketactivitymember":`キャンペーンメンバー`,
"label.recycle.execute.tip":`ゴミ箱を空にするには時間がかかりますが、完了したら通知のメールを送信します。`,
"label.permission.detail.system.setting":`システム権限の設定`,
"label.RecordType":`レコードタイプ`,
"label.custom.error.between":`カスタム年度の開始日またはカスタム年度の終了日が履歴カスタム年度期間にあるので、確認して再設定してください。`,
"vue_label_dashboard_selectview":`ビューの選択`,
"label.tianyancha.businessverify.cancel":`企業データ認証の有効化を解除`,
"label.partnerCloud.financeSetting.MD5":`MD5シークレットキー`,
"label.multilang.messagedetail.new.error":`名前に{0}がついたChatユーザは見つからないです`,
"label.callcenter.pleaseenter.private.key":`プライベートアクセスシークレットキーを入力してください`,
"label.umeng.activity.youdistribute":`割り当てたの`,
"label.weixin.nickname":`ニックネーム`,
"label.customerinfo.mailusername":`送信メールボックスのユーザ名`,
"label.partnerCloud.orderingPlatform.discountPlan":`割引スケジュール名`,
"lable.account.year":`会計年度`,
"T":`時刻`,
"System.Email.Template.Title":`CloudCC CRMプラットフォームへようこそ`,
"label.login.type":`ログイン種別`,
"label.notification.evaluation":`{0}は{1}の場合に{2}のコメントを残しました。`,
"label.turntolist":`リスクに切り替え`,
"label.sort":`並び替え`,
"vue_label_commonobject_notice_clickcross":`アップロードしたファイルを差し替える必要がある場合は、[X]ボタンをクリックして再度アップロードしてください。`,
"label.Select.maximumecords.operate":`最大200件までのレコードを選択して処理することができます`,
"label.submission_rate":`投稿率`,
"label.datadelete.record.sucessfully":`レコードの削除に成功しました。`,
"label.version.standard.dashboard":`ダッシュボード`,
"label.task.postunsolve":`期限切れのToDo`,
"label.Receivables.name":`代金受取計画の名称`,
"label_tabpage_noOperationz":`この内容は固定値で、アクションできません。`,
"label.attendance.onrecord":`1つ以上のレコードを選択してください`,
"label.partner.error2":`エラー：ドメインは英字あるいは数字しか含まないです`,
"label.account.map":`取引先マップ`,
"label.dashboardSetup.reference.legend":`図の参照`,
"label.Yaxisscope":`Y 軸範囲`,
"label.hierarchy.tree.tip":`タブ毎の検索項目で選択したレコードに基づき、作成した階層図です。階層構造表示は以下の通りです。`,
"label.permission.objlist.columnsize":`項目数`,
"label.setup.mobile.bottombutton.savesuccess":`第一階層のページ設定の保存`,
"label.mobile.side.tab.selected":`選択済み`,
"label.partner.donotdel.cause":`の削除のアクションで、これは以下のパートナーユーザと関連しています`,
"label.ccchat.message.new.error4":`メッセージ：`,
"vue_label_systemSettings_setorganization":`組織に合わせてアプリケーションを設定し、機能部門ごとに異なるメニューをカスタマイズすることができます。`,
"label.umeng.approval.approvalmes4obj1":`時間内に承認事項を確認してください`,
"UG_opportunity_010":`取引の作成`,
"label.tag.addtags.public":`公開`,
"System.TAB.SeeViewPageAmount":`ページの表示`,
"label.filterconditions":`検索条件`,
"front-personalEmailBox-module-v12-clear-not-associated":`接続をキャンセルすると、関連づけられていないすべてのメールが消去されますが、本当に接続をキャンセルしていいのでしょうか？`,
"label.assign":`割り当て`,
"label.layout.clone.tip":`既存のレイアウトを選択してコピーすることも可能です`,
"label.choose.relatedlist":`移行する関連リストの選択`,
"label_chatter_recordcall":`レコードコール済み`,
"label.product.proofOne":`0}では、{1}までの製品オプションを選択してください。`,
"label.layout.availablefield.relatedlist":`選択可能な項目/関連リスト`,
"label.campaignmember.main.updateleadstatus":`更新状況-既存リード`,
"label.custom.buttonandlink":`カスタマボタン或はリンク`,
"label.view.manage":`ビューの管理`,
"label.search.exp":`次の機能を有効にするオブジェクトを選択し、[保存] をクリックします。`,
"vue_label_appstore_apply_to":`に適用します`,
"label.dashboard.message.refreshfail":`ダッシュボードの更新に失敗しました`,
"UG_Case_02":`ケースは取引先の質問に応じて解決することができます。ケースはCloud CCでは機能が強いレコードで、取引先の問題をフォローできるだけでなく、取引先ビューも表示できます。`,
"label.project.hit.three":`デイリーサブタスクリマインダー`,
"label.tianyancha.businessverify.tip":`企業データの検証の有効化をチェックしました。これはユーザが企業情報を入力する場合、正しい企業登録情報の入力に役立ちます。`,
"label_emailsync_status_disconnect":`関連付けの解除`,
"label.rule.disabled.successfully":`ルールの無効化に成功`,
"label.custombutton.queryerror":`検索に失敗が発生し、再アクションしてください`,
"label.customfields.deletecannotresume":`対応するデータは完全に削除され、復元できないため、慎重に作業をを行ってください。`,
"label.account.current.M":`今月`,
"label.under.approve.data":`申請中のレコード`,
"vue_label_title_remainingdays":`残りの日数`,
"label.partnerCloud.orderingPlatform.refundable":`利用可能なリベート`,
"label.lookup.iscover":`同期許可の編集`,
"label.recordtype.detail.selectlist":`編集可能な選択リスト`,
"label.sso.isActiveYes":`はい`,
"label.service.appointmentList.canceltheSuccess":`キャンセルに成功しました`,
"label.escalation.setup.newentries.createfirst":`ケースの作成時間により、ケースを初めて修正した後に使用禁止されます。`,
"label.new.ccpeakfolder":`クラス：新規フォルダ`,
"lable.currencyAdv.exchagecurrency.after":`その後`,
"label.majoranddetailrelation":`主‐詳細情報リレーション`,
"label.appointment.wizard.subtitle4-2-1":`1時間`,
"label.projectManagement.working.hours":`労働時間`,
"label.forecast.customforecast.button.forehistory":`予測履歴`,
"label.mymasterplate":`私のテンプレート`,
"component.setup.tabs.label.memo":`タブラベル名の設定`,
"label.customfields.longtextarea.tip":`最大32000文字までの複数行テキストを入力することができます。しかもオブジェクト毎に10つまでの項目しかサポートしません。`,
"label.service.miniProgram.fillJumpLink":`ジャンプリンクを記入してください。`,
"label.british.summer.time":`グリニッジ標準時`,
"label.nogreate":`<`,
"label.assignment.setup.detail.sameuser":`同じユーザ`,
"mesage.error.profile.delate.user":`プロファイルはユーザが割り当てされたため、削除できません。`,
"label.tabpage.cownerz":`所有者の変更`,
"label.multilang.dupicatecheck.processedcount":`{0}件の重複データは処理され、残り{1}件のデータは処理されていません。`,
"vue_label_report_notice_leavecertification":`入力したデータが保存されない可能性があるので、本当にこのページを閉じますか。`,
"label.master.required":`子レコードに記入されていない必須項目があります`,
"label.chatter.follow":`フォロー`,
"label.dataimport.insertdata.error.repeat":`当該レコードは元データベースでのデータと重複しており、エクスポートが見落とされています。`,
"label.sms.cgid":`チャンネルグループ番号`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`対象項目`,
"label.forecast.editshrepage.quanxian":`アクセス権のレベルの共有`,
"label.weixin.interactive.log":`インタラクティブログ`,
"label.batchedit.remark":`複数のレコードに対して、編集することができます。`,
"label.user.permissions.message":`ユーザ情報を設定する権限がありません`,
"label.mobile.phone.month":`月`,
"chatter.sel.u":`メンションする人を選択あるいは@[ユーザ名]を入力`,
"label.service.gantt.assigned.work":`割り当てられた仕事`,
"UG_ST_001":`メッセージ`,
"label.edit.select.one":`ドロップダウンリスト`,
"label.forecast.shrepage.desc0":`このページでは、{0}へのアクセスを共有するユーザ、ロールとエリアが表示されます。`,
"label.multilingual.confirm.close":`本当に無効にしていいのですか？無効にすると、マルチランゲージは使用できなくなり、ユーザーの言語はデフォルトの言語に変更されます。`,
"label.setting.intergrationlist.integration":`イングレーション`,
"label.leadscore.rule.list":`リードスコアリングのルールリスク`,
"component_telerecord_button_save":`保存`,
"label.weixin.save.log":`ログの保存`,
"label.validate.function.funcExplain.DAY":`1カ月の中のある日を返します。1～31まの範囲の整数です。`,
"label.appointmentdetail.wizard.title1":`会議名前`,
"label.multilang.feedtrack.dealkey":`{0}を{1}から{2}に変更します`,
"label.optional.features":`選択可能な機能`,
"vue_label_email_no_email":`メールボックスなし`,
"label.sendemail.chat.messagecontent":`メッセージの内容は`,
"label.tabpage.lessequalz":`小さい或いは等しい`,
"setup.layout.label.setupfield":`設定項目のプロパティー`,
"label.approved.receiveApprovalEmail.option1":`もし私が承認者あるいは代理承認者です。`,
"label.chatter.relateList":`関連リスト`,
"component.sendmail.label.fromuser":`送信者`,
"label.projectManagement.problem.status":`課題状況`,
"label.weixin.fmu.before.hour":`0時間`,
"chatter.feed.menutype.feed.mark":`私がブックマークした書き込み`,
"label.addQuoteLineGroup":`見積り行グループの追加`,
"label.report.action.addtodashboard6":`追加`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`現在と前回のカレンダー年度`,
"label.tabpage.emptyz":`クリア`,
"less":`より小さい`,
"label.h5.selectmostphotos":`最大9枚までの写真を選択することができます`,
"UG.activity.04":`Outlook/Gmailメールボックス　メール履歴`,
"template.chart.qbhtje":`全契約額`,
"label.tabpage.endz":`終了`,
"label.partner.workspace.member":`メンバー`,
"label.filter.error.filedvaluetoolong":`エラー：項目値は最大制限を超えています。`,
"label.months":`月の`,
"button.partner.workspace.disable":`有効化を解除`,
"label.visualpage.checkpinyin.grammar":`スペルの構文をチェつくしてください`,
"label.dashboardSetup.geshihua":`フォーマット`,
"label.belongto":`対象`,
"label.upload.cannot.empty":`アップロードするフォルダは空であってはいけません。`,
"label.number.MaxCheck":`0}の最大値は{1}です。数量を修正して変更を保存してください。`,
"pagecreator.page.message.save.fail":`ページ保存に失敗しました`,
"label.edit.SMS":`SMSアラートの編集`,
"UG_Lead_002":`製品やサービスの「リード」を識別する方法がたくさんあります。`,
"label.quickcreate.active.quickcreate":`クイック新規を有効化`,
"label.recordtypeselect.tip":`このページをスキップするなら、個人設定でレコードタイプの設定を変更してください。`,
"label.form_content":`フォーム`,
"workflow.action.tasks.assignortype.related":`関連ユーザ`,
"vue_label_allsearch_set_more_items":`検索ボックスの左側にあるドロップダウンボックスで、さらに検索項目を設定して検索することができます`,
"label.tianyancha.businessverify.title":`企業認証`,
"label.errormessage.batchedit.norecord":`データなし`,
"label.permission.appname":`アプリ名`,
"label.report.action.addtodashboard7":`キャンセル`,
"label.generated.transfer.product":`アセットコンバージョンの方法に従って、資産を生成します。`,
"vue_label_commonobjects_detail_you":`様`,
"label.user.captcha":`ユーザ確認コードの認証`,
"label.notification.event4":`あなたが【任命先】に割り当てた行動は【開始時刻】に開始します`,
"label.version.setup":`バックグランド設定`,
"setup.object.layout.message.selectedlayoutandrecordtype":`レイアウトとレコードタイプを選択してください`,
"label.role.add":`ロールの追加`,
"label.versiontype.Unlimited":`無限版`,
"label.partnerCloud.financeSetting.developerID":`デベロッパーIDを入力してください。`,
"front-invoice-online-payment-setup-global":`グローバルアカウントに応募する`,
"vue_label_commonobjects_view_basis":`カテゴリの基準`,
"label.decimaldigits.tip":`小数点の右側の桁数`,
"vue_label_commonobjects_detail_selected":`選択したステージとしてマーク`,
"label.data.export.page":`データエクスポートページに入ります`,
"message.error.serviceresource.servicecrewid":`各サービスグループは、1つのグループタイプのサービスリソースレコードだけとして追加されることができます。`,
"label.loginttime.alltime":`ユーザのタイムゾーンの作成者`,
"label.requiredinfo":`必須情報`,
"label.forecast.edit.di":`第`,
"vue_label_calendar_failed_to_remove_calendar":`カレンダーの削除に失敗しました。`,
"pagecreator_systemstyle_button_delete":`スタイルの削除`,
"label.import.page3.continueimport":`インポートを続ける`,
"label.page.width":`フルスクリーンの幅`,
"label.campaignmember.selectmember.addmember":`メンバーの追加`,
"label.finalreject":`最終却下`,
"label.isend":`完了しますか`,
"front-console-conversation":`ダイアログ`,
"label.mr.theLastGroupOfThisPage":`これは最後のグループです。[戻って重複データリスクを参照]をクリックして、重複データを参照します。`,
"label.data.dataexpalltype.all_desc":`現在ユーザーの参照権限があるオブジェクトデータをエクスポートします`,
"label_emailtocloudcc_redmessage7":`バックグランド設定がエラーで、管理者に連絡してください`,
"label.forecast.shrepage.classdes.all":`完全アクセス権－ユーザは参照と予測データのカバーができます。ユーザは共有アクセス権をその他のユーザに付与することができます。`,
"market.contacts":`マーケットの取引先責任者`,
"label.weixin.polls.voter":`投票参加者リスク`,
"template.report.industry.distribution.customers":`アカウントの業界分布`,
"front-electronic-signature-setup":`契約 Infor Autofill と Backfill のセットアップ`,
"vue_label_chatter_removecertification":`メンバー"{name}"を削除しますか。`,
"label.appointment.wizard.subtitle1-2":`15分`,
"label.sso.saml.idp.config.custattr":`カスタマプロパティ`,
"label_tabpage_totalTeamz":`チームの共有`,
"lable.outlook.detail.assigned":`割り当てされたユーザとプロファイル`,
"label.department.user.delete":`削除`,
"label.customcomponent.check.label.same":`表示ラベル名は存在済みです`,
"label.partner.error1":`エラー：ドメインの長さは長すぎます`,
"label.escalation.setup.entrydetail.escalation.notify":`通知`,
"component_todaytask_label_choicestate":`状況の選択`,
"label.customfields.fielddependency.new.step1":`ステップ1.1つのコントロール項目と1つの連動項目を選択します。完了時に[続く]をクリックします。`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`すべての人が見ることができ、このグループへの加入を申請することができます。`,
"label.custom.pixel":`ピクセル`,
"label.quicksave":`クイック保存`,
"label.approved.persion":`代理承認者`,
"lable.info.queue.member":`キューメンバー`,
"label.addattachment.step2.weixin":`ステップ2.［ファイルのアップロード］をクリックして、ファイルをアップロードします。`,
"label.forecast.customforecast.title":`予測`,
"mainpage_setup_chosecomponent_leastone":`少なくとも1つのコンポーネントはホームページに置く必要があります。`,
"label.appointmentconfirmpage.wizard.title2":`今回の予約の詳細日程はメールで送りました。`,
"label.useallselectedapprover":`すべての選択された承認者が全員一致で承認する必要はあります。`,
"label.ccpeak.current.line.return":`現在の行から戻り、引き続き執行しません。`,
"label_new_target_model":`新規ターゲットモデル`,
"label.saving":`保存中…`,
"label.mobile.phone.write":`更新`,
"label.applt.updown.text":`また、自社専用のミニ番組ポータルのQRコードをダウンロードして、Webページや公開記事の中にQRコードを設置し、お客様がQRコードを読み取ることでミニ番組を利用することができます。`,
"label.partner.common.manageSetup":`パートナークラウド管理の設定`,
"label.quickbooks.new":`新規取引先`,
"message.error.color":`colorは空にしてはいけません。`,
"label.project.template.two":`各レコードタイプの設定は、1つのオブジェクトにつき1セットのみです。`,
"label.approval.input.des1":`段階的審査、最大階層は`,
"label.x.axis.cannot.empty":`X軸は空であってはいけません`,
"label.solomon.isiands.time":`ソロモン諸島時間`,
"label.login.access.duedate":`アクセス期間`,
"label.service.dispatch.booking.order":`サービス予約の割り当て`,
"label_shareme_forecast":`私の予測に共有する`,
"label.custom.page.cuspage.height":`ページの高さ (ピクセル)`,
"label.quote.line.group.":`groupName}の引用行グループを削除してよろしいですか？このグループ内の引用行も操作後に削除されます。`,
"label.data.downpage.i_title.num6":`データをインポートする前、正確性を確保するために5本のレコードを含むテストファイルをインポートしすることをお勧めします。`,
"label.\u2019s":`の`,
"label.version.contact.management":`契約管理`,
"label.document.history.user":`ユーザ`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`小数点以下2桁までの正しい金額を入力してください。`,
"label.weixin.target.contract.jine":`契約の目標金額`,
"lable.common":`小計￥0`,
"front-kefu-moudle-sendemail-success":`メールが送信されましたので、セールススタッフができるだけ早くご連絡いたします。`,
"label.service.no.operation.time":`このレコードは、関連操作時間がありません`,
"label.info":`情報`,
"label.ccchat.zw":`昼`,
"label.assignment.setup.newentries.title":`ルールエントリーの編集`,
"label.weixin.report.timeline":`時間軸`,
"UG.quota.04":`見積書の印刷`,
"label.social.user.exception":`ソーシャルユーザーの情報に異常が発生しています。`,
"label.import.index.failed":`失敗`,
"label.common.settings":`一般設定`,
"label.nullvalue":`NULL 値`,
"PageLayout_Search_MultiSearch_002":`カスタマ_索ボックスを有_化する（独自_目の_索）`,
"message.myselfreport":`私の非公開カスタマレポート`,
"label.productsales.today.noevttskaddtsk":`今日、行動予定あるいは期限切れのToDoがありません。右上の「＋」をクリックしてToDoを追加することができます。`,
"lable.oppdt.noconditionrecrods":`条件に一致するレコードはありません。`,
"label.campaignmember.selectmember.deletelead":`キャンペーン：リードからメンバーを削除`,
"label.marketingactivity":`キャンペーン`,
"vue_label_pool_self-built":`自分で作成する`,
"message.textareamaxlength":`長さは4000文字を超えてはいけません`,
"label.valadate.must.value":`値をご入力ください`,
"label.tabpage.groupsVisiblez":`選択されたユーザーグループ`,
"component.button.cancel":`キャンセル`,
"label.emailobject.list.inbox":`受信箱`,
"label.app.step1.error.labelexist":`エラー：表示ラベルは存在済みです`,
"front-calendar-V1-Unable-to-display":`1つまたは複数のレコードの終了フィールドが開始フィールドよりも早い場合、そのレコードはカレンダーに表示できません。`,
"label.forecast.settings.prompt1":`1つ以上の予測オプションを選択：収入と数値`,
"front-kefu-moudle-callout-missphone":`不在着信の呼び出し`,
"label.tabpage.editz":`編集`,
"vue_label_chatter_label_new_team":`新規グループ`,
"label.version.formulafield":`数式項目`,
"label.partner.step1":`ステップ1.テンプレートの選択`,
"label.weixin.perfect.url":`URL情報を改善`,
"label.appointmentconfirmail.wizard.subtitle4":`説明`,
"label.step7.total7":`ステップ　7/7`,
"setup.object.layout.label.selectedprofile":`選択済みのプロファイル`,
"label.payments.paytip5":`正しい数値を入力してください`,
"label.visualpage.open.type":`オープン型カスタマページ種別`,
"lable.Sort.field.tips":`ソートするフィールドを選択して、関連リストの記録順をカスタマイズできます。オブジェクトの数値や日付のフィールドを基準にして並べることができます。`,
"label.nosharerules":`共有ルールが設定されていません。`,
"label.service.miniProgram.bindSetOwner":`ケース所有者の設定`,
"report_label_highlevelreport":`高度なレポートは最大で4つまでのオブジェクト関連レポートを作成することができます。`,
"S":`テキスト`,
"label.lastmodifyby":`最終更新者`,
"label.customerinfo.mailaddress":`送信メールアドレス`,
"vue_label_pool_converted":`置換え済み`,
"UG.ST.004":`データ管理-》データのインポートの権限を持っていないので、管理者に連絡してください。確認をクリックして{0}インターフェイスに直接に移動します。`,
"label.view.application.mobile.terminal.filed":`このビューはモバイル端末に応用され、最大10つまでの項目が選択できます。現在選択した項目は`,
"chatter.feed.limitentity500":`最大500までの人とレコードをフォローすることができます`,
"label.starttime":`開始時刻`,
"chatter.emailToMe":`ユーザが次の動作をした場合にメール送信`,
"label.custom.Current.and.PreviousCQ":`現在と前のカスタマ四半期`,
"label.my.logout":`私`,
"label.quickbooks.searchlist.enddate":`終了日`,
"label.ccservice.validate.length":`オブジェクトAPIは{0}の下の{1}項目で対応値が{3}です。その長さが超えており、改めて設定してください。`,
"label.integrations.installed":`権限が付与されている`,
"label.integrations.mailchimplist":`Mailchimp リスク`,
"label.checkfield.matchothers":`その他の一致レコードの指定`,
"label.umeng.activity.event.distributewillbegin":`#name様に割り当てした行動#eventは#timeから開始します`,
"pool.notice.gotolightning":`この機能を利用する場合、Lightningバージョンにアクセスしてください。`,
"label.batchtransfer.pleaseselecttransferreddata":`移行するデータの選択`,
"label.mr.title.mailingAddress":`郵送先`,
"vue_label_approve_no_response":`無回答`,
"component.event.label.title":`間もなく行う行動`,
"label.mobile.setup.confirm":`モバイル端末のデフォルトタブアイコンの位置情報を更新しており、更新した後に、以前タブで配置されたすべてのモバイル端末タブアイコンは削除されます。タブでモバイル端末アイコンは再設定されない限りに、設定したディレクトリからランダムで選択されます。`,
"label.tianyancha.approvaltime":`承認時間`,
"label.download_merge_file":`マージファイルのダウンロード`,
"label_display_quota":`クォータを表示する`,
"label.publishreadonly":`公開/参照のみ`,
"label.campagin.roi.query.roi":`キャンペーンROI`,
"label.dashboardSetup.lookup":`ダッシュボードの検索`,
"vue_label_notificationcenter_nomessages":`未読のメッセージがない`,
"label.create.object":`新規オブジェクト`,
"label.social.campaign.null":`カンパジンの情報は空ではない`,
"label.console.step6.left":`左側に固定します。リスクはいつでも参照可能です。`,
"label.line":`列`,
"label.bottonandlink.introduce":`以下はボタンとリンクのリストです。ボタンあるいはリンクを追加するには、ページレイアウトを編集して下さい。
ボタンは詳細情報ページ、関連リストとリストビューに表示されます。
1.詳細情報ページにおけるボタンあるいはリンクをカスタマイズするなら、ページレイアウトを編集して下さい。
2.関連リスクにおけるボタンあるいはリンクをカスタマイズするなら、ページレイアウトで関連リストリストのプロパティを編集してください。
3.リスクビューにおけるボタンあるいはリンクをカスタマイズするなら、検索レイアウトでリスクビューレイアウトを編集してください。`,
"label.layout.list1":`リスト1`,
"label.mr.title.customerName":`取引先名`,
"label.user.text":`本文`,
"label.nolastestrecord":`最新のレコードはありません`,
"label.emailobject.appointment.urltext1":`これは私のスケジュールです。どうぞ`,
"label.chat.topic.my.favorites":`私のお気に入り`,
"label.select.dashboar.cd0":`グループ化項目は空であってはいけません`,
"label.data.downpage.e_title.num2":`2、個別オブジェクトデータをエクスポートする場合、エクスポート方法を選択する必要があります。データエクスポートの方式には、カスタマエクスポート、 テンプレートによるエクスポート、テンプレートのエクスポートがあります。`,
"message.error.user.service.login.unconn":`サーバーにエラーが発生し、少々お待ちください。`,
"label.escalation.setup.newentries.title":`ルールエントリーの編集`,
"label.import.step1.above2000":`トリガーを実行すると、一度に最大2000件までのレコードをインポートすることができます。複数のファイルに分割して、インポートしてください。`,
"label.ccchat.person.allowinvite":`同僚の招待を許可`,
"label.input.number.between":`{0} から {1} までの数値をご入力ください`,
"label.forecast.shrepage.wpfmanager":`代理予測マネージャー`,
"label_server_is_time_out":`サーバーがタイムアウトしています。後でもう一度お試しください。`,
"label.indochina.standard.time":`インド標準時`,
"label.cpq.quote.sync.opportunity.failure":`機会と同期できるのは、主な見積書のみです。主な見積書のボックスにチェックを入れてから同期を開始してください。`,
"label.emailobject.send100emails":`すみません、毎日100通のメールしか発送できません。もう一度選んでください。`,
"label.dashboard.snapshot.end":`締切`,
"label.jiandangfenpei.rightlist":`割り当てされたプロファイル`,
"label.input.string.length.between":`長さが{0} と {1} の間の文字列を入力してください`,
"label.multilang.lookfiltercondition.select":`第{0}行の条件にエラーが発生し、1つの項目を必ず選択してください。`,
"label.datamanage.lead.namenull":`ご注意：[リード名]項目に割り当てしないと、レコードはインポートされることができません。`,
"label.forecast.detailforecast.button.saveandfresh":`保存&更新`,
"label.venezuela.time":`ベネズエラ時間`,
"label.same.analyze.miaoshu1":`より多いルールが必要であるなら、」を使用してください。`,
"label.twomb":`アップロードできるのはjpg/pngファイルのみで、サイズは2MBまでです。`,
"label.event.moveup.7hour":`7時間`,
"label.weixin.forgot.password":`パスワードを忘れました`,
"label.import.page1.diledsizelimited":`2.アップロードするファイルのサイズは最大100Mまでです`,
"label.file.foldername":`フォルダ名`,
"label.multilingual.open":`MultiLangiuage Managementが有効です。`,
"label.dashboard.snapshot.refresh.failed":`ダッシュボードスナップショットの更新に失敗しました`,
"label.marketsea.memberfieldselectone":`表示項目とメンバーが参照可能な項目を 少なくとも1つ選択してください。`,
"label.trigger.createdate":`作成日`,
"label.ccpeak.operation.sharetab":`アクション共有リスト`,
"label.partner.message.admin.access":`システム管理者のみ登録できます`,
"label.emailsync.status.email":`メールの操作`,
"chatter.error":`エラー：先ずアップロードするファイルをご選択ください`,
"label.role.viewinlist":`リスク形式で表示`,
"label.tag.addtags.title":`表示ラベル`,
"setup.mainpage.label.welcome6":`ユーザーはプログラミングの知識やコード開発を必要とせずに、CloudCCシステムのすべてのオブジェクトに様々なタイプの項目を作成することができます。項目の種類には、検索関係、単一選択項目、二重項目選択、数式、自動採番、URL、電話、FAX、電子メール、チェックボックス、日付、時間、数字、テキスト、テキストエリア、オプションリスト（単一/複数選択）、通貨などあります。`,
"label.delete.rule.successfully":`ルールの削除に成功`,
"label.field.duplicate.error.msg6":`項目値が重複します。既存のレコード:`,
"label.stdashbord.xsld.business.jhzsl":`商談件数`,
"label.compact.layout":`キー情報のレイアウト`,
"label.checkfield.merge.introduce":`マージしたレコードで保有する値を選択してください。`,
"earlieststarttime.duedate.time.illegal":`サービス予約の最も早い可能な開始期日は満期期日よち小さいべきです。`,
"label.dataimport.validate.prompt":`入力規則のメッセージ`,
"message.setuptip":`作成した後に、削除してもいいです。`,
"template.report.customer.collection.statistics":`アカウント決済統計`,
"vue_label_homepage_dashboardcomponents":`ダッシュボードコンポーネントの編集`,
"setup.mainpage.label.welcome30":`CloudCCプラットフォームは、真のクラウドコンピューティングプラットフォームです。このプラットフォームのオープンな属性、標準的な統合方法、柔軟なカスタマイズは、あらゆる業界に適用でき、サードパーティのソフトウェアを統合し、企業の管理データのリアルタイムな統一を実現し、お客様の包括的で詳細な管理ニーズを最大限に満たします。CloudCCプラットフォームは、SAP、Kingdee、UFなどのソフトウェアを含むあらゆる企業のアプリケーションやシステムとを統合するのが可能です。柔軟なSOAアーキテクチャの下、標準的なWebサービス方式を採用しているため、いかなる破壊性、技術依存性やベンダーロックインは存在しません。`,
"label.SMS.new.det":`1つあるいはより多くのワークフロールール、承認プロセスに関連するよう、SMS通知を作成する。SMS通知を変更するなら、すべての変更はこれらに関連するルール、承認に応用します。`,
"lable.product.page.previous":`前のページの戻る`,
"label.recordtype.labelname":`レコードタイプの表示ラベル`,
"message.error.system.service.failure":`サービスの執行に失敗し、システム管理者に連絡してください。`,
"label.visualpagefolder":`ページフォルダ`,
"label.username":`ユーザ名`,
"label.data.downpage.i.title.num5":`5、データの正確さを確認してください。`,
"label.permission.manage":`割り当ての管理`,
"label_emailsync_status_user":`ユーザ`,
"label.weixin.voting.least.two":`投票選択肢は少なくとも2つあります`,
"label.tabpage.thisrecord":`このレコード`,
"label.icon.119":`黒板`,
"label.partner.common.webSit":`ドメイン名`,
"label.email.form.html2":`「本文のみ」に切り替え`,
"label.appupload.upload.noversion":`アップロードされたバージョンがありません`,
"label.appointmentpage.wizard.subtitle1_2":`招待者のタイムゾーンは{0}です。`,
"MR":`複数選択の検索`,
"label.partnerCloud.orderingPlatform.availableBalance":`残高`,
"label.schedulejob.setup.schedule.st3":`三番目`,
"label.reportsSubscriptionPage.email.general":`簡略`,
"label.setsharerule.step4":`ステップ 4.権限の選択`,
"front-epwechat-module-v1-info-desc":`ウィーコムのバックエンドから情報を得て、ここに記入してください。`,
"message.duplication.label.isactive":`有効`,
"pagecreator_systemstyle_label_linkcolor":`リンク色`,
"label.import.page1.alertfiledsize":`アップロードするファイルは100MBを超えてはいけません。`,
"tomorrow":`明日`,
"label.publicdashboard":`ファイリングされていない公開ダッシュボード`,
"label.knowledgebase.same.taborworkspace":`同じタブやワークスペース`,
"homepage.layout":`ホームページのレイアウト`,
"label.emailobject.trackemailopening":`メールの追跡`,
"label.unlock.tip":`ロックをキャンセルして、編集できます。`,
"lable.account.NextzDays":`これからの90日`,
"vue_label_report_throw":`廃棄`,
"label.icon.102":`スケジュール`,
"label.payments.paytip2":`有料版にすでにアップグレードし、確認をクリックすると、このウィンドウが閉じられてCRMシステムは更新されます。`,
"label.customfields.email.tip":`メールアドレスを入力できます。入力されたアドレスは、入力形式が正しいかどうかが認証されます。クリックすると、自動的にメールソフトが起動され、メールを作成して送信できます。`,
"label.test_visitors":`訪問者が見たときにフォームがどのように見えるかをテストします。`,
"label.workflow.immediatelyoperate":`ルール適用時のアクション`,
"label.approvalstep4.tip":`承認ページでは承認者は申請を承認しまたは拒否します。下記のオプションを使用して、このページで表示する項目を選択します。`,
"label.ccchat.person.invite.failsend":`以下の案内状の送信に失敗し、管理者に連絡してください。`,
"label.import.index.obj":`オブジェクト`,
"label.multilang.leadscore.countnum":`{0}回`,
"label.report.error.typefind":`グループ化情報でレポートタイプが見つかりませんでした`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`使用可能なグループ化データはありません`,
"lable.Create.new.template":`新規サービスレポートテンプレート`,
"label.knowledgebase.display.error":`Show {a} Mistakes`,
"label.emailobject.template.message2":`現在のメールの本文に挿入されている項目は、関連付けたレコードと一致しないため、Null値になる可能性があります。`,
"label.productsales.today.taskcomplete":`完了に設定`,
"label.emailobject.selectone":`メールの宛先としてレコードを少なくとも一つ選んでください。`,
"button_partner_workspace_saveas_memo":`当該パートナークラウドを別称でテンプレートに保存します。`,
"vue_label_help_detail":`レコードの詳細`,
"label.tabpage.minutesagoz":`分前`,
"label_tabpage_characterz":`スタート文字`,
"message.error.accesstoken.null":`トークンは空ではありません。`,
"label.textMessageObject.send100":`申し訳ありませんが、1日に100通のテキストメッセージしか送信できませんので、再度選択してください`,
"vue_label_commonobjects_detail_record_call":`新規通話履歴`,
"label.campaignmember.main.addlead":`メンバーの追加‐既存リード`,
"setup_mainpage_label_welcome30":`CloudCC クラウドプラットフォームは、本格的なクラウドプラットフォームで、そのプラットフォームのオープンプロパティ、スタンダートイングレーション方式、柔軟なカスタマイズが各業種や第三者ソフトウェアの統合に適用されており、企業データのリアルタイム管理を実現し、取引先の管理ニーズを最大限に満たすことができます。CloudCC プラットフォームは、SAP、金蝶、使用友等の第三者のソフトウェアに統合でき、柔軟なSOA に基づくWeb Service方式を採用して、いずれの破壊性がなく、他社の技術に依存せず、他のメーカーにもロックされない。`,
"label.file.library.deleteprompt":`ライブラリーのメンバー{0}を削除しますか。`,
"label.wtd.changefields.title":`Web to CloudCCの設定`,
"label.sendmail.step1":`ステップ 1. 送信する宛先を選択`,
"label.cpq.newquote.createorder.checkbox.selected":`見積書の新規作成時に「注文の作成」のチェックボックスが選択できない。`,
"label.emailtocloudcc.name":`名前`,
"message.error.object.nullbinding":`bindingが空です`,
"B":`チェックボックス`,
"label.pc.endtime":`ライセンス有効期限が切れるまで30日間に足りないですが、支障なく使用することができるため、リチャージしてください。`,
"label.visualpage.section.start":`スタートで表示ラベル`,
"label.partnerCloud.basicSetting.available":`ドメイン名は利用可能です。`,
"label.data.exportall.all_desc":`現在ユーザーの参照権限があるオブジェクトデータをエクスポート`,
"label.editor.layout":`検索レイアウトを編集`,
"label.send.chatter":`書き込みの発信`,
"label.h5.chatter.reply":`クイック返事`,
"component_chatter_post_button_file":`ファイルの追加`,
"label.emailobject.emaildetail.button.reply":`返事`,
"label.eidt.queue.title.desc":`名前は一意で、文字から始まり、アンダースコアと英数字しか使用できません。また長さは50文字を超えてはいけません。`,
"label.campaign.channel.input.url":`5 .ユーザーが登録した後に、感謝ページ、キャンペーンリストまたは入場券など参照できる情報を設定して下さい。`,
"label.compact.layout.assign.tip":`このリストはレコードタイプ毎のキー情報レイアウトの割り当てを表示します。`,
"vue_label_fall":`降下`,
"label.trigger.save.failed":`保存が失敗し、データは空であってはいけません`,
"label.appupload.upload.tips.report":`ご注意：[私の非公開カスタマレポート]と[ファイリングされていない公開レポート]の中でのレポート、古いレポートはパッケージに追加されることができません。またこのリスクで表示されることもできません。`,
"label.tianyancha.businessverify.rewriteall":`すべてのベータを記入`,
"label.campaign.channel.step6.remark4":`ご注意：リードの所有者は現在キャンペーンの所有者あるいは販売チャンネルの招待人です。`,
"front-kefu-moudle-called-num":`ダイヤルした番号`,
"label.approvalstep4":`ステップ4.承認ページで表示する項目を選択`,
"label.login.verification.please.scan":`スマートフォンのMFAアプリケーションを使用して、QRコードを読み取ります。`,
"label.invoice.message.statusupdated":`Invoiceステ_タスは更新_みです`,
"label.pc.ui.2018.subject":`トピック`,
"label.area.notexist.userinfo":`存在しないユーザチーム`,
"label.newuser":`新規ユーザ`,
"label.chat.micropost.share":`投稿の共有`,
"label.locatedupcurrentvalue":`現在の値の上にある値`,
"vue_label_systemSettings_course":`ライトニングパスの設定`,
"chatter.group.public":`公開`,
"label.reportsSubscription.entrance":`購読`,
"front-kefu-moudle-v1-online-at":`オンラインエージェント`,
"label.rejectbehaviourselect":`このステップの却下アクションのみ行い、この承認申請を直近の承認者に戻します。`,
"vue_label_commonobjects_view_currentviewset":`現在のデフォルトビューの設定を解除するために、他のビューをデフォルトビューとして設定することができます`,
"lable.currencyAdv.and":`と`,
"label.appexchange.installedpage.publish":`リリース者`,
"label.tab.profile.ismobile":`モバイル端末に応用`,
"label.data.setok.t.desc2":`データテンプレートページに戻る`,
"label.email_required":`メールは必須です。`,
"label.tabpage.fullscreenz":`フルスクリーン`,
"chatter.sticker.set":`書き込み追跡の設定`,
"label.mobile.phone.year":`年度`,
"label.projectManagement.next.page.before":`前のページ`,
"pagecreator_button_pcpage":`PC端末`,
"label.dashboard.xsld.percent":`割合`,
"label.ccpeak.service.checkerror":`構文チェックに失敗しました`,
"label.icon.26":`フォルダ`,
"label_partner_common_webSit_memo":`御社のパートナークラウドのデフォルトドメイン名：`,
"label.unselectfile":`未選択のファイル`,
"label.take.notice":`注意`,
"message.error.filename.null":`fileNameは空にしてはいけません。`,
"vue_label_SMS_nophone":`電話番号なし`,
"label.area.assignuser":`ユーザの割り当て`,
"label.icon.176":`促す`,
"label.icon.21":`通貨`,
"message.error.system.service.deletedeny":`データは関連付けられて、削除できません。`,
"label.compact.layout.main.tip":`このオブジェクトのレコードがCloudCCでリストオプションに使用するキー情報レイアウトを選択します。`,
"label.emailtocloudcc.delete":`削除`,
"label.dashboardSetup.showdw.d2":`千万`,
"front-kefu-moudle-hqyyjlsb-admin":`音声記録の取得に失敗しました、管理者に問い合わせてください`,
"label.partnerCloud.basicSetting.userCounts":`パートナーの役割の合計`,
"front-kefu-moudle-calling-num":`呼び出し番号`,
"label.alldocument":`すべてのファイル`,
"coderules.nullvalue1":`生成に失敗しました。生成ルールで使用する【{0}】の値を入力してください。`,
"lable.automatically.shared":`自動共有`,
"label.batchadd.newbatchpage.save.emptyselect":`必須項目は選択されていません。チェックしてください。`,
"vue_label_homepage_card_30dayswithout":`30日間連絡していない商談`,
"label.multilang.dupicatecheck.onegroupnote":`2つのデータをチェックし、[選択した情報のアップロード]をクリックして、データマージページに入ります。現在は{0}番目の企業情報で、{1}件のレコードがあります。`,
"UG.activity.03":`スケジュールの予約`,
"label.pc.oldpage":`古いバージョンのページ`,
"label.exchange.sync.state.task.m2":`最後60分間の同期レコード`,
"label.setmovable":`活動の設定`,
"label.sendemail.send.loginfail":`メールのログインに失敗しました。メール情報を改めて設定してください。`,
"label.copy.quote.lines":`クローンの見積もりライン`,
"label.copying.reward.to.groups":`見積もりライングループへのコピー`,
"label.ems.connect.error":`サーバー接続に失敗し、チェックしてください。`,
"lable.account.Tomorrow":`明日`,
"label.manageAll.sta2":`承認通過`,
"label.create_form":`新しいフォーム`,
"label.ems.saveDetail.error.msg":`保存に失敗しました。メールボックスのアカウントやパスワードなどの情報をチェックしてください。`,
"label.service.gantt.distribution.recommendation":`アサインされた提案`,
"label.email.track.attachment.size.control2":`アップロード中のファイルは10Mを超えているため、引き続きアップロードできません。`,
"lable.product.pricebooks.add":`価格表に追加`,
"label.login.time":`ログイン時刻`,
"label.tabpage.yes1z":`はい1`,
"label.SalesCommitmentKanBan":`販売承諾ボード`,
"label_partner_workspace_myspace":`私のワークエリア`,
"chatter.like":`受信したいいね!`,
"lable.PowerProcess.number.input":`整数を入力してください。`,
"chatter.coll":`ブックマーク`,
"label.campaign.channel.img.remark":`注意：画像サイズは2Mを超えてはいけません。`,
"label.field.duplicate.error.msg7":`重複データ`,
"vue_label_pool_discard":`廃棄`,
"label.service.gantt.total.planned.duration":`サービス予約の計画継続時間の合計`,
"label.weixin.click.loadmore":`クリックしてさらにアップロードします`,
"label.help.new.features.yd":`PC端末の新しいインターフェースの操作ガイド`,
"label":`表示ラベル`,
"label.quickbooks.viewlist.total1":`合計で{0}件の請求書で、合計で{1}になる`,
"front-kefu-moudle-v1-input-publicKey":`共有キーを入力してください`,
"label.approval.allowed.reject":`拒否ができます`,
"label.visualpage.folder.notdel":`当該フォルダはファイルを含み、削除できません。`,
"label.projectManagement.charging":`小計`,
"label.ccservice.validate":`オブジェクトAPIは{0}の下の{1}項目で対応値が{2}です。その表示形式がエラーで、正しい数字を入力してください。`,
"message.unbind.mfadevice.no.permission":`MFAデバイスのバインディングを解除する権限がありません。システム管理者に連絡してください。`,
"label.partner.new.step3.meno":`何を入力するか確認できくても大丈夫です。随時に更新できますから。`,
"label.import.page3.importsucceedtip":`インポートされています。インポートが完了された後、バインディングされるメールボックスにメールを送信します。`,
"label.customsetting.visible.protect":`保存済み`,
"label.publishreadandwrite":`公開/参照?更新可能`,
"vue_label_file_add_most_once":`1回の最大追加回数`,
"label.salescloud.teamrole.optionlist.group":`ロールを商談チームメンバーと取引先チームメンバーに割り当てる`,
"label.appointment.wizard.subtitle7":`場所`,
"label.task.dateminus":`マイナス`,
"label.data.exp.zippwd":`手動でパックファイルの暗証番号を入力します`,
"UG_Forcast_09":`次のステップへ`,
"message.duplication.label.allselectlink":`「すべて選択」`,
"label.file.ccchat.selectfromcloudcc":`CloudCCから1つのファイルを選択してください`,
"label.ems.addaccount3":`アカウントの追加`,
"front-epwechat-module-v1-schedule-sync":`スケジュールの同期`,
"label.h5.manage":`アプリケーション管理`,
"setup.layout.label.nobutton":`選択可能なボタンはありません。`,
"label_component_hotdeal":`ホットトレード`,
"template.dashboard.contract.analysis":`契約と債権の分析`,
"vue_label_dashboard_editcomponent":`コンポーネントの編集`,
"label.quotationInformation":`見積書の情報`,
"label.data.file.validation_rules":`入力規則の執行`,
"label.ccpeak.construction.shareobj":`オブジェクトの共有リスクオブジェクトを作成するには、オブジェクトのAPI名および共有アイコンを記入する必要があります。`,
"label.wei.pollinformation":`Micro Voteの一般情報`,
"label.quickbooks.viewlist.total3":`合計で{ 0 }件の支払で、すべて{ 1 }です`,
"label.paging.totalofpagesnoid":`{0}ページ`,
"label.unlock":`ロックのキャンセル`,
"front-invoice-online-payment-information":`インボイス情報`,
"label.permission.systempermission":`割り当てされたシステムの権限`,
"message.error.object":`サービスを呼び出すとき、オブジェクトがカスタマイズされていないことが分かりました。`,
"font-trade-module-v1-invoice-intro":`請求書番号または請求書名を入力してください。`,
"label.userinfo.pwdexpired":`現在のパスワードは期限切れになっています。安全 性を確保するために、パスワードを更新してください。`,
"label.userphoto.photo":`写真`,
"label.tabularreport.filterrecord":`どれのレコードが使用する条件を表示するか確認してください。`,
"label.partnerCloud.orderingPlatform.rechargeIt":`アカウントの残高が不足しているので、追加してください。`,
"label.icon.120":`コンピューター`,
"label.projectManagement.select.new.type":`新規タイプを選択`,
"vue_label_commonobjects_detail_customer_details":`取引情報の読み込み`,
"label.ems.status":`状況`,
"label.validate.function.description":`入力ルールでjava構文に適用するいずれの関数を使用することができ、エクスプレッションは1つのブール値を返す必要があります。CloudCCが提供する特定の関数も使用可能です：isNew(),isChanged(項目Api名__c),priorValue(項目Api名__c),priorValue()object種別を返し、対応する項目種別に置き換える必要があります。`,
"label.escalation.setup.newaction.step2":`ステップ2.自動的にケースを割り当てるユーザの選択`,
"label.forecast.customforecast.searchforecast":`予測の検索`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`ブロック単位で価格を設定する場合、各レベルの上限値は下限値より必ず大きいです。`,
"vue_label_commonobjects_view_notice_deletefailreason":`ID {0}のデータの削除に失敗しました。失敗理由は{1};です`,
"page.field.masterinput.remark":`有効になっているマスター/ディテール入力はタブページで関連リストレコードの作成に使われています。`,
"lable.SalesCommitmentKanBan.contractName":`契約名`,
"front-gantt-module-add-milestone":`マイルストーンの追加`,
"label.callcenter.save.error":`繰り返し保存しないでください`,
"label.workflow.selectobj":`ステップ1.オブジェクトの選択`,
"label.validate.function.category.all":`すべての関数カテゴリ`,
"label.multilang.uploadifupage.select":`{0}個のファイルを選択しました`,
"label.weixin.dragsort":`わたしのアプリケーションでのアイコンをドラッグして、改めて並び替えることができます。`,
"N":`数値`,
"label.knowledge.article.translation.completed":`記事の翻訳完了`,
"label.weixin.myapp":`私のアプリケーション`,
"label.icon.138":`通貨`,
"vue_label_chat_create_discussion_now":`すぐディスカッションを作成します`,
"label.knowledge.recover.article":`記事の復元`,
"label.ccpeak.use.class.time.map":`Listへの導入を通じてセットでアクセスします`,
"front-email-payment-error-tips":`インターフェースエラー`,
"label.service.gantt.ziyuan":`に限る`,
"label.upload.error":`失敗しました`,
"label.staticresource.upload.error":`静的リソースのアップロードに失敗しました。`,
"com.cloudcc.login.error.message.loginfail":`操作に失敗しました、管理者に連絡してください`,
"pagecreator_button_back":`前のステップ`,
"label_tabpage_skip":`スキップ`,
"label.pw.old":`旧パスワードを入力してください`,
"pagecreator.layout.label.modifylayout":`レイアウトエディター`,
"vue_label_chatter_share_group":`チームとの共有`,
"label.app.edit":`アプリケーションの編集`,
"label.user.Email.repeat":`メールが重複しています。このユーザーはエージェントとの結合に対応していません`,
"label.field.quilt":`当該項目は`,
"label.projectManagement.Groupuser":`ユーザーによるグループ化`,
"label.deleteall":`すべてを削除`,
"label.appexchange.download.tiaoguo.mes":`下記のコンフリクトコンポーネントのインストールをスキップします。`,
"label.sendemail.recycle.operatehello":`#username様 こんにちは:\r\n`,
"label.emailmerge.mergeFolder.max20templates":`最高20までのテンプレートを選択することができます。`,
"label.campaignmember.main.deleteleaddesc":`キャンペーンからすべての取引先責任者を一括削除します`,
"Opportunity_Detailed_Phase_Label_Popup_003":`滞在日数`,
"vue_label_file_no_title":`タイトルなし`,
"label.data.dataexpalltype.all.desc":`当該ユーザーが参照可能すべてのオブジェクトのデータをエクスポートします。`,
"label.dashboard.unit2":`単位：百万`,
"label.list.userinterface.isrelatedlist":`関連リストのフロート表示リンクを有効化`,
"label.role.tree":`組織のロール階層は以下のようです`,
"label.campagin.roi.zcsl":`登録件数`,
"message.error.forecast.setupchange":`アクセスするデータは他のユーザにされ、または変更されたため、見つからないです。`,
"label.sendemail.changeowner.dataname":`フォルダ名が#datanameのファイル`,
"label.salescloud.opportunity.contactrole.optionlist":`取引先責任者の役割 選択リスト値`,
"setup_mainpage_label_welcome1":`相応の権限が必要です`,
"UG_activity_02":`ToDoの割り当て`,
"label.tabpage.erraddressz":`メールアドレスの形式が正しくありません。正しいメールアドレスを入力してください。`,
"label.weixin.nicheng":`Wechatのニックネーム`,
"label.forecast.settings.mrsz":`デフォルトの予測数値`,
"label.campaign.channel.download.size3":`小サイズ：1000×1000ピクセル`,
"label.icon.73":`工作機械`,
"label.ServiceCloud.suoxuchanpin":`必要な製品`,
"label.escalation.setup.newrule.description":`ルール名を入力して、有効になっている［チェックボックス］を選択し、自動的にこの割り当てルールがケースのレベルアップに使用されます。当該ルールが有効されたら、現在のケースのエスカレーションルールの使用が禁止されます。`,
"label.data.import.setup.whichfield.cloudccid":`CloudccID`,
"label.validate.function.funcExplain.PRIORVALUE":`オブジェクト種別に戻って、対応する項目種別に置き換える必要があります。`,
"Lead.Scoring.Warning.001":`1つのリードレコードを作成・編集する際に、自動的にスコアリングします。しかし、一括インポートやインターフェースで作成されるリードなら、手動でスコアリングする必要があります。`,
"label.tianyancha.businessverify.msg9":`北京神州雲動科技股份有限公司は本「協議」の釈明権を持っています。`,
"label.compact.layout.tip":`キー情報レイアウトにより、詳細情報ページでレコードの詳細情報のキー項目が表示されます。`,
"label.visualpage.btype":`レポート`,
"label.textmessage.vonage.settings":`設定`,
"label.field.not.exites":`存在しません`,
"label.payment.switch.version":`エディションを切り替え中`,
"label.ems.hour":`時間`,
"label.weixin.cannot.edit":`当該ファイル種別は編集できません。`,
"chatter.pt.limit":`ファイルの最大サイズは`,
"label.quote.detailinfo.add":`見積書の明細を追加`,
"component.setup.label.displayfield":`表示項目`,
"vue_label_report_reportfolder":`レポートのフォルダ`,
"label.gbkencoding":`簡体字中国語(GBK)`,
"front-kefu-moudle-v1-Transfer-to":`転送先 {TransferName} への転送`,
"label.file.stop.sharing.desc2":`共有`,
"label.textmessage.messageCannoutuse":`不可能です。管理者に連絡してテキストメッセージを有効にしてください。`,
"component_newrecords_label_type":`メモリーの種類`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`新規価格表`,
"vue_label_newfile":`新規ファイル`,
"label.reportTypcrtB":`関連オブジェクト（B） クリックして関連オブジェクトを選択してください`,
"label.knowledgebase.type":`カテゴリー`,
"label.report.select.format":`レポートタイプを選択`,
"component.todaytask.label.title":`今日のToDo`,
"message.undelete":`確かに復元しますか`,
"label.ccdocument.trace.retention":`履歴保留機能`,
"label.publicgroup.tip":`公開グループは複数のユーザで構成されます。個々のユーザ、他の公開グループ、特定のロールまたはテリトリーに属するユーザを含みます。`,
"label.forecast.settings.lable2":`フィードデフォルトビューの予測`,
"label.projectManagement.positive.integer":`0～24の正の整数を入力してください`,
"label.projectManagement.one.work.list":`少なくとも1つのワークリストに記入してください。`,
"label.or":`あるいは`,
"label.projectManagement.no.person.in.charge":`責任者がありません`,
"vue_label_commonobjects_detail_an_email":`メールを送ります`,
"front-electronic-signature-field-mapping":`フィールドマッピングの追加`,
"label.marketsea.name.error":`プール名は空にしてはいけません。`,
"component.setup.button.appurl":`本システムのURL`,
"label.mr.title.button.group1":`第`,
"chatter.contact":`連絡先`,
"vue_label_pool_hasfixed":`決まった提携チャンネルがあります`,
"lable.list.queue.des":`キューを使用するユーザグループはより効果的に共有する仕事を管理することができます。`,
"label.reportsSubscriptionPage.condition":`条件の設定`,
"label.transwork":`トランスレーションワークベンチ`,
"label.batch.batchopration.resel":`移行するデータを再選択し、［OK］をクリックしてビューリストページにスキップします。`,
"label.cloudccsite.new":`新規サイト`,
"label.button.select.page.required.field":`ページの必須項目を選択`,
"label.pagelayout":`ページレイアウト`,
"label.weixin.trace.record":`追跡記録`,
"label.emailtocloudcc.clear":`クリア`,
"label.checkfield.find":`重複検索`,
"message.view.count.title0":`現在のページの集計`,
"label.reportsSubscriptionPage.schedulereport.frequency":`頻度`,
"setup.mainpage.label.welcome5":`カスタム項目`,
"label.implementation.details":`詳細情報の執行`,
"label.attendance.history":`勤怠履歴`,
"label.is.pigeonhole":`アーカイブしますか。`,
"lable.account.CurrentandPreviousFYt":`現在と2つ前の会計年度`,
"label.forecast.customforecast.tab.opportunity":`販売機会の子タブ`,
"label.version.business.track":`ビジネスチャンスの追跡`,
"label.profilelayoutedit.selectrecordtype.tip":`ユーザプロファイルにレコードタイプを選択します。詳細情報ページと編集ページで当該レコードタイプ項目を表示するために、これをこのプロファイル関連のページレイアウトに追加する必要があります。`,
"label.campagin.roi.zclzb":`登録数の割合`,
"label.validate.function.funcFormat.WEEKDAY":`WEEKDAY(date)`,
"label.view.sort.message":`{!sort}に基づき、並び替えます`,
"page.field.masterinput.sort":`マスター/ディテール入力は保存時間に基づき表示される`,
"label.selected.field":`選択済みの検索項目`,
"label.product.proofTwo":`0}では、{1}以上の商品の選択肢を選んでください。`,
"vue_label_report_filtercondition":`フィルター条件`,
"label.forecast.shrepage.desc1":`0`,
"label.file.copy.link":`リンクのコピー`,
"vue_label_chat_movedto":`{name}は{label}を{newField}に変更しました`,
"label.layout.new.built":`新規部分`,
"label_tabpage_crecordtypez":`レコードタイプの更新`,
"label.report.searchcustominfo":`検索時に使う一致するカスタマレポートのキーワードを入力`,
"chatter.feed.menutype.user":`人`,
"label.recordtypeselect":`レコードタイプを選択`,
"label.partner.new.step3":`ステップ3.名称とURLの入力`,
"label.newCustomReportType":`新規カスタマレポートタイプ`,
"label.service.gantt.day.timescale":`ディリービューで表示する時間と時刻：`,
"label.displaytype3":`リストボタン`,
"label.weixin.discharge.rate":`排気量`,
"label.weixin.menu.message":`メニュー情報`,
"label.mask.show.all.characters":`サブネットマスクのすべて文字を表示`,
"label.quickbooks.fieldlabel.billingaddress":`請求先`,
"Dashboard.View.All":`すべてのダッシュボード`,
"setup_mainpage_label_welcome22":`アクションガイド：このページの右側のメニュー → 管理の設定 → 通信テンプレート →メールテンプレートをクリックしてください。`,
"chatter.group.groupInformation":`チーム情報`,
"front-epwechat-module-v1-input-secret":`秘密を入力してください。`,
"lable.Set.value.prompt":`または、関連リストに表示されているレコードをフィルタリングします。チェックボックス、またはピックリストのフィールドと、フィルタリングしたい値を選択します。値を手動で入力する場合は、カンマで区切ってください。`,
"label.appupload.upload.from":`より`,
"label.weixin.postunsolve":`期限切れ`,
"label.cooperation.all":`すべてコラボレーション`,
"lable.PowerProcess.close.time":`{detailInterestType}の終了時間に基づく`,
"lable.opppdt.selPdt.leastone.fields":`以下のいずれかの項目を選択してください`,
"label.emailtocloudcc.help":`正しいメールパスワードまたは認証コードを入力してください。第三者のアカウントでログインするために、メールサーバーでIMAP/SMTPサービスを有効にする必要がある場合は、まずメールアカウントの設定にログインしてサービスを有効にし、適切な認証コードをこのパスワード入力ボックスにコピーしてください。`,
"label.attendance.offwork.time":`退勤時間`,
"front-gantt-module-v1-project-gantt":`プロジェクトガントチャート`,
"label.chuangming.description":`Chuang Ming  SMSインタフェース情報を設定して、組織のショートメッセージの送受信業務の需要を満たします。`,
"label.custom.lead.notice.account.name":`こんにちは。あるリードは置き換えて、あなたを取引先、取引先責任者、商談の所有者に指定し、取引先名は`,
"label.emailobject.failedtosend1":`送信失敗の原因：メール認証が失効したため、個人メールにもう一度関連付けてください。`,
"vue_label_ccchat_notice_updaterecordsuccess":`この記録は更新済みです`,
"label.dayinmonth":`カ月の`,
"label.sendemail.chat.follow":`#name様:\n\n    こんにちは。#userName様はあなたをフォローしました。`,
"label.emailsync.form.emialpassword":`パスワード`,
"component_task_label_subject":`トピック`,
"label.projectManagement.please.enter.a.positive.integer":`正の整数を入力してください`,
"lable.account.NexteDays":`こらからの7日`,
"label.appupload.upload.managed":`1つのマネージドパッケージしか作成できません`,
"label.data.dataexpalltype.all.desc1":`1、エクスポートした圧縮ファイルのパスワードを自動生成するか、手動で入力することができます。自動生成されたパスワードは、データのエクスポートに成功したときに、ユーザーのメールボックスに送信されます。手動で入力したパスワードはメールボックスに送信されませんので、ユーザーは入力したパスワードを覚える必要があります。入力しない場合は、デフォルトでパスワードがないことが認められます。`,
"label.step1.total3":`ステップ 1/3`,
"label.escalation.setup.detail.section":`ルールの詳細情報`,
"front-gantt-module-drag-task-sorting":`タスクをドラッグして順番に並べる`,
"label.isEnableVisualpage.new.title":`カスタムページアクセスの有効化`,
"label_tabpage_yesz":`はい1`,
"label.emailobject.emaildetail.button.replyall":`すべて返信`,
"label.knowledge.setting.data.one":`これ以上サブカテゴリーを増やすことはできません。`,
"label.manageAll.sel.one3":`わたしが承認したプロジェクト`,
"UG_contact_01":`どのように取引先人者を利用しますか。`,
"font-trade-module-v1-invoice-name":`請求書名`,
"label.central.daylight.time":`中央ヨーロッパ夏時間`,
"label.chatter.pastThirtyday":`過去の30日間`,
"vue_label_commonobjects_detail_activity_ownevent":`行動あり`,
"label.user.modify":`ユーザの編集`,
"label.uploadTemplate":`テンプレートのアップロード`,
"setup_mainpage_label_welcome14":`ワークフローの作成、承認プロセスの管理`,
"label.workmate":`同僚`,
"label.displaycolumns":`表示される列`,
"label.emailnoticeintro":`メールアラートは、ワークフロールールが適用された時に送信されるメールです。`,
"label.knowledge.category.button.five":`カテゴリーの削除`,
"template.report.business.opportunities.type":`タイプ別の機会`,
"vue_labenl_applauncher_moreapp":`その他のアプリ`,
"label.captcha.expired":`検証コードが期限切れになっているので、もう一度検証してください。`,
"template.chart.bnqzkhslmb":`年間の目標リード数`,
"chatter.up.user.pic":`プロファイル写真のアップロード`,
"label.timezone.importtimezone.gmt":`グラビアの標準時間を使用`,
"label.step.type":`メンバータイプの検索を選択`,
"Dashboard.View.RecentlyView":`最近の表示`,
"label.reportinthisfolder":`当該フォルダのレポード`,
"label.product.vies":`商品のビュー`,
"pagecreator_systemstyle_message_delete_fail":`スタイルの削除に失敗しました`,
"label.multipleactivity.singleUser":`個別のユーザ`,
"vue_label_email_enter_subject":`件名の入力`,
"label_tabpage_alltabs":`すべて表示`,
"label.publicgroup.groupname":`チーム名`,
"template.report.sales.performance":`販売員のパフォーマンス`,
"label.newWindow":`これは新規ウインドウです`,
"label.forecast.editopp.forecastedit":`予測を編集`,
"label.data.import.setup.whichfield":`ソリューションのどれの項目に一致しますか`,
"label.noadd_dashboard":`ダッシュボードに追加しない`,
"label.subtotal":`サブトータル`,
"front-email-payment-weichat":`WeChatの "Scan "をご利用ください。`,
"label.attendance.position.alert":`まずマーカーを選択してください`,
"chatter.follow.me":`私をフォローしている`,
"label.mobile.more.details":`ファイルの詳細情報を編集`,
"Dashboard_SelectBoardToDisplay":`ダッシュボードタブページで表示されるダッシュ―ボードを選択してください`,
"front-gantt-module-v1-search-project":`あなたのプロジェクトを検索する...`,
"label.paging.totalofpagereport":`{0}ページ({1}件`,
"label.from.phone":`より`,
"lable.Signatory":`Signtory。`,
"label.campagin.roi.query.roi2":`キャンペーン販売チャンネルROI`,
"label.tabpage.selectcontentz":`内容を選択してください`,
"label.multilang.lookfiltercondition.valuetypenotmate":`第{0}行の条件にエラーが発生し、値の種別は一致していません。`,
"label.interfaceconstraint.disabled":`インターフェースが無効になっているので、システム管理者に連絡してください。`,
"third":`三番目`,
"label.quickbooks.viewlist.status":`状況`,
"label.emailtocloudcc.select3":`レコードの所有者所有者を選択してください`,
"label.projectManagement.week.work":`私の今週の仕事`,
"vue_label_pool_nodemand":`ニーズなし`,
"label.version.two.developapi":`APIの二次開発`,
"label.icon.82":`プリンター`,
"label.batchadd.newbatchpage.suclist":`追加に成功したデータ（件）`,
"label.checkfield.chooseatlast":`2つ以上を選択してください`,
"label.quotation.deleteTip":`削除する見積り行を選択してください。`,
"label.generatepage.title.desc2":`保存ボタンをクリックしてから、webページ及びアクセスする web URLリンクが生成されます。`,
"label.licence.total":`ライセンス件数`,
"Y":`参照関係`,
"label.wuzibiekesitan.time":`ウズベキスタン時間`,
"label.component.hotdeal.nodata":`商談関連のデータはありません。`,
"label.data.exp.save":`テンプレートを保存`,
"label.appupload.upload.tips.dashboard":`ご注意：私の非公開ダッシュボードとファイリングされない公開ダッシュボードでのダッシュボードはパッケージに追加されることができません。このリスクで表示されることもできません。関連する古いレポートはアップロードできません。`,
"lable.PowerProcess.new.PowerProcess":`新規エンタイトルメントプロセス`,
"label.loginhis.search.download":`ログイン履歴が多いことを考慮して、ダウンロードを検索する時、2ヶ月以内の履歴しかダウンロードできません。`,
"label.tabpage.deleteview":`ビューの削除`,
"label.chatter.recently":`最近`,
"label.industrialandcommercialverification.title":`企___`,
"message.nextapproverlost":`指定する次回の承認者はNULLです。`,
"front-kefu-moudle-v1-mfsysy-time":`フリートレイルの残りの日数`,
"label.role.assign.tip":`選択可能なユーザの指定/リスクで表示されるユーザはロールに割り当てされる`,
"label.addattachment.step2.intruduce":`ステップ1とステップ2を重複に行い、複数のファイルを追加します`,
"vue_label_pool_returnreasondiscription":`戻る理由の説明`,
"label.weixin.report.range":`持続時間`,
"label.wei.weiresearchtab":`Micro Voteのオプション`,
"vue_label_report_setdrill":`ドリルの設定`,
"page_404_button_back":`前のステップへ`,
"label.customfields.autonumber.tip":`システムはあなたが定義した表示形式を使用して番号を生成します。この番号は、新しいレコードが追加されるごとに自動的に増えます。`,
"label.ccpeak.return.allrecords":`すべてのレコードを返す`,
"label.ccchat.notmember.active.group2":`0`,
"label.uniquename":`一意の名前`,
"label.emailtocloudcc.filed.ssl":`安全な接続`,
"chatter.emailFollowMe":`私をフォローしているとき`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`弊社は著作権について、すべての権限を留保しています。顧客サービスホットライン`,
"label.projectManagement.actualworkinghours":`実際の労働時間`,
"label.quickbooks.fieldlabel.taxresale":`税金の再販売`,
"label.icon.12":`サービス`,
"label.data.exp.dataexptemp":`データエクスポートテンプレート`,
"component_setup_tabs_label_add":`新規`,
"label.appointmentdetail.wizard.title10":`開始日`,
"label.multilingual.close":`マルチランゲージマネージメントが有効になっていません。`,
"message.error.username.notexist":`知らないユーザ名で、再入力してください`,
"label.batchadd.newbatchpage.des2":`項目は自動採番であれば、入力する必要がありません。保存時に自動的に番号が生成されます。`,
"vue_label_SMS_search":`リードや取引先責任者の検索`,
"label.appupload.successWithUrl":`現在インストールURLを使用して、パッケージをインストールすることができます。`,
"UG_Forcast_06":`予測を許可するユーザを選択してください`,
"vue_label_dashboard_secondarygroup":`セカンダリーグループを選択してください`,
"label.weixin..xsld.total":`ファネル総価値`,
"label.setup.mobile.bottombutton.recovery.default.fail":`デフォルトの復元に失敗しました`,
"label.addrecurrencetimetrigger":`周期性タイムトリガーの追加`,
"label.emailsync.connectaccount":`メールアカウントの関連付け`,
"label_fiscal_years":`会計年度`,
"label.icon.164":`コーチ`,
"label.batchadd.mustinput":`付き`,
"message.newtabpage.nokeywords":`1文字以上のキーワードを入力してください。あるいは高度な検索条件を使用してください。`,
"label.login.verification.mfa.desc3":`アカウントは複数の人に共有して使用されており、MFAをバインディングした後、その他のMFAをバインディングしていない人は登録できません。この問題を解決するために、他の人にもこのページのQRコードをスキャンし、MFAアプリケーションをインストールさせます。しかし、セキュリティー上の理由で、複数の人によるアカウントの共有を解除することをお勧めします。`,
"label.partnerCloud.basicSetting.initialize":`初期化後にドメイン名を変更することはできません。`,
"label.address.county":`区町`,
"label.validate.function.funcFormat.TODAY":`TODAY()`,
"label.sso.addAKey":`秘密鍵の追加`,
"label.myusergroup":`私のユーザチーム`,
"label.import.index.time-consuming":`時間`,
"label_tabpage_systems":`合計で*つのシステム`,
"batch.sendemail.s":`メール送信に成功しました`,
"label.appointment.wizard.subtitle4-1-1":`15分`,
"label.projectManagement.delete.milestone":`このマイルストーンを削除すると、このマイルストーンの関連情報もすべて削除され、データの復元はできません。確かに削除ししますか。`,
"label.umeng.chatter.praise":`あなたのクラウドポストにいいね!と言いました`,
"font-evaluate-module-v1-evdetails":`評価の詳細。`,
"label.group.filter.resources.and":`リソースのフィルタリング方法として、アンド関係を選択します。`,
"label_emailtocloudcc_description":`sales@company.com、info@company.com、support@company.comなどの企業のメールボックスをここに追加して、システムは自動的に受け取ったメールに基づき、リードあるいはケースレコードを生成し、タイムリーにお客さんのメールをフォローします。`,
"label.chat.topic.delete.prompt2":`ご注意：他のコミュニティでの同じ名前のトピックスは削除されません。`,
"message.error.group.authorization":`このグループを設定す権限はありません。`,
"label.attendance.wz":`場所`,
"vue_label_activity_notice_logacal_success":`電話を既に記録した`,
"label.emailtocloudcc.step1.case1":`Email to Case`,
"label.h5.chatter.praisenum":`気に入り`,
"label_time_statistics_basis":`時間統計ベース`,
"label.onlyadmincanedit":`管理者は承認プロセスでレコードを編集することができます。`,
"label.fieldtoolongmassage":`項目`,
"label.sales.team.shared":`商談チームの共有`,
"label_emailsync_status_department":`部門`,
"label.mobile.quickcreate.default.sellingfunnel":`セールスファネル`,
"label.tabpage.closez":`クローズ`,
"homepage.components.two":`ステップ2.カスタマコンポーネントの位置を選択`,
"label.everyday":`毎日`,
"lable.Product.to.asset.BOM":`製品から資産のBOMへ`,
"label.appointment.wizard.subtitle4-3":`招待された人は会議開始の時間間隔を選択することができます`,
"label.customobjects.standardfieldslist":`標準項目リスク`,
"label.customfields.suretodelete":`はい、当該カスタマ項目を削除します。`,
"component.chatter.label.to":`まで`,
"label.emailsync.form.seversetting":`設定`,
"label.service.gantt.enabled.resources":`有効化済みのリソース`,
"label.tianyancha.h5.weibo":`Weibo`,
"template.chart.dddje":`失われたオーダーの量`,
"label.pc.trigger.apiname":`Api Nameは存在済みです。もう一度試してください。`,
"label.icon.34":`セットアップ`,
"label.schedulejob.setup.schedule.prgname":`アプリケーション名`,
"label.weixin.free.registration":`無料登録`,
"label.placeholder":`検索のキーワードを入力してください`,
"label.emailobject.manage.template":`メールテンプレートの管理`,
"label.knowledge.article.existsdata":`他のデータが存在するため、要求に合っていません。`,
"label.campaign.channel.lookup.ticket":`入場券を表示`,
"label.searchlayout.relation.searchfield":`検索結果に対する絞り込み検索条件項目。`,
"label.recordid.cannot.empty":`レコードIDは空いてはいけません`,
"label_partner_workspace_member_choice":`プロファイルの選択`,
"vue_label_campaign_amount":`収入金額`,
"label.niue.time":`ニウエ時間`,
"front-homepageobject-module-v1-workload-ranking":`作業量ランキング`,
"message.error.datainvalid":`エラー：無効なデータ`,
"vue_label_helpcenter_salesfunnel":`新バージョンのセールスファネルを使用して、商談フォローの状況を分析し、セールスプロセスにデータを提供します。<br>左上では、役割や所有者などの条件に応じてレコードがフィルタリングされ、対応する条件で表示可能なすべての商談が表示され、分析を行います。セールスファネル図のステージをクリックすると、そのステージでのすべてのレコードが表示されます。`,
"vue_label_transferownernotice":`このアイテムに関連するレコードの所有者も変更されます`,
"label.monitorsys.operator":`操作者`,
"label.please.codeNorm":`コード規格を選択してください。`,
"label.campaign.channel.step6.remark2":`社員の招待機能を有効化`,
"market.potential.customers":`マーケットのリード`,
"label.customfields.phone.tip":`電話番号を入力できます。自動的に電話番号形式にします。`,
"label.currency.edit":`通貨種別の編集：会社の通貨種別の変更`,
"label.emailobject.emaildetail.button.markasunread":`未読としてマークします`,
"label_partner_template_memo":`説明`,
"label.chat.message.search.all":`すべてのメッセージを検索します`,
"label_tabpage_hoursagoz":`時間前`,
"label.customcomponent.developer.help":`カスタマコンポーネントの開発者　ヘルプ`,
"setup_mainpage_label_welcome":`CloudCC PAAS　プラットフォームへようこそ。プラットフォームの主な機能は以下の通りです。`,
"label.h5.similar.opportunity.list":`結果はすでに獲得した取引先の商談で、この商談があなたの商談と同じ1つまたは複数の項目です。商談をブックマークとして設定すると、これらを商談の詳細情報ページでの類似商談の関連リストに追加します。`,
"vue_label_record_count":`レコード数`,
"label.icon.29":`デモ`,
"pagecreator.page.label.pagelayout":`ページレイアウト`,
"label.ggReleaseRange.searchRole":`ロールの検索`,
"label.campagin.member.field.setup":`キャンペーンメンバー項目の設定`,
"augest":`八月`,
"label.salescloud.massloss.content":`チームセリングの使用を禁止したら、ユーザーのデフォルト商談チームと商談でのすべての既存チームを削除し、しかも復元することができません。`,
"label.customfields.new.step2.opration.unique.info":`重複する値が許可されません`,
"vue_label_email_optional_members":`選択可能なメンバー`,
"label.emailobject.attachment.download":`ダウンロード`,
"label.recordamount":`レコード数`,
"front-kefu-moudle-call-recorder":`通話録音`,
"label.more.info":`詳細情報`,
"vue_label_commonobjects_view_secondsbefore":`{seconds}秒前`,
"label.emailsync.status.action":`アクション`,
"label.customfields.totalsummary.collectedfields":`集計するオプジェクト`,
"label.knowledge.setting.hint.two":`注意一度有効にしたKnowledgeを無効にすることはできません。`,
"label.login.access.yujidao":`期限`,
"label.assignment.setup.detail.description":`ルールエントリーを作成して、この中で指定された条件に基づき、レコードを自動的にユーザに割り当てます。`,
"message.error.marketsea.null":`プールが存在しない`,
"lable.account.Current.CY":`現在のカレンダー年度`,
"vue_label_salesadvance_lost":`流失`,
"label.file.ownedbyme":`私に所有される`,
"label.component.helper.nodata":`今注意事項がありません。後ほどまたチェックしてください。`,
"label.weixin.appr.pending.auditor":`提出者`,
"UG_opportunity_004":`多数の業務種別`,
"label.leadscore.setup":`リードスコアリングの設定`,
"label.addtimetrigger":`タイムトリガーの追加`,
"label.mr.title.match":`完全一致`,
"label.projectManagement.Newmilestone":`新規マイルストーン`,
"label.preview":`プレビュー`,
"label.tabpage.issuez":`問題`,
"label.img.max.size":`アップロードしたファイルは大きすぎて、500Kを超えないでください。改めてアップロードしてください。`,
"label.mainpageset":`ホームページコンポーネントの配置`,
"label.user.login.false.lock":`ログイン試行回数を超えました。アカウントはロックされています`,
"UG_solution_02":`ソリューションは取引先の問題を解決する解決策です。`,
"vue_label_approve_put_away":`崩壊`,
"label.profile.existing":`既存のプロファイル`,
"label.ems.logininfo":`ログイン情報`,
"label.weixin.location.service":`位置情報サービスオブジェクトの指定`,
"label.multilang.datamoveaction.totaldata":`{0}件の条件に一致するレコードがあり、最大で1回に100件のレコードまで移行することができます`,
"label.ccdocument.cannot.update.set":`Word、Excel、PPTのファイルではないため、フォルダのテンプレートセットにアップロードできません。`,
"vue_label_fliter_addfliter":`フィルターの追加`,
"label.custom.page.or.trigger":`（カスタマページあるいはトリガー）`,
"label.tag.filter1":`選択したすべての表示ラベルを同時に満たします`,
"UG.homepage.006":`アンケート、ライブチャット、電子メール、ソーシャルメディアへの投稿、さらに営業活動（リード、サービスサポート、アクティビティなど）を通じて、取引先の活動を全面的に把握します。`,
"SCORE":`評価`,
"label.file.library.managemembers2":`ライブラリーのメンバーを管理します`,
"label.email.template.public.SMS":`パブリックSMSテンプレートフォルダ`,
"label.leadscore.donot":`リードスコアリングできません`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`プレビュー`,
"UG_contact_04":`或は`,
"label.ccchat.person.invite.eminfo":`{ 0 }はCloudCC Chatの{ 1 }-御社の専用の協力空間への加入を招待しました。Chatを通じて同僚とチャットしたり、プロジェクトチームを作成したり、ファイルを共有したりします。`,
"setup_object_field_dependency_label_actionfieldvalue":`コントロール項目の値`,
"lable.Product.options":`製品オプション`,
"front-electronic-signature-add-autofill-field":`オートフィルフィールドの追加`,
"label.customfields.totalsummary.selectcollectedfields":`集計するオブジェクトの選択`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`契約金額は最大10桁まで入力が可能です。`,
"label.forecast.shrepage.pagetitle":`ユーザ、ロールとエリアの共有`,
"label.login.access.mark":`サポートの問題調査のため、システム管理者またはサポート担当者があなたに代わってアクセスしてご使用のデータにアクセスできるように権利を付与できます。`,
"lable.outlook.edit.zdyout":`カスタマExchange項目の対応付け`,
"label.approveoperate":`アクションの承認`,
"label.tabpage.linknamez":`リンク名`,
"label.report.error.deletehavedashboard":`このレポートには新規ダッシュボードがあり、削除することはできません。`,
"label.summaryreport.2018.step1":`ステップ1.集計条件のグループ化方式を選択`,
"label.campaignmember.main.leadtomember.title":`項目の対応付けの設定`,
"label.select.dashboar.type":`ダッシュボードタイプをご選択ください`,
"message.setup.field.picklist.valueexists":`選択リスト値は存在済みです`,
"label.loading":`データアップロード中`,
"label.payments.paytip1":`システムバージョンは試用版ではなく、「確認」をクリックして更新し、または再登録してください。`,
"label.view.appliedMobile":`モバイル端末にも使用しますか`,
"label.multilang.forcast.financialyear":`{0}番目の会計年度`,
"front-web-module-v1-detail-comment-opinion":`フィードバック`,
"UG_Forcast_10":`完了`,
"label.optionlistset":`選択リスクのオプション`,
"label.visualpage_list.vpname":`カスタマページ名`,
"vue_label_calendar_failed_to_delete_calendar":`カレンダーの削除に失敗しました。`,
"label.json.string.null":`空`,
"message.serviceappo.time.violation2":`サービス予約の利用可能な時間の違反：サービス予約の終了日がサービス予約の期限よりも早いです`,
"label.productsales.today.noevttsk":`今日、行動予定あるいは期限切れのToDoがありません。`,
"label_tabpage_emptyz":`クリア`,
"front-kefu-moudle-no-create":`未作成`,
"label.wedge.shaped.tail.arrow.cannot.empty":`上昇ウェッジ型矢じりは空であってはいけません。`,
"label.continue.shopping":`ショッピングを続ける`,
"label.turntomain":`主内容にスキップ`,
"component.assistant.label.nodata":`本日は事項がありませんので、後日ご確認ください。`,
"label.payments.paytip4":`正しい数値を入力してください。`,
"label.appupload.upload.versionName":`バーション名`,
"label.chatter.endData":`終了日`,
"front-kefu-moudle-buytr-tip":`CloudCCのコールセンターをご利用いただき、正式なコールセンターアカウントをご購入いただくことで、より良いサービスをご提供させていただきます。`,
"label.repw":`新しいパスワードの確認`,
"label.tabularreport.intro":`表形式レポートは最も簡単で早くデータを並べる方法です`,
"label.selectoperatetype":`アクション種別の選択`,
"setup.layout.label.required":`必須項目`,
"label.default.designee":`デフォルト任命先`,
"label.ccdocument.cannotdel.folder":`当該フォルダにファイルがあるため、削除できません。`,
"label.escalation.setup.newentries.inputentries":`ルールエントリーの入力`,
"label.emailobject.addnewtemplate":`テンプレートの選択`,
"label_chatter_content":`内容`,
"label.htyj.mubiao":`目標`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`金曜日`,
"label_tabpage_fieldoptions":`レコードタイプ項目、選択リスト項目及びオプションリスト（複数選択）項目は、10のキーワードまで入力し、また英文の読点で仕切ること（例えば：“北京、上海、広州”。）をお勧めします。`,
"label.mobiletablayoutedit.remark2":`携帯電話のフロントエンドタブのページで表示する項目を選択`,
"label.sendemail.chat.addComentsat":`#name様:\n\n    こんにちは。#userName様が発信した書き込みで私に関する内容を書き込みました。`,
"Z":`数式`,
"label.multilang.batchdeleteaction.movesuccess":`{0}件のレコードは削除に成功しました。`,
"label.textmessage.vonage.message2":`Vonage APIアカウントを設定することで、ユーザーはCloudCCがNexmo APIアカウントにアクセスしてテキストメッセージを送受信できるようになります。`,
"label.file.use.document":`ストレージスペースの使用状況`,
"UG.Lead.011":`クルーの作成`,
"label.view.name":`ビュー名`,
"label.data.downtemplate":`テンプレートをダウンロード`,
"vue_label_appstore_get_now":`今すぐ手に入れる`,
"label.controlfield":`項目のコントロール`,
"label.dataimport.type.insert":`挿入`,
"label.customfields.multiselect.tip":`ユーザは定義されたリストから複数の値を選択可能です。`,
"label.weixin.approval.qxzjl":`レコードを選択してください`,
"component.salesperformance.label.70finish":`完了済み - 未処理（>70%）`,
"Lead_Auto_Scoring_Setting":`リードの自動的なスコアリングの設定`,
"pagecreator_layout_message_canntdelete":`このレイアウトは削除できません`,
"vue_label_report_exprotpage":`ページをエクスポートする：第 {page}ページ`,
"label.campaign.channel.step4":`ステップ4.販売チャンネル登録ページで項目設定を必ず記入してください`,
"label.app.launcher":`アプリケーションランチャー`,
"vue_label_campaign_selectedmember":`{member}人のキャンペーンメンバーを選択した`,
"label.mobile.quickcreate.default.approvals":`承認待ち`,
"label.view.step4":`ステップ 4.表示の制限`,
"label.exchange.sync.state.user":`ユーザの同期状況`,
"label.forecast.customforecast.tab.forecast":`子タブの予測`,
"label.theUserLoginForTheFirstTime":`初ログイン`,
"label.workflowoperate.tip":`ルール条件に一致したときに起動されるワークフローアクションを指定します。`,
"font-evaluate-module-v1-ten-points":`ポジティブマーク：10点`,
"label.knowledge.delete":`知識の削除にエラーが発生しました`,
"front-console-see-contacts":`識別された{num}個のコンタクト`,
"label.h5.similar.opportunity.add.to.favorites":`しおりに追加`,
"front-epwechat-module-v1-install-app":`WeComでのインストール`,
"setup_layout_message_relatedlistbutton":`関連リスクで表示するスタンダードボタンを選択`,
"label.salescloud.massloss.title":`データを大量に失う恐れがあります`,
"front-console-conversation-btn1":`リングバック`,
"label.custom.canvasScale":`キャンバススケール`,
"label.lead.score.doing":`リードスコアリングを行っています`,
"message.approval.step.validation.invalid.number":`正しい数値を入力してください`,
"chatter.lk":`いいね`,
"label.dashboardSetup.showmaxval":`最大表示数`,
"label.keywords":`キーワード`,
"vue_label_helpcenter_SMS":`SMS機能をオンにする<br> ご購入いただいたCRMシステムの国コードがUSAであれば、システムでSMS機能が利用できます。管理者は、バックグラウンド統合アプリケーションのvonageゲートウェイで、購入した電話番号をvonageシステムに入力し、セールスクラウドアプリケーションのメニューでSMS機能を使用することができます。<br>SMSボックス<br> SMSボックスは、2つの部分に分かれています。左側には、SMSを使ったリードや取引先責任者のレコードがあります。レコードをクリックすると、右に送信・受信の詳細が表示されます。自分と部下のレコードを参照することができます。<br>グループメッセージの送信<br> SMSメニュー、リードまたは取引先責任者のリスト、キャンペーンのメンバーにあるSMSメッセージの送信ボタンで、グループテSMS
を送信することができます。CRMでのリードや取引先責任者のみに、SMSを送信することができます。SMSを編集した後、「送信」をクリックして、受信者数に関わらずグループレコードが生成されます。また、「それぞれ送信」をクリックすれば、それぞれ送信したSMSは、 SMSテンプレートに挿入されたマージ項目を表示することができます。`,
"label.emailobject.createnewavailability":`スケジュール予約リンクの作成`,
"front-kefu-moudle-buytr-send-email":`あなたはまだシステムのメールボックスに関連付けられていません。support@cloudcc.com にメールを送り、ご意向、会社名、ご連絡先をお書きください。営業担当者が早急にご連絡いたします。`,
"front-kefu-moudle-v1-Put-away-the-chat":`チャットの詳細を折りたたむ`,
"label.marketseamemset.lead.maxuser":`メンバーの最大リード数`,
"label.forecast.forecastroleuserpage.shre.manager":`管理者のみがこの予測を共有できます`,
"label.file.noselect":`ファイルがまだ追加されていません`,
"label.notification.task3":`あなたが【任命先】に割り当てたToDoの状態は【新しい状態】に変更されました`,
"label.dependfield":`連動項目`,
"lable.SalesCommitmentKanBan.receipts":`代金受取`,
"label_partner_workspace_member_search":`検索`,
"label.share.originally.posted":`最初に投稿&コメントを行う人`,
"label.autonumber":`自動採番`,
"label.view.sortview.name":`ビュー名`,
"label.h5.add.activity":`活動の追加`,
"label.textmessage.vonage.phone.number":`電話番号`,
"label.partnerCloud.financeSetting.enterApiKey":`APIシークレットキーを入力してください。`,
"label.industrialandcommercialverification.enablestatus":`ステ_タスの有_化`,
"label.reportTypeFocusD1":`当該レポートタイプによって生成されるレポートの行レコードとなるオブジェクトを指定してください。`,
"vue_label_report_four-levelseriesobjecttree":`4段階の直列式オブジェクトツリー`,
"label.mobile.default.catalogue":`デフォルトのディレクトリ`,
"label.partnerCloud.partnerAccount.again":`リチャージ`,
"label.summaryreport.step2.new":`ステップ2.集計情報のグループ化方式を選択`,
"label.tabpage.cancel":`キャンセル`,
"label.multilang.datamovelist.datamove":`複数の{0}をあるユーザから他のユーザに移行します`,
"label.conferloginandvisitlimit":`ログインアクセス権限の付与`,
"vue_label_help_viewhelpcenter":`CloudCCヘルプセンターの表示`,
"label.leadscore.norule":`スコアリングルールがないため、まずスコアリングルールを作成して、または既存のスコアリングルールを有効化してください。`,
"label.tabpage.exitz":`ログアウト`,
"label.DeploymentStatus":`開発状況`,
"label.layout.saving":`レイアウト保存中`,
"label.emailobject.emaildetail.field.object":`オブジェクト`,
"label.customfields.searchrelation.fieldtag.tip":`表示ビュー、ページレイアウトビュー、レポートビューとリスクビューで使用される表示ラベルを入力します`,
"message.huanxin.bindtenant.notfound":`アンバウンドエージェント`,
"label.referpersonalias":`提出者の別称`,
"label.icon.31":`コンピューター`,
"label.appupload.upload.install.thispackage":`このソフトパッケージ`,
"label.appointment.wizard.subtitle1-1":`カスタマプロパティ`,
"pagecreator_page_message_save_fail":`ページの保存に失敗しました`,
"label.lastset":`最終に基づく`,
"label.version.support.limited":`サポート権限の付与`,
"vue_label_homepage_kanban":`看板`,
"label.layout.editsearchdistribute":`検索レイアウトを編集`,
"template.dashboard.customer.analysis":`アカウント分析`,
"label.continue_editing":`編集を続ける`,
"label.version.sum.customtab":`カスタマタブ`,
"label.validate.function.funcExplain.TIMEVALUE":`日付/时间項目の時間に戻る（时分秒）`,
"label.import.page1.selectobjfromdata":`データをインポートするオブジェクトの選択`,
"label.partnerCloud.basicSetting.success":`初期化成功`,
"label.customfields.fielddependency.cannotcreat":`連動関係は作成できません。選択した項目は直接的または間接的に自身に連動しています。`,
"label.umeng.activity.youhaveatask":`新なToDoが1件あります`,
"label.file.folder.create":`新規フォルダ`,
"vue_label_campaign_member_status":`メンバーステータス`,
"lable.opppdt.addpdt.table.date":`日付`,
"label_partner_workspace_login_buttontext":`ボタンテキスト`,
"label_other_mistakes":`その他のエラー`,
"label.must.be.configured":`設定が必要`,
"label.customize.memory.function.sorting.enable":`ヘッダーソートの記憶の活性化`,
"setup.layout.label.areaname":`エリア名`,
"label_chatter_pastThirtyday":`過去の30日`,
"setup_mainpage_label_welcome25":`アクションガイド：このページの右側のメニュー → 管理の設定 → セキュリティーのコントロール → 共有の設定をクリックしてください。`,
"label.ccchat.person.invite.succsend":`Chatに加入する招待は～宛てに送信されました。`,
"label.select.time.range":`時間帯を選択してください。`,
"label.partnerCloud.orderingPlatform.djustQuantity":`商品をカートに入れると、数量の調整や価格の確認ができます。`,
"label.manageAll.sta1":`審査中`,
"label.cy.select":`通貨種類をご選択ください`,
"chatter.lam":`コメント`,
"label.partner.setup.title":`設定`,
"component.setup.label.displaybutton":`表示ボタン`,
"component.salesperformance.label.target":`目標`,
"label.campagin.channel":`登録チャンネルの値を入力してください`,
"label.validate.function.funcFormat.ISCHANGED":`ISCHANGED(field)`,
"UG.homepage.009":`CRMにアクセスする`,
"label.file.item":`プロジェクト`,
"label.file.library.addmembprompt":`既にメンバーで、重複な追加をしないでください`,
"label.bmap.releasePosition":`投稿の位置`,
"setup_object_layout_label_selectedprofile":`選択済みのプロファイル`,
"label_emailsync_message":`メッセージ`,
"label.view_submissions":`投稿作品を見る`,
"lable.tianyancha.repeated":`繰り返し選択します`,
"label.import.index.introduce":`簡単な3つのステップでデータをシステムにインポートことができます。`,
"label.time.operation.new":`新規スケジュール済みジョブ`,
"label.projectManagement.Pleaseentersettlementtype":`決済方法を入力してください`,
"label.icon.169":`ツアーカー`,
"vue_label_commonobjects_detail_related_listview":`リスト表示`,
"label.view.step1":`ステップ 1.ビュー名を入力`,
"label.summaryreport.intro":`集計レポートは同時にデータのサブトータルとその他の集計情報を並べます`,
"vue_label_file_input_correct_name":`正しい名前を記入してください`,
"System_Email_Template_Title":`CloudCC CRMプラットフォームへようこそ`,
"label.tianyancha.province":`都道府県の略称`,
"label.deleteall.sure":`確かにすべてを削除しますか`,
"label.passwordPolicy.setup.uppercasealpandnum":`英数字を含まなければなりません`,
"front-lightning-module-v1-details-page-chart-select":`オブジェクトとディスプレイの選択`,
"setup_mainpage_label_welcome8":`ドラッグ&ドロップ方式のインターフェースの作成`,
"lable.outlook.edit.lastupc":`最終更新された取引先責任者`,
"label.weixin.registered":`登録`,
"vue_label_file_history_version":`過去のバージョン`,
"vue_label_campaign_earned":`未収金`,
"label.staticresource.useful.realtion.tip":`以下はこの静的リソースのページに対するすべての参照です。`,
"vue_label_file_libraray":`ライブラリー`,
"label.department.phone":`携帯電話番号`,
"label.emailtemplate.edit":`メールテンプレートの編集`,
"label.processsetting.key.information.tips":`キー情報とヒント`,
"label.summaryreport.step7":`ステップ7.図表種別とレポートの最優先表示を選択`,
"label.chat.topic.remove.favorite":`お気に入りから削除`,
"label.campagin.roi.ksrq":`開始日`,
"label.data.downpage.e_title.e_btn":`インポートページに入り、インポートを開始します`,
"label.approvaldatamove.dname":`現在の承認者`,
"lable.Partial.attributes":`パーシャルアトリビュート`,
"template.report.enabled.products":`活性化された製品`,
"lable.outlook.detail.cto":`CloudCC.com から Exchange　まで`,
"label.sendemail.activity.newtasktitle":`新規ToDoの通知`,
"label.validate.function.funcFormat.DAY":`DAY(date)`,
"label.log.datetime.value":`検索時間をご入力ください`,
"label.import.index.updaterecord":`レコードの更新`,
"label.registration.page.invitation":`登録ページの案内`,
"pagecreator_systemstyle_label_detailcolor":`文字色`,
"label.tabname.cannot.empty":`タブ名は空であってはいけません。`,
"label.data.newtemplate.savetemp":`[別称でテンプレートに保存]をチェックし、このデータのインポートで選択した項目及び条件をデータインポートテンプレートとして、テンプレートページに保存します。今後の使用のために、テンプレート名とテンプレートの説明をきちんと記入してください。`,
"label.ems.body":`本文`,
"enc":`暗号化テキスト（メモリの暗号化）`,
"label.profile.mobile.setup.commonSaler":`一般的な販売`,
"label.continueselectproduct":`商品の選択を続ける`,
"label.event.new":`新規行動`,
"label.renametabandtaglib":`リネームタブと表示レベル`,
"label.qrcodelogin.message.exception":`サーバーに異常が発生し、管理者に連絡してください`,
"label.service.gantt.locationToGantt":`ガントチャート`,
"label.mr.theLastGroup":`これは最後のグループです。[戻って重複データリスクを参照]をクリックして、重複データを参照します。`,
"label.report.export.format.content":`該当レポートのヘッダー、グループ、詳細情報をエクスポートします。詳細情報を最大限にエクスポートします。`,
"label.version.accountandcontact":`取引先と取引先責任者`,
"label.partnerCloud.financeSetting.enterMd5Key":`MDSの秘密鍵を入力してください。`,
"label.login.access.quater":`週`,
"vue_label_commonobjects_view_searchthisview":`このリストを検索...
`,
"label.import.step1.allobj":`すべてのオブジェクト`,
"front-efficient-project-management":`Project Cloudは、プロジェクトのキックオフ、計画、実行、コントロール、クロージングまでのフルライフサイクル管理を提供し、お客様のビジネスニーズに応じてプロジェクト管理プロセスを最適化し、効率的なプロジェクト管理を支援します。`,
"label.includedvalue":`含んだ値`,
"label.service.newBuildDialog.past.days":`過去の日数`,
"vue_label_report_sortup":`昇順で並び替える`,
"label.appointment.wizard.subtitle3-2":`火曜日`,
"label.dashboard.trend":`傾向`,
"label.schedulejob.setup.schedule.st2":`二番目`,
"label.view.sortview.number":`レコード数`,
"lable.Please.enable.order":`注文が有効になっていないので、有効にしてください。`,
"label.datamanage.immediately.import":`すぐインポート`,
"label.delete.condition":`クリア`,
"label.dashboard.chooseDispalyOnTheHomePage":`表示するページの選択`,
"asset.accountid.contactid.required":`各アセットは、取引先また取引先責任者と関連付ける必要があります。`,
"label.mask.character":`サブネットマスク文字`,
"lable.account.Previous.FY":`前回の会計年度`,
"chatter.attachment":`添付ファイル`,
"label.view_only":`表示のみ`,
"label.tianyancha.name":`会社名`,
"label.service.gantt.avg.traveltime":`サービス予約の平均移動時間`,
"vue_label_pool_move":`移行`,
"label.import.index.beforeexport":`2、インポートする前に、関連するすべてのレコードをインポートするようにしてください。例えば、取引先責任者レコードをインポートし、また取引先項目（検索項目）を記入する必要がある場合、まず記入する取引先レコードを作成してから取引先責任者レコードをインポートし、取引先項目に取引先の名前やIDを記入してください。`,
"label.view.delete":`ビューの削除`,
"template.detail.info.link":`詳細情報リンク`,
"label.sendemail.send.setfail":`メール情報の設定に失敗し、正しくメール情報を配置してください。`,
"label_emailtocloudcc_redmessage11":`SMTPの認証に失敗しました。メールアドレスとパスワードが正しいかどうか確認してください。`,
"label.campaigns.memberalert":`メンバーを少なくとも一人選択してください`,
"label.schedulejob.setup.schedule.frequency":`頻度`,
"component.newrecords.label.all":`すべて表示`,
"label.mr.caption.opportunity":`重複検索&マージ：商談の重複データの検索条件`,
"chatter.group.onlyMembers":`このグループはメンバーのみ見られます。グループ全員がグループのメンバーの追加ができます。`,
"label.recordtype.edit.selectvalue.show":`選択リスト値は保存順番により表示されます`,
"message.textmaxlength":`長さは255文字を超えてはいけません`,
"label.reportsSubscriptionPage.visibility":`次のユーザー視角でレポートを実行します。`,
"label.umeng.chatter.addcoments":`あなたのクラウドポストに新しい返事が1つあります`,
"chatter.up.f":`知らないエラーで、アップロードに失敗しました。`,
"label.icon.146":`キーボード`,
"lable.custom.CY.Ago":`2つのカスタマ年度の前`,
"label.tabpage.step3":`ステップ3 表示する項目の選択`,
"label.checkfield.introduce":`オブジェクトで重複検索できる項目を設定し、データリスクで設定された項目によりデータに対して、重複検索を行います。`,
"label.tag.addtags":`表示ラベルの追加`,
"label.service.newBuildDialog.characterlimit":`名前が25文字の制限を超えています`,
"font-evaluate-module-v1-evquestions":`評価項目`,
"label.knowledge.only.update.draft":`ドラフトのみ更新`,
"label.partnerCloud.basicSetting.defaultCounts":`パートナーアカウントを追加する際のデフォルトのロール番号`,
"label.chat.topic.delete":`削除`,
"label.workflow.contentcondition":`条件が一致する`,
"vue_label_commonobjects_view_sortby":`{field}に基づき並び替える`,
"label.passwordPolicy.setup.pwdremember24":`リメンバー（0）のパスワード`,
"front-kefu-moudle-free-account":`トライアルアカウント`,
"label.marketsea.isautorecycle":`自動回収の有効化`,
"label.addattachment.view":`ファイルを表示`,
"vue_label_helpcenter_contact":`詳細情報では、取引先責任者の横にある「樹形図」ボタンをクリックすると、取引先責任者の階層図が表示され、関連する取引先責任者の上下関係を理解し、各取引先責任者のいくつかの項目情報を参照します。`,
"label.taskevent":`ToDo&行動`,
"label.industrialandcommercialverification.message":`今日の_索回数は上限になりました`,
"label.object.already.delete":`オブジェクトは削除済み`,
"label.project.hit.four":`サブタスク更新のお知らせ`,
"label.taskpagelayout":`ToDoページレイアウト`,
"label.version.sum.locationfield":`件の地理的位置項目`,
"front-sales-button-toQB":`QuickBooksへの同期`,
"label.app.oceanblue":`ダークブルー`,
"label.operating":`アクション中`,
"label.customfields.formula.dateexample":`Reminder Date（リマインダータイム）`,
"label.happen_delete":`フォームを削除するとどうなりますか？`,
"label.service.appointmentList.plansToStart":`プラン開始`,
"label.persmets.operate.licence":`許可`,
"label.mobile.quickcreate.default.activities":`行動予定`,
"label.australian.eastem.standard.time":`東部夏時間（ニューサウスウェールズ）`,
"label.emailobject.remove":`削除`,
"label.weixin.vote":`投票に参加`,
"label.reportsSubscriptionPage.condition.aggregate":`合計`,
"front-kefu-moudle-has-unbind":`You Have Been Unbound`,
"chatter.group.newGroup":`新規チーム`,
"label.tabpage.systems":`すべて*件のシステムがあります。`,
"label.textmessage.vonage.connect":`ヴォネージへの接続`,
"label.campaign.channel.input.ticket":`入場券を送信`,
"label.ccpeak.query.sharetab":`共有リストの検索`,
"label.reporttype":`レポートのタイプ`,
"message.duplication.label.isprofiletip":`チェックすれば、重複検査時に現在のユーザが参照可能なデータを校正します。そうでなければ、すべてのデータを校正します。`,
"label.tianyancha.businessverify.xieyi":`ユーザーライセンス契約`,
"font-evaluate-module-v1-select-person":`お客様担当者を選択してください`,
"vue_label_chatter_all_groups":`すべてのグループ`,
"label.recordtype.profile.setdefault":`デフォルトの設定`,
"label.mr.descreption.nocondition":`条件に一致する重複データはありません`,
"label.tabpage.askz":`何かご質問がありますか。`,
"label.marketsea.selectMember":`メンバーの選択`,
"template.report.stage.possibility.analysis":`ステージの可能性分析`,
"label.data.selectderivedobject":`エクスポートするオブジェクトを選択`,
"label.customfields.formula.explain":`説明：現在は数値、パーセントなど項目の四則運算及び項目の持つ値の検索をサポートします。例えば：数字種別の数式jine*knxing&nbsp;&nbsp;&nbsp;&nbsp;項目の持つ値の検索：khmc__r.dianhua`,
"vue_label_notice_change_fail":`変更に失敗しました`,
"label.customobjects.trackoldandnewvalues":`古い値と新しい値を追跡`,
"label.h5.leftprompt":`編集内容はまだ送信されていないですが、確かにこのページから離れますか。`,
"label.select.field":`選択可能な項目`,
"label.customobjects.layoutedit":`ページレイアウトの割り当て`,
"label.false":`FALSE`,
"UG_Forcast_07":`予測を許可`,
"vue_label_chatter_team_member":`グループメンバー`,
"label.tabpage.retypez":`レコードタイプを変更する時、既存のオプションリストの値は自動的には変更されませんので、同じ場所にあるレコードの既存のオプションリストの値を更新することをお勧めします。`,
"front-epwechat-module-v1-single-desc":`WeComを介してCloudCCの他のエンドにシングルサインオンし、すべてのエンド間でスイフトスイッチを行う。`,
"label.closeandconverted":`クローズ：置換済み`,
"label.service.confirmed":`確認済み`,
"label.partner.workspace.member.cloudcc":`Cloudcc プロファイル`,
"label.star.click":`クリックしてクリア`,
"label.icon.135":`通貨`,
"button_partner_workspace_login_logo_upload":`画像のアップロード`,
"message.error.sql.constraint.recordnotsingle":`外部IDの設定は成功しません。原因:元のデータの中に重複データがあります`,
"label.ccchat.person.invite.errorpwd":`少なくとも8文字で、しかも数字と文字の組み合わせを含まなければなりません`,
"label_tabpage_isdeleterecord":`選択したレコードを削除しますか`,
"label.weixin.prompt.message":`メモメッセージ`,
"vue_label_chatter_view_original_post":`元の書込みの表示`,
"label.multilingual.tip3":`マルチランゲージを有効にすると、有効にした言語を組織内の各ユーザーが設定できるようになります。`,
"label.dataimport.error.datetime":`エラー：日付/時間`,
"label_tabpage_addcondition":`条件の追加`,
"label.query.detail.manageexcludeuser":`外部ユーザの管理`,
"label.tianyancha.creditcode":`統一社会信用コード`,
"label.cy.enter":`御社が使用する通貨種別が新しい通貨種別に転換する際の為替レートを入力します。`,
"label.textmessage.vonage.message1":`Vonageと連携することで、ユーザーはVonage経由でCloudCC Platform上でテキストメッセージを送受信することができます。ただし、テキストメッセージを送信する前に、Vonageのアカウントを登録し、電話番号を購入する必要があります。`,
"front-marketing-module-v1-share-invitation":`シェアスタッフ募集`,
"label.file.items":`件のプロジェクト`,
"label.otherwise":`そうでなければ`,
"label.permission.detail.system":`システム`,
"message.success.task.emailsend":`メールの保存と送信に成功しました`,
"label.the.reward.group":`見積り行グループ`,
"setup.layout.label.relatedlistsetup":`関連リストの設定`,
"label.empty":`クリア`,
"label.weixin.cloudcc.user.binding":`CloudCCユーザのバインディング`,
"label.file.what.change":`何の更新を送信（選択可能）`,
"label.search":`検索`,
"label.mobile":`携帯`,
"template.report.month.potential.customer":`今月のリード`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`名詞スキャンを使用する際に、承認ルールを有効にしますか`,
"lable.outlook.list.des":`Exchange Sync 更新ルールは特定ユーザチームのCloudCC for Exchange の更新に応用されます。`,
"label.appupload.install.error.info":`{0}“{1}”は{2}に使用され、既存の{0}の名前を改めて付けてください。`,
"label.tabpage.addoptionsz":`オプションの追加`,
"label.arabian.standard.time":`アラブ標準時`,
"label.thefirst":`一列目`,
"label_partner_workspace_login_footertext":`フッターテキスト`,
"lable.Disabled.successfully":`正常に解除されました。`,
"label.confirm.del":`承認中のレコードで、確かに削除しますか。`,
"vue_label_normal_reregister":`再ログイン`,
"label_file_img":`画像`,
"label.salescloud.salesdashboard.sales.behavior":`販売行為`,
"label.startdate":`開始日`,
"label.field.duplicate.error.msg5":`下記のすべてのエラーメッセージを確認し修正してから、再試行してください。`,
"setup.main2018.label.managesetup":`管理の設定`,
"label.forecast.editshrepage.title":`新規共有`,
"UG.solution.01":`ソリューションの提供`,
"label.knowledgebase.data.recovery.successfully":`a}のデータを正常に復元`,
"label.pc.ui.2018.myccchat":`私のCCChat`,
"label.attachement":`メモ&ファイル`,
"message.mobilechooseatmostten":`10つの項目まで選択します`,
"label.campagin.roi.bhzeywjh":`商談件数`,
"label.autoresponserule":`自動レスポンスルール`,
"label.attendance.yuyue":`予約していないですが、オンサイト登録しますか。`,
"label.insert":`挿入`,
"label.service.ganttBaiduMap.shutDown":`クローズしますか。`,
"label.icon.194":`テレビ`,
"message.serviceterritory.violation":`エリアの違反：リソースエリアとサービス予約のエリアが一致していません`,
"label.appointment.disable.function":`無効化機能`,
"lable.currencyManage.manageexchangeRate.dis":`[期限切れの為替の管理]クリックして、会社の期限切れの為替を管理します。期限切れの為替は商談、商談商品及び関連するレポートに適用されます。`,
"vue_label_file_upload_tip_newmsg":`{size}MBのファイルをアップロードすることをお勧めします。そうでなければ、ページの読み込みが遅い可能性があります。`,
"label.event.next.week":`これから一週間の行動`,
"label.datamanage.import.contactfield":`下記のリストで、インポートするファイルで取引先責任者にインポートする項目を選択します。完了したら、[次へ]をクリックします。`,
"label.projectManagement.time.allocated":`割り当て済みの時間`,
"label_tabpage_isdeleteview":`確かにこのビューを削除しますか`,
"label.pc.ui.2018.search":`検索内容を入力してください`,
"label.role.createrolelevel":`ロール階層の作成`,
"label.tabpage.editview":`ビューの編集`,
"label_partner_common_manageSetup":`パートナークラウド管理の設定`,
"label.service.gantt.noservice.resource":`選択したサービスエリアで利用可能なサービスリソースは見つかりませんでした`,
"message.numbertoolarge":`数字は大きすぎます。`,
"label.sendsms.success":`ショートメッセージの送信に成功しました`,
"UG.opportunity.009":`或いは`,
"label.ccpeak.construction.dataobj":`データオブジェクトを作成するには、オブジェクトAPI名を記入しなければなりません。`,
"front-lighting-module-v1-detail-file-uploadInfo":`このレコードはロックされており、ファイルのアップロードはできません。ロックを解除するには、管理者に連絡してください。`,
"label.import.page2.newnotmatchfiled":`ファイルに合計{{ csvfiledlength }}個の項目があります。残りの{{this.csvfiledlength - this.selectlength}} 個の項目がマッチングされていません`,
"label.ems.inputmailss":`ポスト?オフィス?プロトコル`,
"label.knowledgebase.data.published.successfully":`データの公開に成功`,
"label_emailtocloudcc_position":`職位`,
"label.data.exp.customexp":`カスタマインポート`,
"component_chatter_post_button_user":`人の追加`,
"label.new.visualpagefolder":`カスタマページ：新規フォルダの作成`,
"label.forecast.shrepage.classdes":`アクセス権レベルの説明`,
"label.task.overdue.unfinished":`期限切れのToDo`,
"label.ccchat.micropost.isedit.setting.info":`投稿とコメントの作者、レコードの所有者、CCChat のモデレータ及びこのコミュニティのモデレータはこのファイルを修正する権限を持っています。`,
"label.recordname":`レコード名`,
"label.posted_your":`に掲載されています。`,
"label.globaloperation.operationtype.custom.page":`カスタムページ`,
"label_tabpage_busoppnamez":`商談名`,
"front-epwechat-module-v1-schedule-desc":`WeComのスケジュールとCloudCCのイベントを同期`,
"label.escalation.setup.newentries.lastmodifydate":`前回更新したケース時間に基づいく`,
"setup_layout_label_nofield":`選択可能な項目がありません`,
"label.sendemail.registIMUser.logininfo":`ログインできるパートナークラウドは以下通りです。<br>`,
"label.weixin..xsld.kehu":`取引先`,
"label.display_thank":`サンキューページを表示する`,
"label.group.no.my.group":`一致する私のチームはありません`,
"label.partnerCloud.newBuildSite.enterDomain":`ドメイン名を入力してください`,
"label.step1.total2":`ステップ　1/2`,
"label.ccpeak.delete.record":`削除履歴`,
"label.customer.tab.step1.introduce":`この新規カスタムタブのカスタムオブジェクトを選択してください。その他の詳細を入力してください。`,
"label_tabpage_newInterfacez":`新版インターフェース`,
"setup.mainpage.label.manageuser":`ユーザー管理`,
"label.partnerCloud.partnerAccount.completed":`支払いは完了しましたか？`,
"label.projectManagement.kanban":`タスク看板`,
"label.operate":`アクション`,
"label.service.dispatchingUnits.selected.time.range":`選択した時間範囲内のサービス予約を表示します`,
"component_setup_label_pagesize":`ページ毎に表示される件数`,
"font-evaluate-module-v1-email-evaluation-settings":`メール評価の設定`,
"label.service.dispatchingUnits.skills":`スキル`,
"label.editrecurrencetimetrigger":`周期性タイムトリガーの編集`,
"vue_label_file_edit_lib":`ファイルライブラリの編集`,
"label.campaignmember.selectmember.deleteconc":`キャンペーン：取引先責任者からメンバーを削除`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`月曜日`,
"front-detail-module-v1-by":`によるものです。`,
"label.mobile.home.page.date.signed":`契約締結予定日`,
"label.apply.send.success":`送信に成功しました。`,
"label.app.choseimg":`ロゴの選択`,
"label.customsetting.visible":`表示`,
"label.sendemail.activity.task.distributetaskcompleted":`#belongtoidccname様に割り当てしたToDoは「完了」とマークされました`,
"label.dashboard.snapshot.refreshing":`更新中`,
"label.document.name.already.exists":`ドキュメントの一意の名前は存在しません。`,
"label.ccchat.person.invite.needlastname":`姓を入力してください`,
"pagecreator_page_button_copy":`コピー`,
"label.appointmentpage.wizard.subtitle1-2":`先週`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(日付)`,
"label.profile.allowtocreateview":`ビューの作成`,
"message.error.recordid":`レコードIDは空にしてはいけません`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`上位ロールに戻る`,
"label.translation.start3":`必要に応じて、オブジェクトを選択します。たとえば、ワークフロー ToDo には、翻訳可能な用語を絞り込むオブジェクト (取引先、取引先責任者など)があります。`,
"label.ccpeak.send.email":`メール通知の送信`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`有効期限なし`,
"label.permission.objectpermission.objpermission":`オブジェクトのパーミッション設定`,
"label.version.custom.report":`標準レポート（カスタマページ）`,
"label.title.qrcodeOrbarcode":`バーコード/QRコードの生成`,
"label.emailtocloudcc.step2.name":`メール所有の設定`,
"label.reportsSubscription.edited.successfully":`レポート購読の編集に成功しました。`,
"label_tabpage_kanbansetup":`ボードの設定`,
"label.tianyancha.regcapital":`登録資本金`,
"front-epwechat-module-v1-web-single":`Webシングルサインオン。`,
"label.visualpage.display.top":`ヘッダーを表示、false-ヘッダーを非表示`,
"label.customfields.fielddependency.selectcell":`以下のリストからいずれかセルを選択してください`,
"label.paging.addmember.totalofpages":`{0}件`,
"label.email.saveing":`データが保存中...`,
"label.userinfo.doublepwd.notnull":`確認用パスワードは空であってはいけません。`,
"label.appointment.wizard.subtitle4-4-2":`2週間`,
"label.chatter.BCC":`BCC`,
"label.emailtocloudcc.description":`sales@company.com、info@company.com、support@company.com のような企業メールをここに追加し、受信したメールに従って自動的にリードやケースの記録として生成されて、取引先をタイムリーにフォローすることができます。`,
"label.sendemail.send.atlastone":`受信者は少なくとも1つです。`,
"label.mobile.phone.subordinate":`部下を含みますか`,
"label.data.choses.e_desc":`ご要望に基づいて、すべてエクスポートあるいは1つのオブジェクトデータを選択することができます。`,
"chatter.new":`メッセージ`,
"vue_label_help_back":`前に戻る`,
"label.skipwizardintro":`ジャンプスタートウィザードを使用して何分間以内に承認プロセスを作成することができます`,
"label.weixin.fmu.before.week":`0週間`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat あなたの書き込みが気に入りです。`,
"lable.currencyAdv.andafterdate":`と　これからの日付`,
"label.sometoprocess":`いくつかのレコードタイプだけはこの承認プロセスに入ることができる場合は、下記に条件を入力してください。例えば、本社従業員の費用レポートだけがこの承認プロセスを使用します。`,
"label.campaignmember.main.updateleaddesc":`すべてのリードの状況を一回で更新`,
"label_partner_common_roleSetup":`パートナークラウドロールとユーザの設定`,
"label.console.step5.no":`レコードの表示方法を選択`,
"label.salescloud.teamrole.optionlist.account":`アカウントチームのメンバーを追加して`,
"Report.Delete.Confirm.Title":`確認してください`,
"label.onclick":`クリック`,
"label.weixin.input.identifying.code":`確認コードをご入力ください`,
"label.knowledge.translate":`下書きまたは公開されたメインバージョンの知識記事のみ翻訳できます。`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`Mailchimpにチェックイン`,
"label.escalation.setup.newaction.otheremail.otheremail":`その他のメール`,
"label.icon.104":`スケジュール`,
"label.partnerCloud.exceedTwo":`アップロードされるプロフィール写真は、2MBを超えることはできません`,
"label_tabpage_thevalurofz":`の値`,
"front-lightning-module-v1-details-page-chart-maximum":`最大50文字まで入力できます。`,
"label.data.downpage.i.title.num6":`データをインポートする前に、5つのレコードを含むテストファイルをインポートして、インポートするデータが正しいかどうか確認してください。`,
"label.ccpeak.update.record":`レコードの修正：`,
"label.dataimportandexport":`デートのインポートとエクスポート`,
"label.tabpage.notexceed25":`選択するレコードは25件を超えてはいけません`,
"label.starting":`進行中`,
"label.knowledge.language.spanish":`スペイン語`,
"label_emailtocloudcc_set":`メール情報の設定`,
"message.oneormoreneedsreport":`ダッシュボードは当該レポートを使用します。参照された当該レポートのダッシュボードコンポーネントを削除してから、また試してください。`,
"label.attendance.xccheckin":`サインイン`,
"label.emailmerge.editfolder.title":`差し込み印刷テンプレートのファイル`,
"template.report.year.customer":`今年のリード`,
"label.partner.common.webSit.memo":`御社のパートナークラウドのデフォルトドメイン名：`,
"label.partnerCloud.financeSetting.onlinePayment":`オンライン決済`,
"Pagelayout.Setup.001":`ホバーレイアウトで表示される関連リストを選択してください。`,
"front-kefu-moudle-time-length":`期間`,
"label.deleteObject":`オブジェクトは削除済み`,
"label.setup.mobile.homepageshortcuts.select":`ホームページのトップエリアに表示する4つのショートカット機能を選択します。`,
"setup.mainpage.label.welcome26":`データ管理 - 一括処理`,
"label.ServiceCloud.yuyuebainhao":`サービスアポイントメントNo.`,
"label.emailobject.emaildetail.button.addtolead":`リードに追加`,
"label.event.single.view":`個別のビュー`,
"lable.product.pricebooks.ustand":`標準価格を選択`,
"label.emailtocloudcc.department":`部門`,
"component_assistant_label_30daysnoact":`30日間に何の活動もありません`,
"label.weixin.no.pending.qzkh.qin":`現在リードデータはありません`,
"label.vlidaterule.formula":`エラー条件数式`,
"label.tianyancha.h5.contact":`連絡先情報`,
"label.button":`ボタン`,
"message.checkemail":`エラー：メールの入力にエラーがあり、チェックしてください。`,
"lable.account.previous.CY":`前回のカレンダー年度`,
"label.icon.13":`サービス`,
"chatter.coll.c":`ブックマークをキャンセル`,
"label.knowledge.category.hint.four":`データカテゴリの割り当て`,
"label.tianyancha.phonenumber":`連絡先`,
"label.tablayoutedit.remark":`フロントエンドタブで表示する項目とカスタマページを選択します`,
"label.shareusers":`ユーザを共有`,
"label.endtime":`終了時刻`,
"label.length":`長さ`,
"label.umeng.activity.event.begin":`の後に開始します`,
"label.tabpage.alltabs":`すべて表示
`,
"label.exact.query":`高度なルックアップ検索`,
"label.weixin.skip":`スキップ`,
"label.ems.cancel":`キャンセル`,
"label.trigger":`トリガー(Before Insert)`,
"label.exchange.sync.setting":`Exchange Sync の設定`,
"label.product.pricebooks.name":`価格表の名称`,
"label.relation.list.total":`選択済みの合計`,
"label.step2.total7":`ステップ　2/7`,
"label.martrixreport.2018.step6.new":`ステップ6：画像種別とレポート強調表示の選択`,
"label.standard.buttonandlink.override":`カバー`,
"front-console-conversation-btn4":`新しいケースとしてのセパレート`,
"vue_label_dashboard_range":`範囲`,
"label.app.sort.show":`アプリケーションは保存の順番により表示される`,
"label.salescloud.teamrole.choose.correct":`重複ユーザを選択したため、修正してください。`,
"label.schedule_post":`ポストの発行`,
"front-kefu-moudle-server-request-num":`サービスリクエストリストNo.`,
"label.h5.logout":`ログアウト`,
"label.weixin.horse.club.member.message":`愛馬社メンバー情報`,
"label.field.addoptionlist.introduce":`以下の 1 つ以上の選択リスト値を追加します。値は 1 行につき 1 つ存在する必要がある。`,
"setup_layout_label_setupfield":`項目プロパティの設定`,
"label.chatter.nextStep":`次のステップ`,
"label.quickbooks.searchlist.total1":`{0}件の関連されていない請求書を検索しており、この総金額は{1}です`,
"label.tianyancha.h5.regcapital":`登録資本金`,
"label.icon.184":`助言`,
"label.dashboard.message.refreshtoomush":`ダッシュボードのスナップショットの更新は非常に頻繁で、暫くしてから更新してください。`,
"label.umeng.approval.reject":`#approverは#objの承認を拒否しました`,
"label.h5.chatter.newmessage":`新規情報を入力`,
"message.error.relationid":`relationidは空にしてはいけません。`,
"label.setup.mobile.offlinecache.selectdefault":`デフォルトで有効になっているオフラインタブを選択`,
"label.setup.mobile.homepageshortcuts.saveprompt":`4つのショートカット機能を選択してください`,
"label.projectManagement.Selectmonth":`月を選択`,
"label.version.ultimate":`フラグシップ版`,
"label.validate.remark5":`開始日の後に終了日が来るようにするなど、日付項目の時間順を正しく設定する`,
"label.version.nowis":`現在のCloudCCバージョンは`,
"front-kefu-moudle-CRM-set":`CRMセットアップ`,
"label.mr.title.customerAddress":`取引先の住所`,
"label_emailtocloudcc_step1_name":`機能の選択`,
"label.time.operation.edit":`スケジュール済みジョブの更新`,
"label_tabpage_operationz":`項目、アクションは空であってはいけません`,
"label.translation.start4":`翻訳列をダブルクリックして、新しい値を入力します。`,
"vue_label_systemSettings_request":`一括転送の依頼`,
"label.maintenance.notice":`定期保守の通知`,
"label.customfields.txet.textlength.tip":`下記で入力するテキスト項目の最大文字数を入力してください。テキスト項目の長さは255文字を超えてはいけません。`,
"label.ccdocument.select.template.open":`テンプレートを選択して開いてください`,
"vue_label_display_date_field":`日付項目の表示`,
"label_partner_workspace_tab":`タブ`,
"lable.account.LasthDays":`過去の120日`,
"chatter.using.sticker":`書き込みの追跡を有効化`,
"message.save.dataerror":`エラー：データが長すぎ、またはその他の問題があるため保存にエラーが発生し、データを修正して再保存してください。`,
"vue_label_commonobjects_view_chart_newchart":`新規図表`,
"label.chat.micropost.a.group":`チーム`,
"lable.currencyManage.advcurrencyunEnabled":`高度な通貨種別管理は有効になっていません`,
"label.appexchange.workflow":`ワークフロールール`,
"vue_label_calendar_show_details_and_add_events":`詳細情報を表示して行動を追加する`,
"label.salescloud.optionlist.inputname":`下記で選択リスト値の名称を入力してください`,
"label.dashboard.folder":`ダッシュボードファイル`,
"label.knowledgebase.permanently.remove.articles":`アーカイブされた記事を削除すると、関連する他のバージョンも永久的に削除されます。`,
"label.emailtocloudcc.titel":`Email to CloudCC`,
"label.visualpage.sel":`当該フォルダのカスタマページ`,
"label.planned.all.work":`すべてのスケジュール済みジョブ`,
"label.weixin.agree.agreement":`関連協議に同意`,
"label.forecast.customforecast.qsn":`スタート年`,
"label.appupload.managed":`マネージド`,
"template.report.folder.sale.index":`販売指標の分析`,
"UG_opportunity_011":`取引のインポート`,
"label.validate.function.funcFormat.SECOND":`SECOND(date)`,
"UG_homepage_005":`セールスインテリジェンス`,
"label.clicktoreturn":`ここをクリックして戻る`,
"label.collectionofview":`のビューセット`,
"com.cloudcc.login.error.message.nonuser":`ユーザーが存在しません。`,
"vue_label_systemSettings_emailsetting":`メール設定`,
"vue_label_email_mark_as":`としてマーク`,
"label.tabpage.customernamez":`取引先の名前`,
"label.appupload.install.apicannotsame":`新しいapi名をもとの名と同じにすることができません`,
"label.task.all.undealt":`すべての未完了のToDo`,
"front-lightning-module-v1-dashborad-statistical-indicators":`統計インデックス`,
"UG.quota.02":`見積もりは取引先と供給者の間で、指定された時間に指定された価格で指定された商品を取引する法律条項です。`,
"label.approve":`承認`,
"vue_label_calendar_remove_calendar":`カレンダーの削除`,
"label.mr.title.contactName":`取引先責任者の名前`,
"label.projectManagement.resource":`リソースの管理`,
"label.rejectbehaviour1":`承認者が手動で選択して何番目のステップに戻ることができますか？（前のN番目のステップに戻る）`,
"label.publicgroup.relationship":`チームメンバーのリレーションシップ`,
"Lead.Scoring.DetailedPage.Popup.Title":`リードインサイト`,
"label.owner.edit":`所有権の編集`,
"label.campaign.channel.ticket.mark":`ご注意：QRコードをスクリーンショットで取って携帯電話のアルバムに保存し、あるいはQRコードを携帯電話に保存して、QRコードにて入場します。`,
"label.opportunity.setting.showstage.info":`モバイル端末の詳細情報ページは商談段階のショートカット操作エリアを表示しますか。`,
"label.emailobject.wizard.desc3":`メールテンプレートを使用して、時間を節約します。`,
"label.cpq.quote.no.product.add":`見積書に製品が追加されていません。注文を作成する前に製品を追加してください。`,
"label.customer.tab":`カスタマタブ`,
"Opportunity_Detailed_Phase_Label_Popup_002":`離れる日付`,
"component_telerecord_label_name":`名前`,
"label_component_helper_nodata":`現在、注意事項はありません。後ほどチェックしてください。`,
"label.dashboardSetup.d2":`区切りの2つの値`,
"setup.mainpage.label.welcome4":`手順は以下の通りです。ページ左側のメニュー → アプリケーション設定 → 作成 → オブジェクトをクリックする。`,
"label.step4.total5":`ステップ　4/5`,
"label.payment.the.remaining.days":`アカウントの有効期間は{ 0 }日残っています`,
"label.encoding":`コード`,
"label.setting.intergrationlist.status2":`このイングレーションはインストール済みです`,
"label.new":`新規`,
"label.search.searchsetup":`検索の設定`,
"label_tabpage_printz":`プリント`,
"report.type.label.customService":`顧客サポート`,
"label.notification.addEmailObject.message":`{!fromaddress}からのメールが届きました。クリックしてご覧ください。`,
"label.icon.68":`機械`,
"UG.Lead.003":`ソーシャル`,
"label_mobile_default_field_service_home":`サービスクラウド トップページ`,
"label.select.one.group":`少なくとも1つの引用ライングループを選択してください。`,
"front-kefu-moudle-trkey-nopower":`Tianrunのキーペアには割り当てられたパーミッションがない`,
"label.chatter.cancel":`キャンセル`,
"label.weixin.report.optiondisplay":`レポートオプションの表示`,
"front-kefu-moudle-v1-System-version":`システムバージョン。`,
"lable.product.pricebooks.editall":`すべてを編集`,
"label.group.no.recent3":`あるいは`,
"label.knowledge.article.delete":`知識記事の削除にエラーが発生しました。`,
"label.relateobj":`関連先`,
"workflow.action.tasks.assignortype.type":`種別`,
"label.layout.selectedfields":`選択された項目`,
"label.role.assign.operate":`その他のユーザからこのユーザに割り当てます。ドロップダウンリストから選択し、使用可能なユーザを表します。左側から1つのユーザを選択し、選択済みのユーザに追加します。`,
"label.field.insert":`項目の挿入`,
"label.icon.11":`人`,
"label.group.no.recent4":`チームの作成`,
"front-epwechat-module-v1-input-corpid":`Corpldを入力してください。`,
"setup_object_field_dependency_label_actionfieldnotnull":`コントロール項目の値を選択してから、設定してください。`,
"setup.mainpage.label.welcome19":`手順は以下の通りです。  このページの左側のメニュー → 設定の管理 → ユーザーの管理 → ユーザー、ロール、プロファイルをクリックする`,
"label.escalation.setup.list.rulename":`ルール名`,
"label.ems.addaccount":`すぐアカウントを追加します`,
"label.reportsSubscription.details.only":`詳細情報のみ（ (Excel 形式 .xlsx)`,
"vue_label_commonobjects_view_groupby":`グループ化の基準`,
"label.email.form.text":`本文のみ`,
"label.weixin.loginname":`ログイン名`,
"label.forecast.settings.sr":`収入`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0}公開された記事を{1}で全てに公開`,
"label.ccchat.enter.subject":`投票トピックを記入してください`,
"label.customer.tab.introduce":`カスタムオブジェクトタブの外観と動作は、Salesforceが提供する標準タブと似ています。`,
"message.login.mfaverification.wrong":`セキュリティコード?エラー`,
"component.newrecords.label.name":`名前`,
"label.salescloud.opportunity.addandedit.contactrole":`取引先責任者の役割の追加と編集`,
"label_emailtocloudcc_button_next":`次のステップ`,
"label.console.step5":`ステップ5.レコードの表示方法を選択`,
"setup.main2018.label.norole":`システム管理の権限を持っていません`,
"template.chart.ywjhqd":`ビジネスオポチュニティステージ`,
"label.instrumentPanel.breakpointOneLabelname":`この値は最小値よりも大きい必要があります`,
"label.qrcode":`QRコード`,
"label_tabpage_no2z":`いいえ2`,
"label.log.search.date.range":`検索の周期は{c}カ月より大きくなってはいけません。`,
"label.console.step7":`ステップ7.プローファイルの割り当て`,
"label.australian.central.standard.time":`中央標準時（北領地）`,
"label_tabpage_deleteviewfailed":`ビューの削除に失敗しました`,
"vue_label_commonobjects_view_searchview":`このビューで検索`,
"message.error.object.notexists":`オブジェクトは存在しません`,
"label.tablecell":`セル`,
"vue_label_notice_edit_success":`編集に成功しました`,
"label.customer.language":`デフォルト言語`,
"label.csrf":`csrf Security Protectionの有効化`,
"label.forecast.customforecast.submit.zhi":`まで`,
"label.sso.saml.idp.config.desc2":`IDティプロバイダを有効にします。アイデンティティプロバイダとしてCloudCC.comを有効にします。`,
"label.export_data":`エクスポートデータ`,
"component.todaytask.label.all":`全て表示`,
"label.h5.chatter.record":`レコードの追跡`,
"front-vew-email-verification":`メールを表示し、アカウントを確認します。メールを確認してからでないとログインできません。`,
"laber.marketsea.del.error":`プールが占有されているため、削除できない`,
"vue_label_notice_homepage_entername":`変更後の名前を入力してください`,
"UG.Forcast.01":`予測`,
"front-email-payment-tips":`請求書の金額が空欄になっています。請求書の金額を入力してからオンライン決済を開始してください。`,
"setup.mainpage.label.welcome2":`カスタムデータベース（オブジェクト）`,
"APPIntegration.Social.facebookerror":`facebook.comの有効なURLを入力する必要があります。`,
"label.profile.mobile.setup.stand":`スタンダードホームページ`,
"label.custom.CY":`カスタム年度`,
"label.knowledgebase.publishing.conditions":`Pulish {a} data failed, they are off the publish criteria!`,
"label.tianyancha.description":`天眼査商業データの検証を有効化にして、ユーザが取引先の資料を入力する時、正しい取引先の商業登録情報を提供します。このサービスは天眼査が提供され、中国内陸に登録された企業データをサポートします。`,
"label.appexchange.uninstallpage.title":`このパッケージをアンインストールしたら：`,
"label.currencyRate":`為替レート`,
"setup_layout_label_areashow":`エリア名に位置情報が表示される`,
"label.setup.case.setting":`ミニプログラムからケースまで`,
"vue_label_commonobjects_view_fixed_at_most":`最大でも3列しか固定できない`,
"template.report.month.income":`今月の収入`,
"label.sms.companyname":`会社名`,
"label.sendemail.registIMUser.waitmessage":`しばらくログインできるパートナークラウドがありません。後ほど管理者のお知らせを待ち、指定されたアドレスにアクセスします。上記のユーザ名、パスワードでログインしてください。`,
"label.custom.field.task.object":`こんにちは、新規ToDoがあります。ToDoトピックは`,
"message.pleaseselectdayinweek":`曜日の選択`,
"label.chat.topic.favorites":`お気に入り`,
"UG.Campaign.004":`キャンペーンのインポート`,
"label.approval.preview":`承認プロセスのプレビュー`,
"label.knowledgebase.assign.articles.to.people.or.queues":`ターゲット言語を選択し、記事を関係者またはキューに割り当てます。通常、エクスポートされた翻訳記事はキューに、社内で翻訳された記事は担当者に割り当てられます。`,
"pagecreator_systemstyle_message_save_success":`スタイルの保存に成功しました`,
"label.outline":`概要`,
"label.read.only.field":`読み取り専用のフィールド`,
"front-gantt-module-v1-early-warning":`早期警戒`,
"label.file.ccchat.selectfrompc":`コンピュータからファイルを1つ選んでください`,
"vue_label_systemSettings_social":`ソーシャルメディア`,
"label_report_year_last_year":`前年同期比`,
"lable.PowerProcess.Meet.the.conditions":`以下の条件を満たす必要があります。`,
"label.changemydisplay.list.title":`私の表示を変更`,
"UG_Forcast_03":`計画を開始して事業戦略を実行します。<br> よい予測できるようにお祈りします。`,
"label.sendemail.chat.sendmessage":`#name:\n\n様、こんにちは。#userName様はメッセージを1つを送信しました。`,
"label.huanxinconfig.secretid.lost":`secretidは空にできません。`,
"label.icon.49":`発電`,
"chatter.feed.button.publish":`発表`,
"label.power":`^累乗`,
"label.partnerCloud.financeSetting.informationThree":`3.秘密鍵管理画面に入り、「mapi Gateway Product Key」をクリックして、パートナーIDとMDS秘密鍵を取得します。`,
"label.emailtocloudcc.step1.lead2":`設定すると、このメールボックスに届いたメールは自動的にCloudCCのリードレコードとして生成され、いかなる商談も見逃さないように確保します。`,
"label.knowledgebase.delete.draft.succeeded":`ドラフト削除成功`,
"label.dashboardSetup.title":`コンポーネントエディター`,
"label.trigger.operation.email.template.map":`テンプレート情報に戻ります。メールの件名：m.get("subject")；メールの内容：m.get("context")；メールのタイプがテキストですか：m.get("istext")`,
"label.dependencesearchfilter":`関連検索条件`,
"label.selected.search.length":`選択した検索項目は10つを超えていけません`,
"label.profile.commonusercontrol":`一般ユーザ権限`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`アプリケーション`,
"label.customsetting.manage.position":`位置`,
"vue_label_systemSettings_bindweb":`バインドウェブ`,
"label.loginservice.license.notexist":`ライセンスは存在しません。`,
"label.icon.43":`鐘`,
"UG_homepage_003":`360度ビュー`,
"label.file_format":`ファイル形式`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`日曜日`,
"vue_label_chatter_post_has_delete":`書込みは削除されました`,
"report_label_searchresult":`検索結果`,
"label.tabpage.justsz":`先ほど`,
"Lead_Scoring_Setting_LevelSetting":`リード人気の設定`,
"setup.object.field.dependency.label.selectedfieldvalue":`選択可能な項目値`,
"label.search.morelistview":`更なるリストビュー`,
"vue_label_homepage_won":`獲得済み`,
"label.notification.last30days":`ほぼ30日間`,
"vue_label_helpcenter_pool":`取引先プールとリードプールを利用して、営業データを管理します。<br>プールの設定<br>バックグラウンドでプールを作成し、プールの管理者とメンバーを設定し、期限切れの自動回収ルールを設定することで、チーム内の商談フォロー状況を管理し、チームメンバーに積極的にフォローしてもらうのに便利です。<br>データの手動管理<br>プールの管理者は、プール内のレコードの割当て、回収、廃棄、移行などの操作を行い、プール内のレコードを統一的に管理することができます。<br>プールのメンバーは、未割り当てのレコードを受け取ったり、自分が担当しているレコードを表示することができます。`,
"label.emailsync.status.export":`Excel_csv形式の項目としてエクスポートする`,
"label.service.miniProgram.slideshowTitle":`カルーセル`,
"label.service.miniProgram.slideshowName":`カルーセルの名称`,
"label.fieldupdate.selectobj":`この項目の更新にオブジェクトを選択し、「次へ」をクリックします。項目の更新は同じクラスのワークフローと承認プロセスしか関連することができません。`,
"label.ccpeak.take.notice.sharetab":`ご注意：共有リスクのエクスプレッションで項目が__c"！"を加ええる必要がないです。`,
"label.log.startdate.after.endate":`開始時刻は終了時刻より大きくなってはいけません`,
"label.rememberme":`ユーザ名の記憶`,
"label.partner.all.maxNum":`パートナークラウドの最大データ：`,
"component.setup.iframe.label.inputurl":`URLアドレスの入力`,
"label.h5.systemmessage":`システムメッセージ`,
"label.delete.date":`日付を削除`,
"front-email-payment-select-month-tips":`MMを選択してください。`,
"front-kefu-moudle-bind-userinfo":`ユーザー情報のバインド`,
"label.appointment.wizard.notif2":`予約を作成する前に予約枠の長さを設定してください。`,
"label.custom.field.maping.number":`リードの数字桁数は対応付け項目の数字桁数より大きくなってはいけません`,
"label.event.dayview":`日のビュー`,
"label.replace":`置換`,
"label.knowledgebase.search.knowledge.articles":`知識記事の検索`,
"component_event_label_soon":`すぐ`,
"label.imgfield.upload":`画像のアップロード`,
"message.printable.view":`プリント可能なビュー`,
"vue_label_notice_uploadavatar_notice1":`アップロードされるアバターのサイズは2MBを超えることはできません。`,
"label.visualpage.developer.help":`カスタマページの開発者　ヘルプ`,
"label.validate.function.funcFormat.IF":`IF(logical_test, value_if_true, value_if_false)`,
"label.sso.saml.sp.description1":`ログイン設定をクリック`,
"vue_label_calendar_step_1":`ステップ1：オブジェとカレンダーの名前付け`,
"component.telerecord.button.save":`保存`,
"setup_mainpage_button_manageobject":`オブジェクト管理`,
"label.marketingactivityinfluence":`キャンペーンの影響`,
"label.quote.bjjsxx":`見積の受取メッセージ`,
"label.appupload.upload.install.retry":`再インストール`,
"label.layout.assignrules":`割り当てルール`,
"UG.Lead.006":`サイト訪問者`,
"label.workmate.searchs":`同僚の検索`,
"label.visualpage_list.no":`カスタマページのアクセス権がありません`,
"label.service.miniProgram.slideshowintroduce":`カルーセル名は複数の広告エントリを識別するのに使われ、広告には表示されません。`,
"label.multilang.messagedetail.search.desc":`{0}があるメッセージが見つからないです`,
"label.mobile.phone.read.note":`ここに説明を入力してください`,
"label.passwordPolicy.setup.isUsingGotp":`ログインの再校正を有効化`,
"message.datetypeerror":`エラー：日付の入力は不正確です`,
"label.searchlayout.listview.button":`リストビューに表示されるボタン`,
"label.sectionpart":`部分`,
"label.partnerCloud.basicSetting.userSetting":`ロールとユーザーの設定`,
"System_Data_Import_Warning_MaxCount":`あなたの組織は一回に{ 0 }件のデータをインポートすることしかできません。今はすでにオーバーしており、調整して再度インポートして下さい。`,
"label.datamove.qualified.record":`条件に一致するレコード（件）、最大100件まで移行できます。`,
"component_task_label_priority":`優先度`,
"vue_label_report_me":`私`,
"label.college.duplicate.option":`オプションは繰り返し使用できません`,
"label.pw.letter":`レターズ`,
"label.file.sharedwithme":`私と共有`,
"label.translation":`通訳`,
"lable.currencyAdv.exchagecurrency.before":`その前`,
"label.file.share":`共有`,
"label.page.next":`次のページ`,
"label.autoRegister.changepwd.setpwd.notmatch":`2度入力したパスワードは一致していません`,
"label.tabpage.include":`含む`,
"front-email-payment-thanks":`ありがとうございます。`,
"vue_label_help_helponthispage":`このページのヘルプ`,
"label.approvepagelayout":`ページレイアウトの承認`,
"vue_lightning_help_zero_distance_communication":`オンラインサポートの有効化によって時間を節約し、CloudCCサービス専門家とゼロ距離でコミュニケーションをとります`,
"vue_label_normal_case_sf":`ケース`,
"label.report.line.tuozhuai":`ドラッグ＆ドロップ、またはダブルクリックでレポートの列を選択し、順序を調整してください。`,
"template.dashboard.management":`運用管理`,
"label.customcomponent.params.info.n1":`componentラベルのargsプロパティを使用する値argsはjson形式です。例えば、argsです。`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`契約の承諾率`,
"label.add.status":`状況の追加`,
"label.loss.customers":`完了済み/カスタマー チャーン`,
"vue_label_chatter_involving_me":`関与している`,
"label.update.input":`入力をご修正ください`,
"label.import.step1.commonobj":`一般的なオブジェクト`,
"label.appupload.upload.tips.document":`ご注意：「私の個人フォルダ」と「フォルダのテンプレートセット」のフォルダはソフトパッケージに追加できなく、このリスクにも表示できません。`,
"label.appupload.install.complete":`完成`,
"label.console.edit":`コンソールの編集`,
"setup.object.field.dependency.label.removefromlist":`選択した値の削除`,
"label.textmessage.groupsms.no.phone":`電話なし`,
"label.account.Current.and.NextFQ":`現在と次回の会計年度`,
"label.sso.saml.sp.idtype.userid":`ステートメントにはユーザオブジェクトからのユーザIDが含まれています`,
"label.data.import.setup.operate.update":`既存レコードを更新し、いずれ新規レコードを挿入しません。`,
"front-kefu-moudle-v1-jcaws-call-serve":`コールセンターをAWS（Amazon Web Service）に統合し、より充実したSaaSサービスを提供`,
"label.version.bacheditordel":`一括編集/削除/移行`,
"lable.even.higher":`上位`,
"label.datetime.error":`日付の表示形式は不正確です。`,
"vue_label_commonobjects_detail_customer_hierarchy":`アカウント階層`,
"label.startuploadfile":`アップロードを開始`,
"label.appointment.wizard.subtitle3-1":`月曜日`,
"label.weixin.relevance":`関連の商談`,
"label.datamanage.field.mapping.information":`項目の対応付けの設定`,
"label.brief.lastweek":`先週`,
"label.nextstep":`次へ`,
"label.listtoshow":`以下は1つのリスクが表示されました。表示内容は`,
"label.partner.ishave":`エラー：ドメイン名はすでに存在しました`,
"label.service.miniProgram.name":`名前を記入してください。`,
"label.view.filterbyaddition":`追加項目別に絞り込み(省略可能)`,
"label.projectManagement.nodata.task":`ToDoのレコードがありません。ToDo情報を追加しましょう`,
"label.chooseemailtemplate":`メールテンプレートの選択`,
"label.page.step4.add.profile":`ステップ4.プロファイルに追加`,
"label.ems.mailtype":`メール種別`,
"label.weixin.no.pending.projects.vg":`いいですね。承認待ちのプロジェクトがありません`,
"label.tabpage.saveviewfailed":`ビューの保存に失敗しました`,
"label.chat.file.upload.cancel":`アップロードをキャンセル`,
"com.cloudcc.login.error.message.notenabled":`ユーザーは有効化されていません`,
"label.data.import.setup.operate.insertandupdate":`既存レコードの更新&新規レコードの挿入`,
"label_target_type":`目標タイプ`,
"label.notification.event2":`【任命先】に割り当てた行動は表示されています。`,
"chatter.feed.menutype.feed.news":`フォローしている内容`,
"label.import.page1.suitedwayofcustomer":`取引先をマッチングさせる方式`,
"label.import.page2.CloudCCfiled":`CloudCC項目`,
"label.custom.quarter.start":`カスタム四半期の開始日`,
"label.page.including.tab":`タブを含む`,
"label.mobile.phone.day.plan2":`今日の計画`,
"template.report.lead.conversion.statistics":`リードのコンバージョン統計`,
"label.show.type":`表示の種別`,
"label.weixin.no.pending.wdgz.qin.week":`今週は仕事の計画がありません`,
"2018UI.Homepage.DataDeleted.Info":`データが削除済みで、クリックして前のステップに戻ってください。`,
"label.vlidaterule.message":`エラーメッセージ`,
"label.approval.remark":`承認コメント`,
"label.field.duplicate1":`ユニーク`,
"label.batchtransfer":`一括移行`,
"label.quickbooks.view.allinvoices":`すべての請求書`,
"vue_label_commonobjects_detail_lead_selectedstatus":`選択済みステータスとしてマーク`,
"label_home_page_source":`データソースを選択してください。`,
"front-kefu-moudle-v1-opencall-please":`コールセンターを有効にしてから、設定してください。`,
"setup_layout_label_asc":`昇順`,
"label.use_tikect":`入場券を使う？`,
"label.tag.setup":`表示ラベルの設定`,
"label.existinglayout":`存在済みのページレイアウト`,
"label.productsales.today.noevt":`今日、行動予定がありません。`,
"message.error.view.date.validerr":`有効な日付表示形式(YYYY-MM-DD、MM/DD/YYYY)あるいは特別な日付文字を入力します`,
"label.mr.descreption.oneGroupReData3":`重複データ、処理済み`,
"label.tianyancha.businessverify.msg1":`企業データ認証を有効化する場合、ユーザーは「ユーザの許可協議」（下記は協議という）の北京神州雲動股份有限公司（下記は CloudCCという）の免責条項やユーザーに対する権利制限規定など各条項をよく理解しなければなりません。慎重に読んだ上、本「協議」を同意するかどうか確認してください。`,
"label.custom.CQ":`カスタム四半期`,
"label.version.custom.dashboard":`標準ダッシュボード（カスタマページ）`,
"vue_label_commonobjects_detail_dragtoupload":`ファイルをここにドラッグするか、<em>ファイルを選択してアップロード</em>してください。`,
"label.tabpage.addadvancedoptions":`高度なオプションの追加`,
"front-kefu-moudle-v1-Launch-page":`ランディングページです。`,
"label.emailobject.tabname":`メール`,
"label.weixin.addmore":`さらに追加`,
"message.error.view.operator.validerr":`サポートされないアクション列`,
"label.another_page":`別ページへのリダイレクト`,
"label.reportTypeFocusD2":`例パートナーとの機会に関する連絡先」をレポートする場合、プライマリオブジェクトとして「連絡先」を選択します。`,
"label.icon.47":`バロメーター`,
"label.task.today":`今日のToDo`,
"label.service.gantt.weekend.highlight":`ハイライトで週末を表示する`,
"label.customcomponent.referencetagname":`表示ラベル名`,
"label.senderemail":`送信者のメールアドレス`,
"label.defaultvalue":`デフォルト値`,
"label_tabpage_Sdfez":`日前`,
"pagecreator.page.label.pagename":`ページ名`,
"vue_label_report_pagenumber":`範囲内のページ値`,
"label.emailsync.connectaccount.description":`ここに個人用のメールボックスを追加すると、CloudCCはシステム内のリードと取引先責任者をメールアドレスに応じて自動的に照合します。また追跡やコミュニケーションを円滑にするため、メールの内容を記録に同期させます。`,
"label.schedulableprg.chooseweek":`毎週の日曜?日付を選択してください`,
"lable.edit.queue.membercanuse":`選択可能なユーザ`,
"lable.Quick.find":`クイックルック`,
"label.daynuminmonth":`月目の`,
"message.error.state":`Stateは空にしてはいけません。`,
"label.introduction.the.form":`商品説明`,
"label.batchtransfer.pleaseselectcomefromuser":`ユーザからの移行を選択してください`,
"front-dashboard-module-implemented":`実現`,
"label.custombutton.newerror":`新規作成に失敗しました`,
"label.version.allow.size":`上限に達しました。需要に応じて、CloudCC をバージョンアップしてください。`,
"label.weixin.account.loginpage":`ログインページ`,
"message.pleaseselectfieldtype":`項目種別を選択してください`,
"component.setup.label.parentobject":`上位オブジェクト`,
"System.TAB.SeeViewAmount":`合計数の表示`,
"label.event.lastmonth":`先月`,
"label.taskrecordtype":`ToDoレコードタイプ`,
"label.layout.selectedpages":`ページを選択`,
"label.appointmentdetail.wizard.title19":`土曜日のスケジュール`,
"label_chatter_endData":`終了日`,
"label.appupload":`ソフトパッケージ`,
"label.knowledgebase.article.link":`リンク記事`,
"label.licence.enddate":`ライセンスの期限日`,
"chatter.fieldtrack.record":`記録`,
"label.reportsSubscriptionPage.schedulereport.weekly":`毎週`,
"label.forecast.editshrepage.title2":`共有を編集`,
"label.attendance.onwork.time":`出勤時間`,
"label.appointment.wizard.subtitle1-8":`3時間`,
"pagecreator.layout.button.upload":`レイアウトのアップロード`,
"label.input.notless.than.number":`{0}以上の数字を入力してください`,
"setup.mainpage.label.welcome13":`手順は以下の通りです。トップメニュー → レポート」→「新規作成」をクリックする。`,
"label.forecast.settings.data.opp":`商談のクローズ時間`,
"vue_label_display_checkbox_field":`チェックボックス項目の表示`,
"label.summaryreport.2018.step5":`ステップ5.図表種別とレポートの最優先表示を選択`,
"front-lightning-module-v1-dashborad-one-statistic":`少なくとも1つの統計値と統計の種類を選んでください。`,
"label.home.standard.dashboard.forcase":`予測を許可していないため、販売承諾ボードを参照することができません。`,
"page.field.track":`項目追跡`,
"label.dataimport.format.datetime.error":`表示形式エラー、yyyy/MM/dd HH:mm:ss あるいは yyyy-MM-dd の書式を使用してください。`,
"lable.opppdt.selPbk.title":`価格表の選択`,
"pagecreator_systemstyle_label_stylename":`スタイル名`,
"label.projectManagement.nodata.project":`関連データがありません。私に関連するプロジェクトを作成しましょう`,
"label.start_below":`フォームを連絡先と共有することができます。あなたのフォームは安全に公開され、以下のウェブアドレスで使用できるようになりました。`,
"label.campaignmember.main.delete":`キャンペーンメンバーの一括削除`,
"label.modifyall":`すべて変更`,
"label.homepage":`ホームページ`,
"vue_label_pool_adoptedbyme":`私が受け取ったの`,
"label.email.clearItem":`項目に関連付けられていないメールのみを削除します`,
"label.callcenter.login.Amazon.connect":`Amazon Connectへのログイン`,
"label.import.page1.selectimportfiled":`インポートするファイルの選択`,
"message.error.id":`idは空にしてはいけません。`,
"label.ggReleaseRange.searchUsers":`検索パートナーユーザー`,
"label.changemypwd":`私のパスワードの変更`,
"label.ccpeak.reference.parameters":`参照可能なパラメータは`,
"chatter.share.success.tip":`成功しました。この投稿をまで共有しました。`,
"label.message.checkfailed":`シンタックスチェックに失敗しました。このクラス名は既に使われています。`,
"label.shangqing.introduction":`リードや取引先の最近のホット行動を総合的に分析し、取引先をより包括的に理解できるようにします。`,
"label.allemailnotice":`すべてのメールアラート`,
"vue_label_report_copy":`レポートのコピー`,
"label.exchange.sync.state.setting":`更新の設定`,
"label.merge.result.error1":`以下のレコードがロックされたため、「マージ」操作が許可されません`,
"label.process.des":`現在のレコードの詳細情報を参照するなら、左側のリンクをクリックして入ります。`,
"label.textmessage.vonage.create.lead.setting":`システムに登録されていない電話からのショートメッセージを受信した時、新規リードを作成する`,
"label.views":`ビュー`,
"label.notification.tip1":`通知はありません`,
"label.forecast.detailforecast.returnforecast":`予測に戻る`,
"label.knowledgebase.target.framework.name":`対象フレーム名`,
"label.brief.close.opportunities":`商談件数`,
"label.appointment.wizard.subtitle4-2":`最終スケジュールリの知らせ時間`,
"vue_label_systemSettings_set_record":`関連リストの分散モードを設定し、カードモードとリストモードの切り替えを試みる。`,
"pagecreator_page_message_publish_fail":`ページのリリースに成功しました`,
"vue_label_homepage_name":`ホームページ名`,
"label.weixin.no.pending.wdgz.qin.month":`今月の今週は仕事の計画がありません`,
"label.campagin.register.page":`キャンペーンメンバーの登録ページ`,
"label.campaign.channel.edit":`キャンペーン：販売チャネルの編集`,
"label.folder":`フォルダ`,
"label.umeng.chatter.follow":`私をフォローした`,
"label.sso.theKeyToEdit":`秘密鍵の編集`,
"label.deletelayout":`ページレイアウトの削除`,
"label.same.analyze.miaoshu":`以上の条件リレーションシップは、「商談名」あるいは「取引先名」あるいは（「取引先責任者の携帯電話」と「取引先責任者のメールボックス」）です。`,
"label.ccpeak.sel":`当該フォルダのクラス`,
"label.tabpage.addtoworkbench":`ホームのワークベンチに追加すします`,
"label.forecast.shrepage.classdes.r":`参照のみ‐ユーザは予測データを参照することができます。`,
"homepage.custompagename":`カスタマホームページ名`,
"label.sendemail.batchapprovalinfo":`#name様 こんにちは。\r\n     一括承認のアクションは成功しました。合計で#successnum件の承認は成功し、#errornum件の承認は失敗しました。`,
"front-email-payment-Invoice-alipay-describe":`安心・安全なお支払い`,
"setup.object.field.dependency.label.configured":`割り当てられた内容`,
"label.potentialcustomers":`リード`,
"label.timetrigger.button":`追加した時間トリガーボタンは以下の状況で使用できません：`,
"label.category.10":`弁護士`,
"label.selectall":`すべて選択`,
"message.field.id.not.null":`項目IDは空であってはいけません。`,
"CloudCCCRM.ST.Info.TypeIn.001":`入力してください。`,
"label.author":`作者`,
"label.import.step1.csvonly":`1.csv形式のファイルのみに対応しており、インポートでは1回{recordnumlimit}件までのレコードがインポートできます。トリガーを実行する必要がある場合は、最大2,000件までのレコードをインポートできます。制限を超えたレコードは、システムによって自動的に無視されます。より多くのデータをインポートする場合は、まず複数のファイルに分割し、インポートしてください。.`,
"label.assignment.setup.newrule.name":`ルール名`,
"label.campaignmember.selectmember.chosestatusdesc":`追加するメンバーのキャンペーンを選択し、メンバー状況を制定します。新規キャンペーンを作成したら、このプロセスから退出しなければなりません。`,
"label_tabpage_operation":`アクション`,
"label_tabpage_datatyoez":`データ型`,
"UG_product_04":`新規商品`,
"label_emailtocloudcc_step1_case2":`設定後、このメールボックスで受信したメールはケースを自動的に生成することができます。そして、ケースサービスの受入と追跡するために、ケースを送信トレイによって取引責任者と取引先をマッチングさせます。`,
"workflow.action.tasks.assignortype.role":`ロール`,
"vue_label_notice_refreshi_success":`更新に成功しました`,
"label.notification.arketsea.abandon":`{5}は{2}{0}を廃棄しました：{1}`,
"label.icon.36":`コンピューター`,
"chatter.group.cancelToJoin":`加入を解除`,
"label.publicgroups.edit":`公開グループの編集`,
"message.duplication.label.letternum":`一致する文字の桁数`,
"label.brief.lost.opportunities":`ロスの数`,
"setup.layout.label.nofield":`選択可能な項目がありません`,
"label.dataimport.isSharingRule":`共有ルールの執行`,
"vue_label_opportunity_contactrole_synctocontacts":`情報を取引先責任者に同期させます`,
"attachment_button_massdownload":`一括ダウンロード`,
"label.weixin.agreement.remark":`このWeChatサービスは愛馬社が取引先のコンサルティングサービスに対する補助ツールで、保険会社の賠償の最終的な根拠ではありません。取引先の賠償は保険会社の実際要求に準拠しなければなりません`,
"label.partnerCloud.basicSetting.introTwo":`ユニークURLの一部を編集します。CloudCC.comはURLの最初の部分を提供し、後の部分は数字または文字のみを含みます。例えば、"mycpmpanypotal "のように、会社名またはその変形を使用することをお勧めします。`,
"pagecreator_layout_funcpath":`/ページビルダー/レイアウトライブラリー`,
"label.ccdocument.online.edit":`フォルダのオンライン編集`,
"label.partner.setup.Enable":`ベリファイ`,
"label.log.state":`アクション状況`,
"label.lower.bound":`下限`,
"label.timezone.isenable":`複数タイムゾーンを有効化して、日付がユーザのタイムゾーンで表示されるよう、ユーザに自分のタイムゾーンを設定させます。`,
"label.martrixreport.setrowtitle":`列タイトルの指定`,
"label.bottom":`ボトム`,
"label.multilang.ccchat.groupnotcontainsname":`名称に{0}が含まれる活動チームのメンバーではありません。`,
"label.step1.of.step5":`ステップ　1/5`,
"message.report.error.FieldListIsAmbiguous":`レポート項目に下記の項目を参照する数式項目があるため、異常が発生しました。この数式項目を削除してください。数式で参照した項目は`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`0}から{1}に変更します`,
"label.report.export.print.content":`現在のレポートのヘッダー、グループ、最初の2000レコードのエクスポート`,
"message.thanksusing":`cloudCC.comを使用していただき、ありがとうございます。`,
"label.reportexport.allobject":`すべてのオブジェクトをエクスポート`,
"label.projectManagement.working.hours.per.day":`毎日の労働時間数`,
"label.partnerCloud.financeSetting.enterCollaborator":`協力者のIDを入力してください`,
"label.defineReportRecords":`レポートレコードセットを定義`,
"greate":`より大きい`,
"label.sure_discard":`本当に変更を諦めるのか？`,
"label.escalation.setup.newaction.notifyowner":`ケースの所有者に通知`,
"label.icon.28":`ドクターハット`,
"lable.PowerProcess.see.page":`重大事件の表示`,
"message.error.object.relogin":`ログインに失敗し、もう一度ログインしてください`,
"label.chatter.activity":`活動`,
"label.query.clone.detail.choose.canChoose":`選択可能な明細オブジェクト`,
"chatter.using.object":`オブジェクトタイプのレコードをフォローするため、オブジェクトの書き込みの追跡を有効化します。ユーザがフォローするレコードで項目が変更されるときに、書き込みの追跡を参照できるよう、追跡する項目を選択します。`,
"UG.opportunity.001":`販売状況をどのように把握していますか。`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`サービスリソース分布図`,
"vue_label_email_current_email":`このテンプレートを挿入すると、既存メールが上書きされます`,
"label.h5.approval.page.layout":`下記の方法で承認ページレイアウトを設定することができます：設定->作成->ワークフローと承認->承認プロセス<br>対応する承認プロセスの選択、プロセス名をクリックして、<br>編集の選択->ページレイアウトの承認<br>承認ページレイアウトを行えます。`,
"component.hots.label.title":`人気がある取引`,
"mail.foldername.notOnly":`このファイルはすでに存在しています`,
"label.customer.tab.step1":`ステップ 1. 詳細情報の入力`,
"label.delete.persion":`削除者`,
"chatter.changed0":`{0}を{1}から{2}に変更します`,
"homepage.components.type":`コンポーネントタイプ`,
"label.norfolk.isiands.time":`ノーフォーク時間`,
"label.product.pricebooks.view":`価格表のビュー`,
"label.forecast.customforecast.director":`直接部下`,
"label.emailtocloudcc.step3total3":`ステップ3／3`,
"label.cloudccsite.end":`サイトホームページの使用禁止`,
"label.login.verification.mfa.device":`仮想MFAデバイスの認証`,
"chatter.follow":`フォローする`,
"label.month's":`月の`,
"label.sendmail.step1.introduce":`以下のビューの1つを選択（当該メールの受信者を含む）`,
"label.shangqing.title":`ビジネス情報の設定`,
"label.rejectrecords":`却下のレコード`,
"label.selectupdatevalue":`価値の変化`,
"vue_label_pricebook_disabled":`価格表が無効になりました`,
"component.chatter.label.title":`最新の書込み`,
"label.partner.all.workspace":`ワークエリア`,
"label.querydetailservice.delete.message":`データは削除され、または存在しません。`,
"label.objectRelationshipWithout":`関連レコードの有無`,
"nocontain":`含まない`,
"label.partnerCloud.financeSetting.accountSettings":`パートナーファンドの設定`,
"label.file.sharetype.owner":`所有者`,
"label.open.multilingual":`マルチランゲージ対応`,
"label.searchresult.field":`結果項目の検索`,
"label.tabpage.selectdate":`日付の選択`,
"label.h5.logouting":`ログアウト`,
"label.quickbooks.fieldlabel.payment":`支払方法`,
"label.chatter.leaveword":`コメント`,
"label.customfields.majoranddetailrelation.tip":`このオブジェクト（子レベルあるいは詳細情報）と別のオブジェクト（親レベルあるいは主）との親子リレーションを作成します。その中：<br>●すべて詳細情報レコードの関連項目は必須項目です。<br>●関連項目の値が保存されると、更新できません。</li><br>●詳細情報レコードの所有権と共有は主レコードで決められます。</li><br>●ユーザが主レコードを削除すると、すべての詳細情報レコードは削除されます。</li><br>●主レコードで積み上げ集計の項目を作成して、詳細情報レコードを集計します。</li><br>この項目によって、ユーザはルックアップアイコンをクリックして表示されるポップアップリストから複数のレコードを選択できます。主オブジェクトはリスクの値のソースとなります。`,
"label.batchapproveorrefuse":`一括更新一括申請の却下`,
"label.copy.success":`コピー成功`,
"vue_label_show_record_count":`レコード数の表示`,
"label.ems.delete.false":`削除に失敗しました`,
"label.new.Product.Goals":`新製品の目標`,
"label_chatter_BCC":`BCC`,
"label.knowledgebase.data.archived.successfully":`{a}データアーカイブの成功`,
"label.chuangming.title":`Chuang Ming  SMS`,
"label.notification.arketsea.recovery":`あなたの{0}:{1}は{5}に{2}に回収されました。`,
"label.partnerCloud.orderingPlatform.paymentAmount":`支払い金額`,
"label.martrixreport.2018.step5.new":`ステップ5：レポート標準の選択`,
"label.testing":`測定中`,
"chatter.poll.option4":`選択肢 4`,
"lable.outlook.detail.otc":`Exchange から CloudCC.com まで`,
"label.startuploadfile.batch.step2":`ステップ2.「ダウンロード開始」をクリックして、ファイルをダウンロードします。`,
"lable.outlook.edit.outdes":`Exchangeで作成したカスタマ項目を入力してください。このカスタムExchange項目を cloudCC.com 項目に対応付けて、cloudCC.com は初めて同期するとき、Exchange 項目が存在するかどうかを検証します。`,
"hour":`時間`,
"label.appointmentpage.wizard.notif4":`無効なメール形式`,
"label.import.index.state":`状況`,
"label.integrations.mailchimp.massage6":`現在のページで選択されたデータは、選択済みのMailchimpリストにインポートされます。`,
"label.file.share.email.subject":`でファイルを共有しています。`,
"label.assignment.setup.newentries.noassignment":`所有者の再割り当てをしないでください`,
"label.dashboard.unit1":`単位：万`,
"label.forecast.customforecast.foretype.commit":`コミット`,
"label.type":`種別`,
"label.partner.workspace.login.logo":`フッターロゴ`,
"pagecreator_systemstyle_button_edit":`スタイルの編集`,
"label.displaytype2":`詳細情報ページボタン`,
"email.one":`ユーザーの皆様へ<br/>CloudCCへようこそ。あなたは{!operatetime}でパスワードのリセットを要求しました。15分以内に下記の認証コードでログインしてください。<br/>ランダムな認証コードです。<b>{!authcode}</b><br/>以下のリンクをクリックし、パスワードをリセットしてください。<b>{!URL}/authcodecheck.jsp?username={!username}&lang={!lang}</b><br/><br/> <b>重要なことです。</b><br/>もし、あなたがリクエストしていない場合、またはこのメッセージがあなたに届くはずがないと思われる場合は、すぐに管理者に連絡してください!`,
"label.partnerCloud.orderingPlatform.unavailable":`該当する製品はありません。`,
"vue_label_email_save_the_signature_successfully":`サインの保存に成功しました`,
"label.reportsSubscriptionPage.email.detailed":`詳細`,
"chatter.group.query":`検索`,
"label.translation.unsupported.format":`無効な表示形式で、多言語のエクスポートはproperty形式しかできません。`,
"message.operateexception":`情報メッセージ（問題があればシステム管理者に連絡してください）`,
"label.sendemail.chat.praiseFeedcomment":`#name様:\n\n    こんにちは。#userName様はあなたのコメントをお気に入りに追加しました。`,
"label.recycle.clearmy":`ゴミ箱を空にしてください`,
"label_tabpage_choose":`選択`,
"#label.importstep2tip":`多数のファイルをアップロードするなら、すべてのファイルをパッキングしてインポートすることができます。`,
"label.batchedit":`一括編集`,
"label.integrations.mailchimp.export":`Mailchimpにエクスポート`,
"label.cloudccsite.name":`サイト名`,
"serviceterritory.serviceappointment.iscontain.contain":`サービスエリアとサービス予約が関連していますので、サービスエリアを削除できません。このサービスエリアを有効にしなくてもいいです。`,
"label.sum":`サム`,
"setup.mainpage.label.welcome29":`他社製品との標準的なAPIの集成`,
"label.tabpage.nothingz":`無し`,
"label.weixin.actual.contract.jine":`実際の契約金額`,
"label.tabpage.emailaddressz":`送信者アドレス`,
"label.dashboard.unit4":`単位：千万`,
"label.dashboard.data.labels":`データラベル`,
"label.import.page2.oneonone":`1つのCloudCC項目は、1つのファイルの項目のみに対応します。`,
"homepage.components.name":`コンポーネント名`,
"template.report.task.theme":`タスク・サブジェクト`,
"component.setup.label.setupsaveok":`コンポーネント設定の保存に成功しました`,
"front-epwechat-module-v1-add-selfapp":`Seflで作成したアプリの追加`,
"label.to.save.the.current.page.information.button.":`現在のページの情報を保存したい場合は、「クイックセーブ」ボタンをクリックしてください。`,
"vue_label_file_not_support_preview":`このファイルはプレビューできないので、ダウンロードしてご覧ください。`,
"label.object.reached.limit":`オブジェクトは上限に達しました`,
"label.partnerCloud.basicSetting.online":`オンライン決済の有効化`,
"label.app.step1.error.nameexist":`公開チーム名は存在済み`,
"label.workflowandapprove":`ワークフローと承認`,
"label.recordtypeselect.change.tip":`レコードタイプを変更するとき、既存の選択リスト値は自動的に変更されません。同じところでレコードでの既存選択リスク値を更新することをお勧めします。`,
"label.summaryreport.step6":`ステップ6.レポート標準の選択`,
"Pagelayout.Setup.004":`最大で4つの項目を設定することができます`,
"label.file.attached":`追加`,
"front-invoice-online-payment-setup-configure":`Configure Now "をクリックし、"Configure {name} Payment Interface "を選択します。`,
"label.approvaldatamove.submitdate":`提出日`,
"label.emailobject.time.from":`発信者：`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`このレコードでの$schemefield_name$項目はデータベースにすでに存在するたね、再挿入できません。このレコードのエクスポートが見落とされています。`,
"assetbom.copy.notpermission":`アセットBOMをコピーする権限がありません。管理者に連絡してください。`,
"lable.outlook.mcto.autoallocation":`関連するCloudCC.comレコードに自動的に割り当てる`,
"label.dataimport.but.datalength":`、しかしデータの長さは`,
"label.setuserstocommit":`下記のオプションを使用して、初期承認申請を提出することができるユーザを指定します。`,
"component_telerecord_label_related":`関連先`,
"front-lighting-module-v1-detail-file-lockInfo":`このレコードはロックされており、ファイルの追加ができません。管理者に連絡して解除してください。`,
"pagecreator_layout_button_edit":`レイアウトの編集`,
"label.app.step3.tabcanuse":`選択可能なタブ`,
"label.ems.delete.sure":`確かにこのメールボックスのアカウント情報を削除しますか`,
"label.email.show":`表示`,
"label.checkbox.unchecked":`選択されていない`,
"message.error.operation":`アクションに失敗が発生し、システム管理者に連絡してください。`,
"label.template.set.folder.only.upload.type.file":`フォルダのテンプレートセットはWord、Excel、PPTのファイルしかアップロードできません`,
"label.knowledgebase.select.publish.status":`公開状況を選択してください`,
"label.recordtype.tabname.edit":`選択したレコードタイプに新しい名称を入力して、「保存」をクリックします。`,
"label.tabpage.exportview":`ビューをエクスポート
`,
"label.dataimport.insert.sharetab":`共有リストの失敗を挿入`,
"vue_label_dashboard_penetrateto":`まで突き抜ける`,
"label.weixin.group.member":`人`,
"vue_label_systemSettings_customadd":`カスタムエクステンション`,
"UG_Account_03":`積極的に取引先を参照し、マージする`,
"label.singapore.standard.time":`シンガポール時間`,
"label.weixin.captcha":`確認コード`,
"Account_News_Setting_004":`ニュースの有効化`,
"label_emailtocloudcc_select1":`選択してください`,
"label_ring_ratio":`月間`,
"label.industrialandcommercialverification.button.save":`保存`,
"label.approvalstep5.tip":`承認ページで承認者は申請を承認しあるいは拒否することができます。以下のオプションで、このページで表示する項目の編集プロパティを選択します。`,
"label.import.page1.maxrecord{{30000}}":`1.一回に最大{{30000}}件のレコードをインポートすることができます。`,
"setup_object_layout_label_profileoptions":`割り当て可能なプロファイル`,
"label.emailtemplate.type":`テンプレートタイプ`,
"label.searchlayout.tab.field":`タブに表示される項目`,
"chatter.news":`メッセージ`,
"label.pw.small.letter":`小文字`,
"label.notification.group3":`公開グループへの加入は拒否されました`,
"label.ccchat.day.before.yesterday":`一昨日`,
"component.chatter.post.label.title":`張り付け`,
"label.tianyancha.type":`法人種別`,
"label.detail.searchlayout":`検索レイアウトを表示`,
"vue_label_pool_deleteconfirm":`選択した?{??1??}件のレコードを削除しますか。`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1.csv形式のファイルにのみ対応しており、最大対応容量は{{100}}mb、1回のインポートで最大{{30000}}件のレコードをインポートすることができます。制限を超える場合は、複数のファイルに分けてインポートしてください。`,
"label.h5.similar.opportunity.lookup":`類似商談の検索`,
"template.report.customer.list.opportunity":`機会を増やすアカウントリスト`,
"component_setup_iframe_label_memo":`設定アイコンをクリックして、組み込みURLアドレスを入力してください。`,
"label.version.allemail":`メールの一括送信`,
"lable.product.editp":`価格の編集`,
"label.weixin.plate.number":`自動車ナンバープレート`,
"font-evaluate-module-v1-disabled-successfully":`評価オプション "Neutral "の無効化に成功しました。`,
"label.multilingual.tip1":`このページでは、組織の言語を定義します。`,
"label.japan.standard.time":`日本標準時`,
"lable.product.notdel.use":`下記のレコードに関連しているため、{0}の削除はできません。その場合に、使用禁止を勧めます。`,
"label.appointment.wizard.subtitle4-2-4":`4時間`,
"label.queue.edit":`編集`,
"label.partnerCloud.financeSetting.informationTwo":`2.マーチャントセンターの「アカウント管理」「マーチャント管理」「プロダクトPIDIKEY」「シークレットキー管理」をクリックします。`,
"label.partnerCloud.partnerOrdering.permission":`パートナーの注文許可`,
"vue_label_commonobjects_detail_company_hierarchy":`会社の階層構造`,
"label.forecast.settings.sl":`数値`,
"label.partner.workspace.tab.memo":`選択したパートナークラウドはタブを使用し、システムスタンダードタブとカスタマタブを選択することができます。`,
"label.mr.mainRecord":`主レコード`,
"setup_mainpage_label_welcome20":`メール、SMSテンプレート`,
"front-email-payment-select-date-tips":`YYを選択してください。`,
"label.dependencelisttag":`関連リスクの表示ラベル`,
"label.umeng.activity.eventof":`の行動`,
"label.sales.dashboard.collection":`代金受取の目標`,
"report_label_folder":`フォルダ`,
"label.assignment.setup.newentries.step1":`ステップ1.このルールエントリーの順番を設定`,
"label.quote.shrname":`名前(納入先)`,
"label.newreport.group.sum":`グループ数の統計`,
"label.number.MinCheck":`a}の最小値は{0}です。数量を修正して変更を保存してください。`,
"label.chatter.save":`保存`,
"vue_label_email_all_email_templates":`すべてのメールテンプレート`,
"message.summaryconditionnototal":`集計条件は積み上げ集計の項目を選択することができます。`,
"label.callboard":`リリース`,
"label.step2.total5":`ステップ2、合計で5つのステップ`,
"vue_label_homepage_custom_homepage_page":`カスタムホームページ`,
"label.data.newtemplate.e_seltype":`データエクスポートの方法の選択`,
"label.data.dataexpalltype.all.desc2":`2、すべてのデータをエクスポートするには時間がかかります。エクスポートが完了すると、データのエクスポートが成功したことを示すリマインダーメールが送られます。`,
"lable.account.CalenderYear":`カレンダー年度`,
"message.error.data":`転送するデータは空にしてはいけません。転送のパラメータを確認してください。`,
"label.from_user":`ユーザーから`,
"label.parentdepartment":`上位部門`,
"template.dashboard.product.analysis":`製品分析`,
"label.tabpage.unpacketz":`使用可能なグループ化データはありません。`,
"label.icon.107":`コミュニケーション`,
"label.monitorsys.operator.username":`ユーザ`,
"label.serchreport":`検索レポート`,
"label.payment.upgrade":`グレードアップ`,
"setup_layout_button_ok":`確認`,
"label.please.select.channel":`チャンネル責任者を選択してください`,
"template.chart.txdrw":`タスクリマインダー`,
"chatter.group.accept":`受ける`,
"pagecreator_systemstyle_message_canntdelete":`このスタイルは削除できません`,
"label_tabpage_ctbtsftcz":`検索をクリックして、内容を選択してください`,
"label.datamanage.select.accountfield":`（インポートする取引先項目の選択）`,
"label.schedulejob.setup.list.title":`スケジュール済みジョブ`,
"label.visualpage_list.title":`有効になっているカスタマページのアクセス`,
"label.mr.selectTwoData":`2つ以上のマージするデータを選択してください`,
"label.customer.tab.step2.different":`プロファイルごとに異なるタブ表示を適用する`,
"label.mobile.side.tab.can":`使用可能`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`CloudCCアカウントはバインディング済みで、続ければ以前にバインディングされたこのCloudCCアカウントのWechatアカウントはCloudCCシステムを使用することができなくなりますが、続きますか。`,
"label.applet.to.case":`ミニ番組お客様相談室`,
"lable.outlook.detail.cmaping":`取引先責任者項目の対応付け`,
"label.theUserActiveTime":`過去のパスワードの利用制限日数`,
"label.event.moveup.9hour":`9時間`,
"vue_label_pool_other":`その他`,
"label.fieldname":`項目名`,
"vue_label_notice_add_success":`追加に成功しました`,
"label.conditiontag.lookup.insertbutton":`選択したものの挿入`,
"label.identifying":`ID`,
"label.tabpage.uploadingz":`アップロード中`,
"label.view.introduce":`ビューの編集`,
"vue_label_dashboard_sortingmethod":`並び替え方式を選択してください。`,
"label.quote.number.introduce":`と割引の数を入力し、[保存]をクリックします。`,
"front-kefu-moudle-which-missphone-case":`電話がかかってこなかったケースの作成`,
"label.sendemail.chat.response":`書き込みの返事：`,
"label.productsales.refreshTime":`前回の更新時間`,
"lable.SalesCommitmentKanBan.phase":`階段`,
"label.version.sum.object":`オブジェクト（個）`,
"label.defineReportStep2":`ステップ2`,
"message.duplication.label.returnDuplications":`重複検索条件リスクに戻る`,
"label.lookover":`参照`,
"label.quickbooks.button.copy2":`CloudCCからQuickBooksに同期する`,
"label.checkbox.true":`はい`,
"label.profilename":`プロファイル名`,
"label.finalapproveoperate":`最終承認アクション`,
"label.SMS.detailed":`SMS通知はトリガされたとき、ワークフロールールが発送するメールです`,
"label.lasttimemodifier":`前回の更新者`,
"label.sso.summary":`集計`,
"label.customfields.encd.tip":`いずれ文字列と数字の組み合わせを入力でき，クリアテキストで保存します。暗号化形式で表示し、検索することが可能です。`,
"vue_label_report_formulacolumn":`行レベルの数式列`,
"vue_label_systemSettings_transfer":`一括転送記録`,
"lable.product.ecm":`正しい金額をご入力ください`,
"label.partner.setup":`パートナークラウドの設定`,
"label.same.analyze.miaoshu2":`機能`,
"label.mobile.phone.day.summary":`今日のまとめ`,
"label.ccchat.person.error.illdomain":`エラー：ドメイン表示形式は不正確です`,
"label.knowledgebase.edit.as.draft":`ドラフトとして編集`,
"message.duplication.label.newfilterule":`新規重複検索条件ルール`,
"vue_label_salesfunnel_notice1":`商談のまとめ`,
"label.partnerCloud.partnerAccount.order":`オーダーNo:`,
"label.account.Current.and.PreviousFQ":`現在と前回の四半期決算`,
"label.customfields.formula.dateandtimeexample":`Next（次の値）`,
"label.area.unassign":`割り当てされていないユーザ`,
"label.at.my":`私がメンションした内容`,
"vue_label_calendar_notice_stopsharingfail":`共有の停止に失敗しました。`,
"label.data.file.validation.rules":`検証規制の実行`,
"label.escalation.setup.entrydetail.escalation.hour":`時間`,
"vue_label_ccchat_notice_pleaseentercontent":`書込みのコンテンツやオプションを入力してください`,
"label.forecast.edit.error1":`エラー：無効な追加種別`,
"label_emailtocloudcc_exists1":`このメールボックスは既にEmail to Lead. に設定されていますので、重複な設定をしないでください。`,
"label.trigger.send.email":`トリガーのメール通知の送信`,
"label.setmysafetysignagain":`セキュリティトークンのリセット`,
"label.callcenter.pleaseenter.access.keyID":`シークレットキーIDを入力してください`,
"chatter.poll.option10":`選択肢 10`,
"vue_label_systemSettings_mobelbottonsetting2":`ユニファイド・ボトムメニューの設定`,
"label.quickbooks.searchs":`検索`,
"label.section":`セグメント`,
"label.customfields.fielddependency.new.tip":`連動関係を作成します。この連動関係はユーザが他の項目で選択した値に基づき、選択リストまたは複数選択リストにおける値を動的に選択することにつながります。<ul ><li>選択を進める項目をコントロール項目と呼びます。1～300の値を保有するスタンダードとカスタマイズのチェックボックス及び選択リストはコントロール項目になることができます</li><li>その値が選択された項目を「連動項目」と呼びます。カスタマ選択リストと複数選択リストは連動項目になることができます。</li></ul>`,
"label.customobjects.track.introduce3":`ご注意：更新部分で表示される項目のみ追跡します。項目値を追跡するとき、「更新済み」のみ表示されます。`,
"front-kefu-moudle-all-hidden-phone":`グローバルに電話番号を隠す`,
"vue_label_calendar_share_calendar_with_others":`カレンダーを他の人と共有する`,
"label.case.copre":`WebポータルQRコードのダウンロード`,
"label.conditiontag.lookup.pagetitle":`選択リスト値の選択`,
"UG.opportunity.004":`マルチサービスタイプ`,
"label.event.moveup.1day":`1日`,
"label.industrialandcommercialverification.enablestatus1":`企_デ_タの__を有_化`,
"label.ccpeak.newrecord.getorpost":`新規レコード：CCObjectオブジェクトを使用します。CCObjectに2つの構造方法があります。`,
"frame.personinfo.label.resizeimage":`サムネイル画像を調整するには、上のプロフィール写真の点線部分をドラッグしてサイズを変更します。`,
"label.optional.searchresultfield":`選択可能な検索結果項目`,
"UG.Contract.02":`契約書とは、当事者間の合意事項を記したものです。多くの企業は、他社との取引条件を定義するために契約書を利用しています。CloudCCを通じて、取引先と商談の既存契約を確立し、文書化することができます。承認プロセスで契約を追跡します。ワークフローのリマインダーを利用して、契約の期限切れが通知されます。`,
"label.group.activity":`活動チーム`,
"label.tabpage.characterz":`開始文字`,
"label.globalsearch.tip":`検索内容をご入力ください`,
"label.campaign.channel.download.size2":`中サイズ：500×500ピクセル`,
"label.step3.total4":`ステップ　3/4`,
"label.partnerCloud.payForFailure":`決済失敗`,
"label.ggReleaseRange.editSuccess":`編集成功`,
"label.summaryinforelyon":`情報を集計する根拠`,
"label.productsales.htyj":`契約業績`,
"label.newpagelayout":`新規バージョンのレイアウト`,
"front-gantt-module-input-task-name":`タスク名を入力してください`,
"label.c_d_without":`Cレコードに関連Dレコードがあり、またはありません。`,
"label.licence":`ライセンス`,
"setup.layout.button.selectall":`全て選択`,
"label.app.step1.error.appnameexist":`エラー：アプリケーション名は存在済みです`,
"label.cpq.quote.item.no.record":`契約に移行できるのは、記録のある受注製品のみです。`,
"label.knowledgebase.noaffect.existing.translations":`いいえ、私の修正は既存の翻訳には影響しません。`,
"label.schedulejob.setup.schedule.editjob":`スケジュール済みジョブの編集`,
"lable.PowerProcess.Tips":`エンタイトルメント プロセスは、すべてのステップのカスタマイズ可能なタイムラインで、サポートサービスなどのスタッフはすべてのステップを完了しなければ、サポートされたケースや作業注文レコードを解決できません。設定した後、エンタイトルメントに適用することができます。`,
"label.campaignmember.selectmember.step2":`ステップ2：追加するメンバーを選択`,
"vue_label_calendar_stopsharing":`本当にカレンダーの共有を停止しますか`,
"vue_label_notice_savemenu_fail":`メニュー保存に失敗しました`,
"message.error.getitems.id":`getItems: idは空にしてはいけません`,
"label.return.currencylist":`リスクに戻る：通貨管理`,
"label.wtd.detail.p":`PC版`,
"label.knowledgebase.publish.now":`今すぐ公開`,
"label.appupload.install.explain":`インストール説明`,
"label.visualpage.folder.all":`すべてのページファイル`,
"message.passwordPolicy.validate.complexReq2":`エラー：パスワードは必ず数字の英字の組み合わせです`,
"label.umeng.chatter.at":`私に関する内容を書き込みました`,
"label.mobile.phone.month.report":`月報`,
"label.describableEditeSelectedFields":`新規カスタマレポートとして、レポート列でデフォルト表示される項目を選択します`,
"component.event.label.subject":`件名`,
"label.knowledgebase.edit.draft":`エディットドラフト？`,
"label.customer.tab.step1.selectoneobject":`既存のカスタマオブジェクトを選択します`,
"label_partner_step2":`ステップ2.テンプレートの確認`,
"label_starting_annual":`開始年`,
"X":`テキストエリア`,
"label.customer.tab.style":`タブスタイル`,
"vue_label_commonobjects_detail_book":`標準価格表`,
"chatter.email.referredToMe":`投稿で私に関する内容を書き込んだ（私をメンション）`,
"label.enable.both.barcode.qrcode":`バーコードやQRコードを有効にする`,
"front-market-form-quired-choose":`必須項目`,
"noinclude":`含まない`,
"label.sms.template.select":`SMSテンプレートを選択してください`,
"label.weixin.optionten":`選択肢 10`,
"message.duplication.label.matchlastletters":`後ろのいくつかの文字が一致している`,
"label.webtocloudcc.submit.success":`提出成功`,
"label.sales.dashboard.number":`第`,
"label.custom.field":`当該カスタマ項目を`,
"label.dataimport.of.field":`項目（個）`,
"label.view.new":`新規ビューの作成`,
"UG_activity_03":`日付の予約`,
"label.customfields.image.tip":`図表のアップロードを許可.`,
"label.startexport":`インポートを開始`,
"vue_label_commonobjects_view_chart_verticalbar":`縦棒グラフ`,
"label.ccchat.person.invite.allexist":`招待した人はすでにChatを使っています。`,
"label.fielddependence":`項目の連動関係`,
"label.scan.tip":`IE7、IE8、ChromeあるいはFirefoxウェブブラウザーを使用する場合、1024×768以上の解像度の使用を勧めます`,
"label.wei.weiactor":`Micro Voteの参加者`,
"label.service.miniProgram.quantity":`カルーセルレコードは最大20件まで作成可能～`,
"vue_label_homepage_new_homepage_page":`新しいホームページ`,
"label.apply.telphone.validate.error":`携帯の確認コードが間違っています`,
"component.assistant.button.newevent":`新規行動`,
"System_TimeField_Format_Warning":`有効期間ではない`,
"chatter.feed.publishfeed":`投稿&コメント`,
"label.setting.intergrationlist":`アプリケーション?インテグレーション`,
"label.object.prefix":`オブジェクトの接頭辞`,
"label.tippage.confirmed":`はい、私はカスタマレポート種別とすべての連動レポートを削除したいです。`,
"label_emailsync_form_signin":`ログイン`,
"label.delete.cancel":`復元`,
"label.dashboard.myHomePage.des":`すべてのアプリケーションで表示されるダッシュボードを選択してください`,
"lable.account.FY.Ago":`2つの会計年度の前`,
"label.umeng.approval.reassign":`#approverは#objの承認を再割り当てました`,
"label.data.exp.zippwd2":`自動的にパックファイルの暗証番号を生成します`,
"label.tabpage.contentz":`コンテンツを入力してください`,
"label.callcenter.batch.add.number":`バッチで数字を追加`,
"label.tabpage.deleteviewsuccess":`ビューの削除に成功しました`,
"setup_layout_group_field":`項目`,
"label.appupload.component.addobj.scheme.label.suoshu":`所属のオブジェクト`,
"front-project-module-v1-market-is-template":`テンプレートとして登録`,
"label.service.gantt.one.esource.types":`以下のいずれのリソースタイプ`,
"label.emailtocloudcc.search":`検索`,
"label.mobile.home.page.myyj":`私の業績`,
"vue_label_normal_invoice_sf":`領収書`,
"label.permission.detail.app.fenpei.tip":`アプリケーションメニューでのアプリケーションの参照可能の設定`,
"label.login.access.month":`月`,
"label_tabpage_retypez":`レコードタイプを更新する際、ご利用中の選択リスト値は自動的に更新することができないため、同じ場所でレコードのご利用中の選択リスト値を更新することをお勧めします。`,
"label.ems.private.company.message":`プライベートクラウドはオンラインでの会社メールボックスの編集をサポートしません`,
"label.dataimport.length.check":`長さは18桁を超えており、このレコードをよくチェックしてください。`,
"label.batchtransfer.type1":`既存取引先に属しない未処理商談を移行`,
"vue_label_calendar_are_you_sure_to_remove":`このカレンダーを削除しますか`,
"label.icon.117":`ランドセル`,
"vue_label_systemSettings_downloadapp":`モバイルアプリのダウンロード`,
"label.approval.project":`承認待ちのプロジェクト`,
"template.organization":`組織レベル`,
"label.weixin.return.research":`Micro research情報ページに戻る`,
"label.ccchat.person.invite.addsay":`1つの選択可能な情報を追加`,
"UG.Case.02":`ケースでは取引先の問題に対応し、解決することができます。ケースは Cloud CCでの機能が強いレコードで、取引先の問題を追跡するだけでなく、取引先ビューを表示することもできます。`,
"label_emailtocloudcc_step1":`ステップ1`,
"workflow.action.tasks.assignortype.owner":`所有者`,
"label.data.import.page":`データエクスポートページに入ります`,
"label.cache":`キャッシュ`,
"label.custom.page.cuspage.width":`ページの幅 (ピクセル)`,
"label.customcomponent.referencetag":`参照の表示ラベル`,
"label.tabpage.search":`検索`,
"label.knowledge.searcharticle.casefields":`推奨文章を検索するケース項目`,
"setup_layout_message_relatedlistfield":`関連リスクで表示する項目を選択し、再並び替えることもできます。`,
"label.relationobject.type":`関連オブジェクトタイプ`,
"UG_Account_02":`ある企業は他の企業にサービスを提供し、ある企業は直接的に端末ユーザーと協力し、またある企業はNGO組織にサービスする。`,
"UG_homepage_006":`アンケート、ライブチャット、電子メール、注文、ソーシャルメディアの書き込みおよび販売活動（リード、サービスサポートと活動など）を通して、取引先の活動を360度に理解します。`,
"chatter.poll.option1":`選択肢 1`,
"label.ccdocument.fieldforld":`ドキュメントが属するフォルダの名前`,
"label.wei.result":`投票結果`,
"label.recentview.new":`最新`,
"label.martrixreport.setsumfield":`マトリックスレポートで行を集計する項目を選択して下さい`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`月曜日`,
"label.marketsea.button.recycle":`回収`,
"label.standard.buttonandlink.info2":`この標準ボタンあういはリンクを置き換えるCloudCC URLのカスタマページを選択してください。`,
"label.reportsSubscription.select.two.months":`この周波数の日付範囲は2ヶ月以内に選択してください。`,
"label.standard.buttonandlink.page":`標準CloudCCページ`,
"vue_label_commonobjects_view_chart_horizontalbar":`横棒グラフ`,
"label.Remove":`削除`,
"label.mobile.phone.receivable":`代金受取`,
"label.appupload.uploaddetail.goback":`ソフトパッケージリストに戻る`,
"label.select.role":`ロールを選択してください`,
"label.file.sharetype":`共有種別`,
"label.app.chosetab":`タブの選択`,
"label.case.other.phone":`その他の電話番号`,
"chatter.edit.cancel":`更新はキャンセルされました`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`auth2cnの取得に失敗しました。`,
"message.error.system.service.permissiondeny":`すみません、当該サービスの権限が付与されていまえん。システム管理者に連絡してください。`,
"label.chatter.mygroups":`私のグループ`,
"label.umeng.approval.approvalpass":`#objの承認は通過しました#objname`,
"label.chatter.owner":`所有者`,
"vue_label_commonobjects_view_kanban_view":`看板ビュー`,
"message.please.choose.group.role":`チームロールを選択してください`,
"label.icon.136":`通貨`,
"label_tabpage_selectdate":`日付の選択`,
"chatter.emailInformation":`一般情報`,
"front-lightning-module-v1-dashborad-bubble-size":`バブルサイズ`,
"label.stdashbord.xsld.business.wan":`万`,
"label.datamanage.field.notexist":`オブジェクトの項目は存在しません`,
"UG.Forcast.04":`試験開始`,
"UG.contact.02":`コール、Eメール、ソーシャルなど複数のチャネルを通じて取引先責任者を獲得します`,
"vue_label_pool_selecttransferinto":`移行するリードプールの選択`,
"label.quote.xingming":`名前`,
"label.customerinfo.userlicencenum":`ユーザライセンス件数`,
"label.group.no.my.archived":`一致するファイリングされたチームは見つかりません`,
"label.weixin.add.activity.tel":`活動電話の追加`,
"label.partner.setup.address":`パートナークラウドアドレス`,
"label.data.file.i_title.num3":`3.システムはインポートするデータファイルをサーバーに先読みし、バックグランドのバッチ処理を有効化してアプリケーションをインポートします。インポート結果はメールでユーザに通知するため、このアクションページで待つ必要がありません。`,
"label_sum_up":`合計`,
"label.searchall.title":`グローバル検索`,
"label.bind.chooseone":`オーナー選択`,
"label.campaign.channel.input.owner.select1":`現在のキャンペーン所有者`,
"front-kefu-moudle-v1-Expand-chat":`チャットの詳細を見る`,
"label.component.hotdeal":`人気のある取引`,
"component_event_label_title":`これから行う行動`,
"No.planed.activity":`活動予定はありません`,
"label.searchlayout.result.field":`検索とタギングの検索結果列`,
"label.leadscore.value":`スコア`,
"vue.dashboard.linkage.is.set.successfully":`連動の設定に成功しました。`,
"PersonalInfo.LoginHistory.001":`ブラウザ検証メールアドレスの登録リンク`,
"front-gantt-module-v1-problem-number":`問題数`,
"label.page.step5.of.step5":`ステップ　5/5`,
"label.sendemail.chat.sendmessagesubject":`CloudCC CCChat メッセージ通知`,
"label.Linkedin_accounts":`LinkedInアカウント`,
"label.qrcode.useful.life":`QRコードの有効期限`,
"deleterow":`行の削除`,
"label.forecast.settings.future1":`これからの1週間`,
"message.error.group.operation":`グループファイリングにエラーが発生しています`,
"label_tabpage_loadz":`ページはアップロード中で、少々お待ちください。`,
"label.brackets.left":`(左括弧`,
"label.source.code":`ソースコードの表示`,
"setup_layout_label_areasetup":`エリアプロパティの設定`,
"component.assistant.label.todaylead":`今日あなたに割り当てたリード`,
"label.qrcode_signin":`QRコードは、その場でコードをスキャンしてサインインする必要があるアプリケーションに限られます。`,
"label.calendarshare":`カレンダー共有`,
"IMG":`画像`,
"label.use.rule.when.both":`このルールは、バーコードとQRコードを同時に有効にする場合に適用されます。`,
"label.ccpeak.addshare.record":`新規共有リスクレコード：新規レコードをを参照してください。`,
"label.enable.email.tracking":`メールの追跡を有効化`,
"label.top.plsinput":`このリストを検索...
`,
"vue_label_helpcenter_case":`ケースとは取引先からのフィードバックや質問です。サポートエージェントは、ケースを確認することで、如何により良いサービスを提供するか考えいます。営業担当者はケースの利用でで、販売プロセスへの影響を理解し、取引先に満足していただき、ブランドイメージを高めることができます。`,
"label.useonly":`非公開`,
"label.displaytype":`表示の種別`,
"label.most.user.group":`ユーザが最大100ユーザチームまで参加できますが、すでに100ユーザチームに参加しました。`,
"label.umeng.activity.yourevent":`あなたの行動`,
"label.forecast.shrepage.classdes.w":`参照/更新－参照と予測データのカバーができます`,
"label.defaultaccess":`デフォルトのアクセス権`,
"label.partner.new.step2":`ステップ2.テンプレートの確認`,
"component_setup_iframe_label_title":`カスタマページ`,
"label.sso.saml.sp.idenitytype":`SAML アイデンティティタイプ`,
"label.dashboard.this.folder":`当該フォルダのダッシュボード`,
"label.data.newtemplate.e.seltype.desc":`データエクスポートに2種類の方式があります：</li><li class`,
"label.forecast.customforecast.submit.tip1":`から提出しますか`,
"label.version.workflow.and.approval":`ワークフローと承認の自動化`,
"label.tianyancha.tip":`入力されたテキストが間違っています、もう一度入力してください`,
"label.report_details":`レポート詳細`,
"template.report.folder.contract.product":`契約・製品分析`,
"label.all":`所有`,
"label.version.area.long.rich":`{0}リッチ/ロングテキスト項目`,
"label.enc":`メモリの暗号化`,
"vue_label_pricebook_enterproductname":`製品名を入力してください`,
"label.edit.quote.line":`見積り行の編集`,
"label.edit":`編集`,
"M":`マスタ詳細情報リレーション`,
"front-kefu-phonenumber-exists":`シートNo.｛a｝は既に存在しています。`,
"label.standardplatformuser":`標準プラットフォームユーザ`,
"label.custom.page.configuration":`カスタマページの更新`,
"url.error.contact.null":`マイクロサービスの住所が空です`,
"label.sethelp":`ヘルプの設定`,
"setup.mainpage.label.welcome23":`セキュリティ設定`,
"label.sales.page.dashboard.fenxi":`販売分析ダッシュボード`,
"label.limit":`アクセス権`,
"maintenanceasset.asset.contractlineitem.illegal":`まず契約行の項目で資産を選択してから、契約行の項目と保守資産を関連付けることができます。`,
"UG.contact.04":`或いは`,
"Opportunity.Detailed.Phase.Label.004":`日`,
"label.emailobject.receive":`受信者`,
"label.brief.new":`新規`,
"label.marketsea.button.adopt":`受取`,
"label.select.up.to.three.fields":`最大で3つの分野を選択できます。`,
"vue_label_allsearch_noresults":`カスタマイズされた検索設定で検索しましたが、{userInput}と一致する結果は見つかりませんでした。`,
"Report_CantDelete_Info":`{0}レポートは{1}ダッシュボードに参照されており、削除できません。`,
"label.chile.summer.time":`チリ時間`,
"label.partnerCloud.menu.selectedMenu":`選択されたメニュー（チェックされたメニューはアプリに同期する`,
"vue_label_report_onlysummary":`概要のみ`,
"front-template-V1-Applicable-object":`該当するオブジェクトを選択してください。`,
"label.invoice.message.sendfailed":`Invoiceの_送に失_しました`,
"front-kefu-moudle-v1-use-free":`無料でお試しいただけます。`,
"label.rule.updated.successfully":`ルールの更新に成功`,
"label.owner.lastone":`少なくとも1つの条件を維持します`,
"label.appointment.wizard.subtitle1":`会議期間`,
"template.report.opportunities.closed.month":`今月のクローズド案件`,
"label.tabpage.choosecontent":`値の内容を選択してください`,
"template.chart.jbnddxl":`この半年間の受注状況`,
"label.fieldsecurity.detail":`項目セキュリティの詳細情報`,
"label.knowledgebase.data.deleted.successfully":`{a}データの削除が成功しました。`,
"label.sso.saml.idp.config.nameidfmt":`名称IDの形式`,
"label.emailobject.prompt":`メッセージ`,
"label.marketsea.isgetbyself":`メンバーによる受取を許可します`,
"label.winxin.cancelprompt":`現在のアクションは保存していません。確かにログアウトしますか。`,
"label.appexchange.installedpage.message2":`アプリケーションやコンポーネントは、パッケージでインストールされます。インストール直後は、すべてのカスタムアプリケーション、タブ、およびカスタムオブジェクトに「開発中」のマークが付いており、組織内のユーザは利用できません。このため、アプリケーションをテストおよびカスタマイズしてからリリースできます。コンポーネントは、[リリース] をクリックして、他の設定機能を使用して個々にリリースしたり、グループ単位でリリースしたりすることができます。`,
"vue_label_import_importtype":`タイプのインポート`,
"label.data.importef.des":`インポートに失敗したファイルはサーバーで48時間保存されますが、48時間を経過すると削除されます。`,
"chatter.email.reply":`私の投稿へのコメント`,
"label.stdashbord.xsld.business.sdl":`チャンスロス率`,
"labal.emailtemplate.namemessage":`メールテンプレートの一意の名前は存在しているため、再編集してください。`,
"vue_label_email_Please_select_file":`ファイルを選択してください`,
"label.event.modify":`行動の編集`,
"label.projectManagement.isnmber":`最大1桁の小数を入力してください`,
"lable.outlook.detail.emailst":`メールの設定`,
"label.partnerCloud.priceOfManual.isUsed":`この設定は、パートナーが注文時にこの価格表を使用できるかどうかを決定します。`,
"setup_mainpage_label_welcome26":`データの管理-一括処理機能`,
"label.file.version":`バージョン`,
"pagecreator_systemstyle_label_bordercolor":`フレームの色`,
"label.approval.isallowed.reject.prompt":`単一データの承認時に拒否ができますか（一括承認は常に拒否ができます)。`,
"label.myinfo":`私の情報`,
"front-template-V1-fontSize":`フォントサイズ`,
"lable.outlook.edit.alpreo":`Exchangeをいつも優先的に選択します`,
"front-email-payment-card-number":`カード番号`,
"label.cpq.quote.pricebook.no.change":`一度決定した見積書のプライスブックは変更できません。新しいプライスブックを使用するためには、新しい見積書を1件作成してください。`,
"vue_label_file_size_limit_tip":`ファイルサイズが制限を超えている`,
"lable.PowerProcess.worktime":`エンタイトルメントプロセスの作業時間`,
"label.monthly.month.report":`月間YoY、MoMレポート`,
"front-kefu-moudle-v1-sydq-buyuser":`トレイルは期限付きです。イージーモブを購入して、使い続けてください`,
"label_tabpage_Rolesz":`ロールと下位ロール`,
"chatter.f.n":`このレコードの追跡`,
"UG.Forcast.02":`予測とは、ある期間の予想売上高の推定値のことで、予測モデルを使えば、ある期間の製品需要や売上高を把握することができます。マネージャーは予測を使って目標を設定したり、チームの進捗状況を測定したりすることができます。組織の全体的な予測は、営業担当者によりすべての販売状況を反映させることができます（パイプラインステージからクローズドステージまでのいかなるステージ）。`,
"label.productsales.contract.phb":`契約ランキング`,
"label.umeng.insert.approval.submit":`#applyerが#objを提出して承認を得る`,
"message.duplication.label.matchfirstletters":`前のn番目の文字が一致します`,
"label.partnerCloud.partnerAccount.toPay":`決済へ`,
"label.model.un":`モデル番号：UN6786`,
"label.save.c1":`web to cloudcc の名前は重複できません`,
"week":`曜日`,
"Pagelayout.Setup.003":`名前項目を選択する必要があります`,
"label.query.detail.openpartnermessage":`取引先はパートナーとして有効化されると、isPartner項目で絞り込んだレポートとリストビューの中に現れます。また、パートナーユーザーはこの取引先に関連する取引先責任者から作成することができますが、確かにしますか。`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(date)`,
"label.apply.send.false":`送信に失敗しました`,
"label.recordtype.edit.selectvalue":`選択リスト値`,
"label.chosesubject":`トピックの選択`,
"label.validate.function.funcExplain.YEAR":`日付に対応する年を返します。戻り値は、1900 (年) から 9999 (年) までの整数となります。`,
"component.chatter.button.more":`詳細情報をさらに表示する`,
"label.top.class.smallest":`階層の最小値は1です`,
"label.startingvalue":`開始番号`,
"label.multi.layout.remark":`フロントエンドのマスター/ディテール入力と一括追加に応用されるレイアウト`,
"label.role.availableuser":`選択可能なユーザ`,
"label.weixin.iebrowser":`現在使用しているブラウザーバージョンはIE6で、IE6はマイクロソフトが2001年にリリースした古いーバージョンです。CloudCC は新しい技術で開発されたシステムで、すべての機能が正常に使用することは確保できないため、使用しているブラウザを最新バージョンに更新してください。`,
"Homepage_News_004":`ニュースはありません`,
"vue_label_normal_task_sf":`ToDo`,
"label.version.nonsupport.trigger":`トリガーを暫くサポートしません。`,
"pagecreator_page_label_pagelayout":`ページレイアウト`,
"label_tabpage_step3":`ステップ 3.表示する項目の選択`,
"label.canOnlyUploadCSVFormatFile":`CSV形式のファイルのみアップロードできます`,
"label.b.c.least":`「B」レコードには少なくとも1つの関連「C」レコードが必要です。`,
"label.list.userinterface.sales.enable":`販売ホームページのランキングを参照する権限を有効化`,
"label.umeng.approval.approvalreject":`#objの承認は拒否されました#objname`,
"vue_labenl_normal_notice_share_fail":`共有に失敗しました`,
"label_emailtocloudcc_tip":`メッセージ`,
"label.h5.touchselect":`クリックして選択`,
"label.tabularreport":`表形式レポート`,
"label.app.defaulttab":`デフォルトタブ`,
"label.validate.function.category.Datetime":`日付と時間`,
"vue_label_pricebook_editdetail":`価格表エントリーの編集`,
"vue_label_commonobjects_view_no_selected_record":`レコードが選択されていない`,
"chatter.changed":`0`,
"label.asset.bom.based":`注文の製品構成に応じた資産BOMの作成`,
"label.appointmentdetail.wizard.title8":`どれぐらいの間隔で始まりますか`,
"label.area.query.user.error":`エリアが対応するユーザデータの検索に失敗しました。エリアIDはNULLです。`,
"page.field.masterinput":`マスター/ディテール入力の設定`,
"chatter.selads":`受信者の選択`,
"label.data.exp.please.savebutton":`「別称でテンプレートに保存」をチェックしてください`,
"label.members.activity":`活動メンバー`,
"label.weixin.click.searchs":`クリックしてレコードを検索します`,
"label.input.least.two":`少なくとも2文字を入力してください`,
"label.marketing.seting":`Marketing Cloudの設定`,
"label.approveprocess.tip":`承認プロセスは、実施前に情報収集と計画を要する複雑なビジネスプロセスです。設定を開始する前に、以下の手引きにしたがって作業することをお勧めします。`,
"front-email-payment-Invoice-login-account":`ログインアカウント`,
"label.selectmulti.mes":`選択した受信者は多すぎます`,
"label.workflow.gotolist":`ワークフローリスクに戻る`,
"label.profile.fieldsafety":`項目レベルセキュリティ`,
"front-project-module-v1-no-selectemplat":`利用可能なテンプレートはありません`,
"label.sendemail.queue.assigntitle":`キュー割当先のレコードの通知メール`,
"label.approval.mobile.comments.placeholder":`ここでコメントを入力してください。最大で1000文字までです`,
"vue_label_report_given":`特定`,
"vue_label_dashboard_groups":`グループ化を選択してください`,
"label.service.gantt.popoverTip":`移動距離・移動時間`,
"label.mr.title.characters":`前のいくつの文字に基づく`,
"label.passwordPolicy.setup.day":`日`,
"label_tabpage_personvisible":`関連者が参照可能`,
"ct":`多種の通貨`,
"label.chatter.newEvent":`新規行動`,
"vue_label_systemSettings_id":`ログインID`,
"label.page.preview.web.tab":`Web タブのプレビュー`,
"label_emailsync_button_sure":`確認`,
"front-template-V1-Modification-time":`修正時間`,
"vue_label_homepage_edit_fixed_components":`スタンダードコンポーネントの編集`,
"label.apply":`適用`,
"Main.Menu.Mobiledownload":`に利用可能`,
"vue_label_salesfunnel_notice6":`可能性が100%である商談金額`,
"label.chosesubject.sendemail":`メールを送信`,
"label.changemydisplay.chagetab.des":`私のアプリケーションで表示されるタブを選択`,
"label.attendance.setting.checkUser":`その他の勤怠に存在済みです`,
"label.list.projectSetting.setup":`プロジェクト管理の設定`,
"label.app.introduce2":`既存のアプリケーションをカスタマイズして自分の仕事のやり方に合わせたり、標準タブやカスタムタブをグループ化して新しいアプリケーションを構築したりすることができます。`,
"label_emailsync_form_emialpassword":`パスワード`,
"label.Lightning.Setting":`ライトニングの設定`,
"label.print.preview":`印刷用に表示`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`それでもこの期間にイベントを作りたいと思いますか？`,
"label.mobile.phone.report.type":`レポートタイプ`,
"lable.account.CalenderWeek":`カレンダー曜日`,
"label_emailtocloudcc_step3total3":`ステップ　3/3`,
"label_tabpage_emailaddressz":`送信者のメールアドレス`,
"label.data.is_woking":`作業中`,
"label.knowledge.cancelattach.case":`キャンセル ケースに取り付ける`,
"label.sendemail.chat.chatcontent":`トピックの内容：`,
"label.timezone.set":`エリアの設定`,
"label_tabpage_uploadingz":`アップロード中`,
"front-epwechat-module-v1-home-url":`ホームページのURLです。`,
"label.reportsSubscription.select.subscription.frequency":`購読頻度を選択してください。`,
"label.validate.function":`関数`,
"label.partnerCloud.orderingPlatform.quantity":`数量`,
"label.compact.layout.chatter":`マイクロポスト`,
"label.sso.saml.sp.description2":`外部環境からCloudCCシステムにログインするために、シングルログインを設定します。`,
"label.ccchat.message.new.error1":`がついた名前は見つからないです{0}のChatユーザ`,
"label.file.share.email.content3":`詳細情報については、Cloudcc CRMシステムにログインして、参照してください`,
"label.file.cancel.sharing":`共有を解除`,
"label.changemydisplay.showalltabs.add":`マイディスプレイにタブを追加する`,
"label_chatter_incident":`行動`,
"label.file.folder.delete3":`{foldername}を削除しますか?`,
"label_tabpage_delsuccessz":`削除に成功しました`,
"label.view_contact":`連絡先を見る`,
"label.deactivate":`使用禁止`,
"label.Horizontal.Date":`レベル日付でサービス予約を絞り込みます`,
"label.forecast.tree.title":`予測構造`,
"vue_label_dashboard_dategruop":`日付のグループ化の方法を選択してください。`,
"label.version.nonsupport.custompage":`カスタマページを暫くサポートしません。`,
"label.tabpage.personvisible":`関係者が参照可能です`,
"message.error.unknown":`知らないエラー`,
"label.down":`下へ`,
"label.multilang.customforcast.financialyear":`{0}番目の会計年度`,
"label.dataimport.type.error":`種別にエラーが発生し、当該レコードをチェックして修正してください。`,
"label.batchadd.newbatchpage.save.num":`数値形式は不正確です`,
"front-Dev-V12.2.8-calendar-endField":`エンドフィールド`,
"label.tabpage.rtemptyz":`レコードタイプは空にしてはいけません`,
"vue_label_dashboard_maximum":`最大値を入力してください。`,
"label.expiredate":`期日`,
"label_emailtocloudcc_button_view":`表示`,
"label.event.future":`これからの行動`,
"label.mobile.app.layout":`モバイル端末のレイアウト`,
"label.emailobject.contacts":`  連絡先`,
"label.approvalstep2.tip":`指定されたレコードはこのステップに入る前に、ある条件を満たしていますか。`,
"label.usefollowtoset":`下記のオプションを使用して、承認申請が割り当てられるユーザを指定します。`,
"label.dashboard.summary.editPageHeader":`ヘッダーの編集`,
"label_partner_workspace_tab_memo":`このパートナークラウドで使用可能なタブを選択します。スタンダードタブとカスタマタブはどっちでも選択可能です。`,
"front-lightning-module-v1-details-page-chart-title-supports":` タイトルは、"Opportunity Amount of {recordname}"のように、{recordname}の形式でレコード名を挿入することをサポートしています。現在のレコード名がCloudCCであれば、「CloudCCのOpportunity Amount」と表示されます。`,
"label.enable.generate.location.service":`ユーザ住所による緯度経度データの生成を有効化`,
"label.loginsystem":`ログインシステム`,
"label.email.template.edit.template":`テンプレートの編集`,
"vue_label_commonobjects_detail_share":`収入シェア`,
"label.icon.142":`家`,
"label.maintype":`主種別`,
"label.step2.total4":`ステップ　2/4`,
"label.select.intended.tablayout":`作成する Web タブのページレイアウトを選択`,
"label.custom.unit":`ユニット`,
"label.mr.title.phone":`電話`,
"label.compact.layout.frame.showtype":`表示方法`,
"label.associations":`関連オブジェクト`,
"label.potentialcustomers.name":`リード名`,
"label.edit.profile":`プロファイルの更新`,
"label.tabpage.allvisible":`すべてのユーザーが参照可能`,
"label.login.verification.confirmation.enabled":`有効の確認`,
"vue_label_norm_recordselected":`{selectNum} 件のデータを選択しました`,
"label.partner.workspace.member.selectedprofile":`選択可能なプロファイル`,
"label.divide":`/割る`,
"label.version.case.control":`ケース管理`,
"label.attendance.nocheckin":`サインインしていない`,
"vue_label_helpcenter_report2.1":`2.行グルーピングの削除<br> A. 左側の「group row」リストの中から削除したい「row grouping」フィールドを見つけた後、フィールドボックスの「×」をクリックします。<br> B. または、右側のプレビューレポートのヘッダーで削除したい「行のグループ化」フィールドを見つけ、「ドロップダウンボタン」をクリックし、「グループ行の削除」をクリックします。<br> 列のグループ化を削除する。<br> A. 左側の「Group Columns」リストの中から削除したい「Column Grouping」フィールドを見つけた後、フィールドボックスの「×」をクリックします。<br> 1.B. または、右側のプレビューレポートのテーブルヘッダで削除したい「行グルーピング」フィールドを見つけ、ドロップダウンボタンをクリックし、「グループ行の削除」をクリックします。<br> To remove a column grouping:<br> A. 左側の Group Columns リストの中から削除したい Column Grouping フィールドを見つけ、フィールドボックスの「x」をクリックします。<br> B. または、右のプレビュー レポートのテーブル ヘッダーで削除したい Column Grouping フィールドを見つけ、ドロップダウン ボタンをクリックし、Delete Group Column をクリックします。<br>?レコードをグループ化するために日付の粒度をカスタマイズする<br> Step 1: 日付フィールドでグループ化した後、日付の粒度をカスタマイズすることもできます。まず、レポートをグループ化したい日付フィールドを選択します。次に、プレビューレポートのヘッダーでこのフィールドの横にあるドロップダウンボタンをクリックし、「日付グループ化の基準」をクリックします。<br> ステップ2： グループ化の方法を選択します。日、月、年、会計四半期、会計年度、カスタム四半期、カスタム年度。<br>?Step 1: プレビューレポートのヘッダーで要約したい列を見つけた後、「ドロップダウンボタン」をクリックし、「Summary」をクリックします。<br>?`,
"label.payment.renew":`リニュー`,
"vue_label_file_wrong_type":`'アップロードするファイルの形式にエラーが発生しています。現在アップロードしているファイル形式は {type}!`,
"UG_opportunity_005":`複数の販売プロセス`,
"label.knowledge.language.korean":`韓国語`,
"label.customobjects.inputrecordtagandformat":`レコードの表示ラベルと表示形式を入力`,
"label.h5.chatter.commentednum":`受け取った返事`,
"label.quickbooks.button.unlink":`関連付けを解除`,
"label.step5.total5":`ステップ　5/5`,
"label.projectManagement.Selweek":`週を選択`,
"label.optional.searchfield":`選択可能な検索項目`,
"label.mobile.quickcreate.default.signin":`サインイン`,
"label.visualpage.unable.parse":`解析できないタグ`,
"mesage.error.role.delete":`現在ロールは子ロールが割り当てされたため、削除できません。`,
"label.role.user":`ロールでのユーザ`,
"button_partner_workspace_saveas":`別称で保存`,
"label.file.no.public.link.created":`公開リンクは作成されていません`,
"label.login.access.shenyu":`残り`,
"label.ccchat.group.section":`チーム`,
"label.weixin.object.notnull":`トピックは空であってはいけません`,
"label.accmarketsea.add.title":`新規プール`,
"label.sales.funnel.layout":`セールスファネルレイアウト`,
"pagecreator.page.button.edit":`編集`,
"label_tabpage_entercontent":`内容を入力してください`,
"component_event_label_begindate":`*開始時刻`,
"label.file.versionhref":`新版ページにスキップ`,
"label_chatter_send":`送信`,
"setup_layout_label_buttonlist":`ボタンの選択`,
"label.custom.Current.and.NexttCQ":`現在と次の3つのカスタマ四半期`,
"pagecreator_page_label_pagedesc":`ページの説明`,
"label.appupload.upload.uploader":`アップロード者`,
"label.console.step5.tab.primary":`マスタタブとする`,
"vue_label_globalsearch_expandlist":`リストを展開`,
"label.forecast.edit.userqu":`の目標`,
"label.step1.total5":`ステップ 1/5`,
"label.multilang.dupicatecheck.onegroupredata":`重複検索&マージの進度 ：{0}件`,
"vue_label_systemSettings_repeat":`重複の管理`,
"label.mobile.side.tab.error1":`表示する一般機能、アプリケーションタブを選択してください`,
"label.knowledgebase.reduction":`リストア`,
"label.standard.buttonandlink.override.usedefault":`カバーしていない（デフォルトを使用）`,
"dateandtime":`日付/時刻`,
"label.group.activate.info":`チームの有効化`,
"label.triggertotask":`ToDoトリガー`,
"label.emailobject.save.template":`テンプレートとして保存します`,
"label.audit.objInfo":`承認の詳細情報`,
"label.callcenter.successfully.logged.account":`ログインに成功しました`,
"label_new_customer_target":`新規取引の目標`,
"label.campaign.channel.step5":`ステップ5.販売チャンネルの登録ページのプレビューとソースコードの参照`,
"label.log.type":`アクション種別`,
"front-template-V1-noTemplate":`スイッチされたオブジェクトの下に、利用可能なテンプレートが見つかりませんでした。`,
"label_report_line_daixuan":`選択待ちのレポートリスト`,
"label.tianyancha.businessverify.relation.tip":`天眼查が返す項目をユーザ項目に記入します`,
"label.default.value":`この値をマスター選択リストのデフォルト値とします`,
"label.weixin.campaign.attendance":`キャンペーンのサインイン`,
"message.duplication.label.check":`校正`,
"label.salescloud.salescloud.yes2forbidden":`はい、チームセリングの使用を禁止します`,
"lable.currencyAdv.exchagecurrency.rate":`為替範囲`,
"lable.Hide.title":`タイトルを隠す`,
"label.finishedreport":`生成済みのレポート`,
"vue_label_account_business":`取引先所有者のクローズしした商談を置換える`,
"vue_label_pool_assigned":`割当て済み`,
"label.report.export.error":`エクスポートに異常があり、改めて試してください。`,
"label.layout.availablefield":`選択可能な項目`,
"label.licence.remainder":`ライセンスの残り数`,
"label.approval.idea.required":`承認意見は必須項目です。`,
"front-kefu-moudle-needhand-createcase":`ケースを作成する前に手動で確認する必要があります。`,
"label.dashboard.snapshot.Data.change":`データソースは変更しているため、改めて配置してください`,
"label.partner.workspace.login.footertext":`フッターテキスト`,
"vue_label_chatter_upload_link_type":`アップロードリンクタイプの書込みを選択した`,
"front-dialog-module-v1-error-detail":`エラーの詳細`,
"label.emailobject.sendgroupemail":`メールの一括送信`,
"lable.newtabpage.allviews":`すべてビュー`,
"label.khdd":`取引先の場所`,
"vue_label_dashboard_sortfield":`並び替え項目`,
"label.form.sample":`フォーム例`,
"component_setup_button_cancel":`キャンセル`,
"vue_label_salesfunnel_notice5":`1%～99%の確率で発生する商談の金額 * 可能性`,
"pagecreator_systemstyle_label_modifystyle":`スタイルエディター`,
"UG_homepage_001":`少ない時間でより多くの取引を勝ち取る`,
"label.campaign.pc":`PC端末`,
"label.visualpage.lightning":`ライトニングバージョン`,
"label.knowledge.category.hint.two":`カテゴリグループを作成した後、このページでライトニングのグループを選択します。`,
"label.south.africa.standard.time":`南アフリカ標準時`,
"label.service.gantt.reservation.number":`注文番号`,
"label.weixin.report.period":`時間代`,
"label.leadtomap.exp":`それぞれのリードカスタマ項目を、カスタマ取引、取引先責任者、または商談項目に対応付けます。リードを置き換えるとき、これらの対応付けを使用します。`,
"label.currency.d":`会社の通貨種別を組織がサポートできる別の通貨種別に更新します。この更新に従って、システムで定義でれるすべての為替レートも修正されます。`,
"label.forecast.detailforecast.oppyclb":`商談予測タイプ`,
"label.reportsSubscriptionPage.email.selected":`選択したメンバー`,
"vue_label_homepage_componentname":`コンポーネント名を入力してください。`,
"lable.account.Previous.FYt":`ユーザのデフォルト商談チーム`,
"label.appupload.success":`アップロード完了`,
"label.customer.newtab":`新規カスタマページタブ`,
"label.value.notnull":`値は空であってはいけません`,
"label.case.miniprogram.layout":`ミニプログラムに提出されたサービス要求書で使用されているページレイアウトは、編集のみ可能で、削除できません。`,
"label.partnerCloud.partnerAccount.twoDecimal":`正しい形式で入力してください。  小数点以下を2つ保持できます。`,
"UG.Lead.004":`Webフォーム`,
"label.umeng.activity.event.eventwillbeginnew":`行動のお知らせ:#event、開始時刻#begintime`,
"label.projectManagement.subtasks":`サブToDo`,
"vue_label_checkduplicate_repeat_conditions":`重複条件を判定します`,
"label.subject":`トピック`,
"label_search_otherusers_forecast":`他のユーザーの予報を検索する`,
"label_tabpage_namemandatory":`ビュー名は必須項目です。`,
"label.timezone.importtimezone":`データのインポート日付項目のタイムゾーンの設定`,
"label.mobile.buttom.team.init":`チームユーザーの初期化`,
"label.checkfield.choosefield":`表示する項目を選択してください`,
"label.b_c_least":`レコード「B」に少なくとも1つの関連レコード「C」があります。`,
"label.knowledge.setting.hint.five":`知識人を選ぶ`,
"label.h5.similar.opportunity.step2":`ステップ2.一致条件を指定`,
"label.page.style.imbedded.cloudcc":`フルスクリーンを利用して、最大限でCloudCC.comウィンドウに組みこんだ内容を参照することができます。`,
"label.sendemail.marketactivity.invitecode":`キャンペーン#campaignnameの招待コード`,
"label.block.pricing":`ブロック別での価格設定`,
"message.error.field.number.zero":`長さの入力形式は間違っており、0になってはいけません`,
"pagecreator.systemstyle.message.save.success":`スタイルの保存に成功しました`,
"pagecreator_systemstyle_label_styledesc":`スタイルの説明`,
"APPIntegration_Dropbox_setting_01":`有効化`,
"label_emailtocloudcc_redmessage2":`正しいメールアドレスのパスワードを入力してください。`,
"label.user.special.operations":`運営専用で、しばらくは使用できません。管理人に連絡してください`,
"pagecreator_page_label_layoutpreview":`レイアウトのプレビュー`,
"APPIntegration_Dropbox_setting_03":`Dropboxを有効化して、直接的に添付ファイルでdropboxからファイルを選択できます。`,
"label.sure_leave":`本当に出発するのか？`,
"label.applt.copylink":`コピーミニプログラムのリンク`,
"label_tabpage_allpotentialcustomers":`すべてのリード`,
"label.rulestrikedate":`ルールトリガ日付`,
"label_tabpage_justsz":`今ほど`,
"label.customize.memory.function.sorting.title":`ソート機能のカスタマイズ`,
"message.duplication.label.mergebutton":`マージ`,
"chatter.group.cancelRequest":`申請をキャンセル`,
"label.campaign.channel.step6.remark":`登録ページが確認されたら、生成ボタンをクリックして、システムは登録ページを生成します。`,
"label.appupload.upload.install.abort":`インストールの完了`,
"label.emailobject.proposetimes":`スケジュール予約`,
"label.probability.cannot.empty":`可能性は空であってはいけません。必ず数字を記入してください。`,
"vue_label_homepage_editkanban":`看板の編集`,
"lable.Related.template":`関連するテンプレート`,
"label.cloudccclass.list.cls.time":`スケジュール済みクラス`,
"component.task.label.enddate":`有効期限`,
"label.sendmail.step3":`ステップ3.承認と確認`,
"label.projectManagement.Gridview":`グリッドビュー`,
"label.emailobject.time":`送信時間`,
"label.applt.address":`ミニプログラムの顧客サービスポータル`,
"label.searchfield":`検索項目`,
"vue_label_calendar_please_enter_the_name":`名前を入力してください`,
"label.list.userinterface.default.page.setup":`システムのデフォルトインターフェース`,
"label.detail.2018":`詳細情報`,
"label.webtocloudcc.success":`情報提出に成功しました。ご参与頂き誠にありがとうございす。私達は誠意を尽くしてサービスします。`,
"component_telerecord_label_title":`通話の記録`,
"label.setting.sureDelete.rules":`このルールを削除してよろしいですか？`,
"vue_label_email_current_theme":`このテンプレートを挿入すると、現在のメールの件名がカバーされます。`,
"lable.Order.product":`製品の注文`,
"UG_product_02":`製品は販売?購買した製品またはサービスを参照します。`,
"label.appexchange.task":`ワークフローToDo`,
"label.selectprocesscondition":`ステップ条件の指定`,
"label.mobile.quickcreate.default.scan":`スキャン`,
"label.tabpage.prepagez":`全ページに表示`,
"label.query.error":`検索エラー`,
"label.tabularreport.2018.step1":`ステップ1.レポートの列を選択`,
"pagecreator.systemstyle.label.modifystyle":`スタイルエディター`,
"label.app.step3":`ステップ 3. カスタムアプリケーションロゴに使用する画像のソースを選択`,
"label_tabpage_rowsz":`行の削除`,
"label.validate.function.funcExplain.SUBSTITUTE":`new_textで文字列のold_textを置き換えます。テクスト文字列で指定されたテキストを置き換えるなら、SUBSTITUTEを使用します。`,
"vue_label_checkduplicate_select_data_to_merge":`データを選択してマージします`,
"vue_label_commonobjects_view_chart_displaymode":`表示方式`,
"label.industrialandcommercialverification.servicesetiings":`サ_ビスの_定`,
"label.refresh":`更新`,
"label.taskfield":`ToDo項目`,
"label.notification.approval4":`【提出者】は【オブジェクト】の承認を申請しています`,
"label.group.isusing":`有効化`,
"label.language.settings":`言語設定`,
"front-kefu-moudle-please-login":`最初にログインしてください。`,
"label.page.double.line.cloudcc":`２列で、CloudCCのサイドバーも含む`,
"folder.error.delete":`1.当該フォルダにはレポートが含まれており、削除することはできません。2.当該フォルダには隠しレポートが含まれており、削除できません。隠しレポートとは、論理的に削除されたオブジェクト（設定-作成-オブジェクトでの削除されたオブジェクト）に基づいて作成されたレポートです。`,
"eight":`八`,
"label.marketseamemset.user":`メンバー`,
"label.recordnum":`レコード番号`,
"page.404.button.back":`前のステップに戻る`,
"label.mobile.phone.month.plan":`来月の計画`,
"label.marketseamemset.account.title2":`すべてメンバーに影響する取引先数の上限を設定してください。上限はプールとは関係ありません`,
"vue_label_chatter_current_avatar":`既存のアバター`,
"label.mobile.side.tab.remark3":`Shiftボタンを押してクリックし、または直接的にクリックしてドラッグし、複数の隣接するアイテムを選択します。Ctrlボタンをクリックし、複数の隣接しないアイテムを選択します。`,
"component.sendmail.label.touser":`受信者`,
"label.homeitems.noobject":`トピックなし`,
"template.report.overall.sales":`全体の販売期間（リードソース別）`,
"label.partner.donotdel":`に対して、完成できません`,
"label.service.miniProgram.bindCopyDesc":`会社の公式アカウントやミニプログラムに組織をバインドした後、このアドレスをワンタップでコピーしたり、このアドレスにジャンプしたりすることで、自社のカスタマーサービスポータルとして利用することができます。`,
"UG_Contract_01":`契約の管理`,
"UG_quota_06":`レポートの作成`,
"vue_label_report_deletereport":`レポートの削除`,
"front-epwechat-module-v1-input-appname":`アプリケーション名を入力してください`,
"label_tabpage_deleteviewsuccess":`ビューの削除に成功しました`,
"component_chatter_label_mygroup":`私のチーム`,
"label.campagin.roi.leixing":`キャンペーン種別`,
"label.dashboard.myHomepageDashboard":`私のホームページダッシュボード`,
"UG_solution_04":`ソリューションのインポート`,
"label.knowledge.setting.hint.four":`知識の活性化`,
"label.campaign.channel.add.field":`ボタンをクリックして、項目を追加して下さい`,
"label.eastem.european.time":`東ヨーロッパ時間`,
"label.partner.workspace.member.partner":`Cloudcc Partnerプロファイル`,
"label.campaignmember.main.backtocampaign":`キャンペーンに戻る`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`絶対`,
"label.task.unsolve":`すべての未完了のToDo`,
"label.multilang.chatterservice.vote":`{0}票`,
"label.console":`コンソール`,
"label.emailsync.message1":`関連付けをキャンセルすると、メールボックスの内容をリードや連絡先に同期できなくなりますが、本当にキャンセルしますか。`,
"pagecreator.systemstyle.label.stylename":`スタイル名`,
"setup_mainpage_label_welcome16":`アクションガイド：このページの右側のメニュー → アプリケーションの設定 → 作成 → ワークフロー、承認プロセス、ToDo、電子メールの通知、項目の変更をクリックしてください。`,
"message.duplication.label.editfilterule":`重複検索条件ルールの編集`,
"Account.News.Setting.004":`ニュースの有効化`,
"label_tabpage_saveviewsuccess":`ビューの保存に成功しました`,
"label.forecast.forehistory.replacecommit":`承諾額の代替`,
"pagecreator_button_cancel":`キャンセル`,
"label.knowledge.article.nomatch":`関連ドラフトが存在するため、この記事をアーカイブすることができません。草稿を削除して再度お試しください。`,
"vue_label_combined_field":`合計に使える項目はありません。`,
"label.batchadd.save.prompt":`レコード`,
"label.tabpage.summaryway":`まとめ方式`,
"label.check.input.condition.two":`SQLはサポートされていません。`,
"mail.apiCode.notOnly":`唯一の名前はすでに存在しています`,
"UG.quota.01":`取引先の見積もり管理`,
"label.approved.receiveApprovalEmail.option3":`私が代理承認者の時のみ`,
"label.stdashbord.xsld.business.img5":`可能性が0%の段階にある総金額`,
"vue_label_chat_movedfromto":`{name} は{label}を{oldField}から{newField} に変更した`,
"label.customfields.new.step2.opration":`一般オプション`,
"label.dashboardSetup.isurl":`リンクを追加しますか`,
"label.forecast.settings.mrfwqj":`デフォルト範囲期間`,
"label.campaign.channel.field":`項目`,
"label.weixin.optionthree":`選択肢 3`,
"label.safetystatement":`セキュリティに関する声明`,
"label.useskipwizard":`ジャンプスタートウィザードを使用`,
"label.projectManagement.completion":`完成状況`,
"label.customfields.fielddependency.new.step2":`ステップ2.下記のページで、検索ルールを編集します。これらのルールは項目の値と連動項目の値をコントロールします。`,
"setup.mainpage.label.welcome8":`ドラッグ＆ドロップによるインターフェースのカスタマイズ`,
"label.emailobject.list.outbox":`送信トレイ`,
"label.app.default.login.tab":`デフォルトログインタブ`,
"label.follow_emails":`フォームを送信した訪問者に素早く簡単に連絡を取るには、フォローアップメールが最適です。`,
"vue_label_homepage_application_page":`アプリケーションのホームページ`,
"label.confirm.template":`テンプレートの確認`,
"lable.product.not":`完成できません`,
"label.multilang.feedtrack.dispalyinfo":`最大で{0}個までの項目を選択することができます`,
"label.weixin.plz.inputsrhkey":`検索キーワードをご入力ください`,
"label.projectManagement.service.appointment":`サービス予約`,
"label.list.userinterface.watermark.enable":`PCとAPPホームページ、ビュー、レコード詳細、レポート、ダッシュボードでウォーターマークを有効にする`,
"label.confirmDelete":`確かにこれらのデータを削除しますか。`,
"label.sso.description":`ユーザはユーザ名と承認コードに基づきログインなしでCloudCCシステムに入ります。システムURLはhttp://localhost:8080/ssologin.action?userName`,
"errormessage_email_atleastonereceiver_z":`受取人の住所を少なくとも1つ選択または記入してください`,
"C":`通貨種類`,
"label.service.major.event.edit":`重大行動の編集`,
"label.icon.9":`サービス`,
"label.visualpage.notvalidate.check":`有効なカスタマページではありません。ヘルプドキュメントを参照して、ページのスペルをチェックしてください。`,
"label.audit.todo.from":`出所：`,
"label.directboss":`直属上司`,
"label.manageAll.selpage":`現在のページ`,
"label.console.step6.all":`全画面にして、固定をキャンセルします。リストはナビタブを選択した場合のみ、参照可能です。`,
"vue_label_pool_expiredate":`有効期限`,
"lable.no.matching.record":`マッチしていないレコードがありません`,
"label.standard.redirecterror":`標準ボタンのカスタマページへのスキップに失敗しました`,
"label.Platform.Setting":`プラットフォームの設定`,
"lable.outlook.edit.havenewc":`最新行動の取引先責任者があります`,
"label.partnerCloud.partnerAccount.choosePayment":`決済方法を選択してください。`,
"label.weixin.optionsix":`選択肢 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Pipeline`,
"page_404_button_toknowmore":`さらに習う`,
"label.customfields.number.tip":`数値を入力できます。先頭の 0 は削除されます。`,
"label.import.index.processimport":`インポート`,
"label.quote.phone":`電話`,
"label.insert.approval":`挿入承認`,
"label.tabpage.printview":`ビューをプリンター
`,
"lable.product.price":`価格`,
"front-kefu-moudle-call-detail":`詳細はこちら`,
"label.umeng.approval.apply":`申請`,
"label.background.the.form":`フォームの背景`,
"chatter.f":`フォローされている`,
"label.quickbooks.searchresault.company":`取引先`,
"vue_label_systemSettings_platformutils":`プラットフォームツール`,
"front-quotation-v1-nofilles-tocreate":`見積もりを作成する」をクリックし、作成後に送信してください。`,
"label.category.6":`医療`,
"label.attendance.choose.positon":`ランドマークの選択`,
"label.batchadd.newbatchpage.save.pho":`電話番号の形式は不正確です`,
"UG.Account.01":`取引先は誰ですか。`,
"label.marketseamemset.addspecialuser":`スペシャルメンバーの追加`,
"label.query.detail.forbidpartneruser":`パートナーユーザの使用を禁止`,
"label.stdashbord.xsld.business.ydzhl":`契約の獲得率`,
"vue_label_SMS_mymessagebox":`私のショートメッセージボックス`,
"label.knowledgebase.data.publishing.failed":`公開{a}データに失敗しました。公開するには、ステータスが「Draft」の記事を選択してください。`,
"label.wholestate":`全体状況`,
"label.selectedline":`選択された列`,
"label.validate.function.funcExplain.LEFT":`テキストの文字列の左側から数える指定数の文字に戻ります`,
"label.emailmerge.edittemplate.detail":`差し込み印刷テンプレート情報`,
"vue_label_checkduplicate_checkduplicate":`重複チェック`,
"label.knowledgebase.assign.articles":`アッシング記事`,
"label.tabpage.recordsz":`レコード`,
"label.field.img.validate.error":`変数名のスペルエラーあるいは無効な参照で、スペルをチェックしてください。`,
"workorderlineitem.worktype.isnot.father.worktype":`この作業注文書の項目の親レコードに関連するワークタイプを選択する必要があります。`,
"label.ccchat.group.name.noexist":`入力したチーム名は存在しません。再入力してください。`,
"label.weixin.sign.type":`サインイン（アウト）種別は間違っています`,
"label.nowvaluereplace":`既存に置換`,
"report_label_report":`レポート`,
"label.knowledge.setting.plus":`ライブラリのプラス設定`,
"label.event.moveup.2day":`2日`,
"label.translation.start":`トランスレーションワークベンチで操作を開始する`,
"lable.PowerProcess.created.time":`{detailInterestType}の作成日に基づく`,
"label.ems.step2":`ステップ2`,
"label.tabpage.groupingemptyz":`グループ化アイテムは空にしてはいけません。`,
"pagecreator.layout.button.new":`新規レイアウト`,
"label.tabpage.listshow":`リスト表示`,
"label.partnerCloud.productSet.optionName":`オプション名`,
"label.service.without.cycle":`サイクルなし`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0}は{1}のすべての人に票を発行しました。`,
"label_target_model_dimension":`ターゲットモデルの次元`,
"component.task.label.subject":`テーマ`,
"label.custom.field.login.query.information":`システムブラウザーの詳細情報に入ってください。`,
"label.validate.function.funcExplain.NOT":`FALSEをTRUEに変え、あるいはTRUEをFALSEに変えます`,
"pagecreator_layout_button_horizontal":`横割り`,
"lable.Returned.to.successful":`リターンに成功しました`,
"label.campaign.channel.ticket.title":`入場券`,
"label.ruleName.supportMaximum.50Characters":`ルールの名前には最大50文字まで使用できます。`,
"label.email.track.attachment.size.control1":`現在メールファイルのサイズは累計で20Mを超えており、引き続きアップロードできません。`,
"template.report.folder.opportunities":`機会分析`,
"label.knowledge.setting.data.eight":`あなたは{flzmc}カテゴリーグループとそのカテゴリーを削除します。このカテゴリは、レコードへの割り当てができなくなります。カテゴリ グループの削除を 15 日間キャンセルできます。15 日後には永久に削除され、復元できなくなります。本当にこのカテゴリーグループとそのカテゴリーを削除してもよろしいですか？`,
"mail.id.notNull":`テンプレートを削除する際にIDを空にできない`,
"vue_label_normal_product_sf":`製品`,
"vue_label_report_superiortothisrelationship":`上位のオブジェクトとこのオブジェクトの関係`,
"label.leadscore.operation":`アクション列`,
"label.customfields.formula.percentexample":`割引`,
"component.setup.iframe.label.inputurlmemo":`インポートするページURLを入力してください。`,
"label.icon.177":`ロゴ`,
"label.tabpage.myz":`私の`,
"label.leadmarketsea.add.title":`新規プールの作成`,
"label.partnerCloud.partnerAccount.thePage":`ページ{skippageNum}。`,
"label.visualpage.some.size":`コードキャパシティ：最大300KB文字、約300000文字`,
"label.setwxpay.null":`WeChat決済を設定するための必須情報は空です。`,
"label.icon.74":`工作機械`,
"font-evaluate-module-v1-evbad":`評価の種類はNegative`,
"System.TimeField.Format.Warning":`無効な時間`,
"label.captcha":`確認コード`,
"label.payment.assessment":`他のエディションをチェック`,
"message.error.not.taskevent":`ToDoではない行動オブジェクト`,
"font-evaluate-module-v1-evaluation":`評価`,
"vue_label_commonobject_view_updatedago":`{timeInterval}で更新した`,
"label.sendemail.birthday.newevent":`{!ownerName}様：\r\n  3日後は{!objectLable}{!recordName}様の誕生日です。ご注目ください。\r\n                        {!orgName}`,
"label.laststep":`前へ`,
"message.duplication.label.matchoption":`一致するオプションの指定`,
"label.setupmultplerecordtype":`複数のレコードタイプ`,
"vue_label_account_unprocessed_oppprtunities":`未処理の商談`,
"KeyInformationLayout.DefaultLayout.Name":`システムプリセット`,
"label.partner.all":`すべてのパートナークラウド`,
"label.datamanage.export.error":`エクスポートに失敗しました`,
"label.standard.buttonandlink":`標準ボタンとリンク`,
"label.reportsSubscriptionPage.email":`メールレポート`,
"message.nogrammarfaultinformula":`数式に構文エラーがありません`,
"front-kefu-moudle-nofind-instance":`インスタンスが見つからない`,
"label.is.delete.data":`削除するデータに承認中のレコードがありますが、確かにデータを削除しますか。`,
"label.partner.error":`エラー：ドメイン形式は不正確です`,
"label.notification.time2":`{0}分前`,
"label.ccchat.person.invite.needfirstname":`名を入力してください`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`表示可能なレコードはありません`,
"label.readwrite":`参照/更新`,
"label.partnerCloud.orderingPlatform.orderPayment":`注文決済`,
"label.accesslimittype":`アクセス権レベル`,
"label.preciew_tab":`リンクを新しいタブでプレビュー`,
"label.attachment":`添付ファイル`,
"label_tabpage_helpNavigationz":`ヘルプとガイド`,
"label.dataimport.select":`当該情報を選び、データをエクスポートすときに執行します。`,
"chatter.en.info":`自己紹介文を入力してください。`,
"label.ccservice.validate.date":`オブジェクトAPIは{0}の下の{1}項目で対応値が{3}です。その表示形式がエラーで、正しい日付或は時間表示形式を入力してください。`,
"label.social.posts.send":`投稿に失敗しました`,
"label.emailobject.time.to":`受信者：`,
"label.defineReportStep1":`ステップ1`,
"savefail":`保存に失敗しました`,
"label.mr.descreption.title":`重複データのマージ`,
"label.share.info.by":`ため`,
"label.list":`リスク`,
"label.event.select":`選択済み`,
"message.accountmap.cannotfind":`取引先住所が見つからないため、取引先住所を更新してください。`,
"label.choosefield":`ページ項目の承認`,
"label.forecast.settings.title":`予測設定`,
"label.setup.log.datetime":`検索時間範囲ないの行為ログをダウンロード（ファイルExcel.xls）`,
"button_partner_new":`パートナークラウドの新規`,
"label.umeng.approval.dlsp.reject":`#approvalnameは代理して、#actornameが申請した#objAPIName#recordnameの承認を拒否しました。`,
"label.tabpage.totalTeamz":`グループの共有`,
"label.lead.score.prompt3":`スコアリングが長い時間をかかるかもしれません。完成したら、確認のメールを受け取ることができます。`,
"label.schedulejob.setup.schedule.name":`ToDo名`,
"vue_label_report_advanced":`アドバンストフィルターが有効な場合、下のアドバンストフィルターボックスに手動でフィルター条件を書き込むと、図のような書式になります。`,
"label.emailsync.form.connecttime":`時間の関連付け`,
"front-gantt-module-v1-project-status":`プロジェクトの状況`,
"label.field.for.example":`例えば`,
"label.marketsea.manager.notnull":`管理者は空にしてはいけません`,
"label.click.here":`ここをクリックして戻る`,
"UG.solution.04":`ソリューションのインポート`,
"label.validate.function.funcExplain.IF":`条件がTRUEであるかどうかチェックし、TRUEであれば1つの値を返し、FALSEであればその他の値を返します。`,
"label.profile.settab":`タブので設定`,
"front-email-payment-weichat-tips":`QRコードを読み取ってお支払い`,
"label.task.next.week":`これから一週間の行動`,
"label.operatedata.selectobjectfields.tip":`少なくとも1つのインポートする項目を選択してください。`,
"label.recalculate.alert":`再適用の共有リスクを選択してください`,
"label.marketsea.noopportunitydays":`商談を作成していない日数（獲得後のフォローしていない日数より多いことが必要です）`,
"label.chat.likeperson":`個人`,
"label.selectedFields":`選択済みの項目`,
"label.App":`アプリケーション`,
"label.file.type":`ファイルタイプ`,
"permissionService.error1":`アプリケーションライセンスの数が不足しています。`,
"front-detail-module-v1-chart-display":`チャート表示`,
"label.audit.status":`承認状況`,
"UG.activity.05":`通話履歴`,
"label.connectOtherObject":`(クリックして他のオブジェクトと関連付ける)`,
"lable.currencyManage.unEnabledadvcurrency":`高度な通貨種別管理の使用を禁止`,
"label.ccpeak.getthree.function":`3つの方式があります。また`,
"label.weixin.new.weitoupiao":`新規Micro Voteを作成します。Wechatのeventで投票情報を獲得して、投票に参加できます。`,
"label.tag.manage.prompt":`表示ラベルは既に存在しています！`,
"label.goon":`続く`,
"label.addworkflowoperate":`ワークフローアクションの追加`,
"label.weixin.click.search":`クリックして、レコードを検索します`,
"vue_label_report_deletecolumn":`列の削除`,
"label.ordercondition":`並び替え条件`,
"message.error.group.notallow":`グループはアーカイブを許可していない`,
"label.unread":`未読メール`,
"vue_label_report_notice_namerequired":`列の名前は必須項目です`,
"label.tabpage.entercontent":`コンテンツを入力してください`,
"label.schedulejob.setup.schedule.startdate":`開始日`,
"component_assistant_button_newtask":`新規ToDo`,
"vue_label_report_notice_filter1":`高度なフィルターを有効にした場合、図のように、下記の高度なフィルターを手動で記入する必要があります。`,
"value":`値`,
"label.icon.70":`サービス`,
"label.knowledgebase.delete.draft.t":`ドラフトの削除`,
"label.setup.mini.bind":`ミニプログラムのバインド`,
"component_timeline_button_more":`更なるステップ`,
"label_emailtocloudcc_redmessage4":`ポート情報を入力してください`,
"label.field.input.number":`正しい数値を入力してください`,
"front-invoice-online-payment-setup-title":`オンライン決済の開始`,
"front-kefu-moudle-called-user":`コールパーソン`,
"label.currency.disable":`使用禁止された通貨種別`,
"label.user.alias":`別称`,
"UG_quota_04":`見積書のプリント`,
"label.chatter.delete":`削除`,
"label.addtocurrentcustomer":`既存の取引先に追加`,
"message.error.recordid.null":`recordidは空にしてはいけません`,
"label.merge.records":`マージのレコード`,
"report_label_norole":`当該権限がないため、管理者に連絡してください。`,
"label.pqrs":`。`,
"label.email.attach.button":`「追加」ボタンをクリック`,
"label.tabpage.selrecordtypez":`レコードタイプの選択`,
"label.ServiceCloud.purchase.date":`購入日`,
"label.customreporttype.delete.prompt":`以下のレポートを削除してから、削除のアクションを執行します。`,
"label.brief.total.page":`すべて{total}ページ`,
"label.reportsSubscription.unsubscribe":`配信停止`,
"label.ccpeak.take.notice.exp.order":`ご注意：expとordering条件の項目API名の後ろに__cをつける必要があります`,
"report_type_label_quote":`見積`,
"label.file.norecord":`表示可能なプロジェクトがありません。`,
"vue_label_checkduplicate_all_processed":`すべてのデータを処理した`,
"label.next":`次のステップ`,
"label.icon.10":`フォルダ`,
"label.lanxin.title.setting":`統合情報`,
"label.h5.chatter.business":`関連商談`,
"lable.are.you.sure.to.delete.this.view":`このビューを削除しますか。`,
"vue_group_no_operation_permission":`操作の許可がない！？`,
"label.knowledge.archive.article":`アーカイブ記事`,
"vue_label_lead_":`有効化されたスコアリングルールがないため、システム管理者に連絡してください`,
"label.fiscal.error.between":`会計年度開始日または会計年度終了日が過去の会計年度以内にあるので、確認してリセットしてください。`,
"label.stdashbord.xsld.business.qdzje":`獲得金額`,
"label.calendar.day.view":`日のビュー`,
"label.emailtocloudcc.tip":`プロンプト`,
"label.schedulejob.setup.schedule.st1":`一番目`,
"label_tabpage_addtoworkbench":`トップページのワークベンチに追加`,
"label.umeng.approval.waitapproval":`承認待ち`,
"label.justcheckingwebsite":`サイトの認証のみ`,
"homepage.components":`ホームページコンポーネント`,
"label.audit.remark":`承認説明`,
"label.searchs.labelname":`検索 {fieldlabelName}`,
"label.remarkofreport":`レポート説明`,
"label.weixin.isno":`可否`,
"label.currencyCode":`通貨種別コード`,
"label.service.resources":`リソース`,
"label.clone_form":`クローンフォーム`,
"label.weixin.view.information":`表示ビューの情報`,
"UG_activity_05":`通話の記録`,
"chatter.feed.menutype.user.recentuser":`最近に参照する人`,
"label.marketsea.notfollowdays2":`日フォローしていない`,
"label.tabpage.namemandatory":`ビュー名は必須項目です。`,
"message.demo.nosupport":`次のバージョンでこの機能が追加されます。`,
"label.mail.merge.template":`差し込み印刷テンプレートは進行中です`,
"label.sendemail.marketactivity.sign":`キャンペーンサインインのお知らせ`,
"setup_layout_group_relatedlist":`関連リスク`,
"label.pc.ui.2018.all.tabs":`すべて表示`,
"label.field.lost.right.bracket":`右括弧がない`,
"label.datamanage.contact.novalue":`ご注意：今回のインポートアクションは[取引先責任者名]項目に割り当てしないため、取引先責任者レコードはインポートされることができません。`,
"label.version.unlimited.edition":`無限版`,
"vue_label_dashboard_selectsortfield":`並び替え項目を選択してください。`,
"label.partnerCloud.productSet.instructions":`商品群に階層を設定することができます。商品を追加する際に表示する階層を、機能別に絞り込みます。最大10階層まで設定可能です。`,
"front-kefu-moudle-v1-canuse-obj":`見えること`,
"thursday":`木曜日`,
"label.nextapprover":`次回の承認者`,
"setup_mainpage_label_manageuser":`ユーザ管理`,
"label.saveandcontinue":`保存&次へ`,
"label.top.userCenter":`個人センター（個）`,
"component.chatter.file.button.save":`発表`,
"label_emailsync_setting":`個人のメールボックスの設定`,
"label.usableshareuser":`使用可能な共有者`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`入力した順番ではなく、アルファベットの順番により値を並び替えます。すべての値はアルファベットの順番により表示されます。`,
"label.list.button":`プロファイルの割り当て`,
"chatter.up.m":`アップロードするファイルは大きすぎて、20Mを超えないでください。`,
"label.knowledgebase.filters":`{a}のフィルター`,
"label.sso.saml.sp.idtype.username":`ステートメントにはユーザのcloudccユーザ名が含まれています。`,
"vue_label_file_size_limit":`ファイルサイズは{size}Mbを超えてはいけません。`,
"label.appupload.install.error.choice4":`コンフリクトコンポーネントをスキップし、インストールしません。`,
"label.currencyDecimalDigits":`小数点以下桁数`,
"label.weixin.customer.details":`取引先の詳細情報`,
"component.timeline.label.7daysahead":`前の7日間`,
"label.sendsms.batch.step1":`ステップ1.含むメッセージ受信者の指定`,
"label.brief.opportunity1":`商談`,
"label.datamanage.click.importbutton":`[すぐインポート]をクリックすると、データはCloudCCシステムにインポートされます。`,
"label_filter_benchmark_objects":`参照オブジェクトを絞り込む`,
"label.area.record.notexist":`レコードは存在しません`,
"label.event.overdue.unfinished":`期限切れの行動`,
"label.file.publicview.errortype":`このファイルの種別はプレビューをサポートしません`,
"label.setup.mobile.bottombutton.profile.setting":`プロファイルのボトムメニューのカスタマイズ`,
"label.campaignmember.main.addleaddesc":`既存取引先をこのキャンペーンに一括追加`,
"vue_label_approve_actual_operator":`実際のオペレーター`,
"label.version.essential":`基本版`,
"lable.SalesCommitmentKanBan.commitments":`Pipeline`,
"label.chatter.pastEvents":`過去の活動`,
"vue_label_calendar_choose_calendar_type":`カレンダーの種類を選択`,
"label.service.dispatchingUnits.batch.send":`一括発送`,
"chatter.poll.option8":`選択肢 8`,
"label_tabpage_summaryway":`集計方法`,
"front-kefu-moudle-trindex-copy-num":`ティアンランシステムのホームページに掲載されている企業番号をコピーしてください。`,
"lable.quote.syncing.syncfinish":`同期の完成`,
"label.home.task.finish":`完了済みのToDo`,
"label.toleadfield":`リード項目の対応付け`,
"label.everyone":`みんな`,
"label.multilang.databatchadd.success":`{0}件のデータが追加に成功しました`,
"label.quote.createdate":`作成日付`,
"email.template.nopermission":`管理者のみがこのフォルダ内のテンプレートを編集可能`,
"label.report.action.addtodashboard2":`ダッシュボードの追加`,
"label.campaign.name":`キャンペーン名`,
"label.check.input.condition":`構文にエラーが発生し、入力の検索条件をチェックしてください。`,
"front-epwechat-module-v1-upload-file":`クレジット文書のアップロード`,
"label.batchadd.newbatchpage.button.add":`一行の追加`,
"label.partnerCloud.footer":`フッター`,
"lable.Enter.template.name":`タンプレット名を入力してください。`,
"label_tabpage_last":`前のステップ`,
"label.setup.mobile.bottombutton.setting":`モバイルアプリのファーストレベルのページ設定`,
"label_emailtocloudcc_filed_emailto":`Email to`,
"label.data.downpage.e_title.num3":`3、ご要望に基づいて、エクスポートのテンプレートを作成し、データをエクスポートする際に、当テンプレートを選択して、エクスポートを簡略化することができます。`,
"startwith":`スタート文字`,
"vue_label_normal_cancel":`キャンセル`,
"label.reportTypcrtD":`関連オブジェクト（D） クリックして関連オブジェクトを選択してください`,
"label.globalselect.disabledvalue":`無効な値`,
"vue_label_commonobjects_view_notice_deletecertification":`選択した {selectNum } 件のレコードを削除しますか？`,
"front-epwechat-module-v1-bound-role":`バウンドの役割`,
"label.partnerCloud.financeSetting.gaofilter":`アドバイス フィルター条件（例：1 And 2 Or 3`,
"label.quote.sprname":`名前（請求先）`,
"lable.asset.successfully":`製品を無事に資産に移すことができました。`,
"label.projectManagement.service.appointment.work.noedit":`サービス予約の労働時間を編集することができません`,
"lable.tianyancha.h5.inputandsearch":`キーワードを入力し、関連会社を検索します`,
"label.customcomponent.check.tag.firstrow":`第一行目は必ず`,
"label.knowledgebase.published.translations":`また、公開された翻訳はアーカイブされ、Draftステータスの翻訳は削除されます。`,
"vue_label_wang_yi":`トム`,
"label.step3.total3":`ステップ　3/3`,
"label.stdashbord.xsld.business.img6":`可能性が100%の段階にある件数（可能性が100%段階の件数＋可能性が0%の段階にある件数）`,
"component_button_cancel":`キャンセル`,
"label.delete.false.not.exists":`削除に失敗し、データは存在しません`,
"label.appupload.install.error.choice1":`インストールをしないでください`,
"label.Days.After.Horizontal.Date":`レベル日付の後の日数`,
"setup_layout_button_additem":`選択した項目の追加`,
"UG.contact.05":`取引先責任者の作成`,
"label.form.title":`フォームタイトル`,
"label.horizontalbar-group":`レコードレベル-グループ化`,
"component_sendmail_label_title":`メールの送信`,
"label.passwordPolicy.setup.neverexpires":`いつも有効です`,
"label.sso.saml.idp.config.desc1":`CLoudC.comをIDプロバイダーとして有効化にして、他のサイトでシングルログインを利用し、シングルログインアプリケーションをサポートするサービスプロバイダーを設定します。再ログインしなくても、異なるサービスプロバイダに切り替えることができます。`,
"label.chat.topic.desc.null":`当該トピックスの情報を獲得したい場合、右上にあるプルダウンメニューで詳細情報の編集を選択します。`,
"label.movablecustomerfield":`活動カスタマ項目`,
"label.trigger.folder":`ファイリングされないトリガーフォルダ`,
"label.selectuploadfile":`ファイルのアップロードを選択してください`,
"front-email-payment-card-tips":`カード番号を入力してください。`,
"label.tabpage.addcondition":`条件の追加`,
"label.number.MinAndMaxCheck":`0}の最小値は{1}、最大値は{2}となっています。数量を変更して、変更を保存してください。`,
"vue_label_dashboard_dashboard":`ダッシュボードの名前変更に成功しました`,
"label.objectDeleteList":`オブジェクト削除リスト`,
"lable.service.gantt.and":`アンド`,
"label.emailtocloudcc.step2":`ステップ2`,
"label.chatter.postup":`張り付け`,
"label.personalsetting":`個人設定`,
"message.please.choose.permission":`アクセス権限を選択してください`,
"label.mobile.move":`モバイル端末`,
"label.Choose":`選択肢`,
"label_chatter_vote":`投票`,
"label.weixin.user.select.one":`1つのユーザを選択します`,
"pagecreator.page.label.modifypage":`ページ編集`,
"label.select.partOrField":`制御したいパーツやフィールドを選択`,
"vue_label_helpcenter_chat":`1.インスタントメッセージング<br> チームは企業のWeChatなどの代わり、CRMシステムで作業しながら会社の同僚にテキストメッセージやファイルなどを送ることができます。組織の各部門が部門ごとのディスカッショングループを設立する必要がある場合、部門リーダーはチームでグループチャットを開始し、部門メンバーをグループチャットに追加することができます。<br> 2.取引先や商談のレコードにグループチャットを作成する<br> 取引先や商談のレコードの詳細ページを開き、右上の「チーム」ボタンをクリックすると、このレコードに関するグループチャットがチームで作成されます。グループチャットがレコードの所有者によって作成されていない場合は、レコードの所有者も自動的にグループチャットに加入されます。他の人は、レコードの詳細ページの右上にある「チーム」ボタンをクリックしたか、グループ所有者によって追加された後、グループチャットに加入することができます。<br> 3.グループチャットでレコードを追跡する<br> 4.2の方法に従って取引先や商談のレコードのためのグループチャットを作成し、カードを送ることによってグループチャットでレコードの動態を追跡することができます。ユーザーがカード上のレコードを参照する権限を持っている場合、ユーザーがカードをクリックすると、対応するオブジェクトの詳細情報ページに直接的にジャンプすることができます。<br>グループチャットでレコード項目の変更を追跡する<br>レコードに「項目追跡」の関連リストが設定され、追跡が必要な項目が設定されている場合、追跡された項目が変更されると、グループチャット内のグループ戦略アシスタントが項目変更情報のカードをグループに送信します。<br>グループチャットですべての変更を追跡する<br> レコードの所有者が変更されると、グループチャットのグループ戦略アシスタントは、所有者の変更情報を含むカードをグループに送信します。<br>グループチャットで活動を追跡する<br> レコードのグループチャットが作成された後、この記録に関する新しいタスクやイベントが作成されると、グループチャットのグループ戦略アシスタントは、ToDoや行動の基本情報を含むカードをグループに送信します。<br>グループチャットで関連リストの新規レコードを追跡して作成する<br>グループチャットが作成された後、関連リストのレコードが追加されると、グループチャットのチームアシスタントは、追加された新規レコードの基本情報が記載されたカードをグループに送信します。例えば：取引先レコードの取引先責任者リストに新しい取引先責任者が追加されると、顧客グループチャットで「新規取引先責任者」カードが受信され、新しいレコードの基本情報がカード上で確認できます。`,
"label.tianyancha.business":`企業情報`,
"chatter.group.groupMembersToFind":`チームメンバーの検索`,
"label.pc.ui.2018.pin.top":`ピン`,
"label.forecast.forehistory.submitor":`提出者`,
"vue_label_email_send_emails_separately":`それぞれメールの送信に成功しました`,
"vue_label_homepage_select_display_field":`表示項目の選択`,
"label.partnerCloud.partnerAccount.accountBalance":`バランス`,
"label.sendemail.template":`メールテンプレートの選択`,
"label.service.violated":`違反した`,
"label.manageAll.title":`承認センター`,
"label.forecast.settings.qy":`予測の共有を有効化`,
"label.detailofshare":`共有の詳細情報`,
"label.multilang.passwordpolicy.chechlength":`エラー：パスワードの長さは{0}個の文字以上でなければなりません。`,
"label.visualpage.filesave.error":`ファイル保存に失敗し、改めて試してください`,
"vue_label_campaign_please_select_member_status":`メンバーステータスを選択してください`,
"homepage.components.sort":`コンポーネントの並び替え`,
"label.brief.thismonth":`今月`,
"label_emailsync_connectaccount_description":`個人メールボックスをここに追加します。取引先とのコミュニケーションの進捗を追跡しやすくするように、自動的にメールの送受信アドレスに基づき、システムのリード、取引先責任者をマッチングして、メールの内容をこのレコードに同期します。`,
"label.sms.csid":`サイン番号`,
"label.ccdocument.remark":`ドキュメントの説明`,
"label.forecast.customforecast.disdw":`ディスプレイユニット`,
"label_tabpage_field":`項目`,
"label.logintime.all":`一日中`,
"UG_Account_06":`取引先の作成`,
"label.login":`ログイン`,
"label.dupicate.data.error":`マージデータの検索にエラーが発生し、チェックしてください。`,
"label.monitorsys.recent.logs":`最新の200ログのデフォルト表示`,
"message.chooseatleastonefield":`少なくとも1つ項目を選択してください`,
"lable.PowerProcess.name1":`エンタイトルメントプロセスの名前`,
"label.processdetail":`定義された詳細情報の処理`,
"label.upload.file.size.limit":`アップロードするファイルは2MBを超えてはいけません。`,
"label.forecast.userenablepage.desc":`有効になっている予測ユーザは「有効になっているユーザ」のリストにあります。使用可能なユーザを有効化するなら、これらのユーザを「有効化になっているユーザ]のリスクに追加し、ユーザの使用を禁止するなら、これらを削除してください。`,
"label.visualpage.type.detailembed":`ページタイプはdetailEmbedカスタムページの使用規定です`,
"label.textmessage.vonage.configurations":`コンフィグレーション`,
"label.report.select.chart.and.item":`図表種別とレポートの最優先表示を選択`,
"label.data.downpage.i.title.num1":`1、システムは共通のCSV形式しか対応しません。`,
"label.mobileapp.scansetting":`モバイル端末のスキャンモジュールの設定`,
"chatter.emailFollow":`フォロー`,
"label.weixin.businformation":`車両情報`,
"label.import.index.recentrecord":`最近のインポート記録`,
"label.case.update":`変更`,
"label.isEnableVisualpage.new.desc":`使用可能なカスタムページを選択し、有効化されたカスタムページに追加して保存します。その後、このプロファイルは有効化されたカスタムページにアクセスすることができます。`,
"label.emailobject.wizard.title":`個人メールの関連付け`,
"vue_label_ccchat_notice_deletepostsuccess":`書込みの削除に成功しました`,
"label.deleteQuoteLine":`見積り行の削除`,
"label.integrations.export.failed.Mailchimp":`エクスポートに失敗しました。ネットワーク接続を確認し、後でもう一度試してください。`,
"label.increase":` プラス`,
"label.setup.mobile.homepageshortcuts.setunable":`ホームページはこのモジュールを表示しません`,
"label.ccchat.person.invite.toolong":`255文字を超える本文を入力することができません`,
"label.knowledge.setting.help":`カスタマーセルフサービスヘルプ`,
"label.is_pigeonhole":`ファイリングしますか`,
"message.atleastonecommitter":`提出者は少なくとも一人います`,
"label.emailobject.wizard.desc4":`予約可能な時間を挿入し、複数人の招待を簡単にさせます。`,
"APPIntegration_Dropbox_setting_02":`使用禁止`,
"template.report.open.opportunities":`非公開の機会`,
"label.goonwork":`仕事を続ける`,
"label.isiands.time":`島時間`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`有効なルール（各オブジェクトは1つのQRコードまたはバーコードにのみ対応しています。`,
"label.summaryreport.2018.step2":`ステップ2.集計する情報の選択`,
"pagecreator.systemstyle.message.delete.success":`スタイルの削除に成功した`,
"label.standarduser":`標準ユーザ`,
"label.reportsSubscription.succeeded":`レポートの購読に成功しました。`,
"lable.Select.a.template":`既存のテンプレートを新規テンプレートのベースとして選択します。`,
"label.file.library.addfile2libsuccess":`{0} 件のファイルはアップロードしました！`,
"label.searchfield.instruction":`検索項目はグローバル検索あるいは1つのオブジェクトに対する検索を行うための項目です。デフォルトで選択しない場合、新規ウィンドウで提出してください。`,
"U":`URL`,
"label.Time.slot.overlap":`1つまたは複数のタイムスロットの時間帯が重複しています。重複していない時間帯に更新してください。`,
"vue_label_chat_opportunity_details":`機会の詳細`,
"label.knowledge.category.hint.seven":`選択されたカテゴリーグループ`,
"label.chatter.list":`リスト`,
"front-email-payment-Invoice-preview":`請求書プレビュー`,
"label_emailsync_message1":`関連付けを解除したら、このメールを連絡先責任者、リードにに同期することができなくなります。確かに解除しますか？`,
"label.summaryreport.step5":`ステップ5：レポート各列の順番を確認`,
"component_newrecords_label_name":`名称`,
"label.appointment.wizard.subtitle4-4-5":`2か月間`,
"component_salesperformance_label_title":`販売業績`,
"label.ccchat.person.invite.says":`と言います`,
"label.fax":`FAX`,
"label.knowledge.modify.article":`記事の修正`,
"label.componenteditor.Limit.number.components":`1つのページに最大15個までのコンポーネントを追加することができます。`,
"label.multilang.forecast.shrepage.desc":`このページでは、{0}へのアクセスを共有するユーザ、ロールとエリアが表示されます。`,
"label.chat.micropost.write.comment":`コメントの編集`,
"Lead.Scoring.Setting.Rule.Setup.Active":`アクティブ`,
"label.ccpeakfolder.time":`スケジュール済みクラスフォルダ`,
"label.partnerCloud.financeSetting.filter":`フィルター条件。`,
"label.knowledge.delete.topicassignment":`サブジェクトの割り当てを削除するにはエラーが発生しました`,
"label.file.orderbyname":`タイトル順`,
"vue_label_chat_activelater":`後ほど有効化します`,
"chatter.reply":`返事`,
"label.setup.profile.accordtext":`表示文字は`,
"label.encd.plaintext":`クリアテキストの表示`,
"label.h5.approval.cannotreassignmark":`代理承認のプロジェクトは再割り当てができません。承認プロジェクトを改めて選択してください。`,
"label.version.area.lookup":`{0}テキストエリアあるいは複数選択の項目の検索`,
"approval.request.email.body":`以下の事項は承認待ちです：\n      下記のリンクをクリックしてください：\n`,
"label.user.mass.emails.select":`メールの一括送信：テンプレートの選択`,
"lable.quote.syncing.title":`見積と商談の同期`,
"vue_label_dashboard_dashboardaccess":`ダッシュボードへのアクセス権限`,
"label_emailtocloudcc_filed_owner":`レコード所有者`,
"label.brief.page":`ページ`,
"label.isEnableVisualpage_new.desc":`使用可能なカスタム権限を有効になっているカスタム権限のリストに追加し保存してから、このプロファイルは有効化になっているカスタマページにアクセスできます。`,
"label.service.shift.view":`シフトビュー`,
"label.emailsync.addnewaccount":`新規アカウントの追加`,
"label.forecast.settings.prompt":`予測共有の使用を禁止してから、すべての手動共有のアクセスを削除します。`,
"front-electronic-signature-explain-second":`電子署名を行う際には、企業の営業許可証の写真と統一された社会的信用コードをご用意ください。`,
"label.emailtocloudcc.redmessage3":`サーバーアドレスを入力してください。`,
"message.confirmgiveupedit":`このページから離れると、すべての保存されていない更新がなくなりますが、続きますか。`,
"label.gantt.plan.success":`正常にスケジュールされている`,
"label.monitorsys.type.error":`検索種別を選択してください。`,
"label.industrialandcommercialverification.button.setup":`_定`,
"today":`今日`,
"label.attendance.setting.position":`ランドマークの設定`,
"chatter.mynews":`私のメッセージ`,
"label.recycle.dis.tip1":`データは15日間ごみ箱の中に保存され、レコードはゴミ場後に保存された15日後に、完全にに削除されます。`,
"label.icon.81":`冷凍`,
"label.customer.tab.page.prompt":`少なくとも1つのページは配置してください`,
"label.globalselect.use":`グローバル選択リスト値セットを使用`,
"template.report.customer.sales.order":`レベルの異なるアカウントの販売順序`,
"vue_label_dashboard_lastruntime":`最後の運行日`,
"label.edit.ccpeakfolder":`クラス：ファイルの編集`,
"vue_label_lead_be_converted":`置換えステータスになっていますので、置換えできません`,
"label.tabpage.filenamez":`ファイル名`,
"label.please.click.add.products.":`価格表に商品を追加するには、「商品の追加」をクリックしてください。`,
"label.followup_emails":`訪問者がフォームを送信した後、メールでフォローアップすることは、訪問者と素早くつながるための簡単な方法です。`,
"label.indochina.time":`インドシナ時間`,
"message.error.task.email":`メールToDoに異常が発生しました`,
"label.dynamic.copy":`連動レイアウトルールを同時的にコピーします`,
"label.log.d":`検索時間範囲ないの監査ログをダウンロード（ファイルExcel.csv） >>`,
"pagecreator_layout_label_layoutname":`レイアウトの名称`,
"template.chart.htsktj":`契約回収統計`,
"label.appointment.wizard.subtitle4-2-5":`一日`,
"label.view_form":`フォームを見る`,
"label.tablet":`タブレット`,
"label.campaignmember.main.addcontact":`マンバーの追加‐既存の取引先責任者`,
"message.get.userinfo.error":`ユーザ情報の獲得に失敗しました`,
"label.department.username":`ユーザー名`,
"label.ems.verifysuccess":`メールボックスアカウントの検証と追加に成功しました。`,
"label.batchedit.copyValue":`本列に応用`,
"label.trigger.triggerVersion":`バージョン`,
"label.mr.descreption.oneGroupReData5":`未処理のデータ`,
"label.appointmentconfirmpage.wizard.subtitle5":`説明`,
"label.weixin.inbetween":`複数選択`,
"label.salescloud.contactrole.relatelist.customnize":`当該リスクはカスタマイズできません`,
"label.data.exp.please.nameanddes":`テンプレート名とテンプレート説明を記入してください`,
"label_partner_workspace_login":`ログインページ`,
"label.notification.approval7":`【委任者名】はあなたの代わりに【提出者が請求した【オブジェクト】【オブジェクト名】の申請を拒否しました。`,
"message.send.posts.image.error":`写真のアップロードに失敗しました。`,
"message.fieldtrack.operateupdate":`更新済み`,
"label.sharerule.grantuselevelconstructureaccess":`階層のアクセス権限の付与`,
"label.translation.setup":`多言語設定`,
"PageLayout.Search.MultiSearch.003":`項目を少なくとも1つ選択してください`,
"label.ccchat.person.emaildomain":`会社メールのドメイン`,
"pagecreator.systemstyle.label.bordercolor":`ボーダーカラー`,
"label.submit":`提出`,
"UG.Lead.001":`如何にクルーを導入しますか。`,
"label.icon.172":`地図`,
"label_chatter_owner":`所有者`,
"vue_label_systemSettings_Currency":`通貨管理`,
"page.layout.binfo":`一般情報`,
"label.version.date":`{0}件の日付項目`,
"label.data.is.woking":`アクションしている`,
"label.customfields.searchrelation.dependobjectDefault.tip":`関連オブジェクトの一つのレコードを、この項目のデフォルト値として選択することができます。`,
"label.partnerCloud.orderingPlatform.configuration":`コンフュギュア製品`,
"lable.currencyManage.Enabledadvcurrency":`高度な通貨種別管理を有効化`,
"label.event.moveup.3hour":`3時間`,
"label.reportexport.object":`オブジェクトのエクスポート`,
"front-dialog-module-v1-requestid":`リクエストID`,
"label.pw.symol":`シンボルマーク`,
"label_group_field":`グループ化項目の指定`,
"label.recallapprove":`承認申請の呼び戻し`,
"vue_label_pool_deal_done":`成約済み`,
"label.shangqing.description":`これはビジネス情報の説明です`,
"label.view.allcansee":`すべてのユーザが参照可能`,
"chatter.poll.addOption":`オプションの追加`,
"label.icon.112":`食物`,
"label.ignorecase":`ABCをabcと重複値とします。（大文字と小文字は区別されません）`,
"label.email.track.edit":`電子メールを編集する`,
"label_tabpage_erraddressz":`メールアドレスは間違っており、正しいのを入力してください。`,
"label_tabpage_viewz":`このビューをプリント`,
"component.timeline.label.future":`次のステップ`,
"label.b_c_without":`Bレコードに関連Cレコードがあり、またはありません。`,
"label.version.autonumberfield":`自動採番項目`,
"label.appointmentdetail.wizard.title5":`招待リンク`,
"label.weixin.addoption":`選択肢の追加`,
"label.b.c":`BtoCの関係`,
"chatter.group.complete":`完成`,
"label.must.numeric.value":`コストは数字でなければなりません`,
"lable.edit.queue.memberdes":`キューにユーザを追加するには、[選択可能なユーザ] からユーザを選び、[選択済みのユーザ] へ追加してください。キューにあるすべてのオブジェクトの共有モデルが「公開/参照/更新/所有権の移行」に設定されている場合は、全員がこれらのオブジェクトのレコードにアクセスできるため、キューにユーザを割り当てる必要はありません。`,
"label.staticresource.chose.limit":`この形式のファイルを暫くサポートしません。機能が改善中で、しばらくお待ちください。`,
"vue_label_commonobjects_view_kanban_unset":`看板ビューの設定でグループ化の基準を選択してください。`,
"label.appexchange.download.merge.mes":`下記のコンフリクトコンポーネントをマージしてインストールします。`,
"label.sharerule.baseofowner":`レコード所有者に基づく`,
"label.email.template.manage.SMS":`SMSテンプレートの管理`,
"label.imgfield.example.tip":`承認状況は承認通過のとき、緑色の画像が表示され、そうでなければ赤色の画像が表示されます。`,
"template.report.potential.customer.industry":`リード産業`,
"component_hots_label_title":`ホットトレード`,
"label_file_use_document":`メモリ使用状況`,
"label.input.path":`参照パスを入力してください`,
"label.partnerCloud.financialSetup":`パートナーの財務設定`,
"label_tabpage_myz":`私の`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`削除後はこのメールでEmail to CloudCC機能が実現できなくなりますが、確かに削除しますか。`,
"label.customfields.fielddependency.sure":`コンロロール項目値は連動関係の値を含みません。続いて保存しますか。`,
"label.project.task.date":`ToDoの日付は、属するマイルストーンの日付範囲内でなければなりません。`,
"Report.CantDelete.Info":`0}レポートは{1}ダッシュボードに引用され、削除できません。`,
"label.assignment.setup.title":`割り当てルール`,
"image.pt.most.maxsize":`最大ファイルサイズは 2M です。`,
"label.appupload.introduce":`パッケージには、アプリケーション、オブジェクト、タブ、トリガー、カスタマページなどのコンポーネントが含まれています。これらのパッケージは、アップロードして AppExchange に投稿し、公開して共有できます。下の一覧に、組織で作成されたすべてのパッケージが表示されています。新規パッケージを作成するには、[新規] をクリックしてください。`,
"label.import.page2.confirm":`確認`,
"label.console.step2.introduce":`下記の項目カスタマコンソールを記入`,
"label.extendsfather":`親から`,
"front-homepageobject-module-v1-year":`今年は`,
"front-grasp-sales-opportunities":`CRMは、販売機会を正確に把握し、より多くのリードを獲得し、迅速な見積もりを提供し、より多くの取引を成立させるとともに、オムニチャネル・マーケティングを実現し、企業のROIを継続的に向上させます。`,
"label.tab.oldpage":`旧バージョンのページ`,
"label.service.miniProgram.intro":`概要`,
"label.data.import.setup.operate.insert":`既存レコードをクリーンアップしなく、新規レコードを挿入するのみです。`,
"label.ccpeak.direction.for.use":`CloudCC プラットフォームマニュアル[パージョン2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat 書き込みの返事`,
"label.campaignmember.main.importmember.contacts":`メンバーのインポート：既存の取引先`,
"setup.mainpage.label.welcome20":`メール、SMSテンプレート`,
"label.newbatcheditor.remark":`異なるデータレコードに異なるレコードタイプが存在することに対して、システムはデフオルトで1番目のデータレコードタイプの行式レイアウトを一括編集のページレイアウトとします`,
"label.step4.total7":`ステップ　4/7`,
"label.campagin.roi.tzhbl":`投資収益率`,
"label.emailmerge.mergepage.step3":`活動のレコード`,
"label.marketsea.isrecyclecreatebyself":`自分で作った取引を回収しますか`,
"message.mobilechooseatmost.five":`モバイル端末のメニューでは、最大5つのフィールドを選択することができます。`,
"label.icon.171":`ゲストハウス`,
"label.saveandnext":`保存して次のステップへ`,
"label.import.page1.selectcodingtype":`エンコードの種類を選ぶ`,
"label.searchlayout.displaybutton":`表示されたボタン`,
"label.approvalstep5":`ステップ4.承認ページレイアウトで表示する項目の編集プロパティを選択`,
"label.passwordPolicy.setup.enforcePswHis":`パスワード強制変更の履歴`,
"vue_label_commonobjects_detail_contact_hierarchy":`取引先責任者の階層構造`,
"front-kefu-moudle-v1-trythjzx-intelligent":`TRRT(tinet) インテリジェント・サービス・コールセンター`,
"label.select.statistical.indicators":`統計指標を選択してください`,
"label.callcenter.Tianrun.RONGTONG":`TRRT(tinet)`,
"label.file.library":`ライブラリ`,
"lable.completion.rate.color.setting":`完了率のカラー設定`,
"label.name.firstname":`名`,
"setup_layout_label_readonly":`参照のみ`,
"label.chatter.recordcall":`電話履歴`,
"label.service.appointmentList.service.empty":`サービス予約は空です。`,
"component_milestones_label_choicestate":`当該状況の確認`,
"label.approved.receiveApprovalEmail.option2":`私が承認者のときのみ`,
"label.marketseamemset.account.title":`リードプールのメンバー設定`,
"label.changemydisplay.list.custom":`タブのカスタマイズ`,
"label.emailtemplate.selecttype":`メールテンプレートの種別を選択してください。`,
"component_timeline_label_title":`時間軸`,
"chatter.group.addRemoveMembers":`メンバーの追加/削除`,
"label.console.step6.width":`幅`,
"pagecreator.systemstyle.message.delete.fail":`スタイル削除に失敗しました`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}製品，{totalCount}個，オリジナル価格：{currency}。オリジナル価格：{currency}，割引：{currency}。割引：{通貨}`,
"label.h5.share":`共有`,
"label.schedulejob.setup.list.tip":`スケジュール済みジョブを設定して、毎週あるいは毎月に自動的執行します。`,
"message.intheapproving":`当該レコードは承認中で、再提出できません。`,
"vue_label_commonobjects_detail_real_time":`加入後にチームリストに表示され、チームの動きがリアルタイムに届けます。`,
"label.autoRegister.changepwd.setpwd.too.weak":`短すぎ`,
"label.salescloud.forbiddenteamsales":`チームセリングの使用禁止`,
"component.chatter.link.label.title":`リンク`,
"label.layout.editsearchdistribute.page":`タブページに含むカスタマページを選択`,
"label.dashboard.show.value.percent":`表示値と表示%を少なくとも1つ選択してください`,
"label.everymonth":`毎月`,
"label.campaign.channel.download.size1":`大サイズ：1000×1000ピクセル`,
"permissionService.error2":`アプリケーションの許可ライセンスの追加に失敗しました`,
"button.partner.workspace.manage.memo":`パートナークラウドを管理し、その配置プロパティを設定します。`,
"label.forecast.forehistory.commit.remark":`メモの提出`,
"six":`六`,
"label.datamanage.donot.export.object":`エクスポートできないデータオブジェクト`,
"label.schedulejob.setup.schedule.execute":`実施`,
"lable.account.CurrentandPreviousCY":`現在と前回のカレンダー年度`,
"label.temp.SMS":`SMSテンプレート`,
"label_partner_all_state":`状況`,
"label.editdocument":`プロパティの編集`,
"front-epwechat-module-v1-ios-single":`iOSシングルサインオン`,
"lable.redo":`やり直し`,
"vue_label_SMS_alltemplates":`すべてのテンプレート`,
"label.allfolderreport":`すべてのレポートファイル`,
"label.layout.alltab":`すべて表示
`,
"lable.account.Yesterday":`昨日`,
"label.formula.to.evaluate":`数式を入力して、商品に一致するキーワードを検索します。`,
"component_setup_label_setupsaveok":`コンポーネント設定の保存に成功しました`,
"pagecreator_page_message_canntdelete":`このページは削除できません`,
"label.tab.message.failtotp":`タブのセットアップに失敗しました。`,
"label.h5.chatter.location":`挿入場所`,
"vue_label_commonobjects_view_chart_gotodashboard":`ダッシュボードへ移動します`,
"label.data.exp.conf":`確かにデータをエクスポートしますか。`,
"label.currency.e":`通貨種別の編集`,
"message.matrixReportSetupStage.column":`[列タイトルの指定]サブトータルの根拠を選択してください。2つから少なくとも1つを選びます。`,
"font-evaluate-module-v1-have-comment":`評価を残す`,
"chatter.feed.dao":`まで`,
"label.import.index.notice":`注：`,
"label.weixin.information":`詳細情報`,
"label.multilingual.tip5":`マルチランゲージの状態が正しくありません。更新して再度お試しください`,
"label.appointment.wizard.subtitle3-7":`日曜日`,
"label.emailobject.groupemail.fail.content":`{0}様:\r\nこんにちは！一括送信に失敗したメールアドレスは｛1｝r\n CloudCCです。`,
"vue_label_notice_uploadavatar_fail":`アバターのアップロードに失敗しました`,
"chatter.group.myGroup":`私のチーム`,
"label.ccpeak.object.fieldapi.name":`オブジェクト項目のAPI名`,
"lable.activeCurrency":`有効化になっている通貨種類`,
"label.file.save.to.send":`Save&Send`,
"label.emailmerge.list.editfolder":`フォルダの編集`,
"label.Path.Setting":`プロセスの設定`,
"label.validate.function.funcFormat.DATE":`DATE(year,month,day)`,
"message.objapiexists":`オブジェクトapiは存在済みです`,
"label.sendmail.batch.confirm":`メールの一括送信：確認`,
"message.approval.cannotsubmit.detail":`このレコードは、有効な承認プロセスの条件または初期提出を満たしていません。管理者にお問い合わせください。`,
"setup.layout.button.deleteitem":`選択したアイテムの削除`,
"label.end.loginipIP":`終了 IP アドレス`,
"component_event_label_subject":`トピック`,
"message.500":`サーバーのエラーメッセージ`,
"label.wei.polltype":`種別`,
"vue_label_norm_duplicate":`デュプリケート`,
"label.addcycletrigger":`周期性トリガーの追加`,
"DetailedInfo.Activity.EmailMessage.01":`0}が{1}にメールを送りました。`,
"No.Activity":`何の活動もありません`,
"label.chat.topic.add.topic":`トピックの追加をクリックします`,
"label.schedulejob.setup.schedule.morning":`午前`,
"chatter.save.al":`更新は保存済みです`,
"label.setsharerule.step3":`ステップ 3. 共有先のユーザを選択します`,
"label.tabpage.Sdfez":`日前`,
"label_submit_forecast":`予測の提出`,
"label.version.sum.formulafield":`数式項目`,
"lable.weixin.you.invitation":`ご招待したの`,
"label.stacked.horizontalbar":`積み重ねた図形－レコードレベル`,
"label.file.anyone.can.link":`このリンクを保有するすべての人はファイルのダウンロードと参照ができます`,
"label.campaignmember.main.importmember.lead.desc":`フォルダのデータをキャンペーンリードにインポートします`,
"UG_activity_01":`取引先とチームとのインタラクティブのために、どのようにレコードをフォローしますか。`,
"label.reason":`原因`,
"label.version.free.createmax":`2000件のレコードを作成することができますが、すでに上限に達しました。`,
"label.brief.thisweek":`今週`,
"label.deleteobjinapprove":`コメントを入力し、承認プロセスから当該プロジェクトを削除してください。`,
"calendar.tips.event":`イベントのない日`,
"label.customerinfo.mailinfo":`会社の送信メールボックスの情報`,
"lable.electronic.signature":`Esignature`,
"label_emailsync_addnewaccount":`新しいアカウントの追跡`,
"label.layout.exampleoftesgobj":`テストオブジェクトの例`,
"label.happen_submit":`訪問者がこのフォームを送信した後の処理について`,
"label.forecast.customforecast.button.submit":`提出`,
"label_right_click_notice":`注意事項CloudCCのメールボックスに送信されるメールは、システムユーザーのバインドメールアカウントであってはなりません。そうでない場合、リードやケースの生成に無効なメールが送信されることになります。`,
"font-trade-module-v1-invoice-no-price":`To Be Repaid`,
"lable.opppdt.selPdt.morecondtions":`より多い検索条件`,
"label_invalid_token":`無効なトークン`,
"label_chatter_postup":`投稿&コメント`,
"label.escalation.setup.newaction.step1":`ステップ1.当該グレードアップルールの時間条件の指定`,
"label.sendmail.step3.dealoption2":`各メールのアクティビティを保存する`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`本当にテンプレートを一括削除していいのでしょうか？`,
"vue_label_appstore_enter_website":`公式サイトに入る`,
"label.when":`発行時期`,
"label.linellae":`線`,
"label_chatter_detailinfo":`詳細情報`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`代金受取の目標額`,
"vue_label_homepage_dashboard_deleted":`ダッシュボードは削除済みです`,
"pagecreator.layout.button.vertical":`縦分割`,
"label.redistribution1":`5人まで選択することができます`,
"pagecreator_page_label_modifypage":`ページエディター`,
"label.Service.Cloud.Setting":`サービスクラウドの設定`,
"setup_layout_label_pagename":`ページレイアウト名`,
"label.ems.send":`送信`,
"vue_label_commonobjects_view_kanban_notice1":`看板ビューには最初の200レコードしか表示されない`,
"lable.outlook.detail.maping":`項目の対応付け`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`モバイル端末スライダーの設定`,
"label.trigger.operation.email.template.param":`転送パラメータ：言語、メールテンプレートID、レコードID`,
"front-objectTemplate-V1-Select-a-template":`既存のテンプレートを新規テンプレートのベースとして選択します。`,
"label.email.template.delete.template":`このテンプレートを削除してよろしいですか？`,
"label.reportsSubscription.cancel":`キャンセル`,
"lable.quote.syncingfrom.firstsync.description":`商談商品は見積書の明細に代わる`,
"label.weixin.no.pending.xsld.qin":`現在セールスファネルのデータはありません`,
"template.dashboard.sales.indicators":`販売指標`,
"label.field.new":`ユーザーのに評価とスコアアクションを提供します。`,
"label.generatepage.title.desc1":`選択した項目に基づき、モバイル版あるいはPC版の HTML コードを生成します。ユーザは需要に応じて、コードを修正することができます。`,
"template.report.source.potential.customers":`リードソース`,
"label.mr.title.queryData":`重複データの検索`,
"button_partner_workspace_enable":`パートナークラウドの有効化`,
"V":`自動採番`,
"label.icon.19":`フォルダ`,
"vue_label_report_summaryformula":`まとめ方式`,
"label.appointment.wizard.subtitle2":`利用可能な日付範囲`,
"label.stdashbord.xsld.business.bjdzhl":`本段階の転換率`,
"label.forecast.forehistory.deopportunity":`の商談`,
"chatter.email.referredToMeLeaveMessage":`コメントで私に関する内容を書き込んだ（私をメンション）`,
"label.dategrouprelyon":`日付グループ化の根拠`,
"label.sendmail.batch.finish":`メールの一括送信：完了`,
"label.weixin.allexpired":`すべての期限切れ`,
"label.dashboardSetup.showdw.d4":`万`,
"message.duplication.label.masterRecord":`主レコード`,
"vue_label_calendar_availability":`使用可能性`,
"vue_label_chat_approval_message":`承認メッセージ`,
"vue_label_zhang_er":`ジェニー`,
"label.select.options":`オプションを選択してください`,
"label.israel.daylight.time":`イスラエル標準時`,
"front-sales-search-QB":`合計で0データ、QuickBooksで新規アカウントを作成するかどうかは`,
"vue_label_account_change_customer":`取引先所有者の変更`,
"label.integrations.mailchimp2":`MailchimpとCloudCC CRMの関連情報をさらに表示`,
"lable.product.pricebooks.onisu":`有効になっていない価格表`,
"front-electronic-signature-backfill-field":`バックフィル・フィールド`,
"label.document.myself.folder":`私の個人フォルダ`,
"label.event.moveup.10hour":`10時間`,
"report.label.report":`レポート`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`検索失敗、ユーザは存在しません`,
"front-epwechat-module-v1-input-EncodingAESKey":`EncodingAESKeyを入力してください。`,
"label.event.multi.view":`数人ビュー`,
"label.h5.similar.opportunity.setup":`類似商談の設定`,
"label.setting.intergrationlist.button.install":`インストール`,
"label.event.monthview":`月のビュー`,
"label.version.weixin":`Whchat版`,
"label_emailtocloudcc_redmessage6":`IMAP/SMTP認証に失敗しました。メールアドレスとパスワードが正しいかどうか確認してください`,
"UG.homepage.003":`全面的にビュー`,
"vue_label_calendar_shared_calendar":`カレンダーの共有`,
"label.select.hope.merge.num1.record":`1つのレコードにマージするレコードを選択してください（毎回最大3つまで）`,
"label.createnewprocess":`新しい承認プロセルの作成`,
"font-trade-module-v1-invoice-status":`お支払い状況`,
"label.customerinfo.introduce":`組織プロファイル情報`,
"label.objectname":`オブジェクト名`,
"label.chosen.field":`選択可能な項目`,
"label_target_name":`ゴールモデル名。`,
"label.appointment.wizard.subtitle4-4-4":`一か月`,
"label.emailobject.groupemail.msg1":`メールアドレスがありません`,
"label_component_hotdeal_nopermission":`商談関連データを参照する場合に、システム管理者に連絡してください。`,
"label.appointmentdetail.wizard.title13":`説明`,
"front-web-module-v1-detail-comment-title":`このサービスについてコメントをお願いします`,
"label.visualpage.component.n1":`1.転用方法　&lt;component:Name /> Nameはコンポーネントの具体的な名称`,
"lable.outlook.mcto.erecord":`最も早いレコード`,
"label.weixin.del.log":`ログのクリア`,
"setup_mainpage_label_welcome23":`セキュリティーの設定`,
"label.selectreportline":`レポートの列を選択`,
"label.chatter.following":`フォローしている`,
"seven":`七`,
"message.error":`エラー：`,
"label.mobile.phone.reporter":`報告者`,
"label.valadate.telphone.false":`携帯電話番号の入力が間違ったため、チェックしてください`,
"label.linkedin.setting":`LinkedIn H5 MiniAppの統合`,
"label.mobile.side.tab.success":`モバイル端末のスライダー設定の保存に成功しました`,
"label.notification.approval3":`あなたの【オブジェクト】承認は【承認者】に【再承認者】に割り当てられました。`,
"label.channel.invites.employees":`このチャンネルで社員を招待します`,
"label.assignment.setup.detail.assigner":`に割り当てる`,
"label.campaignmember.main.updatecontactdesc":`すべての取引先責任者の状況を一回で更新`,
"label.permission.detail.app.fenpei":`アプリケーションの割り当て`,
"label.copydown":`下へコピー`,
"label_emailsync_status_action":`アクション`,
"lable.Please.switch":`この機能を利用するには、水平または垂直システムに切り替えてください。`,
"label_adjust_remark":`調整メモ`,
"label.weixin.newspaper.coverage.list":`リスクシート`,
"label.datamanage.contact.field":`取引先項目`,
"label.partner.workspace.login.headerfooter":`フッターとヘッダー`,
"lable.account.quarter.ovdate":`四半期決算の終了日`,
"pagecreator.systemstyle.label.textcolor":`文字色`,
"label.industrialandcommercialverification.fieldmappingsettings":`_目の__付けの_定`,
"component_chatter_button_message":`コメント`,
"label.partnerCloud.enterAddress":`アドレスを入力してください`,
"label.email.template.recently.used":`最近の使用例`,
"component.event.label.calendar":`カレンダーの表示`,
"label.setup.mobile.offlinecache.setting":`モバイル端末のオフラインキャッシュの設定`,
"label.custom.PreviousCQ":`前のカスタマ年度`,
"lable.total.of.payments":`全部0件の支払いです`,
"label.ccpeak.use.class.time.trigger":`トリガーが当該クラスを転用するなら、CCServiceでの方法を使用することができます。`,
"label_tabpage_addresswrongz":`メールアドレスは間違っており、正しいのを入力してください。`,
"vue_label_homepage_select_components":`コンポーネントの選択`,
"front-kefu-moudle-v1-secretID-reinput":`secretIDを入力してください。`,
"label.ccdocument.select.template.red":`テンプレートセットを選択してください`,
"vue_label_email_public_template":`パブリックテンプレート`,
"label.eowechat.openid":`ウィーコムID`,
"label.user.ip.notlogin.range":`IPアドレスはログイン範囲内にありません。`,
"chatter.email.reply.collection":`私がブックマークした投稿にコメントした`,
"label.integrations":`イングレーション`,
"label.permission.modifyAppPermission.selectedapp":`選択可能なアプリケーション`,
"label.privacystatement":`プライバシーに関する声明`,
"label.specificvalue":`特定の値`,
"label.appointmentconfirmpage.wizard.subtitle2":`日付と時間`,
"label.message.ispartner.delete":`この取引先責任者はパートナークラウドユーザに関連付けされているため、削除できません。`,
"report_button_go":`前に進む`,
"label.h5.similar.opportunity":`類似商談`,
"UG_Lead_005":`メールボックス`,
"label.num.length.not.overstep":`数値の長さは18桁を超えてはいけません`,
"label.profile.mobile.setup.CEOandDirector":`CEOと最高営業責任者`,
"label.addfield":`項目の追加`,
"template.dashboard.institutional.overview":`機関概要`,
"label_tabpage_datefield":`日付項目はイコールのとき、「昨日」、「今日」「明日」、「先月」、「今月」、「来月」、「先週」、「今週」、「来週」あるいは 「YYYY-MM-DD、MM/DD/YYYY」という書式を使用することができます。`,
"label.category.7":`観光`,
"UG_contact_02":`複数のチャネル（通話、メール、ソシャル）を通じて、取引先責任者を獲得します`,
"chatter.feed.menutype.feed.mecom":`私に関する更新`,
"vue_label_systemSettings_calltemplate":`手紙のテンプレート`,
"approval_process_errore":`保存にエラーが発生し、システム管理者に連絡してください。`,
"label.tabpage.choosefilez":`ファイルの選択`,
"label.changemydisplay.chagetab.cusapp":`カスタマアプリケーション`,
"clearadvancedoption":`高度なオプションのクリア`,
"front-epwechat-module-v1-binding-user":`バウンドユーザー`,
"label.customfields.fielddependency.null":`定義されない項目の連動関係`,
"label.enterprise":`企業版`,
"font-evaluate-module-v1-five-points":`ニュートラルマーク：5点`,
"lable.Synchronize.from.QuickBook":`QuickBookからの同期`,
"front-gantt-module-v1-task-number":`タスク量`,
"label.currency.edit.newexchagecurrency":`期限切れの為替レート`,
"label.partnerCloud.partnerSite":`パートナーサイト`,
"label_tabpage_unequalz":`一致しない`,
"label.version.solutions":`ソリューション`,
"label.setting.intergrationlist.button.installed":`インストール済み`,
"label.h5.chatter.share":`ファイルの共有`,
"front-epwechat-module-v1-unbound-item4":` 外部アカウントの結合`,
"label.textmessage.vonage.accessibility.setting":`アクセシビリティの設定`,
"font-evaluate-module-v1-evaluation-set":`評価設定`,
"message.servicecrew.time.violation2":`この時間には働きません`,
"label.processinfo":`承認プロセス情報`,
"label.knowledgebase.last.modified":`最終更新日`,
"label.to.phone":`にしています。`,
"label.baseoffirsttimereply":`<strong>に基づいて初めて</strong>承認を返事しまたはるいは拒否します。`,
"label.projectManagement.startingEndingTime":`開始と終了の時間`,
"label.licence.enable":`有効化`,
"label.partnerCloud.basicSetting.cshua":`Partner Cloudの初期化`,
"APPIntegration.Dropbox.setting.03":`Dropboxを有効にすると、Dropboxからファイルを選択して添付ファイルとして追加することができます。`,
"label.account.contact":`取引先責任者構造図`,
"label.many.dayline.tab":`タグ`,
"label.weixin.input.username":`名前を入力してください`,
"label.logintime.pagecue.invalido":`終了時刻も必ず終日です。`,
"label.icon.30":`本`,
"label_tabpage_advancedscreening":`高度な絞り込む条件`,
"lable.currencyManage.unEnabledadvcurrency.agree":`はい、高度な通貨種別の使用を禁止します`,
"label.tab.web.new":`新規Webタブ`,
"label.bmap.tiananmen":`天安門`,
"label.disabled":`使用不可能`,
"error.currencyAdv.deleteprecodedate":`通貨コードの前の日付の為替レートを削除することができません`,
"message.error.view.checkbox.validerr":`エラー：TUREを使用`,
"UG_ST_006":`直接入る`,
"label.dongshifang.title":`DongShiFang  SMS`,
"label.data.dataexpalltype.all.desc3":`3、エクスポートに成功したデータは圧縮ファイルを生成しします。ユーザーはメールに記載されているファイル情報に従って、エクスポート成功一覧ページからダウンロードすることができます。`,
"vue_label_pool_returnreason":`戻る理由`,
"label.list.userinterface.des":`組織のユーザインターフェースを設定します。`,
"label.notification.approval2":`あなたの【オブジェクト】の承認申請は【承認者】に拒否されました`,
"label.service.dispatchingUnits.the.level":`レベル`,
"front-email-payment-Invoice-preview-tips":`現在、すべての請求書テンプレートが無効になっています。請求書を作成する前に、管理者に連絡してテンプレートを有効にしてください。`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`エラー：コンポーネントにリストで使用できない項目は1つまたは複数あります。<br>ダッシュボードコンポーネントエディターで使用可能な項目を1つ選択してください。`,
"label.import.step2.chooseidorother":`2、IDまたは名前のマッチングレコードと記入する検索項目を選択することができます。対応するレコードIDなどの情報を取得すると、レポートを作成し、レコード名と記レコードDをグループ列に設定して、レポートをエクスポートします。`,
"label.customobjects.introduce":`カスタムオブジェクトとは、Salesforceの組織に固有のデータを保存できるデータベーステーブルのことです。カスタムオブジェクトを使用して、cloudcc 機能を拡張したり、新しいアプリケーション機能を開発できます。`,
"label.visualpage.oldsystem":`旧バージョン`,
"label.icon.94":`本`,
"label.setup.log.desctiption":`組織の追跡をタウンロードすることができます（ファイルExcel.xls）。`,
"label.dynamicpage.layout":`動的ページのレイアウト`,
"lable.list.queue.objct":`サポートされるオブジェクト`,
"label.customfields.placeholder.tip":`例のテキストは入力ボックスに表示され、フォーカスを取ってから消えます`,
"label.ems.activationtime":`有効化日付`,
"label.detailinfo":`詳細情報`,
"label.icon.17":`報告する`,
"label_emailtocloudcc_button_complete":`完了`,
"label.visualpage.component.n2":`2.ご注意：コンポーネント表示ラベルは<cc>の表示ラベルにネストできません`,
"label.object.name.one":`オブジェクト名 1`,
"label.summaryreport.step2":`ステップ2：集計情報の選択`,
"thisisanew":`新しい`,
"label.query.detail.editpartneruser":`パートナーユーザの編集`,
"label.tabpage.newview":`新規ビューの作成`,
"label.partnerCloud.productSet.addNew":`新しいオプション`,
"label.appupload.upload.new.remark":`これは全く新しいコンポーネントです。`,
"label.case.ptext":`御社をWeb版ポータルにリンクしました。貴社専用の顧客サービスポータルのWeb版アドレスをコピーして、貴社の公式Webサイトにポータルを追加してください。`,
"lable.PowerProcess.name":`エンタイトルメントプロセス`,
"label_tabpage_choosefilez":`ファイルの選択`,
"homepage.components.place":`コンポーネントの位置`,
"lable.Synchronization.failure":`同期に失敗しました`,
"label.dashboard.snapshot.get.data":`あなたのデータを獲得`,
"label.input.invalid.format":`有効な表示形式の入力`,
"label.quickbooks.view.openinvoices":`行われている請求書`,
"label.weixin.seating":`座席数`,
"label.searchlayout.remark":`以下の検索機能に表示される標準項目およびカスタム項目を選択できます。`,
"label.escalation.setup.entrydetail.escalation.assiner":`に割り当てる`,
"vue_label_calendar_availability_view":`カレンダー-使用可能なビュー`,
"label.country":`国`,
"label.campagin.roi.zl":`概観`,
"lable.currencyManage.advcurrencyEnabled":`高度な通貨種別管理は有効になっている`,
"label.projectManagement.project.task":`プロジェクトのToDo`,
"label.appointmentpage.wizard.subtitle3-2":`メール`,
"label.input.invalid.date":`有効な日付を入力してください（ISO)`,
"vue_label_chatter_my_followers":`私のフォロワー`,
"label.setupdevelop":`新規アプリの開発`,
"label.sendemail.send.checksend":`メールの送信をチェック`,
"label.eventfield":`行動項目`,
"label.ccpeak.ccobject.put":`CCObjectにputで割り当てる。例えば：`,
"label.campaignmember.main.addMemberDesc":`既存のリードと取引先を検索して、このキャンペーンに追加し、また既存メンバーを管理することもできます。`,
"label.knowledge.setting.hint.eleven":`データカテゴリの入力`,
"label.knowledge.category.button.four":`兄弟姉妹カテゴリーの追加`,
"label.icon.27":`学ぶ`,
"vue_label_chatter_certification":`{isStatus}"{titleName}"でよろしいですか。`,
"label.data.downpage.i.title.btn":`インポートページに移動し、インポートを開始する`,
"label.campaign.channel.step6.pc":`PC端末ページの生成`,
"label.mr.caption.rule":`ルール：1つまたは多数の重複検索ルールを必ず選択してください。`,
"label.service.gantt.resourcestype":`リソースの種類`,
"label.searchfitconditions":`以下の条件に一致するものを検索`,
"label.partner.template.name":`テンプレート名`,
"setup.mainpage.label.welcome15":`CloudCC クラウドプラットフォームのワークフロールールは、営業やマーケティングなどのサポートプロセスを自動化します。あらかじめ設定されたルールに応じて、レコードを自動的にユーザーに割り当てたり、あるユーザーから別のユーザーに変換したりすることができます。ワークフロー管理の主なメリットは、レコード更新時の多くの不要な操作を排除することで作業効率を向上させ、作業方法の標準化や運用コストの削減により、業務処理レベルの向上や管理プロセスの最適化を実現することです。任意のオブジェクトに対する無限大の承認をサポートし、リマインダーメール、SMSリマインダー、タスク、フィールド更新などの機能をトリガーすることができます。`,
"vue_label_commonobjects_view_chart":`チャート`,
"label.salescloud.teamrole.choose":`チームロールを選択してください`,
"lable.outlook.mcto.emailrel":`メールの関連付け`,
"front-invoice-online-payment-setup-describe":`高速アクセス、ワンクリックアクセス。簡単、安全、迅速なオンライン決済サービス。`,
"label.korean.standard.time":`韓国標準時`,
"label.lord.howe.standard.time":`ロード?ハウ夏時間`,
"setup_layout_group_button":`ボタン　`,
"label.editdefaultshare":`デフォルトの共有設定の編集`,
"label_fiscal_year":`会計年度`,
"label.appointmentdetail.wizard.title2":`所有者`,
"label.email":`メール`,
"label.city":`町`,
"label.knowledgebase.data.recovery.failed":`a}のデータの復元に失敗`,
"setup_mainpage_label_welcome6":`ユーザはプログラミング知識を持っていなく、コード開発を行わなくても、 CloudCC システムのオブジェクトを利用して、様々な項目を構築することができます。項目種別は、関係検索、単一選択項目、複数選択、公式、自動採番、URL、電話、ファックス、電子メール、日付、時間、数字、テキスト、テキストエリア、オプションリスト（単一／複数）、貨幣種別などが含まれています。`,
"label_emailtocloudcc_button_enable":`有効`,
"label.account.custom":`カスタマ四半期決算`,
"label.custompublish_time":`お客様の公開時間`,
"label.dashboardSetup.selwz":`位置表示の選択`,
"component_todaytask_label_all":`すべて参照`,
"label.service.resource.group.tip":`サービスグループを選択してサービスリソースを作成します。リソースの種類はグループのみ選択できます。`,
"label.tianyancha.legalpersonname":`法人`,
"component.setup.label.titlefield":`タイトル項目`,
"label.email.template.public.mail":`公開メールテンプレートフォルダ`,
"front-template-V1-DeleteTempalte":`本当に"{currentTelmplateName}"を削除するのですか？`,
"pagecreator.layout.label.layoutdesc":`レイアウトの説明`,
"vue_label_file_singel_upload":`アップロードできるファイルは1つだけです。ファイルを差し替える場合は、先にアップロードしたファイルを削除してください。`,
"label.view.hierarchy":`階層を表示`,
"label.file.owner.settings":`所有者の設定`,
"label.sales.dashboard.name":`名前`,
"label.offfer.filer.name":`引用ファイル名`,
"label.quickbooks.view.recentlypaid":`最近に支払う`,
"label.step1.select.merge.records":`ステップ1.マージするレコードの選択`,
"message.recordtype.assignprofile.tip":`新しいレコードタイプを使用するため、プロファイルにチェックボックスを有効化します。このプロフィールに割り当てされたユーザーは、このレコードタイプのレコードを作成し、またはこのレコードタイプを既存のレコードに割り当てることができます。新しいレコードタイプをあるプロファイルのデフォルトのレコードタイプをさせるには、「デフォルトチェックボックスに設定」を選択してください。`,
"label.appointmentdetail.wizard.title9":`旅行時間`,
"label.group":`チーム`,
"label.deltorecycle":`ゴミ箱に削除`,
"label.import.index.numlimit":`1.サポートされているのはcsv形式のファイルのみです。（一度にインポートできるのは30,000個のレコードです。トリガーを実行する必要がある場合は2,000レコードまでです）。この制限を超えたレコードは、システムによって自動的に無視されます。より多くのデータをインポートする場合は、まず複数のファイルに分割し、インポートしてください。.`,
"label.file.delete.desc":`ファイルは削除されたら、それを添付するレコードや書き込みからも削除されます。`,
"UG_activity_04":`Outlook/Gmailメール　メールの記録`,
"label.event.all.undealt":`すべての未完了の行動`,
"label.appupload.upload.install.error":`このアプリケーションはインストールできません。インストールを終わらせて、またはAPIを修正してから、改めてインストールしてください。`,
"template.chart.yqydcpsl":`活性化された製品の数`,
"label.import.index.advancepreparation":`事前準備`,
"label.eowechat.epdeptnamee":`ウィーコム部門名`,
"front-kefu-moudle-please-input-servernum":`サービスリクエストリストNo.を入力してください。`,
"label.lookup.autocmp.nodata":`一致するデータはありません`,
"vue_label_pool_assign":`割当て`,
"label.knowledge.timing.publish":`タイムドパブリッシュの失敗`,
"label.selected.groups":`選択された見積ライングループ`,
"front-epwechat-module-v1-removesele-desc":`削除すると、このアプリケーションのすべての設定が削除されます。本当に削除していいの？`,
"label.batchtransfer.type2":`完了済みの商談の移行`,
"label.richtext":`リッチ`,
"label.icon.174":`航空機`,
"vue.please.select.grouping.basis":`グループ化の根拠選択してください`,
"label.matrixreport":`マトリックスレポート`,
"label.jiandangfenpei.leftlist":`割り当てされないプロファイル`,
"label_chatter_card":`カード`,
"label.file.enter.title":`タイトルを入力してください`,
"label.the.record.is.locked.and.cannot.be.selected.":`このレコードはロックされており、選択できません。`,
"label.partner.success":`成功しました。このドメインは使用可能です。`,
"label.selectreporttype":`レポートデータソースの選択`,
"report.type.label.productPricebooks":`製品と価格表`,
"label.texttemplate.mergefields.tip":`SMSの内容を編集しながら、incorperateフィールドを追加することができます。SMSを送信する際に、組み込みフィールドを対応するテキストで置き換えることができます。例えば、{!Contact.name}は、SMS送信時に連絡先名に置き換えることができます。`,
"label.publicgroup.detail.showallusers":`すべてのユーザを表示`,
"label.brief.follow":`フォロー`,
"label.forecast.settings.qijian.p":`四半期ごとの予測`,
"label.sms.url":`サイト`,
"setup_layout_group_custompage":`カスタマページ`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`あなたにメッセージを1つ送信しました`,
"label.pc.layout":`PCレイアウト`,
"label.currency.v":`新しい通貨種別で表示されるデータの小数点の桁(小数点右の桁)は、必ず0から6までの整数でなければなりません`,
"label.projectManagement.kanbantask":`看板タスク`,
"component_recdetail_label_title":`詳細情報`,
"label.isremider":`通知しますか`,
"front-epwechat-module-v1-input-home-url":`ホームページのURLを入力してください。`,
"label.usefullife":`有効期間`,
"label.visualpage.ptype":`普通`,
"label.quote.name":`見積書名`,
"vue_label_report_addtocomponent":`本当に{name }をコンポーネントライブラリに追加しますか`,
"label.dashboardSetup.showdw.d1":`億`,
"label.validate.function.funcFormat.OR":`OR(logical1,logical3,...)`,
"label.component.helper.potentialcustom":`今日割り当てられたリード`,
"label.autoRegister.changepwd.setpwd.tip.number":`少なくとも1つの数字があります`,
"label.data.setok.e.desc3":`エクスポートしたデータをダウンロードします。`,
"label.data.downpage.e.title.num4":`4、エクスポートするファイルにはCSV形式と圧縮形式との二種類があります。圧縮形式は、圧縮ファイル形式にはパスワードが自動的に生成されるものと、手動でパスワードを入力するものに分かれています。`,
"lable.quote.editqtpdt.description":`見積もりに価格表を選択します。個別価格表しかから商品を追加することができます。選択した価格表を更新したら、この見積書からすべての既存商品を削除します。`,
"front-kefu-moudle-edit-userinfo":`ユーザー情報の編集`,
"label.please.ChooseMinAndMax":`商品の選択肢は最低でも{0}以上、最大で{1}まで選択してください。`,
"label.knowledgebase.archive.an.article":`記事をアーカイブするには？`,
"label.multilang.customforcast.submit":`{0}番目の会計年度{1} から{2}番目の会計年度{3} までの予測を提出しますか。`,
"label.import.index.filename":`ファイル名`,
"front-console-no-reco-contact":`連絡先が特定できない`,
"label.quantity.greater.than0":`数量は0より大きくなければなりません。`,
"label.codeNorm":`コード・スタンダード`,
"label.average":`平均値`,
"label.multilang.page1":`第`,
"label.data.exp.save.ok":`テンプレート保存が成功しました`,
"message.error.delete.record":`削除するレコードが見つかりませんでした。`,
"label.newvaluereplaceoldvalue":`このページでは、新しい値で選択リストの既存値を置き換えます。選択リストの詳細ページで新しい値を作成することを確保します。`,
"label.tabpage.saveviewsuccess":`ビューの保存に成功しました`,
"label.partnerCloud.productSet.parentOptions":`親のオプション`,
"label.emailtemplate.availablemergefields":`使用可能な差し込み項目`,
"label.data.import.setup":`データインポートの設定`,
"label.escalation.setup.entrydetail.escalation.action":`グレードアップのアクション`,
"System.TimeField.Description":`ユーザーが現地時間を入力することができます。例えば、"2:40 PM"、"14:40"、"14:40:00 "などはこの項目のすべて有効な時間です。`,
"front-additional-products":`他の製品を購入する`,
"label.appointment.wizard.subtitle4-4-1":`一週間`,
"label.chatter.colleagues.list":`同僚リスト`,
"label.log.invalid.data":`無効な時間`,
"label.file.preview.unconvert":`プレビュー情報が生成されておらず、プレビュー詳細情報をクリックしてください`,
"label.customer.detailed":`この新規タブのページを選択し、その他の詳細を入力してください。`,
"label.sendsms.content":`内容は以下の通りです。`,
"label.exported_to":`エクスポートされたファイルは、メールで`,
"label.attendance.checkin":`サインイン`,
"Dashboard.NoAccessRightToSee.Warning":`デフォルトオープンとして設定されているダッシュボード{0}を表示する権限がありませんので、リセットしてください。`,
"message.choosedelete":`削除するデータを選択してください`,
"label_tabpage_choosecontent":`値の内容を選択してください`,
"label.no_responses":`回答なし`,
"report_type_label_customService":`顧客サポート`,
"label.report.select.condition":`条件を選択`,
"label.umeng.activity.distributeevent":`割り当てされた行動`,
"label.knowledge.language.portuguese":`ポルトガル語`,
"label.knowledgebase.published":`公開`,
"UG_opportunity_001":`販売をどのようにモニターしますか。`,
"label.mr.caption.scope":`範囲：選択しないとすべてのデータを検索します`,
"message.login.mfaverification.to.pclogin":`ログインの再校正は有効化済みで、初めてのログインにはモバイル設備をバインディングする必要があり、PC端末でログイン時のバインディングを行ってください。`,
"vue_label_dashboard_pleaseenterthecolorrange":`色の範囲を入力してください`,
"label.emailsync.status.time":`時間`,
"chatter.putup":`ファイルを貼り付け`,
"vue_label_report_drillcondition":`条件のドリル`,
"label.emailobject.list.myemail":`私のメール`,
"label_tabpage_andz":`と`,
"label.share_link":`シェアリンク`,
"label.emailtocloudcc.exists2":`このメールボックスは、「Email to Case」に設定されています。設定を重複しないでください。`,
"label.icon.89":`助言`,
"front-kefu-moudle-v1-qdygbzx-chat":`オンラインチャットをオフにしても大丈夫ですか？`,
"label.approval.selectone":`以下のいずれかを選択してください`,
"chatter.group.groupName":`チーム名`,
"label_chatter_relateitem":`関連先`,
"label.file.folder.delete1":`フォルダを削除しますか?`,
"Pagelayout_Setup_003":`名称項目を選択しなければなりません`,
"setup_mainpage_label_welcome2":`カスタマデータベース（オブジェクト）`,
"pagecreator.systemstyle.label.linkcolor":`リンクカラー`,
"label.task.this.week":`今週のToDo`,
"message.custom.field.donotdelete.report":`この項目はレポートに参照されている`,
"pagecreator.layout.button.delete":`レイアウトの削除`,
"label.reportsSubscriptionPage.condition.operator":`論理記号`,
"label.location.display.type.degrees":`度、分、秒数`,
"label.appupload.upload.url":`URLのインストール`,
"label.logical.relation":`論理関係`,
"label.knowledge.publish.article":`記事の公開`,
"vue_label_commonobjects_detail_activity_commingtask":`間もなく行うToDoがあります`,
"vue_label_pool_reason":`{0}理由`,
"front-gantt-module-subtasks-cannot-subtasks":`サブタスクの下にサブタスクを表示することはできません。`,
"label_tabpage_filesizez":`ファイルサイズ`,
"label.customfields.formula.returntype.monry.tip":`ドルまたはその他の通貨金額を計算し、項目を通貨金額の表示形式に自動的に置き換えます。`,
"label.tabpage.allapplications":`すべてのアプリケーション`,
"message.duplication.label.matchcontainletters":`一致を含む`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`作業注文の生成方法は「資産ごとに作業注文書の項目を作成する」を選択してください。`,
"label.preview_post":`プレビューポスト`,
"chatter.p.data":`発表日`,
"label.isnot.right.number":`正しい数字ではありません`,
"label.contentsource":`内容ソース`,
"message.groupandsummaryconditionsame":`グループ化の条件は集計条件と同じになってはいけません`,
"label.weixin.wdyj.nodata.qin":`データがありません`,
"chatter.vote":`票`,
"label_partner_workspace_tab_option":`選択可能なタブ`,
"chatter.changeVote":`投票の更新`,
"label.data.file.i_title.num2":`2.インポートする前にエクスポートすることを勧めます。エクスポートするフォルダをデータテンプレートしとしてインポートするデータを整理してから、インポートします。（インポートするデータに読点があれば、「@」でこれに替わります。`,
"label.relation.list.error":`エラー`,
"label.validate.function.funcExplain.MILLISECOND":`日付/时间項目のミリ秒に戻る`,
"label.emailobject.emaildetail.button.relateto":`関連先`,
"label.dashboard.dataSource":`データソースの表示`,
"label.marketseamemset.lead.title":`リードプールのメンバー設定`,
"label.appupload.addobj":`ソフトパッケージに追加`,
"lable.outlook.mcto.domain":`表示形式は（gmail.com）の通りで、排除したドメインリスクに追加します。`,
"label.input.right.url":`正しいURLを入力してください`,
"label.newprocessstep5.tip":`承認ページで承認者が承認あるいは承認却下を行うことができます。下記のオプションを使用して、このページで表示する項目を選択します。`,
"label.schedulejob.setup.schedule.st4":`四番目`,
"label.emailsync.status.user":`ユーザー`,
"front-kefu-moudle-v1-jymm-reinput":`大文字、小文字、数字、文字のうち2つ以上を組み合わせた12桁のパスワードを入力してください。`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`スコアリングルール名`,
"label.mr.title.fieldName":`項目名`,
"label.data.deriall":`すべてエクスポート`,
"label.tianyancha.businessverify.step2":`企業データ検証ステップ2を有効化`,
"label.submissions":`投稿作品`,
"vue_label_calendar_removed_successfully":`カレンダーの削除に成功しましｔ`,
"label.eventrecordtype":`行動のレコードタイプ`,
"lable.outlook.detail.syndire":`同期方向`,
"label.mobile.bind.fail":`バインドに失敗しました、後でもう一度試してください`,
"label.notification.task2":`あなたが【任命先】に割り当てたToDoは参照されました`,
"label.partnerCloud.orderingPlatform.paymentMethod":`ペイ・バイ`,
"label.escalation.setup.newaction.step3":`ステップ3：通知するユーザの選択`,
"label.summaryreport.selectsum":`集計条件と集計種別の選択`,
"label.components.setup":`コンポーネントの設定`,
"label.taskevent.introduce":`以下はToDo&行動のリスクです。`,
"label.assignment.setup.detail.conditon":`条件`,
"front-lightning-module-v1-details-page-chart-select-statements":`レポートの選択`,
"lable.Song.typeface":`シムサン`,
"label.formulassesstrue":`数式評価がtureです`,
"label_partner_common_setup":`一般的な設定`,
"label_chatter_dateRange":`期日範囲`,
"label.partner.workspace.tab.mobile.using":`チェックしたメニューは同時にモバイル端末に表示されます。`,
"message.servicecrew.time.violation1":`発送時間の違反：チームメンバーがいます`,
"report_label_projectcount":`件のプロジェクト、レポート名に基づき、並び替える。`,
"label.file.uploadfile":`ファイルのアップロード`,
"vue_label_commonobjects_detail_correct_email_address":`正しいメールアドレスを入力してください。`,
"lable.account.CurrentandNextCQr":`主な取引先責任者がいません`,
"setup.layout.label.order":`並び替えの方式`,
"label.service.major.event.independent":`独立`,
"label.icon.38":`ポジショニング`,
"label.knowledge.draft.record":`削除するレコードが見つかりません。`,
"label_quota_percentage":`クォータの完了率を表示する`,
"label.escalation.setup.entrydetail.escalation.minute":`分`,
"label.knowledgebase.edit.article.category":`記事カテゴリの編集`,
"Homepage_News_003":`取引先のデータがないため、ニュースが表示できません。取引先を作成してから、ここでは取引先に関するニュースが表示できます。`,
"label.mr.descreption.oneGroupNote3":`レコード`,
"label.customsetting.touse.getListCustomSetting":`[リスク]種別のカスタマ設定データを検索し、対応するapiNameの全てのデータマップを返します`,
"message.error.view.cannotbenull":`エラー：必ず1つの値を入力してください`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`金曜日`,
"message.error.view.badprevilege.qin":`アクセス権がないため、データがありません。`,
"label.dashboard.distribution":`ディストリビューション`,
"label.field.value.save":`この項目にレコードを保存する値が1つ必要です。`,
"label_custom_year":`カスタム年度`,
"label.code.error":`このコードには許可されていないコマンドと関数が含まれています。例えば：`,
"label.appexchange.uninstallpage.message2":`コンポーネントのカスタマイズをすべて完全削除`,
"label.global.search.obj":`グロ_バル_索_象の_定`,
"label.emailobject.from":`送信者`,
"lable.opppdt.selPdt.byconditions":`項目に基づいて条件を絞り込む`,
"chatter.p.note":`当該投稿のコメント`,
"label.hiddenformulaedit":`数式エディターの非表示`,
"label.editQuotation":`見積書の編集`,
"label.notification.arketsea.collection":`{5}は{2}{0}{0}:{1}を受け取りました`,
"label.timzone.tip.info1":`データベースの保存(insertとupdate)java.util.Date種別のデータに関わるとき、例えばTpSysTask task`,
"label_tabpage_transformationsz":`置換`,
"front-kefu-moudle-IP-phone":`IPフォン`,
"label.emailobject.list.draft":`下書き`,
"label.tianyancha.businessverify.readandconfirm":`天眼查が返した項目をユーザ項目に追加します。`,
"label.win.customers":`完了済み/取引先の獲得`,
"vue_label_commonobjects_view_switch_display":`レコードはレコードタイプによって分類されており、対応するレコードタイプ名をクリックして表示が切り替えます。`,
"pagecreator_systemstyle_label_textcolor":`文字色`,
"label.autosearch.keywords":`キーワード検索を自動的に行う`,
"label.knowledge.setting.data.six":`カテゴリ{lbmc}を削除しようとしていますが、このままでよろしいですか？`,
"front-console-sort-field":`ケースNo.`,
"label.bangladesh.time":`バングラデシュ時間`,
"label.dashboardSetup.number":`数値`,
"lable.account.LastbDays":`過去の30日`,
"label.layout.searchdialog":`ルックアップダイアログ`,
"label.newprocessstep4.tip":`メールテンプレートを選択し、承認者に承認申請を割り当てたと通知します。ご注意：このテンプレートはこのプロセスのすべてのステップに使用されます。`,
"label.nousing":`有効になっていません`,
"vue_label_report_detailline":`詳細情報の行`,
"label.emailobject.template.message3":`メールテンプレートが上限に達しました`,
"label.c.d":`C to Dの関係。`,
"message.report.error.fail":`アップロードに失敗が発生し、改めて試してください。`,
"label.edit.ccdocument.content":`ファイル内容を更新しました`,
"label.textmessage.exceeded":`テキストテンプレートの数が制限を超えてしまいました。`,
"label.saveas":`別称で保存`,
"label.visualpage.an.inline.style":`詳細ページとタブページにカスタマページ種別に埋め込みます`,
"label.pagelayout.remark2":`ページレイアウトを作成したら、[ページレイアウトの割り当て] ボタンをクリックして、デフォルトでユーザに表示されるページレイアウトを指定します。`,
"label.notification.approval1":`あなたの【オブジェクト】の承認申請は【承認者】に承認されました。`,
"label.h5.chatter.image":`アップロードした画像形式は不正確です`,
"vue_label_dashboard_displayunit":`表示ユニットを選択してください`,
"label.knowledge.default.language":`ライブラリのデフォルト言語`,
"label.chatter.publish":`発表`,
"label.companyprofile.serveraddress":`今回の同期は現在のサーバを同期させるだけです。`,
"label.chatter.groups":`グループ`,
"label_set_successfully":`設定に成功しました`,
"label.quote.zongjia":`総価格`,
"label.project.notice.endingdatelater":`終了日は、開始日と同じかより遅い必要です。`,
"label.customfields.fielddependency.info":`当該ページでは、項目間の連動関係を作成します（例えば：連動関係のある選択リスト）。`,
"vue_label_lead_successful_conversion":`置換えに成功しました`,
"label.icon.93":`本`,
"shift.serviceresource.illegal":`サービスリソースはこのサービスエリアのメンバーに含まれていません。または交代の日付範囲はメンバー関係の範囲内ではありません。`,
"label.integrations.action.addnewlead":`新規リード`,
"label_display_all_zeros":`ゼロの値であるすべての行を表示`,
"canlendaryear":`カレンダー年度`,
"label_tabpage_selrecordtypez":`レコードタイプの選択`,
"vue_label_commonobjects_view_chart_funnel":`ファネルグラフ`,
"label.layout3":`レイアウト3`,
"label.logintime.cue":`ログイン時間帯の制限はありません。`,
"label.service.miniProgram.lastDate":`最終更新日`,
"label.emailobject.view.fromcrm":`連絡先/リードからのメール`,
"pagecreator.button.mobilepage":`モバイル端末`,
"lable.oppt.jieduan.signcur":`現在の段階のマークが付いています`,
"label.fullaccess":`完全アクセス権`,
"homepage.layout.pagename":`ページレイアウト名`,
"label.appointment.wizard.subtitle4-2-3":`3時間`,
"label.knowledgebase.please.check.record":`少なくとも1つのレコードを選択してください。`,
"label.view.sortview.closepage":`このページをクローズ`,
"label_forecast_type":`予測の種類`,
"all.day":`一日中`,
"label.view.sortview.printpage":`このページをプリント`,
"message.integration.configure":`統合の設定は空にしてはいけません。`,
"label.forecast.customforecast.foretype.close":`クローズド`,
"label_chatter_like":`いいね`,
"template.report.folder.customer.potential":`リード分析`,
"label.umeng.approval.dlsp.approve":`#approvalnameは代理して、#actornameが申請した#objAPIName#recordnameの承認を許可しました。`,
"vue_label_normal_movedown":`下に移す`,
"chatter.group.groupAccessPermissions":`チームのアクセス権`,
"label.visualpage.tip":`ここで自分のページを作成することができます`,
"message.validation.isnotdate":`正しい日付の表示形式をご入力ください`,
"label.icon.173":`ヨット`,
"label.icon.124":`注入`,
"label.import.page2.csvfiled":`CSV項目`,
"setup_layout_component_area":`エリア`,
"label.visualpage.workability.standard":`ページで使用可能な標準クラス`,
"label_emailtocloudcc_redmessage9":`データベースがエラーで、管理者に連絡してください`,
"label_tabpage_contactsz":`取引先責任者`,
"label.multilang.workflow.everydayinmonth":`{0}カ月{1}置きの{1}日`,
"APPIntegration.Social.linkedinerror":`linkedin.comの有効なURLを入力する必要があります。`,
"button_partner_workspace_manage_memo":`パートナークラウドを管理し、その配置プロパティを設定します。`,
"template.chart.bnsrmb":`年の収益目標`,
"chatter.follow.now":`フォローしている`,
"label.entitlement.process.condition.repeat":`重大行動の重複を設定する`,
"label.relationobject.isdl":`代理しますか`,
"label.lasttimemodifieralias":`前回変更者の別称`,
"vue_label_commonobjects_detail_task_name":`ToDo名の編集`,
"vue_label_homepage_quarterlyperformance":`四半期業績`,
"pagecreator.layout.message.delete":`今選択したレイアウトを削除しますか？`,
"component_sendmail_label_cc":`CC`,
"vue_label_email_enable_signature":`サインの有効化`,
"label.partnerCloud.financeSetting.create":`新しいパーターが有効になったときに、対象となるユーザーに自動的にファンドを作成します。`,
"label.data.file.i.title.num1":`1.インポートするファイルはCSV形式でなければなりません。ファイルにはタイトルを含む必要で、タイトルないならインポートできません。`,
"label_efine_assessment":`評価サイクル`,
"message.duplication.label.sectionTitle":`保留される値を選択`,
"front-electronic-export-buttonExport":`エクスポートへ続く`,
"message.submitpage.email":`おめでとうございます。メール一括送信の申請に成功しました。`,
"after":`より遅い`,
"label.version.nonsupport":`サポートしません`,
"label.icon.105":`スケジュール`,
"label.quickcreate.titledesc":`クイック保存を有効化すると、項目を記入するとき、検索ボックスで作成した新しいレコードを参照することができます。`,
"label.quote.number":`数値の記入`,
"label.view.sortview.setdefault.prompt":`このビューリストをデフォルトのビューとして設定します`,
"label.refertime":`提出時間`,
"frame.personinfo.label.minipic":`サムネイル画像`,
"label.mobile.home.page.newopp":`最新のリード`,
"label.address":`住所`,
"front-pay":`給与`,
"label.chat.serviceAppointment":`サービスのお知らせ`,
"label.umeng.activity.eventviewed":`#name様に割り当てした行動はチェックされました`,
"label.validate.function.funcExplain.DATE":`年、月、日を通じて、日付を作成します`,
"label.commiterselectapprover":`提出者が手動で承認者を選択することは許可さます`,
"label.appointmentconfirmpage.wizard.subtitle3":`場所`,
"vue_label_display_text_field":`テキスト項目の表示`,
"label.salescloud.teamrole":`チームロール`,
"maintenanceplan.workorder.generate.limit":`生成した作業注文書は、メンテナンス計画の範囲内で行うべきです`,
"label.campaignmember.selectmember.description":`1つのビューを選択して、メンバーを選択しキャンペーンに追加します。ユーザ状況は`,
"label.ismodify":`編集を許可しますか`,
"label.height":`高`,
"label.tabpage.thevalurofz":`の値`,
"label.create_successful":`フォーム作成成功`,
"front-invoice-online-payment-setup-configure-dialog":`支払い方法の設定`,
"label.customerinfo.smsEid":`ゲードウェイEID`,
"label.visualpage.list.no":`カスタムページのアクセス権限がありません`,
"look.trigger.in":`マニュアルを表示`,
"label.setting.disable":`ディアクティベート`,
"chatter.group.name":`チーム`,
"label.solutionadministrator":`ソリューションの管理者`,
"label.vlidaterule.top":`ページの最上位へ`,
"pagecreator.layout.message.save.fail":`レイアウトの保存に失敗しました`,
"label.partnerCloud.orderingPlatform.noZero":`数量は0ではありません。`,
"label.customfields.suretodeleteprompt":`カスタマ項目の削除メッセージを確認`,
"button_partner_viewdetail":`ビュー`,
"label.icon.122":`家`,
"label.customer.tab.step2.introduce":`新規カスタムタブを利用可能にするユーザプロファイルを選択します。それぞれのプロファイルの詳細ページ、編集ページからタブの表示/非表示も設定可能です。`,
"label.task.delegated":`代理済み`,
"vue_label_salesadvance_averageamount":`平均客単価`,
"vue_label_chat_invitedtojoin":`“{invite}”はあなたをグループチャットへの招待しました`,
"label.data.downpage.e_title.num1":`1、インポートするデータのオブジェクト、あるいはすべてエクスポートをを選択してください。`,
"label_display_options":`表示オプション`,
"vue_label_chatter_more_comments":`その他のコメント`,
"label.ggReleaseRange.publish":`掲載リスト`,
"label.valuetype.notmate":`行の条件は間違って、値の種別は一致していません。`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`前回の同期行動`,
"label.dataimport.duplication.filter":`重複検索条件メッセージの表示`,
"label.appdownload.uninstall":`パッケージソフトをダウンロード`,
"message.error.task.add":`新規ToDoに異常が発生しました`,
"UG.Account.07":`取引先のインポート`,
"label_tabpage_lastone":`少なくとも1つのアクションを選択してください`,
"front-console-holdTime":`ラグタイム`,
"label.emailobject.schedule":`これは私のスケジュールです。都合の良い時間えお選んでください。`,
"label.lookup.locked.data":`このレコードはロックされており、選択できません`,
"label.assignment.setup.newentries.ifcondtions":`以下の条件を満たしたら、当該ルールを運行します。`,
"label.magadan.time":`ペトロパブロフスクカムチャツキー時間`,
"message.error.serviceterritorymember":`サービス予約計画の開始と終了の時間範囲内で選択したサービスリソースをサービスエリアメンバーと定義してください。`,
"label_chatter_delete":`削除`,
"label.partner.workspace.member.permission":`選択可能な権限セット`,
"label.notification.task5":`あなたのToDoは期限切れです`,
"mary":`五月`,
"label.homepagemodule":`ホームページコンポーネント`,
"label.compact.layout.frame.error1":`画面の右側には内容が必ずあります`,
"chatter.error.refresherror":`更新が失敗し、改めて試してください。`,
"label.login.rememberPsd":`パスワードを覚える`,
"Lead.Scoring.Setting.Rule.Setup.01":`リードスコアリングルールのリスト`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`日曜日`,
"label.visible":`参照可能`,
"label.console.new":`新規コンソール`,
"label.mr.descreption.reDataList4":`ミリ秒。ページ毎に表示`,
"vue_label_notice_uploadavatar_notice2":`アップロードするアバターは、JPG/PNG/GIF形式のみです`,
"label.operation.error":`アクションに失敗が発生し、改めて試してください。`,
"label.sendsms.context":`SMS内容`,
"label.least.show.line":`（4行以上を表示）`,
"label.tabpage.newWizardz":`機能ウィザードの追加`,
"label.tippage.li2":`カスタマレポートタイプベースのすべてのレポートを削除`,
"label.customfields.new.step2.opration.unique":`ユニーク`,
"label.listofshare.remark":`以下のユーザは当該レコードの情報を参照することができます`,
"label.address_information":`アドレス情報`,
"label.projectManagement.overdue.tasks":`期限切れのToDo`,
"lable.account.PreviousCQ":`前回のカレンダー年度`,
"label.service.miniProgram.advertising":`広告名は複数の広告エントリを識別するのに使われ、広告には表示されません。`,
"label.integrations.mailchimp.exportlead":`Mailchimpにリードをインポートする`,
"label.payments.paytip3":`請求先住所を選択してください`,
"label.mobile.phone.screen":`絞り込む`,
"label.h5.tome":`私に関して`,
"label.mobile.side.tab.remark1":`CloudCCのメニューとオブジェクトをモバイル端末スライダーのナビゲーションメニューに追加します`,
"vue_label_calendar_choose_a_custom_color":`このカレンダーのカスタマカラーを選択`,
"label.lastname":`姓`,
"vue_label_dashboard_selectreport":`レポートを選択してください`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Cloud CCで表示されているようにレポートをエクスポートします。レポートのヘッダー、グループ、フィルター情報を含みます。`,
"label_chatter_default":`デフォルトページ`,
"label.globalSearch.info":`選択されたすべてのオブジェクトを検索`,
"label.integrations.mailchimp.massage2":`リードをMailchimpにエクスポートしていますが、後ほどMailchimpリスクで参照できます。`,
"label.tabpage.addresswrongz":`メールアドレスの形式がエラーで、正しいメールアドレスを入力してください`,
"label.mobile.phone.customer.call":`取引先訪問`,
"vue_label_email_linkrecordfail":`レコードの関連付けを取り消した`,
"lable.account.LastfDays":`過去の90日`,
"label.cpq.order.status.delete":`この注文は有効であり、削除することはできません。`,
"label.ccchat.notmember.active.group":`0`,
"label.savepayset.failure":`オンライン決済アカウントの保存に失敗しました`,
"label.version.createlimitbyobject":`現在のCloudCCバージョンは {0}で、オブジェクト毎に{1} 件の{2}を作成することができますが、既に上限に達しました。CloudCC をバージョンアップしてください。`,
"approval.process.errore":`保存中にエラーが発生し、管理者に連絡してください。`,
"label.stdashbord.xsld.business.reportanalysis":`図表分析`,
"label.login.verification.please.enter":`MFAアプリケーションで獲得したセキュリティコードを入力してください`,
"label.tabpage.cue":`メッセージ`,
"vue_label_salesadvance_converserate":`置換え率`,
"label.marketsea.recyclereminddays1":`自動回収前`,
"label.import.page1.update":`更新`,
"label.document.folder":`ドキュメントフォルダ`,
"label.h5.similar.opportunity.feature":`当該機能により、ユーザの商談と同じ項目を持つ商談を検索できます。有効にすると、商談レコードに [類似商談] 関連リストが表示されます。`,
"label.myanmar.time":`ミャンマー時間`,
"monday":`月曜日`,
"vue_label_account_shareholder":`株主`,
"button.partner.search":`検索`,
"label.partnerCloud.partnerAccount.topUpAmount":`上乗せ金額`,
"label.tabpage.refreshz":`更新`,
"lable.PowerProcess.complete":`重大行動を完成した時間（分）`,
"front-kefu-moudle- normal-phone":`一般電話`,
"label.user.unauthorized.organization":`権限が付与されていない組織で、管理者に連絡してください。`,
"label.area.canot.save.nulldata":`NULLデータは保存できません`,
"label.version.role.management":`ロール管理`,
"label.recordtype.batchaddattachments.batch.remark":`ステップ1.ファイルを選択　ステップ2.「アップロード開始」をクリックして、ファイルをアップロードします　ステップ3.「完了」をクリックし、前のページに戻ります`,
"label_tabpage_contentz":`内容を入力してください`,
"label.partner.workspace.member.all":`すべて`,
"label.validate.function.funcFormat.LEFT":`LEFT(text, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`リードまた取引先責任者を少なくとも1つ選択してください`,
"label.appupload.install.error.choice5":`インストールをすぐやめて、コンフリクトコンポーネントを入力します。`,
"label.version.lookupmdfield":`主な詳細項目`,
"setup.layout.label.desc":`降順`,
"vue_label_report_addsummaryformula":`まとめ方式の追加`,
"label.done":`実際`,
"label.input.samevalue":`同じ値の記入`,
"label.SMS.next":`このSMS通知の更新にオブジェクトを選択し、「次へ」をクリックします。SMS通知の更新は同じクラスのワークフローと承認プロセスしか関連することができません。`,
"label.role.allunselectuser":`すべての割り当てられていないユーザ`,
"label.loginhistory":`ログイン履歴`,
"vue_label_report_addpublicreportstofolder":`このフォルダにパブリックレポートを追加する`,
"label.email.track.no.attachment":`添付ファイルなし`,
"label_network_connection_failure":`ネットワーク接続に失敗しました。`,
"vue_label_file_delete_lib_member":`ファイルライブラリメンバーの削除`,
"label_partner_step1":`ステップ1.テンプレートの選択`,
"label.password":`パスワード`,
"label.select.the.fields.around.code":`QRコード/バーコードの周囲に表示するフィールドを選択します。`,
"label.file.share.limit":`共有の上限を超えており、新しい共有を追加することができません。`,
"label.desktop":`デスクトップ`,
"label.sendmail":`メールを送信`,
"label.quote.detail":`見積書の明細`,
"label.approvalstep2":`ステップ2.ステップ条件の指定`,
"label_component_hotdeal_nodata":`商談関連データはありません`,
"lable.reset":`リセット`,
"label.eventpagelayout":`行動ページのレイアウト`,
"label.icon.100":`文房具`,
"UG.quota.03":`見積もりテンプレート`,
"label.calendar.week.view":`週ビュー`,
"component_chatter_file_button_save":`発表`,
"label.as":`のため`,
"template.chart.yqxypjz":`平均期待応答`,
"UG.Contract.03":`契約書の作成`,
"label.projectManagement.gantt":`ガント図`,
"label.forecast.edit.error0":`エラー：1つの会社通貨を有効化してください。`,
"label.ccpeak.delete.sharetab":`共有リストを削除`,
"label.account.contact.goback":`取引先に戻る`,
"vue_label_email_insert_field":`挿入項目を選択してください`,
"setup_object_field_dependency_label_fieldvalueoptions":`選択可能な項目値`,
"label.salescloud.opportunity.contactrole.optionlist.main":`以下の選択リスト値は、取引先責任者の役割項目で使用する主リストです。`,
"label.huanxinconfig.tenantid.lost":`tenantidは空ではありません。`,
"label.mask.show.last_4":`サブネットマスクの最後4桁を表示`,
"label.targer.name":`指標名`,
"vue_label_commonobjects_detail_unlocksuccess":`ロック解除に成功した`,
"front-kefu-moudle-length-min":`長さ（分）`,
"label.chat.topic.my.favorite":`私のお気に入りのトピックス`,
"chatter.upload":`アップロード`,
"message.cannotapproveit":`承認申請が処理できません`,
"label.weixin..xsld.order.by.jine":`契約金額に基づいて並び替えます`,
"label.projectManagement.wait.test":`テストを待っています`,
"template.report.customer.contact.list":`アカウントの連絡先一覧`,
"label.empty.recycle.bin":`ごみ箱を空にする`,
"label.detail.approveprocess":`承認プロセスを表示`,
"label.appexchange.uninstallpage.message4":`このパッケージのカスタマオブジェクトに基づくすべてのレポート、ビューとカスタマタブを完全に削除します。`,
"label.weixin.linkreport":`関連→レポート`,
"label.tianyancha.orgnumber":`組織機構コード`,
"Q":`選択リスト (複数選択)`,
"pagecreator_systemstyle_message_save_fail":`スタイルの保存に失敗しました`,
"label.partner.new":`パートナークラウド：新規`,
"label.ems.accounttype":`アカウントタイプ（A)`,
"label.weixin.next":`次のステップ`,
"label.weixin.coach.interpret":`愛馬社はWebchatサービスの法律範囲内の修正権と最終的な釈明権を保有します`,
"label.some":`個`,
"label.currency.rate":`通貨種別の編集：為替レート`,
"label.emailobject.template.name":`テンプレート名`,
"UG.Campaign.001":`キャンペーンの企画`,
"label.mr.descreption.reDataList3":`チーム、検索に時間がかかります`,
"label.project.hit.nine":`デイリーイシューリマインダー`,
"lable.PowerProcess.golist":`<<リストへ：エンタイトルメントプロセス`,
"label.viewbuttonedit.remark":`フロントエンドビューで表示する標準ボタンとカスタマボタンを選択します`,
"label.component.helper":`アシスタント`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`契約して代金を受け取る`,
"chatter.group.userName":`ユーザ名`,
"label.mobile.phone.business":`ビジネスチャンス`,
"label.quickbooks.payments":`PAY`,
"label.step6.total7":`ステップ6、合計で7つのステップ`,
"label.forecast.detailforecast.revenue":`収入予測`,
"vue_label_commonobjects_view_chart_displayas":`に表示します`,
"label.recordeditoption":`編集可能なプロパティのレコード`,
"label.sendemail.send.sendfailstandby":`メールの送信に失敗し、管理者に連絡してください。（代替の送信トレイ）（エラーコード：`,
"label.knowledgebase.reset.filter":`リセットフィルター`,
"label.icon.111":`食物`,
"label.standard.buttonandlink.firstsetting":`優先級の設定`,
"front-filter-module-v1-filter-description":`フラッシュフィルターは保存できません。現在の操作にのみ適用され、ビューや他のユーザーに影響を与えることはありません。`,
"label.showmore":`さらに表示`,
"UG_Lead_001":`どのように手がかりを導入しますか。`,
"label.exchange.sync.state.setting.m1":`提供した Miscrosoft Exchange のサービスアカウントは`,
"label.please.enter.channel.name":`チャンネル名を入力してください`,
"label.emailtocloudcc.edit":`編集`,
"label.layout.tabdialog":`タブ`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`完了したタスク`,
"label.tabpage.enterviewname":`ステップ1：ビュー名を入力してください`,
"label.mobile.phone.not.to.choose":`未選択`,
"label.datamanage.contact.namenull":`ご注意：[取引先責任者名]項目に割り当てないと、取引先責任者レコードはインポートされることができません。`,
"LT":`地理的位置情報`,
"label.exchange.sync.state.task.m3":`最後24時間の同期レコード`,
"lable.SalesCommitmentKanBan.contractOwner":`契約の所有者`,
"vue_label_chatter_write_review":`コメントを書く`,
"label.h5.approval.enter.content":`承認の説明内容をご入力ください`,
"label.location.display.type":`緯度と経度の表示方法`,
"label.numberscannotnull":`数値は空であってはいけません`,
"label.icon.3":`通貨`,
"setup_object_field_dependency_label_linkedfieldvalue":`連動項目の値`,
"label.task.future":`これからのToDo`,
"label.look.more.record":`レコードをさらに表示`,
"vue_label_account_cases":`取引先所有者のすべてのケースを置換える`,
"label.emailobject.emaildetail.title.ccaddress":`CC:`,
"label.setHistoryTrack":`追跡履歴の設定`,
"ObjectDetailed.ViewKeyInformation.Layout":`キー情報の編集`,
"label.layout.editsearchdistribute.tip":`この検索レイアウトに含まれる項目を選択します。選択は検索結果の表示を決定するだけで、実際に検索された項目に影響を与えないので、ご注意ください。`,
"label.emailtoall":`所有者にメールを送信します`,
"label_partner_new":`パートナークラウド：新規`,
"label.direct.dashboard.me.not.approval":`私の未承認プロジェクト`,
"label.platform.customize.customizeui":`カスタムUI`,
"label.userinfo.pwderror.againinput":`先に入力したパスワードと一致しません。再入力してください。`,
"label.customsetting.introduce":`カスタム設定を使用して、組織レベル、プロファイルレベル、およびユーザレベルでカスタムデータを作成および管理できます。カスタム設定データはアプリケーションキャッシュに保存されます。つまり、問い合わせを繰り返すことなく、カスタム設定データに効率的にアクセスできるようになっています。`,
"label.file.owner":`所有者`,
"label.icon.7":`人`,
"label.document.query.button":`ブラウザーボタンから検索してください。`,
"label.tabpage.turnoffsz":`クローズド  コンバート`,
"message.error.appid.appsecret.failed":`暗号化キーの取得に失敗しました`,
"vue_label_commonobjects_view_to_display_fields":``,
"label.martrixreport.setlinetitle":`行タイトルの指定`,
"vue_label_chatter_applycertification":`"{name}"のグループへの加入を同意しますか`,
"front-electronic-export-success":`エクスポートに成功し、Mailchimpのリストで確認してください。`,
"label.emailsync.status.enable":`関連付けの有効化`,
"label.c_d":`CからDまでの関係`,
"PageLayout_Search_MultiSearch_003":`少なくとも1つ_目を__してください`,
"label.tabpage.newInterfacez":`新しいインターフェース`,
"label.cutomsummaryfieldedit":`カスタマ集計項目の編集`,
"label.usermanage.view.field.notexist":`ビューの項目は存在しません。`,
"label.list.userinterface.dashboard.setup":`ダッシュボードの設定`,
"label.knowledgebase.delete.article":`記事の削除`,
"label.dataimport.type.update":`クリーンアップ`,
"label.marketsea.new":`新規プール`,
"label_tabpage_newlybuildz":`新規`,
"vue_label_helpcenter_report1":`1.レポートを作成する<br>販売管理システムCloud CC Lightningレポートは、強力なデータ分析ツールです。多くの営業上の問題は、レコードをグループ化、フィルタリング、要約することで解決できます。例えば、以下のようなものです。"前四半期に会社の新しい商談がどれだけの収益を生み出したか。"データの概要を完成させた上で、レポートのチャートを追加することができます。レポートが完成して、「実行」をクリックすると、データの完全な結果が表示されます。<br> Step 1: レポートタブから「新規レポート」をクリックします。<br> Step 2: レポートのデータソースを選択し、「次へ」をクリックします。<br> 選択したレポートのデータソースによって、レポートで使用できるレコードやフィールドを決定することができます。メインオブジェクトとしてオブジェクトを選択または検索します。<br> メインのオブジェクトと関係のあるオブジェクトを4つまで選択でき、オブジェクト間の関係を選択することができます。<br> Step 3: レポート編集画面に入り、プレビューデータを表示する<br> 編集モードでは、レポートをカスタマイズしたり、レポートに項目を列として追加したり、行や列をグループ化したり、フィルタを使って必要なデータが正確に表示されるまでレポートデータをフィルタリングしたりすることができます<br>列を追加または削除し、順序を調整する<br>.列を追加する。レポート編集モードで、ページ左側の「サマリー」にある「列」入力ボックスをクリックし、項目を検索するか、項目のドロップダウンリストをスクロールしてオブジェクト項目を選択した後、レポートの列を追加します。<br> カラムを削除する。<br> A. 左側の「カラム」リストから削除する「カラム」を見つけた後、項目ボックスの「×」をクリックします。<br> B. または、右のレポートプレビュービューのヘッダーで削除する「列」を見つけて、「ドロップダウンボタン」をクリックし、「列の削除」をクリックします。<br> レポートから列を削除しても、項目は削除されません。<br>レポートから列を削除しても、項目は削除されません。削除した列を元に戻す場合は、再度追加してください。<br> 列の順序を調整する。左側の「列」リストにある「列」項目を上下にドラッグすると、「列」の配列順を調整できます。<br>行のグループ化と列のグループ化の追加と削除<br>行のグループ化を追加します。ページ左側の「サマリー」にある「行のグループ化」入力ボックスをクリックし、レポートの行グループ化項目を追加して、項目を検索するか、ドロップダウンの項目リストをスクロールしてから対象の項目を選択してデータをフィルタリングします。<br> 列グルーピングを追加する場合は、最大3つまでの行グルーピングを追加することができます。<br> 列グルーピングの追加：行グルーピングが存在する場合、列グルーピングを追加することができます。ページの左側にある「サマリー」の「列のグループ化」入力ボックスをクリックし、検索後に項目を選択するか、項目のドロップダウンリストをスクロールして目的の項目を選択します。 データをフィルタリングするためにレポートの列のグループ化項目を追加するには、ウェイズを選択します。<br> 列グループは2つまで追加できます。列グループを追加する場合は、最大2つの行グループを追加できます。行グループとして追加された項目は、列グループとして追加することはできません。<br>`,
"label.notification.event1":`【任命者】はあなたにToDoを割り当てました`,
"chatter.field":`項目`,
"chatter.feed.menutype.feed.newscom":`フォローしているすべての内容`,
"label.attendance.range":`出席範囲`,
"vue_label_calendar_deleteconfirm":`カレンダー{name}を削除しますか`,
"label.ems.createTask":`新規{taskName}`,
"label.visualpage.wgd":`ファイリングされていないカスタマページ`,
"label.multilang.product.deleterederect1":`下記のレコードに関連しているため、{0}の削除はできません。その場合に、使用禁止を勧めます。`,
"label_emailtocloudcc_filed_servertype":`サーバータイプ`,
"label.umeng.insert.approval.dlsp.approvenew":`#actornameは#objAPIName#recordnameを承認します。`,
"label.tabpage.queue":`キュー`,
"label.approval.step":`承認のプロセス`,
"label.approvaldatamove.approvalprocessname":`プロセス名`,
"label.actualapprovedpeople":`実際の承認者`,
"label.systemlog.f":`失敗`,
"front-template-V1-addText":`テキストの追加`,
"label.chat.like":`お気に入り`,
"label.userinfo.oldpwd.notnull":`現在のパスワードは空であってはいけません`,
"label.service.all.done.major.event":`すべての重大行動を完了した`,
"label_chatter_to":`まで`,
"message.toomuchlinecannotoutput":`選択したレポート列が多すぎるため、レポートは出力できません。`,
"maintenanceasset.assetid.maintenanceplanid.unique":`アセットにメンテナンスプランが割り当てられました。繰り返し割り当てないようにしてください。`,
"lable.quote.syncing.firstsync.description":`見積書の明細は商談商品に代わる`,
"lable.outlook.mcto.saveemail":`メールの添付ファイルを必ず保存してください`,
"label.passwordPolicy.setup.pwdremember2":`2つのパスワードを記憶`,
"label.project.hit.five":`タスクアップデートのお知らせ`,
"label.linkedin.setting.appid":`暗号化キー`,
"label.dataimport.error.name.notnull":`エラー：名前は空であってはいけません`,
"label.knowledge.case.field.selected":`選択されたケースフィールド`,
"label.version.datetime":`{0}件の日付項目`,
"Dashboard_NoAccessRightToSee_Warning":`デフォルトオンに設定されたダッシュボード{0}を参照する権限がありません。他の値に設定する必要があります。`,
"label.login.access.permission":`アクセス権限の付与`,
"label.operatedata.import.tip":`1.導入するファイルは必ずCSV形式で、CSVファイルはタイトルを含む必要で、タイトルがないとインポートできません。2.インポートする前にエクスポートすることを勧めます。エクスポートするフォルダをデータテンプレートしとしてインポートするデータを整理してから、インポートします。（インポートするデータに読点があれば、@でこれに替わります。3.システムはインポートするデータファイルをサーバーに先読みし、バックグランドのバッチ処理を有効化してアプリケーションをインポートします。インポート結果はメールでユーザに通知するため、このアクションページで待つ必要がありません。`,
"workflow.action.tasks.assignortype.rolename":`ロール名`,
"vue_label_account_quotations":`取引先所有者のすべての見積書を移行します`,
"lable.account.CurrentCQ":`現在のカレンダー四半期`,
"label.user.database.error":`データベース?エラー`,
"label_emailtocloudcc_titel":`Email to CloudCC`,
"label_file_content":`本文内容`,
"label.button.behavior":`モデル`,
"message.recordtype.new.tip":`詳細情報の入力`,
"label.ccchat.message.new.error3":`エラー：9つ以上の受信者を選択することができません`,
"vue_label_commonobject_notice_lessthanwords":`ファイル名は{FILE_NAME_COUNT}の文字以下です。`,
"label.stacked.verticalline":`積み重ねた図形－カラムレベル`,
"vue_label_SMS_messagebox":`ショートメッセージボックス`,
"label.appexchange.installedpage.message3":`インストール済みパッケージの横にあるリンクにより、このページから別のアクションを実行することができます。パッケージを削除するには、[アンインストール] をクリックします。パッケージのライセンスを管理するには、[ライセンスの管理] をクリックします。`,
"label.unusedapproveprocess":`有効になっていない承認プロセス`,
"label.onlywithspecificconditions":`この集計は特定条件のレコードのみ含みます`,
"lable.outlook.mcto.formaterror":`表示形式エラー`,
"label.area.parent":`上位エリア`,
"vue_label_chat_activesuccess":`有効化に成功しました`,
"label.setting.intergrationlist.button.upgrade":`更新`,
"label.page_hidden":`秘伝フィールドの登録ページ`,
"label.customsetting.manage.belong":`所有者の設定`,
"label.appointment.wizard.subtitle4-2-8":`7日間`,
"template.chart.ydywjhxsje":`月間ビジネスオポチュニティ販売額`,
"label.multilang.currencylist.after":`{0}の後に`,
"vue_label_commonobjects_view_chart_countby":`合計の根拠`,
"label.week":`週`,
"label.emailtemplate.name":`テンプレート名`,
"label.umeng.sign":`サインイン済み`,
"label.appupload.upload.details":`詳細情報`,
"label.file.loading":`アップロード中`,
"label.newdetail.orgTitle":`取引先責任者リレーションシップ`,
"label.salescloud.field.addoptionlist":`選択リスト値の追加`,
"pagecreator.page.funcpath":`/ ビルダー/ページリスト`,
"Account.News.Setting.001":`取引先の設定`,
"label.marketsea.getnoconversiondays":`日間置換えていない（取得後のフォローしていない日数以上である必要）`,
"message.error.event.add":`新規行動に異常が発生しています`,
"front-electronic-export-choseChimp":`エクスポートされたMailchimpリストを選択してください。`,
"vue_label_report_personothers":`その他のメンバー`,
"label.hierarchy.diagram":`階層図`,
"label.stdashbord.xsld.business.yqsr":`期待収益`,
"label.chat.topic.max.count":`トピックスの最大件数に達しました`,
"label.sendemail.send.sendfail":`メールの送信に失敗し、管理者に連絡してください。`,
"registration.page.body.title":`登録ページ`,
"label.userphoto.back":`キャンセル`,
"label.service.without.timeslot":`タイムスロットがないようです。今はいくつか追加しましょう。`,
"label.processsetting.remaining.quantity":`最大255までの文字が入力することができます。残りの数：`,
"label.sure.delete":`削除の確認`,
"front-epwechat-module-v1-callback":`コールバック設定`,
"front-email-payment-failed":`申し訳ありませんが、支払いに失敗しました。`,
"label.icon.67":`機械`,
"UG_Forcast_01":`予測`,
"label.escalation.setup.newentries.step3":`ステップ3.グレードアップ時間の設定方法を指定`,
"lable.account.NextCY":`次回のカレンダー年度`,
"report.type.label.quote":`見積`,
"label.area.name":`エリア名`,
"component.setup.label.object":`オブジェクト`,
"label.customsetting.type":`設定種別`,
"label.showdetail":`詳細情報を表示`,
"label.department.prev":`前のページ`,
"label.select.data.source.report":`データソースレポートをご選択ください`,
"UG_homepage_002":`一体化した業務システムを使って、手がかり、リード、セールスファネル及び取引先情報を管理する`,
"vue_label_report_notice_exprot1":`詳細情報の行のみがエクスポートされます。このデータを使って、より多くの計算をしたり、他のシステムにアップロードします。単一ページは最大5000件までがエクスポートできます。`,
"message.error.task.phonecreate":`電話ToDo作成に異常が発生しています`,
"label_chatter_day":`日`,
"label.setinitialcommiter":`ステップ6.初期提出者の指定`,
"message.huanxinconfig.notfound":`Easemobの設定が見つかりません`,
"label.customfields.file.count.tip":`この項目に入力可能なファイル数を入力してください。デフォルト値は1です。`,
"label.weixin.appmanage":`アプリケーションの管理`,
"label.approverautoconfirm":`承認者の自動的な確認方法`,
"vue_label_CCChat_followers":`フォロワー`,
"label.usermanage.notselect":`未選択のユーザ`,
"label.item":`件`,
"label.sendemail.chat.linkurl":`リンクURLは`,
"label.sendmail.step3.deliveroptions":`オプションの提出`,
"homepage.components.creationtime":`作成日`,
"label.pc.ui.2018.ccchat.setting":`CCChat設定`,
"label.knowledge.search.result.highlight":`検索結果で関連文章をハイライトで表示します`,
"label.data.downpage.e.title.num2":`2、単一オブジェクトデータをエクスポートする場合は、データエクスポート方式を選択する必要があります、その方式にはカスタムエクスポート、テンプレートによるエクスポート、テンプレートのエクスポートがあります。`,
"label.field.duplicate.error.msg1":`重複データがありますので、重複データを処理した後、独自のプロパティを設定してください。`,
"label.campaign.channel.input.number.error":`数値形式エラー`,
"label.goto.dashboard":`ダッシュボードに切り替え`,
"com.cloudcc.login.error.message.invalid.ip":`IPはログイン範囲内にありません`,
"label.selectnewfieldvalue":`新しい項目値の指定`,
"label.appointmentdetail.wizard.title11":`終了日`,
"Opportunity_Detailed_Phase_Label_Popup_001":`現在の段階の開始時間`,
"front-dynamiclayout-module-v1-readonly":`required}のフィールドは、Read Onlyに設定されています。`,
"vue_label_calendar_start_field":`開始項目`,
"label.weixin.recalculate.shared.failed":`オブジェクトの共有ルールの再集計に失敗しました`,
"label.sendmail.step3.dealoptions":`オプションの処理`,
"setup_layout_label_modifypage":`編集ページ`,
"homepage.components.select.wide":`*状況`,
"label.import.page1.laststep":`前のステップ`,
"label.weixin.donot.permission":`このアクションを執行する権限がありません`,
"message.error.name.null":`nameは空にしてはいけません`,
"label.salescloud.teamrole.optionlist":`チームロールの選択リスト値`,
"component_setup_label_titlefield":`タイトル項目`,
"vue_label_commonobjects_detail_have_been":`ためにされています`,
"label.textmessage.vonage.setup":`Vonageのセットアップ`,
"label.recordtype.profile.enableit":`プロファイルのために有効化します`,
"UG.product.04":`製品の作成`,
"label.knowledge.No.related.articles":`関連記事はありません...`,
"label.chat.muted":`通知の鳴動制限`,
"registration.page.field.selection":`登録画面項目の選択`,
"label.project.hit.eleven":`アサインメント通知の発行`,
"lable.newtabpage.advsearch":`高度な検索`,
"label.report.share.roleandsub":`ロールと下位ロール`,
"component.salesperformance.label.nodata":`商談を追加しここに戻って、パフォーマンスグラフを参照します。`,
"label.submitted_on":`投稿日`,
"label.file.create.link":`リンクの作成`,
"label.contact":`取引先責任者`,
"label.tab.message.failtoopenleft":`左カラムでマージ操作でを開くことができなかった`,
"label.replaces":`置換`,
"label.customcomponent.check.tag.startwith":`翻译存疑`,
"label.tab.web":`Web タブ`,
"message.success.task.add":`新規ToDo情報の保存に成功しました`,
"label.chatter.addresser":`送信者`,
"label.mobile.homepage":`トップページ`,
"label.data.imp.su.ok":`システムはインポート中`,
"label.knowledge.category.hint.one":`カテゴリーグループとは、データのカテゴリーを階層化したものです。例えば、「場所」というカテゴリーグループには、大陸、国、地域、州という地理的な階層が含まれていることがあります。このページでは、カテゴリーグループとサブカテゴリーの管理を行います。`,
"label.schedulejob.setup.schedule.weekly":`毎週`,
"label.tag.manage.description":`｛0｝に関連するすべての表示ラベルを以下のようにに示されています。利用可能な表示ラベルの名前を変更したり、削除したりすることができます。`,
"label.tabcontrol":`タブ`,
"label.field.duplicate3":`「ABC」と「abc」を重複値と見なします（大文字と小文字は区別しない）`,
"label.customsetting.type.list":`リスト`,
"lable.account.ovdate":`四半期決算の終了日`,
"label_chatter_pastSevenday":`過去の7日`,
"front-kefu-moudle-v1-lxndxsdb-free":`営業担当者に連絡して、フリーエージェント・サービサーを有効にしてください。`,
"label.termsforusage":`使用条項`,
"label.forecast.settings.qijian.m":`毎月の予測`,
"label_tabpage_viewname":`ビュー名`,
"label.report.action.addtodashboard1":`ダッシュボードに追加`,
"label_vue_create_edit_obj_create_event_dialog_desc":`割り当てられたユーザーは、すでにスケジュールに参加しています。`,
"vue_label_report_standardfilter":`スタンダートフィルター`,
"label.umeng.approval.submit":`#applyerは#objの承認申請を提出しました`,
"label.tab.mobile.sign":`モバイル端末のアイコン`,
"vue_label_commonobjects_detail_check_the_content":`認証エラーが発生しています、内容を確認してください`,
"UG_Campaign_001":`予定のキャンペーン`,
"chatter.group.baseInformation":`一般情報`,
"label.sendemail.send.noreceiver":`受信者がいないか、または受信者のメールアドレスはNULLです`,
"template.chart.yskje":`受領額`,
"label.textarea":`テキストエリア`,
"vue_label_statistics_value":`統計値`,
"font-evaluate-module-v1-select-img":`画像の選択`,
"label.totalof":`合計で選択した数`,
"label.hangye":`業界`,
"label.partner.common.setup":`一般設定`,
"label.icon.78":`農業`,
"lable.outlook.detail.addemail":`メールの追加`,
"label.ServiceCloud.fuwuquyu":`サービス地域`,
"label.gb2312encoding":`簡体字中国語(GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10分`,
"label_emailtocloudcc_reauthorization":`再付与`,
"label.approval.message":`承認コメントは最大1000文字までです`,
"label_component_helper":`助手`,
"label.editRate":`為替レートの編集`,
"label.setuptemplate":`自動化テンプレート`,
"label_emailsync_button_cancel":`キャンセル`,
"label.marketseamemset.account.maxuser":`最大の取引先数`,
"label.someerror":`セキュリティー上の理由で、 CloudCC のダイアログは時間切れになりますが、<br><br>どう選択しますか。`,
"label_person_in_charge":`責任者`,
"label.visualpage.reference.standard.style":`プラットフォームスタンダードスタイルを引用、customize-カスタマスタイル`,
"errormessage_email_relatedorreceivermusthaveone_z":`受信者と関連先をどっちか1つ選んでください`,
"label.insert.field.empty.continue":`resDataField}】の値がvoidのレコードが存在するため、コードを生成できません。生成を続行しますか？`,
"component.newrecords.label.title":`最近のレコード`,
"template.detail_info_link":`詳細情報リンク`,
"component_setup_tabs_label_default":`デフォルトページ`,
"label.emailobject.template.name.null":`メールテンプレート名は空であってはいけません。`,
"label.knowledge.field.changed":`{1}を変更`,
"homepage.components.select.narrow":`表示されるナローコンポーネントを選択してください`,
"label.mobile.phone.week":`何週目`,
"component_chatter_button_like":`いいね`,
"label.brief.won":`合意`,
"label.setup.profile.replaceme":`「私に関して」を置換`,
"label.knowledge.setting.enable.lightning":`ライトニング・ライブラリの有効化`,
"label.middle":`中`,
"label.icon.109":`人`,
"vue_label_normal_activity_sf":`活動`,
"chatter.poll.option6":`選択肢 6`,
"label.lanxin.setting":`Lanxin H5 MiniAppの統合`,
"label.stdashbord.xsld.business.totals":`業務状況の集計`,
"label.emailobject.emaildetail.promptbutton1":`確認`,
"Opportunity.Detailed.Phase.Label.001":`ステージ`,
"label.customcomponent.params.info":`パラメータの使い方`,
"label.emailtocloudcc.button.next":`次のページ`,
"front-email-payment-billing-date":`請求書発行日`,
"label.ems.with3day":`3日間以内`,
"label.project.subtask.date":`サブToDoの日付は、属するToDoの日付範囲内でなければなりません。`,
"label.role.allunselectanduseduser":`すべての割り当てられない有効になっているユーザ`,
"front-kefu-moudle-yes-wantbuy":`はい、購入したいです。`,
"label.looking_for":`求めていたものは手に入りましたか？`,
"page.404.label.noresource":`すみません、アクセスするリソースは存在しません。`,
"vue_label_ccchat_notice_deletecommentcertification":`このコメントを確かに削除しますか。`,
"label.data.setok.e.desc1":`エクスポートに成功した後、システムのお知らせメールが送られます。エクスポートされたデータは48時間しかサーバーに保存されません。できるだけ早くしてください`,
"label.weixin.confirm.delete":`確かにこのデータを削除しますか。`,
"A":`テキストエリア (リッチ)`,
"template.report.sales.cycle":`セールスサイクル期間`,
"label.service.shift":`シフト`,
"label.visualpage.display.side.bar":`サイドバーを表示、false-サイドバーを非表示`,
"label.list.userinterface.chatter.showall":`トップページ CCChat にあるすべて書き込みのデフォルト表示`,
"vue_label_systemSettings_set_course":`各ステージにTIPSを追加し、段階的にユーザーを誘導することで、パスを設定する。`,
"label.icon.156":`人`,
"label.marketsea.button.move":`移行`,
"front-email-payment-select-email":`郵便番号を入力してください。`,
"front-electronic-signature-service-provider":`サービスプロバイダー`,
"label.h5.add.checkin":`サインイン`,
"vue_label_amount_total":`合計金額`,
"label.campaign.channel.new":`キャンペーン：新規販売チャネルの作成`,
"label.knowledgebase.restore.creates.draft":`復元すると、現在のバージョンからドラフトが生成されます。そのドラフトを誰でも見られるように公開する必要があります。`,
"UG_Case_01":`ケース`,
"label.validate.function.funcExplain.CONTAINS":`テキストに特定の文字があるかどうかチェックし、そうであればTRUEを返し、そうでなければFALSEを返します。`,
"label.data.exp.savetemp":`別称でテンプレートに保存`,
"front-project-module-v1-template-newcreate":`プロジェクトテンプレートからプロジェクトを作成`,
"label.field.default.count":`デフォルト行数`,
"page.note.acc":`メモ&添付ファイル`,
"label.close":`クローズ`,
"label.app.detailbeforeedit":`以下はカスタマアプリケーションの情報です。[カスタマアプリケーションの更新]をクリックして編集します。`,
"label.profile.standardfieldsafety":`標準項目レベルセキュリティ`,
"vue_label_report_notice_deletefilter":`まず高度なフィルター条件を削除してください`,
"label.multilang.datamoveaction.movesuccess":`{0}件のレコードは移行に成功しました！`,
"label.emailmerge.edittemplate.descirption":`差し込み印刷テンプレートに関する情報を入力してください。説明は Salesforce でのみ表示され、Word では表示されません。`,
"label.visualpage.at.the.end":`終了のところにマークをつけます`,
"label.exchange.sync.state":`Exchange Sync 状況`,
"label.newdashboardpage.new":`一行を追加`,
"label.querydetailservice.profile.notsetup":`アカウントが対応するプロファイルが設定されていません`,
"label.escalation.setup.detail.description":`ルールエントリーを作成し、この中で指定された条件に基づき自動的にケースをグレードアップします。ルールエントリーを作成した後、このページで再並び替えることができます。`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`モバイル端末はH5の新規編集を有効化しますか。`,
"vue_label_file_upload_tip_msg":`ファイルが30MB以下のファイルのアップローをおススメします。そうでなければ、ページの読み込みが遅くなる可能性があります`,
"label.eowechat.epdeptid":`ウィーコム部門ID`,
"label.adminorapprover":`管理者と現在の承認者`,
"label_emailtocloudcc_email":`メール`,
"setup_main2018_label_norole":`システム管理権限がありません`,
"label.onlyone":`一意`,
"label.sso.saml.idp.config.nameidtype":`オブジェクトタイプ`,
"vue_label_normal_campaign_sf":`キャンペーン`,
"label.icon.61":`クレーン`,
"label.datatype":`データ型`,
"label.mobile.home.page.today.work":`私の仕事`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat あなたのコメントが気に入りです`,
"chatter.sel.p":`0人をすでに選択しました`,
"label.b_c":`BからCまでの関係`,
"label.tabcontrolnameandtaglib":`タブ名と表示ラベル`,
"label.globaloperation.tip":`詳細情報ページで、グローバルアクションの作成、編集、参照ができます。`,
"R":`レコードタイプ`,
"label.initcommiteoperate":`初期提出アクション`,
"front-kefu-moudle-v1-Operation-without0-permission":`このレコードの操作は許可されていません、管理者にお問い合わせください`,
"button_partner_create":`作成`,
"label.document.name.length.cannot.than":`ドキュメントの長さは255文字を超えてはいけません`,
"label.area.donot.delete":`エリアは下位エリアを持っているため、削除できません。`,
"label.currency.activation":`アクティブにします`,
"label.connect":`&連続`,
"button.partner.viewdetail":`ビュー`,
"setup_object_field_dependency_label_mustsetup":`項目連動関係を設定してから、保存してください。`,
"label.SalesCommitmentKanBan.task":`ノルマ`,
"lable.quote.syncing.finishbutton":`完成`,
"label.weixin.group.type":`アクセス種別`,
"vue_label_commonobjects_detail_relationship":`関係の度合い`,
"vue_label_email_cc":`BCC`,
"setup.object.field.dependency.label.fieldvalueoptions":`選択可能な項目値`,
"label.sso.lookAtTheKey":`秘密鍵を表示`,
"UG.opportunity.008":`商談チーム`,
"label.customfields.new.step1":`ステップ1.項目種別の選択`,
"lable.qrcodeOrbarcode.rule":`QRコード/バーコードの生成ルール`,
"vue_label_notice_nopermission_delete":`申し訳ありませんが、このレコードを削除する権限がありませんので、管理者に連絡してください。`,
"label.customerobj.tab":`カスタマオブジェクトタブ`,
"com.cloudcc.login.error.message.nolicens":`ライセンスが存在しない`,
"label.sendsms.batch.confirm":`SMSの一括送信：確認`,
"label.forecast.settings.sos":`収入と数値`,
"label.calendar.addevent.notice.opencalendarfirst":`イベントを追加する前に、私のカレンダーや他のカレンダーを開いてください。`,
"message.success.task.phonerecord":`通話記録の保存に成功しました`,
"label.knowledgebase.create.new.subtab":`新規サブタブ`,
"label.knowledge.article.recordid":`知識記事のIDは空にしてはいけません`,
"Opportunity.Detailed.Phase.Label.Popup.003":`現段階での日数`,
"homepage.layout.nowpage":`現在のページレイアウト`,
"template.chart.khslph":`アカウント数 ランキング`,
"front-epwechat-module-v1-android-single":`Androidシングルサインオン。`,
"serviceresource.assignedresource.islacksr.lack":`サービスリソースにサービス予約が割り当てられていますので、サービスリソースを削除できません。このサービスリソースを有効にしなくてもいいです。`,
"label.email.only.display.info":`次のボックスには、メールアドレス、取引責任者または同僚が保存されています。`,
"label.weixin..xsld.yjhtje":`予測の契約金額`,
"label.permission.delete.permsets.error.prompt":`権限セットには割り当てられたユーザーがいるため、削除できません。`,
"label.ccchat.enter.two.choices":`2つ以上のオプションを入力してください`,
"label.edit.field.select.style2":`オプションごとに1行で表示します`,
"vue_label_email_please_enter_email_subject":`メールの件名を入力してください`,
"batch.sendemail.f":`メール送信失敗`,
"label.sms.senderr":`SMS送信失敗`,
"label.batchadd.newbatchpage.save.em":`メール形式は不正確です`,
"label.icon.96":`方位磁針`,
"message.recordtype.deleterecord.tip":`このページでは、すべての既存レコードタイプを新規レコードタイプに置き換えます。以下の枠で、削除されたレコードタイプを含むいずれのレコードに応用するには、代替のレコードタイプを選択します。新規レコードタイプでこのレコードタイプを置き換えるのではなく、既存レコードからこれを削除するだけでは、"なし"を選択してください。`,
"label.field.edit.max":`最大評価`,
"label.partnerCloud.orderingPlatform.preferential":`割引`,
"label.callcenter.login.later":`後でログイン`,
"batch.change.owner":`所有者をご選択ください`,
"label.version.allow.upload.size":`アップロードするファイルの最大サイズは`,
"setup.mainpage.label.welcome17":`権限の設定`,
"label.tag.sectionname":`表示ラベルの情報`,
"label_partner_workspace_setup":`設定`,
"label.managecontrol":`システム管理者権限`,
"label.timetrigger.condition":`評価条件は作成されたとき、および編集されるたびに設定されます`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`週間`,
"front-verkoop-bywerking-error":`アップデートの失敗`,
"label.allowcommittercallback":`提出者による承認申請の呼び戻しを許可`,
"vue_label_commonobjects_detail_lead_finishistatus":`ステータスを完了にマークします`,
"message.error.object.lookupmd":`オブジェクトは主な詳細リレーションを作成した`,
"label.stdashbord.xsld.business.img7":`可能性が100%の段階にある件数（可能性が100%段階の件数＋可能性が0%の段階にある件数）`,
"label.checkruleofevent":`行動の入力ルール`,
"front-epwechat-module-v1-single":`シングルサインオン`,
"label.tabpage.save":`保存`,
"label_emailtocloudcc_search":`検索`,
"label.tianyancha.h5.registeredPlace":`登録地（略称）`,
"label.field.addoptionlist":`選択リスト値の追加：選択リスト`,
"label.schedule_anotherpost":`他の投稿を計画する`,
"label.customfields.searchrelation.tip":`このオブジェクトと別のオブジェクトをリンクするリレーションを作成します。この項目によって、ユーザはルックアップアイコンをクリックして表示されるポップアップリストからレコードを選択できます。リストには指定したオブジェクトのレコードが表示されます。`,
"label.partnerCloud.partnerAccount.prepaidPhone":`アカウントトップアップ`,
"label.projectManagement.view.details":`詳細情報の表示`,
"label.sendemail.chat.praiseFeed":`#name様:\n\n    こんにちは。#userName様はあなたの書き込みをお気に入りに追加しました。`,
"label.validate.function.category.Text":`テキスト`,
"component.task.label.newevent":`新規ToDo`,
"label.data.import.setup.operate":`既存レコードが見つかる場合、どんな操作を行いますか。`,
"label.salescloud.salesdashboard.clear.option":`オプションのクリア`,
"lable.account.PreviousCY":`2つまでのカレンダー年度`,
"label.appointment.wizard.subtitle8":`招待者に見える会社名`,
"label_emailsync_status_viewlog":`ログの参照`,
"message.duplication.label.filtertitle":`重複検索条件`,
"label.custom.quarter.description":`このページでは、カスタム四半期を定義・編集することができます。カスタム四半期の日付は、以下の選択肢に基づいて生成されます。`,
"label_tabpage_filenamez":`ファイル名`,
"lable.currencyAdv.andbefordate":`と　その前の日付`,
"label.version.nonsupport.sharerule":`共有ルールを暫くサポートしません。`,
"front-epwechat-module-v1-unbound":`アンバインド`,
"label.division":`支部`,
"label.data.import.setup.repeat":`重複レコードの作成を阻止しますか`,
"label.callcenter.makesure.Amazon.connect":`注：Amazon Connectのインスタンスが作成されていることを確認してください。`,
"label.version.lead.control":`リードの管理`,
"label.copying.reward.groups":`見積り行グループのコピー`,
"#label.severalorone":`圧縮あるいは個別のファイル`,
"label.mailinginfo":`郵送先`,
"component.telerecord.label.title":`通話履歴`,
"label.godocumentlist":`フォルダリスクに戻る`,
"APPIntegration.Dropbox.setting.01":`有効化`,
"label.tianyancha.website":`URL`,
"label_tabpage_greaterequalz":`より大きいorイコール`,
"vue_label_campaign_influencedopportunity":`商談に影響します`,
"message.save.param.null":`パラメータはNULLで、保存に失敗しました`,
"front-epwechat-module-v1-domain":`信頼できるドメイン名JSSDK：。`,
"label.allowreport":`レポート許可`,
"label.service.major.event":`重大行動`,
"label.import.index.selectobjectandfiles":`オブジェクトとファイルの選択`,
"label.chatter.task":`ToDo`,
"label.knowledge.setting.hint.twelve":`データカテゴリの入力`,
"lable.account.CurrentandPreviousFY":`現在と前回の会計年度`,
"label.martrixreport.step3":`ステップ3：集計情報の選択`,
"front-console-select-cases":`選択したケース番号が10を超えることはできません。`,
"label.partnerCloud.partnerAccount.backHome":`ホームページに戻る`,
"label.me.assign":`私が割り当てた`,
"label.appointment.wizard.subtitle3":`集合時間`,
"label.edit_columns":`コラムの編集`,
"label.partnerCloud.orderingPlatform.useRebates:":`リベートを使う`,
"label.projectManagement.enter.up.to.10.digits":`最大10桁まで入力できます`,
"label.integrations.description.mailchimp":`CloudCCとMailchimpを統合することで、CloudCCアカウントから選択したリードやコンタクトをMailchimpにインポートし、意図した受信者にメールを送信することができるようになります。`,
"label.ccchat.person.error.requiredomain":`エラー：1つ以上のドメインが必要です`,
"label.projectManagement.Pleaseselectitem":`プロジェクトを選択してください`,
"label.netaccess":`ネットワークアクセス`,
"vue_label_SMS_searchobject":`オブジェクトの検索`,
"label.role.viewintree":`ツリー形式で表示`,
"lable.SalesCommitmentKanBan.accountName":`取引先名`,
"label.please.contact.your.administrator":`QRコード/バーコードを生成するためのルールを有効にするには、管理者にお問い合わせください。`,
"label.sso.saml.sp.idenitysource":`SAML アイデンティティロケーション`,
"label.queue.delete":`削除`,
"label.service.miniProgram.jumpLink":`リンクへジャンプ`,
"label_set_ forecast_scope":`予測範囲の設定`,
"label.weixin.success.sign":`すでに到着してサインインしました。ご了承ください。`,
"front-dialog-module-v1-error-code":`エラーコード`,
"label.projectManagement.nodata.problem":`素晴らしい！解決する必要がある難しい問題がありません。`,
"label.myhomepage":`私のトップページ`,
"label.exchange.sync.state.task.m1":`前回の同期活動`,
"label.pw.config":`パスワードを確認してください。`,
"front-console-new-contact":`新規コンタクト`,
"label.customfields.fielddependency.editexplain":`<li>列タイトルのコントロール項目値の表示を切り替えるよう、あるセルをダブルクリックします。</li><li>複数のセルを変更するには、複数のセルを選択し、「含む値」或は「除く値」ボタンをクリックして、選択したすべてのセルの表示を同時に変更します。</li><li> Shift ボタンを押しながら、一連の隣接するセルをクリックして選択します。 Ctrl ボタンを押しながら、複数の隣接しないセルをクリックして選択します。</li><li>「プレビュー」ボタンを使用して、結果を予測することができます。 </li>"`,
"setup_mainpage_label_welcome7":`アクションガイド：このページの右側のメニュー → アプリケーションの設定 → 作成 → オブジェクト → オブジェクト名 → カスタマ項目をクリックしてください。`,
"message.validation.sum":`承認ページレイアウトで表示される項目は多すぎで、最大190までです。`,
"label.knowledge.attach.case":`ケースに取り付ける`,
"front-electronic-signature-custom-field-type":`カスタムフィールドタイプ`,
"vue_label_pricebook_activated":`価格表が有効になりました`,
"vue.schedule.pre":`これが私のスケジュールです、どうぞ`,
"Lead_Tools_BatchScoring":`リードの一括スコアリング`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Filter By`,
"label.report.no.recently":`最近のレコードはありません`,
"label.service.gantt.dangerous.sum":`危険な状態にあるサービス予約数`,
"label.main.field":`プライマリーフィールド`,
"label.weixin.optionfive":`選択肢 5`,
"homepage.wide":`ワイド（右）カラム`,
"vue_label_notice_confirmdelatehomepage":`ホームページを確かに削除しますか。`,
"vue_label_report_exportpages":`エクスポートしたページ数：第`,
"label.select_compaign":`キャンペーンの選択`,
"attachment.button.massdownload":`一括ダウンロード`,
"label.chatter.incident":`行動`,
"label_partner_new_step1":`ステップ1.好きなテンプレートの選択`,
"button.partner.workspace.saveas.memo":`当該パートナークラウドを別称でテンプレートに保存します。`,
"vue_label_pricebook_edit":`価格表の編集`,
"label.weixin.privacy.rights":`プライバシー関連の権限：大体の位置情報（ネットワークに基づき）、正確な位置情報（GPS）`,
"label.please.codeType":`コードタイプを選択してください。`,
"label.approveorrefuserequest":`承認/申請却下`,
"message.error.sharemember":`転送するsharememberシェアメンバーは空にしてはいけません。転送のパラメータを確認してください。`,
"label.file.folder.edit":`フォルダ名を変更`,
"label.data.import.setup.repeat.yes":`はい-重複レコードの作成を阻止します。ご注意：既存レコードを更新するなら、このオプションを選択する必要があります。`,
"label.approveBeforeTheOperation":`承認前のアクション`,
"vue_label_file_already_checked_file":`{checkedWork}個のファイルを既に選択しました。毎回最大10個までのファイルを追加することができます。`,
"vue_label_hidden_record_count":`レコード数の非表示`,
"UG_product_01":`商品とサービスのリスト`,
"label.tabpage.clearoptionsz":`高度なオプションをクリアします`,
"label.partnercloud.num.overstep":`パートナークラウドの最大数を超えました。`,
"label.tianyancha.businessverify.msg8":`この機能は中国本土に登録した企業の検証のみサポートし、少し遅延することもあります。`,
"Lead_Scoring_DetailedPage_Popup_Title":`リード観察`,
"label.emailtocloudcc.email":`電子メール`,
"vue_label_pool_highcost":`製品コストが高い`,
"label.callcenter.enterprise.configuration":`TianrunのシステムのEnterprise ConfigurationSystem Interconnectionのキーペアをコピーしてください。`,
"label.view.edit.search.prompt":`キーワードを入力してください`,
"label.ems.sms":`ショートメッセージの送信`,
"label.emailobject.list.new":`メールの作成`,
"label.salescloud.forenableteamsales":`チームセリングの有効化`,
"pagecreator.systemstyle.funcpath":`/ ビルダー/ブランドスタイルライブラリー`,
"label.partnerCloud.basicSetting.domain":`トップレベルドメインは空にできない`,
"label.projectManagement.Posttask":`ポストタスク`,
"label.tianyancha.businessverify":`企業データ認証を有効化`,
"label.tianyancha.h5.info":`一般情報`,
"september":`九月`,
"chatter.poll.option9":`選択肢 9`,
"label.department.firstpage":`最初のページです。`,
"label.reportsSubscriptionPage.condition.button":`条件の追加`,
"label.exchange.sync.state.task":`ToDo`,
"pagecreator.layout.button.splitall":`所有の分割`,
"vue_label_calendar_please_select_the_start":`開始項目を選択してください。`,
"label.tab.message.failtogettop":`トップタブの取得に失敗しました`,
"label.sharerule.organizationscopesetshare":`組織のデフォルト共有設定`,
"label.delete.rules":`ルールの削除`,
"label.recordtype.tabname.detail":`[編集]ボタンをクリックしてレコードタイプのプロバイダを更新します。[選択リスク値]関連リスク中の[編集]リンクを使用して、レコードタイプに使用可能な選択リスク年を選択します。`,
"label.knowledge.setting.hint.ten":`オーグニッション・モードがわからない？問題ありません。後で実行することができます。`,
"vue_label_norm_undone":`この操作は撤回できません`,
"label.trigger.line":`行：`,
"lable.info.queue.reason":`メンバーになった原因`,
"label.validate.function.funcExplain.HOUR":`日付/时间項目の時間（0~11の数字）に戻る。`,
"label.update.document.content":`フォルダ内相を修正しました`,
"lable.Existing.template":`利用可能なテンプレート`,
"label.summaryreport.step3":`ステップ3.集計情報とグループ化方式の選択`,
"label.emailmerge.list.filetype":`ドキュメント種別`,
"label.customfields.helptext.tip":`ユーザがこの項目の隣の情報アイコンにフロートするとき、このテキストは商談情報ページと編集ページに表示されます`,
"label.setting.intergrationlist.description":`CloudCCイングレーションを通じて、CRMを離れなくても、ビジネスアプリケーションの間で、データの表示と共有もできます。QuickBooks、Zapierなどのようなイングレーションは、ユーザが権限を授与されてから利用できます。またGmail、Outlookのようなイングレーションは、各ユーザのアカウントで構成されます。`,
"component_milestones_label_title":`里程標`,
"label.custom.AntiRevocation":`キャンセル 元に戻す`,
"label.mobile.app.new.task":`モバイル端末はApp版を有効化して、新規ToDO&行動を作成しますか`,
"vue_label_opportunity_related_chooseproduct":`製品を少なくとも1つ選択します`,
"label.standardguest":`標準取引先`,
"label.icon.125":`楽器`,
"label.skipsomeset":`これはジャンプスタートウィザードで、cloudcc は自動的にいくつかの設定を選択します。`,
"label.forecast.shrepage.fmanager":`予測マネージャー`,
"label.mobile.quickcreate.default.work":`オフィス`,
"label.projectManagement.nodata.team.members":`私のプロジェクトメンバーが見つかりません`,
"label_social_media_account_settings":`ソーシャルメディアアカウントの設定`,
"UG.quota.05":`商談との双方向同期`,
"label.partner.workspace.tab.selectedoption":`選択済みのタブ`,
"front-kefu-moudle-v1-clientID-reinput":`クライアントIDを入力してください。`,
"label.mobile.home.page.contract.value":`予測契約金額`,
"december":`十二月`,
"label.campagin.roi.dcrs":`出席人数`,
"label.currency.edits":`通貨種類を編集`,
"label.currency.company":`会社の通貨種類`,
"label.customfields.newformula.nogrammererror":`エクスプレッションに構文エラーがありません。`,
"label.version.nonsupport.api":`APIインターフェスをしばらくサポートしません`,
"label.data.file.i.title.num2":`2.データをインポートする際には、エクスポートするドキュメントをテンプレートとして、インポートするデータを照合してからインポートすることをお勧めします。(インポートデータにコンマが含まれている場合は、@マークに置き換えてください)。`,
"front-console-conversation-title":`サービス評価`,
"front-kefu-moudle-call":`コール`,
"vue_label_systemSettings_pagefooter":`フッター設定`,
"label.newRule.successfully.added":`新しいルールの追加に成功しました。`,
"label.trigger.direction.for.use":`プラットフォームトリガーのマニュアル[バージョン2.0]`,
"label.instrumentPanel.maxLabelname":`この値は最小値、ブレークポイント1の値、及びブレークポイント2の値より大きい必要があります。`,
"label.same.month.report":`前年同期比・前月比レポート`,
"label.knowledge.language.american":`アメリカ英語`,
"label.paging.totalof":`{0}件`,
"label.tianyancha.businessverify.enable.error":`企業データ検証の獲得に失敗し、システム管理者に連絡してください。`,
"vue_label_commonobjects_detail_email_template":`メールテンプレートの使用`,
"message.error.save.failed":`保存に失敗しました！`,
"advancedoptions":`高度なオプション`,
"setup_object_layout_message_selectedlayoutandrecordtype":`レイアウトとレコードタイプを選択してください`,
"label.sendemail.recycle.operatesuccess":`ゴミ箱を空にしました。#size件のデータを削除しました。`,
"J":`テキストエリア（ロング）`,
"message.validation.isnotmail":`正しいメールアドレスを入力してください`,
"label.timetrigger.before.lasttime":`最終更新日より1時間早い`,
"label.tabpage.arecordtypez":`使用可能なレコードタイプ`,
"label.reportoption":`レポートオプション`,
"pagecreator.button.next":`次のステップ`,
"assetbom.transferowner.notpermission":`アセットBOMを移行する権限がありません。管理者に連絡してください。`,
"label.toptitle.lightning":`ライトニングメニュー`,
"label.copy.target":`クローン指標値`,
"label.productsales.oppor.approach":`近づく商談`,
"label.email.template.select":`メールテンプレートをご選択ください`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`各割引レベルの編集に必要な下限値。`,
"label.tabularreport.step3":`ステップ3.レポートの各リストの順番を確認`,
"label.multilang.cchttpservice.signin":`{0}様：{1}活動に招待したお客の{2}様はすでに到着しサインインしました。ご了承ください。`,
"label.appexchange.uninstallpage.message3":`当該パッケージのカスタマオブジェクトが作成したすべてのデータを完全に削除します`,
"label_tabpage_ownedz":`共有`,
"label.tabularreport.2018.step2":`ステップ2.レポート標準の選択`,
"label.object":`オブジェクト`,
"template.report.contracted.customers":`契約アカウントの業界分析`,
"label.field.remark3":`(注意) カスタム項目を削除すると、その項目を使用している条件が削除されます。また、その項目の値を使用している割り当てルールやグレードアップルールの動作も影響を受ける可能性があります。`,
"label.eventview.issms":`SMSアラート`,
"label.knowledge.language.brazilian":`ポルトガル語（ブラジル)`,
"vue_label_norm_viewfilter":`ビューのフィルター`,
"label.forecast.settings.qijian":`予測期間`,
"label.startuploadfile.step.intruduce":`[ファイルの選択]をクリックしてファイルを検索し、選択したファイルを下記エリアで表示します。`,
"label.smstemplate":`SMSテンプレート`,
"vue_label_chatter_no_permission":`このファイルを表示する権限がありません`,
"label.callcenter.Incorrect.data.filling":`データの入力に失敗しました`,
"label.tag.search.button":`表示ラベルによって検査します`,
"label.multiplyselectoptions":`チェックボックス選択肢`,
"lable.outlook.detail.mutual":`双方向同期`,
"label.workflow.estimatecondition1":`作成されたとき、およびその後基準を満たすように編集されたとき`,
"label.validate.globalvariable.user.profileId":`プロファイルID`,
"UG.Campaign.003":`キャンペーンの作成`,
"label.validate.function.funcExplain.ISNULL":`エクスプレッションはNULLであるかどうかチェックしてください。NULLであればTRUEを返し、ある値を含むなら、関数はFALSEを返します。`,
"label.setting.intergrationlist.status0":`イングレーションの状況`,
"label.copy_error":`コピーに失敗しました。`,
"label.connectOtherNone":`選択したオブジェクトには関連付けできるオブジェクトがありません。`,
"label.bmap.beijing":`北京`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemobが削除されました。再接続してください。`,
"label.wei.pollsubject":`投票トピック`,
"APPIntegration_Social_twittererror":`有効なtwitter.comのURLでなければなりません`,
"label.appupload.install.apicannotuse":`api名前は使用不可能です`,
"label.returntolist":`リスクに戻る`,
"label.translation.start2":`設定コンポーネントを選択します。`,
"lable.edit.queue.alter":`サポートされるオブジェクトを選択してください`,
"label.campaign.channel.step3":`ステップ3.販売チャンネルの登録ページ項目を選択`,
"label.data.newtemplate.e.seltype":`データエクスポート方式の選択`,
"front-kefu-moudle-hangup":`電話を切る`,
"label.forecast.forecastroleuserpage.shre.managerandother":`管理者と予測マネージャーは当該予測を共有することができます`,
"label.knowledgebase.mark.as.new.version":`新規リリースとしてマーク`,
"label.conditiontag.lookup":`検索`,
"label.import.page3.importsucceed":`インポートに成功した`,
"label.stdashbord.xsld.condtion":`条件設定`,
"label_emailtocloudcc_redmessage10":`情報は失効したため、再登録してください。`,
"label.event.moveup.1hour":`1時間`,
"label.chat.topic.page.add.favorite":`chatページでお気に入りに登録します`,
"label.icon.88":`助言`,
"page_404_label_noresource":`すみません、アクセス元は存在しません。`,
"label.quickbooks.refresh":`更新`,
"front-kefu-moudle-which-getphone-case":`電話に出た後にケースを作成するルール`,
"label.objecttab.edit":`オブジェクトタブの編集`,
"label.data.file.the.trigger":`トリガーの実行`,
"frame.personinfo.label.personimage":`プロファイル写真`,
"label_tabpage_turnoffsz":`クローズ‐置換済み`,
"label.sendmail.batch.chose":`メールの一括送信：受信者の選択`,
"label.data.downpage.i_title":`データインポートのステップ`,
"label.recycle.clearconfirm":`確かにクリアしますか。`,
"chatter.using":`0`,
"label.batchadd.newbatchpage.list":`データリストの一括追加`,
"pagecreator.systemstyle.button.new":`新規スタイル`,
"label.notification.serviceappointment.changestate":`1}{0}のステータスが{2}{3}に変更されました。`,
"label.weixin.weipollname":`Micro Vote名`,
"label.tabpage.skip":`スキップ`,
"label.edit.field":`フィールドの編集`,
"label.edit.new.rule":`生成規則の編集`,
"label.approved.receiveApprovalEmail":`メール承認申請を受け取る`,
"label.dashboard.refreshNow":`すぐ更新します`,
"label.lookup.introduce":`文字を入力して、あいまい検索できます`,
"homepage.components.newdes":`有効で形式が正確であるHTMLコードを入力してください。コンポーネントで適切ではないHTMLコードを入力すると、ホームページタブが正確に表示されない可能性があります。`,
"label.role.giveuserrole":`ユーザにロールを割り当てる`,
"lable.opppdt.selPbk.subtitle":`の価額表`,
"setup_mainpage_label_welcome19":`アクションガイド：このページの右側のメニュー → 管理の設定 → ユーザの管理 → ユーザ、ロール、プロファイルをクリックしてください。`,
"setup.mainpage.label.welcome22":`手順は以下の通りです。このページの左側のメニュー → 設定の管理 → メルマガテンプレート → メールテンプレート をクリックする。`,
"label.tianyancha.h5.zipcode":`郵便番号`,
"label_tabpage_allapplications":`すべてのアプリケーション`,
"label.chatter.like":`気に入り`,
"label.licence.noremainder":`ライセンスの残り数は足りない`,
"lable.outlook.edit.dataset":`データの設定`,
"D":`日付`,
"label.detail":`参照`,
"label.globaloperation.operationtype.custom_page":`カスタマページ`,
"label.addattachment.down":`ファイルをダウンロード`,
"label.data.exportall.all_btn":`すべてのデータをエクスポートします`,
"label.recordtypeselect.current":`現在のレコードタイプ`,
"label.tabpage.entercusnamez":`取引先の名前を入力してください`,
"label.location.valunit.km":`キロメートル`,
"label.mobile.phone.week.plan":`来週の計画`,
"vue_label_report_everyday":`毎日`,
"label.weixin.broadcasting":`発送中`,
"label.input.search.string":`検索する文字列を入力してください`,
"label.picandreporttype":`図表種別`,
"label.setmulti":`複数を`,
"label.visualpage.component.t":`コンポーネントを使用`,
"label.knowledge.designate":`ステータスが下書きの知識記事のみが割り当てられます。`,
"label.enable.barcode.only":`バーコードのみ有効`,
"vue_label_commonobjects_detail_a_group_strategy":`このデータには所有者がいないため、チームを作成することはできません。`,
"setup.layout.group.button":`ボタン`,
"label.mini.layout.remark":`フロントエンドのフロートウィンドウで表示するレイアウトに応用します`,
"setup.mainpage.label.welcome3":`CloudCCクラウドプラットフォームでのフォーム作成は、カスタムデータベース（オブジェクト）に依存しています。ユーザー定義オブジェクトは、組織に固有のデータを格納するデータベーステーブルです。テーブルとテーブルの関係は、プログラムを開発することなく簡単に構築できます。`,
"label.knowledge.draft.status":`知識文章の投稿状態は必ず下書きでなければなりません`,
"label.manageAll.sel.one1":`承認待ちのプロジェクト`,
"label.campagin.roi.bhydkhywjh":`獲得する商談件数`,
"label_partner_template_thumbnail":`サムネイル`,
"label.loginip.setup":`ログイン IP アドレスの制限`,
"label.data.downpage.e.title.e.btn":`エクスポートページに移動し、エクスポートを開始します`,
"vue_label_appstore_project_management":`プロジェクトマネジメント`,
"assetbom.delete.notpermission":`アセットBOMを削除する権限がありません。管理者に連絡してください。`,
"vue.dashboard.setdrill.inThe":`中の`,
"label.mobile.more.savephoto":`画像を保存`,
"label.customerinfo.PageTriggerFag":`カスタマクラス、トリガー、カスタマページの同期`,
"label.commonobjects.Nopermission":`すみませんが、このデータを編集する権限がありませんので、システム管理者に連絡してください`,
"label.searchlayout.opperationtab.xsldfield":`商談タブのセールファネルリンクで表示されるビュー項目をクリックしてください。`,
"label.emailsync.form.disconnect":`関連付けのキャンセル`,
"label.document.nofile.upload":`アップロードするファイルはありません`,
"label.appointmentpage.wizard.subtitle3-3":`電話番号`,
"message.custom.field.donotdelete":`項目は使用され、削除できません`,
"chatter.using0":`ここまで{0}msを使いました`,
"label.tabpage.multiple":`複数選択`,
"label.attendance.setting.sy.alert":`勤怠管理の対象を選択する必要があります。`,
"label.refuse":`却下`,
"label.log.button":`ユーザ名に基づいて、検索します`,
"component_chatter_link_label_title":`リンク`,
"template.report.contract.collection":`契約金`,
"label.campaignmember.selectmember.step1":`ステップ1.キャンペーンとキャンペーンメンバーの選択　状況`,
"label.datamanage.warn.owner":`警告：今回のインポートアクションを続ければ、あなたをレコード所有者としてすべてのレコードにインポートします。`,
"label.a.b":`A to Bの関係`,
"label.app.step3.homeisfrist":`ホームページは必ず一番目です。`,
"UG_Lead_003":`ソーシャル`,
"label.partner.workspace.member.choice":`プロファイルの選択`,
"lable.outlook.detail.emaping":`行動項目の対応付け`,
"label.service.appointmentList.gantt.chart.shows":`ガントの日付表示`,
"label.mr.caption.account.result":`重複検索&マージ：取引先の重複データの検索結果`,
"vue_label_chatter_approve_members_join":`メンバーのグループへの加入を許可します`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`日`,
"pagecreator.systemstyle.label.modifycolor":`カラーの編集`,
"label.tabpage.yesz":`はい`,
"label.fieldtoolongmessage":`項目は制限を超えています`,
"lable.account.year.name":`会計年度名称`,
"label.mini.layout":`フロートページのレイアウト`,
"label.icon.97":`教える`,
"vue_label_chat_smart_assistant":`スマートアシスタント`,
"label.marketingmanagementuser":`市場販売ユーザ`,
"label_emailtocloudcc_description2":`企業メールの関連付け`,
"label.campaign.channel.input.name":`1.販売チャンネルの名称をご入力ください`,
"UG.homepage.007":`フォローメールの送信からセールスキャンペーンの自動化まで、ブループリント技術を使ったワークフローの作成からカスタムマクロのトリガーまで、日々のToDoを自動化し、より関係構築に専念します。`,
"label.share":`共有`,
"label.step2.total6":`ステップ　2/6`,
"label.sendemail.chat.addComentspraise":`#name様:\n\n    こんにちは。#userName様はお気に入りの書き込みを返事しました。`,
"label.icon.20":`ファイル`,
"label.service.gantt.absenteeism":`欠席`,
"message.error.color.nagatice":`現在のページ数はマイナスではいけません`,
"chatter.group.applyToJoin":`加入申請`,
"pagecreator_layout_message_delete":`選択したレイアウトを削除しますか。`,
"label.multilang.viewlist.count":`{0}件のレコード`,
"message.notdesable.type":`以下のプロファイルはこのレコードタイプをデフォルト値としているため、このレコードタイプの使用を禁止することができません。`,
"label.standard.time":`標準時`,
"label_chatter_newpost":`最新の投稿`,
"front-epwechat-module-v1-binding":`バインド・ウィーコム`,
"label.recent":`最近`,
"label.globaloperation.createfeeditem":`フィードの作成`,
"label_partner_common_roleNum":`ロール数`,
"front-template-V1-quikSearch":`フィールド名を入力して検索`,
"label_tabpage_haschangedz":`このリードは置換済み`,
"label.service.work.order.line":`ワークオーダー項目`,
"label.lead.score.ok":`はい`,
"Account_News_Setting_003":`一般設定`,
"label.event.moveup.15minutes":`15分`,
"vue_label_all_selected_objects":`すべて選択したプロジェクト`,
"label.visualpage.an.inline.style.relatedlist":`関連リスクにカスタマページ種別を埋め込みます`,
"label.umeng.approval.approvaling":`#applyerは#obj#objname#ownerの承認を申請しています`,
"lable.SalesCommitmentKanBan.digital":`数値`,
"label.appupload.img.max.size":`アップロードしたファイルは大きすぎて、20Kを超えないでください。改めてアップロードしてください。`,
"vue_label_normal_top":`トップ`,
"label.knowledge.language.traditional":`繁体字中国語`,
"homepage.layout.edit":`ホームページレイアウトを編集`,
"label.campagin.qrcode":`キャンペーンQRコード`,
"label.emailmerge.merge.emailmerge":`差し込み印刷`,
"label.icon.18":`時計`,
"vue_label_homepage_taskview":`ToDoビュー`,
"label.search.related.record":`関連レコードが見つからない`,
"label.report.reports":`レポート`,
"label.appointment.wizard.subtitle4-3-2":`15分`,
"label.forecast.condition":`予測条件`,
"label.westem.indonesia.time":`西インドネシア時間`,
"front-epwechat-module-v1-callback-desc":`以下の情報をWeComのバックエンドにコピーします。`,
"label.version.group":`チーム版`,
"label.allReportType":`すべてのカスタマレポートタイプ`,
"label.trigger.lastmodifydate":`前回の修正日`,
"message.layout.unique.sectionfield":`ページレイアウトでの項目の一意制約を違反したが、確認してから再保存してください。`,
"vue_label_systemSettings_mobelbottonsetting":`モバイルアプリのボトムメニュー設定`,
"label.recordtype.selectonefield":`1つ以上の新規項目を選択`,
"label.notification.group1":`【申請者】はあなたの公開グループへの加入を申請しています`,
"component_todaytask_label_title":`今日のToDo`,
"label.assignment.setup.list.description":`定義した条件に基づいて、自動的にリードがユーザまたはキューに割り当てられます。さまざまな条件で複数のルールを作成できます。`,
"label.project.resource.data":`このサービスリソースはサービス予約に割り当てられていますので、重複して追加しないでください。`,
"label.emailmerge.newtemplate.file":`ファイル`,
"label.notification.task1":`【任命者】はあなたにToDoを割り当てました`,
"label.ServiceCloud.Overlapping":`重複表示ディスパッチ`,
"label.globalselect.used":`項目が使用する位置`,
"setup_layout_button_layoutprop":`レイアウトのプロパティ`,
"label.quickbooks.retrivingdata":`データを獲得中`,
"component.button.ok":`確認`,
"message.pleaseinputformula":`数式をご入力下さい`,
"label.h5.whatifollow":`私のフォロー`,
"label.new.crew.target":`新規人員の目標`,
"label_chatter_task":`ToDo`,
"label.knowledge.setting.data.four":`最大で{count}個のカテゴリグループを選択することができます。`,
"label.rule.not.enabled":`無効化ルール`,
"label_in_scope":`範囲内`,
"label.partnerCloud.orderingPlatform.bundle":`パッケージ`,
"label.emailtocloudcc.redmessage10":`情報の有効期限が切れていますので、再度ログインしてください。`,
"label.knowledgebase.data.assignment.succeeded":`{a} データが正常に割り当てられた`,
"vue_label_commonobjects_view_nokanban":`作成された看板ビューはありません`,
"label.knowledgebase.article.cancelled.attaching.case":`記事{名前}は、ケースに添付するためにキャンセルされました!`,
"label.brief":`速報`,
"label.version.sum.app":`アプリケーション（個）`,
"label.commoninfo":`一般情報`,
"vue_label_SMS_nodata":`データなし`,
"label.icon.153":`情報`,
"label.conditiontag.lookup.false":`FALSE`,
"label.emailobject.view.unread":`すべて未読`,
"label.staticresource.useful":`どこに使いますか`,
"label.ems.connect.test":`チェック`,
"vue_label_chat_group_assistant_notification":`グループアシスタント通知`,
"label.multipleactivity.total":`合計`,
"vue_label_report_addtocomponentlibrary":`コンポーネントライブラリへの追加`,
"font-evaluate-module-v1-following-personnel":`評価が3未満の場合、次のユーザーに通知する。`,
"label.setup.mobile.bottombutton.change.fail":`変化に失敗した`,
"front-epwechat-module-v1-unbound-item5":`と表示され、データが取得できない場合、本当にアンバインドしていいのでしょうか？`,
"label.customerinfo.smsUid":`SMSゲードウェイUID`,
"label.list.isOpenApprovalQueue":`承認キューの有効化（手動で承認者を選択する場合は利用できません。`,
"label.leadscore.setup.scorenumber":`回`,
"label.workflow.selectobj.introduce":`当該ワークフロールールが応用するオブジェクトを選択`,
"label.visualpage.label.for.example":`ページの表示ラベル：`,
"label.appointmentdetail.wizard.title17":`木曜日のスケジュール`,
"label.projectManagement.timeFrame":`ToDoの開始日と終了日は、マイルストーンの時間範囲内でなければなりません。`,
"lable.product.pricebooks.list":`価格表は特別定義がある単価と通貨種別の商品リスクで、複数の通貨種別を設定することができます。商品ファミリを価格表に追加するとき、商談あるいは見積は個別価格表の商品しか含みません。価格表の商品を編集するなら、価格表名をクリックしてください。`,
"font-trade-module-v1-delete-invoice":`インボイスの確認`,
"vue_label_salesadvance_winamount":`勝ち取った契約の総金額`,
"component.salesperformance.label.nopermission":`商談関連データを参照するには、システム管理者に連絡してください。`,
"vue_label_report_formatreport_desc":`レポートヘッダー、グループ、フィルター設定を含むレポートをエクスポートします。`,
"label.enable.qrcode.only":`QRコードのみ有効`,
"label.smstemplate.edit":`SMSテンプレートの編集`,
"label.qrcodeSetting.detailed.information":`QRコードは、バーコードよりも多くのデータを格納することができ、直線的な読み取りは必要ありません。そのため、QRコードは、商品の追跡、アイテムの識別、文書管理、マーケティングなどに幅広く応用されています。`,
"label.event.moveup.1week":`1週間`,
"label.customize.memory.function.sorting.disable":`ヘッダーソートの記憶を無効にする`,
"label.icon.195":`バスタブ`,
"label.compact.layout.assign":`キー情報レイアウトの配置`,
"label.icon.183":`家`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Easemob社のシート・オンライン・チャットを統合し、より包括的なSaaSサービスを提供。`,
"label.mycontact":`私の取引先責任者`,
"label.tabularreport.2018.step3":`ステップ3：レポート標準の選択`,
"chatter.group.uploadGroupPicture":`チームアバターのアップロード`,
"label.total.forecast.setup":`予測を優先し、に設定する`,
"label.weixin.group.description":`メモ`,
"label.edit_emailfooter":`メールフッターの編集`,
"label.ems.create":`新規`,
"label.weixin.optionseven":`選択肢 7`,
"font-evaluate-module-v1-continue-work":`皆様の評価が私たちの励みになります。これからも努力していきたいと思います。`,
"label.close.multilingual":`マルチランゲージの無効化`,
"component.chatter.post.button.user":`人員の追加`,
"label.use_QRcode":`QRコードを使う`,
"label.operatedata.exportsuc":`エクスポートに成功しました。メールボックスに登録して、ファイルエクスポートのダウンロードアドレスを参照してください。エクスポートしたファイルは48時間に保存されますが、できるだけ早くダウンロードしてください。セキュリティーのため、ダウンロードした後、システムが送信したメールを削除することをお勧めします。`,
"label.page.step2.define.content":`ステップ2：内容の定義とプロパティの表示`,
"label_tabpage_groupingitem":`グループ化項目`,
"label.customfields.placeholder":`サンプルの記入`,
"vue_label_commonobjects_detail_enter_subject":`テーマを入力してください`,
"label.multilang.workflow.everyotherdayinmonth":`{0}月毎に{1}日`,
"label.knowledgebase.data.archiving.failed":`{a}データアーカイブの失敗`,
"vue_label_notice_nopermission_view":`申し訳ありませんが、このレコードを参照する権限がありませんので、管理者に連絡してください`,
"vue_label_calendar_calendar_view":`カレンダービュー`,
"lable.outlook.edit.des":`ある Exchange 取引先責任者は複数の CloudCC.com 取引先責任者に一致するなら、以下条件を満たす CloudCC.com 取引先責任者を同期します。`,
"label.custom.NextCQ":`次のカスタマ四半期`,
"label.emailsync.form.stutas":`ステータスの有効化`,
"label.nameandintro":`名称と説明`,
"label.dashboardSetup.showdw":`ディスプレイユニット`,
"label.tianyancha.actualcapital":`実際に受け取った登録資本金`,
"front-kefu-moudle-info-delete-calluser":`情報が変更されていますので、管理者にお問い合わせください。`,
"label.emailobject.list.all":`すべて選択`,
"label.campaign.channel.step7.send":`メールの送信先を選択`,
"label.formulafield.type":`数式の戻り値型`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`木曜日`,
"label.chosesubject.eat":`食事を約束します`,
"label.back":`戻る`,
"label.h5.allcompany":`すべてのクラウドポスト`,
"label.location.display.type.digital":`数字`,
"label.datamanage.error.csv":`不正確なファイル形式で、システムは通用するCSV形式しかサポートしません。改めて試してください。`,
"label.emailobject.mark":`マーク`,
"setup_mainpage_label_welcome9":`ユーザがコード開発を行わなくても、マウスでドラッグ&ドロッするだけで、すべてのページ要素の分類表示、レイアウトの調整を実現し、またページでの項目の読み取り、必須項目などのプロパティを設定することができます。`,
"label.icon.56":`測定器`,
"label.forecast.edit.fwcd":`範囲の長さ`,
"vue_label_email_Please_select_related_items_first":`関連項目を選択してください`,
"label.icon.87":`本`,
"label.knowledgebase.recovery.was.successful":`復旧に成功した`,
"label.emailobject.emaildetail.promptcontent":`削除はキャンセルできませんが、このメールを削除しますか。`,
"label.delete.role":`ロールの削除`,
"label.multiselect":`複数選択可能な選択リスト`,
"label.customerinfo.mailisnull":`会社メールボックスは設定されていません`,
"label.waitforamoment":`ページのインストール中です。しばらくお待ちください。`,
"lable.edit.queue.tip":`通知を発送する際（例えばケースがキューに割り当てられたときに）、キュー名とメールアドレスを入力します。メールアドレスが記入されない場合、通知されません。「メンバーにメールを発送する」を選んだ場合、キューメンバーに通知されます。選んでない場合、通知されません。`,
"lable.custom.y.d":`このページでは、カスタム年度のレコードを定義することができます。カスタム年度の日付は以下の選択肢に基づき、生成されます。`,
"chatter.feed.content.user.searchbutton":`検索`,
"label.data.downpage.i.list.desc3":`ユーザーはダウンロードした後、ファイルの最後の一列にインポートが失敗した原因が表示されます。`,
"label.tag.manage.createdby":`作成者`,
"label.h5.similar.opportunity.last.months3":`直近の３カ月`,
"chatter.group.members":`メンバー（人）`,
"label.knowledgebase.data.translation.failed":`Translate {a} data failed`,
"label.log.look":`監査証跡の設定を参照`,
"label.service.gantt.week.timescale":`ウィークビューで表示する時間と時刻：`,
"label.userLicence":`ユーザライセンス`,
"label.file.library.managemembers.permission":`アクセス権`,
"label_emailtocloudcc_name":`名前`,
"label.mr.mrSuccess":`マージ成功`,
"vue_label_commonobject_view_notice_selectadd":`追加するデータを選択してください。`,
"vue_label_commonobjects_detail_level":`レベル`,
"CloudCCCRM_ST_Info_TypeIn_001":`入力してください`,
"label_chatter_list":`リスト`,
"label_tabpage_optionsz":`オプション`,
"UG_homepage_008":`現在の業務状況（販売速報、ランキング、セールスファネルなど）を理解し、問題があるかもしれない商談を調べ、業績の達成状況を予測し、重要な事項を直ちに処理して、賢明な決定を下しましょう。`,
"label.myselfdashboard":`私の非公開ダッシュボード`,
"label.globaloperation.operationtype.record_phone":`通話の記録`,
"label.field.standard":`標準項目`,
"label.changemydisplay.appedit.check":`ユーザの個人カスタマアプリケーションとカスタマ設定をカバー`,
"label.tianyancha.h5.legalpersonnames":`代表法人`,
"label.tabpage.sorttypez":`並び替えタイプ`,
"label.newdashboard.folder":`新規ダッシュボードフォルダ`,
"label.campaign.channel.step6":`ステップ6：販売チャンネルの登録ページを生成`,
"label.ems.composeemail":`メールの送信`,
"label.app.step4.tabcanuse":`選択可能なタブ`,
"label.sendmail.batch":`メールの一括送信`,
"label.process.execute.title":`承認中`,
"lable.outlook.detail.lastup":`最終更新`,
"label_emailtocloudcc_delete":`削除`,
"lable.opppdt.selPdt.leastone":`一件以上を選択してください`,
"label.customfields.new.step2.opration.exid":`外部ID`,
"label.assignment.setup.newrule.description":`ルール名を入力して、有効になっている［チェックボックス］を選択し、自動的にこの割り当てルールが割り当てに使用されます。当該ルールが有効されたら、現在の割り当てルールがの使用が禁止されます。`,
"label.campaign.channel.input.to.isactivity":`7.編集を許可しますか`,
"label.document.return":`フォルダページに戻る`,
"label.data.downpage.i_title.num5":`5、データの正確性を確認してください。`,
"label.taskinto":`ToDo はToDo をユーザに自動的に割り当てるときにワークフロールールが使用するテンプレートです。`,
"label.customfields.formula.textexample":`フル‐ネーム`,
"label.appointmentpage.wizard.subtitle1-1":`来週`,
"label.weixin.radio":`ラジオ`,
"vue_label_file_replace_reason_check":`置換えの理由（必須項目ではない）`,
"label.sendemail.recycle.operateexception":`ゴミ箱を空にするには異常が発生し、改めて試してください。`,
"label.vlidaterule.formulaerror":`割引率が 30% を超えている場合にエラーを表示します`,
"vue_label_campaign_existing_member_status":`既存メンバーステータスの保留`,
"label.service.miniProgram.fillSlideshowName":`カルーセルの名称を記入してください。`,
"label_partner_workspace_login_headerfooter":`フッターとヘッダー`,
"label.quickbooks.viewlist.total2":`合計で{0}件の見積で、合計で{1}になる`,
"chatter.viewingResults":`結果を表示`,
"label_tabpage_allvisible":`全ユーザー`,
"label.quote":`見積書`,
"label.changemydisplay.list.des":`需要に応じて、タブを更新します`,
"label.leadscore.notimes":`スコアリングの回数は上限になっています`,
"label.icon.51":`発電`,
"component.assistant.label.title":`アシスタント`,
"label.emailobject.emailsent":`メールの送信に成功しあした！`,
"label.group.nofile":`このチームに送信したファイルはありません`,
"label.foldervisitlimit2":`すべてのユーザは当該フォルダを参照することができません`,
"label.dataoperate":`データアクション`,
"label.addattachment.size":`大きさ`,
"label.not.double":`重複値は許可されていません`,
"label.customfields.formula.number.tip":`数値の集計`,
"lable.opppdt.addpdt.table.description":`行の説明`,
"label.sms.isactivity":`有効`,
"label.campaign.channel.input.owner":`4.当該販売チャンネルリードを作成する所有者設定してください。`,
"label.visualpage.notfound.error":`知らないエラーが発生し、管理者に連絡してください。`,
"label.mr.title.button.group3":`レコード（件）`,
"label_tabpage_beginz":`開始`,
"label_tabpage_queue":`キュー`,
"label.tabpage.advancedscreening":`高度なフィルタ`,
"nogreate":`より小さいorイコール`,
"chatter.fields":`の項目`,
"button_partner_workspace_manage":`管理`,
"label.partnerCloud.orderingPlatform.search":`製品検索`,
"message.password.isnull":`パスワードは空であってはいけません。`,
"label.fenbeitong.title":`FenBeiTongの設定`,
"label.salescloud.contactrole.message.chooseatleastone":`以下のいずれかの取引先を選択してください`,
"label.knowledge.delete.election":`データカテゴリーの選択を削除するにはエラーが発生しました`,
"front-console-status-hoided":`レイアップ`,
"label.lastmodifydate":`最終更新日`,
"vue_label_chat_deleting_chat":`削除すると、チャットの履歴が消去され、チームリストからも削除されます。新しいメッセージを受信すると、再びチームリストに表示されます。`,
"label.timeframe":`時間幅`,
"UG.opportunity.002":`セールスサイクルの定義、ステージの設定`,
"label.templates.merge":`マージするテンプレートを選択してください。最大で20個まで選択可能です。`,
"label.generatepage.c2":`最大文字数は30です。`,
"label.appointment.wizard.subtitle4-1-6":`2時間`,
"label.passwordPolicy.setup.pwdremember3":`3つのパスワードを記憶`,
"button.partner.workspace.enable":`パートナークラウドの有効化`,
"vue_label_pool_nopool_notice":`プールにまだ加入していないので、管理者に連絡してプールの作成または加入をしてください。`,
"label.layout.required.field.select":`選択済みの必須項目`,
"label.loginhis.date":`開始時刻と終了時刻を入力してください`,
"vue_label_commonobjects_detail_and_overdue":`間もなく来る予定と期限切れ`,
"label_tabpage_advancedsearch":`高度な検索`,
"label.custom.field.login.home.query":`システムホームページに入って、ToDo詳細情報をご覧下さい。`,
"page":`ページ`,
"label_tabpage_onlymevisible":`私専用`,
"label.weixin.optionfour":`選択肢 4`,
"label.confirm.to.remove":`削除の確定`,
"label.event.moveup.30minutes":`30分`,
"label.mail.merge.template.finish":`差し込み印刷テンプレートは完了済みです`,
"label.multilang.currencylist.before":`{0}の前に`,
"label.goback":`前のステップに戻る`,
"label.unknown.prefix":`知らない接頭辞、正しい接頭辞を入力してください`,
"lable.account.CurrentandPreviousCYt":`現在と2つ前のカレンダー年度`,
"label.product.dent":`キーワードを検索条件を入力して、検索をクリックして検索します。[より多い検索条件]をクリックして、1つ以上の検索条件を使用します。検索結果は入力したキーワードと検索条件と一致するすべてのレコードを含みます。`,
"label.ems.bcc":`BCCの追加`,
"label.import.index.operation":`操作方法`,
"label.knowledge.setting.hint.eight":`すべてが完璧な状態に保たれています。`,
"label.sso.saml.sp.idtype.fid":`ステートメントにはユーザオブジェクトからのフェデレーションIDが含まれています。`,
"vue_label_chat_voice":`音声`,
"label.config.pw":`新パスワードの確認`,
"lable.newtabpage.closesearchresult":`検索結果を折りたたむ`,
"lable.account.NextWeek":`来週`,
"label.ems.username":`ユーザ（U）`,
"vue_label_email_emails_from_potential":`CRMのリードや取引先からのメール及び受信者に含む彼らのメールは、ここにアーカイブされます。`,
"lable.approval.shared":`承認の共有`,
"label.tabpage.allz":`すべて`,
"label.file.uploadfiles":`ファイルのアップロード（本条日语需缩短）`,
"label.emailobject.text":`名称：`,
"label.version.allow.create":`新規作成を許可`,
"label.empty.field":`フィールドを空にすることはできません。`,
"label.emailsync.status.department":`部門`,
"label.pw.str":`5文字`,
"label.attendance":`勤怠`,
"label_mobile_buttom_team":`チーム`,
"label.campaignmember.main.addcontactdesc":`すべての既存取引先責任者をこのキャンペーンに一括追加します`,
"label.search.result":`検索結果`,
"label.weixin.activity.account":`活動の顧客`,
"label_tabpage_clearoptionsz":`高度なオプションのクリア`,
"UG.activity.01":`如何に取引先／チームとの記録を追跡しますか。`,
"serviceappointment.new.status.limit":`ステータスが「計画済み」または「派遣済み」のサービス予約を作成することができません`,
"label.notice.higher":`上位に通知しますか`,
"label.passwordPolicy.setup.gletters":`文字`,
"label.data.exportsf.des":`エクスポートファイルをサーバーで48時間保存されますが、48時間を経過すると削除されます。`,
"label.view.onlymecansee":`私のみが参照可能`,
"UG.Lead.005":`メールボックス`,
"label.umeng.approval.approvalfail":`提出に失敗しました`,
"label.huanxinconfig.clientid.lost":`clientidは空ではありません。`,
"label.campaignmember.main.updatecontactstatus":`更新状況‐既存の取引先責任者`,
"component_chatter_button_delete":`削除`,
"label.weixin.no.pending.projects.qin":`現在、承認待ちのプロジェクトはありません。`,
"front-electronic-signature-auto-fill-field":`オートフィル・フィールド`,
"message.resetpw":`確かにパスワードを更新しますか`,
"label.service.ganttBaiduMap.service.resourname":`サービスリソース名`,
"vue_label_pricebook_deleted":`価格表は削除されました`,
"label.icon.193":`バスタブ`,
"label.validate.function.funcFormat.NOT":`NOT(logical)`,
"label.address.city":`市`,
"label.pc.ui.2018.searchs":`検索内容を入力してください`,
"label.yard":`招待コード`,
"label.data.downpage.i_title.btn":`インポートページに入り、インポートを開始します`,
"label.useablereceivers":`使用可能な受取人`,
"label.cloudccsite.name.length":`サイト名は255文字を超えてはいけません`,
"label.secrecy":`秘密`,
"label.campagin.roi.ydkhywjhzz":`獲得した商談の総価値`,
"vue_label_report_conditiondesc_one":`サブスクリプションを除き、このレポートには条件を設定することができます。すべての条件が満たされた場合に通知されます。これはオプションです。`,
"label.datamanage.select.contactfield":`（インポートする取引先項目の選択）`,
"label.emailtocloudcc.filed.action":`アクション`,
"label.smstemplate.new":`新規SMSテンプレート`,
"label.mobile.side.tab.app":`アプリケーション`,
"label.icon.118":`時計`,
"label.customfields.selectcontainfieldlayout.tip":`この項目は最後の項目として、これらのページレイアウトの最初2列に追加されます。レイアウトを選択しないと、この項目はいずれのページでも表示されません。この項目のページにある位置を更新するなら、ページレイアウトのカスタマイズが必要です。`,
"Lead_Homepage_Tools_BatchScoring":`一括スコアリング`,
"lable.quote.syncing.quote":`見積書`,
"pagecreator.button.preview":`プレビュー`,
"label.ccchat.am":`午前`,
"chatter.feed.menutype.user.nullrecent":`新規レコードはありません`,
"lable.info.queue.showallmember":`ビューメンバーを表示`,
"label.multilang.campaign.selelctmember.desc":`1つのビューを選択して、メンバーを選択しキャンペーンに追加します。ユーザ状況は{0}です。`,
"label.notification.ccchat3":`あなたの書き込みに新しい返事が1つあります`,
"UG.product.03":`複数通貨対応の価格表`,
"label.sso.saml.idp.config.pksize":`キーサイズ`,
"label.defineCustomReportType":`カスタムレポートタイプの定義`,
"component.timeline.button.filter":`フィルター`,
"label.mr.nextGroup":`当該チームをスキップ、次のチームへ`,
"label.quote.sprdz":`住所(請求先)`,
"label.total.refuse.forecast.have.priority":`いずれの予測優先を拒否`,
"lable.product.peep":`有効な価格を入力してください`,
"label.file.who.can.access":`誰がアクセスできますか`,
"label.page.last":`最後のページ`,
"label.icon.180":`人`,
"font-evaluate-module-v1-enabled-successfully":`評価オプション "Neural "の有効化に成功`,
"label.appointment.wizard.subtitle4-2-2":`2時間`,
"label.passwordPolicy.setup.oneyear":`一年`,
"label.login.bound.mfadevice.title":`仮想MFAデバイスを有効化`,
"vue_label_dashboard_statisticalvalue":`統計値を選択してください`,
"label.ishistory":`の履歴`,
"component.timeline.label.title":`時間軸`,
"label.page.step3.of.step5":`ステップ　3/5`,
"label.assignment.setup.detail.section":`ルールの詳細情報`,
"label.salescloud.opportunity.nothave.main.contactrole":`主な取引先責任者はいないです`,
"label.import.page1.limitedcsv":`アップロードされるファイルはCSV形式のみ可能です。`,
"label.icon.187":`ハンマー`,
"label.emailobject.wizard.desc5":`あなたのサインをカスタマイズして、メールがより美しく見えるようにします。`,
"vue_label_report_notice_copy_success":`レポートのコピーに成功しました`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`重複チェックのルールを選択していません`,
"label.componentEditor.upper.limit":`上限は100です`,
"label.validate.function.funcExplain.ISNEW":`レコードは新規であるかどうかチェックし、新規であればTRUEを返し、そうでなければFALSEを返します。`,
"label.postalCode":`郵便番号`,
"label.dashboard.snapshot.enable.flag":`ダッシュボードスナップショットを有効化`,
"vue_label_file_upload_type_size":`アップロードできるファイルは{fileType}のみで、サイズは{size}Mbを超えてはいけません。`,
"label.appointment.wizard.subtitle3-6":`土曜日`,
"homepage.narrow":`狭い欄（左欄）`,
"chatter.addmute.confirm":`確かにこの投稿を鳴動制限にしますか。`,
"label.lookup.account":`取引先の検索`,
"message.lostthemanager":`この提出はユーザのマネージャーの承認が必要ですが、この値はNULLです。詳細について、管理者に連絡してください。`,
"label.exchange.sync.state.contact.m3":`最後24時間の同期レコード`,
"label.version.phone.app":`モバイルAPP版`,
"label_tabpage_search":`検索`,
"vue_label_helpcenter_campaign":`詳細情報では、キャンペーンの横にある樹形図ボタンをクリックすると、キャンペーンの階層構造図が表示され、キャンペーンの親子レベルの関係を理解することができます。<br>キャンペーンのメンバーの関連リストを通じて、キャンペーンに関わる取引先責任者やリードを管理します。`,
"front-lightning-module-v1-dashborad-last-year":`昨年`,
"label.campaign.channel.value":`値`,
"vue_label_opportunity_contactrole_primarycontact_notice":`主要な連絡先を選択するには、この手順を保存し、「管理」から選択します。`,
"label.biaoqingfaxian.title":`bid&tender discovery`,
"label.approved":`承認済み`,
"label.hong.kong.time":`香港時間`,
"label.customfields.file.cannotopen":`このファイルを開くことができません`,
"lable.New.tips":`新規作成 "をクリックすると、標準テンプレートまたは選択したテンプレートを基に、新しいサービスレポートテンプレートが作成されます。作成したテンプレートを有効にして、使用を開始してください。`,
"component.setup.tabs.label.add":`追加`,
"label.forecast.forehistory.replacebest":`ベストケースのオーバーライド`,
"front-kefu-moudle-v1-jctrrt-call-serve":`コールセンターとTRRTを統合し、より包括的なSaaSサービスを提供`,
"label.workflow.configrule":`ステップ2：ワークフロールールの更新`,
"label.dashboard.snapshot.refresh.frequently":`ダッシュボードスナップショットは頻繁すぎで、後ほど改めて試してください。`,
"label.ems.editsetting":`メール編集の設定`,
"message.confirmdeleteAPP":`このアプリケーションを削除します`,
"label_chatter_activity":`活動`,
"label.editsharerules":`共有権限の編集`,
"label.loginservice.license.notuse.must":`ライセンスは現在使用できません。`,
"label.import.step2.beforeexport":`1、インポートする前に、関連するすべてのレコードをインポートするようにしてください。例えば、現在インポートされているオブジェクトと取引先責任者との間に検索関係がある場合は、先にこれらの取引先責任者を導入してからデータをインポートしてください`,
"label.chat.mute":`通知の鳴動制限`,
"label.icon.128":`家`,
"label.give":`&&AND`,
"label.hide":`表示しない`,
"label.relationobject.wpr":`委任者`,
"label.summation":`総計`,
"label.layout.availabletab.details":`詳細情報`,
"label.circle":`輪形`,
"vue_label_opportunity_contactrole_add":`取引責任者の追加`,
"label.file.library.file2libsuccess":`このライブラリに追加されました！`,
"label.weixin.report.reportgenerated":`レポートは生成済みです`,
"label.icon.91":`人`,
"report.label.pleaseinput":`検索内容を入力してください`,
"label.escalation.setup.newaction.otheremail.tip":`最大で5つまでのメールを入力することができます。アドレス毎に読点で仕切りって入力してください。`,
"label.area.donot.have.data":`データなし`,
"label.customcomponent.btn.reference":`コンポーネントの参照`,
"label.appointmentdetail.wizard.title7":`リマインダータイム`,
"label.ccchat.with":`保有`,
"label.file.size":`大きさ`,
"label.product.sort.beyond":`最大で10段階のレベル設定が可能です。`,
"label.ccchat.2018":`動的`,
"label.report.select.column":`列の選択`,
"label.appointmentpage.wizard.subtitle1_1":`日付と時間を選んでください。`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`英数字と記号を含まなければなりません`,
"label_chatter_addressee":`受信者`,
"label.profile.remark2":`組織でレコードタイプを使用する場合は、レコードタイプの設定セクションの [編集] リンクからこのプロファイルに 1 つ以上のレコードタイプを関連づけてください。`,
"UG_Account_01":`取引先は誰ですか。`,
"label.dataimport.error.contact.notnull":`エラー：取引先名は空であってはいけません`,
"lable.account.CalenderQuarter":`カレンダー四半期`,
"vue_label_commonobjects_detail_empty":`販売価格は空にしてはいけません`,
"label.approveassigntemplate":`メールテンプレート割り当ての承認`,
"label.objectRelationshipDescription1":`当該レポート種別は`,
"vue_label_email_insertmergefield":`マージ項目の挿入`,
"label.mobile.home.page.check.team":`チームを表示`,
"lable.edit.queue.edit":`キューを編集`,
"label.campagin.roi.query":`キャンペーンROIの検索`,
"label.dataimport.field.allow.access.to":`データ項目はアクセスできません。手動で対応するレコードを削除してから、また試してください。`,
"pagecreator.systemstyle.message.canntdelete":`該当スタイルは削除できません`,
"label.searchkey":`キーワードをご入力ください`,
"chatter.showall":`すべて表示`,
"show":`表示`,
"label.quote.choseproduct":`商品を選択`,
"label.report.selected.field":`選択済みの項目`,
"label.globaloperation.operationtype.create_data":`レコードの作成`,
"label.knowledge.setting.data.seven":`カテゴリーグループの削除{flzmc}の`,
"chatter.email.mentionOrMessage":`メンションあるいはメッセージ、`,
"label_tabpage_exclusivez":`含まない`,
"chatter.en.userinfo":`私に関する情報の入力`,
"label.log.orgid":`機構`,
"label.dataimport.insertdata.error.fieldrepeat.update":`このレコードでの$schemefield_name$項目はデータベースで見つからないため、更新アクションは執行できません。このレコードのエクスポートが見落とされています。`,
"vue_label_chatter_add_link_success":`リンクの追加に成功しました`,
"label.sender_details":`新しい送信者の詳細を追加するには、あなたのアカウントでユーザーを作成します。`,
"label.ccpeak.addwhere.condition":`where条件が追加可能`,
"label.datamove.total":`共有`,
"label.tianyancha.businessverify.warning":`ご注意：中国本土に登録した企業のデータのみ検証できます。`,
"label.emailmainbody":`メール本文`,
"label.justadmin":`管理者のみ`,
"label.data.downpage.e.list.desc1":`このページで表示されるデータはエクスポートに成功したファイルです。メッセージに基づいて、エクスポートしたファイルを素早くダウンロードしてください。`,
"label.reportsSubscriptionPage.email.value":`使用可能な値`,
"message.error.serviceappointment":`サービス予約に開始予定時刻と終了予定時刻を記入してください`,
"label.textMessageObject.selectone":`テキストメッセージの受信者として、少なくとも1つのレコードを選択してください。`,
"label.schedulejob.setup.schedule.plan":`計画`,
"label.assignment.layout.field.isassigned":`有効な割り当てルールによりケースを割り当てる`,
"label.captcha.error":`検証エラーです。`,
"mobel_web_not_more_data":`更なるデータがありません`,
"label.emailsync.form.emailaddress":`メールアドレス`,
"label.loginservice.error":`ログインにエラーが発生したため、システム管理者に連絡してください`,
"label.integrations.description":`CloudCCアカウントを他のアプリケーションに接続する`,
"vue_label_homepage_notice_selectone":`リードまたは取引先を少なくとも1つ選択してください`,
"label.chatter.default":`デフォルト`,
"label.tabpage.datefield":`日付項目が等しい場合、「昨日」、「今日」、「明日」、「先月」、「今月」、「来月」、「先週」、「今週」、「来週」、または 「YYYY-MM-DD、MM/DD/YYYY 」形式を使用することができます。`,
"front-kefu-moudle-myzdhsc-file":`記録ファイルが見つからない、または生成されていない`,
"label.createname":`創造主`,
"label.mobile.phone.enter.plan":`ここに計画を入力します`,
"report.label.highlevelreport":`高度なレポートでは、最大4つまでのオブジェクト関連リストを作成することができます。`,
"label.edit.select.label":`編集方式`,
"label.partnerCloud.financeSetting.deduction":`アクティベートを行うと、リベートアカウント、リベートインカム、リベートエクスペンスオブジェクトにファンが追加されます。パートナーユーザーは、リベートアカウントを使用して支払い金額を差し引くことができます。`,
"message.duplication.label.updateoption":`更新時のアクション`,
"label.custom.CurrentCQ":`現在のカスタマ四半期`,
"front-kefu-moudle-wait":`待機中`,
"sunday":`日曜日`,
"label.service.timezone":`タイムゾーン`,
"setup.layout.label.selectfield":`項目の選択`,
"label_emailtocloudcc_filed_action":`アクション`,
"label.forecast.customforecast.mycommit":`私の承諾額`,
"label.uploadsuc":`アップロード成功`,
"vue_label_commonobjects_view_notice_atleast1field":`表示項目を少なくとも選択してください`,
"label.dataimport.khmc.length":`エラー：取引先名は長すぎます。`,
"label.isemailnotification":`メールアラート`,
"label.addAPPexchange":`AppExchange アプリケーションの追加`,
"label.partnerCloud.orderingPlatform.currency":`通貨。`,
"UG_quota_02":`見積は取引先とサプライヤーの間の指定された時間、指定された価格、指定された商品で取引するための法律条項です。`,
"label.customer.tab.step2.same.option3":`タブの非表示`,
"H":`電話`,
"label_tabpage_searchz":`検索`,
"vue_label_homepage_deleted":`削除されました`,
"label.weixin.recent.view":`最近表示されたビュー`,
"template.report.opportunity.sales":`機会の販売量`,
"label.customfields.new.step2.opration.unique.info.v1":`ABCをabcと重複値とします。（大文字と小文字は区別されません）`,
"savesuccess":`保存に成功しました`,
"label.partner.workspace.member.memo":`選定されたプロファイル、権限セットのすべてのユーザはこのパートナークラウドをアクセスできます。`,
"label.icon.23":`薬`,
"lable.batchadd.service.cfq.before":`トリガー(Before Insert)`,
"label.instrumentPanel.breakpointTwoLabelname":`この値は最小値とブレイクポイント1の値よりも大きい必要があります。`,
"message.selectgsummaryinformation":`集計条件を選択してください`,
"label.tianyancha.businessverify.msg6":`この機能は第3者サービスを利用しているため、多頻度利用より性能が安定していない、またはサービスができないことがありますが、CloudCCはこれに対して一切の連帯責任を負わないです。`,
"vue_label_helpcenter_report3":`3.A. フィールド検索ボックスをクリックし、検索するかフィールドのリストをスクロールして目的のフィールドを選択し、フィールドの演算子を選択し、値を入力または選択して「適用」をクリックすると、フィールドフィルタが有効になります。<br> B. フィールド検索ボックスの上にある「 」マークをクリックし、「フィルタ条件入力ボックス」に数字と文字で構成された高度なフィルタ条件を入力します。例えば、(1と2)とか、3.<br>?フィルターの編集<br> フィルターを編集するには、標準のフィルターを含め、フィルターをクリックします。<br>?フィルターの削除<br> フィルター上の「x」アイコンをクリックすると削除されます。<br>?レポートの実行<br> 編集ページの右上にある「実行」ボタンをクリックすると、レポートの全結果が表示されます。<br>?レポートを保存する<br> 編集ページの右上にある「Save」ボタンをクリックし、レポート名を記入し、レポートフォルダを選択して保存します。<br>2.レポートフォルダの作成<br>レポートフォルダを作成する前に、システムはデフォルトで「My Custom Report Folder」と「Unarchived Public Report Folder」を生成します。<br> Step 1: [Reports] タブで [New Reports Folder] をクリックします<br> Step 2: [New Reports Folder] ポップアップで、[Unarchived Public Reports] フォルダからこのフォルダにレポートを転送することを選択できます。このフォルダにアクセスできるユーザーとアクセス権を選択することができます。<br> 3.レポートの閲覧<br> Step 1: [Reports] タブから [Reports] リストページに移動し、[Recently Viewed]、[I Created]、[All Reports]、または [Reports] フォルダを切り替えて、閲覧したいレポートを探します。 または [Reports] フォルダを切り替えて、閲覧したいレポートを探します。<br> Step 2: レポート名をクリックして、レポートを表示します。または、レポートの右端にあるドロップダウンボタンをクリックし、「実行」を選択してレポートを表示します。<br>管理者プロファイルの場合は、「レポート」タブから「レポート」リストページに移動し、「新規フォルダ」ボタンの横にある歯車アイコンをクリックして、各フォルダのレポートリストのテーブルヘッダーに表示するフィールドを選択します。<br>4.レポートのエクスポート<br> Step 1: 「レポート」タブから「レポート」のリストページに移動し、エクスポートしたいレポートを見つけ、レポートの右端にあるドロップダウンボタンをクリックします。<br> Step 2: タイプを選択します。<br> フォーマットレポート：レポートのヘッダー、グループ化、フィルタリングの詳細が含まれています。<br> 詳細のみのレポート。フォーマットされていない詳細行。<br> ステップ3： 「エクスポート」をクリックします。詳細のみのレポートは、ページ単位でエクスポートする必要があり、1ページあたりのデータ数は最大2000個です。  `,
"label.batchdelete.success":`一括削除に成功しました`,
"label.newprocess5.seq":`順番`,
"label.knowledgebase.data.translated.successfully":`a] データの翻訳に成功`,
"label_enable_range":`有効化された範囲`,
"label.ccchat.and":`と`,
"label.assignment.setup.list.norule":`割り当てルールがありません`,
"vue_label_report_summaryformulacolumn":`数式列をまとめる`,
"label.field.edit.change1":`最大評価は100を超えてはいけません。`,
"syntaxerror":`構文エラーで、入力する条件をチェックしてください。`,
"label.icon.116":`家`,
"lable.asset.BOM.according.to.product":`製品構造に応じた資産BOMの作成`,
"chatter.like.post":`コメントにいいねと言った人`,
"label.trigger.page":`トリガーページ`,
"vue_label_email_contact_adminstrator":`システムが異常です、管理者に連絡してください。`,
"label.workreport":`仕事のレポート`,
"vue_label_homepage_edit_card_view":`カードビューの編集`,
"label_emailsync_status_disabel":`使用禁止`,
"label.icon.54":`掘削機`,
"message.error.view.validerr.common":`認証失敗`,
"label.exchange.sync.account.username":`サービスアカウントのユーザ名（ドメインユーザ名あるいはUPN）`,
"label.dataimport.error.date":`エラー：日付`,
"label.orgname":`組織`,
"label.weixin.group.owner":`所有者`,
"vue_label_dashboard_colorrange":`色の範囲`,
"label.forecast.shrepage.tableth":`アクセスの予測`,
"label.related.disabled":`関連リストは有効になっていません。システム管理者に連絡して、ページレイアウトで関連リスクを有効化してください。`,
"label.version.product.management":`商品管理`,
"label.knowledge.new.article.published":`新しい記事として公開されます。`,
"label.sendsms.batch.step4":`ステップ4.SMSを提出して、処理を行っている。`,
"vue_label_commonobjects_detail_and_tasks":`おめでとうございます。未処理の行動とToDoがありません。`,
"label.salescloud.ci":`個`,
"label.ccpeak.getapi.name.time":`CCServiceクラスの方法を使用するには、実例化するのが必要です`,
"label.escalation.setup.detail.conditon":`条件`,
"label.lbs.isUseLbs":`位置情報サービスを有効化`,
"front-lightning-module-v1-dashborad-color-depth":`色の濃さ`,
"date":`日付`,
"label.select.personnel":`人員の選択`,
"label.appointmentpage.wizard.notif3":`メールを記入してください。`,
"label.import.page1.pleaseselectwayofdealdata":`処理方式を選択してください。`,
"label.partner.all.memo":`リストで御社のすべてのパートナークラウドが表示されています。URLをクリックして、ログインページにスキップできます。`,
"label.appointment.wizard.subtitle4-3-3":`30分`,
"component_telerecord_label_subject":`トピック`,
"label.sendsms.batch.finish":`SMSの一括送信：完成`,
"label.login.access.myusername":`私のユーザ名`,
"label.weixin.wechatnumber":`Wechatのアカウント名`,
"label.eowechat.status":`ユーザーステータス`,
"Lead_Scoring_Setting_Rule_Setup_Value":`スコア`,
"label.appexchange.oldreport.noupload":`古いレポート‐アップロードできません`,
"label.approverfieldediting":`承認者項目とレコードの編集可能性`,
"label_tabpage_customernamez":`ユーザ名`,
"vue_label_dashboard_linkagesettings":`連動性の設定`,
"vue_label_ccchart_notice_deletecomment":`このコメントを確かに削除しますか。`,
"label.allprofile":`すべてのプロファイル`,
"label.campaignmember.main.addMember":`メンバーの追加‐検索`,
"label.projectManagement.subtask.list":`サブToDoリスト`,
"label.code.some.size":`コードキャパシティ：最大200KB文字、約200000文字`,
"front-custom-service":`Service Cloudは、効率的かつ俊敏にカスタマイズされたサービスをお客様に提供し、インテリジェントな作業指示システムによりサービス解決時間の短縮と解決率の向上を図り、お客様のロイヤルティ向上と再購入率の向上を実現します。`,
"label.SMS.det":`SMSアラートの詳細情報`,
"setup_layout_label_nobutton":`選択可能なボタンがありません`,
"vue_label_email_Could_not_save_template":`テンプレートを保存できませんでした`,
"label.imgfield.height":`高さ`,
"label.leadscore":`リードスコアリング`,
"setup_object_field_dependency_label_removefromlist":`選択された値の削除`,
"message.error.code.null":`認証コードは空にしてはいけません。`,
"label.tianyancha.businessscope":`経営範囲`,
"vue_label_chat_empty_message":`メッセージをクリア`,
"label.total":`合計`,
"label.delerror.list":`削除していないファイルリスク`,
"label.selectedreceivers":`選択した受信者`,
"label.layout.availablepages":`使用可能なページ`,
"label.pc.ui.2018.personalinfo":`個人情報`,
"label.chat.topic.edit.detial":`詳細情報の編集`,
"label.mr.descreption.reDataList1":`で`,
"label.document.value.too.long":`このファイルのサイズは5Mを超えています。`,
"lable.opppdt.addpdt.table.listprice":`定価`,
"label.selectoperate":`アクションの選択`,
"label.icon.5":`通貨`,
"label.icon.126":`病院用ベッド`,
"label.hiddensearch":`検索を非表示`,
"label.view.sortview.exportble":`エクスポート可能`,
"vue_label_homepage_noassignee":`割当て者がいません`,
"label.knowledgebase.close.and.resolve":`閉じる・解決する`,
"label.licence.used":`使用済みのライセンス件数`,
"label.newprocessstep5":`ステップ5.承認ページレイアウトで表示される項目を選択`,
"vue_label_appstore_all_applications":`すべてのアプリケーション`,
"label.no.edit.permission":`選択できません。選択されたレコードを編集する権限がありません。`,
"vue_label_calendar_calendar_added_successfully":`カレンダーの追加に成功しました`,
"report_line":`データ項目`,
"component.chatter.link.label.name":`リンク名`,
"label.data.expnode.e_desc1":`1、カスタマエクスポート：ユーザは需要に応じてエクスポートする項目及び検索条件を選択することができます。`,
"label.tabularreport.step4":`ステップ4.レポート標準の選択`,
"Opportunity.Detailed.Phase.Change.Text.001":`商談ステージの変更`,
"label.quickbooks.searchresault.action":`アクション`,
"component_timeline_label_today":`今日`,
"label.callboard.remark":`下の欄に御社のリリースを入力してください`,
"label.campagin.field.choose":`キャンペーン登録ページに含む項目を選択`,
"front-gantt-module-rolling-temporary-tasks":`一時タスクへのローリング`,
"label.file.des":`説明`,
"Dashboard_View_RecentlyView":`最近の表示`,
"UG_Account_04":`取引先フィルタリングの受動的なクエリ`,
"chatter.refresh":`更新`,
"label.tianyancha.companyorgtype":`会社種別`,
"label.chatter.dateRange":`日付の範囲`,
"label.campagin.step3":`ステップ3.ページを生成`,
"label.appointmentdetail.wizard.title14":`月曜日のスケジュール`,
"setup.object.field.dependency.button.setdependency":`項目連動の設定`,
"serviceterritorymember.serviceterritory.isactive.notactive":`このサービスエリアは有効化されていません。有効なサービスエリアのみでメンバーを追加することができます`,
"template.chart.ygydyj":`従業員の勝利命令パフォーマンス`,
"label.tag.edittags":`表示ラベルの編集`,
"label.clone":`コピー`,
"front-electronic-signature-setting-intro1":`アカウントをバインドする前に、まずDocuSignプラットフォームに登録し、認証を受けることをお勧めします。`,
"label_reach":`パフォーマンス`,
"label.tabpage.havez":`あり`,
"label.email.clearCase":`ケースに関連づけられていないメールのみを削除します`,
"label.customer.tab.all":`すべて表示`,
"label.direct.dashboard.day.report":`新規日報の作成`,
"label_tabpage_exportview":`ビューをエクスポート
`,
"label.passwordPolicy.setup.maxFailTimes":`ログイン失敗によりロックするまでの回数`,
"label.processsetting.complete.enable":`完成して有効化`,
"label.marketsea.memberfield":`メンバーが参照可能な項目`,
"label.report.export.format.title":`レポートのフォーマット`,
"label.recycle.execute.title":`ゴミ箱を空にしています`,
"label.file.use.most.user":`ストレージがより多いユーザー`,
"report_type_label_systemReport":`システムレポート`,
"label.customobjects.majorobject":`主オブジェクト`,
"label.file.delete.public.link":`公開リンクの削除`,
"front-epwechat-module-v1-id":`ウィーコムID`,
"label.partner.common.roleNum":`ロール数`,
"label.sendtonextapprover":`次回の承認者に送信`,
"label.notification.tip3":`さらに20件をアップロードします`,
"label.tabpage.placeenterz":`入力してください`,
"label.mobile.phone.cc.people":`CC`,
"component_setup_iframe_label_inputurlmemo":`導入するページURLアドレスを入力してください。`,
"label.umeng.activity.statuschange":`#name様に割り当てした行動の状況は#newstatusに修正されました`,
"label.step3.restricted.visibility":`ステップ 4.表示の制限`,
"label.multilang.datadelete.approvedata":`承認中のレコード（{0}件）`,
"label.reportsSubscription.save":`保存`,
"label.emailobject.template.visibility":`表示`,
"label_partner_step3":`ステップ3.一般情報`,
"label.product.across":`各価格表を渡る`,
"label.same.analyze.opportunity.name":`商談名`,
"label.chatter.memotel":`通話履歴`,
"label.recentview.seloption2":`最近作成したデータ`,
"label.ccchat.message.search.desc1":`が見つからないです`,
"label.reportexport":`エクスポート`,
"label.service.gantt.drop.tip":`Permission Denied:操作するのに十分な権限がありません。管理者にお問い合わせください。`,
"label.australian.westem.standard.time":`オーストラリア西部標準時`,
"label.emailobject.email":`メール`,
"Homepage_Contract_FieldMissed_DoesntSupport":`契約対象に項目の「qdrq」と「htje」がないため、データの表示ができません。`,
"label.email.cancel.upload.info":`アップロードをキャンセルします`,
"label.page.copy.merged.field.value":`差し込み項目値のコピー`,
"UG.ST.006":`直接に入る`,
"label.trigger.service.connot.access":`アクセスできないセンテンス`,
"label.projectManagement.new.tasks":`新規ToDo`,
"lable.SalesCommitmentKanBan.receiptsRate":`代金受取の達成率`,
"label.productsales.oppor.overdue":`期限切れの商談`,
"vue_label_pool_convertedbyme":`私が置換えたの`,
"label.loginip.pagecue.invalidt":`開始IP アドレスは終了IP アドレスより大きいです。または無効なIP アドレスです。`,
"label.campagin.roi.xyzj":`レスポンス件数`,
"label.visualpage.list.title":`有効化されたカスタムページへのアクセス`,
"chatter.feed.searchinitvalue":`名前を記入`,
"label.export_submission":`投稿データのエクスポート`,
"this.season":`今四半期`,
"label.forecast.settings.gx":`予測データの共有`,
"label.tag.addtags.tagcolour":`表示ラベルの色`,
"label.api":`API名`,
"label.bulk.delete":`一括削除（完全に）`,
"label.reportsSubscriptionPage.condition.emailoption":`メールオプション`,
"vue_label_dashboard_newdashboardsuccessfully":`ダッシュボードの作成に成功しました`,
"three":`三`,
"label.prompt":`メッセージ`,
"label.same.analyze.contact.phone":`取引先責任者の携帯`,
"label.icon.62":`パイプライン`,
"label.forecast.shrepage.tableth.isnable":`提出を許可`,
"label.multilang.polloption.vote":`{0}票`,
"label.customfields.totalsummary.selecttotaltype":`類型種別の選択`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`代金受取の承諾率`,
"label.areaAndSub":`エリアと下位エリア`,
"vue_label_pool_recycle":`回収`,
"lable.outlook.detail.synset":`同期の設定`,
"label.quote.detail.introduce":`キーワードを入力して、[検索]をクリックして検索を開始します。検索完了後に[選択]をクリックして、次のステップに入ります。`,
"label.profile.customappset":`カスタムアプリケーション設定`,
"label.changemylanguage":`言語の更新`,
"message.approval.plzcapppor":`承認者をご選択ください`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`公開カレンダーと資源`,
"label.wtd.changefields.title.desc1":`ページで使用する項目を選択し、返すURLを入力し、生成ボタンをクリックして、ページを生成します。`,
"label.weixin.voting.not.empty":`投票選択肢は空であってはいけません`,
"label.campaign.channel.equal":`イコール`,
"label.emailobject.emaildetail.button.back":`戻る`,
"label.ccchat.person.invite.allowemails":`セキュリティーのために、終わりが下記のようなメールアドレスのみを入力してください`,
"label.notEdit.message":`このデータを編集する権限がありませんので、システム管理者に連絡してください。`,
"label.layout.selectedfields.relatedlist":`選択された項目/関連リスト`,
"label.weixin.voting.deadline":`投票の締切日`,
"label.document.upload":`アップロードするファイル`,
"label.import.page2.notmatchfiled":`ファイルにの{csvfiledlength} 個の項目があります。残り{difflength}個の項目はマッチングされていません`,
"label.data.exp.selzippwd":`入力しないと、パックファイルのパスワードがないと認識されます。`,
"label.user.step2.select.email.template":`ステップ2.メールテンプレートの選択`,
"label.currency.effective":`有効な通貨種別`,
"label.version.control.type":`バージョンタイプ`,
"label.projectManagement.Taskorproblem":`ToDo/課題`,
"label.everyweek":`毎週`,
"label.passwordPolicy.setup.pwdremember4":`4つのパスワードを記憶`,
"label.emailobject.groupemail":`グループメール`,
"label.approvepagelayout1":`複数の人は同じページレイアウトを採用しています`,
"label.integrations.mailchimp.massage5":`CloudCCアカウントから選択したリードとコンタクトをMailchimpにインポートし、意図した受信者にメールを送信します。`,
"label.icon.22":`追加`,
"Dashboard_View_All":`すべてのダッシュボード`,
"label.import.page2.example":`例`,
"label.send.letter":`案内状の送信`,
"label.mobilesectionpart":`モバイル端末の部分`,
"component_setup_tabs_label_title":`Tabページング`,
"label.knowledgebase.results":`{a}の結果`,
"label.field.remark":`応用先`,
"vue_label_systemSettings_url":`ドメイン名の設定`,
"vue_label_SMS_failed_find_view_list":`ビューリストの検索に失敗しました`,
"setup_layout_label_order":`並び順`,
"label.customsetting.touse":`カスタマ設定の使用`,
"label.product.enter":`キーワードを入力して該当する商品を検索してください。`,
"label.email.template.private.SMS":`専用SMSテンプレートフォルダ`,
"vue_label_homepage_chart_deleted":`チャートやダッシュボードが削除されました`,
"label.conversion_pages":`変換ページ`,
"label.compact.layout.select":`キー情報レイアウト項目の選択`,
"report_label_folderandreport":`レポートとフォルダ`,
"label.product.entry":`価格表`,
"label.campaignmember.main.manageMember":`管理メンバー`,
"front-QBtoCC-changing":`更新中...`,
"vue_label_pool_abandonreason":`廃棄の理由`,
"template.report.customer.contract.statistics":`アカウントの契約分析`,
"label.invoice.message.sendsuccessully":`Invoiceの_送に成功しました`,
"label.addcurrentoperate":`既存アクションの追加`,
"label.customerinfo.mailpwd":`メールボックスのパスワードを送信`,
"batch.nochange.owner":`データ所有者を更新する権限がありません。`,
"label_tabpage_uploadfailez":`アップロードに失敗し、改めてアップロードしてください`,
"vue_label_systemSettings_mobelqrsetting":`モバイルアプリのスキャン設定`,
"label.regular_field":`フォームドメイン`,
"label.tabpage.delsuccessz":`削除に成功しました`,
"label.Days.Before.Horizontal.Date":`レベル日付の前の日数`,
"label.evaluation.general":`オーケー`,
"chatter.notlike.p":`「コメントにいいね」を解除`,
"label.chatter.send":`送信`,
"label.emailsync.button.cancel":`キャンセル`,
"label.notification.task4":`あなたのToDoは今日までです`,
"vue_label_helpcenter_detail1.2":`ToDoの状態を素早く変更する：「期限切れ・間もなく来る」モジュールのToDoの前にあるチェックボックスにチェックを入れ、更新ボタンをクリックすると、ToDoの状態を素早く「完了済み」に変更します。<br>更新する前に、チェックをキャンセルすると、ToDoの状態は変更されません。<br>優先度の高いToDoには、活動のタイムラインに「赤旗」のアイコンが表示されます。<br>活動タイムラインの表示順序<br>ToDoの締切日、録音された通話の締切日、イベントの開始日、メールの送受信日、SMSの送受信日に応じて逆順に並べます。上記の日付が同じ場合は、レコード作成時刻の逆順にソートされます。<br>活動のタイムラインフィルタ<br>活動タイムラインのフィルタを使用して、表示されるアイテムの範囲を狭めたり、重要なアイテムに焦点を当てたり、目的のアイテムを見つけたりすることができます。タイムラインのフィルターには、日付の範囲、表示する活動、活動の種類の3種類があります。<br> 表示する活動：すべての活動、私の活動<br> 活動タイムラインのフィルターでは、このオプションで活動の表示範囲を絞り込むことができます。<br> 私の行動：所有者でも参加者でも、自分が参加した活動を表示します。例えば、あなたが所有者でメールを送信したり、活動を開催したりした場合。例えば、メールのCCやBCC項目の受信者が自分である場合、行動に参加していることを意味します。<br>。`,
"component_chatter_post_label_title":`投稿&コメント`,
"label.data.dataexptemplate.desc":`データエクスポートテンプレートは、データを簡単にエクスポートするために、ユーザが作成したテンプレートです。`,
"label.helptext":`ヘルプテキスト`,
"vue_label_norm_removecomponent_certify":`コンポーネント削除の確認`,
"front-template-V1-Click-new-template":`新規」をクリックすると、新しいテンプレートが作成されます。このテンプレートを有効にして使用を開始する`,
"label.optional_fields":`任意のフィールド`,
"label.delete_about":`を削除することになります。`,
"chatter.feed.initvalue":`何を処理していますか。`,
"label.mail.configure":`取引先との送受信を行うメールボックスを配置する。CloudCCメールアドレスを使って送受信できるだけではなく、またリードと取引先責任者にメールを同期することもできます。`,
"label.project.hit.seven":`タスクの期限切れを知らせる`,
"label.button.upgrade":`エディションの購買と修正`,
"lable.PowerProcess.event.name":`重大行動の名前`,
"label.weixin.confirm":`確認`,
"label.customfields.new.inputformula":`数式を入力`,
"label.standard.buttonandlink.edit":`標準ボタンとリンクの書き直し`,
"workflow.action.tasks.assignortype.createdtype":`作成者の種別`,
"front-email-payment-paypal-describe":`続ける」をクリックすると、PayPalのウェブサイトにログインするか、PayPalアカウントを作成して請求書の支払いを完了することができます。`,
"label.selectexistingoperate":`既存アクションの選択`,
"label.workflow":`ワークフロー`,
"label.assignment.setup.detail.ruleentries":`ルールエントリー`,
"label.data.file.i.title.num3":`3.システムがデータファイルをサーバーに事前に読み込んだ後、バックグラウンドの一括インポーターを起動します。その結果はメールでユーザーに通知しますので、このページで待つ必要がありません。`,
"label.use.view":`既存ビューを使用`,
"label.forecast.settings.moren":`デフォルト商品ファミリ`,
"vue_label_calendar_add_share":`共有の追加`,
"label_tabpage_newview":`新規ビューの作成`,
"label.recycle":`ゴミ箱`,
"UG_solution_03":`ソリューションの作成`,
"label.customfields.formula.text.tip":`テキスト文字列を作成します。例えば、その他のテキスト文字列との連続を通じます。`,
"vue_label_file_single_file_size":`単一ファイルの最大限のサポート`,
"label.a.b.least":`「A」レコードには、関連「B」レコードが少なくとも1つあります。`,
"label.validate.function.addtoformula":`選択した関数を挿入`,
"label_tabpage_pleaseSelectz":`選択してください`,
"label.account.NextFQ":`次回の四半期決算`,
"label.project.project.name":`プロジェクト名を重複できません。`,
"label.emailtocloudcc.filed.owner":`レコードの所有者`,
"label.textmessage.template.message2":`現在のメールに挿入されているフィールドが、関連するレコードと一致しないため、NULL値が発生することがあります。`,
"label.icon.92":`本`,
"label.trailerpage":`ラストページ`,
"component_event_label_noevent":`今日の仕事はすでに完了しましたね。`,
"label.trigger.tip":`トリガーに関して`,
"label.knowledge.case.field.usable":`利用可能なケースフィールド`,
"label.group.isusing.success":`有効化に成功しました`,
"label.marketsea.nextnotfollowdays":`前回のフォローまで`,
"component.todaytask.label.choicestate":`状況の選択`,
"label.recordtype.main":`マスタ`,
"label.sendletter.step1":`ステップ1.案内状の受信者の指定`,
"label_tabpage_saveviewfailed":`ビューの保存に失敗しました`,
"vue_label_report_notiec_selectone":`上位オブジェクトレコードごとに、関連オブジェクトレコードが少なくとも1つ必要です。`,
"UG_opportunity_003":`販売チャネルをフォローし、ダッシュボードを作成する`,
"#label.importsourcestep4":`ステップ4.ファイルを導入`,
"front-kefu-moudle-v1-trrt-tip":`クリックしてダイヤル」の機能を実現するためには、TRRTの内線番号にユーザー（カスタマーサービスエージェント）を関連付ける必要があります。`,
"UG.Forcast.09":`次のステップ`,
"label.ggReleaseRange.subordinates":`検索の役割と部下`,
"label.log.desctiption":`組織の設定変更履歴を Excel csv ファイルとしてダウンロードできます。`,
"label.submitted":`提出済み`,
"label.validate.function.funcExplain.BEGINS":`テキストが特定の文字から始まるのかチェックし、そうであればTRUEを返し、そうでなければFALSEを返します。`,
"label.campaign.channel.code":`キャンペーン販売チャンネルのQRコード`,
"chatter.group.theLastActivityDate":`前回活動の日付`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`ブレイクポイント2の値を入力してください`,
"label.labeltranslation":`表示ラベルの翻訳`,
"label.multilang.product.deleterederect":`その他の価格表のレコードと関連付けられているため、{0}の削除はできません。関連レコードは以下通りです。`,
"lable.currencyManage.manageRate.dis":`御社のその他のオブジェクトの為替レートを管理し、新しい通貨種別を添加し、通貨種別の有効化あるいは使用禁止をし、または会社の通貨種類を変更する際に、通貨種別の管理をクリックしてください。`,
"setup.layout.label.modifypage":`ページの編集`,
"label.import.page2.editforname":`項目{necessaryName}のマッピングを編集してください`,
"label.searchlayout":`検索レイアウトを編集`,
"label.chatter.loadmore":`更に読み込み`,
"label.trigger.folder.all":`すべてのトリガーファイル`,
"label.export_submissions":`エクスポートフォームの送信`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`契約の目標総額`,
"KeyInformationLayout_DefaultLayout_Name":`システムのデフォルト`,
"label.h5.chatter.great":`気に入り`,
"label.call.center.configuration.enable":`下記の設定で組織のコールセンター機能の有効を修正します`,
"label.overdate":`終了日`,
"chatter.poll":`投票`,
"label.login.input.verification.code":`セキュリティコードを入力してください`,
"label.file.sharetype.cooperation":`協力者`,
"label.app.step5":`ステップ 5. プロファイルへの割り当て`,
"front-gantt-module-save-order":`オーダーの保存`,
"label.globalselect.toallrecord":`新規選択リスト値をこのグローバル値セットを使用するすべてのレコードタイプに追加します。`,
"setup.mainpage.label.welcome24":`クラウドプラットフォーム「CloudCC」では、システム内のすべてのオブジェクトデータに対するセキュリティアクセス設定が可能です。様々なルールや条件を設定することで、データの共有やアクセス権を配置することができます。`,
"homepage.layout.desctiption":`当該ページでは、ホームページタブに多種のタブレイアウトを作成します。`,
"vue_label_SMS_notice_send_sussess":`SMSは送信済みです`,
"label.projectManagement.overdue":`期限切れ`,
"label.assignment.setup.list.lead.description":`リード割り当てルールを使用して、リードを適当なユーザに割り当てることができます。リード割り当てルールはリードで定義される条件と多数のルールエントリからなります。`,
"label.list.projectSetting.des":`下記の設定でメールを送信しますか。`,
"setup.mainpage.label.welcome18":`CloudCCの企業レベルの権限設定では、データやモジュールを扱う際に個々のユーザーの使用権を設定することができます。また、ロールによる権限設定には、ユーザーポジション、グループ、ロール、データ共有ルール、項目レベルのセキュリティコントロールが含まれており、企業のさまざまな人や部門の間でのデータ共有が可能です。`,
"label.ratio":`前年同期比、前月比`,
"label.Xaxis":`X 軸`,
"label.google.map":`グーグルマップ`,
"Dashboard.SelectBoardToDisplay":`ダッシュボードのタブページに表示するダッシュボードを選択してください。`,
"label.data.newtemplate.e_conditions":`条件をエクスポート`,
"label.emailtocloudcc.description3":`sales@company.com、info@company.com、support@company.com のような企業のメールをここに追加し、受信したメールに従って自動的にリードやケースの記録として生成されて、取引先をタイムリーにフォローすることができます。`,
"label.page.select.profile":`使用する新規カスタマタブのユーザプロファイルを選択することができます。プロファイルの詳細情報と編集ページでタブの表示を変更することもできます。`,
"label.chosen.button":`選択済みのボタン`,
"front-epwechat-module-v1-info":`ウィーコムのバックエンド情報`,
"label.translation.select":`ご連絡ください。`,
"ten":`十`,
"label.barcode":`バーコード`,
"lable.product.nextdel":`表示されるレコードを削除し、またはクリックします。`,
"label.default":`デフォルト`,
"label.chatter.theme":`トピックス`,
"vue_label_commonobjects_view_split_screen_view":`分割画面表示`,
"label.ems.myemails":`私のメール`,
"label.email.clearPersonalEmail":`個人メールと同期されているすべてのメールを削除しますか。`,
"label.login.access.admin":`会社のシステム管理者`,
"label.emailobject.wizard.desc":`CloudCCにメールアカウントを接続すると、関連するリード、コンタクト、オポチュニティに自動的にリンクしながら、CloudCCから直接メールを送信することができます。コミュニケーション履歴は時系列でわかりやすく整理されています。`,
"label.passwordPolicy.setup.minpwdlength":`最小パスワード長`,
"choserow":`表示される列を選択してください`,
"front-epwechat-module-v1-role-binding":`ロール・バインディング`,
"lable.outlook.edit.newdata":`最も早い作成日付`,
"label.schedulejob.setup.schedule.enddate":`終了日`,
"label.quickbooks.view":`ビュー`,
"font-evaluate-module-v1-not-inform":`通知なし`,
"chatter.poll.option3":`選択肢 3`,
"setup_layout_label_selectfield":`項目の選択`,
"label.partner.common.roleSetup":`パートナークラウドロールとユーザの設定`,
"label_partner_new_step3":`ステップ3.名称とURLの入力`,
"label.transfer":`移行`,
"label.bmap.myaddress":`私の位置`,
"label_tabpage_individual":`単一選択`,
"label.autoRegister.changepwd.setpwd.repassword":`パスワードを再入力してください`,
"vue_label_commonobjects_detail_and_before":`もっと前に`,
"front-kefu-moudle-v1-single-Login-area":`シングルサインオン ドメイン名`,
"label.replacedocument":`フォルダの置換`,
"label.validate.function.category.Logical":`論理`,
"label.companyprofile.syncsuccess":`同期に成功`,
"template.chart.rwzthyxj":`タスクの対象と優先順位`,
"label.product.clearcondition":`クリア条件`,
"component_task_label_person":`*任命先`,
"label.tabpage.as":`例えば`,
"message.error.calendar.add":`カレンダーは追加済みです`,
"label.marketsea.isrecycleleadcreatebyself":`自分で作ったリードを回収しますか`,
"label.icon.57":`バロメーター`,
"UG.Lead.010":`或いは`,
"setup_object_field_dependency_label_configured":`更新済みの内容`,
"label.tianyancha.regnumber":`登録番号`,
"front-kefu-moudle-v1-Opened-chats":`チャットの有効化`,
"label_tabpage_converstatez":`状況は置換済み`,
"label.bmap.beijing.haidianqu":`北京市海淀区上地10番地`,
"label.startimport":`インポートの開始`,
"label.knowledgebase.application.default.settings":`ライトニングアプリの初期設定`,
"lable.account.year.custom":`カスタマ会計年度`,
"label.event.nextmonth":`来月`,
"label.email.body":`本文`,
"setup.object.field.dependency.label.mustsetup":`項目の依存関係を設定してから保存してください。`,
"label_tabpage_multiple":`複数選択`,
"label.task.this.month":`今月のToDo`,
"label.customfields.formula.moneyexample":`Gross Margin（売上総利益）`,
"label.tonewemailnotice":`このタスクのオブジェクトを選択し、「次へ」をクリックします。タスクは、同じタイプのワークフロールールおよび承認プロセスとのみ関連付けることができます。`,
"setup.mainpage.label.welcome11":`カスタムレポート`,
"label.layout.availabletab":`選択可能なタブ`,
"label.data.importef":`失敗したファイルのインポート`,
"label.appupload.upload.alert":`アップロードする前に、このソフトパッケージの詳細情報を提供してください。ソフトパッケージのアップロードの条件を満たすよう設定します。`,
"label.sales.accountteam.shared":`アカウント・チーム・シェアリング`,
"lable.currency.addexchageRate":`為替の追加`,
"label.page.simplified.chinese":`簡体字中国語`,
"label.service.dispatchingUnits.search.service.area":`サービスエリアの検索`,
"lable.list.queue.name":`キュー名`,
"pagecreator.button.save":`保存`,
"label.ccpeak.support.function":`単一テーブルの各種関数をサポートします`,
"label.tianyancha.legalpersonid":`法人ID`,
"label.sendemail.chat.addPostmainPage":`#name様:\n\n    こんにちは。#userName様はあなたのCCChatホームページに投稿しました。`,
"batch.no.change":`移行する権限がないデータ`,
"label.the.referenced":`参照`,
"label.input.webtab.information":`Web タブの関連情報を記入`,
"vue_label_systemSettings_subscription":`購読タイプ`,
"label.login.access.title":`ユーザにアクセス権限の付与`,
"label.schedulejob.setup.schedule.lastday":`最後の日`,
"label.synchronize.department":`ユーザーの同期`,
"label_tabpage_lessequalz":`より小さいorイコール`,
"label.file.library.successmanagemember":`メンバーの管理に成功しました`,
"label.service.major.event.oreder":`序列`,
"label.desktopintegration":`デスクトップインテグレーション`,
"label.a_b":`AからBまでの関係`,
"every":`毎`,
"label.tabpage.bar":`件`,
"label.filecontentsnotnull":`ファイル内容は空であってはいけません`,
"label.layout.detailoftestobj":`テストオブジェクトの詳細情報`,
"label.summaryreport.2018.step3":`ステップ3.レポートリスクの選択`,
"UG.Lead.002":`自品やサービスの「リード」を見極める方法はたくさんあります。`,
"label_partner_workspace_member_selectedprofile":`選択可能なプロファイル`,
"label.newdescription":`新規説明`,
"vue_label_normal_moveup":`上に移す`,
"label.mobile.quickcreate.default.logacall":`通話の記録`,
"userterritory.serviceterritory.user.unique":`このユーザーはすでにこのサービスエリアを割り当てられています。再割当てしないでください。`,
"label.weixin.record":`レコード`,
"front-kefu-moudle-connecting":`コネクティング`,
"label.monitorsys.recent.operation.log":`最新のアクションログ`,
"lable.outlook.detail.lmaping":`リード項目の対応付け`,
"lable.account.year.ovdate":`会計年度の終了日`,
"vue.homepage.auditcard.record":`レコード{recordTotal}件`,
"label.processsetting.delete.process.succeeded":`プロセスの削除に成功しました。`,
"label.customerinfo.smsPwd":`SMSゲートウェイのパスワード`,
"label.tolead.object":`オブジェクトをインポート`,
"label.data.downpage.i.list.desc2":`データをインポートした後、お知らせのメールが届きます。`,
"label.sharerule.ruletype":`ルールタイプ`,
"label.reportsSubscriptionPage.email.toothers":`私と他のユーザーへ送信します`,
"label.emailobject.templates":`テンプレートの選択`,
"vue_label_checkduplicate_":`衝突分析`,
"label.campaign.channel.lookup.example":`サンプルを表示`,
"label.login.verification.please.note":`ご注意ください：`,
"label.version.charge":`料金を徴収します`,
"label.ccdocument.show.trace":`履歴の表示`,
"label.sendemail.approval.submit":`こんにちは、#dlspr：\n      #actorname様が#actordateに提出した#objAPIName-#recordnameはあなたの承認を待っています。\n以下のリンクをクリックした、またはCRMシステムに登録して、承認センターに入って承認を行ってください。\n  #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`ユーザーは、プログラミングをせずに、システムが提示する手順に従ってマウスをクリックするだけで、レポートのカスタマを完了することができます。システムには、リスト・レポート、サマリー・レポート、マトリックス・レポートが用意されており、選択することができます。すべて項目の表示オプションも用意され、不要な項目情報を削除されます。そしてストリップ、折れ線、リング、ファンネル、ケーキなど様々なグラフィック表示を行い、ユーザーが一目でわかるようになっています。`,
"UG_contact_06":`取引先責任者のインポート`,
"message.success.event.add":`新規行動情報の保存に成功しました`,
"report.line":`データ項目`,
"label.approvepagelayout2":`それぞれ異なるページレイアウトを採用しています。`,
"vue_label_normal_contract_sf":`契約`,
"label.tabpage.tpcustomersz":`リードの置換え`,
"label.ccchat.message.new.error5":`エラー、メッセージは10000文字を超えてはいけません。`,
"label.severalorone":`個別のファイル`,
"pagecreator_systemstyle_label_buttonfontcolor":`ボタン文字`,
"label.customer.tab.step3.introduce":`新規カスタムタブを利用可能にするカスタムアプリケーションを選択してください。それぞれのカスタムアプリケーションの詳細ページ、編集ページからタブの表示/非表示も設定可能です。`,
"chatter.group.groupEdit":`チーム編集`,
"label.partnerCloud.partnerAccount.spending":`リベート支出額`,
"label.slip":`件）`,
"label.field.master.class":`主な詳細リレーションレベルは3級を超えています`,
"label.sendemail.chat.addComentsmyFeed":`#name様:\n\n    こんにちは。#userName様はあなたの書き込みに返事しました。`,
"label.service.ganttBaiduMap.selectingDispatchTime":`派遣期間の選択`,
"label.knowledgebase.remove.article":`記事フォームのアーカイブを削除しても大丈夫ですか？`,
"label.appupload.notmanaged":`アンマネージド`,
"label.report.goto.step":`ステップに切り替え`,
"label.publicgroup.save.mustbeselect":`メンバーの選択は必須です`,
"label.data.expnode.e.desc2":`2、テンプレートによるエクスポート：ユーザーはデータエクスポートのテンプレートを選択することができます。`,
"UG.product.02":`製品は販売または購入した製品またはサービスを参考にする。`,
"label.sendemailtouser":`確かに選択したユーザにメールを送信しますか。`,
"label.knowledge.setting.hint.nine":`知らなければ、その知識はどのように役立つのでしょうか？似たような記事をデータカテゴリだけで分類し、より広いカテゴリに蓄積していきます。では、データカテゴリーを追加してみましょう。カテゴリは後から追加することもできます。`,
"front-asset-module-v1-view-asset-bom":`アセットBOMの表示`,
"label_partner_all_enable":`有効化`,
"label.processsetting.disable.process.successfully":`プロセスの無効化に成功しました。`,
"label.call.center.enable":`コールセンターを有効化`,
"message.recordtype.applyitseparatly":`私に所有される`,
"label.weixin.report.customize":`カスタマ`,
"label.file.mongdb.file.is.not.exist":`ファイルは存在しません`,
"label.chat.edit.topics":`トピックの編集`,
"label.knowledge.delete.searchterm":`検索語の削除にエラーが発生しました`,
"label_emailtocloudcc_redmessage3":`サーバーアドレスを入力してください`,
"use":`使用`,
"label.batchtransfer.transferfrom":`より移行`,
"label.recycle.my":`私のゴミ箱`,
"label_json_string_null":`NULL`,
"label.version.lookupfield":`検索項目`,
"lable.tianyancha.h5.searchf":`見つからないです`,
"label.validate.globalvariable.description":`$User.[項目API]で、例えば、選択可能な項目値はid,name,roleId,roleName,profileId,profileName,department,title,emailです。`,
"UG.opportunity.006":`商談の天才`,
"label.applt.copy":`ワンタップ クローン`,
"chatter.emailMessageOrReply":`投稿あるいはコメント`,
"label.newreport.self":`選択済みの項目`,
"label.visualpage.checkpinxie":`ページのスペルをチェックしてください`,
"label.knowledgebase.article.attaching.case":`記事{name}がcaseに添付されました!`,
"label.dialogbox":`ダイアログボックス`,
"label.summaryreport.step3.new":`ステップ3：集計する情報を選択`,
"label.confirm":`確認`,
"label.mobile.buttom.team":`チーム`,
"label.quickbooks.action.link":`関連`,
"vue_label_commonobjects_view_support_to_datas":`このアクションは最大10個のデータをサポートしています。`,
"vue_label_helpcenter_homepage":`各ユーザーは、最初からスタンダートホームページと個人ホームページの2つのホームページを持っています。管理者は、ユーザーのプロファイルに応じて、対応するプロファイルホームページをユーザーに割り当てることができます。なお、Lightningバージョンのホームページと旧バージョンのホームページは互換性がありません。<br> 1.スタンダートホームページ<br> スタンダードホームページのコンテンツは統一されており、編集できません。四半期業績コンポーネント、最近表示したコンポーネント、承認センターコンポーネント、今日の行動コンポーネント、ToDoコンポーネント、期限切れの商談コンポーネント、30日以内の商談コンポーネント、今後の商談コンポーネントを含みます<br> 四半期業績コンポーネント：誰でもが四半期目標を設定できます<br> 最近表示したコンポーネント。最近表示したオブジェクトレコードを10件表示します<br> 30日連絡していない商談コンポーネント。連絡していない日数が30日以上で、確率が0または100でない5つの商談を表示します<br> 2.個人ホームページ<br> 誰でも個人ホームページを持っており、個人ホームページのコンテンツは、コンポーネントの追加や削除、ドラッグ＆ドロップによるコンポーネントの位置やサイズの調整などをカスタマイズすることができます<br> 個人ホームページにアカウントを開設すると、デフォルトでブリーフィングコンポーネント、承認センターコンポーネント、期限切れの商談コンポーネント、近日公開の商談コンポーネントが表示されます<br> 個人ホームページでは、最大15のコンポーネントを使用することができます<br> 3.プロフィールのホームページ<br> 管理者はホームページをカスタマイズすることで、プロフィールのホームページを作成/編集/削除することができ、異なるプロフィールに異なるホームページを割り当てることができるので、異なるプロフィールのユーザーは異なるホームページを表示することができます<br> 1つのプロフィールのホームページに15個までのコンポーネントが可能です<br> 4.コンポーネントの追加<br> 個人用ホームページとプロフィール用ホームページは、コンポーネントを追加してカスタマイズすることができ、ダッシュボード・コンポーネント、ダッシュボード・チャート・コンポーネント、カード・ビュー・コンポーネントを追加することができます<br> ダッシュボード・コンポーネント：システム内のダッシュボード全体をホームページに追加します。ダッシュボードのサブコンポーネントの数は、ダッシュボードコンポーネントが占めるコンポーネントの数を表しています（ホームページでは最大15個までののコンポーネントをサポートしています）。追加後のダッシュボードコンポーネントのデータは、元のダッシュボードとは関連付けられません（つまり、元のダッシュボードが削除されても、ダッシュボードコンポーネントも使用できます）<br> ダッシュボードのチャートコンポーネント：システム内のダッシュボードにある特定のチャートコンポーネントをホームページに追加することができ、このときコンポーネントの関連付け機能は無効となります<br> カードビューコンポーネント：データソースとしてオブジェクトの特定のビューを選択してホームページに追加することができ、項目や操作項目をカスタマイズすることができます。ただし、カードビューのデータソースとなるビューを削除すると、カードビューにはデータが残らないのでご注意ください。`,
"label.usersandlimit":`ユーザと権限`,
"label.sendmail.step3.introduce2":`当該メールの受信者(人）`,
"label.setupcustomfield":`カスタマ項目`,
"label.layout.last.notdel":`最後のレイアウトは削除できません`,
"label.emailtocloudcc.redmessage7":`バックグラウンド設定エラーで、管理者に連絡してください。`,
"label.includedIn":`親製品名}に含まれています。`,
"label.permission.detail.app.pagesetting":`カスタマページの設定`,
"label.addfile.tips":`{selectedNum}個のファイルが選択しました。一度に{originNum}個までのファイルを追加することができます。`,
"label.fieldinformation":`項目情報`,
"label.campagin.roi.sjcb":`実費`,
"label.email.all.works.company":`会社のすべての同僚`,
"label.currencyDesc":`このページで、組織が使用するすべての通貨種別が定義されます。会社の通貨種別を本社の収益レポートで使った通貨種類に設定します。その他の通貨種別を会社の通貨種別に指定したら、すべての為替レートも更新されます。`,
"label.file.details":`詳細情報`,
"label.foldervisitlimit3":`当該フォルダにアクセスできるのは以下のユーザのみ`,
"label.account.next.M":`来月`,
"label.oweralias":`所有者の別称`,
"label.projectManagement.entryname":`プロジェクト名`,
"label.customcomponent.page.add.title1":`コンポーネント情報`,
"label.projectManagement.PleaseenterCreator":`作成者を入力してください`,
"label.multipleactivity.memberselected":`選択済みのメンバー`,
"label_chatter_memotel":`通話の記録`,
"lable.Confirm.customers":`{num}個のリードを回復することを確認する。`,
"front-email-payment-Invoice-number":`インボイスNo.`,
"label.not.appoint.validation":`指定する入力規則のオブジェクトがないため、指定してください。`,
"label.peru.time":`ベルー時間`,
"label.setting.intergrationlist.status3":`QuickBooksアカウントでのログインが必要です`,
"vue_label_display_number_field":`数字項目の表示`,
"label_productline_count":`製品シリーズの数量`,
"label.data.downpage.i_title.num2":`2、データをインポートする前、項目名が CloudCC 項目名と一致していることを確認します。`,
"label.field.duplicate4":`ABCをabcと違う値とします（大文字と小文字は区別されます）`,
"message.approval.step.validation.invalid.levels":`階層は少なくとも1です`,
"label.tianyancha.businessverify.step1":`企業データ検証ステップ1を有効化`,
"label.hidedetail":`詳細に非表示`,
"UG_Lead_009":`APP通話記録`,
"label.partnerCloud.newProductSeries":`新製品ファミリー`,
"label.brief.opportunities":`商談件数`,
"label.user.mfa.unbind.remind":`選択したユーザに対してMFAのバインディングを解除します。次回にログインした後、MFAデバイスを改めてバインディングする必要がりますが、確認してください。`,
"vue_label_report_grouprow":`グループ行`,
"setup.layout.label.newarea":`新規エリア`,
"label.nostart":`未開始`,
"UG_Lead_010":`或は`,
"label.emailmerge.mergepage.record.requeired":`マージするレコードを選択してください`,
"label.appointmentpage.wizard.notif1btn1":`確認`,
"UG.Account.02":`ある企業は他の企業にサービスを提供し、ある企業はエンドユーザーと直接に提携し、またある企業はNGOにサービスを提供しています。`,
"label.address.country":`国/地域`,
"label.userinfo.updatepwd":`パスワードを更新`,
"label.salescloud.teamrole.optionlist.opportunity":`商談チームメンバーの追加先`,
"lable.account.Current.FY":`現在の会計年度`,
"chatter.coll.p":`当該投稿をブックマークします`,
"label.setupsms":`SMS`,
"label.atlantic.daylight.time":`大西洋夏時間`,
"label.recordslock":`レコードロック`,
"button_partner_search":`検索`,
"vue_label_salesfunnel_notice4":`可能性が1%～99%である商談の金額`,
"vue_label_report_statistics":`統計`,
"label.ccchat.notmember.active.group0":`名称に{0}が含まれる活動チームのメンバーではありません。`,
"label.tag.manage.newtag":`表示ラベルの作成`,
"label.customfileds.formula.dateandtime.tip":`日付/時間を計算します。例えば、他の日付/時間に一定の日数をプラスします`,
"label.weixin.mobile.fly.ios":`iosモバイル端末の共有`,
"vue_label_file_over_file_size":`file.name  'のファイルサイズはシステムのプリセットを超えています。`,
"label.schedulejob.setup.schedule.last":`最後`,
"label.ccchat.whose.name.contains":`いずれの活動チームのメンバー`,
"label.project.milestone.name":`1つのプロジェクトでマイルストーンの名前は重複してはいけません。`,
"message.passwordPolicy.validate.reuse":`エラー：当該パスワードを再使用しないでください。`,
"label.stdashbord.xsld.business.img3":`可能性が1%-99%の段階にある金額*可能性`,
"label.event.view.list":`ビューリスト`,
"label.workflow.ruletriggertime":`ルールのトリガ時間`,
"label.campaign.channel":`キャンペーン販売チャンネル`,
"label.appexchange.emailnotice":`ワークフローのメールアラート`,
"label.icon.77":`農業`,
"label.visualpage.display.value":`表示する値を入力し、前後がスペースを入れてはいけません。`,
"label.forecast.customforecast.type.user":`ユーザに基づく`,
"label_tabpage_lessz":`より小さい`,
"label.same.analyze.contact.email":`取引先のメールボックス`,
"vue_label_report_range":`範囲`,
"lable.product.pricebooks.nr":`以下の選択リスクを選択して、既存の価格表から内容をコピーします。`,
"label_mobile_buttom_team_setUp":`チームの設定`,
"label.email.bcc.recipients":`BCCの宛先`,
"vue_label_ccchat_notice_deletepostfail":`書込みの削除に失敗しました。`,
"label_file_type":`ファイル種別`,
"label.multilang.feedtrack.operateupdate":`{0}のレコードを更新しました`,
"label.contractmanager":`契約マネージャー`,
"front-gantt-module-drag-one-task-sorting":`タスクは同じマイルストーンの中でしかソートできません。`,
"label.partner.step2":`ステップ2.テンプレートの確認`,
"front-epwechat-module-v1-again-binding":`リバインド`,
"label.service.miniProgram.imageSize":`アップロードする画像は2MBを超えてはいけません。`,
"setup_main2018_label_managesetup":`設定管理`,
"component_salesperformance_label_nopermission":`商談関連データを参照すう場合に、システム管理者に連絡してください。`,
"lable.account.stadate":`四半期決算の開始日`,
"label.service.gantt.and.resourcestype":`リソースタイプは`,
"label.ems.attachfiles":`ファイルの追加`,
"label.data.expnode.e.desc1":`1、カスタムエクスポート：ユーザーはニーズに応じて、エクスポートする項目を選択し、フィルタ条件を設定することができます。`,
"vue_label_systemSettings_analyse":`分析`,
"label.project.all.date":`終了日は開始日と同じか、または大きい必要があります。`,
"vue_label_commonobjects_view_summary_basis":`まとめ基準`,
"template.chart.yywjhdschd":`チャンスのあるキャンペーン`,
"vue_label_pool_notmeet":`取引先の要望に応えられない`,
"label.attendance.manager":`勤怠場所の管理`,
"vue_labenl_normal_current":`現在`,
"label.projectManagement.completed.quantity":`完成数`,
"label.layout.testfield":`テスト項目`,
"label.customfields.selectcontainrelatelistlayout":`当該関連リスクを含むページレイアウトの選択`,
"label.fiji.time":`フィジー時間`,
"message.error.domain.already.exists":`ドメイン名はすでに存在しています`,
"label.accountandcontact":`取引先/取引先責任者`,
"label.dashboardSetup.right":`右`,
"label.view.appliedMobile.xgry":`当該オプションをチェックして、関連者のトップページワークベンチで当該ビューを参照することができます。`,
"label.file.share.all":`会社のいずれのユーザ`,
"vue_label_pool_summary":`合計 {0} 件のレコードはすでに{1} で更新されました。`,
"label.emailtemplate.new":`新規メールテンプレート`,
"label.tag.manage.button1":`表示ラベルの作成`,
"label.data.exp.tempexppage":`データエクスポートテンプレートページ`,
"font-trade-module-v1-invoice-total":`請求書の合計金額`,
"label.folder.sort":`フォルダの並び替え`,
"label.multilang.campaign.countnum":`{0}回`,
"label.homepagelayout":`ホームページレイアウト`,
"setup_layout_button_cancel":`キャンセル`,
"lable.Search.in.QuickBook":`QuickBookで検索する`,
"setup_fielddependency_label_pleaseclick":`「コントロール項目の値」をクリックして、編集を行ってください。`,
"setup.fielddependency.label.pleaseclick":`「コントロール項目」 の値をクリックして編集してください`,
"label.version.sum.field":`カスタマ項目`,
"label.form.is.submitted.successful":`フォーム送信成功時のプロンプト`,
"label.campaignmember.main.batchaddmember":`キャンペーンメンバーの一括追加`,
"label.sendemail.activity.newevent":`#belongtoidccname様、こんにちは。\r\n  同僚の#createbyidccname様は#createdateに新しい行動を割り当てしました。内容は以下の通りです。\r\n  トピックス：#subject\r\n  開始時刻：#begintime\r\n  終了時刻：#endtime\r\n  関連先：#relatedstr\r\n  内容：#remark\r\n  詳細情報については、\r\n #path\r\n にアクセスしてください。                     #orgNameCRMシステム`,
"label.knowledgebase.select.target":`ターゲットを選択してください`,
"setup.layout.label.buttonlist":`ボタンの選択`,
"pagecreator.page.label.pagedesc":`ページの説明`,
"label.version.professional":`専門版`,
"UG.Forcast.10":`完成`,
"template.chart.schdyqsr":`キャンペーンによる収入見込み`,
"front-filter-module-v1-quick-filter":`フラッシュフィルター`,
"label.notification.group2":`公開グループへの加入は成功しました。`,
"label.ServiceCloud.statistics.by.serviceArea":`サービス地域別の統計`,
"label.validate.function.funcExplain.TIMENOW":`現在の時刻に戻る（時分秒）`,
"label.brief.lastmonth":`先月`,
"label.weixin.member.states":`会員状況`,
"template.chart.ljxsje":`累積販売額`,
"label.eidt.queue.label.hasused2":`このキュー名はすでに使用されました`,
"label.textmessage.nophonenumber":`この連絡先には、携帯電話の番号が記録されていません。`,
"label.task.new":`新規ToDo`,
"label.tabpage.grid":`グリッド表示`,
"label.workbanch.setup.viewname":`ビュー名`,
"front-gantt-module-temporary-tasks":`一時的なタスク`,
"label.reportTypeDescripe":`カスタムレポートタイプを使用すると、ユーザはあらかじめ定義したオブジェクト、オブジェクトリレーション、および項目から、レポートを作成できるようになります。`,
"setup_layout_label_fieldlist":`使用可能な項目`,
"label.ggReleaseRange.searchforRole":`検索パートナーの役割`,
"label.datamanage.account.field":`取引先項目`,
"label_tabpage_groupingemptyz":`グループ化項目は空であってはいけません`,
"label.permission.edit.insertinfo":`権限セット情報の入力`,
"label.back_forms":`フォーム一覧に戻る`,
"vue_label_calendar_step_2":`ステップ2： スタンダードオブジェクトまたはカスタムオブジェクトを選択して、カレンダーを作成する。`,
"lable.outlook.mcto.out":`排除したドメイン`,
"label.workflow.accessnext":`以下の条件を満たしたら、当該ステップに入ります。`,
"label.data.exp.temppage":`データエクスポートとテンプレート作成のページ`,
"label_tabpage_printview":`ビューをプリンター
`,
"vue_label_report_preview":`最新の編集内容を表示するには、プレビューを更新してください。`,
"frame_personinfo_label_personimage":`プロファイルの写真`,
"component.chatter.button.like":`気に入り`,
"label.ems.drafts":`下書き`,
"front-lightning-module-v1-details-page-chart-report-name":`レポート名`,
"label.partner.workspace.login":`ログインページ`,
"include":`含む`,
"label_length_20":`文字数は20文字までです`,
"component_event_button_save":`保存`,
"label.weixin.recalculate.shared.success":`オブジェクトの共有ルールの再集計に成功しました`,
"message.duplication.errorinscript.lessthan2":`2つ以上のマージするレコードを必ず選択します。`,
"label_my_forecast":`私の予想`,
"label.ems.to":`受信者`,
"label_mobile_buttom_team_init":`チームユーザーの初期化`,
"label.sendemail.send.codeerror":`コードの置換に失敗し、正しいコードを使用してください`,
"lable.quote.syncing.and":`と`,
"label.campaignmember.selectmember.step1oftotal":`ステップ 1/2`,
"label.ems.step3":`ステップ3`,
"lable.PowerProcess.detail.message":`エンタイトルメントロセスの情報`,
"chatter.poll.option2":`選択肢 2`,
"front-view-module-v12-verify-number":`数値フォーマットのエラーです。入力データを確認してください。`,
"label.setup.mobile.homepageshortcuts.savesuccess":`モバイル端末ホームページのショートカット機能設定の保存に成功しました。`,
"lable.outlook.edit.zdyoutfi":`Exchange項目名のカスタマイズ`,
"label.assignment.setup.newentries.inputentries":`ルールエントリーの入力`,
"label.customfields.money.tip":`ユーザーにドルまたはその他の通貨の金額を入力することを許可し、また項目を通貨金額形式に置き換えます。この機能はデータを Excel またはその他のスプレッドシートにエクスポートするときによく使用されています。`,
"label.service.appointmentList.cancelThePlan":`プランのキャンセル`,
"label.chat.topic.suggest.add.topic":`異議なし。トピックスを追加してください`,
"vue_label_commonobjects_detail_tips":`ヒント`,
"message.error.view.nameexists":`エラー：ビューの一意の名前は存在しません`,
"label_emailtocloudcc_step2_name":`メールのホームの配置`,
"label.field.validation.apiname":`文字から始まり、アンダースコアと英数字しか使用できません。最大文字数は50、最小文字数は2文字になり、データペースのキーワードを含んではいけません。`,
"page.field.masterinput.remark2":`例えば、販売注文を作成するとき、同じページに販売注文の明細も入力するには、この機能を有効化する必要があります。（この機能は主な詳細リレーションのオブジェクトの使用によく適しています）`,
"label.rule.enabled.successfully":`ルールの有効化に成功`,
"label.role.createrolelist.tip":`以下は組織のロールリスクです。ロールリンクをクリックして詳細情報を参照することができます。`,
"label.multilang.datamanage.dataimport.redundantmsg":`タイトルの長さは&nbsp;{0}&nbsp;で、データの長さは&nbsp;{1}&nbsp;です。システムはどれ&nbsp;{2}&nbsp;の項目が余ったのを確認することができません。`,
"label.visualpage.staticresource":`静的リソースの参照`,
"chatter.group.members01":`メンバー`,
"label.planned.workname":`ジョブ名`,
"label.service.dispatchingUnits.gantt.data":`ガント表の日付にマッチする`,
"label.data.newtemplate.t.conditions":`テンプレート条件`,
"label.accmarketsea.edit.title":`取引先プールの編集`,
"label_chatter_priority":`優先度`,
"label_mobile_buttom_team_open":`PCとアプリチームを有効化する`,
"front-gantt-module-no-tasks-available":`利用可能なタスクがない`,
"component.newrecords.label.type":`ストレージタイプ`,
"label.version.ccdocument.and.remark":`添付ファイル&メモ`,
"label.martrixreport.step2":`ステップ2.集計情報のグループ化方式を選択`,
"label.projectManagement.Scheduleinformation":`タイムテーブル情報`,
"label.emailmerge.mergeFolder.description":`当該ページで、取引先データを含むMicrosoft Wordフォルダを生成することができます。差し込み印刷テンプレートを選択してください。最大20つまで選択可能になります`,
"label.autoRegister.changepwd.setpwd.tip":`パスワードの設定は以下の条件に満たす必要です`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`カートが空なので、「商品を追加する」をクリックして追加してください。`,
"label.marketcloud_seminar":`Marketing Cloudセミナー`,
"label.knowledgebase.no.results.knowledge.search":`知識で「{a}」に関する検索結果はありません。`,
"label.createdate":`作成日`,
"vue_label_systemSettings_bazaar":`マーケット`,
"report_type_label_contractPayment":`契約と代金受取`,
"label.myemailset":`私のメールの設定`,
"label.emailtype":`メール種別`,
"label.appexchange.uninstallpage.message5":`このパッケージでのカスタマオブジェクトに関連するリレーションシップと関連リスクを完全に削除します`,
"label.customerinfo.applicationlicencenum":`機能別ライセンス数`,
"label.product":`商品`,
"lable.opppdt.selPdt.subtitle":`商品選択の用途`,
"label_emailtocloudcc_step1_lead1":`Email to Lead`,
"label.multilang.recentview.query":`最新の{0}を表示します。`,
"label.cumstom":`カスタマイズ`,
"lable.product.pep":`価格をのご入力ください`,
"label.suggestion":`意見`,
"vue_label_email_sentto":`ために`,
"label.email.cancel":`関連付けを解除すると、そのメールボックスを使ってメールの送受信ができなくなります。本当にアソシエーションを解除していいのか？`,
"component_timeline_label_1monthahead":`前の一か月`,
"setup_mainpage_label_welcome31":`アクションガイド：このページの右側のメニュー → 管理の設定 → 作成 → アプリケーションをクリックしてください。`,
"label.weixin.settlement.rate":`代金受取の達成率`,
"front-lightning-module-v1-details-page-chart-add-report":` レポートのチャートは最大4枚まで追加できます。`,
"label_related_list_types":`ライトニングバージョンの関連リストのタイプ`,
"label.tabpage.converstatez":`ステータスが置換え済みです`,
"label.chatter.ok":`確認`,
"lable.SalesCommitmentKanBan.contractRate":`契約の達成率`,
"component.setup.label.setupsavefail":`コンポーネント設定の保存に失敗しました`,
"label.email.form.text2":`「HTMLに切り替え`,
"UG.Lead.009":`APPの通話履歴`,
"label.escalation.setup.newrule.title":`ケースグレードアップのルール`,
"label.field.available.value":`取得可能な項目値は`,
"label.cannotuseaddtimetrigger":`<b>  追加した時間トリガーボタンは以下の状況で使用できません。<br/><ol><li>  ルール条件が毎回作成あるいはレコードの編集であるとき、</li><li>  ルールは有効化されました。`,
"vue_label_chat_activefail":`有効化に失敗しました`,
"label.dashboard.show.total.percent":`表示件数と表示%を少なくとも1つ選択してください`,
"label.schedulejob.setup.schedule.jobprg":`ジョブプロセス`,
"label.select.email.type":`Eメールの種類を選択してください。`,
"chatter.group.allTheMembers":`すべてのメンバー`,
"label.webtab.validation.apiname":`文字から始まり、アンダースコアと英数字しか使用できません。最大文字数は20、最小文字数は2になります。`,
"label_partner_new_step3_name":`名称`,
"vue_label_chatter_remove_member":`メンバーの削除`,
"label.customobjects.majorobject.tip":`主な詳細ではないリレーションを選択すると、データを集計するなら権限が要りません。`,
"label.forecast.edit.kjjd":`四半期決算`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`三週目`,
"label.weixin.senderror":`送信失敗`,
"label.visiturl":`URLを見る`,
"label.apply.img.error":`図の中の文字は正しく入力されていない。`,
"label.been.detained":`割引のリセット`,
"vue_label_helpcenter_dashboard2":`<br> 新しく作成したダッシュボードでは、まずコンポーネントを追加し、レポートデータソースまたはリストビューデータソースを選択する必要があります。次に、使用するチャートの種類を決定し、対応するグループ化と統計データを選択してチャートを作成します。<br> コンポーネントを追加した後、ダッシュボードの「並び替え」ボタンをクリックして、コンポーネントの位置とサイズを調整することができます。<br> 一部のコンポーネントに時間のフィルター条件を設定する必要がある場合は、「フィルター条件設定」をクリックしてコンポーネントを選択し、コンポーネントがフィルターする必要のある時間フィールドを設定することができます。設定後は、ダッシュボード上で時間によるフィルタリングを行い、対応する時間範囲を選択して、選択したデータを更新することができます。<br>注：ダッシュボードは最大10個のコンポーネントをサポートしています。<br> 2.コンポーネントの浸透と連携<br> 同じダッシュボード内で、コンポーネントAは同じデータソースからコンポーネントBとCをその連携オブジェクトとして設定することができます。設定完了後、コンポーネントAのデータ領域をクリックすると、コンポーネントBとコンポーネントCは、コンポーネントAのデータ領域の条件に基づいて、同時にデータの再カウントを行います。<br>なお、コンポーネントBやコンポーネントCのデータ領域をクリックしても、コンポーネントAの再カウントは行われません。この効果を得るためには、コンポーネントAをコンポーネントB/Cのリンケージオブジェクトとして設定する必要があります。<br> ダッシュボード内の各チャートコンポーネントでは、データはビューまたはレポートから来ています。そのため、貫通機能が用意されています。つまり、コンポーネントのデータ領域をクリックすると、対応するレポートやリストビューにジャンプすることができるのです。なお、元のデータソースに障害が発生した場合、コンポーネントにはデータがなく、ペネトレーション機能も障害となります。<br> ペネトレーションとリンケージはどちらもコンポーネントのデータ領域をクリックするものなので、両方同時に効果を発揮することはできません。コンポーネントにペネトレーションとリンケージの両方が設定されている場合、コンポーネントは同時に1つの機能しか有効にすることができず、リンケージとペネトレーションの状態を切り替えることで有効な機能を選択することができます。`,
"vue_label_commonobject_view_notice_delete_false":`レコード{0}の削除に失敗しました。理由は{1}です。`,
"label.weixin.newspaper.coverage.information":`リスクシートの情報`,
"label.you.do.not.have.permission.to.operate.":`操作するためのアクセス権がありません。`,
"label.checkfield.match":`マッチング`,
"message.custom.field.donotdelete.ref":`当該項目はその他の項目に参照されています`,
"label.version.maxsum":`、上限に達しました。`,
"System.ChangeUser.Info.001":`所有者の変更に成功しました。このレコードを参照する権限がありません。クリックしてから前のページに戻ります。`,
"label.target":`目標`,
"template.dashboard.behavior.analysis":`アクション分析`,
"label.login.verification.enter.prompt":`数字6桁のセキュリティーコードを入力してください`,
"label.am":`午前`,
"chatter.emailSetUp.remark":`CCChat では、誰かがあなたをフォローしたり、投稿したりしたときに、メールで通知を受信することができます。`,
"label.accmarketsea.grouplist.title":`取引先プールのグループ化設定`,
"label.stdashbord.xsld.business.danwei":`単位：万元`,
"label.app.step1.error.namenull":`公開チーム名は空であってはいけません`,
"label.login.button.verification":`入力規則の提出`,
"label_tabpage_newWizardz":`新規機能ウィザード`,
"label.addattachment.step1.intruduce":`ファイルパスを入力し、またはボタンをクリックしてファイルをチェックします`,
"pagecreator.layout.funcpath":`/ ビルダー/レイアウトライブラリー`,
"fourth":`四番目`,
"label.timetrigger.after.lasttime":`最終更新日より1日遅い`,
"vue_label_report_showme":`私に表示します`,
"label.h5.similar.opportunity.end.date.in":`終了時刻は以下の時間範囲内です`,
"label.turntonextstep":`次のステップへ`,
"label.icon.106":`スケジュール`,
"label.user.receivenewsbulletin":`ニュースダイジェストの受取`,
"label.mask.card.number":`クレジットカード番号`,
"setup.object.layout.label.profileoptions":`割当てが可能なプロファイル`,
"vue_label_systemSettings_obj":`オブジェクトとフィールド`,
"label.call.center.history.open":`自動的に通話記録ページを開きます`,
"label.attendance.cityname":`都市名を入力してください`,
"label.newemailnotice.tip":`メールアラートを作成し、1 つ以上のワークフロールール、承認プロセス、またはエンタイトルメントプロセスと関連付けます。メールアラートを変更すると、変更はそれに関連付けられているすべてのルール、承認、またはエンタイトルメントプロセスにも適用されます。`,
"label.app.step1.error.labelnull":`エラー：表示ラベルは空であってはいけません`,
"front-kefu-moudle-connect-free-account":`CloudCCユーザーとTRRTのトライアルアカウントの関連付け`,
"label.biaoqingfaxian.description":`bid&tender discoveryの有効化をチェックすると、フロントエンドにbid&tender discoveryのメニューを追加し、ユーザーは関連業界の入札情報を参照して、入札データをリードに置換えることができます。`,
"label.filter":`フィルター`,
"label.data.downpage.e.title.num1":`1、エクスポートするオブジェクトを選択するか、すべてをエクスポートするかを選択します。`,
"label.h5.similar.opportunity.last.months12":`直近の9-12か月`,
"label.chatter.name":`名前`,
"vue_label_helpcenter_email":`1.メールの送信<br> 取引先責任者とのコミュニケーションのために、システムから離れてメールボックスに移動するのは、すでに時代遅れです。Cloud CCでは、個人のメールアドレスを関連付けて、Cloud CCから直接的にメールを送信することができます。受信者のメールアドレスや名前を入力すると、取引先責任者やリードのレコードをマッチングしてもらえるので安心です。また、メールレコードを設定された関連レコードと関連付けることができ、送信したメールはレコードの詳細ページで同期されます。<br> 2.メール送信時の4つの共通機能<br>メールを送信する際、メール本文の下にある4つの機能を使って作業を補助することができます。<br>メール追跡<br>メール追跡をオンにすると、このメールが開封された回数や最後に開封された時間をモニターすることができます。送信ボックスリストの「目」のアイコンにマウスを合わせると表示されます。<br>添付ファイルのアップロード<br>添付ファイルのアップロードをクリックすると、システムにアップロードされているファイルを選択することができます。添付ファイルのサイズが20M以下であれば、複数の添付ファイルを選択することができます。<br>マージされた項目の挿入<br>メールがオブジェクトレコードに関連付けられている場合、マージ項目を挿入するためにクリックし、関連付けられたオブジェクトを選択し、挿入する綱目を選択し、{!Contact.FirstName,Sir or Madam }のように、マージ項目のコンマの後に置換テキストを入力します。テンプレートを保存すると、マージ項目がテンプレートのメールテキストに表示されます。メールコンテンツをパーソナライズするためにマージ項目を使用します。任意のマージ項目に置換テキストを追加できます。置換テキストは、マージ項目にその項目のデータが含まれていない場合にのみ表示されます。<br>署名の編集と有効化<br>仕事用のメールを送信する際に、自分のアイデンティティを表すことができる署名があれば、仕事上のプロ意識を高めることができます。「署名の編集」ボタンをクリックすると、基本的な情報を編集することができ、写真を挿入することもサポートしています。「署名の有効化」をチェックすると、メールを作成するたびに、署名が本文に添付されます。署名はいつでもオフにすることができます。<br> 3.受信箱のフィルタリング<br> 受信箱の中の未読メールをすべてフィルタリングして、作業を円滑に進めることができます。メールでファイルをダウンロードするとき、受信ボックスの中の添付ファイル付きのメールをすべてフィルタリングすることができるので、必要なメールを素早く見つけることができます。また、オープンな商談を含むメールを選別したり、リードや取引先責任者から送られてたメールを選別したりすることで、メールで追跡したシステム内の取引先のレコードを素早く確認することができます。<br> 4.一括送信<br> リードや取引先責任者のリストの右上には、一括送信のボタンがあります。メールアドレスがあるリードや取引先責任者に一括送信することができます。キャンペーンレコードがある場合、キャンペーンのメンバーに一括送信するとができるので、行動の招待状を送るのにも便利です。`,
"front-kefu-moudle-auto-callphone":`接続された通話に対して新しいケースを自動作成する`,
"label.fiscal.FQ":`会計四半期`,
"label_tabpage_groupsVisiblez":`選択されたユーザーグループ`,
"UG.product.01":`製品・サービスの紹介`,
"vue_label_commonobjects_view_members":`選択可能なメンバー`,
"label.organization.id":`組織ID`,
"label.tyle_preview":`スタイルプレビュー`,
"label.campaign.channel.input.to.owner":`6. メンバーサインインの所有者への通知を設定してください：`,
"label.appointmentconfirmpage.wizard.notif1":`予約はすでにキャンセルされました`,
"lable.tianyancha.maping":`項目の対応付け`,
"front-kefu-moudle-v1-noadd-online-chats":`オンラインエージェントが追加されない`,
"vue_label_commonobjects_detail_group_strategy":`この取引先のチームに加入しました。`,
"vue_label_report_deletegrouprow":`グループ行の削除`,
"lable.account.y.d":`このページでカスタマ会計年度を定義することができます。カスタマ会計年度の日付は下記に行う選択により生成されます。`,
"label.visualpage.lllegal.definitions":`無効な定義`,
"label.tabpage.enterrecordnamez":`レコードの所有者を入力してください`,
"vue_label_report_howmuchlines":`{長さ}行`,
"homepage.components.custom":`カスタマコンポーネント`,
"label.campaign.channel.upload.img":`画像をアップロード`,
"UG_Case_03":`ケースの自動的なグレードアップ`,
"label.approved.receiveApprovalEmail.option4":`ずっとしない`,
"System.Data.Import.Warning.MaxCount":`貴社では、一度に{0}件のデータしかインポートできません。現在制限を超えていますので、調整して再度インポートしてください。`,
"label.sent.sms":`SMSの送信`,
"vue_label_dashboard_statistictype":`統計の種類`,
"label_report_last_year_same":`前年同期 前年同期`,
"lable.Examle":`例`,
"label.customerinfo.PageTriggerFagTitle":`2時間に1回同期できます`,
"label.mobile.phone.read":`レビュー`,
"label.product.gopage":`スキップ先`,
"label.a_b_without":`Aレコードに関連Bレコードがあり、またはありません。`,
"front-kefu-moudle-callin-missphone":`不在着信の呼び出し`,
"label.sso.saml.sp.idsource.attrname":`プロバイダ名`,
"label.h5.chatter.colleagues2":`同僚`,
"label.approveprocess":`承認プロセス`,
"label.dataimport.error.name.null":`エラー：名前はNULLです。`,
"label.paging.countitems":`{0}件`,
"vue_label_report_notice_filter":`高度なフィルターを有効にしていない場合、異なるフィルター条件は「アンド」、つまり1と2の共通の特徴を満たすレコードはレポートに表示されます。例えば、1は金額が100万以上の商談で、2は契約予定日が今月と同じであるため、レポート結果は「今月の100万以上の商談」となります。`,
"front-lightning-module-v1-dashborad-export-picture":`エクスポートイメージ`,
"label.activity.disabled":`活動は有効化されていません。ページレイアウトで活動履歴と活動予定を有効化するよう、システム管理者に連絡してください。`,
"message_chooseatleastonefield":`表示する項目を少なくとも1つ選択してください。`,
"label.case.text":`Webサイトから送信されたサービスリクエストフォームは、システム内にケースレコードを生成することができます。ケースレコードの作成者としてユーザーを選択し、選択されたユーザーはケースオブジェクトの作成権限を持っている必要があります。Webページは、パソコンと携帯電話で利用できます。`,
"label.sendmail.step3.dealoption1":`私にBCCメールを送信してください`,
"label.forecast.settings.title.remark":`最も最適な収益予測値を獲得するため、これらの予測はユーザに全体的な業務ビューを提供します。`,
"label.apply.youxiaotime.finish.opperation":`有効期間は5分間で、できるだけ早くアクションを完成して下さい。このアクションを行わなかったら、このSMSを無視してください。`,
"label.user":`ユーザ`,
"pagecreator.page.button.copy":`コピー`,
"label.userinfo.pwdupdate.or.reset":`パスワードは前回更新あるいはリセットされました`,
"label.fieldupdata":`項目の更新`,
"label.sendemail.chat.followsubject":`CloudCC CCChat フォローする人がいました`,
"component_task_label_enddate":`期限日`,
"label.campaign.channel.step6.remark5":`リード割り当てルールを通じて再割り当てできます。割り当てルールに関しては`,
"label.mr.title.mobilePhone":`携帯`,
"label.notice":`通知`,
"message.serviceappo.time.violation":`サービス予約の利用可能ば時間の違反：サービス予約の開始日は許可された最も早い開始日よりも早いです。`,
"label.account":`取引先`,
"front-kefu-moudle-callcenter-user":`コールセンターユーザー`,
"label.usermanage.query.notexist":`検索したユーザは存在しません`,
"label.forecast.userinfo.isnable":`予測を許可`,
"label_partner_workspace_member":`メンバー`,
"vue_label_dashboard_penetrationsetting":`ペネトレーション設定`,
"chatter.fieldtrack.operatecreate":`1件を作成した`,
"label_tabpage_tpcustomersz":`リードの置換`,
"label.emailtocloudcc.redmessage6":`IMAP/SMTP認証に失敗しました。メールアドレスとパスワードが正しいかどうか確認してください。`,
"label.customfields.file.upload":`アップロード`,
"label.forecast.isforecast":`収入予測を有効化していません`,
"label_benchmark":`参考`,
"label.exchange.sync.state.system":`システムの同期状況`,
"UG.opportunity.003":`販売チャネルの追跡　ダッシュボードの作成`,
"label.campaign.matchway.select.error":`データを更新するには、一致方式を指定してください`,
"vue_label_dashboard_located":`ダッシュボードがあるフォルダ`,
"front-electronic-signature-enter-object":`オブジェクトを入力してください`,
"vue_label_systemSettings_mobelquick":`モバイルアプリケーション クイックセットアップ`,
"lable.outlook.list":`Exchange Syncの更新`,
"label.sendemail.approval.dlsp":`こんにちは、#dlspr：\n      #actorname様が#actordateに提出した#objAPIName-#recordnameは承認者があなたを代理承認者を設定したため、あなたの承認を待っています。\n以下のリンクをクリックした、またはCRMシステムに登録して、承認センターに入って承認を行ってください。\n#url\nありがとうございます。\n#orgName`,
"label.service.deleteCustomView.wanttoremove.filter":`確かに"{name}"フィルターを削除しますか。`,
"component_task_label_newevent":`*状況`,
"vue_label_commonobjects_view_chart_groupby":`グループ化の方式`,
"front-kefu-moudle-v1-edit-chats":`エディットエージェント`,
"pagecreator_page_message_delete_fail":`ページの削除に失敗しました`,
"label.file.search":`ファイルの検索`,
"label.projectManagement.Addpredecessors":`プリタスクの追加`,
"label_tabpage_norecordtypez":`使用不可能なレコードタイプ`,
"label.come.recycle.bin":`ゴミ箱に入る`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`相対的`,
"label.customfields.address.tip":`ユーザは都道府県、市町村の項目を選択し、また具体的な住所を入力することができます。これにより、緯度経度を計算することができます。`,
"label.weixin.optioneight":`選択肢 8`,
"label.recordtypeselect.modify":`レコードタイプの編集`,
"label.forecast.settings.future3":`これからの3週間`,
"label.rename":`リネーム`,
"label.emailtocloudcc.button.complete":`完了`,
"chatter.new.at":`最新の活動`,
"component.setup.label.milestonesfield":`マイルストーン項目`,
"vue_label_commonobjects_detail_email_newaddress":`送信先`,
"lable.PowerProcess.big.event":`重大行動`,
"label.appexchange.uninstallpage.confirm":`はい、当該パッケージをアンインストールし、関連コンポーネントを完全に削除します。`,
"label_mobile_buttom_homepage":`ホームページ`,
"label.sso.saml.idp.config.logouturl":`シングルログアウトURL`,
"lable.quote.pdf.button.savetoquote":`見積書に保存`,
"label.page.select.application":`使用する新しいカスタマタブのカスタマアプリケーションを選択します。カスタマアプリケーションの詳細情報と編集ページでタブの表示をチェック′修正することもできます。`,
"chatter.down":`ダウンロード`,
"label.tabpage.searchz":`検索`,
"label.emailsync.form.action":`アクション`,
"label.campaignmember.setup.campaignmember.field":`キャンペーンメンバー項目`,
"label.version.remark":`説明：無料版は5つののユーザに限り、2000件までの新規レコードを作成することができ、データのインポート&エクスポートができません。`,
"label.selectoperateobject":`サクションするオブジェクトを選択してください`,
"label.appointmentdetail.wizard.title12":`ブックタイム`,
"label.submitforapproval":`承認待ちの提出`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`各割引レベルの編集の下限は、最後のレベルの上限に等しいものとする。`,
"label.appupload.install.component.view":`コンポーネントを表示`,
"label.profile.customobjcontrol":`カスタマオブジェクト権限`,
"label.customfields.configprofilefieldsafety.tip":`項目レベルセキュリティーを通じて、この項目に編集?アクセス権を付与するプロファイルを選択します。この項目を項目レベルの安全性に追加しないと、いずれのプロファイルにも表示されません。`,
"label.service.gantt.service.resources":`サービスリソース`,
"label.input.right.emailaddress":`正しいメールアドレスをご記入ください`,
"label.ccdocument.folder.notedit":`このファイルは編集できません。`,
"label.data.choses.i.desc":`ニーズに応じて、単一オブジェクトのデータをインポートします。`,
"label.icon.75":`車`,
"label.summaryreport.step4":`ステップ4.レポートの列を選択`,
"label.appupload.upload.install":`インストール`,
"label.reportlist.newfolder":`新規レポートファイル`,
"label.projectManagement.myproject":`私のプロジェクト`,
"label.true":`TRUE`,
"label.tabpage.reallproplez":`所有者のレコード`,
"label.change.lead.share.error":`取引先の権限を編集することができません`,
"F":`日付/時刻`,
"lable.account.CurrentandNextCQ":`現在と次回のカレンダー四半期`,
"UG.activity.06":`取引先をフォローしたい`,
"UG.contact.03":`取引先責任者のセールスシグナルをあるところで追跡します`,
"label.field.duplicate.error.msg2":`ユニークプロパティの設定に失敗しました`,
"label.sales.dashboard.reality":`実際の受取金額`,
"lable.PowerProcess.type":`エンタイトルメントプロセスのタイプ`,
"batch.selected.data":`選択済みのデータ数`,
"#label.importsourcefilestep2":`ステップ2.ファイルをパッキング（選択可能）`,
"label.emailtemplate.select":`使用するメールテンプレートを選択してください`,
"chatter.most.w":`最大500までの文字を入力することができます。`,
"vue_label_calendar_new_object_calendar":`新規オブジェクトカレンダー`,
"label.aggregated_formsdata":`フォームデータの集計`,
"label.knowledge.language.french":`フランス語`,
"label.customfields.enc.tip":`いずれ文字列と数字の組み合わせを入力でき、暗号化形式で保存します。検索することが不可能です。`,
"label.icon.158":`雲`,
"font-evaluate-module-v1-bad-review ":`評価の種類がネガティブの場合`,
"UG_quota_03":`見積のテンプレート`,
"label.eidt.queue.label.hasused":`この表示ラベルは使用済みです。`,
"label.lookupfilter":`絞り込み検索条件`,
"label.callcenter.Instance.name":`インスタンス名`,
"label.commitertype":`提出者の種別`,
"vue_label_checkduplicate_any_one":`いずれの条件を満たす`,
"label.campaign.channel.input.img":`感謝ページとして、ローカルのパソコンから画像を選択してください。`,
"vue_label_dashboard_pleaseenterafoldername":`フォルダ名を入力してください`,
"label.tianyancha.look":`参照`,
"label.tabpage.lastone":`アクションを少なくとも1つ選択してください`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName}  あなたの承認を待っています`,
"label.chat.topic.delete.prompt1":`トピックスの削除には時間がかかり、完了までトピックスは引き続き投稿とレコードで保留されます。`,
"component_setup_label_displaybutton":`ボタン表示`,
"label.partnerCloud.backgroundImage":`背景画像`,
"label.mobile.phone.time.range":`時間範囲`,
"label.page.url.address.remark":`「リンクURL」項目でWebアドレスを入力します。ブラウザで表示する形式のように、URLアドレスを入力することができます。１つあるいは多数のマージ項目を使用して、組織の特定データをCloudCCからURLパラメーター挿入することができます。ブラウザーのセキュリティ設定、あるいはサイトによる表示の阻止のため、あるサイトは恐らくWebタブで無効になります。`,
"label.h5.copyemail":`メールボックスはコピー済みです`,
"label.view.step3":`ステップ 3.表示する項目の選択`,
"label.quickbooks.view.moneyreceived":`代金受取`,
"label.emailobject.attachment.preview":`プレビュー`,
"label.selectapprover":`承認者の選択`,
"vue_label_normal_opportunity_sf":`商談`,
"label_emailtocloudcc_filed_port":`端末`,
"mesage.errorinsaving":`レポートで選択可能な項目`,
"label.partnerCloud.partnerCloudName":`パートナークラウドの名称を入力してください。`,
"lable.edit.queue.checkemail":`エラー：メールアドレスは無効です`,
"label_builder":`ページビルダー`,
"component_setup_label_setupsavefail":`コンポーネント設定の保存に失敗しました`,
"label.icon.76":`車`,
"label.reportsSubscriptionPage.schedulereport.monthly":`毎月`,
"message.nopermession":`権限が不足しています`,
"label.view.groupscansee":`あるユーザチームが参照可能`,
"label.leadscore.rule.new":`リードスコアリング：新規ルールの作成`,
"label.new.ccpeakfolder.time":`スケジュール済みクラス：新規フォルダの作成`,
"label.record":`レコード`,
"message.error.flabel":`項目表示ラベルは英字と引用符を含んではいけません`,
"label.emailobject.emaildetail.promptbutton2":`キャンセル`,
"label.h5.phone":`電話`,
"label.visualpage.error.deal.with":`エラーが発生し、システム管理者に連絡してください`,
"label.button.step1.select.field":`ステップ1.項目の選択`,
"label.setsharerule.step1":`ステップ 1. 設定するルールタイプを選択`,
"component.chatter.file.label.title":`ファイルのアップロード`,
"front-epwechat-module-v1-appname":`アプリ名`,
"chatter.error.notsel":`エラー：先ずアップロードする画像を選択してください。`,
"label.updatevalue":`更新する精確値`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0}は{1}内のすべての人にドキュメントを投稿しました。`,
"label_tabpage_grid":`グリッド表示`,
"homepage.components.standard":`標準コンポーネント`,
"label.movable":`活動`,
"label.report.selected.field.cannot":`選択した項目は50つを超えてはいけません`,
"label.projectManagement.distribution.by.excess":`オーバーによる割当て`,
"addrow":`行の追加`,
"label.approvaldatamove.p":`複数の未承認の申請を管理します。まず、承認申請レコードの条件を指定し、[検索] をクリックします。結果一覧が表示されたら、実行するアクションを指定します。`,
"label.passwordPolicy.setup.title":`パスワードポリシー`,
"label.appointmentpage.wizard.title1":`{0}（{1}）はあなたを招待しています`,
"label.tippage.li1":`カスタマレポートタイプを完全削除`,
"label.campagin.roi.dcl":`出席率`,
"label.h5.new.errorbody":`*が付いている必須項目を記入してください`,
"label.cy.enable":`通貨種別の有効化`,
"label.currency.rate.e":`組織で使用する通貨間の為替レートを編集します。`,
"or":`あるいは`,
"lable.custom.Previous.CYt":`前の2つのカスタマ年度`,
"front-epwechat-module-v1-unbound-desc":`バインドを解除すると、バインドされたアカウントがクリアされます。本当にバインド解除しますか？`,
"pagecreator_button_publish":`発表`,
"font-evaluate-module-v1-case-owners":`ケースオーナーへの通知`,
"label.pw.new":`新しいパスワードを入力してください。`,
"message.tabsearch.nokeywords":`1文字以上のキーワードを入力してください。あるいは高度な検索条件を使用してください。`,
"label.sendemail.send.erroruser":`間違ったユーザ`,
"label.personalinfo":`私の個人情報`,
"label.case":`ケース`,
"lable.product.pricebooks.now":`既存の価格表`,
"label.ccpeak.take.notice":`ご注意：ID、自動採番、作成者、作成時間などシステム項目は割り当てられる必要がありません。`,
"label.page.first":`1ページ目`,
"label.icon.168":`観光`,
"label.choices":`選択`,
"label.is.delete.document":`このフォルダを削除しますか。`,
"homepage.layout.custom":`カスタマレイアウト`,
"label.emailobject.template.insert.field":`項目の挿入`,
"label.ccpeak.folder.all":`すべてのフォルダ`,
"front-console-conversation-btn3":`メールの転送`,
"label.ems.port":`ポート番号`,
"label.app.introduce":`アプリケーションは、機能の提供単位となるタブ群です。各ページの右上角にあるアプリケーションのドロップダウンメニューを使用するとアプリケーションを切り替えることができます。`,
"label.file.library.managemembers.admin":`ライブラリーの管理者`,
"vue_label_salesadvance_win":`勝ち取った契約`,
"label.email.click.complete.info":`「完了」ボタンをクリックして、前のページへに戻ります`,
"label.umeng.activity.event.willbegin":`あんたの行動#eventは#timeから開始します`,
"label.mobile.phone.week.summary":`今週のまとめ`,
"label.quickbooks.fieldlabel.terms":`条項`,
"lable.currencyManage.advcurrencyEnabled.dis":`通貨為替レートを特定の期日範囲内の期限切れの為替レートに対応付けることができます。期限切れの為替レートは期限切れの為替は商談、商談商品及び関連するレポートに使用されます。`,
"label.weixin.data.save.failed":`データ保存時に失敗しました`,
"label.service.gantt.filter.logic":`フィルターロジック：`,
"vue_label_pool_adopt":`受取`,
"label.emailobject.markasunread":`未読`,
"label_please_select_a_member":`メンバーを選択してください`,
"label.salescloud.unit.ci":`単位（個）`,
"vue_label_pool_obsolete":`廃棄済み`,
"label.cancelall":`すべて選択を解除`,
"label.exchange.sync.state.setting.m2":`CloudCC Exchange 更新中のユーザが有効化済みです。`,
"vue_label_pool_claimtime":`受取期日`,
"label.forecast.forehistory.history":`の予測履歴`,
"label.knowledge.article.record":`知識記事は要求に合っていません`,
"label.setting.intergrationlist.button.uninstall":`イングレーションのアンインストール`,
"label_tabpage_gotit":`わかりました`,
"label.data.exp.csvform":`エクスポートしたデータのみに有効`,
"UG.Forcast.06":`予測可能なユーザーを選択してください。`,
"vue_label_report_savereport":`レポートの保存`,
"setup.object.field.dependency.label.mustone":`依存する項目の値を少なくとも1つ設定してください。`,
"label.batchadd.newbatchpage.des1":`レコードのname項目は必須項目で、記入されないと、このデータは保存されません。`,
"lable.custom.CurrentandPreviousCYt":`現在と過去の2つのカスタマ年度`,
"label.versiontype.Professional":`専門版`,
"label.customfields.configprofilefieldsafety":`プロファイル項目のセキュリティを更新`,
"label.ccpeak.wgd.time":`ファイリングされていないスケジュール済みクラス`,
"component.telerecord.label.subject":`テーマ`,
"label_year":`年度`,
"pagecreator_layout_label_modifylayout":`レイアウトエディター`,
"label.compact.layout.frame.splitline":`split line`,
"lable.PowerProcess.enter.the.process":`{describeName} プロセスに入ります`,
"label.emailobject.cc":`CC:`,
"front-electronic-export-choseCount":`インポートデータを選択してください。`,
"label.setup.mobile.bottombutton.recovery.default.success":`デフォルトの状態に戻すことに成功しました。`,
"label.datamanage.import.accountfield":`下記のリストで、インポートするファイルで取引先にインポートする項目を選択します。完了したら、[次へ]をクリックします。`,
"vue_label_opportunity_related_list":`関連リストに追加します`,
"label.group.recent":`最近に表示したチーム`,
"vue_label_pool_finalclaimtime":`最終の受取期日`,
"vue_label_homepage_30daysnocontact":`30日間連絡していない商談`,
"label.tianyancha.field.error":`天眼査項目が見つからないため、システム管理者に連絡し、初期化の操作を執行してください`,
"label.product.go":`レポートに切り替え`,
"label.customsetting.manage.introduce":`カスタマ設定はリスクであれば、[新規データの追加]をクリックしてください。例えば、アプリケーションに国別コード設定があれば、データは国名と電話コードを含みます。`,
"label.task.dateadd":`プラス`,
"label.email.recipients.select":`受信者を選択してください`,
"chatter.emailListMyChat":`投稿またはいいね!`,
"label.batchadd.newbatchpage.save.name":`名前はNULLであれば、システムはこのレコードをデフォルトで追加しません。名前がNULLでないことを確認してから保存します。`,
"UG_Lead_011":`手がかりの作成`,
"vue_label_salesfunnel_notice2":`進行中の商談総件数`,
"APPIntegration_Social_linkedinerror":`有効なlinkedin.comのURLでなければなりません`,
"label.industrialandcommercialverification.enablestatus2":`ユ_ザ名のリアルタイム_索`,
"label.stdashbord.xsld.business.ajssx":`ロールの絞り込み`,
"lable.info.queue.showalluser":`すべてのユーザを表示`,
"label.generatepage.c1":`文字から始まり、アンダースコアと英数字しか使用できません。`,
"label.thenset":`これからクリックします`,
"label.salescloud.salescloud.defaultteam":`ユーザのデフォルト商談チーム`,
"label_partner_workspace_tab_selectedoption":`選択済みのタブ`,
"label.tippage.li":`カスタマレポートタイプを削除したら`,
"lable.quote.syncingfrom.syncingto":`商談商品を見積書に同期しました。`,
"label.emailobject.delete":`削除`,
"label.data.selectimportobject":`インポートするオブジェクトを選択してください`,
"label.knowledge.language.dutch":`オランダ語`,
"message.campaign.page.overtime":`当該ページは期限切れになりました`,
"label.ccchat.message.search.desc4":`検索ワードのスペルをチェックします。`,
"label.login.forgetPsd":`パスワードを忘れる`,
"vue_label_title_order":`オーダー`,
"template.report.contract.follow.status":`契約のフォローアップ状況`,
"label.forecast.edit.kjnd":`会計年度`,
"front-electronic-export-listTitle":`Mailchimpリスト`,
"label.dataimport.error.khmc.notnull":`エラー：取引先名は空であってはいけません`,
"label.testobject":`テストオブジェクト`,
"label_chatter_nextStep":`後続ステップ`,
"label.file.public.link.share":`公開リンクの共有`,
"label.weixin.organization.name":`組織名称`,
"label.quote.email":`メール`,
"label.reg_field":`レギュラーフィールド`,
"font-evaluate-module-v1-response":`評価後の返信`,
"label.chatter.sendmail":`メール送信`,
"label.weixin.start.incorrect":`開始日付の表示形式は不正確です。`,
"component_chatter_link_label_url":`リンクURL`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`はい、高度な通貨種別管理を有効化します`,
"label.east.africa.time":`東アフリカ時間`,
"label.product.proof.Three":`0}では、{1}以上、{2}までの商品オプションを選択してください。`,
"label_emailtocloudcc_filed_password":`パスワード`,
"component.task.label.person":`任命先`,
"pagecreator_systemstyle_label_buttonareacolor":`アクションエリアの色`,
"label.clearrule":`クリアルール`,
"lable.customer.access":`取引先のアクセスライセンス`,
"label.finish.wait":`ご申請を処理しており、お待ちください。メールを随時にチェックしてください。`,
"label.weixin.appr.auditor":`承認者`,
"label.tabpage.systemz":`件のシステム`,
"label.file.nocan.process.desc":`申請が処理できません　内容の転送が処理できません`,
"label.relationobject.name":`関連オブジェクト名`,
"setup.layout.group.relatedlist":`関連リスト`,
"label.generatepage.title":`Web to CloudCC ページ`,
"label.page.step3.input.url.information":`ステップ3.URLの詳細情報の記入`,
"label.change.to":`にキャンペーンメンバー状況を変更`,
"label.validate.function.funcFormat.TIMEVALUE":`TIMEVALUE(date)`,
"label.partnerCloud.seriesSettings":`プロダクトファミリーの設定`,
"component.timeline.label.1monthahead":`1ヶ月前`,
"label.batchadd.senumberpage.selnum":`追加するレコード件数を選択`,
"label.downloadapp":`アプリのダウンロード`,
"label.dashboardSetup.showmainpage":`トップページの表示`,
"label.h5.nophoneprompt":`当該同僚は連絡先電話番号を記入していません`,
"label.service.deleteCustomView.wanttoremove.theFilter":`“{name}”フィルターを削除しますか。`,
"label.appupload.state1":`アップロード済み`,
"component_timeline_button_filter":`絞り込み`,
"label.passwordPolicy.setup.subtitle":`パスワードの制限やログインの制限に関するポリシーを設定します。`,
"vue_label_normal_quote_sf":`見積書`,
"label.productsales.today.noevttskaddall":`今日、行動予定あるいは権限切れのToDoがありません。右上の「＋」をクリックしてToDoあるいは行動を追加することができます。`,
"label.projectManagement.no.end.date":`終了日がありません`,
"label.sendmail.batch.chosetemplate":`メールの一括送信：テンプレートを選択`,
"serviceterritorymember.serviceresource.isactive.notactive":`このサービスリソースは有効化されていません。有効なサービスリソースにサービスエリアを割り当てることができます。`,
"label.notification.event.overlapEvent.continue":`作成を続ける`,
"label.appupload.component.type.obj":`カスタマオブジェクト`,
"label.partnerCloud.financeSetting.basicConfiguration":`アクセスパス。パブリック・プラットフォーム  開発  基本構成`,
"lable.outlook.detail.info":`Exchange Sync更新の詳細情報`,
"vue_label_commonobjects_detail_activity_commingevents":`間もなく行う行動があります`,
"coderules.nullvalue2":`生成に失敗しました。生成ルールで使用する【{0}】【{1}】の値を入力してください。`,
"label.version.sum.workflowrule":`ワークフロールール`,
"label.sso.saml.idp.config.enable":`IDプロバイダの有効化`,
"label.temp.exp.conf":`確かにテンプレートをエクスポートしますか。`,
"label.department":`部門`,
"label.trigger.operation.email.template":`メールテンプレート情報の取得`,
"label.page.content.frame.height":`内容幅の高さ（ピクセル）`,
"label.ServiceCloud.jinengyaoqiu":`スキル要件`,
"PageLayout.Search.MultiSearch.001":`最大3つまでの項目ドを選択することができます。`,
"label.error500":`エラーが発生しました。早くシステム管理者に連絡してください。`,
"label.appexchange.download.stop":`コンフリクトが発生したため、インストールを停止してください`,
"label.service.dispatchingUnits.left.right.totalAll":`現在 {left}-{right} 件のデータで、合計{totalCount} 件のデータです。`,
"label.tabpage.haschangedz":`このリードは置換え済みです`,
"label.industrialandcommercialverification.button.cancel":`キャンセル`,
"label.edit.role":`ロールの更新`,
"label.mr.descreption.condition2":`ルール-前のいくつかの文字に基づき：数字を入力して、入力した数字の前のいくつかの同じ文字で重複データを検索します。`,
"label.testgrammer":`構文のチェック`,
"label.age":`年齢`,
"lable.real.time.chat":`リアルタイムチャットの技術サポートはEasemobが行います。イースモブで詳細設定を行ってください。`,
"vue_label_opportunity_selected":`{sum}件をすでに選択した`,
"label.weixin.optionone":`選択肢 1`,
"label.file.delete.public.link.desc":`公開リンクを削除すると、このURLがあるファイルにアクセスすることができません。新規公開リンクを作成するなら、新しいURLが生成されます。`,
"label_tabpage_cancel":`キャンセル`,
"template.report.opportunity.analysis":`オポチュニティステージの分析`,
"label.escalation.setup.newrule.inputrule":`ルール名の入力`,
"label.ccpeak.getapi.name":`レコード名を取るときに直接的に項目をゲットするAPI名は`,
"second":`二番目`,
"label_tabpage_uploadsz":`アップロード`,
"label.description":`メモ`,
"label.ccchat.person.invite.notsamepwd":`パスワードは一致していません`,
"label.mobile.app.isEnableAblumWatermark":`サインイン時に携帯アルバムから選んだ写真にウォーターマークを入れる`,
"vue_label_allsearch_searchable_items":`検索可能なアイテム`,
"lable.outlook.detail.react":`最近の活動`,
"label.sales.team":`商談チーム`,
"label.guif.standard.time":`ペルシャ湾標準時`,
"label.emailobject.emaildetail.button.forward":`転送`,
"label.refused":`却下済み`,
"homepage.components.one":`ステップ1：カスタマコンポーネント名を記入`,
"day":`日`,
"label.dataimport.error.number":`エラー：数値`,
"label.customer.tab.step2.same.option2":`デフォルト非表示`,
"component_button_ok":`確定`,
"label.allrecordmeetprocess":`すべてのレコードはこのステップに入るべきです。`,
"label.version.onefile.size":`個別ファイルのアップロードサイズ`,
"label.partnerCloud.orderingPlatform.allProducts":`すべての製品`,
"pagecreator.page.message.publish.success":`ページ公開に成功しました`,
"lable.currencyAdv.exchagecurrency.rate.pro":`前の範囲`,
"label.attendance.persons":`対象`,
"label.send.an.email":`メールの送信`,
"registration.page.browser.title":`カンパジン・マーケティング・チャンネル登録`,
"label.importfilestep3":`ステップ 2. ファイルを選択してアップロード`,
"lable.currencyAdv.exchagecurrency.rate.next":`次の範囲`,
"label.ems.no.sync.msg":`メールの同期情報をまだ設定していません`,
"label.total_views":`フォーム送信プレビュー`,
"label.knowledge.article.notnull":`1つ以上の記事を選んでください。`,
"message.error.view.lastview.delete":`最後の公開リスクビューを削除することができません/すべてのユーザーが参照可能な最後のリストビューを削除することもできません。`,
"label.integrations.second.half":`インポートしたデータを選択します。`,
"vue_label_systemSettings_mobelparams":`モバイルアプリのパラメータ設定`,
"message.choose.maximum":`共有情報は最大150件まで選択でき、現在選択済みです。`,
"vue_label_homepage_won&unprocessed":`獲得済み＋未処理`,
"UG.contact.01":`如何に取引先責任者を最大限に活用しますか。`,
"label.data.import.setup.remark":`システム管理者はデータエクスポートに関するルールを設定することができます。ルールは入力規則、トリガー、重複検索条件を執行するかどうか含みます。`,
"pagecreator_layout_message_delete_success":`レイアウトの保存に成功しました`,
"lable.account.name":`四半期決算の名称`,
"label.userinfo.must.updatepwd":`契約締結予定日`,
"label.mobile.phone.subordinate.setup":`部下を含むかどうか設定できません。所有者を選択して、予測を許可します。`,
"label.monitorsys.delete.date":`日付`,
"label_emailsync_form_emailaddress":`メールアドレス`,
"label.projectManagement.cancelled":`キャンセル済み`,
"label.partnerCloud.partnerAccount.rechargeAmount":`トップアップの金額は0.1～100000000の間である必要があります。`,
"label.select.relatedlist.approval.layout":`承認ページレイアウトで表示される関連リストを選択`,
"label.userphoto.thumbnail":`サムネイル`,
"label.assignment.setup.list.rulename":`ルール名`,
"label.emailtemplate.usemergefields":`メールテンプレートに差し込み項目を使用します`,
"label.tabpage.enabletomobile":`モバイル端末を有効化しますか`,
"setup_layout_label_desc":`降順`,
"vue_label_pool_abandonreasondiscription":`廃棄理由の説明`,
"label.ems.outputmails":`シンプルメールトランスファープロトコル（SMTP）`,
"font-evaluate-module-v1-evall":`すべての評価`,
"front-epwechat-module-v1-unbound-tips":`以下のデータは結束解除後に消去されます。`,
"label.weixin.number.data":`データ（件）`,
"front-objectTemplate-V1-UseObject":`適用対象`,
"label.call.center.configuration":`Call Centerの設定`,
"vue_label_systemSettings_website":`顧客サービスのWebポータル`,
"lable.currencyAdv.foreverdate":`{0}から{1}に変更します`,
"label.globalselect.view":`選択リスト値セットの表示`,
"component_newrecords_label_title":`最近のレコード`,
"component_assistant_label_title":`助手`,
"label.equals.deletebut.bulk.delete":`削除ボタン、一括削除（ゴミ箱）を含みます`,
"label.field.duplicate.error.msg4":`エラー：無効なデータです`,
"label.input.right.date":`正しい日付の表示形式をご入力ください`,
"file.error.notsel":`エラー：アップロードするファイルを選択してください`,
"label.customcomponent.page.add.title":`新規カスタマコンポーネント`,
"message.chooseatleastthreefield":`3つ以上の項目を選択してください`,
"label.dataimport.system.unnecessary":`、システムは残りを確認することができません`,
"message.login.wrong":`ユーザ名とパスワードは不正確です。`,
"label.appupload.install.recheck":`再チェック`,
"label.ems.option":`オプション`,
"label.wei.subject.img":`トピックアイコン`,
"chatter.emailReceiveOrNotAccept":`このオプションを選択するとメールをを受信し、選択を解除すると、受信を解除できます。`,
"label.icon.46":`かまど`,
"label.newpw":`新しいパスワード`,
"font-evaluate-module-v1-praise":`評価のタイプはPositive`,
"label.help.user":`ユーザガイド`,
"label.callcenter.no.searchs":`関連情報は見つかりません`,
"UG_homepage_007":`フォローアップメールの送信から販売活動の自動化まで、またブルーマップ技術によるワークフローの作成からカスタムマクロのトリガまででは、自動的に日常のToDoを作成し、さらにリレーションシップの確立にもっと専念します。`,
"label.saveandnew":`保存&新規`,
"component_salesperformance_label_70finish":`完了済み‐未処理（>70%）`,
"lable.account.dp":`このページでカスタマ会計年度を定義することができます。`,
"label.notification.serviceappointment.injeopardy":`1}{0}はクリティカルな状態です。なるべく早く処理してください。`,
"label.workflow.edit.esimaterule":`エラー：このルールに関連の時間トリガーがある場合、評価条件を「毎回作成しまたは編集するとき」に変更することはできません。`,
"label.partnerCloud.basicSetting.feature":`機能設定`,
"label.sms.companyname.gm.infor":`創明網絡SMSインターフェス情報`,
"vue_label_homepage_components":`コンポーネントを選択してください`,
"label_chatter_allactivity":`すべての活動`,
"label.quickcreate.title":`クイック新規レイアウト`,
"label.tabpage.exclusivez":`含まない`,
"front-service-cloud-transfer-desc":`アセットのBOMオーナーを変更すると、現在のアセットとそのアセットの下にある自分のアセットのオーナーが変更されます。`,
"label.data.downpage.i.list.desc1":`インポートしている時に、データのフォーマットが正しくないか、またはトリガーや検証ルールが失敗したため、インポートに失敗したたデータは、当該ページに表示されるCSVファイルを生成されます。インポートに成功したデータは、当該ページには表示されません。`,
"template.report.individual.case.status":`ケースの状況`,
"label.report.export.file.format":``,
"vue_label_filternotice1":`つまりフィルター条件がすべて満たされています。例えば、一つ目は金額が100万以上の商談で、二つ目は契約予定日が今月と等しい商談です。フィルター結果は今月100万以上の商談が表示されます。<span style="color: red">は高度なフィルター</span>を有効化した時、 高度なフィルターボックスに手動でフィルター条件を入力する必要があります。`,
"label.lead.score.confirm1":`スコアリングが長い時間をかかるかもしれません。完成したら、確認のメールを受け取ることができます。`,
"label.scores":`点`,
"label.dashboard.message.mainnoset":`ホームダッシュボードが設定されていない`,
"label.customfields.optionlist.fieldvaluelist":`選択リスト項目に1列の値を入力していて、すべての値は一行を占めるべきです`,
"label.autosearch.title":`自動的にタイトル検索を行う`,
"label.knowledge.setting.hint.seventeen":`記事の作成`,
"label_tabpage_closez":`クローズ`,
"label.partnerCloud.orderingPlatform.shoppingCart":`カート`,
"label.recalculate":`再適用`,
"label.umeng.approval.approvalmes4obj":`#numsuccレコードは#objで承認された、#numfailedreocrdsは承認されなかった。`,
"label.appointment.wizard.subtitle2-2":`To`,
"label.validate.function.funcExplain.AND":`すべてのパラメータはTUREであるかどうかチェックし、すべてがTUREであれば、TUREを返します。`,
"label.recordtype.batchaddattachments.remark":`ステップ1.ファイルを選択；  ステップ2.ファイリングしますか；  ステップ3.[アップロードを開始]をクリックして、ファイルをアップロードします； ステップ4.[完了]をクリックして、前のページに戻ります`,
"label.reportlist.findreport":`レポートの検索`,
"label.partnerCloud.financeSetting.enterAppsecret":`Appsecretを入力してください。`,
"label.campagin.roi.query2":`キャンペーン販売チャンネルROIの検索`,
"label.sendmail.notice.immediately":`すぐメール通知を送信します`,
"label.file.library.managemembers1":`メンバーの管理`,
"label.forecast.customforecast.foredis.yclb":`已翻译`,
"label.no.target.model.available.":`利用可能なインジケータモデルがありません。先にインジケーターモデルを作成するか、システム管理者にお問い合わせください。`,
"label.quote.contactname":`取引先責任者の名前`,
"label.customer.tab.step2.same":`タブ表示をすべてのプロファイルに適用する`,
"UG_product_03":`多数の通貨種別がサポートする価格表`,
"label.pc.system.prompt":`システムメッセージ`,
"homepage.components.description":`コンポーネントの説明`,
"front-email-payment-safety-code":`セキュリティコード`,
"label.the.extra.reward.group.describes":`見積り行グループ説明の追加`,
"label.isEnableVisualpage.new.rightlist":`カスタムページが有効化された`,
"label.icon.84":`変成器`,
"label.chat.message.to":`受信者`,
"lable.product.pricebooks.edit":`価格表の編集`,
"label.partner.workspace.member.belong":`属する`,
"pagecreator_systemstyle_message_delete_success":`スタイルの保存に成功しました`,
"label.salescloud.teamrole.message.chooseatleastone":`以下のいずれかのユーザを選択してください`,
"label.knowledgebase.self.window":`同一ウィンドウ`,
"label.product.cost":`最低販売価格`,
"label.imgfield.remove":`画像のクリア`,
"label.event.lastweek":`先週`,
"template.report.today.statistics":`本日の売上高`,
"label.emailobject.recipients":`受信者（{0}）：`,
"vue_label_commonobjects_view_successfully":`デフォルトビューの設定に成功しました`,
"label.uploadfail.typeerror":`画像の表示形式にエラーが発生し、アップロードに失敗しました。`,
"vue_label_lead_required_fields":`必須項目を入力してください。`,
"front-console-reopen":`再開`,
"message.layout.unique.relatedlist":`ページレイアウトでの項目の一意制約を違反したが、確認してから再保存してください。`,
"label.emailobject.emaildetail.nextactivity":`次の活動`,
"label.publicgroup.save.error":`エラー：下記のあるグループはすでにこのグループの親レベルです。`,
"label.editdefaultshare.tip":`組織全体のデフォルトの共有ルールを設定してください。これらのデフォルト値を変更すると、すべての共有ルールが再適用されます。組織内に存在するデータの量に応じて、この処理には、多少のシステムリソースと時間が必要となります。`,
"label.icon.53":`車`,
"label.exchange.sync.state.setting.m3":`Microsoft Exchange と CloudCC メールアドレスにリンクされたユーザ`,
"label.currency.enable":`通貨種別：通貨種別の有効化`,
"component.timeline.label.past":`過去の活動`,
"workflow.action.tasks.assignortype.user":`ユーザ`,
"setup_layout_label_relatedlistsetup":`関連リスクの設定`,
"label.systemadmin":`システム管理者`,
"label_tabpage_allz":`すべて`,
"label.ems.subject":`トピック`,
"message.recordtype.selectlayout.tip":`このプロファイルユーザーが参照するこのレコードタイプのページレイアウトを選択します。保存後にこのレコードタイプが使用可能な選択リスト値を選択します。`,
"label.current.version":`ご利用中のプログラムのバージョン`,
"label.sourceoffile":`未翻訳 - 未翻訳のテキストを含む言語別のファイルのセットを生成します`,
"label.file.versionerror":`新しいインターフェースでファイルタブ機能を使用してください`,
"label.validate.function.funcExplain.MINUTE":`日付/时间項目の分間に戻る`,
"abel.setup.mobile.bottombutton.profile.setting":`プロファイルのボトムメニューのカスタマイズ`,
"label.recycle.dis.tip3":`ドロップダウンリストから私のゴミ箱を選択し、削除したデータを参照します。管理者はすべてのゴミ箱を参照することができます。`,
"message.selectnothing":`指定なし`,
"label.develop":`開発`,
"label.tab.lightningpage":`ライトニングバージョンページ`,
"label.chat.micropost.share.info":`共有`,
"label.block.pricing.editor":`ブロックプライシングエディター`,
"label.ccchat.file.unavailable":`このファイルは使用できません`,
"label_component_helper_businesschange_0UntreatActivity":`活動予定の商談はありません`,
"label.search.setup.obj":`100件までのオブジェクトを設定することができます`,
"component.setup.button.cancel":`キャンセル`,
"message.longtextareamaxlength":`長さは32000文字を超えてはいけません`,
"vue_label_chat_removedby":`あなたは 「管理者 」にグルーチャットから削除されました。`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`必ず8文字以上です`,
"label.informassigner":`任命先へ通知`,
"font-evaluate-module-v1-not-received":`連絡先から満足度評価を受けたことがない`,
"label.trigger.triggertime":`トリガ時間`,
"label.attendance.cannot.make":`マーク付けできません`,
"label.shouldallrecords":`この集計はすべてのレコードを含みます`,
"label.eidt.queue.alter1":`キューメンバーを選択してください`,
"L":`選択リスト`,
"label_emailtocloudcc_filed_email":`メール`,
"label.productsales.contract.badversion":`現在のバージョンは契約対象をサポートしないため、契約業績を参照することができません`,
"label.tabpage.operation":`アクション`,
"label.file.copy.public.link":`公開リンクをすでにコピーしました`,
"label.all.SMS":`すべてのSMSアラート`,
"UG_opportunity_008":`商談チーム`,
"UG.Campaign.002":`キャンペーンの計画、実行及びその効果のモニタリングを行う。`,
"label.jiandangfenpei.title":`プロファイルの割り当て`,
"pagecreator.systemstyle.message.delete":`今選択したスタイルを削除しますか？`,
"lable.outlook.mcto.repeat":`重複レコードが見つかる際のメールの関連先`,
"label.user.field":`ユーザ項目`,
"vue_label_commonobjects_detail_market_hierarchy":`市場階層構造`,
"label.ems.emails":`メール`,
"label.tabpage.deleteviewfailed":`ビューの削除に失敗しました`,
"label.data.exp.new.expobjtemp":`オブジェクトをエクスポートするテンプレートの作成`,
"label.useformulassetval":`数式を使用して、新しい値を設定します。`,
"label.service.newBuildDialog.six.fields":`最大6つまでの項目を選択することができます`,
"error":`エラー`,
"template.chart.sdyyfx":`Lost Reasonの分析`,
"label.icon.191":`口ひげ`,
"label.app.step3.tabused":`選択されたタブ`,
"label.user.level":`ユーザレベル`,
"label.custombutton.querydata.notexist":`検索のデータは存在しません`,
"label.executestate.calculating":`集計中`,
"label.visualpage.folder.notdel2":`1、現在のフォルダにあるファイルは削除できません。2、現在のフォルダにある非表示ファイルは削除できません。非表示ファイルは論理削除オブジェクト（設定‐作成‐オブジェクトでの削除済みファイル）により作成されたファイルで、オブジェクトが削除されないため、ファイルは非表示されています。`,
"vue_label_report_conditiondesc_three":`すべての条件が満たされた場合に通知されます。`,
"approval.request.email.subect":`承認申請`,
"label.log.user.value":`検索ユーザ名を入力してください`,
"label.isCompanyCurrency":`会社`,
"label.related.2018":`関連リスト`,
"label.tonga.time":`トンガ時間`,
"message.actionfailed":`アクション失敗`,
"label.’s":`の`,
"label.custombutton.queryobj.notnull":`検索するオブジェクトIDは空であってはいけません`,
"label.list.userinterface.setup":`ユーザインターフェースの設定`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`メールの形式が正しくありません。再度入力してください。`,
"label.chatter.content":`コンテンツ`,
"label.projectManagement.Addnotes":`メモの追加`,
"label.service.newBuildDialog.reservation":`予約の表示`,
"label.ccchat.pm":`午後`,
"vue_label_chat_cannot_invite_users":`グループホルダー以外の人が、ユーザーをグループチャットに招待することはできません。`,
"label_partner_workspace_member_belong":`属する`,
"label.task.modify":`ToDoを編集`,
"label.tabpage.transformationsz":`置換え`,
"label.new.password.no.indexof":`新しいパスワードには、漢字やスペースを含めることはできません。`,
"label.ji.quarter":`No.{a} クォーター`,
"label.sso.isActiveNo":`いいえ`,
"label.mobile.phone.week.report":`週報`,
"label.email.template.please.select.folder":`フォルダを選択してください`,
"label.pc.ui.2018.tab.groups":`メニュー`,
"label.h5.approval.status":`承認状況`,
"setup.mainpage.label.welcome27":`クラウドプラットフォーム「CloudCC」は、システム内のすべてのオブジェクトデータのインポート、エクスポート、一括削除、一括転送などの機能を提供します。`,
"vue_label_systemSettings_setHomePage":`セットアップホーム`,
"label.select.button":`選択可能なボタン`,
"label_emailsync_status_enable":`関連付けの有効化`,
"label.trigger.triggerVersion.detail":`この項目は編集できません、トリガーには現在1.0と2.0の2つのバージョンがあり、新規のトリガーはすべてバージョン2.0で、バージョン1.0ではすでに作成できなくなっています。`,
"pagecreator_layout_message_save_fail":`レイアウトの保存に失敗しました`,
"label.salescloud.salesdashboard.10big":`これから3か月のトップ10の商談`,
"label.file.share.size":`ファイル毎の共有と公開リンクの最大数は`,
"label.page.simple":`簡単`,
"pagecreator.page.message.delete":`今選択したページを削除しますか？`,
"label.weixin.newspaper.coverage.detailinfo":`リスクシートの詳細情報`,
"label.list.userinterface.chattersetup":`CCChatの設定`,
"lable.opppdt.addpdt.table.quantity":`数値`,
"label.product.description":`製品概要`,
"button_partner_back":`戻す`,
"label.user.current.loginuser.sessionid":`現在のログインユーザのSessionID：`,
"label.otherreport":`その他のレポート`,
"pagecreator_button_mobilepage":`モバイル端末`,
"label.mobile.phone.state":`レビュー状況`,
"lable.currencyManage.unenableCurrencyAdv":`高度な通貨種別管理の使用を禁止`,
"lable.product.addp":`価格の追加`,
"label.field.validate.notpass":`認証が通過し、構文エラーが見つからなかったです。`,
"label.app.global.search.obj":`グローバル検索に応用する検索のオブジェクトは最大で10つまでのオブジェクトを設定することができます。`,
"label.group.archived":`ファイリング`,
"vue_label_approve_to_submit":`提出待ち`,
"showfrom":`から表示する`,
"chatter.emailNotification":`メールアラート`,
"label.callcenter.pleaseenter.enterprise.number":`企業名を入力してください。`,
"label.forecast.customforecast.forecastnumber":`予測数値`,
"label.vlidaterule.messagelocation":`エラー表示場所`,
"label.h5.similar.opportunity.step3.conment":`一致する項目の数を表す関連列は常に表示されます。`,
"label.ccchat.group.gd.setting.info":`CCChatチームの設定を修正`,
"label.knowledgebase.delete.article.succeeded":`記事の削除に成功`,
"message.layout.edit":`ページレイアウト管理は個別の付加価値機能で、組織は当該機能モジュールを購入するなら、システム管理者にパスワードを問い合わせてください。またより多い問題があればCloudCC.に連絡してください。`,
"label.case.create":`ケース（{0}）を作成`,
"label.icon.170":`ショッピング`,
"message.error.contact.null":`連絡先を空にしてはいけません`,
"label.appupload.install.error.hasinstalled":`このソフトはすでにインストール済みです。新規バージョンをインストールする前に、既存のバージョンをアンインストールする必要があります。`,
"label.service.miniProgram.imageType":`画像はPNG、JPG、JPEG形式に対応しています。750*349ピクセルの画像を推奨します。画像の上にマウスを置くと、再アップロードや削除ができます。`,
"label.leadscore.rule.edit":`リードスコアリング：ルールの編集`,
"vue_label_commonobject_anytime":`いずれの時間帯`,
"label.clearing.conditions":`条件クリア`,
"label.campagin.roi.ydkhjhze":`商談獲得数`,
"Lead_Auto_Scoring_Setting_001":`リードが保存または編集時に自動的にスコアリングします。（一括インポートとインターフェースの作成は含まれない）`,
"pagecreator.systemstyle.label.buttonareacolor":`アクションエリアの色`,
"label.batchregist.huanxinuser.finish":`ユーザの一括登録は完成済みです`,
"UG_opportunity_006":`商談天才`,
"message.serviceappo.violation":`発送時間の違反：この時間帯は他のサービス予約と重複しています`,
"label.recordtypeselect.selectnew":`新しいレコードタイプを選択`,
"Lead.Tools.BatchScoring":`リードの一括スコアリング`,
"label.partnerCloud.financeSetting.enterWechat":`WeChatのマーチャントアカウントを入力してください。`,
"label.philippine.time":`フィリピン時間`,
"five":`五`,
"label_average_value":`平均値`,
"message.realdelete":`確かに完全削除しますか。`,
"label.currency.note":`新しい通貨種別を入力してください。ご注意：通貨種別を有効化した後に、削除できません。`,
"label.projectManagement.delete.prompt":`プロンプトの削除`,
"label.approval.present":`（現在）`,
"label.escalation.setup.newrule.name":`ルール名`,
"label.edit.list":`編集可能なデータリスト`,
"label.partnerCloud.financeSetting.informationOne":`1.Alipayマーチャントセンター（b.alipay.com）にアクセスし、Alipayの加入者でログインします。`,
"label.customfields.numberText":`2.入力した数字の長さと小数桁数との和は18桁を超えてはいけません`,
"label.biaoqing.businessverify.relation.tip":`bid&tenderの戻り値をリードフィールドに書き込む`,
"label.icon.149":`ロボット`,
"System.btn.SaveAndCommit":`保存して提出`,
"label.calendar.many":`数人`,
"label.ccchat.create.email":`メールが作成されました`,
"template.report.income.marketing.activities":`キャンペーン収入の報告`,
"label.ccchat.person.invite.needemail":`1つのメールアドレスを入力してください。`,
"template.report.open.amount":`非公開金額`,
"label.currentoperate":`既存のアクション`,
"label.finalapprove":`最終承認`,
"label.emailmerge.mergepage.step2":`2.マージするテンプレート最大20まで選択できます：`,
"label_tabpage_sorttypez":`並び替え方法`,
"label.workbanch":`私のワークベンチ`,
"font-evaluate-module-v1-disable":`本当にこの機能を停止していいのか？`,
"label.ServiceCloud.distributionMap":`分布図`,
"lable.Confirm.potential.customers":`{num}個のリードを受け取ることを確認します。`,
"label.mobile.quickcreate.default.nearby":`付近`,
"label.isremider.noremider":`通知しない`,
"label.approval.select.step":`返す必要がある承認ステップを選択してください`,
"chatter.error.pm":`エラー：アップロードしたファイルは大きすぎます。`,
"UG_activity_08":`日程を予約する`,
"label.marketsea.notwinopportunitydays":`成約しない日数（商談を制作していない日数よりも多いことが必要です）`,
"label.selectpage":`既存ページを選択します`,
"label.dashboard.dispalyOnTheHomePage":`表示されたホームページ`,
"front-lightning-module-v1-details-page-chart-set-report":`レポートの設定`,
"vue_label_pool_mydeal":`私が成約したの`,
"vue_label_report_lastone":`最後の1つ`,
"label.tabpage.potentialcustomersz":`リード`,
"font-evaluate-module-v1-more-satisfied":`私たちは十分ではありません。 次回はもっとご満足いただけるようにします。`,
"label.trigger.instructions":`<font color`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`承諾の完成率`,
"label.umeng.approval.dlsp.approvenew":`代理承認：#actornameは#objAPIName#recordnameの承認を申請してます。`,
"label.edit.visualpagefolder":`カスタマページ：フォルダの編集`,
"label.pc.flash.teach":`動画による教育`,
"label.showsearch":`検索を表示`,
"label.reportsSubscriptionPage.condition.title1":`すべての条件が満たされた後に通知が届きます`,
"label.h5.search.result":`結果`,
"vue_label_commonobjects_view_chart_pie":`円グラフ`,
"label_please_enter_currency":`通貨を入力してください`,
"chatter.share.to.profile":`あなたのプロファイル`,
"label.mykeeptouchset":`私のキープインタッチの設定`,
"label.profile.mustcopyaprofile":`コピーをする既存のプロファイルをご選択ください。`,
"label.managereport":`レポート管理`,
"label.total.choice":`件のファイルで、選択した`,
"label_emailtocloudcc_help":`正しいメールアドレスのパスワードまたは認証コードを入力してください。IMAP/SMTPサービスをオープンしてから第三者のクライアントが登録することができるようになりますから、まずメールボックスに登録して、このサービスがオープンしたことを確認し、対応するライセンスコードをコピーしてパスワードボックスに入力してください。`,
"label.trigger.sel":`当該フォルダのトリガー`,
"label.dashboardLookUp":`ダッシュボードを表示`,
"label.batchadd.newbatchpage.save.emptytext":`記入されていない必須項目がありますが、チェックしてください。`,
"setup.mainpage.label.welcome16":`手順は以下の通りです。ページ左側のメニュー → アプリケーション設定 → 作成 → ワークフロー、承認プロセス、タスク、メール通知、項目更新などをクリックする。`,
"vue_label_email_mark as":`としてマークする`,
"label.customobjdel.cannot.delete.try":`オブジェクトはその他のオブジェクトの下記のリレーションシップと関連しているため、削除ができません。`,
"label.customsetting.visible.public":`公開`,
"label.log.bit":`桁数`,
"label.data.exportall.all.desc":`該当ユーザーが参照可能なすべてのオブジェクトデータをエクスポートします。`,
"message.login.mfadevice.already.bound":`ユーザはすでにMFAデバイスをバンディングしました`,
"label.campaign.channel.please.img":`画像をアップロードしてください`,
"assetbom.manage.notpermission":`管理資産のBOMにアクセスできるようにするには、管理者にお問い合わせください。`,
"schedstarttime.schedendtime.time.illegal":`サービス予約の開始予定時刻は実際の終了時刻より小さいべきです。`,
"label.referperson":`所有者`,
"front-email-payment-area":`地区`,
"label.c.d.least":`「C」レコードには、少なくとも1つの関連「D」レコードが必要です。`,
"label.weixin.longitude.isnull":`経度緯度は空で、あるいは無効です。`,
"setup.layout.button.ok":`確認`,
"vue_label_fiter_component_date_customdate":`カスタム日付`,
"label.enable.case.createarticle":`ユーザーがケースから記事を作成できるようにする。`,
"label.event.moveup.8hour":`8時間`,
"label.input.most.string":`最大で {0} 文字まで入力してください`,
"lable.SalesCommitmentKanBan.contractEndDate":`契約の終了日`,
"label.visualpage.function.name":`方法に名前を付ける：`,
"label_emailtocloudcc_redmessage1":`正しいメールアドレスを記入してください`,
"message.aliasnameinput":`エラー：一意の名前は英数字しか含めません。英字からスタートし、しかも一意でなければなりません。`,
"label.data.exp.selectedtemp":`データを選択して、ご希望のテンプレートをエクスポートします`,
"label.import.page1.suitedwayoflinkman":`取引先責任者をマッチングする方式`,
"label.customsetting":`カスタマ設定`,
"label.versiontype.Free":`無料版`,
"setup.layout.label.norelatedlist":`関連リストなし`,
"label.forecast.edittotal.de.leiji":`の累計`,
"label.customfields.file.max":`アップロードするファイルは大きすぎて、5Mを超えないでください。`,
"label_partner_all_workspace":`ワークエリア`,
"label.searchrelation":`参照関係`,
"label.icon.185":`助言`,
"label.service.gantt.effective":`有効`,
"label.newreportstp1":`ステップ1：レポートタイプを選択`,
"label.category.9":`製造`,
"label.zuowei":`として`,
"front-quotation-v1-select-quota":`見積もりを選ぶ`,
"label.dashboard.refresh":`更新`,
"label.weixin.saveandnew.log":`ログの保存&新規作成`,
"label.report.list":`レポートリスト`,
"FL":`ファイル`,
"label.h5.followingcolleagues":`フォローした同僚`,
"template.report.conversions.number":`リードのコンバージョン数（オーナー別）`,
"label.validate.function.funcFormat.MONTH":`MONTH(date)`,
"front-kefu-moudle-v1-tenant-ID":`借主ID`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`時間`,
"label.multilang.workflow.everyotherday":`{0}日置き`,
"label.chat.message.send.message":`メッセージの送信`,
"label.knowledgebase.fast.operation.error":`クイック・オペレーティング・エラー`,
"label.multilang.dupicatecheck.dumplicatedata":`{0}件のレコードで条件に満たす{1}件の重複データを検索し、{2}ミリ秒がかかりました。1ページに{2}件のデータが表示されます。`,
"vue_label_report_addFile_detail_Information":`2000の詳細情報行のみをエクスポートします。このデータを使用して、より多くの計算を行うか、または他のシステムにアップロードします。`,
"label.ccchat.message.search.desc3":`検索メッセージ`,
"message.deletereport.prompt":`当該レポートを削除することができません`,
"pagecreator.page.message.save.success":`ページの保存に成功しました`,
"vue_label_rise":`上昇`,
"label.appupload.install.error.choicehead":`既存のコンポーネントはインストールするコンポーネントとコンフリクトする場合、如何処理しますか。`,
"message.dispatch.violation":`発送時間の違反：発送期間がリソースの作業時間の範囲内ではありません`,
"label.tool":`道具`,
"label.sso.saml.idp.downloadcert":`ライセンスのダインロード`,
"label.chatter.detailinfo":`詳細情報`,
"label.area.tree":`エリアの階層ツリー`,
"label.partnerCloud.priceOfManual.notEnabled":`非活性化`,
"label.chosesubject.call":`コール`,
"label.leadscore.rule.detail":`リードスコアリング：ルールの詳細情報`,
"front-welcome-to-try":`試練を迎える`,
"label.umeng.activity.event.willbegin1":`行動#eventは#timeから開始します`,
"component.event.label.noevent":`今日の仕事は既に完了したようですね。`,
"label.document.templatesetof.folder":`フォルダのテンプレートセット`,
"label.quickbooks.none":`一致するデータはありません。手動に検索または作成してください。`,
"label.assignment.setup.newrule.inputrule":`割り当てルール名の入力`,
"label.appointmentdetail.wizard.title4":`会社名`,
"label.malaysia.time":`マレーシア時間`,
"label.partnerCloud.partnerAccount.way":`トップアップ方式`,
"label.roleoflinkman":`取引先責任者のロール`,
"mesage.error.role.delate.user":`ロールにユーザが割り当てられたため、ユールを削除することができません。`,
"chatter.warning":`警告：その他のオブジェクトを選択したら、先の変更が保存できません。このアクションを確かに執行しますか。`,
"label.service.gantt.violations.sum":`不正なサービス予約数`,
"label.permission.objectpermission.recordfenpei1":`割り当てられたレコードタイプ`,
"label.mobile.phone.required.plan":`計画は必須項目です`,
"label.after_leaving":`離脱後は現在のデータは保存されません。`,
"label.cpq.opportunity.mainquote.trasnfer.order":`機会の下で一次見積が行われ、注文に移行しています。`,
"component.setup.iframe.label.title":`ページのカスタマイズ`,
"visit.dispatchplatform.nopermission":`権限不足：ディスパッチコンソールへのアクセスが許可されていません。管理者に連絡してください。`,
"label.validate.function.funcExplain.RIGHT":`テキストの文字列の右側から数える実行数の項目に戻ります`,
"component.chatter.link.button.save":`発表`,
"label.knowledge.selection":`各Knowledgeでは、最大8つのデータグループを選択することができます。`,
"chatter.email.homePage":`私のCCChatホームページに投稿した`,
"vue_label_commonobjects_view_copy_view":`コピービュー`,
"label.documentmessage":`フォルダ詳細情報`,
"label.emailtocloudcc.step1":`ステップ1`,
"label.user.mfa.unbind":`選択したユーザのMFAのバインディングをクリア`,
"label.stdashbord.xsld.business.sdzje":`チャンスロスの総金額`,
"vue.please.select.the.total.method":`集計方法を選択してください`,
"label.stdashbord.xsld.business.img1":`確率1％～99％のステージ数`,
"label.reportsSubscriptionPage.condition.title":`購読機能を除き、このレポートに条件を設定することができます。条件が満たされたときに通知が届きます。これは必須項目ではありません。`,
"chatter.sel.field":`20以上の項目を選択しました`,
"label.login.access.year":`年`,
"label.dashboard.all":`すべてのダッシュボード`,
"label.approver":`承認者`,
"Lead.Homepage.Tools.BatchScoring":`バッチスコア`,
"lable.opppdt.selPdt.lesscondtions":`より少ない検索条件`,
"label.integrations.action.export":`すぐエクスポート`,
"label.datamanage.lookupandsure":`（参照と確認）`,
"label.email.attach.to.mail":`メールに追加`,
"message.nodataordeleted":`データは存在しません、または削除されました`,
"component_newrecords_label_all":`すべて参照`,
"lable.currencyAdv.startdate.rate":`開始時刻が下記範囲で定義されるすべての為替レートを表示します`,
"label.callbackoperate":`呼び戻しアクション`,
"label.knowledge.setting.hint.eighteen":`知恵袋の記事作成開始`,
"label.user.step4.submit.email":`ステップ4.メール送信申請は提出済み`,
"label.appointment.wizard.subtitle4-1":`イベント間の移動時間`,
"component.assistant.button.newtask":`新規ToDo`,
"label.icon.129":`カード`,
"label.relatedlist":`関連リスト`,
"label.report.recently":`最近の表示`,
"label.batchadd":`一括追加`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}"の削除に成功しました。`,
"label.appupload.upload.otherdetail":`その他の詳細情報`,
"label.emailobject.link":`シンク`,
"label.quickbooks.createcustomer":`QuickBooksで新規取引先を作成する`,
"report.label.projectcount":`件のプロジェクト、レポート名に基づいて並び替える。`,
"vue_label_normal_contact_sf":`取引先責任者`,
"chatter.group.groupActivities":`すべてのチーム`,
"label_tabpage_addoptionsz":`オプションの追加`,
"label.knowledgebase.submit.for.translation":`翻訳を依頼する`,
"vue_label_pool_notallowed":`企業の性質上で許可されない`,
"label.icon.80":`製紙`,
"label.readonlys":`参照のみ`,
"label.recordsediting":`レコードの編集可能性`,
"label.mr.title.email":`メール`,
"label.partner.all.enable":`有効化`,
"label.customsetting.manage.errmessage":`まずカスタマ項目を保守して、データを管理してください`,
"label.cloudccclass.list.cls":`クラス`,
"label.weixin.click.loadall":`すべてアップロードをクリック`,
"label.weixin.appr.initialtime":`発起時間`,
"UG_ST_002":`確認`,
"setup_mainpage_label_welcome17":`権限の設定`,
"label.appupload.state0":`未アップロード`,
"label.icon.115":`家`,
"setup_mainpage_label_welcome5":`カスタマ項目`,
"lable.custom.year.ovdate":`カスタム年度の終了日`,
"label_tabpage_findz":`検索`,
"label.appupload.uploading":`ソフトパッケージをアップロード中`,
"setup.mainpage.label.welcome1":`対応する権限が必要です`,
"label.file.folder.delete2":`ライブラリを削除しますか？`,
"2018UI_Homepage_DataNoAccess_Info":`このレコードにアクセスする権限がありません。クリックして前のステップに戻る。`,
"label.ems.google":`グーグル`,
"label.hawaii.aleutian.standard.time":`ハワイ標準時`,
"template.report.unfinished.tasks":`未完了のタスク`,
"vue_label_calendar_add_calendar":`カレンダーの追加`,
"label.button.sel.useremail":`選択済みのユーザにメールを送信します`,
"user.email.template":`{username}様：<br>{Campaign.name}]の招待コードは以下のように表示されています<br>{Campaign.ColleagueInvitationLetter}<br>また、URLは以下のようになっています<br>{Campaign.ColleagueInvitationLetterLink}<br>今回のキャンペーンではQRコード登録とURLリンク登録ができます。ご協力ありがとうございます。<br>キャンペーン所有者：{Campaign.Owner}。`,
"label.forecast.settings.shouru":`期待収益`,
"label.casesensitive":`ABCをabcと同じ値とします（大文字と小文字は区別されます）`,
"message.pleaseinputrightdistanceweek":`正しい間隔（週間）を入力してください`,
"label.linellae-group":`線-グループ化`,
"label.showdefault_times":`デフォルトの発行時間を表示`,
"label.smstemplate.finishmessagedetailinfo":`SMSテンプレートの詳細情報を入力する`,
"label.service.miniProgram.backgroundImage":`背景図`,
"label.recentview.news":`最新のレコード`,
"label.reportType.chose.and.form":`レポートデータソースとレポートフォーマットの選択`,
"setup.layout.button.additem":`選択したアイテムの追加`,
"front-epwechat-module-v1-auto-mate":`オートマッチ`,
"vue_label_helpcenter_contract&plan":`契約とは、当事者間の書面による合意のことです。多くの企業は、他社との取引条件を定義するために契約書を利用します。Cloud CCでは、取引先や商談との既存契約を確立し、文書化します。承認プロセスで契約を追跡します。<br>代金受取計画と契約アシスタントなどの機能を通じて、取引を管理します。`,
"label_mobile_version_nonsupport_feature":`このバージョンでは、この機能がサポートされていません。最新バージョンにアップデートしてください。`,
"label.icon.44":`火`,
"label.data.downpage.i.title.num3":`3、インポートする前に、すべての関連レコードをインポートするようにしてください。例えば、今インポートしているオブジェクトと連絡先とルックアップ関係がある場合、先ず連絡先をインポートしてからデータをインポートする必要があります。`,
"label.mr.object.customer":`取引先`,
"label.social.user.null":`ソーシャルのユーザー情報は空にできない`,
"front-epwechat-module-v1-unbound-item2":` アプリケーション設定の全データ`,
"label.partnerCloud.partnerAccount.noempty":`トップアップの金額を空にすることはできません。`,
"label.weixin.myapproval":`私の承認`,
"label.data.setok.e_desc1":`エクスポートが成功したら、システムからの通知メールが送られます。エクスポートしたデータは48時間サーバー上で保存されますが、データエクスポートのリスクページでできるだけ早くエクスポートするデータをダウンしてください。`,
"lable.batchadd.service.cfq.after":`トリガー（After Insert)`,
"label.umeng.activity.youhaveanevent":`新な行動が1件あります`,
"label_emailsync_status_connectaccounts":`関連先のメールアカウント`,
"label.multilang.shenpi.count":`{0}件のレコード`,
"pagecreator.page.message.delete.fail":`ページ削除に失敗しました`,
"label.version.sum.lookupmdfield":`主な詳細項目（個）`,
"vue_label_pool_clueduplication":`クルーの重複`,
"label.system.setup.log":`システム行為ログ`,
"label.globaloperation.operationtype.send.e-mail":`メール送信`,
"vue_label_pricebook_entry":`新規価格表エントリー`,
"label.forecast.forehistory.submit.date":`提出時間`,
"chatter.handle":`何を処理していますか。`,
"lable.SalesCommitmentKanBan.complete":`完了した金額`,
"label.weixin.upload.pictures":`画像をアップロード`,
"label.create.document":`新規フォルダ`,
"vue_label_commonobjects_detail_unlockconfirm":`ロックを解除しますか`,
"label.customer.page":`カスタマページタブ`,
"button.partner.workspace.saveas":`別称で保存`,
"setup.layout.label.asc":`昇順`,
"label.ccpeak.folder.time":`ファイリングされていないスケジュール済みクラスファイル`,
"label_tabpage_includez":`含む`,
"label.custom.button":`カスタマボタン`,
"label.weixin.binding":`バインド`,
"P":`パーセント`,
"chatter.stop.n":`このレコードの追跡をキャンセル`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`水曜日`,
"template.report.revenue.marketing.activities":`キャンペーン収入`,
"lable.SalesCommitmentKanBan.theActualReceipts":`実際の代金受取金額`,
"vue_label_popularresults":`人気がある結果`,
"label.log.belongs":`所属部分`,
"label.profile.remark":`当該プロファイルを持つユーザは、以下のアクセス許可とページレイアウトを使用します。システム管理者は、ユーザの個人情報を編集して、各ユーザのプロファイルを変更できます。`,
"label.appupload.component.type.button":`ボタン`,
"label.partner.all.operate":`アクション`,
"vue_label_notice_modify_fail":`編集に失敗しました`,
"label.icon.137":`地球`,
"front-dialog-module-v1-nosupport-copy":`クローンには対応していません。`,
"label.integrations.mailchimp.massage3":`権限の付与を解除`,
"UG.opportunity.010":`取引の作成`,
"front-lightning-module-v1-details-page-chart-selecting-reports":` 選択できるのは、パブリックレポート、つまりすべてのユーザーがアクセスできるレポートと、未提出のパブリックレポートのみです。`,
"System_btn_SaveAndCommit":`保存と提出`,
"vue_label_dashboard_statisticaltype":`統計タイプを選択してください`,
"label.mr.object.opportunity":`商談`,
"label.area.detail.remark":`テリトリーのユーザのプレビュー`,
"label.view.sortview.index":`番号`,
"label.mobile.quickcreate.default.events":`行動`,
"label.product.price":`販売価格`,
"label.leadmarketsea.edit.title":`リードプールの編集`,
"pagecreator.layout.button.edit":`レイアウトの編集`,
"label.addressee":`受信者`,
"label.movablesearchlayout":`活動検索レイアウト`,
"label.ems.confirm":`確定`,
"vue_label_file_save_to_file":`ファイルに保存する`,
"component_chatter_button_more":`詳細情報を更に表示します`,
"label.ccdocument.hidden.trace":`履歴の非表示`,
"label.partnerCloud.maximumTwo":`最大2Mのファイルに対応しています。`,
"label.event.moveup.4hour":`4時間`,
"label.batchadd.save":`共有の追加が失敗しました`,
"label.passwordPolicy.setup.expireDate":`パスワードの有効期間`,
"label.workflowrule":`ワークフロールール`,
"vue_label_notice_pleaseselecview":`ビューを選択してください`,
"label.h5.chatter.colleagues":`同僚に関して`,
"lable.opppdt.addpdt.subtitle":`に商品を追加`,
"label.data.import.setup.repeat.no":`いいえ‐すべてのレコードを私がインポートしたファイルに挿入します`,
"label.changeCorporate":`会社の通貨種類を変更`,
"label.customfields.dateandtime.tip":`日付/時間を直接入力することも、ポップアップのカレンダーから選択することもできます。ポップアップから選択した場合は、選択した日付とそのときの時間が日付/時間項目に入力されます。`,
"label.integrations.mailchimp.massage1":`エクスポートするレコードを少なくとも1つ選択してください`,
"lable.PowerProcess.custom":`カスタム条件に基づく`,
"label.service.editDialog.displays.service.appointmentsFordays":`水平日付の{before}日前と水平日付の{after}日後のサービス予約を表示します`,
"label.Receivables.ActualMoneyTime":`実際の代金受取時間`,
"label.matrixreport.intro":`マトリックスレポートは行および列ごとにデータを集計することができます`,
"message.validation.isnotnumber":`正しい数値を入力してください`,
"label.partner.workspace.member.search":`検索`,
"label.customfields.deletewill":`当該カスタマ項目を削除すると`,
"label.content":`内容`,
"component.setup.button.weburl":`外部URL`,
"setup.mainpage.label.welcome28":`手順は以下の通りです。このページの左側のメニュー→設定管理→データ管理→データのインポート・エクスポート、一括転送、一括削除をクリックしする。`,
"label.related.setup":`ToDO&行動の関連先の配置`,
"label.weixin.sign":`サインイン済みで、再サインインの必要はありません`,
"label.norecord":`表示するレコードはありません`,
"label.emailmerge.detail.emailtempldatemerge":`差し込み印刷テンプレート`,
"label_emailsync_status_role":`ロール`,
"label.mobileapp.modelsetting2":`実際の使用シーンから業務ニーズに適切なモジュールを選択してください。チェックしたら、モジュールがモバイル端末に表示されます。マルチ-「推奨機能」<br/>無効になります。チェックしたらモジュールは？モバイル端末に再表示されます。「より多く」→「推奨機能」`,
"component.sendmail.label.title":`メール送信`,
"component_assistant_button_newevent":`新規行動`,
"label.chatter.input":`関連内容をご入力ください`,
"message.error.view.operate.rtnlink":`<a href='javascript:history.back();'>ここ</a>をクリックして、前のページに戻る`,
"lable.new.profile":`新規プロファイル`,
"label.custom.field.null":`使用可能なし`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`土曜日`,
"label.stdashbord.xsld.business.img4":`可能性が100%の段階にある総金額`,
"pagecreator_layout_button_splitall":`すべて分割`,
"label.mobile.phone.total.amount":`総金額（万元）`,
"label.ratifyhistory":`承認履歴`,
"label.projectManagement.Antecedents":`プレToDo`,
"label.projectManagement.Newserviceappointment":`新規サービス予約`,
"label.delete.record.is.approval":`削除するレコードは承認中のレコードで、確かに削除しますか。`,
"front-gantt-module-no-tasks-describe":`ワークアイテムが時間経過とともにどのように整理され、どのように重なり、どのように関連しているかをガントチャートで確認することができます。`,
"vue_label_visualize_data":`TianYanChaのデータが入力されています。変更を保存してください。`,
"UG.activity.02":`割り当てToDo`,
"label.field.duplicate2":`重複する値は許可されません`,
"label.cloudccclass.list.tip":`開発者はCloudcc.comプラットフォームでカスタマページとトリガーに使用するクラスを開発することができます。`,
"before":`より早い`,
"UG.ST.001":`プロンプト`,
"label_tabpage_userGuidez":`ユーザガイド`,
"vue_label_account_looking_for":`検索内容を入力してください。`,
"vue_label_calendar_notice_timecantmove":`このカレンダーの日付をドラッグして変更することはできません。`,
"label.mobile.phone.enter.summary":`ここでまとめを入力します`,
"label.object.api.existed":`オブジェクトapi名は存在済みで、api名を修正してください`,
"label.weixin..xsld.order.by.time":`契約締結予定日に基づいて並び替えます`,
"label.h5.chatter.whether":`可否`,
"label.file.delete.success":`ファイルの削除は成功しました。`,
"label.imgfield.type.url.tip1":`ユーザは画像のリンクをインポートすることができ、また画像リンクを通じて&cimgSizeを追加します`,
"label.tomanyrecords":`リストのエントリーは5000件を超えています`,
"label.save.partnercloud":`パートナークラウドの保存にエラーが発生しています。`,
"vue_label_homepage_fliteritems":`設定項目のフィルター`,
"pagecreator_page_button_new":`新規のページ毎`,
"label.sharerule.baseofcondition":`条件に基づく`,
"label.dashboard.snapshot":`ダッシュボードスナップショット`,
"label.appointmentpage.wizard.subtitle1.1":`日付と時間を選択してください`,
"label.reportsSubscriptionPage.condition.emailsummary":`レポートのみ発送`,
"chatter.group.showAll":`すべて表示`,
"label.tabpage.helpNavigationz":`ヘルプとナビゲーション`,
"label.emailtocloudcc.button.back":`キャンセル`,
"approval_request_email_subect":`承認申請`,
"label.lookup.error":`検索時エラーが発生しました`,
"label.publicgroup.save.groupisnull":`保存するときグループデータがNULLであれば、再保存してください。また問題があれば、システム管理者に連絡してください。`,
"label.pie":`円グラフ`,
"chatter.feed.is":`は、ユーザーが一緒に仕事をしたり、お互いに話したり、情報を共有したりすることを可能にする企業ネットワークで、すべてがリアルタイムで行われます。`,
"label.customfields.file.max5m":`ファイルの最大サイズは5Mです`,
"com.cloudcc.login.error.message.vaildauthfail":`無効なログイン認証`,
"label.profile.appsetuppermission":`アプリの設定管理`,
"label.customfields.file.totalmax":`アップロードしたファイルは大きすぎて、500Mを超えてはいけません。`,
"label.sms.list":`SMSインターフェス情報リスト`,
"message.error.referencedcolumnIdnotexist":`レポートが参照した項目が削除されたため、表示できません。システム管理者に連絡してください。`,
"front-lightning-module-v1-details-page-chart-setting-chart":`チャート・オブ・レポートの設定`,
"label.recordtype.profile.enables":`現在の使用可能なレコードタイプ`,
"chatter.this.n":`このレコード`,
"label.only.upload.file":`アップロードできるファイルはjpg/pngのみで、しかも500kb以下です`,
"vue_label_lead_conversion_failed":`置換えに失敗しました`,
"label.file.share.file.success":`ファイルの共有に成功しました。`,
"label.processsetting.delete.process":`確かにこのプロセスを削除しますか。`,
"message.uniquenamevalidate":`文字から始まり、アンダースコアと英数字しか使用できません。`,
"label.group.archived.desc.info":`このチームはファイリング済みで、新しい書き込みとこのチームと共有するファイルを作成することができません。チームを有効化したら、すべての機能も有効になります。`,
"label.customer.maincontact":`主な取引先責任者`,
"label.appointment.wizard.subtitle1-9":`4時間`,
"label_productline_income":`製品シリーズの収益`,
"label.dashboardSetup.tz.ybb":`ダッシュボードにスキップ`,
"label.recordowner":`レコード所有者`,
"message.approval.othersdoing":`その他の人がこのプロセス作業を行っており、更新して最新データを獲得します。`,
"Opportunity_Detailed_Phase_Label_002":`現在の状態はすでに{ 0 }日間にとどまっている`,
"label.field.validating.rule.isnot.passed":`入力規則の編集が通過しなかったため、構文チェックしてください。`,
"label.textmessage.fieldskong":`メッセージの挿入されたフィールドの一部がNULLになっています。`,
"com.cloudcc.login.error.message.islocked":`ユーザーはロックされています。`,
"label.forecast.customforecast.foredis.debfb":`クォータのパーセント`,
"lable.opppdt.selPbk.changepbk.worning":`この商談の価格表を削除すると、この商談に関連する商談商品も削除されますが、続きますか。`,
"label.mr.backLookReData":`戻って、重複データリスクを参照します`,
"label.quickbooks.searchqb":`QuickBooks の検索`,
"label.service.gantt.searchSkills":`検索スキル`,
"label.account.Current.and.NexttFQ":`現在とこれから3つの四半期決算`,
"customer.notopen.chat":`組織がチャット機能を有効にしていないので、管理者に連絡してください。`,
"vue_label_commonobjects_view_sum":`合計件数: {total}件`,
"label.partnerCloud.orderingPlatform.adjust":`注文商品の調整`,
"label.emailmerge.mergeFolder.tips":`このページでは、コンタクトデータを含むMicrosoft Wordファイルを生成することができます。マージするメールテンプレートを選択してください。テンプレートは最大20個まで選択できます。`,
"vue_label_ccchat_notice_deletecommentfail":`コメントの削除に失敗しました。`,
"label.emailsync.status":`ユーザーのメール状況の統計`,
"label.forecast.forecastroleuserpage.desc":`ロールに予測マネージャーを割り当てます。部下の予測はそのマネージャーの予測に集計されます。`,
"label.step1.total4":`ステップ　1/4`,
"front-kefu-moudle-confirm-fjcase":`このケースを分割しても大丈夫ですか？`,
"label.icon.60":`クレーン`,
"label.appointmentpage.wizard.subtitle3":`情報を入力してください`,
"label.loginservice.license.exceed.time":`ライセンスは期限切れです。`,
"label.customcomponent.check.tag.lastrow":`最後の一行は必ず`,
"label.product.code":`商品コード`,
"label.salescloud.salesdashboard.phone":`電話`,
"label_please_input_price_list_price":`価格表の価格を入力してください`,
"label.multilang.page3":`ページ`,
"label.file.lastmodifydate":`モディファイドタイム`,
"label.icon.121":`コンピューター`,
"message.error.system.service.unknow":`知らないサービスで、システム管理者に連絡してください。`,
"label.thesecond":`二列目`,
"vue_label_report_conditiondesc_two":`このレポートに条件を追加する`,
"label.exchange.serverUrl":`サーバーアドレス`,
"RL":`参照`,
"label.emailobject.emailsend.sendindividuallyprompt":`「個別送信」は複数の人にそれぞれ送信し、みんなは自分宛のメールを受け取ることができます。「個別送信」を行いますか？`,
"label.appointmentconfirmpage.wizard.subtitle4":`参加者`,
"message.save.opportunity.team.save.failed":`商談チームは失敗しました`,
"vue_labenl_normal_notice_share_success":`共有に成功しました`,
"label.triggerfolder":`トリガーフォルダ`,
"label.more":`さらに表示
`,
"label.file.num":`数量`,
"label.dashboard.list.sortBy":`件のプロジェクト、アクセス時間に基づき並び替えます`,
"c":`通貨種別`,
"label.weixin.detail.edit":`編集`,
"label.escalation.setup.newentries.step2":`ステップ2.当該ルールエントリーの条件を選択`,
"label.report.error.prompt":`設定に失敗しました。行のセットを持つシリーズレポートのみがサポートされています。公開されているレポートで、削除されていないことを確認してください。`,
"label.notification.new":`新しい通知`,
"label_tabpage_releaseTourz":`ガイドのリリース`,
"label.icon.41":`ポジショニング`,
"label.sendsms.hello.new":`こんにちは：新しいのがあります`,
"label.custom.combination":`コンバイン`,
"label.project.hit.fifteen":`マイルストーン課題のお知らせ`,
"label.campaign.channel.step6.mobile":`モバイル端末ページの生成`,
"label.goback.N.step":`ステップNに戻ります`,
"label_partner_all_name":`パートナークラウド名`,
"label.usermanage.loginusername.exist":`ログインユーザ名は存在済みです。`,
"template.chart.cpxse":`製品販売`,
"chatter.feed.deletecomments":`確かにこのコメントを削除しますか`,
"label.list.userinterface.show.newrcords.enable":`最近レコードの使用を禁止`,
"label.sso.saml.idp.config.enablelogout":`シングルログアウトを有効化`,
"label.file.library.create":`新規ライブラリ`,
"label.event.moveup.half.day":`0.5日`,
"label.stdashbord.xsld.business.jhzje":`商談金額`,
"label.partnerCloud.orderingPlatform.unitPrice":`ユニットコスト`,
"label.recordtype.edit.attribute":`一般プロパティ`,
"front-template-V1-TemplatePreview":`テンプレートプレビュー`,
"label.tabpage.personalCenterz":`個人センター`,
"label.setuplookuplayout":`レイアウトの検索`,
"label.no.merge.records":`マージできるレコードがありません`,
"label.attachementNew.set2":`ステップ2.ファイリングしますか`,
"label.publicgroup.detail.showmembers":`チームメンバーを表示`,
"UG.Forcast.03":`計画を立ち上げ、業務戦略を実行します。<br>ご予測をお楽しみください。`,
"label.h5.manageprompt":`あるタブを選択して、ホームページに追加し、またはタブアイコンをクリックしてタブを開きます。`,
"label.icon.145":`関連した`,
"label.select":`選択`,
"label.publicgroup":`公開グループ`,
"label.customcomponent.usewhere.title":`当該コンポーネントの位置を使用`,
"label.custom.page.button.name":`ボタン名`,
"pagecreator_layout_button_vertical":`縦割り`,
"label.marketsea.autorecyclerule":`自動回収ルール`,
"label.reportsSubscription.entrance.attachment":`エクセル形式 .xlsx`,
"component_chatter_button_collect":`ブックマーク`,
"label.page.step2.of.step5":`ステップ 2/5`,
"label.reportsSubscription.addfile.helptext":`購読メールにレポートを添付するかどうか、または添付するレポートの形式を設定することができます`,
"label.oldpw":`現在のパスワード`,
"lable.SalesCommitmentKanBan.contractAmount":`契約金額`,
"lable.Bundle":`スーペリアパッケージ`,
"label.weixin.unit.million":`単位（万元）`,
"label.app.choseprofile":`プロファイルの割り当て`,
"label_tabpage_editz":`編集`,
"label.email.attachement.size.info":`ファイルはより大きくなってはいけません`,
"label.chatter.pastSevenday":`過去7日間`,
"label.weixin.end.later.start":`終了時刻は必ず開始時刻より大きいです`,
"label.passwordPolicy.setup.lockoutPeriod":`ロックの有効期間`,
"pagecreator_page_funcpath":`/ページビルダー/ページリスト`,
"label.emailobject.apperror":`使用可能のメールサービスはありません。管理者に連絡してください。`,
"label.custom.page.button.broadband":`ボタンの幅 (ピクセル)`,
"label.weixin.contract.rate":`契約の達成率`,
"label.brief.payments":`代金受取金額`,
"lable.approvaldatamove.transfermsg":`未完了の承認申請を新規ユーザに一括転送します。`,
"label.datamanage.account.namenull":`ご注意：[取引先名]項目に割り当てないと、取引先レコードはインポートされることができません。`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`代金受取の累計金額`,
"Opportunity_Detailed_Phase_Label_001":`階段`,
"vue_label_helpcenter_calendar2":`<br> オブジェクトのカレンダー:オブジェクトを使って作成したカレンダーは、レコードのデータをカレンダーエントリとカレンダービューとして日付項目に表示されます。オブジェクトのカレンダーを編集または削除したり、各オブジェクトのカレンダーの色をカスタマイズすることができます。<br>新規行動<br> カレンダービューで新規行動を作成するには2つの方法があります。<br> (1) カレンダービューの右上にある「新規行動」ボタンをクリックすると、新規行動が作成されます。新規行動では、「関連項目」と「名前」項目で他のオブジェクトを選択することで、行動を商談などの他のオブジェクトと関連付けることができます。他のオブジェクトと関連付けられた行動レコードは、他のオブジェクトの詳細ページのアクティビティモジュールで同期されます。<br> (2) あるいは、カレンダーグリッドをクリックして新規行動を作成することもできます。<br>新規オブジェクトのカレンダー<br> Step 1: ナビゲーションメニューのカレンダータブをクリックして、カレンダービューページが表示されます。<br> Step 2: ビューの右側にある マイカレンダーを見つけ、マイカレンダーの傍にあるアイコンをクリックして、新規オブジェクトカレンダーのポップアップウィンドウに進みます。<br> Step 3: まず作成したオブジェクトカレンダーに名前を付けます。カレンダーの基礎となるオブジェクトを選択し、カレンダーの表示内容を決定する項目、「開始項目」、「表示フィルタ」、「表示項目」を選択します。開始項目はデータを表示する時間範囲を決定し、表示フィルタはデータをフィルタリングすることができ、表示項目はカレンダーエントリに表示される内容を決定します。<br>その他のカレンダー<br>その他のカレンダーには、追加された他のユーザーのカレンダーが含まれています。自分より下位の人のカレンダーや、自分とカレンダーを共有している人のカレンダーを追加することができます。<br> 私の行動カレンダーを共有する<br> ステップ1：ナビゲーションメニューの「カレンダー」タブをクリックして、カレンダー表示ページに進みます。<br> Step 2: カレンダービューの右側にある「マイカレンダー」から「私の行動」を見つけ、「私の行動」の右側にあるドロップダウンボタンをクリックして、「カレンダーの共有」を選択します。<br> Step 3: 「カレンダーの共有」のポップアップで、カレンダーの共有を望むユーザーとアクセス権を選択します。さらに、「現在アクセス権を持っている人」をクリックして共有されているカレンダーレコードを確認したり、共有されているレコードの右側にある「x」アイコンをクリックして共有されているレコードを削除することもできます。<br> カレンダーが共有されると、部下の同僚はあなたの行動カレンダーを他のカレンダーに追加したり、あなたのイベントカレンダーを参照することができます。<br>カレンダーを追加する<br> ステップ1：ナビゲーションメニューの「カレンダー」タブをクリックして、「カレンダー表示」ページに進みます。<br> Step 2: カレンダービューの右側にある「他のカレンダー」のドロップダウンボタンをクリックし、「カレンダーの追加」を選択します。<br> Step 3: カレンダー共有のポップアップで、追加を望む人の行動カレンダーを選択します。部下の行動カレンダーだけでなく、自分に共有されている行動カレンダーも選択できます。追加をクリックするとできます。<br> 追加されたカレンダーを削除する<br> 他のカレンダーの下にある削除したいカレンダーの右側にあるドロップダウンボタンをクリックし、「削除」を選択します。`,
"label.callcenter.Seat.number":`座席番号`,
"vue_label_commonobjects_view_change_all_selected_records":`選択したすべてのレコードを変更します`,
"label.user.notinuse":`ユーザは有効になっていません。システム管理者に連絡してください。`,
"label.usermanage.hasbeen.reached":`許可されたユーザー数の最大数に達し、より多くの許可数を獲得するよう、サービスプロバイダーに連絡してください。`,
"vue_label_help_list":`リストビュー`,
"label.infomation.edit":`一般情報の編集`,
"label.ccchat.person.setting.info":`無料でビジネスネットワークを開放しようCloudCCユーザーが、CCChatのCloudCCライセンスを持っていない同僚を招待できるようにします。招待を受けたユーザーは、プロフィール、ファイル、グループのみ見ることができますが、完全なCloudCCライセンスを認可しない限り、オブジェクトの詳細を見ることはできません。`,
"label.sso.isDelete":`削除しますか`,
"label.unique.identification.number":`固有の識別コード`,
"label.weixin.no.pending.projects":`承認待ちのプロジェクトはありません`,
"label.projectManagement.Pleaseenteramember":`メンバーを入力してください`,
"label.salescloud.salesdashboard.visit":`訪問`,
"label.weixin.user.registered":`ユーザ登録`,
"message.loginhistory.downloadcsv":`最近6カ月のログイン履歴をダウンロード（Excel.csv ファイル）`,
"label.icon.37":`ポジショニング`,
"template.chart.schdyqyx":`キャンペーンに期待する反応`,
"label.tel.ten":`通知する携帯電話番号を 10 つまで入力できます。電話番号毎に「」を入力してください。`,
"label.data.exp.objdata":`以下の条件に基づいて、このオブジェクトのデータをエクスポートします。`,
"label.loginservice.after.use":`使用可能になります。`,
"pagecreator_systemstyle_message_delete":`選択したスタイルを削除しますか`,
"label.globalselect.deleteerror":`この選択リスト値セットは以下の項目に使用されているため、削除できません。`,
"label.department.add":`新規部門の追加`,
"label.attendance.dingwei":`位置情報`,
"label.workflow.editrule":`ルールの編集`,
"lable.product.pecm":`正しい金額をご入力ください`,
"label.icon.182":`ブリーフケース`,
"label.help.release.notes":`ガイドのリリース`,
"UG.product.05":`製品のインポート`,
"label.email2":`メールボックス`,
"label.weekrepeat":`曜日重複`,
"label.mr.descreption.oneGroupReData2":`チーム`,
"chatter.at.d":`貢献度`,
"label.mr.descreption.oneGroupReData1":`重複検索&マージの進度：合計`,
"label.weixin.mobile.fly.android":`Android モバイル端末の共有`,
"label.brackets.right":`)右括弧`,
"message.recordtype.applytoAllProfiles":`1つのページレイアウトをすべてのプロファイルに応用します。`,
"label.customcomponent.page.index.tip":`プログラミング言語の機能と同様に、カスタムコンポーネントでは、共通の設計パターンをカプセル化して 1 つ以上のカスタマページで再利用できます。`,
"lable.List.properties":`リストの属性`,
"label.fieldinfo":`項目情報`,
"label.ems.error.fail":`アップロードに失敗し、改めてアップロードして、またはシステム管理者に連絡してください`,
"label_emailsync_form_email":`メール`,
"lable.currencyManage.button.manageRate":`通貨管理`,
"component_salesperformance_label_100finish":`完了済み`,
"label.knowledgebase.data.assignment.failed":`{a}データの割り当てに失敗`,
"label.custom.buttonandlink.remark":`モデルの選択：既存ウィンドウ/新規ウィンドウ（既存ウィンドウ：現在のウィンドウで開く。新規ウィンドウ：新しいウィンドウで開く。）`,
"label.list.userinterface.watermark.setup":`ウォーターマーク設定`,
"component_timeline_label_7daysahead":`前の7日`,
"label.sendemail.chat.replyinchat":`書き込みのコメント：`,
"component.salesperformance.label.title":`販売実績`,
"label.data.downpage.e.list.desc2":`データのエクスポートが完了した後、お知らせのメールが届きます。`,
"vue_label_campaign_fromclosedopprotunities":`ソース{sjcb}件の獲得した商談`,
"label.umeng.activity.taskviewed":`#name様に割り当てしたToDoはチェックされました`,
"vue_label_salesadvance_retentions":`滞留数`,
"label.fieldtag":`項目の表示ラベル`,
"label.quickbooks.button.searchinquickbooks":`QuickBooksで検索する`,
"label.quickbooks.viewlist.action":`アクション`,
"label.weixin.sysapp":`システムアプリケーション`,
"label.approval.examine.level":`ユーザー層に基づき審査され、最高のユーザ層は`,
"label.appupload.upload.error":`このアプリケーションはインストールできません。インストールを終えて、あるいはシステムのAPIを修正して改めてインストールしてください。`,
"label.emailtemplate":`メールテンプレート`,
"front-email-payment-Invoice-amount":`インボイスの金額`,
"label.viewselectedproducts":`選択した商品を表示`,
"label.tianyancha.businessverify.openfirst":`まず企業データ検証を有効化してください`,
"lable.SalesCommitmentKanBan.returnAList":`人のリストに戻る`,
"label.knowledgebase.nopublished.draft.translations":`出版されていない、またはドラフト版の翻訳`,
"vue_label_calendar_day_view":`カレンダー-日视图日表示`,
"label.globalselect.remark":`グローバル選択リスト値セットはオブジェクトの間で値を共有させます。`,
"label.orderby":`並び替え方法`,
"lable.weixin.LastaDaysFinished":`過去7日間に完了済み`,
"lable.currencyManage.Enabledadvcurrency.discripation":`通貨為替レートを特定の期日範囲内の期限切れの為替レートに対応させることができます。期限切れた為替レートは期限切れの為替は商談、商談商品及び関連するレポートに使用されます。期限切れの為替レートはその他のオブジェクト項目あるいはその他のタイプのレポートに使用されることができない。 例えば、1月1日の為替レートは1USD＝6.68CNYで、しかし2月6日の為替レートは1USD＝6.70CNYに変えました。終了時刻は1月1から2月6日までの間の業務は1月1日の為替レートを使用します。`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`一週間目`,
"label.leadtoobjectfield":`リードカスタマ項目の対応付け`,
"label.dashboardSetup.shujuyuan":`データソース`,
"label.tabpage.userz":`ユーザー`,
"label.sms.companyname.dsf":`東時方のSMSインターフェス`,
"label.step2.total3":`ステップ　2/3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`ドラッグでタスクを並び替え`,
"label.dashboard.snapshot.no.enabled":`ダッシュボードスナップショットが有効化されていない`,
"label.dashboard.unit3":`単位：整数単位`,
"label.forecast.shrepage.desc2":`アクセスを共有するユーザ、ロールとエリア`,
"label.commonobjects.new":`新規{eventName}`,
"label.view.nameonlyone":`ビューの一意の名前`,
"label.assignment.setup.newentries.user":`ユーザ`,
"label.otheremails":`その他のメール`,
"component_sendmail_button_send":`送信`,
"vue_label_accountpool":`取引先プール`,
"label.h5.approval.actortime":`発起時間`,
"message.approval.cannotsubmit":`承認待ちの提出ができません`,
"vue_label_pool_createdbyme":`私が作成したの`,
"label.change.event":`行動ビューに切り替え`,
"vue_label_homepage_personalpage":`個人ホームページ`,
"label.new.collect.target":`新しいアグリゲート指標`,
"label.ServiceCloud.zichanxuhao":`アセットNo.`,
"label.product.userl":`すべてのユーザに使用する列`,
"label.syslog":`システムログ`,
"label.reportcreatestatus":`レポートの生成状況`,
"label.datamanage.account.novalue":`ご注意：今回のインポートアクションは[取引先名]項目に割り当てしないため、取引先レコードはインポートされることができません。`,
"label.letter.body":`案内状本文`,
"label.select.please":`選択してください`,
"label.escalation.setup.entrydetail.description":`1.編集をクリックしてルールエントリーのプロパティを変更します。2.新規をクリックしてグレードアップのアクションを追加します。`,
"label.component.salesDashboard.nodata":`使用中の商談を追加して、ここに戻ってから業績を参照してください。`,
"vue_label_helpcenter_account":`詳細情報では、取引先の横にある樹形図ボタンをクリックすると、取引先の階層図が表示され、関連する取引先の上下関係を理解し、各取引先のいくつかの項目情報を参照します。<br>取引先の所有者を変更する場合は、その取引先に関する商談、ケースなど情報の所有者を同時に変更することもできます。`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWSインテリジェントサービス・コールセンター`,
"label.productby":`生成者`,
"label.operation.date":`アクション時間`,
"label.name.donot.delete":`名前は削除できません`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(date)`,
"label.escalation.setup.entrydetail.howescalationtime":`グレードアップ時間の設定方法`,
"label.view.step2":`ステップ 2.検索条件を指定`,
"lable.outlook.edit.notnull":`項目名は空であってはいけません`,
"label.knowledgebase.createnewbrowser":`新しいブラウザタブ`,
"label.partner.all.name":`パートナークラウド名`,
"chatter.group.groupSetUp":`チームの設定`,
"label.reportlist.findfolder":`フォルダを検索`,
"component.setup.tabs.label.title":`タブのページング`,
"label.passwordPolicy.setup.pswComplexReq":`パスワード文字列の制限`,
"label.emaildocument":`メールでフォルダを送信します。`,
"message.selectgsummaryconditon":`集計条件を選択してください`,
"component_todaytask_label_notask":`今日、期限切れになるToDoはありません。－時間があるうちに、コーヒーを飲みに行きましょう。`,
"label.user.organization.notexists":`組織は存在しません`,
"label.isEnableVisualpage.new.leftlist":`使用可能なカスタムページ`,
"label.mobile.phone.write.week.report":`週報の作成`,
"label.emailmerge.edittemplate.edit":`差し込み印刷テンプレートの編集`,
"template.dashboard.folder.sales.manage":`販売管理`,
"label.confirm.order.productsToassets":`本当に注文品を資産化したいのか？`,
"label.service.dispatchingUnits.leftRight.total":`現在{{ left }}-{{ right }件のデータで、合計{{ totalCount }}件のデータです`,
"label.import.step1.chooseidorother":`2、IDまたは名前のマッチングレコードと検索項目を選択することができます。対応するレコードIDなどの情報を取得すると、レポートを作成して、レコード名とレコードIDをグループ列に設定し、レポートをエクスポートします。`,
"label_tabpage_completez":`選択済みの状況を完了にする`,
"chatter.c.adr":`連絡先の住所`,
"label.account.d":`当該ページではカスタマ四半期決算レコードを定義することができます。カスタマ四半期決算の日付は以下の選択によって生成されます。`,
"label.tag.more50":`50表示ラベルまで作成することができます`,
"setup.layout.label.areashow":`エリア名の表示位置`,
"label.partnerCloud.basicSetting.rebate":`Rebateの有効化`,
"label.tabpage.greaterequalz":`大きい或いは等しい`,
"vue.please.select.the.aggregate.basis":`集計方式を選択してください`,
"label.form":`フォーム`,
"label.chatter.colleagues.list.beizhu":`有効化`,
"label.priority":`優先度`,
"vue_label_checkduplicate_set_repeat_rules":`重複ルールの設定`,
"label.share_form":`フォームの共有`,
"label_relation_shareholder":`株主と子会社は同じではいけません。`,
"label.project.hit.sixteen":`発行期限のお知らせ`,
"label.service.miniProgram.imageFormat":`アップロードできる画像はPNG、JPG、JPEGの形式のみです。`,
"label.summary.mode":`集計方法`,
"vue_label_beforeverification":`承認前`,
"label.data.newtemplate.desc":`ユーザが選択した項目と条件をテンプレートに保存し、繰り返し同じ作業をする場合、テンプレートを通じてエクスポートできます。`,
"lable.evaluation.badreview":`悪い`,
"label.total.tabs":`すべて{0}件の{1}`,
"label.emailmerge.mergeFolder.foldertemplate":`当該フォルダのファイル`,
"vue_label_normal_notice_repeated":`重複追加しないでください。`,
"label.icon.140":`データ`,
"label.fromonetoanother":`1つのユーザからその他のユーザに移行する`,
"label.user.list":`ユーザリスク`,
"label.file.prevent.share.operate":`他の人による共有と共有の取り消しを防ぎます`,
"label.app.detail":`アプリケーションの参照`,
"label.h5.similar.opportunity.correlation":`関連性`,
"label_emailtocloudcc_filed_username":`メールのユーザ名`,
"vue_labe_account_shareholdingratio":`持株比率`,
"label.data.dataexpalltype.all_desc3":`3、エクスポートしたデータはパックファイルに生成され、メールのファイル情報に基づき、エクスポート成功のファイルリスクページで、エクスポートするファイルをダウンロードすることができます。`,
"label.callcenter.please.select .seatID":`座席番号をお選びください。`,
"label.remark.length.cannot.than":`説明の長さは255文字を超えてはいけません`,
"label.batchtransfer.dateandtimetype.tip":`日付/時刻項目については、次のような書式で入力します：`,
"label.component.helper.businesschange.0UntreatActivity":`未処理活動の商談`,
"front-project-module-v1-plase-input-start-time":`開始日を入力してください。`,
"label.event.moveup.6hour":`6時間`,
"label.data.exp.tempexp":`テンプレートに基づいてエクスポート`,
"label.schedulejob.setup.schedule.afternoon":`午後`,
"label.ems.format":`表示形式`,
"label.objectHasBeenDeleted":`削除済みのオブジェクト`,
"label.ServiceCloud.chaxunchenggong":`検索に成功しました。`,
"label.campaign.channel.input.notice.owner":`所有者に通知`,
"label.bajisitan.time":`パキスタン時間`,
"label.warnMes":`オブジェクトが参照され、削除に失敗しました。`,
"lable.Up.to.ten.fields":`オブジェクトを選択し、最大10個のフィールドをチャートに追加します。上下の矢印をクリックすると、フィールドの順番を並べ替えることができます。`,
"label.approverule":`承認ルール`,
"message.error.specific":`具体的なエラーメッセージに戻る`,
"front-template-V1-saveUse":`保存とプレビュー`,
"label.uploadfile.success":`アップロードに成功しました`,
"label.tabname.donot.database.key":`タブ名はデータベースのキーワードを含んではいけません。`,
"message.recordtype.selectlayout.select":`ページレイアウトを選択`,
"front-detail-module-v1-list-cardview":`リスト/カードビュー`,
"label.product.maintenance":`保守`,
"vue_label_helpcenter_approve":`1.承認待ち項目<br> 承認が必要な項目をすべてリストアップします。承認待ちレコードは、承認レコードの開始日、終了日、提出者、レコードタイプ、関連項目などで検索できます。<br>単一レコードの処理。各レコードの左ボタンをクリックします。<br> A. 承認<br> Step 1: 「承認」をクリックして、承認依頼のページを開きます。<br> Step 2: 「承認」または「却下」をクリックして、承認操作を完了します。<br> 承認プロセスの設定で、次の承認ステップで承認者を手動で選択する必要がある場合は、「承認」の後にStep 3が実行されます。<br> Step 3: 次の承認者を選択して、承認操作を完了します。<br> 承認プロセス構成において、承認が却下された後に戻るステップを選択する必要がある場合は、「却下」の後にステップ4を実行します。<br> ステップ4：戻る承認ステップを選択して承認操作を完了します。<br> B.再割当て<br>　Step 1:Step ２: "再割当て "をクリックします<br> Step ２: 再割当て者を検索して探します<br> 　Step ３: 「再割当て承認申請」をクリックして、承認者の再割当てを完了します。<br>注：自分があるレコードの代理承認者の場合は、再割当てができません。<br> 複数のレコードを一括処理する。<br> C. 承認<br> Step 1: 承認するレコードを複数選択<br> Step 2: "承認 "をクリック<br> Step 3: "承認 "または "却下 "をクリックして、承認操作を完了します。<br> 承認プロセスの設定で、承認が却下された後の戻るステップを選択する必要がある場合は、"却下 "の後、Step 4に進みます。<br> Step 4: 戻る承認ステップを選択して承認操作を完了させます。<br> D. 再割当て<br> Step 1: 複数の承認レコードを選択します。<br> Step 2: "再割当て "をクリックします。<br> Step 3: 再割当て者を探します。<br> Step 4: 「再割当ての承認申請」をクリックして承認者の再指定を完了させます。<br> 2.提出済みのプロジェクト<br> 自分が提出した承認済みのプロジェクトを表示します。承認レコードの開始日、終了日、提出者、記録タイプ、関連項目、承認状況などから、参照するレコードを素早く検索することができます。<br> 3.私が承認したプロジェクト<br> 自分が承認したプロジェクトを表示します。承認レコードの開始日、終了日、提出者、レコードタイプ、関連項目、承認ステータスから、参照するレコードを素早く検索することができます。<br> 4.私が却下したプロジェクト <br> 自分が却下したプロジェクトを表示します。承認レコードの開始日、終了日、提出者、レコードタイプ、関連項目、承認状況から、参照するレコードを素早く検索することができます。`,
"label.knowledgebase.knowledge.article":`知識記事`,
"march":`三月`,
"label.accraditation":`承認`,
"vue_label_pool_cantreach":`取引先と連絡が取れない`,
"label.service.appointmentList.startOf.maturityPeriod":`締切期間開始`,
"message.huanxin.closed":`非アクティブなチャット機能`,
"label.implementation.time.operation":`スケジュール済みジョブの執行`,
"label.setting.intergrationlist.permissions":`イングレーションの権限`,
"label.translation.norecord":`レコードがありません`,
"label.lack.expression":`エクスプレッションの欠損`,
"setup.layout.message.relatedlistfield":`関連リストに表示する項目を選択します。選択した項目を再度並び替えてもいいです。`,
"label.group.file":`チームファイル`,
"message.error.id.null":`そのようなID情報はありません`,
"label.a_b_least":`レコード「A」に少なくとも1つの関連レコード「B」があります。`,
"label.addattachment.step3":`ステップ4.［完了］をクリックして、前のページに戻ります`,
"label.data.exportsf":`エクスポートに成功したファイル`,
"label.callcenter.call.out":`コールアウト`,
"front-electronic-export-exportIntro":`選択したデータは、選択したMailchimpリストにエクスポートされます`,
"label.custombutton.deletedata.notnull":`削除するデータは空であってはいけません`,
"UG.homepage.002":`一体化したビジネスツールで、クルー、リード、セールス・セールスファネル及び取引先情報を管理します。`,
"label.globaloperation":`グローバルアクション`,
"label.icon.58":`ワーカー`,
"vue_label_salesadvance_lostrate":`流失率`,
"chatter.from":`から`,
"front-epwechat-module-v1-account-binding":`バインドオンアカウント`,
"label.list.userinterface.old.page.setup":`旧版インターフェース`,
"label.forecast.settings.periods":`周期`,
"label.file.share.email.content":`#sharedBy#orgnameであなたとファイルを共有しています`,
"label.knowledge.category.hint.five":`データカテゴリーの設定`,
"setup.layout.label.selectedfield":`項目の選択`,
"label_business_income":`商談の収益`,
"vue_label_display_options_field":`オプションリスト項目の表示`,
"label.emailtocloudcc.set":`メールボックス情報の設定`,
"label.knowledge.setting.data.five":`カテゴリーの削除{lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`保障付き企業`,
"label.ccpeak.delete.recycle":`レコードはゴミ箱に削除されます。`,
"label.leadconvers.tip":`リードの価値が確認されない限り、リードは取引先、取引先責任者、商談及び後続のToDoに置き換えできません。`,
"label.rsa.key.invalid":`パブリックキーが無効なので、再度ログインしてください`,
"label.mobile.bind.success":`バインド成功`,
"label.emailtocloudcc.filed.servertype":`サーバータイプ`,
"label.user.new":`新規ユーザ`,
"label.setup.mobile.homepageshortcuts.remark":`各組織は業務シーンに応じて、組織レベルのホームページトップエリアのショートカット機能を設定することができます。`,
"label_emailtocloudcc_select2":`種別を選んでください`,
"page.send.email":`メールを送信`,
"label.service.newBuildDialog.field.display":`表示する項目`,
"vue_label_homepage_card_impending":`間もなく来る商談`,
"label.message.contactispartner.delete":`この取引先責任者はパートナークラウドユーザに関連付けされているため、削除できません。`,
"label.attendance.checkout":`サインアウト`,
"label.emailmerge.newtemplate.description":`差し込み印刷テンプレートの情報を入力してください。説明はWordに表示されなく、Cloudccのみに表示されることにご注意ください。`,
"laebe.data.exp.success":`エクスポートが成功したら、システムからの通知メールが送られます。エクスポートしたデータは48時間サーバー上で保存されますが、データエクスポートのリスクページでできるだけ早くエクスポートするデータをダウンしてください。`,
"lable.Maximum.number":`テンプレート名には最大50文字まで使用できます。`,
"label.projectManagement.drag.and.drop.existing.tasks":`既存ToDoをこのカテゴリーにドラッグします`,
"label.forecast.tree.desc":`予測階層により、組織でどのように予測値を積み上げ、また誰がこれを参照し調整することは決定されます。予測階層はロール階層により自動的に生成され、需要に応じてマネジャー、販売代理者またはユーザを追加?編集する可能性があります。また個別の予測ユーザに予測共有を有効化するこもできます。`,
"vue_label_chatter_upload_file_type":`アップロードファイルタイプの書込みを選択した`,
"front-lightning-module-v1-dashborad-analysis-dimension":`分析次元`,
"vue_label_homepage_custom_homepage":`カスタムホームページ`,
"label.icon.39":`ポジショニング`,
"label.appointmentpage.wizard.notif1":`先ず時間を選んでください`,
"vue_label_report_filterby":`{screenCondition} に基づいて絞り込みます`,
"label.argentina.time":`アルゼンチン時間`,
"label.role.assign.notremove":`選択済みのユーザリスクのユーザをすべての割り当てられていないしかも有効化になっているユーザとすべての割り当てられていないユーザまで削除することができません。`,
"label.sharerule.detailsetshare":`共有ルール`,
"label.file.publicview.error1":`ファイルは削除され、または公開リンクは無効になりました`,
"label.data.downpage.e_title.num4":`4、インポートするファイルフォーマットはCSV形式とパック形式が2種類あります。またパック形式は2種類に分けて、1つは自動的にパックファイルの暗証番号を生成し、もう1つは手動でパックファイルの暗証番号を入力します。`,
"label.knowledge.case.article":`事例紹介`,
"label.data.newtemplate.e.conditions":`エクスポート条件`,
"front-object-change-owner":`このアカウントのオーナーに対応する関連リストのレコードのオーナーも、新しいオーナーに変更されます。`,
"label.newdashboardpage.edittitle":`編集タイトル`,
"label.datamove.end.query.no.record":`検索が完了し、一致する条件のレコードはありません。`,
"lable.SalesCommitmentKanBan.receiptsTarget":`代金受取の目標`,
"label.orderagain":`再並び替え`,
"vue_report_dashboard_transfer":`フォルダの移行`,
"label.view.sortview.default":`デフォルトのビュー`,
"label.brasilia.time":`ブラジリア時間`,
"label.industrialandcommercialverification.instructions":`正しい取引先の企_登_情_を入力できるように、企_デ_タ__を有_化してください。但し、_在は中国本土に登_した企_のデ_タのみ__できます。`,
"label.chatter":`クラウドポスト`,
"label.sso.goBackToList":`リスクに戻る：秘密鍵の管理`,
"label.mobile.side.tab.state":`カスタマスライダーを有効化`,
"label.weixin.addbus":`車両の追加`,
"label.dropbox.description":`CloudCCであなたのDropBoxアカウントを使用するために、それを接続してください。`,
"label.service.newBuildDialog.available.tousers":`このフィルターをすべてのユーザーが利用できるように設定します`,
"label.knowledge.language.thai":`タイ語`,
"label.passwordPolicy.setup.foreverlock":`完全（管理者によりクリア）`,
"label.bmap.unreported.location":`地理情報を報告していません。Wechat公式アカウントで設定してください。`,
"label.tag.field":`表示ラベル`,
"label.addyourlanguage":`[追加] ボタンをクリックして、組織で使用する言語を追加することができます。`,
"label.chat.topic.my.use":`私が使ったトピックス`,
"UG.contact.06":`取引先のインポート`,
"label.embed_code":`埋め込みコード`,
"label.campaign.channel.input.chenben":`3.実費：`,
"label.quickbooks.estimates":`見積`,
"label.report.items.i.created":`私が作成したレポート`,
"label.forecast.edit.fwqd":`範囲の起点`,
"label.validate.function.funcExplain.DATEVALUE":`入力した日付/时间項目（年、月、日及びグリニッジ標準時を含む）に基づいて、1つの日付項目（年、月、日を含む）に戻る`,
"vue_label_helpcenter_calendar1.1":`行動は取引先との関係を常に把握し、取引を成立させるための強力なツールです。行動は商談、リード、取引先および連絡先に関連付けることができます。行動のレコードは主にカレンダービューに表示されます。<br> 1.カレンダービューとリストビュー<br>カレンダーの表示<br>ナビゲーションメニューのカレンダータブをクリックして、カレンダーページにアクセスします。<br>カレンダービュー<br>カレンダービューの分類：カレンダービューは月ビュー、週ビュー、日ビュー、稼働率ビューに分かれています。異なる時間範囲のレコードデータを、異なるグリッドスタイルでそれぞれに表示することができます。使用可能なビュー表示では、私のカレンダーや他のカレンダーなど、各カレンダーをディメンションとしての日々のレコードデータをが表示されます。カレンダーページの右上にある「カレンダーボタン」をクリックすると、表示が切り替わります。<br> カレンダービューで表示できるもの：カレンダーには、私のカレンダーと他のカレンダーが含まれます。カレンダービューでは、私の行動カレンダーやオブジェクトカレンダーのレコードデータを含み、私のカレンダーを参照することができます。これらのレコードを "カレンダーエントリ "と呼んでいます。<br> カレンダービューでは、自分が持っているすべての行動を参照することができます。オブジェクトで作成したカレンダーでは、カレンダービューの日付欄にカレンダーエントリとしてデータが表示されます。また、カレンダービューに他のカレンダーを表示することもできます。つまり、同僚が共有しているカレンダーエントリで、自分がビューに追加したものを表示することができます。<br>`,
"label.tabpage.rowsz":`行の削除`,
"label.file.library.managemembers.memberlist":`現在のメンバー`,
"label.report.action.addtodashboard4":`既存のダッシュボードを追加してください`,
"label.chat.send.voice":`ボイスメッセージを送信`,
"label.home.dashboard.add":`ホームページのダッシュボードを追加`,
"front-dialog-module-v1-copied-requestid":`リクエストIDがクローン化されている`,
"label.customfields.exportdata":`データのエクスポート`,
"label.emailobject.signature":`サインの編集`,
"label.hide.source":`ソースコードの非表示`,
"label.icon.71":`サービス`,
"vue_label_help_whatslightning":`Lightningとは`,
"report.type.label.systemReport":`システムレポート`,
"front-kefu-moudle-v1-input-email":`Eメールアドレスを入力してください。`,
"label.event.moveup.5minutes":`5分`,
"message.error.postsid.null":`ポストIDは空にできません。`,
"UG.Account.05":`取引先責任者のアーキテクチャ図`,
"label_emailtocloudcc_description3":`sales@company.com、info@company.com、support@company.comなどの企業のメールボックスをここに追加して、システムは自動的に受け取ったメールに基づき、リードあるいはケースレコードを生成し、タイムリーにお客さんのメールをフォローします。`,
"report.label.searchresult":`検索結果`,
"vue_label_report_detailsonly_desc":`詳細情報の行のみをエクスポートします。このデータは、追加の計算や他のシステムへのアップロードに使用します。`,
"label.partnerCloud.partnerAccount.payment":`支払い金額`,
"vue_label_commonobjects_view_select_member":`メンバーの選択`,
"label.emailtocloudcc.step1.lead1":`リードへのメール`,
"label.forecast.settings.current":`現在の周期`,
"label.canceluploadfile":`アップロードのキャンセル`,
"label.manual.shared":`手動共有`,
"label.document.uniquename.length.cannot.than":`ドキュメントの一意の名前は255文字を超えてはいけません`,
"vue_label_lead_notcreateopportunity":`機会を作らない`,
"APPIntegration.Social.twittererror":`有効なtwitter.comのURLが必要です`,
"message.duplication.label.errormessage":`エラー情報`,
"label.file.img":`画像`,
"label.tabpage.sum":`トータル`,
"label.permission.systempermission.fenpei":`システム権限の割り当て`,
"template.dashboard.folder.data":`データ分析`,
"label.sms.account":`ユーザ口座`,
"label.product.filter":`製品フィルタ`,
"label.file.content":`テキストの内容`,
"label.percent":`パーセント`,
"label.single.attachment":`個別`,
"label.processsetting.failed.enable.process":`プロセスの有効化に失敗しました。`,
"label.view.modify":`ビューの編集`,
"label.knowledgebase.enter.keywords.filter":`キーワードを入力してください。`,
"label.tabpage.uploadfailez":`アップロードに失敗し、再アップロードしてください。`,
"label.please.enter.the.target.model.name":`ターゲットモデル名を入力してください`,
"label.layout.availabletab.related":`関連`,
"label.label":`表示ラベル`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`土曜日`,
"label.addattachment.unit":`バイト`,
"vue_label_commonobjects_view_selected":`選択された{checkedLength}レコード。`,
"label.view.sortview.printble":`プリント可能`,
"label.umeng.insert.approval.approvaling":`#applyer submits #obj #objname for your approval`,
"label.forecast.customforecast.tztotal":`調整後の総金額`,
"label.ccchat.failtoset":`ccchat設定にエラーが発生しています`,
"label.ccchat.message.new.error2":`のChatユーザ`,
"label.validate.function.category.Advanced":`高度`,
"label.projectManagement.team.members":`チームメンバー`,
"vue_label_report_clickcrosstofliter":`詳細情報を表示するには、表の中のクロスをクリックします。`,
"lable.opppdt.selPdt.leasttwenty":`最大25件まで選択してください`,
"label.campaign.channel.download":`高解像度QRコードのダウンロード`,
"component_event_label_person":`任命先`,
"vue_label_homepage_new_homepage":`新規ホームページ`,
"label.version.sum.vlidaterule":`入力規則（件）`,
"vue_label_chat_click_for_details":`詳細はこちら`,
"label.fold":`折り畳む`,
"label.readonly":`参照のみ`,
"label.h5.similar.opportunity.result":`類似商談で表示する項目を選択`,
"label.yourimportsuc":`インポート申請は処理されており、メールをご覧下さい。`,
"label.report.line.yixuan":`選択済みのレポートリスト`,
"setup_layout_label_areaname":`エリア名`,
"label.forecast.edit.title":`目標`,
"label.chatter.allweather":`オールウェザー`,
"label.service.ganttBaiduMap.scheduled.endtime":`終了予定日`,
"lable.create.new.list":`新着情報`,
"label.emailobject.groupemail.msg3":`{0}名の受信者`,
"lable.opppdt.selPdt.description":`キーワードを検索条件を入力して、検索をクリックして検索します。[より多い検索条件]をクリックして、1つ以上の検索条件を使用します。検索結果は入力したキーワードと検索条件と一致するすべてのレコードを含みます。`,
"label.file.versionerror1":`以下のリンクをクリックして、直接に新しいインターフェースファイルのファイルタブに切り替えます。また、手動で新しいインターフェースに切り替えた後に、ファイルタブ機能を使用します。`,
"label.under.approve.record":`承認中のレコード`,
"front-epwechat-module-v1-open":`イネーブル`,
"label.projectManagement.delete.task":`このタスクを削除すると、このタスクの関連情報もすべて削除され、データを復元することはできません。削除を確定してよろしいですか？`,
"label.reportforms":`レポート`,
"label.tabpage.onlymevisible":`私専用`,
"label.customer.tab.please.name":`タブ名をご入力ください`,
"label_emailsync_form_stutas":`ステータス`,
"message.recordtype.nolist":`定義されていないレコードタイプ`,
"label.version.forecasting.sales":`販売予測`,
"chatter.sel.mostfield":`最大で選択可能な数`,
"label.data.derived":`データのエクスポート`,
"label.component.helper.businesschange.expiredtask":`商談は期限切れのToDoを含む`,
"label.cycle":`周期`,
"lable.product.standp":`標準価格`,
"label.sendemail.batchapproval":`一括承認のアクション`,
"message.organization.not.open.mffverification":`すべての組織は二時検証を有効化していません`,
"label.icon.131":`傘`,
"UG.activity.08":`スケジュールの予約`,
"label_partner_workspace_member_choicepermission":`権限セットの選択`,
"label.reportTypeCategory":`レポートタイプ`,
"label.exporttwotype":`2種類のテキストをエクスポートすることができます。`,
"message.oppdt.selectpricebook":`先ず価格表をご選択ください`,
"vue_label_dashboard_generatefromlistview":`リストビューからの生成`,
"label.quote.title":`タイトル`,
"label.tianyancha.businessverify.cancel.sure":`企業データ検証の有効化を取り消したら、ユーザの新規作成?編集の時、企業登録情報を記入することができないが、確かに行いますか。`,
"label.save":`保存`,
"label.mobile.quickcreate.default.appstore":`APP市場`,
"label.partnerCloud.orderingPlatform.configure":`{a}製品が設定されていないので、設定後に保存してください。`,
"front-epwechat-module-v1-unbound-role":`縛られない役割`,
"label.partnerCloud.financeSetting.enterAlipay":`Alipayの企業名を入力してください。`,
"label.validate.function.funcExplain.TODAY":`現在の日付を返します`,
"label.visualpage.parameter.values":`パラメータ値を直接的にページで表示します：`,
"label.version.task.and.activity":`ToDoと活動の追跡`,
"label.audit.history":`承認待ち`,
"setup.object.field.dependency.label.addtolist":`選択した値の追加`,
"vue_label_report_exportquantity":`エクスポートの数量`,
"label_tabpage_havez":`ある`,
"label.partnerCloud.partnerAccount.amountOfRebate":`利用可能なリベート額`,
"label.createralias":`作成者別称`,
"label.created_followup":`フォローアップメールの作成`,
"label_chatter_mygroups":`私のチーム`,
"label.chat.topic.no.display":`表示可能なトピックスがありません`,
"vue_label_calendar_month_view":`カレンダー月表示`,
"label.service.gantt.resources.assigned.work":`割り当てられた仕事のリソース`,
"UG_activity_07":`ToDoの作成`,
"label.quote.xsjg":`販売価格`,
"message.toomanyrows":`検索レコードは多すぎます。`,
"label.importsourcestep1":`ステップ 1. 翻訳済みのタブ区切りファイルの準備`,
"vue_label_normal_appointment_sf":`スケジュールの予約`,
"lable.list.queue.message":`キューに属するオブジェクトレコードが存在するため、このキューを削除することができません。`,
"label.service.major.event.desc":`重大行動は、サポートプロセスにおける時間に依存したステップを表示します。重大行動を権限プロセスに追加することができます。その後、プロセスを取引先の権限に適用して、ケースまたはワークオーダーを作成することができます。`,
"label.ems.hostorport.null":`サーバとポート番号は空であってはいけません`,
"chatter.group.private":`非公開`,
"label.icon.192":`石鹸`,
"vue_label_systemSettings_list":`関連リスト ディスプレイ設定`,
"label.activity.saveobj.notnull":`保存するオブジェクトは空であってはいけません`,
"vue_label_chatter_current_no_people_approval":`現在、承認が必要な人はいません。`,
"label.tianyancha.reglocation":`登録住所`,
"UG_ST_005":`わかりました。このページはもう表示されません。次回に直接的にログインします。`,
"label.vlidaterule.example.truetodisplay":`このメッセージは、エラー条件数式が True である場合に表示されます`,
"label.icon.99":`ノート`,
"label.whenselectmoreapprover":`多数の承認者を選択したとき`,
"label.forecast.customforecast.directorbest":`直接部下のベストケース`,
"label.customsetting.view.introduce":`カスタマ設定に項目を作成する。これらの項目データはアプリケーションよりキャッシュメモリに保存されます。`,
"label.there.are.no.unenabled.rules":`すべてのルールが有効になります。`,
"front-project-module-v1-plase-selectemplat":`プロジェクトのテンプレートを選択してください`,
"label.campaignmember.selectmember.from":`から`,
"setup_layout_button_quicksave":`クイック保存`,
"label.setup.service.report":`サービスレポートテンプレートの設定`,
"label.visualpage.direction.for.use":`プラットフォームカスタマページのマニュアル[パージョン2.0]`,
"message.modify":`確かに更新しますか`,
"label.sms.inside":`インテリア`,
"label.category.3":`教育`,
"label.login.mfadevice.verification.title":`MFAデバイスの認証`,
"UG_Forcast_08":`前のステップ`,
"label.projectManagement.unable.to.complete":`完了できない`,
"front-kefu-moudle-all-missphone":`すべての不在着信`,
"font-evaluate-module-v1-emergency":`警告`,
"label.sso.saml.sp.idsource.attr":`アイデンティティは属性の要素にあります`,
"chatter.not.meg":`NULLメッセージを送信することができません`,
"label.chatter.startDate":`開始日`,
"label.emailobject.track.times":`{0}回開きました`,
"label.customsetting.fieldhasbeendeleted":`削除済みの項目`,
"label.knowledge.setting.hint.thirteen":`その他のデータカテゴリーの追加`,
"message.duplication.label.newfiltertitle":`新規重複検索条件`,
"setup_object_field_dependency_label_selectedfieldvalue":`選択した項目値`,
"vue_label_calendar_who_currently_has_access":`今アクセス権限がある人`,
"message.passwordPolicy.validate.minlengthe":`文字`,
"label.emailsync.status.disconnect":`関連付けのキャンセル`,
"label.applt.down.one":`ワンタップ・ダウンロード`,
"label.manageAll.sel.one2":`私が提出するプロジェクト`,
"message.error.SQLTimeout":`システムが忙しいので、後ほどまた試してください。`,
"label.global.search.obj.setup":`グローバル検索オブジェクトの設定`,
"vue_label_commonobjects_view_chat":`チーム`,
"vue_label_systemSettings_startSet":`セットアップ開始`,
"label.quickbooks.viewlist.balance":`残高`,
"message.error.fieldid.null":`fieldidは空にしてはいけません。ファイルコンテンツID`,
"label.replaceallnullvalue":`すべてのNULL 値の置換`,
"label.georgia.time":`ジョージア時間`,
"label.hastransfer":`置換済みを含む`,
"label.partner.all.description":`説明`,
"font-evaluate-module-v1-following-peopple":`否定的なレビューを受け取ったら、次のユーザーに通知します。`,
"label_business_count":`商談の数`,
"vue_label_ccchat_closedetail":`元の書込みをたたむ`,
"label.partner.all.disable":`使用禁止`,
"label.view.relationship":`オブジェクトのリレーションシップ`,
"label.noless":`>`,
"label.sendsms.batch.step2":`ステップ2.メールテンプレートの選択あるいはSMS内容のカスタマイズ`,
"label.stdashbord.xsld.business.jieduan":`階段名`,
"label.appupload.component.type.trigger":`トリガ`,
"label.knowledge.setting.data.two":`カテゴリー名は必須です。`,
"label.color.display.of.completion.rate":`完成率のカラー表示`,
"label.loginhis.default":`デフォルトでは直近の200の履歴を表示します。`,
"vue_label_pricebook_book":`既存価格表`,
"label.knowledgebase.data.deletion.failed":`{a} データの削除に失敗しました。`,
"label_partner_workspace_member_permission":`選択可能な権限セット`,
"label.list.userinterface.approval.setup":`承認の設定`,
"label.weixin.binding.effect":`bindingは無効になり、改めてログインして獲得してください`,
"label.appupload.install.newapicannotnull":`新しいapi名は空であってはいけません。`,
"chatter.feed.menutype.feed.company":`すべての書き込み`,
"label.assignment.setup.detail.email":`メール`,
"label_tabpage_selectcontentz":`内容を選択してください`,
"template.report.converted.leads.campaign":`キャンペーンからのコンバージョンリード`,
"label.forecast.season":`今四半期`,
"label.post":`ポスト`,
"label.knowledge.setting.hint.fifteen":`基礎はできています。あとは、あなたとあなたのチームが、ナレッジの記事を書き、まとめるだけです。`,
"front-kefu-moudle-v1-Seats-name":`エージェントのニックネーム`,
"label.weixin.leadname":`リード名`,
"label.account.quarter":`クオーター`,
"label.detail.field":`項目を表示`,
"label.icon.189":`化粧品`,
"label.appointment.disable.reappointment":`無効化 リスケジュール`,
"label.appointmentconfirmpage.wizard.subtitle1":`行動の名前`,
"label.campaign.channel.step6.remark3":`システムは社員に一意の招待コードを生成します。社員はこのコードを使用して招待し、個人業績にも記入します。`,
"System.AddressFieldType.Post":`郵便番号`,
"label_partner_new_step2":`ステップ2.テンプレートの確認`,
"vue_label_helpcenter_file":`ファイルの表示と管理<br> 新規バージョンのファイルオブジェクトを使用して、自分が所有しているファイルや他の人が共有しているファイルを表示・管理することができます。一部形式のファイルをオンラインでプレビューすることができます。<br>ファイルライブラリ<br>ファイルライブラリ機能を使って、チームのナレッジベースを構築したり、管理者とメンバーを分けて管理したり、フォルダ機能を使ってファイルを分類したりすることができます。`,
"label.locateddowncurrentvalue":`現在の値の下にある値`,
"label.tianyancha.businessverify.msg5":`二、サービスの信頼性：`,
"label.setup.mobile.bottombutton.change.success":`変更に成功しました。`,
"label.appointmentconfirmail.wizard.subtitle2":`時間`,
"label.email.address.lookup":`メールアドレスの検索`,
"setup.mainpage.label.welcome":`CloudCC PaaSプラットフォームへようこそ！プラットフォームの主な機能は以下の通りです。`,
"label.icon.55":`ブルドーザー`,
"label_tabpage_enterrecordnamez":`レコード所有者を入力してください`,
"label.tabpage.andz":`アンド`,
"label.selectfiletoimport":`インポートするファイルの選択`,
"label.version.sum.trigger":`個のトリガー`,
"label.multi.layout":`行レイアウト`,
"pagecreator.button.back":`前のステップ`,
"label.imgfield.truetype":`正しい画像種別をアップロードしてください`,
"front-kefu-moudle-v1-publicKey":`共有キー`,
"label.data.exp.newtemp":`テンプレートの作成`,
"label.martrixreport.2018.step4.new":`ステップ4：レポートリストの選択`,
"label.sendemail.chat.addComentsatsubject":`CloudCC CCChat　コメントで私に関する内容を書き込みました`,
"vue_label_applauncher_description_leadpool":`リードプールを使用することで、組織内のフォローアップ状況を簡単に管理し、担当者の取引完了へのモチベーションを高めることができます。`,
"label.knowledgebase.archive.published.articles.without.drafts":`下書きのない公開済みの記事のみをアーカイブすることができます。`,
"label.projectManagement.bar.chart":`バーチャート`,
"label.ccpeak.condition.return.sort":`条件に基づき、返して並び替えます。`,
"label.salescloud.opportunity.contactrole":`商談での取引先責任者の役割`,
"label.language":`言語`,
"message.error.view.badprevilege":`すみません、当該サービスに権限が付与されていない。リスク管理者に連絡してください。`,
"label.textmessage.managetemplates":`テンプレートの管理`,
"message.error.type.null":`タイプは空にしてはいけません。`,
"setup.mainpage.label.welcome9":`ユーザーは、コードを開発することなく、マウスのドラッグ＆ドロップで、ページの全要素の分類表示やレイアウト調整、ページ上の項目の読み取り専用、必須項目の設定などを実現することができます。`,
"label.appupload.component.type.page":`カスタマデータ`,
"label.textmessage.bookschedule":`下のリンクをクリックすると、私のスケジュールを確認・予約できます。`,
"component_chatter_post_button_save":`発表`,
"lable.oppt.jieduan.signcomplete":`ステータスを完了とマークする`,
"label.help.notes":`ヘルプとガイド`,
"label_tabpage_reallproplez":`レコードの所有者`,
"label.obtain.authorization.failure":`認証コードの取得に失敗しました。再度認証してください。`,
"label.account.FiscalQuarter":`四半期決算`,
"label.customsetting.savecustomvalue":`この設定に対応するデータは存在済みで、修正して再保存してください。`,
"label.maximum":`最大値`,
"component_chatter_file_label_maxsize":`ファイルの最大サイズは20Mです。`,
"c218":`あなたの投稿は下書きとして保存されました`,
"c875":`会話のための新しいポスト`,
"c1623":`バリデート・プロバイダー`,
"c183":`タグで絞り込む
`,
"c366":`プールの設定`,
"c91":`メールインタラクションスコア`,
"c184":`ステージアップ`,
"c1957":``,
"c750":`イニシエーター`,
"c1016":`パラメータ名`,
"c619":`Twitterの投稿は280文字以内でなければなりません。短縮するために短縮形を使ってみてください。`,
"c1261":`トライアル製品シリーズ`,
"c1172":`セレクトボタン`,
"c1220":`選択されたカスタムコンポーネント`,
"c69":`支払い済み`,
"c675":`左寄せ`,
"c1280":`華東地区での担当ユーザー`,
"c1880":``,
"c533":`アップグレードケースの数`,
"c1662":`出欠席の記入`,
"c167":`注文の長さは必須です`,
"c682":`正方形`,
"c1572":`インポートしたい言語ごとに、ラベルと翻訳を含むファイルを作成します。`,
"c960":`スーパーエディション`,
"c1797":`10日`,
"c1966":``,
"c1126":`通貨の種類を編集します。新規通貨（リストから新規通貨を選択）`,
"c1033":`各設問に最低2つの選択肢を用意すること`,
"c850":`これは、現在のページが好きな数を示しているFacebookを除いて、あなたのソーシャルアカウントのそれぞれのフォロワーの現在の数を示しています。`,
"c343":`プロジェクトメンバーの追加`,
"c1007":`コピー 合計金額`,
"c8":`フォームの選択`,
"c1548":`あらかじめ決められた選択項目を追加する`,
"c157":`オープン受注モード`,
"c1039":`メールを見る`,
"c1656":`インボイス`,
"c1482":`クリア座標`,
"c1359":`ホバーリングレイアウト`,
"c1832":``,
"c397":`サービスクルー`,
"c556":`画像の掲載に失敗しました`,
"c563":`アクティブタイム`,
"c179":`パートナーロゴ`,
"c1856":``,
"c147":`オーダーテイクルール`,
"c1787":`パンチインリマインダー`,
"c303":`法的義務`,
"c1491":`物件紹介`,
"c885":`サイドバーを隠す`,
"c1849":``,
"c1012":`標準価格`,
"c1503":`ペインの高さ（ピクセル） （入力値の範囲：12560px）。`,
"c808":`画像の挿入`,
"c718":`セットアップを継続する`,
"c414":`お忙しい中、完成させていただきありがとうございました。`,
"c9":`従業員への勧誘`,
"c1066":`メインレーベルの言語`,
"c1683":`対象物`,
"c1974":``,
"c1844":``,
"c1448":`最大数量を空にすることはできません。`,
"c15":`請求書が発行されています。再選択してください。`,
"c1806":``,
"c1226":`トリガー動作`,
"c1179":`一次回答による承認または却下`,
"c1919":`テンプレート作成後、Wordファイルをアップロード。`,
"c59":`まず、Easemobの管理者シートでバインドしてから、アドバンスドセットアップに入ってください。`,
"c1529":`< span style='color:# エラー: フィールドのフォーマットが正しくありません < / span > 。`,
"c504":`プロジェクトの計画、作業の割り当て、リソースの管理、チームとのコラボレーションにより、プロジェクトの目標を達成し、プロジェクトの進捗を管理し、スケジュール通りに、予算内でプロジェクトを提供します。`,
"c836":`バインドファダダアカウント`,
"c187":`お礼のページ`,
"c208":`ダウンロードパッケージ`,
"c1851":``,
"c952":`ブラジル`,
"c104":`一度返信`,
"c1171":`使用可能なボタン`,
"c1834":``,
"c1847":``,
"c346":`タスクリソースの計算`,
"c1801":``,
"c1322":`カラムを表示する`,
"c1194":`2サイクル前`,
"c913":`サイドバーを展開する`,
"c571":`{selectnumber}のフォームが選択されました。`,
"c1749":`ログアウト］をクリックします。`,
"c1558":`詳細データ`,
"c44":`接続するネットワークを選択する`,
"label.social.posts.content.null":`投稿内容が空欄`,
"c1799":`有効期限なし
`,
"c852":`会社名（未記入）`,
"c561":`フィルタを適用する`,
"c1072":`置き換えられるケースチームの役割`,
"c1626":`ウェブページツール`,
"c1058":`履歴を隠す`,
"c1881":``,
"obtain.contract.envelopeid.fail":`エンベロープ情報または未結合メッセージ情報の取得に失敗しました。`,
"c465":`同じ通貨を使用する注文のみインボイスを生成することができます`,
"c982":`現在のプライスブックは無効化されています`,
"c350":`タスクソート`,
"c352":`人事カレンダー`,
"c670":`グラフィックアイコン`,
"front-electronic-signature-given":`デリバリー`,
"c542":`満足度評価`,
"c314":`インボイスファイルの作成`,
"c148":`メール通知設定`,
"c47":`接続ドメイン`,
"c1745":`権限の限界`,
"c1440":`プール名を入力してください。`,
"c754":`塗りつぶし`,
"c326":`アセットBOM`,
"c289":`プリファレンス`,
"c196":`制限事項のお知らせ`,
"c1306":`タスクシンクの方向性`,
"c63":`objName}を開く`,
"c769":`署名が完了したタスクは、取り消し後に消去されます。取り消しを続けますか？`,
"c216":`投稿が予約されました`,
"c842":`投稿通知メールの送信`,
"c389":`親会社のサービス地域`,
"c7":`プロモーションオーナー`,
"c981":`天津`,
"c143":`通知を受け取るユーザーを選択します。この設定は、フォームが使用されているすべてのランディングページで変更することができます。`,
"c930":`従業員位置決めスイッチ`,
"c1861":`新規レコードタイプ`,
"c1621":`ユーザーと制御`,
"c515":`作品概要の追加`,
"c393":`サービステリトリーメンバー`,
"c1162":`フィールドの削除`,
"c1235":`予測データセット`,
"c357":`レート`,
"c1660":`サービスリソースの不在`,
"c597":`ターゲットゲージ`,
"front-electronic-signature-cancelIntro1":`結合解除後は、DocuSignのEsignatureは利用できません。本当に解除していいの？`,
"c271":`注文の受付にタイムアウトが発生しました、番号：{0}です。作業の遅延にご注意いただき、速やかに対処してください。もっと見る>>をクリックしてください。`,
"c1292":`色の違いでステータスを表現しています。`,
"c1059":`インボイス項目`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Amapが正常に動作しません。秘密鍵が正しいかどうか確認してください。`,
"c424":`サービス・テリトリー・マネジメント`,
"c1729":`タイムフィールドの特性`,
"c995":`プールを選択してください`,
"c711":`あなたのソーシャルアカウントをつなげて、まったく新しいファンに出会える。`,
"c1658":`フィールドサービス・クラウドオブジェクト`,
"c1770":`時間軸`,
"c197":`投稿数が上限に達しました。ご参加ありがとうございました。`,
"front-electronic-signature-save-success":`マッピングの保存に成功`,
"c765":`ブロック化`,
"c1852":``,
"c1445":`その他の設定`,
"c1575":`CSV形式でファイルをアップロードしてください。`,
"c1383":`{n}サイクル(s)`,
"c1244":`最大長を超えた`,
"c286":`コンプライアンス違反`,
"c145":`1人1日1タスク/複数タスクの提出作業時間は24時間を超えてはならない。`,
"c264":`パーソナルフィールドの管理`,
"label.china":`中国`,
"label.no.bind.mobile":`携帯電話はありません。個人情報・バインドへ移動してください`,
"c95":`選択した製品を削除する`,
"front-electronic-signature-open-signInfo1":`DocuSignのEsignature&stampが有効になっています。オフにしてからFadadaのEsignature&stampを有効にしてください。`,
"c1342":`本検証は、中国本土で登録された工業・商業企業データにのみ対応していますので、ご注意ください。`,
"c1393":`ログイン履歴のダウンロード（過去6ヶ月間）`,
"c1501":`ペイン高さ`,
"c1077":`メンバー名`,
"c1661":`サービスリソース工数`,
"c1659":`サービス契約`,
"c1283":`マッピングフィールド`,
"c391":`コメントを見る`,
"c1499":`3回`,
"c1802":``,
"c106":`相互作用`,
"c1120":`フィールドを選択し、挿入をクリックしてください。ラベルの後に'>'が付いているものは、さらにフィールドがあることを示します。`,
"c1736":`プロバイダータイプ`,
"c519":`このタイムシートを削除すると、このタイムシートの関連情報もすべて削除され、データを復元することはできません。削除を確定してよろしいですか？`,
"c528":`ログタイムシート`,
"c1000":`了解！`,
"c78":`オーダーNo.`,
"c983":`リンクURL`,
"c41":`アンバインド成功`,
"c1495":`10文字`,
"c517":`有効な税率を入力してください`,
"c1624":`リンク管理を許可する`,
"c774":`サイン進捗状況`,
"c296":`フィールド名をご記入ください`,
"c996":`理由を選んでください`,
"c1112":`入力待ちの状態`,
"c757":`受け入れるために`,
"c1251":`以下は、220309subchecks の有効な承認プロセスと無効な承認プロセスの一覧です。
承認プロセスを作成するには、新規承認プロセスの作成をクリックし、ジャンプ スタート ウィザードの使用を選択すると、わずかな手順で承認プロセスを設定できます。または、「標準ガイドを使用する」を選択して、すべての承認オプションを設定することもできます。`,
"front-electronic-signature-confirmintro":`バインドに成功しました。これで、Contractsオブジェクトから署名を開始することができます。`,
"c1434":`モバイルページレイアウト：WeChatのミニウェブページとモバイル版表示のレイアウトに適用`,
"c1169":`反転`,
"c1006":`製品価格合計`,
"c1805":``,
"c1543":`CloudCCライセンス`,
"c1950":`著者名`,
"c1561":`メールテンプレート名`,
"c1737":`プロバイダー名`,
"c446":`タスクの状況`,
"c238":`{!ServiceResource.name}は注文を受理しました。アカウント"{!ServiceAppointment.accountid.name}", 件名:"{!ServiceAppointment.subject}"、番号："{!ServiceAppointment.name}"`,
"c980":`上海`,
"c802":`各ユーザーはサービスリソースとしてのみ追加可能です`,
"c1895":``,
"c1312":`チェック合格`,
"c387":`サービスリソーススキル`,
"c965":`EaseMob サービスが有効になっていない`,
"c1070":`ケースアクセス`,
"c480":`どのリストに送ろうか？`,
"c937":`電話番号の変更`,
"c1229":`オブジェクトID`,
"c1920":`Wordファイルを作成するためのチュートリアルを見る`,
"c632":`Facebookで見る`,
"c131":`請求書の口座欄が空欄になっているので、情報を追加してください。`,
"c1088":`ルールを適用するレコード`,
"c1632":`ポータルのカスタマイズ`,
"c680":`白色`,
"c806":`いつ`,
"c1873":``,
"c1971":``,
"c649":`受信箱の中身はすべて読んでいるはずです。`,
"c797":`最近の連絡先`,
"c616":`新しいウィンドウでリンクを開く`,
"c987":`予定時刻`,
"c169":`このグラフを表示する権限がありません。`,
"c1545":`CloudCCパートナーライセンス`,
"c1923":`関連するレコードフィールドを組み合わせる場合は、.docxファイルをアップロードしてください。`,
"c1316":`サービスアカウントのユーザー名（ドメイン名またはUPN）`,
"c1577":`イングリッシュ`,
"c1214":`新規カスタムオブジェクトメニュー`,
"c21":`商品番号が請求金額を下回ることはない`,
"c1512":`重複したコンポーネントを追加しないでください。`,
"c1432":`ロウレイアウト：フォアグラウンドのマスタースレーブ入力と一括加算に適用されたときに表示されるレイアウト`,
"c231":`梱包されている製品の数より少なくすることはできません。`,
"c1057":`もっと見る`,
"c1900":``,
"c1009":`プライスブックの有効化／無効化`,
"c1110":`全モジュール`,
"c555":`投稿画像の公開に失敗しました。`,
"c583":`中国 地図`,
"c1629":`セルフサービスポータル`,
"c1932":`データカテゴリーの作成`,
"c1633":`ポータルユーザー`,
"c1869":``,
"c1218":`クリエイトアクション`,
"c1488":`フッターツールの追加`,
"front-electronic-signature-open-signInfo2":`FadadaのEsignature&stampが有効になっています。オフにしてから、DocuSignのEsignature&stampを有効にしてください。`,
"c822":`新しい外部コンタクト`,
"c600":`数値チャート`,
"c1918":`Wordのテンプレートをアップロードします。`,
"c442":`オールラウンドなプロジェクトマネジメントシステム`,
"c1136":`アサインメントの追加`,
"c762":`署名する`,
"label.user.not.permission":`現在のユーザーには、操作する権限がありません。`,
"c35":`サブスクリプション名`,
"c1477":`ケースアップグレードのルール新規`,
"c1916":`現在のオブジェクト`,
"c921":`やくわり`,
"c1207":`以下のスクリプトをコピーし、サイトのHTMLソースコードの閉じタグの前に貼り付けてください。このスクリプトは、ウィンドウウィジェットを表示する各ページに挿入する必要があります。`,
"c305":`公益事業`,
"c1836":`プロバイダーの種類を選択してください。`,
"c730":`古いパスワードは再利用できません`,
"c1885":`コールセンターURL`,
"c1638":`プロジェクトクラウドの設定`,
"c1223":`無題 条件1`,
"c1155":`名前は一意でなければならない。`,
"c525":`ポータルユーザーを無効にする`,
"c942":`アメリカ`,
"c780":`署名活動`,
"c1202":`アクションを行います。続ける？`,
"c447":`最終チャンネルソース`,
"c1408":`実際の利用シーンに合わせて、組織のホームページを設定します。
企業の業務に関係のないコンポーネントは、デフォルトの設定から無効化したり、停止したりすることができます。
有効：有効なモジュールは、全メンバーのホームページに表示されます。
無効：無効化されたモジュールは、すべてのメンバーのホームページに表示されず、モバイルでのマイホームページ設定リストにもサポートされません。
オフ：デフォルトでは組織の全メンバーのホームページに表示されません。ユーザーは、モバイル側の「configuring my home page」でモジュールを開くことができます。`,
"c1200":`削除の取り消し`,
"c369":`見積もりファイル送信`,
"c702":`ドラフトを作る`,
"c22":`この支払明細の作成を続けると、請求書の支払金額が合計金額よりも大きくなってしまいます。金額を再調整して再度保存してください。`,
"c79":`ご注文日`,
"c785":`本名（任意）`,
"label.insert.approval.reassign.error":`挿入された承認ステータスの承認は再割り当てできない`,
"c1096":`このルールは、すべてのレコードに適用されます`,
"c998":`モジュール`,
"c273":`注文の受付がタイムアウトしました。派遣を中止する。`,
"c3":`チャート削除成功`,
"c448":`チャットセッション`,
"c495":`より速く、よりスマートに販売するために必要なすべて`,
"c429":`派遣KPI`,
"c1977":``,
"c1811":`デベロッパー`,
"c1147":`パーミッション名`,
"c1269":`オプション`,
"c16":`複数の請求書が存在しています。再選択してください。`,
"c1087":`次のような戦略で臨みましょう。`,
"c1644":`アカウントグループの設定`,
"c1084":`税額は数字であること`,
"c1708":`無効：無効なモジュールは、すべてのメンバーのホームページに表示されず、モバイルのマイホームページリストの設定にも対応しません。`,
"c128":`最大5列まで追加可能`,
"c955":`ラベル}の最小幅は{minWidth}pxです。`,
"c1427":`豪ドル`,
"c1556":`グループ名`,
"c716":`CloudCCからすぐに投稿を開始することができます。`,
"c1702":`写真のアップロードは？`,
"c1724":`フォーマットエラーです。yyyy/MM/dd HH: mm: ss または yyyyMMdd HH: mm: ss の形式、または関数を使用してください。Today()`,
"c638":`パブリッシングオプション`,
"c746":`破壊要求の取り消し`,
"c534":`終了した案件の数`,
"c1685":`プロジェクト計画`,
"c948":`イタリア`,
"c1710":`検証失敗`,
"c317":`発注書ファイルの送信`,
"c426":`サービス・リソース・マネジメント`,
"c1252":`このページを使用して、ユーザーデータを表示するためのさまざまなページレイアウトを作成します。ページレイアウトを作成した後、「ページレイアウト割り当て」ボタンをクリックすると、ユーザーがデフォルトで見るページレイアウトを制御することができます。`,
"c1831":``,
"c1219":`使用可能なカスタムコンポーネント`,
"c457":`契約総額ランキング`,
"c263":`パーソナル分野`,
"c372":`注文書の作成`,
"c1930":`記事翻訳  編集`,
"c907":`ライトニングバージョンでのみ使用可能`,
"c1795":`詳細ページ下部に表示されるボタン`,
"c771":`フィルムの進捗状況`,
"c408":`カスタマイズ可能なフィールドサービスアプリケーション`,
"c1522":`カスタムボタンとリンク`,
"c12":`成長率`,
"c1827":``,
"c379":`支払詳細`,
"c410":`仕事の種類`,
"c510":`パートナー注文`,
"c1928":`原稿を見る`,
"c701":`キャンペーンを割り当てる`,
"c617":`投稿を公開するために必要なテキスト`,
"c1630":`ブランド再構築`,
"c213":`EPS形式`,
"c1649":`スコアの設定`,
"c473":`システムは、従業員のためにユニークな招待コードを生成し、従業員は招待コードを使用して招待を行い、個人のパフォーマンスとしてカウントすることができます。リードの所有者は、現在のキャンペーンの所有者またはマーケティングチャネルの招待者になることに注意してください。`,
"c975":`草案の承認とスケジュール`,
"c1239":`シェア`,
"c1975":``,
"c1921":`表示フィールドの値`,
"c168":`チャートを選んでください`,
"c121":`未分類`,
"label.send.invoice":`インボイスの送信`,
"c792":`開始の確認`,
"c1309":`ワークフロー名を入力してください。`,
"c686":`サイズ`,
"c1373":`1 コラム`,
"c1295":`ワークフロールールは、フィルター条件に基づいて、特定のレコードに特定の自動アクションを実行することができます。
ワークフローの自動化は、Eメールの送信、フィールドの更新、レコードの作成などを行うことができます。`,
"c1108":`条件設定が完了しているかどうかご確認ください。`,
"c1603":`イメージフィールドの特性`,
"c1959":``,
"c652":`選択した期間内にアカウント間で公開された投稿の数が表示されます。CloudCC以外の接続アカウントに公開された投稿も含まれます。`,
"c136":`簡単な自己紹介をご記入ください。`,
"c1970":``,
"c662":`カスタムアイコン`,
"c1191":`最終承認ロックレコードを選択`,
"c1865":`ユーザー2`,
"label.invoice.customer.is.error":`請求書の作成は、同一顧客からの注文にのみ対応しています。`,
"c580":`バブルチャート`,
"c1101":`新しいウェブフック`,
"c894":`投稿にキャンペーンを設定すると、同じキャンペーン内で関連する投稿をすべて確認することができます。マーケティング活動にも活用されています。`,
"c1297":`新しいワークフロー`,
"c570":`デザイン`,
"c1597":`ピックリスト（複数選択）フィールドのプロパティ`,
"c1613":`マイアカウントのインポート`,
"c133":`超える`,
"c564":`ユーザーの皆様へ<br/> CloudCCシステムへようこそ。あなたは{!operatetime}でパスワードのリセットを要求しました。15分以内に以下の認証コードでログインしてください。<br/>ランダムな認証コードです。<b>{!authcode}</b><br/><br/><b>重要なことです。</b><br/>この操作を要求しなかった場合、またはこのメッセージがあなたに届くはずがないと思う場合、すぐに管理者に連絡してください!`,
"c854":`何も公開されていないようですね。`,
"c1947":`パッケージの種類`,
"c1248":`どのレイアウトをコピーしますか？`,
"c1243":`新規レイアウトの作成`,
"c1798":`15日`,
"c775":`生産終了`,
"c105":`複数回再生可能`,
"c1948":`カウントを有効にする`,
"c1078":`ケースチームメンバーの更新`,
"c729":`ソーシャルプラットフォームの設定をしているかどうかご確認ください。バックエンド設定  統合  有効化 (Twitter/Facebook/LinkedIn)`,
"c1275":`最大`,
"c1475":`割り当てルールは、レコードを自動的に対応するユーザーに送信するために使用します。
割り当てルールは、レコードに定義された条件と複数のルール項目で構成されます。`,
"c491":`非アクティブ化`,
"c609":`商標について`,
"c1469":`会計年度末日を空にすることはできません。`,
"c611":`リンク先`,
"c843":`投稿を見る`,
"c933":`変換ページ`,
"c383":`オポチュニティ製品`,
"c186":`ユニークIDはすでに存在しています。繰り返し追加しないでください。`,
"c1305":`対立行動`,
"c608":`交換`,
"c149":`Outlookからの通知をONにする（一部のメールサービスのみ対応）`,
"c1028":`サプライヤー`,
"c1350":`Vonageの設定`,
"c1606":`ファイルアップロードのプロパティ`,
"c1931":`記事の翻訳  出版`,
"c486":`メールアドレスに返信する。`,
"c1555":`正常に作成された`,
"c1186":`3サイクル`,
"c598":`ドーナツチャート`,
"c726":`リクエストの破棄に成功`,
"c645":`ドラフトを承認する`,
"label.verificationCode.is.invalid":`認証コードが無効になっていました。再度取得してください`,
"c1284":`アサイン成功!`,
"c1410":`5分`,
"c904":`間`,
"c1397":`リクエストに失敗しました`,
"c594":`2Dラインチャート`,
"c103":`複数回クリックする`,
"c188":`コメント`,
"c891":`レコードは、コンタクト、オポチュニティ、リード、アカウントでない場合があります。`,
"c1254":`2.ホバーページレイアウト：フォアグラウンドのホバーウィンドウに表示されるレイアウトに適用されます。`,
"c902":`サインインアドレスから訪問者までの距離`,
"c1539":`成熟度`,
"c484":`電子メール`,
"c421":`ワークオーダー作成方法`,
"c1889":``,
"c406":`販売管理の自動化`,
"c1426":`同じ言語を繰り返し追加することはできません。`,
"c1113":`式のチェックに失敗しました。構文を確認してください。`,
"c1654":`対象物`,
"c1100":`画像ファイルは20k以下であること`,
"c1246":`注意事項・添付ファイル`,
"c1228":`開発中の機能です。`,
"c739":`キャンペーン社員勧誘`,
"c1511":`ユーザーログイン後の自動ログインツール`,
"c1181":`一意名は文字列でなければならない。`,
"c329":`資産入替`,
"c1857":``,
"c1011":`製品タイプ`,
"c351":`再発頻度`,
"c622":`ネットワーク統計の最終更新日時`,
"c1367":`タイトルは詳細ページにのみ表示されます。`,
"2":`フィルタリングオプションの設定完了`,
"c463":`私の活躍の場`,
"c268":`情報の統合に成功`,
"label.mobile.no.letter.blankcharacter":`電話番号には、文字や空白文字を含めることはできません。`,
"c1531":`以下`,
"c1637":`サービス クラウド モバイル`,
"c1855":``,
"c1125":`高度な通貨管理を有効にすると、通貨の為替レートを特定の日付範囲内の期限切れレートにマップすることができます。
期限切れ為替レートは、ビジネス・オポチュニティ、オポチュニティ製品、およびこれら 2 つのオブジェクトに関連するレポートに使用されます。
期限切れ為替レートは、他のオブジェクトのフィールドや他の種類のレポートには使用できません。
例えば、1月1日の為替レートは1米ドル＝6.68元ですが、2月6日に1米ドル＝6.70元に変更されます。
1月1日から2月6日の間に終了日を迎える機会は、最初の為替レート（1＝6.68）を使用し、2月6日以降に終了日を迎える機会は、2番目の為替レート（1＝6.70）を使用します。`,
"c438":`転送`,
"c581":`MoM&YoY表`,
"c953":`南朝鮮`,
"c90":`課題`,
"c2":`ダッシュボードの削除に成功しました。`,
"c1618":`テンプレート印刷の設定`,
"c1680":`製品リクエスト列のカタログ`,
"c1964":``,
"c1201":`を丸ごと削除します。`,
"c1691":`リベート口座`,
"c897":``,
"c444":`ファーストチャンネルソース`,
"c1286":`キャンセルされ、完了できない。`,
"c1544":`CCChatフリーライセンス`,
"c242":`{!ServiceResource.name}は注文を拒否しました。アカウント"{!ServiceAppointment.accountid.name}"、Number: "{!ServiceAppointment.name}"`,
"c135":`ブランクテンプレート`,
"c659":`フォローミー`,
"c773":`ファイナライズ`,
"c11":`フォームによるマーケティング`,
"c1209":`イネーブルにする`,
"c1580":`コリアン`,
"c799":`外部連絡先`,
"c1260":`説明を入力してください。`,
"c1014":`プライスブックは現在の組織では使用できません。有効にするには、管理者に連絡してください。`,
"c1075":`会員数`,
"c1830":``,
"c880":`ソーシャルポストを編集する`,
"c890":`招待メール送信成功`,
"c1614":`連絡先のインポート`,
"c846":`対象となるサービス予定を選択してください`,
"front-electronic-signature-sucessSign":`署名を開始してください。`,
"c472":`ポスターを貼るフォームを選択する`,
"c1384":`年度 四半期{n}の推移`,
"c963":`名前欄は必須項目です`,
"c1076":`メンバーの役割`,
"c390":`チャイルド・サービス・テリトリー`,
"c248":`転送する注文の受理が保留されている`,
"c1505":`60日`,
"c1675":`アセットスキャン記録`,
"c1875":``,
"c646":`受信トレイストリーム`,
"c1665":`企画戦略目標`,
"c1425":`為替レートは、特定の日付範囲内で期限切れレートにマップすることができます。
期限切れ為替レートは、機会、機会製品、およびこれら2つのオブジェクトに関連するレポートに使用されます。`,
"c308":`少なくとも1つのデータを選択する`,
"c858":`本当に{a}の投稿を下書きとして保存するのですか？これらの投稿は、再度スケジュールを設定しない限り公開されません。`,
"c152":`現在選択されている時間帯の完了したサービス予約の数 / 現在選択されている時間帯の全サービス予約の数`,
"c1754":`同時にスナックを始める？`,
"c1666":`企画戦略`,
"c1925":`原稿を見る`,
"c1403":`フォルダー新規`,
"c1118":`既存のオペレーションを1つ以上選択してください`,
"c1571":`ステップ1：翻訳ファイルの準備（インポートする前に、以下の条件を満たしていることを確認してください。）`,
"c316":`案件の進捗を見る`,
"c1828":``,
"c1808":``,
"c1381":`アドバンストフィルターの追加`,
"c1270":`すべて閉じる`,
"c1602":`テキストエリア(長)フィールドのプロパティ`,
"c1492":`ツールプロパティ`,
"c1444":`左からユーザーを選択し、「選択されたユーザー」リストに追加します。`,
"c1904":`ホストを設定する準備ができました`,
"c435":`ビューバージョン`,
"c1053":`使用するテンプレートを選択してください。`,
"c1409":`この機能を有効にすると、組織のメンバーは、モバイル側でネットワークを介さない状態で、レコードの作成、表示、編集、削除を行うことができます。
選択したメニューは、組織全体のモバイル側でのデフォルトオフラインキャッシュメニューとして有効になります。各ユーザーは、さまざまなシーンに応じてモバイル側で組織設定のオフラインキャッシュメニューを設定したり、他の必要なメニューを有効に切り替えることができます。`,
"c1304":`イベント競合の挙動。交換が常に優先される`,
"c1190":`6サイクル`,
"c1109":`結果が見つかりません`,
"c362":`付属の製品制約事項`,
"c1299":`コンタクトの衝突行動CloudCC.comが常に優先されます`,
"c800":`氏名または会社名を入力してください`,
"c415":`開始予定`,
"c1395":`オプションリスト値の置き換え`,
"c1790":`アソシエイト・ユーザー`,
"c1149":`デフォルトで隠す`,
"c1523":`有効なEメールアドレスを入力してください。`,
"c1276":`税金を払っていない製品`,
"c735":`名前を繰り返すことはできません`,
"c903":`アプリケーションアイコンを選択`,
"c1222":`編集条件`,
"c1023":`申し訳ございません。このURLは、ウェブサイトのセキュリティに損害を与える可能性があるため、アクセスをブロックしています。`,
"c1082":`特殊文字不可`,
"c1655":`ご注文`,
"c1417":`デフォルトフォーマットエラー`,
"label.insert.approval.massreassign.error":`既存の挿入承認のバッチ承認は、再割り当てできません。システムが自動でフィルタリングしてくれます`,
"c1516":`リージョンと従属リージョン`,
"c1898":``,
"c354":`タイムシートの編集`,
"c409":`ワンストップ・カスタマーサービス・プラットフォーム`,
"c1945":``,
"c651":`Facebookを除く、各ソーシャルアカウントの現在のフォロワー数が表示されます。`,
"c1667":`サービス目標`,
"c1121":`レコードを作成する場合`,
"c582":`世界地図`,
"c1360":`開始時刻は終了時刻より後にすることはできません。`,
"c994":`カスタムライトニングコンポーネント`,
"c1826":``,
"c1374":`2カラム`,
"c1199":`更新されるフィールド`,
"c826":`変更内容を本当に破棄してよいのですか？`,
"c1361":`終了時刻は開始時刻より後にすることはできません。`,
"c781":`企業です。営業許可証に記載されている会社名を入力してください。サイン時にチェックが入ります。`,
"c1139":`編集権限セット`,
"c1845":``,
"c873":`詳細はこちら`,
"c1612":`リードのインポート`,
"c837":`バインドを解除すると、Fadada電子署名機能が利用できなくなり、設定されていたオートフィル、バックフィルのフィールド機能が削除されます。本当にバインドを解除してよいのでしょうか？`,
"label.diedirect.sale":`直接的な価格引き下げ`,
"c798":`社内連絡先`,
"c368":`見積もりファイルの作成`,
"c770":`開始済み`,
"c1551":`その他のメール`,
"c882":`利用規約`,
"front-setting-dialog-title-two":`今回入力していない場合は、個人情報ページから設定します。番号を入力するとバインドされる`,
"c1449":`情報不正確`,
"c535":`未解決`,
"front-electronic-signature-look-account":`アカウントを見る`,
"c1972":``,
"c19":`レコード詳細表示モード`,
"c1890":`ユーザーを追加する`,
"c52":`税名`,
"c388":`アソシエイトとユースエンタイトル`,
"c1451":`SGD`,
"c1648":`オポチュニティ・コンタクト`,
"c1156":`intervaltype typeがminuteの場合、30分以上59分以下でなければならない。`,
"c1390":`別のフィールドでユーザーが選択した値に基づいて、オプションリストまたは複数選択リストの値を動的にフィルタリングすることになる依存関係を作成する。`,
"c18":`複数の非アクティブな注文が存在するため、再選択してください`,
"c820":`電話番号/メールボックスを入力してください`,
"c285":`概要`,
"c1245":`シャトルボックス`,
"c1552":`現在のユーザーの電子メール`,
"c478":`Mailchimpを認証する`,
"c1608":`暗号化テキスト(ストレージ暗号化)フィールドのプロパティ`,
"c1206":`インベディング`,
"c164":`0〜60の整数値を入力してください。`,
"label.tip.excess.quota":`このリソース使用量を超えました`,
"c318":`発注書ファイルの作成`,
"c698":`ソーシャルネットワーク`,
"c1116":`説明文の追加`,
"c1092":`条件を満たした場合`,
"c1915":`結合するフィールドを選択してWordにコピー（条件による関連リストレコードの表示にも対応）`,
"c312":`複数の注文はまだ有効ではありません、もう一度選択してください`,
"c110":`プロジェクトごとにグループ化`,
"c549":`日付の範囲は31日を超えることはできません`,
"c1128":`現在の通貨`,
"c1896":``,
"c845":`サービスの予定を1つ以上選択してください`,
"c1329":`ピックリスト(複数)`,
"c282":`お客様の個人情報をCRMで管理`,
"c1587":`ルックアップリレーションフィールドのプロパティ`,
"c1969":``,
"c270":`注文受付タイムアウト`,
"c288":`データ処理基盤の変更`,
"c1231":`Read/Writeユーザーが予測データの閲覧や上書きができます。`,
"c878":`現住所`,
"c1287":`デフォルトの状態`,
"c1698":`レコメンデーション機能のモバイルモジュール設定`,
"c1651":`出欠席の設定`,
"c1161":`名刺ビューからこのフィールドを削除してよろしいですか？`,
"c324":`ケースにキューを追加する`,
"c1099":`画像は.jpgまたは.pngでお選びください。`,
"c1145":`すべてのユーザーから見える`,
"c1462":`選択されたユーザーからすべての未割り当てユーザーと有効なユーザー、およびすべての未割り当てユーザーにユーザーを削除することは許可されていません。`,
"c1840":``,
"c1616":`アカウント/連絡先のインポート`,
"c129":`この操作により、ファイルは永久に削除されます。続行しますか？`,
"c1510":`オートスタート`,
"c339":`GDPRデータ破棄`,
"c1106":`運用は、サードパーティアプリとの通信や、特定のイベント/アクティビティが発生したときにサードパーティアプリにWeb通知を即座に送信するためのものです。`,
"c1303":`イベント競合の挙動。CloudCC.comが常に優先されます`,
"c405":`クルーサイズ`,
"c848":`Linkedinアカウント`,
"c1524":`操作欄`,
"c345":`プロジェクトテンプレート`,
"c591":`オーストラリア 地図`,
"c180":`ログインページの言語`,
"c126":`配信`,
"c1824":``,
"c1404":`フォルダー編集`,
"c311":`効果なし、もう一度選択してください`,
"c587":`メキシコの地図`,
"c37":`これは、お客様がコミュニケーションのプリファレンスページに表示されるテキストです。`,
"c1914":`結合するフィールドの値を選択する`,
"c840":`イエーイ!失敗した投稿はありません。`,
"c1866":``,
"c1355":`このレイアウトパーミッションを割り当てるロールを選択します。`,
"c1183":`1サイクル`,
"c1371":`で一部名称を表示しています。`,
"c1519":`テキストエリア（リッチテキスト）フィールドのプロパティ`,
"c241":`{!ServiceResource.name}は注文を拒否しました。アカウント"{!ServiceAppointment.accountid.name}"、件名。"{!ServiceAppointment.subject}"、番号："{!ServiceAppointment.name}"`,
"c1215":`カスタムアプリケーションアイコンの画像ソースを選択します。`,
"c141":`お礼のメッセージは必須です`,
"c1466":`新規作成」をクリックして、新しいカスタム年を定義します。`,
"c1205":`一括転送の承認が正常に要求されました。`,
"c1430":`開始時刻と終了時刻の範囲は、2ヶ月を超えることはできません。`,
"c1689":`パートナーアカウント`,
"c1540":`当社に対する姿勢`,
"c1271":`すべて開く`,
"c1337":`チャンネルグループ番号(MD5)`,
"obtain.contract.fail":`契約情報の取得に失敗`,
"c1541":`訪問回数スコア`,
"c1129":`シーエヌワイ`,
"c1786":`パンチアウトしてください。(すでにパンチアウトされている場合は無視します)`,
"c945":`ロシア`,
"c1321":`フォームの検証に失敗しました`,
"c454":`契約金額 月額`,
"c34":`ショッピングカートの中の商品は100個です。新しい商品を追加する前に、少なくとも1つの商品をクリアしてください。`,
"c1550":`演算値を空にすることはできません`,
"c243":`{!ServiceResource.name}は注文を拒否しました。件名"{!ServiceAppointment.subject}"、番号："{!ServiceAppointment.name}"`,
"c548":`タイムシートからタスク/課題、サブタスク、プロジェクトの編集ができない`,
"c1640":`リードプールの設定`,
"c807":`今すぐ投稿する`,
"c590":`ドイツ 地図`,
"c831":`サーティフィケーション`,
"c198":`フォームは安全に公開され、以下のURLでフォームを公開リンクとして共有することができます。`,
"c1437":`開始時刻と終了時刻を選択してください。`,
"c977":`これは{0}であなたの投稿が表示される方法です。1}でレイアウトを調整した場合、若干の違いが生じる可能性があります。`,
"c1927":`記事の管理`,
"c66":`製品の物流情報をDeliveredに更新しました。`,
"c1327":`この操作を行うと、このデータは削除されます。続ける？`,
"c1599":`マスター・ディテール関係フィールドのプロパティ`,
"c1829":`レジストレーションプロセッサー`,
"c1756":`全文検索を有効にする`,
"label.twitter.title.setting":`ツイッター統合情報`,
"c922":`Teamを有効にするには、管理者にご連絡ください。`,
"c1926":`過去の記事を見る`,
"c1538":`役割1`,
"c1705":`値がフィルタリングされるフィールドを従属フィールドと呼びます。
カスタムオプションリストや複数選択リストは、従属フィールドにすることができます。`,
"front-email-payment-Invoice-Tips":`管理者に連絡して、PayPalまたはVISAを有効にしてから、オンライン決済を開始してください。`,
"c605":`	
デフォルトの請求先住所`,
"c1704":`レコードタイプの一意名`,
"c1871":``,
"c403":`プロジェクト`,
"c1891":`一括削除`,
"c1793":`sha512で暗号化？`,
"c156":`モバイル側での受注ルール`,
"c1485":`フッターツール`,
"c635":`別の投稿を予定する`,
"c1810":`無料`,
"c1249":`レイアウト名`,
"c1628":`ブランドストーリー・情報`,
"c1755":`起動すると、配車サービスから予約されたユーザーがCloudCCサービスアプリで注文をつかむことができるようになります。`,
"c1153":`キュー内のすべてのオブジェクトの共有モードがPublic Read/Write/Transferの場合、すべてのユーザーがすでにこれらのオブジェクトのレコードにアクセスできるため、キューにユーザーを割り当てる必要はありません。`,
"c753":`参加者`,
"c1822":``,
"c1196":`特定のイベントやアクティビティが発生したことをメールでお知らせします。`,
"c1433":`ホバーページレイアウト：フォアグラウンドのホバーウィンドウに表示されるレイアウトに適用されます。`,
"c1042":`4.ファイルの保存方法`,
"c1641":`グループ設定`,
"c1036":`自社からAPIを利用する場合、ログインするためにセキュリティトークンが必要です。セキュリティトークンとは何ですか？大文字・小文字を区別する英数字で、パスワードと関連付けられています。`,
"c1777":`まずコールセンターにログインしてください`,
"c1676":`経費報告`,
"c647":`すべての活動`,
"c295":`オフにすると、記録のための操作履歴を除き、すべての個人フィールドマーキング、データ処理基準およびDGPRを遵守するためのその他の情報は削除されます。本当にオフにしてよろしいですか？`,
"c915":`プールをオープン
`,
"front-electronic-signature-signStatus":`オンラインサインを開始しました。契約状況は{signStauts}です。`,
"c568":`レイアウトの調整`,
"c1051":`この機能では、選択したマージテンプレートを元に、マージフィールドがCloudCCフィールドを参照するドキュメントを生成することができます。関連するリストフィールドをマージするには、docx形式のマージテンプレートをアップロードしてください。`,
"c1256":`その他の電話番号`,
"c744":`0〜100の間で有効な数値を入力してください`,
"c1285":`計画期間`,
"c1480":`座標を設定する`,
"c1278":`システムで定義されたレイアウト`,
"c1358":`PCページレイアウト`,
"c464":`ポストが削除される`,
"c385":`作品概要`,
"c1973":``,
"c1839":``,
"c1419":`ステップ 2: 次のページで、コントロールフィールドの各値に対して従属フィールドに表示される値 を制御するフィルタルールを編集します。`,
"c392":`必要なソリューションを選択する`,
"c1858":``,
"c418":`担当するサービス・リソース`,
"c256":`アカウントを変更すると、選択した商品の注文がクリアされます。本当に変更しますか？`,
"c1751":`有効化すると、配車サービスで予約したユーザーがCloudCC Service APPで注文の受付・拒否ができるようになります。`,
"c1188":`4サイクル`,
"c690":`画像読み込み`,
"c261":`データの破棄`,
"c1407":`< span style="color: red" > ヒント：カスタマイズされたプロフィールのボトムメニューは、会社のボトムメニューの統一された設定に重なります</span>。`,
"c62":`従業員への勧誘`,
"c1365":`シングルカラム`,
"c892":`現在のレコードが見つかりませんでした`,
"c909":`この通貨の価格定義が追加されました。再追加しないでください`,
"c883":`&`,
"c1617":`関連リストのスタイル`,
"c1739":`認証コードを取得する`,
"c1154":`名前は文字で始まり、大文字と小文字、数字、アンダースコアのみを使用でき、長さは40以上である必要があります。`,
"c1672":`アセット・リレーションズ`,
"c134":`プールメンバーの上限`,
"c1671":`旅行申込書`,
"c896":`レコードがロックされているため、ファイルの追加に対応していません。管理者に連絡し、ロックを解除してください。`,
"c974":`新しい投稿を公開し、新しいコンバージョンを開始します。`,
"c209":`中型`,
"c185":`このページの統計情報`,
"c796":`契約締結を開始する前に、Fadadaプラットフォームで契約書テンプレートを設定するため、管理者にご連絡ください。`,
"c60":`プロジェクト数`,
"c991":`データ共有ルール`,
"c1573":`各ファイルの先頭には言語属性が必要です（中国語のインポートには対応していません）。
言語属性は次のようなものです。Language=ja_US.`,
"c866":`アプリケーションのセットアップ`,
"c666":`ディスプレイ`,
"c219":`あなたの投稿は削除されました`,
"c732":`ポスター`,
"c1048":`少なくとも1つのテンプレートを有効にしてください`,
"c1854":``,
"c1345":`企業の必須情報（連絡先を含む）を取得する。`,
"c1595":`設定必須または読み取り専用`,
"c155":`{名前} 名前`,
"c1328":`このインテグレーションを今すぐインストールしますか？`,
"c511":`Eコントラクト`,
"c1598":`数値フィールドのプロパティ`,
"c240":`不採用`,
"c1454":`写真を選ぶ`,
"c1024":`為替レート`,
"c1730":`デフォルトのURLフォーマットが正しくありません`,
"c468":`ソートタイプは空`,
"c961":`Q{quarter} {year}の場合`,
"c1455":`アクティビティ名を入力してください`,
"c1420":`設定されている内容（「Control Fields」の値をクリックして編集してください。）`,
"c404":`マーケティング、リードジェネレーションのためのツール`,
"c1234":`すべての未割り当てユーザーとアクティブ化されたユーザー`,
"c586":`シンガポール 地図`,
"c1062":`カスタムレーベル`,
"c694":`幅/高さ`,
"c1025":`上記の為替レートで製品価格を再計算する`,
"c1536":`各項目の最高得点は20点（繰り返し可能）です。`,
"c1897":``,
"c1909":`2.結合されるフィールドの値を入力します。現在のフィールドと関連するフィールドの値を表示し、結合するフィールドの値を選択して、ローカルのWordテンプレートにコピーします。`,
"c297":`個人情報の種類を入力してください`,
"c860":`住所変更`,
"c1740":`トークンを取得する`,
"c58":`プロジェクトホームページ`,
"c1791":`出席グループとは無関係で、パンチインは不要です。`,
"c1650":`アップグレードルール`,
"c920":`オートリサイクルルールを設定すれば、制限時間を過ぎてもリードがコンバージョンしなかった場合、システムが自動的にレコードをプールにリサイクルします。それにより、リードのフォローアップの効率が向上します。`,
"c27":`総量を調整するための浮動小数点数を入力してください（例：＋10または10）。`,
"c94":`3回アップ`,
"c1":`モバイルのみ`,
"c557":`受入事例`,
"c1127":`Number of decimal（新しい通貨でデータを表示する際に表示できる小数点以下の桁数（小数点の右側の桁数）を入力し、0～6の整数を入力します）。`,
"c294":`GDPR準拠の設定をオフにする`,
"c1842":`登録処理者を入力してください`,
"c970":`最低でも1冊のプライスブックを選択する必要があります。`,
"c1727":`テキストフィールドのプロパティ`,
"c1324":`DingTalk  H5ミニプログラム`,
"c565":`このタスクは、次の人に割り当ててください。`,
"c668":`アライメント`,
"c972":`マーケティングプロモーション名`,
"c660":`著作権について`,
"c433":`リードプールフィールドトラッキング`,
"c443":`アーカイブ 全て`,
"c1372":`列の一部が表示される`,
"c1105":`全レイアウト`,
"c275":`{0}は注文受付のタイムアウトが発生し、派遣がキャンセルされました。番号：{1}です。クリックして詳細を見る >`,
"c691":`リンク(オプション)`,
"c956":`Mailchimpのアカウントがまだ有効化されていません。設定」→「統合」→「統合リスト」でMailchimpのアカウントを有効化するか、管理者までご連絡ください。`,
"c1750":`受信開始`,
"c910":`新規作業指示書`,
"c692":`デフォルトブラウザ`,
"c1067":`メインラベルのテキスト`,
"c355":`タイムシートの一括追加`,
"c1289":`リコメンデーションポリシールールの表示`,
"c122":`製品画像`,
"c395":`テリトリータイプ`,
"c689":`最大高さ`,
"c344":`ガントチャートでプロジェクトを見る`,
"c1150":`キュー名と、通知（ケースがキューに入れられたときなど）を送信するときに使用する電子メールを入力します。電子メールは未入力でも通知されません。`,
"c1663":`サービス地域 職種`,
"c1483":`フォームに記入後、送信してください。`,
"c656":`リフレッシュタイム`,
"c943":`日本`,
"c1450":`全体像`,
"c1813":`スクリーンショット`,
"c1490":`永久保存版（ロック解除には管理者が必要です）`,
"c1104":`コネクタ`,
"front-electronic-signature-outerSinger":`外部署名者`,
"front-generate-v1-invoiceDetail":`請求書の詳細`,
"front-electronic-signature-open-vertify":`認証コードを入力してください。`,
"c1775":`ケースオーナー`,
"c291":`個人情報の種類`,
"c1471":`中国時間帯`,
"front-setting-phone-message":`電話番号を入力してください。`,
"c559":`エスカレートしたケース`,
"c1453":`会員にメールを送る？`,
"c990":`メールの同期`,
"c1102":`オーソライズタイプ`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Googleマップが正常に動作しません。シークレットキーが正しいか確認してください。`,
"c259":`データ処理の基本`,
"c1924":`ナレッジの閲覧を許可する`,
"c1722":`日付フィールドのプロパティ`,
"c1065":`メインレーベル`,
"c1346":`時間依存型トリガー`,
"c1838":``,
"c488":`招待時間`,
"c6":`プロモーション名`,
"front-electronic-signature-signerInfo":`シグネチャー情報の設定`,
"c1168":`ナビゲーションスタイル`,
"c512":`プロジェクトメンバー`,
"c507":`リード育成`,
"c1385":`最終更新日`,
"c760":`不採用`,
"c756":`送信禁止`,
"c321":`必要・不要`,
"c817":`カスタムページメニューの権限設定を表示する`,
"c949":`スペイン`,
"c1133":`ライセンスを選択してください`,
"label.biaoqing.field.relation.tip":`Bid&tenderの発見分野`,
"c382":`リレーションネットスコアリング`,
"c265":`この命令はまだ有効でないため、変更することはできません。`,
"c417":`サービス・リソース・ワーク情報`,
"c847":`Facebookアカウント`,
"c1521":`標準ボタンとリンク`,
"c494":`CloudCC Marketing Cloudで、すべてのチャネルの統一管理を実現します。顧客とのつながりと長期的な信頼を築き、アナリティクスでROIを促進し、リーチを収益につなげます。`,
"c86":`キャンペーンを実施します。社員紹介を編集する`,
"c1098":`画像の切り出し`,
"c1080":`ケースチーム`,
"c1138":`削除するユーザーを選択してください。`,
"c776":`アンドゥに成功`,
"c709":`接続するネットワークを選択する`,
"label.mobile.orVerificationCode.is.error":`電話番号や認証コードのエラー`,
"c579":`レーダーチャート`,
"c1037":`トークンをリセットすると、APIアプリケーションやデスクトップアプリケーションで古いトークンを使用することができなくなります。`,
"c413":`サービスアポイントメントステータス`,
"c950":`オランダ`,
"c1493":`8文字`,
"c1785":`パンチアウトリマインダー`,
"c1735":`カスタマーサービスケースチャート`,
"c1841":``,
"c1178":`ホバリングページのレイアウトに表示する関連リストを選択します（最大3つの関連リストを選択します。）`,
"c1236":`ユーザーを選ぶ`,
"c573":`2Dバーチャート`,
"label.choose.is.tax":`税金タイプの選択`,
"c768":`開始された契約書署名タスクは完了していません。契約締結後、ドキュメントをダウンロードしてください。`,
"c604":`請求先住所がすでに存在するため、新しい請求先住所として現在を保存する`,
"c160":`期限切れ治療`,
"c1158":`intervaltypeのタイプが正しくありません。タイプを確認してください。`,
"c239":`受理される`,
"c1210":`公開記録`,
"c988":`現在のプライスブックのエントリーが使用され、削除することはできません。`,
"c1699":`電子フェンス`,
"c834":`予備審査通過`,
"c113":`名前}を送信する`,
"c146":`通貨を変更すると、該当する商品がクリアされます。このまま変更しますか？`,
"c313":`インボイスファイル送信`,
"c140":`オブジェクトとテンプレートの選択`,
"c1311":`構文チェック`,
"c298":`非対応`,
"c1399":`メールマージテンプレート編集`,
"c681":`サークル`,
"c870":`本当に一括削除していいんですか？`,
"c551":`試用期間残り<span style="font-size: 16px; font-weight: bold; color: #fe8a14">  {days} </span>日
`,
"c1481":`編集を開始するステップを選択`,
"c88":`裁判の残り日数`,
"c1694":`多言語ワークベンチ
`,
"c1298":`接点同期方向`,
"c1819":``,
"c175":`詳細情報の取得に失敗しました`,
"c64":`objName}を開くかどうか。`,
"c319":`フォームスタイルの設定`,
"label.pay.online":`オンライン決済の開始`,
"c941":`中国  台湾`,
"c550":`開始日または終了日を選択してください`,
"c1546":`条件式を入力してください。`,
"c365":`見積もり行を商談製品に同期させる`,
"c908":`アイコンの選択`,
"c260":`廃棄のお願い`,
"c1238":`ユーザーをアクティブにする`,
"c50":`税率`,
"c869":`すべてのデータをアーカイブすることは確実ですか`,
"c1468":`会計年度の開始日を空にすることはできません。`,
"c93":`繰り返し開く`,
"c280":`メール削除`,
"c1526":`CCChatは、社員が職場で情報を共有するための企業向けソーシャルネットワークです。`,
"c23":`この支払明細の作成を続けると、請求書の支払金額が注文金額よりも大きくなってしまいます。金額を再調整して再度保存してください。`,
"front-console-v1-see-contacts":`複数の連絡先を確認しました。選択してください`,
"c607":`配送先住所がすでに存在するため、現在の住所を新しい請求先住所として保存してください。`,
"c1472":`電子メール`,
"c1056":`全文検索を有効にしてください`,
"c1639":`対象物`,
"c1711":`以下の項目をご確認ください。`,
"c1542":`長さは1～16文字です。`,
"c229":`マイルストーンの削除`,
"front-filter-v1-filter-by-name":`名前}」でフィルタリング`,
"c125":`通過中`,
"c1952":`クリックで検索`,
"c1679":`製品リクエスト`,
"c513":`タイムシート`,
"c80":`請求先住所`,
"c1833":``,
"c1954":``,
"c1422":`トラッキングフィールドの最大値（20）を超えました。`,
"c648":`会話`,
"c521":`注文数`,
"c560":`終了した案件`,
"c973":`受信箱の中身を全部読んでしまった`,
"c1882":``,
"c509":`パッキングリスト`,
"c685":`新規アドレスの追加`,
"c178":`アップロードされた画像のフォーマットはサポートされていません。png、jpg、jpegの形式で画像をアップロードしてください。`,
"c1003":`CCDingは、ディントークのコラボレーション機能と連携することで、プライベートドメイントラフィックをより完全に運用し、顧客関係のライフサイクルを完全に追跡・管理し、企業の運用効率と収益性を向上させることを支援します。`,
"c436":`来場者詳細`,
"front-electronic-signature-prepareTemplate":`契約書を作成する前に、管理者に連絡して契約書のテンプレートを作成してもらってください。`,
"c749":`署名の流れ`,
"c1894":`特定ユーザー`,
"c114":`Generate {name} ボタンをクリックして、送信前に{name}を生成してください。`,
"c1446":`選択ユーザーリストからユーザーを削除すると、上記で選択したロールにユーザーが割り当てられます。`,
"c898":``,
"c279":`売上高`,
"c232":`梱包する製品数を超えることはできません`,
"c1282":`ハードウェアテスト`,
"c911":`派遣中止`,
"c901":`投稿数が上限に達しました。`,
"c1366":`ダブルカラム`,
"c1934":`データ分類の作成`,
"c663":`代替テキスト`,
"c1657":`発注書`,
"c541":`本件に関する統計情報`,
"c1584":`フィールドラベルの翻訳`,
"c1340":`作成条件を選択する`,
"c536":`受信`,
"front-project-v1-batch-deletion-confirmation-information":`選択したレコードを一括して削除すると、選択したレコードに関連するすべての情報も削除され、データは復元できません。本当に削除していいの？`,
"c1809":`推奨アプリケーション`,
"c1301":`式が真であることが検証される`,
"c1318":`このアクションは、ワークフローを有効にする、継続するかしないか？`,
"c893":`現在のユーザーは、アカウント詳細のアドレスフィールドの編集にアクセスすることができません。`,
"c623":`モニター`,
"c1956":``,
"c1198":`フィールドの更新は、フィールドの値を指定された値に自動的に変更することができます。フィールドの更新は、ワークフローのルールや承認プロセスに関連するアクションです。`,
"c493":`デジタルマーケティングを形にして、あらゆるチャンスをつかむ`,
"c1557":`ケースアップグレードルール新規`,
"c1937":`現在利用可能なバージョンでは、{!language}に加えて、最大{!count}個の言語が許可されています。`,
"c1377":`永久に削除する`,
"c1063":`中国語記号はフィルタリング条件に使用できません。`,
"c327":`アセット・ヒエラルキー`,
"c747":`製品の総数が一杯です。まず、いくつかの製品を削除してから、引き続き製品を追加してください。`,
"c728":`データプライバシー`,
"c1423":`関連リストを空にすることはできません。`,
"c1581":`フレンチ`,
"front-reportlist-v1-optimizedReport":`レポートはクエリ後に最適化されます。ランダムに変更しないでください。`,
"c1265":`プロフィールに追加`,
"c1143":`表示されるフィールド`,
"c741":`メール内容をご記入ください`,
"c643":`投稿詳細`,
"c537":`平均応答時間`,
"front-electronic-signature-add-field":`バックフィルフィールドの追加`,
"c1574":`インポートしたファイルが正しいエンコード形式であることを確認し、システムを指定しない場合は、UTF8でエンコードされます。`,
"c1152":`このキューにメンバーを追加するには、メンバータイプを選択し、Available Membersからロールまたはユーザーを選択し、Selected Membersに移動します。`,
"c626":`全ユーザー`,
"c199":`フォームリンク`,
"c1300":`新規`,
"c1611":`データのインポート`,
"c917":`プールを活用することで、チームのポテンシャルを刺激し、アカウントフォローを効率化することができます。プール管理者は、アカウントや一括の割り当てを一元管理。また、営業担当者はリードのスクリーニングやフォローアップを受けることができます。`,
"c1414":`長さフォーマットエラー（0にできない）`,
"c1773":`ケースタイプ名`,
"c1412":`60分`,
"c1933":`データカテゴリーの管理`,
"c159":`注文の長さは、最大で以下の通りです。`,
"c640":`スケジュールポスト`,
"c1001":`ディングトーク統合バックエンドシステムの設定を試す`,
"c192":`現在のページレイアウトです。`,
"c978":`アカウント情報なし`,
"c969":`{0} 選択された`,
"c871":`これは{a}であなたの投稿が表示される方法です。a}がレイアウトを調整した場合、若干の違いが生じる可能性があります。`,
"c1264":`数式の結果が期待されるデータ型（真または偽）と互換性がない。`,
"c814":`1{0}を選択`,
"c1559":`0分`,
"c235":`{!ServiceResource.name} は注文を受け付けました。件名"{!ServiceAppointment.subject}"、番号："{!ServiceAppointment.name}"`,
"c215":`あなたの投稿が公開されました`,
"c425":`サービスアポイントメントマネジメント`,
"c182":`作業指示書と案件記録を一度に接続することができない`,
"c194":`投稿数の制限`,
"c657":`動作許可が出ていない、管理者に連絡してください。`,
"c1352":`正しくご記入の上、保存してください`,
"c855":`予定がないようです。`,
"c1204":`プロンプトデリート`,
"c333":`予算 コスト`,
"c1518":`リクエストに失敗しました`,
"c1091":`執行規則`,
"c1043":`ドキュメントに保存する`,
"c338":`サプライヤー  破棄`,
"c1421":`このページでは、フィールド追跡関連リストで追跡するフィールドを選択することができます。
ユーザーが以下で選択したフィールドのいずれかを変更するたびに、古いフィールド値と新しいフィールド値、および日付、時刻、変更されたプロパティ、変更を行ったユーザーが、フィールドトラッキング関連リストに追加されます。注意：Changedセクションに表示されているフィールドのみが追跡され、フィールド値の追跡時には「changed」だけが表示されます。`,
"c431":`キャンペーン・ヒエラルキー`,
"c374":`プライスブック製品`,
"c506":`自動化されたスケジュール`,
"font-trade-module-invoice-totalMoney":`インボイス債権合計`,
"c203":`Mailchimpでフォームを共有`,
"c962":`月） {年} {年`,
"c786":`電話番号／郵便番号`,
"c1487":`大文字、小文字、数字を含むこと。`,
"c469":`ページは編集中です。ページを離れると、現在のデータは保存されません`,
"c137":`フォームのテンプレートを選択する`,
"c993":`データストレージ（全オブジェクト）`,
"c1905":`操作説明書です。`,
"c483":`キャンペーン情報`,
"c1396":`メールマージテンプレート新規`,
"c1876":``,
"c947":`フランス`,
"c190":`支払い項目の通貨は、注文、請求書、支払いの通貨と一致させる必要があります。通貨を絞り込んで、再度保存してください。`,
"c386":`フルフィルド`,
"c803":`アカウントすべてのアカウント`,
"c1119":`保存する前に、フォームに完全に記入してください`,
"c759":`充填するため`,
"c1917":`フィルター関連オブジェクト`,
"c1678":`ワークルール`,
"c823":`オーダーセッティング`,
"c1187":`ウェブフック一覧`,
"c1498":`ツールのアイコンを選択します。推奨サイズは、x px*y pxです。`,
"c422":`サービスアポイントメントの生成方法`,
"c1686":`ナレッジ`,
"c1326":`この操作を行うと、このタイムトリガーが削除されます。続ける？`,
"c782":`参加方法`,
"c1461":`Selected Usersからユーザーを削除すると、上記で選択したロールにユーザーが割り当てられます。`,
"c416":`サービスレポート プッシュ記録`,
"c1494":`ユーザーが機能を理解しやすいように、ツールに名前を付けてください。名前は、アプリのフッターに表示されます。`,
"c758":`受理される`,
"c407":`サービスクルー`,
"c51":`新税制`,
"c844":`バインドするDocuSignアカウント`,
"c1086":`候補者戦略`,
"c361":`メニュー編集
`,
"c602":`マトリクスチャート`,
"c1257":`レイアウトエディターの設定`,
"c191":`現在のビューの編集権限が必要です`,
"c299":`少なくとも1つのオブジェクトを選択する`,
"c432":`キャンペーンの歴史`,
"c650":`新しい投稿を公開し、新しいコンバージョンを開始する`,
"c1038":`セキュリティトークンのリセット`,
"c1721":`ロールアップサマリーフィールドのプロパティ`,
"c1681":`対象物`,
"c531":`受入件数`,
"c13":`現在のユーザーには編集権限がありません`,
"c162":`譲渡人、譲受人への同時通知`,
"c1620":`税金の設定`,
"c1182":`ユニークな名前を入力してください。`,
"c1045":`保存とダウンロード`,
"c992":`ファイルストレージ`,
"c1307":`タスク競合の挙動。CloudCC.comが常に優先される`,
"c171":`持株比率`,
"c230":`タスクの削除`,
"c470":`オートフィリングフィールド`,
"c367":`契約書作成`,
"c1338":`ない`,
"c26":`割引の設定`,
"c1517":`必須項目が空であることはできません`,
"c989":`フォーキャスト・ユーザーズ・マニュアル`,
"c1424":`このページを使用して、組織で使用されるすべての通貨を定義します。
会社通貨は、本社が収益報告に使用する通貨に設定する必要があります。
他の通貨を会社通貨として指定した場合、すべての為替レートはこの変更を反映するように修正されます。`,
"c1314":`この操作を行うと、このワークフローは永久に削除されます。続行しますか？`,
"c705":`掲載記事`,
"c1949":`以前のユーザー`,
"c613":`外部ページ`,
"front-electronic-signature-openSign":`サイン会開始`,
"c349":`ドラッグ＆ドロップ`,
"c683":`ロードモア`,
"c1253":`1.行レイアウト：フォアグラウンドのマスター・スレーブ入力に適用したときに表示されるレイアウトと、一括追加したときのレイアウト`,
"c679":`グレー`,
"c1741":`ユーザー情報の取得`,
"c1386":`フィールドのプロパティを編集する`,
"c914":`サイドバーを折りたたむ`,
"c1725":`ルックアップリレーション（マルチセレクト）のプロパティ`,
"c1585":`スキルレベルの確認`,
"c224":`マイルストーンへ`,
"c220":`あなたの投稿は失敗して公開されました`,
"c498":`CloudCC Inventoryは、オンラインとオフラインのオムニチャネルビジネスを効率的にサポートし、商品と資金の流れや管理を実現します。複数のモジュールを効果的に組み合わせ、ユーザーは洗練された受注管理を実現し、パートナーとのWinWinの関係を構築することができます。`,
"c566":`保存後、アカウントのアドレスを自動取得`,
"c1978":``,
"front-electronic-signature-ContractTemplate":`契約書テンプレートの選択`,
"c1976":``,
"c1951":`ショートノート`,
"c540":`チャンネル別時間分解`,
"c793":`ドキュメントテンプレート`,
"c293":`GDPR準拠を可能にするオブジェクトの設定`,
"front-invoice-online-pay-again":`あなたはすでにオンライン決済を開始しています。再度のご利用はご遠慮ください。`,
"front-electronic-signature-open-password":`パスワードを入力してください。`,
"front-v1-partner-background-tooltip":`最大2Mまでのファイルに対応しています。鮮明な画像のアップロードを推奨します。`,
"c449":`チャット履歴`,
"c30":`クラシック`,
"c1195":`アサインメントを通知する`,
"c1497":`5回`,
"c1645":`リレーションシップネットワークのスコア設定`,
"c245":`{!oldServiceResource.name} は {!ServiceAppointment.name} という作業指示を {!newServiceResource.name} に転送しました。`,
"c923":`チーム紹介`,
"c24":`地図を見る`,
"c1712":`ステップ1: コントロールフィールドと従属フィールドを1つずつ選択します。完了したらContinueをクリックします。`,
"c872":`名前（未記入）`,
"c886":`サイドバーを開く`,
"c1074":`ケースチームの事前決定`,
"c1259":`メールのテンプレートを選択してください。`,
"c1820":`URLサフィックス`,
"c1068":`ギャップ・トゥ・クォータ`,
"c1596":`大文字・小文字を区別する`,
"c1389":`Lightning詳細ページ埋め込みカスタムページ`,
"c1892":``,
"c1435":`ページレイアウト名を入力してください`,
"c485":`フォーム名`,
"c1554":`リプレースメント成功`,
"c1780":`新しい承認プロセス`,
"c101":`ピーシー`,
"c1883":``,
"c816":`投稿を見る`,
"c1814":``,
"c1652":`DingTalk 外部接点`,
"c445":`プロジェクトの役割`,
"c1911":`テンプレートのダウンロード`,
"c1677":`経費報告書カタログ`,
"c1046":`ファイルの種類を選択してください`,
"c1429":`パーミッションの設定`,
"c1094":`いつ`,
"c1004":`CCDingはCloudCCの強力なカスタマイズ機能を備えており、お客様独自のビジネスニーズに基づき、迅速かつ柔軟に拡張機能を設定することが可能です。`,
"c1035":`申し訳ございませんが、現在の操作権限をお持ちではありません。管理者に連絡してください`,
"c1267":`オプション1`,
"c1653":`WeComコンタクト`,
"c853":`公開した投稿に対する「いいね！」と「コメント」の数が表示されます。`,
"c398":`今すぐ始める`,
"c522":`請求書発行枚数`,
"c1763":`レジストレーションプロセッサー`,
"c287":`コンプライアンス`,
"c578":`MoM&YoY Numeric Chart (数値表)`,
"c40":`パスワードを入力してください`,
"c631":`Twitterで見る`,
"c489":`非活性化時間`,
"c819":`電話番号/メールボックス`,
"c1380":`注：このセクションのすべてのフィールドは、「未使用項目」セクションに移動されます。`,
"c935":`フォームタイプ`,
"c625":`すべてのキャンペーン`,
"c471":`キャンペーンを実施従業員紹介`,
"front-electronic-signature-writen":`フィルド`,
"c1148":`オブジェクトのパーミッション`,
"c1015":`ユーザー定義のフォーマットパラメーター`,
"c889":`ユーザーアカウントの無効化に成功`,
"c201":`このフォームをソーシャルメディアで共有する`,
"c467":`ソートフィールドが空です`,
"label.mobile.no.null":`電話番号は空ではありません。`,
"c307":`エンタイトルメント`,
"c1796":`最初の5つのボタンは、下部に固定されています。その他のボタンは "More "でアクセス可能です。`,
"c1489":`フッターツールは下部に固定されたユーティリティです。`,
"c1019":`ヘッダーパラメータ（APIキー、トークンなど）の追加`,
"c1163":`名刺は見えないため、カスタマイズはできません。`,
"front-kefu-moudle-wait-calling":`通話中のため、後ほどもう一度お試しください`,
"c784":`営業許可証に記載されている会社名を入力してください`,
"c490":`最終ログイン時間`,
"c790":`手書きのサイン`,
"c336":`リード  破壊`,
"c453":`ホームページかんばん`,
"c1157":`intervaltype typeがhourの場合、1時間以上23時間以下であること。`,
"c1738":`サフィックス`,
"c1760":`ファイル名の数とアップロードされた写真の数が一致しない!`,
"c1177":`演算子「{!parameter.type1}」のパラメータが誤った型である。
パラメータ.type2}を期待したが、{!パラメータ.type3}を受け取った。`,
"c1960":``,
"c1765":`アップロード可能なファイル数は最大{n}個です。`,
"c1013":`標準フォーマットのパラメータ`,
"c1083":`名前を空にすることはできません`,
"c1208":`オンラインチャットアカウントが有効になっていません。チャット機能を有効にしてください。`,
"c530":`まず会社のメールボックスを設定してください`,
"c1268":`オプション2`,
"c610":`URLを指定しなかった場合、アイコンはマスタードメインにリンクされます`,
"c359":`チャート`,
"c1438":`ページレイアウトを選択してください`,
"c1279":`リード/ライト  ユーザーは予測データを表示し、上書きすることができます。`,
"c193":`制限事項`,
"label.mobile.verificationCode.exceeded.times":`再試行回数を超えました。再度リクエストしてください。`,
"c138":`会社テンプレート`,
"c821":`新しい社内連絡先`,
"c381":`オンライン決済を申し込む`,
"c1590":`リピート可否`,
"c1484":`大文字、小文字、数字、記号を含む必要があります。`,
"c761":`サイン`,
"c1370":`一部の名称`,
"c964":`マスター・ディテール関係欄は必須`,
"c585":`イギリス 地図`,
"c500":`標準化されたプロセスと効率的な管理でワンストップのカスタマーサービスソリューションを提供し、サービスリソースを調整し、お客様に最高のサポートを提供することができます。`,
"c1502":`ペイン幅（ピクセル）（入力値の範囲：11920px）。`,
"c214":`3つのサイズのビットマップと、すべてのフォーマットのベクターグラフィックスを含める。`,
"c714":`適切なタイミングで公開されるように投稿をスケジューリングします。`,
"c1341":`工業・商業データの照合を有効にするをチェックします。ユーザーが企業の顧客情報を入力するとき、ユーザーが正しい顧客の産業および商業登録情報を入力するのを助けることができます。`,
"c1718":`すでに{0}にディスパッチされており、繰り返しディスパッチすることはできない。`,
"c1044":`ドキュメントにダウンロード`,
"c1846":``,
"c1789":`出席者数`,
"c552":`不採用`,
"c684":`{sumTotalCount} more`,
"c54":`税金の種類を記入してください`,
"c320":`フォームフィールドを選択する`,
"c1008":`コピー商品詳細`,
"c236":`{!ServiceResource.name}は注文を受理しました。アカウント"{!ServiceAppointment.accountid.name}"、Number: "{!ServiceAppointment.name}"。`,
"c1592":`オートナンバーフィールドのプロパティ`,
"c1588":`値をデータベースキーワードにすることはできません`,
"c1901":``,
"c123":`物流情報`,
"c654":`ダッシュボード一覧に戻る`,
"c1442":`このロールに他のユーザーを割り当てるには`,
"c1779":`写真の総容量は20Mを超えることはできません。`,
"c1363":`にて一部タイトルを展示しています。`,
"c335":`利益率`,
"c267":`基準を満たさないため、変更のコミットメントに失敗しました`,
"c1818":``,
"c1803":`URLを入力してください。`,
"c226":`サブタスクへ移動`,
"c102":`1回クリックする`,
"c637":`下書きとして保存する`,
"c1336":`エンドキャラクター`,
"c633":`新しいソーシャルポストの作成`,
"c1103":`レギュラー`,
"c777":`参加者情報を設定する`,
"c223":`プロジェクトに追加`,
"c592":`ウォーターフォール図`,
"c1714":`実際のシナリオに基づき、ビジネス要件を満たすモジュールを選択する。`,
"c1439":`保存するものがない`,
"c1402":`予測区分の値を空にすることはできません。`,
"c315":`有効な注文のみ請求書を生成することができる`,
"c89":`メール イベント名`,
"c108":`オートマッチに成功`,
"c1507":`180日`,
"c402":`フィールド`,
"c748":`タイトル}のプライスブックを選択してください。1つのプライスブックからしか商品を追加できません。選択したプライスブックを変更すると、既存の製品はすべて削除されます。`,
"c1293":`Microsoft Exchangeでユーザーに対してなりすまし許可のあるサービスアカウントを設定した後、CloudCCがExchangeサーバーと通信できるようにサービスアカウントの資格情報を入力します。
サービスアカウントの資格情報を保存しても、ユーザーがレコードを同期できない場合は、Exchange Syncが正しく設定されていることを確認してください。`,
"c1625":`通信チャネル`,
"c501":`お客様に質の高いフィールドサービスを提供する`,
"c1877":``,
"c269":`情報の結合に失敗しました`,
"front-electronic-signature-open-confirm":`バインドアカウント`,
"c584":`アメリカ合衆国の地図`,
"c437":`失敗`,
"c738":`送信日`,
"c274":`注文受付のタイムアウトが発生し、発送がキャンセルされました。番号：{0}です。クリックして詳細を見る >`,
"c83":`検索データ`,
"c206":`PNG形式`,
"c1903":`Wordファイルの作成方法`,
"c309":`オーダーファイル送信`,
"c1899":``,
"c539":`出典の割合が高いもの`,
"c304":`主な関心事`,
"c1835":``,
"c1413":`フィールドラベルを空にすることはできません`,
"c1348":`拡張インターフェースURL`,
"c1452":`キュー・ラベル`,
"c1064":`保護されたコンポーネント`,
"c151":`フォームの主な内容を簡単に説明する。`,
"c1912":`オブジェクト別のテンプレート表示（ダウンロードに対応）`,
"c1294":`Exchange Syncの構成`,
"c639":`今すぐ投稿する`,
"c1401":`オプションリストの値を空にすることはできません。`,
"c1535":`顧客接点構造図に接点五星図を構成するために使用するスコアリングルール`,
"c720":`いいえ、ありがとうございます。`,
"c1913":`Wordテンプレートダウンロード`,
"c801":`新規お問い合わせ先`,
"c900":`訪問者の住所情報がないため、チェックイン距離の算出ができません。`,
"c1669":`消耗品`,
"c1069":`ケースチームの役割`,
"c695":`原寸大`,
"c864":`フォームを選択する`,
"c1443":`利用可能なユーザーを表示するためのピックリストからの選択`,
"c881":`読んで納得`,
"c794":`サイン用テンプレート`,
"c543":`評価を受ける`,
"c1400":`制御フィールドまたは従属フィールドが空であってはならない`,
"c1217":`カスタムコンポーネントメニューの設定`,
"c466":`同じプライスブックを使用している注文のみ請求書を作成することができます`,
"c1783":`また、承認処理中のレコードは常にロックされ、管理者のみが編集可能です。ただし、現在割り当てられている承認者がこのレコードを編集できるようにすることは可能です。`,
"c867":`{ユーザー名}に招待メールが届き、ヘルプセンターにアクセスするためのパスワードを作成するよう促されます。
続行しますか？`,
"c1185":`2サイクル`,
"c529":`トップアップするための利用可能な方法はありません、管理者に連絡してください`,
"c742":`画像は最大4枚まで選択でき、1枚あたり200Kを超えることはできません。画像をクリックすると選択されます。`,
"c430":`検索パフォーマンス用語`,
"c1180":`関連する役割`,
"c553":`最終招待時間`,
"c575":`カラムチャート`,
"c124":`配送保留`,
"c1664":`企画戦略ワークルール`,
"c1525":`リードフィールドは、キャンペーンメンバーフィールドと関連付けられています。`,
"c629":`失敗`,
"c554":`初回招待時`,
"c547":`直近7日間`,
"c1682":`タイムエントリー`,
"c1368":`タイトルはEditページのみ表示されます。`,
"c599":`テーブルチャート`,
"c588":`カナダ 地図`,
"c703":`経由`,
"c1357":`終了日を選択`,
"c1031":`製品を1つ以上追加する`,
"c713":`CloudCC内部からソーシャル投稿を作成できます。`,
"c142":`これは、訪問者があなたのサイトのフォームを送信した後に実行されるアクションです。`,
"c1111":`URL通知`,
"c153":`現在のレコードに関連する商品をクリアした後、通貨を変更することができます。`,
"c1942":`モバイルURL`,
"c1431":`このページを使用して、ユーザーデータを表示するためのさまざまなページレイアウトを作成します。
ページレイアウトを作成した後、「ページレイアウト割り当て」ボタンをクリックすると、ユーザーがデフォルトで見るページレイアウトを制御することができます。`,
"c253":`GDPRコンプライアンス`,
"c1479":`数式エラーです。確認してください`,
"c1313":`エラー: ルールの複雑さのチェックに失敗しました。構文を確認してください。`,
"c1771":`Webサイトから送信されたサービス要求は、システム内に案件記録を生成することができ、そこでサービス要求のページを設定することができます。パソコン・携帯電話向けWebページ`,
"c1079":`ケースチームメンバー`,
"c612":`内部ページ`,
"c1382":`高度なフィルタをクリア`,
"c1716":`受理されるには`,
"c400":`サービス・リソースの位置`,
"c1176":`必須項目をキャンセルする`,
"c1398":`クリックでアップロード`,
"c671":`アイコンとワード`,
"c1227":`ユーザー選択`,
"c20":`関連オーダーの請求数量を超えることはできません。`,
"c514":`報告書のグラフ`,
"c1055":`RequestBodyのパラメータがjson形式でない`,
"c946":`イギリス`,
"c1635":`アセットQRコードルール`,
"c1506":`90日`,
"c1351":`Nexmo APIアカウントを設定することで、ユーザーはCloudCCプラットフォーム上でVonage APIアカウントにアクセスし、テキストメッセージの送受信を行うことができます。`,
"c1719":`DingTalkの統合`,
"c717":`新しい投稿`,
"c1308":`タスクコンフリクトの行動常に交換を優先する`,
"c174":`すべて正常に編集されました`,
"c1330":`複数選択可能なリスト`,
"c1465":`火星時間帯`,
"c940":`中国  香港`,
"c1553":`記録保持者の電子メールアドレス`,
"c743":`有効な数字を入力してください`,
"c1232":`Available User Listに表示されているユーザーを選択して、ロールCEOに割り当てる。`,
"c1940":`PCのURL/モバイルのURLは必須です。`,
"c1963":``,
"c441":`スマートなビジネスと財務管理`,
"c1794":`タイムアウト処理`,
"c1910":`3.メール結合テンプレートのアップロードオフラインでWordのテンプレートを変更した後、Wordファイルをアップロードする`,
"c1406":`ファイルをアップロードしてください`,
"c1197":`その他のメール`,
"c423":`ディスパッチプラットフォーム`,
"c723":`破壊を依頼するための確認`,
"c664":`ソーシャルネットワークなし`,
"c1071":`ケースチームの役割分担`,
"c859":`0}を入力してください。`,
"c356":`計画コスト`,
"c221":`プロジェクトへ`,
"c1225":`PCのアイコン`,
"c1906":`指示を飛ばす？`,
"c1569":`輸出依頼が処理されましたので、メールをご確認ください。`,
"c1339":`テンプレートを作成するオブジェクトを選択する`,
"c1837":`URLの末尾を入力してください`,
"front-email-payment-Invoice-Tips1":`管理者に連絡して、WeChat、Alipay、PayPalまたはVISAを有効にしてから、オンライン決済を開始してください。`,
"c99":`製品数量`,
"c278":`以下のメールを削除しますか？`,
"c364":`引用行`,
"c572":`選択したフィールドを空にすることはできませんので、フィールドを追加してください。`,
"c310":`オーダーファイル作成`,
"c247":`移管`,
"c158":`時間閾値の割り当て`,
"c325":`案件アサイン通知テンプレート`,
"c1600":`ジオロケーションフィールドのプロパティ`,
"c985":`ネットワークが切断されています。ネットワーク接続を確認してください`,
"c1277":`新しいグローバルオプションリストセット`,
"c877":`フィル・ノンオーダー`,
"c1364":`カラムレイアウト`,
"c1564":`チェックボックスフィールドのプロパティ`,
"front-filter-v1-press":`プレス`,
"c505":`訪問者トラッキング`,
"c523":`ポータルユーザーに追加する`,
"c727":`データを正常に破棄する`,
"front-electronic-signature-sended":`送信`,
"c150":`必要事項をご記入ください。`,
"c700":`最終更新時刻`,
"c1325":`WeCom  H5ミニプログラム`,
"c1263":`フィールドの依存性編集`,
"c1700":`電子フェンスの半径`,
"c824":`サインイン順`,
"c710":`すべてのソーシャルメディアを一元管理`,
"c1320":`現在のステップでフォームの確認に失敗しました。次のステップの前に確認してください`,
"c1130":`組織で使用する通貨と他の通貨との為替レートの編集`,
"c1610":`通貨フィールドのプロパティ`,
"c358":`予算`,
"c1537":`ユーザーの訪問回数を入力すると、訪問回数スコアがルールにより算出されます。`,
"c1530":`新しい必須情報レイアウト`,
"c1968":``,
"c544":`チャンネル`,
"c1211":`標準スタイル`,
"c212":`SVG形式`,
"c1255":`3.モバイルページレイアウト：Wechatの小型Webページとモバイル版表示のレイアウトに適用されます。`,
"c165":`024の整数値を入力してください。`,
"c1081":`チーム`,
"c1922":`最大5MBまでのファイルをサポート`,
"c1463":`アメリカ時間帯`,
"c1583":`スパニッシュ`,
"c1415":`長さのフォーマットエラー`,
"c932":`スパム`,
"c888":`ユーザーアカウントのアクティベーションに成功`,
"c838":`オペレーター`,
"c98":`製品カテゴリー`,
"c830":`作成者`,
"c661":`ネットワーク`,
"c1073":`リプレースする場合の役割`,
"c1509":`パスワード`,
"c818":`カスタムページのメニュー設定`,
"c861":`地図から選ぶ`,
"c736":`投稿者`,
"c204":`標準`,
"c1962":``,
"c1753":`起動時に、最大許容オーダー長、タイムアウト後処理モードの設定が可能です。`,
"c1563":`アドレスフィールドのプロパティ`,
"c1709":`オフ：デフォルトでは組織の全メンバーのホームページには表示されません。ユーザーは、モバイル側で「自分のホームページを設定する」ことでモジュールを開くことができます。`,
"c1049":`生成に失敗しました。現在、PDFファイルの生成は、docxタイプのテンプレートにのみ対応しています。`,
"c1961":``,
"c1123":`レコードを作成または編集する場合`,
"c839":`予定がないようです。`,
"c1473":`新しいアサインルール`,
"c456":`支払額`,
"c1697":`新ソフトウェアパッケージ`,
"c1151":`Send Email to Membersを選択すると、キューにオブジェクトが割り当てられたときにキューメンバーに通知され、Don't Notifyは選択されなくなります。`,
"c341":`最終決算`,
"c1281":`展示作品`,
"c724":`データの破棄を確認する`,
"c1017":`値の説明`,
"c1668":`ユーザー地域`,
"c1943":`記事数の上限に達しました。アップグレードをご希望の方は、管理者までご連絡ください。`,
"c865":`私は、{0}と{1}を読み、同意します。`,
"c1193":`3サイクル前`,
"c1744":`カスタム登録処理クラス`,
"c1142":`フィルター条件`,
"c1164":`詳細ページで表示するようにカスタマイズする場合は、非表示にします。`,
"c332":`金額は請求する注文を超えることはできません`,
"c520":`支払いに失敗しました。使用可能なリベートが不足しています`,
"c906":`マイナス`,
"c1174":`カスタマイズ設定`,
"c482":`ネーミング・ユア・コンパジン`,
"c49":`ドメインの安全性設定の更新`,
"c1290":`候補者リスト`,
"c725":`破壊要求の取り消しに成功`,
"c76":`ペイ`,
"c1622":`アイデンティティ・プロバイダー`,
"c1331":`空ではない`,
"c1134":`許可セットを選択してください`,
"c558":`保留の場合`,
"c1884":``,
"c1690":`トップアップの歴史`,
"c876":`サインノンオーダーメイド`,
"front-invoices-v1-nofilles-tocreate":`請求書作成ボタンをクリックして、請求書を作成してから送信してください。`,
"c779":`契約締切日`,
"c1095":`別のオプションを追加する`,
"c603":`MoM&YoY Biaxial Chart（バイアキシャルチャート`,
"c1527":`CCChatの設定`,
"c1752":`注文期間閾値`,
"c1093":`条件を満たさない場合`,
"c1144":`視認性`,
"c1203":`まず、転送するデータを選択してください。`,
"c1496":`10回`,
"c455":`契約目標`,
"c1766":`ここをクリックするか、ここにファイルをドラッグ＆ドロップして添付してください。`,
"c1731":`ディスパッチ失敗`,
"c428":`マップモードでのディスパッチ`,
"c55":`税額を記入してください`,
"c1604":`紹介画像`,
"c899":`チェックイン距離`,
"c1887":``,
"label.facebook.title":`FacebookH5 MiniApp`,
"c487":`受取人名`,
"label.social.posts.info":`投稿内容が見つかりませんでした`,
"c704":`オーディエンス`,
"c1005":`CCDingの利用を希望する場合は、お問い合わせください。`,
"c673":`ウェブ画像`,
"front-electronic-signature-singed":`サイン会開始`,
"c722":`1アカウント接続`,
"c595":`エリアチャート`,
"c1886":``,
"c1054":`このテンプレートではコンテンツはありません。テンプレート設定後、保存してください。`,
"c1344":`編集ワークフロー`,
"c120":`タイプ`,
"c68":`ペイアウト・オーダー`,
"c479":`CloudCC Forms Mailchimp`,
"front-electronic-signature-explain-mainTitle":`電子署名とスタンピング`,
"c5":`税金`,
"c1022":`PDFを見る`,
"c976":`投稿の承認とスケジュール{0}。`,
"c812":`コメント`,
"c532":`レストケース数`,
"c330":`契約項目`,
"c1296":`新規則`,
"c249":`ポスト投函中`,
"c630":`LinkedInで見る`,
"c1160":`最初の実行時間は#timeで、その後#number hour(s)ごとに実行されます。`,
"c1356":`開始日を選択`,
"c958":`ポストライクIDを空にすることはできません。`,
"c1378":`非選択フィールドに移動する`,
"c170":`レコードID {0} のデータ作成に失敗しました、失敗理由: {1} です。`,
"c810":`返信`,
"c783":`署名の必要性`,
"c968":`ディスコネクト`,
"c752":`署名タスクの開始`,
"c1040":`お客様{0}のメールアドレスに新しいセキュリティトークンを送信しました。`,
"c439":`来場者`,
"c1002":`CCDingアプリケーションは、CloudCCとDingTalkプラットフォームをベースに作成されたマーケティング、セールス、サービスのための統合ソリューションです。`,
"c1470":`必須項目が未入力です。`,
"c1184":`Webhookの設定`,
"c1707":`企業の業務に関係のないコンポーネントは、デフォルトの構成から無効化したり`,
"c67":`注文が正常に送信されました`,
"front-generate-v1-invoice":`請求書の作成`,
"c477":`Mailchimpのアカウントで認証する必要があります。Authenticate Mailchimp "ボタンをクリックすると、キャンペーンを送信するためにMailchimpにリダイレクトされます。`,
"c1315":`接触競合行動`,
"c966":`管理者までご連絡ください`,
"c1726":`パーセントフィールドの特性`,
"c764":`不採用`,
"c301":`最大200文字まで入力可能`,
"c1027":`キーペアが正しいか、または無効化されているかを確認してください。`,
"c61":`まずはナレッジを開いてからご利用ください`,
"c815":`アーカイブすべて`,
"c827":`このページには未保存の変更があり、このまま進むと失われます。`,
"c1460":`左からユーザーを選択し、Selected Users リストに追加する`,
"c688":`最大幅`,
"c1693":`DingTalk統合の設定`,
"c1692":`アクション`,
"c1939":`現在のバージョンでは、最大 {!count} 個の記事がサポートされています。`,
"c1237":`ステータスを選択してください`,
"c33":`サブスクリプションタイプを編集する`,
"c217":`post is going out {date}.`,
"c721":`アコアントとの接続を解除する`,
"c284":`顧客からのデータ要求をCRMで処理する`,
"c1273":`メニューの視認性`,
"c939":`中国  マカオ`,
"c503":`プロジェクトの進捗を把握する`,
"c1090":`条件から選ぶ`,
"c1800":``,
"c492":`招待された`,
"c1428":`必要なマーク`,
"c73":`現在の残高`,
"label.the.peoples.republic.of.china":`ピープルズ・リパブリック・オブ・チャイナ`,
"c828":`ポスト`,
"c36":`プレビュー`,
"c954":`新しい電話番号`,
"c1504":`30日`,
"c1520":`以下は、ボタンとリンクの一覧です。ボタンやリンクを追加するには、ページレイアウトを編集してください。
ボタンは、詳細ページ、関連リスト、リストビューに表示することができます。
1.詳細ページでボタンやリンクをカスタマイズするには、ページレイアウトを編集します。
2.2. 関連リスト上のボタンやリンクをカスタマイズするには、ページレイアウトに表示される関連リストのプロパティを編集します。
3.3. リストビューのボタンやリンクをカスタマイズするには、検索レイアウトのリストビューのレイア ウトを編集してください。`,
"front-electronic-signature-innerSinger":`内部署名者`,
"c1457":`ピックリストから選択すると、利用可能なユーザーが表示されます。`,
"c508":`ROI分析`,
"c833":`認証取得`,
"c1872":`サブドメイン`,
"c1804":``,
"c1212":`このページでは、レコードの一括削除を行うことができます。`,
"c207":`ベクターフォーマット`,
"c1441":`このページを使用して、組織で使用されるすべての通貨を定義します。
会社通貨は、本社が収益報告に使用する通貨に設定する必要があります。
他の通貨を会社通貨として指定した場合、すべての為替レートはこの変更を反映するように修正されます。`,
"c31":`ハーフスクリーン`,
"c71":`支払い方法を選択してください`,
"c1061":`ポスト`,
"c373":`標準価格表`,
"c545":`解答時間 (h)`,
"c77":`セットアップモジュール`,
"label.lastcompiledate":`最終コンパイル時間`,
"c1216":`アップロードされていません`,
"c119":`領収書の確認`,
"c1047":`保存方法を選択してください`,
"c281":`データ処理`,
"c1713":`ステップ 2: 以下のページで、従属フィールドに表示される値を制御するフィルタ条件を、コントロールフィールドの各値に対して編集します。`,
"c1332":`エンプティ`,
"c1189":`5サイクル`,
"c715":`ブランドへの言及をモニターし、迅速に対応する。`,
"c1347":`周期的タイムトリガー`,
"c127":`カラムの管理`,
"c1500":`ペイン幅`,
"c1391":`フィルタリングを駆動するフィールドは、コントロールフィールドと呼ばれます。
標準およびカスタムのチェックボックスと、値が1つ以上300以下であるオプションリストが、コントロールフィールドになり得ます。`,
"c1173":`リストプレビューが表示できない`,
"c283":`資料請求`,
"c1464":`UKタイムゾーン`,
"c919":`プールを活用することで、チームのポテンシャルを刺激し、リードのコンバージョン率を向上させることができます。プール管理者は、リードの一元管理、一括割り当てを行うことができます。また、営業担当者はリードのスクリーニングやフォローアップを受けることができます。`,
"c82":`Lightningのみ`,
"front-file-delete-intro":`ファイルが削除された`,
"c1634":`顧客満足度`,
"c1213":`コンソールスタイル`,
"c606":`デフォルトの配送先住所`,
"c1250":`このレイアウトは本当に削除してよいのでしょうか？`,
"c1474":`ルール名を空にすることはできません`,
"c1732":`アロケーションに失敗`,
"c905":`追加`,
"c644":`発行時間`,
"c1560":`チームを有効にするかどうか`,
"c75":`リベート残高`,
"c1026":`ユーザーセキュリティトークンが更新されているかどうか確認してください`,
"c1586":`フォーミュラフィールドの特性`,
"c884":`プライバシーポリシー`,
"c538":`平均解答時間`,
"c322":`新しいインボイス`,
"c1140":`パーミッションセット名`,
"c1135":`カスタムページの割り当て`,
"c1167":`名刺には最大10フィールドまで追加可能です。`,
"c461":`支払傾向`,
"c825":`企業`,
"c56":`請求書の合計金額と受取金額が一致しない。もう一度入力してください。`,
"c931":`従業員位置検出スイッチを有効にしていないため、位置情報共有区間を使用できません。続行しますか？`,
"c1673":`タイムスロット`,
"c276":`GDPRの遵守を可能にする`,
"c334":`予算額`,
"c733":`キャンペーンを実施します。新ポスター`,
"c1146":`モバイル端末に適用？`,
"c384":`新パッキングリスト`,
"c139":`ミーティングテンプレート`,
"c1908":`DNSレコードの表示`,
"c1576":`すでに追加済み`,
"c1568":`すでに存在する`,
"c957":`投稿コメントIDを空にすることはできません。`,
"c1060":`発注項目`,
"front-electronic-signature-nosign":`あなたの組織では、Esignatureのサービスプロバイダーが選択されていません。このサービスを有効にするには、管理者に連絡してください。`,
"c1411":`20分`,
"c1050":`正常に生成されました。ドキュメントがファイルリストに保存されました`,
"c419":`メンテナンスプラン`,
"c1230":`このページは、CEOへの共有アクセス権を持つユーザー、ロール、エリアを一覧表示します。`,
"c934":`変換タイトル`,
"c1020":`1.価格表が有効になると、デフォルトで全商品を含む1冊の標準価格表が生成されます。`,
"c677":`右寄せ`,
"c593":`ラインチャート`,
"c272":`{0}は注文受付のタイムアウトがあります。アカウント{1}, 件名:{2}、番号: {3}です。クリックして詳細を見る >`,
"c1742":`カスタムエラーページ`,
"c811":`RETWEETS`,
"c451":`スプリットケース`,
"c277":`メールを削除すると、次のメールも削除され、今後連絡先に送信されなくなります。これは不可抗力です。`,
"c244":`{!ServiceResource.name}は注文を拒否しました。番号："{!ServiceAppointment.name}"`,
"c627":`発行済み`,
"c1862":`プレビューURL`,
"c1578":`やまと`,
"c601":`ターゲットチャート`,
"c251":`投稿の公開に失敗しました`,
"c202":`Mailchimpで共有する`,
"font-social-prohibit-create":`編集中に新しい記事を作成することはできません。`,
"c394":`CloudCCは、オンラインでの業務管理、効率化を支援します。ご利用になりたいアプリケーションを選択し、紹介・案内に従って操作してください。`,
"c1642":`メンバー設定`,
"c1684":`対象物`,
"c1362":`エンプティ`,
"c1124":`為替レートの範囲：20220531～2022年5月31日（火）00:00:00（日本時間`,
"c1323":`必須項目を表示する`,
"c323":`PDF形式`,
"front-setting-dialog-title-one":`アカウントの紛失を防ぎ、素早くログインし、簡単に検索できるようにするため、電話番号をバインドしてください。`,
"front-electronic-signature-cancelIntro2":`初めてアカウントをバインドする場合は、「続行」をクリックして次のステップに進んでください。バインドを解除した後に再バインドする場合は、「キャンセル」をクリックし、閲覧データを消去した後に再バインドすることをお勧めします。`,
"c1715":`有効にします。チェックを入れると、モバイル側の「その他」「標準機能」にモジュールが表示されるようになります
無効にします。チェックを入れると、モバイルサイドの[その他][標準機能]に表示されなくなります。`,
"c1379":`このサブカラムを今すぐ削除しますか？`,
"c353":`タイムシートの表示`,
"c621":`リッチテキストコンテンツ`,
"front-v1-partner-image-tooltip":`最大2Mのファイルに対応しています。画像は{size}に縮小されます。似たような比率の鮮明な画像をアップロードすることをお勧めします。`,
"c1967":``,
"c772":`最終決定`,
"c1018":`エンティティパラメータを追加する`,
"c734":`投稿者チャンネル名`,
"c380":`新規お支払い`,
"c1291":`ステータスカラー凡例`,
"c979":`重慶`,
"c1723":`フォーマットエラーです。yyyy/MM/ddまたはyyyyMMddの形式、または関数を使用してください。Today()`,
"c1247":`選択された承認者全員の一致した承認が必要です。`,
"c1514":`役割山東一`,
"c233":`出荷状態のパッキングリストは削除できません`,
"c458":`アカウント分布図`,
"c697":`アカウントアドレス{名前}を選択してください。`,
"c1701":`基本アドレス`,
"c476":`招待コードを送信する社員を選択する`,
"c634":`魅力的な投稿をし、世界とつながる`,
"c1567":`8桁以内の正しい番号をご入力ください。`,
"c1288":`レコメンデーションポリシールール`,
"c1607":`日付・時刻フィールドのプロパティ`,
"c1166":`カスタマイズ`,
"c144":`終了時刻が2038年を超えることはできません。新しい終了時刻を選択してください。`,
"c1032":`為替レートによる換算値`,
"c474":`リードの割り当てルールを使用することで再割り当てが可能です。割り当てルールについては、以下を参照してください。`,
"c371":`機会への同期`,
"c420":`メンテナンス資産`,
"c620":`複数のコンテンツをまとめて分析し、1つのマーケティング活動を行うために使用されます。`,
"c1643":`グループロールの置き換え`,
"c708":`スケールを統一するかしないか`,
"c100":`割引`,
"c576":`2次元カラムチャート`,
"c751":`契約締切日`,
"c1132":`ラベルを入力してください`,
"c252":`コンプライアンス設定`,
"c1562":`変更なし`,
"c699":`新規限定`,
"c74":`リベートで支払う`,
"c1778":`撮影可能枚数`,
"c805":`ソーシャルネットワークを選んで始める。`,
"c452":`事例紹介`,
"c740":`招待状を送る社員を選択してください。`,
"c596":`2軸チャート`,
"c1508":`リメンバー`,
"c1137":`アサインメントの削除`,
"c1636":`サービスレポートテンプレート`,
"c1792":`再割り付け操作`,
"c832":`レビュー`,
"c971":`発売予定`,
"c262":`沿革`,
"c363":`センシティブ`,
"c1117":`この操作を行うと、このワークフロールールは完全に削除されます。続行しますか？`,
"label.singleSignOn.is.invalid":`ログインフリーが無効`,
"c1941":`ライトニングバージョン（PC版`,
"c72":`第三者支払`,
"c1870":``,
"c292":`マーケティング`,
"c1874":``,
"c1131":`新しいパーミッションの設定`,
"c1807":``,
"c1349":`コピーワークフロー`,
"c499":`お客様に感動を与える効率的な接客`,
"c574":`スタックバーチャート`,
"c1593":`URLフィールドのプロパティ`,
"c618":`この投稿の内容や公開時間を変更する。  Twitterでは、24時間以内に同じ内容の投稿を複数回公開することはできません。`,
"front-setting-phone-format":`電話番号を正しい形式で入力してください。`,
"c460":`アカウントサイズランキング`,
"c189":`請求書の通貨は、注文書の通貨と一致している必要があります。通貨を絞り込んで、再度保存してください。`,
"label.exe.supported.request.rejected":`exe.ファイルの送信はサポートされていません。リクエストが拒否されました`,
"c835":`この見積もりには、すでに請求書が存在します。続けるかどうか？`,
"c1907":`1.テンプレートをダウンロードする。オブジェクトの選択（現在のオブジェクトのテンプレートをダウンロードすることができます。）`,
"c1720":`補助的なフィールドの検索`,
"c1850":``,
"c655":`投稿者`,
"c1513":`所有者はbiysuat普通と等しい`,
"c1781":`承認ステップを定義する際、承認依頼を異なるユーザーに割り当てることができます。オプションの1つは、ユーザーフィールドを使用してこれらの要求を自動的に送信することです。`,
"c1392":`終了日を入力してください。`,
"c45":`で接続する`,
"c1821":``,
"c43":`接続アカウント`,
"c1534":`必須情報レイアウトフィールドを空にすることはできません。`,
"c481":`別のユーザーでサインインする`,
"c674":`外部アドレス`,
"c266":`この注文は完了したため、変更することはできません。`,
"c967":`0}のアカウントを切断します。このアカウントに関連するすべてのソーシャルメディア設定とパブリッシングオプションが削除されます。`,
"c1010":`非アクティブ化`,
"c1769":`日付}までの有効期限`,
"c154":`製品を選択後、プライスブックを検索してください。`,
"c841":`アイデアをお持ちですか？どんどん書き込んでください。   `,
"c615":`アカウントが選択されていません`,
"c1416":`10進数フォーマットエラー`,
"c84":`招待コードを送信する社員を選択する`,
"c401":`サービス`,
"c290":`有効なオブジェクト`,
"c1733":`ディスパッチ`,
"c205":`QRコードのダウンロード`,
"c928":`最大10フィールドまで選択可能です。`,
"c195":`提出期限`,
"1":`利用可能なアクションなし`,
"c1224":`不十分なアクセス許可は、マルチ組織構成ライブラリのユーザーテーブル情報、ロールID：{id}の下にロールを設定するシステム管理者に連絡してください。`,
"c46":`オーソライズ成功`,
"c459":`契約金額`,
"c1387":`未使用のフィールド`,
"c1394":`オプションリストの値を編集する`,
"c1274":`グローバルオプションリストセットの編集`,
"c1528":`以上`,
"c250":`投稿が下書きとして保存される`,
"c399":`インベントリー`,
"c1107":`アドバンストフィルターの条件チェックに失敗しました、再チェックしてください`,
"c1589":`テキストエリア・フィールドのプロパティ`,
"c1774":`設定されたフィールド`,
"c1034":`オブジェクト名が長すぎる`,
"c518":`ラベルの#recordNameは#failReasonで承認に失敗しました。`,
"c396":`さまざまなソリューションを選択する`,
"c300":`破壊依頼者`,
"c789":`Unrestricted Signature Method（アンリミテッド・シグネチャー・メソッド`,
"c874":`受信箱の中身はすべて読んでいるはずです。`,
"c1955":``,
"c38":`地域ブロック番号`,
"c228":`サブタスクの追加`,
"c1122":`レコードの作成・編集時に初めてルール条件を満たした場合`,
"c342":`利益`,
"c1747":`ログインをクリックすると初期化されます`,
"c1703":`アルバムからの画像アップロードの可否`,
"c879":`ソーシャル投稿のクローン`,
"c173":`リバインドに成功`,
"c1089":`全記録`,
"c1354":`ページレイアウト名`,
"c778":`イニシエーター`,
"c1594":`要求する`,
"c1334":`SMSゲートウェイのパスワード(MD5)`,
"c1946":``,
"c1515":`標準ボタンやリンクの書き換えは、CloudCC URLと、そのURLへのすべての呼び出し（CloudCCページ、ブラウザショートカット、外部システムなど）の意味を変更します。
標準ボタンやリンクされたCloudCC URLをCloudCCのカスタムページで置き換えることができます。
この標準ボタンまたはリンクされたCloudCC URLを置き換えるカスタムページを選択してください。`,
"c211":`小型`,
"c1601":`ピックリストフィールドのプロパティ`,
"c1159":`最初の実行時間は#時間、その後#数分ごとに実行されます。`,
"c1825":``,
"c1478":`ルール名を入力し、有効チェックボックスを選択すると、このルールが症例の自動アップグレードに使用されます。
このルールを有効にすると、現在の症例アップグレード・ルールが無効になります。`,
"c1388":`新規フィールドの作成`,
"c496":`CloudCC Sales Cloud営業目標の達成を支援する、あらゆるシーンに対応するスマートCRM`,
"c1085":`プロフィール編集`,
"c427":`ガントチャートモードでのディスパッチ`,
"c851":`選択した期間内にアカウント全体で公開された投稿の数が表示されます。`,
"c32":`新規加入タイプ`,
"c1953":``,
"c1165":`名刺`,
"c28":`前年同期比`,
"c163":`派遣の通知とキャンセルを同時に行う`,
"c1772":`オンラインケース`,
"c1743":`カスタムログアウトページ`,
"c1863":``,
"c225":`タスクに移動する`,
"c569":`最初にアカウントを選択してください`,
"c1317":`この操作を行うと、このワークフローは無効になります。続行しますか？`,
"c92":`1回オープン`,
"c1706":`実際のシナリオに沿った組織レベルのホームページの構成`,
"c412":`サービス予約の自動作成`,
"c81":`カートに入れる`,
"c999":`携帯電話番号またはパスワードが違う`,
"c653":`公開した投稿に対する「いいね！」「リアクション」「コメント」の数が表示されます。CloudCC以外の接続アカウントに公開された投稿も含まれます。 Twitterのリツイートを探す場合は、「共有」に表示されます。`,
"c1762":`エクステンションフィールド`,
"c1467":`Fiscal Year name は正の整数でなければならない。`,
"c1647":`オポチュニティグループの設定`,
"c516":`出席者数`,
"c1241":`個人情報の編集を許可する、または転送する`,
"c1459":`ダウンロードし、ファイルに保存します。`,
"c918":`オートリサイクルルールが設定されている場合、アカウントが制限時間を過ぎても取引を成立させなかった場合、システムが自動的に記録をプールに再作成します。それにより、アカウントのフォローアップの効率が向上します。`,
"c809":`LIKES`,
"c1570":`エクスポートの例外`,
"c1532":`機能選択`,
"c1192":`ワークフローのルールや設計図、承認プロセスなどを実行する際に、ユーザーに割り当てるタスクのことです。`,
"c181":`ワークオーダーまたはケースレコードを記入してください`,
"c745":`小数点以下2桁まで入力してください。`,
"c669":`カラー`,
"c929":`ネットワーク接続を確認してください`,
"c117":`セーブ＆ペイ`,
"c1240":`Partner Cloud の役割とユーザー設定ユーザー役割の数`,
"c938":`中国本土`,
"c112":`現在、すべての{name}テンプレートが無効になっています。名前}を生成する前に、管理者に連絡してテンプレートを有効にしてください。`,
"c347":`プロジェクトタスクの作業時間変更`,
"c795":`契約書のテンプレートを選択してください`,
"c1631":`アクセス設定`,
"c17":`アクティブではありません。再選択してください。`,
"c787":`オペレーターのサイン`,
"c829":`キャンペーン`,
"c1929":`記事翻訳  翻訳を提出する`,
"c1041":`3.ファイルの種類`,
"c161":`また、情報`,
"c1936":`フィールド条件が設定されていない場合は、すべてのレコードが表示されます。`,
"c65":`製品の物流状況を「配送済み」に変更しますか？`,
"c1958":``,
"c1843":`接続`,
"c1823":``,
"c665":`もう一枚追加`,
"c767":`サイン進捗の確認`,
"c87":`キャンペーンフォームのQRコード`,
"c589":`フランス地図`,
"c1343":`現在、無料版をご利用いただいております。1日あたりのAPIクエリ数の上限は10,000です。
クエリ数を拡張する必要がある場合は、サービスの購入をお勧めします。
サービス購入後、メーカーからトークンを取得してこのページで設定すると、メーカーから対応する有償サービスが提供されます。
ご購入・お問い合わせは、4006422008までお願いします。`,
"c1405":`Eメール結合テンプレートは、Microsoft Word文書であり、結合フィールドはCloudCCフィールドを指します。New Template をクリックすると、新しい Email マージテンプレートがアップロードされます。`,
"front-electronic-signature-newTime":`最終更新日`,
"c813":`シェア`,
"c85":`{メンバー｝インビター選択`,
"c951":`ポーランド`,
"c1853":``,
"c1788":`を入力し、ENTERを押すと検索されます。`,
"c29":`前月比成長率`,
"c1170":`関連リストに表示されている標準ボタンを選択します。選択したボタンは、並べ替えも可能です。`,
"c210":`大きいサイズ`,
"c1615":`インポートクォータ`,
"c39":`アーカイブス`,
"c672":`ワード`,
"c97":`このピックリストには、少なくとも1つの「変換済み」オプションが含まれている必要があります。`,
"c687":`最大サイズ`,
"c1646":`レコードタイプ名`,
"c916":`クローズドプール`,
"c475":`キャンペーンオーナーをご記入ください`,
"c1376":`どうしたいですか？`,
"c1097":`適用ルール`,
"c1812":`はじめに`,
"c1486":`開始時間`,
"c628":`予定`,
"c788":`この機会のための価格帳簿は現在無効になっています。新しい注文を作成する前に、プライスブックを有効にしてください。`,
"c1030":`パッケージ内の製品`,
"c1670":`リソース環境設定`,
"c1436":`レイアウトを選択`,
"c1302":`イベント同期方向`,
"c1768":`修正`,
"c1902":`背面`,
"c177":`推奨サイズ：390*210`,
"c1859":``,
"c856":`イエーイ!失敗した投稿はありません。`,
"c1782":`このオプションを任意の承認ステップに適用するには、以下のリストからフィールドを選択してください。`,
"c70":`ご注文について`,
"c1533":`ラベルを空にすることはできません。`,
"c1141":`ライセンス形態`,
"c546":`過去24時間`,
"c1447":`選択したユーザーリストから、すべての未割り当てのユーザーと有効なユーザー、およびすべての未割り当てのユーザーにユーザーを削除することはできません`,
"c331":`コンバートアセット`,
"label.order.paidamount.greater.than.total":`新しいお支払い情報が作成された後、ご注文金額よりも返金額の方が大きくなってしまいます。お手数ですが、お支払い内容を再調整してから保存してください。`,
"c524":`Reinvite`,
"c1456":`このロールに他のユーザーを割り当てるには`,
"c1758":`写真の総容量は20MBを超えることはできません。`,
"c1175":`必須項目として設定する`,
"c1547":`未使用値の表示・追加`,
"c1717":`新しい作業指示書{0}を受け取りました。クリックして表示し、時間内に処理してください。`,
"c246":`{!oldServiceResource.name}は{!ServiceAppointment.name}というワークオーダー番号をあなたに転送しました。`,
"c986":`マニュアルのダウンロード`,
"c1748":`既存ユーザー`,
"label.parameter.is.incorrect":`誤ったパラメータ`,
"c1242":`関連リスト名`,
"c1687":`トピックス`,
"c1591":`フィールド名は文字で始まり、大文字、小文字、数字、アンダースコア、最大長{maxApinameLength}、最小2桁の数字のみを含むことができます。`,
"c667":`アイコンスペーシング`,
"c1817":``,
"c1375":`このレイアウトで削除したいフィールドを削除するか、左側の未使用フィールドペインに移動します。`,
"c737":`ソーシャルプラットフォーム`,
"c1695":`デベロッパースペース`,
"c48":`ディスコネクト`,
"c111":`名前}を生成する`,
"c1582":`ジャーマン`,
"c755":`順番に`,
"c1333":`トリガーを追加する`,
"c526":`ポータルユーザーを有効にする`,
"c450":`ケースの統合`,
"front-electronic-export-reChoseChimp":`現在のビューにはデータレコードがないため、エクスポートできません。新しいビューを選択してください。`,
"c1759":`モバイルサービスクラウドのアイコン`,
"label.invoice.paidamount.greater.than.total":`新しい支払明細を作成した後、請求書の返金額が合計金額よりも大きくなってしまいます。お手数ですが、お支払い内容を再調整してから保存してください。`,
"c1688":`対象物`,
"c222":`編集プロジェクト`,
"c849":`Twitterアカウント`,
"c1549":`一括追加選択`,
"c1369":`タイトルが表示されない`,
"c678":`ブラック＆ホワイト`,
"c502":`フィールドサービスに関わる全プロセスを処理する包括的なソリューションを提供し、業務の合理化、生産性の向上、顧客ロイヤルティの向上と満足度の向上を実現します。`,
"c1476":`削除しました。`,
"c1052":`ページレイアウトのテンプレート変更`,
"c497":`よりスマートな在庫管理、より強力なビジネスと財務管理`,
"c1458":`ファイルに保存する`,
"c1815":``,
"c200":`ソーシャルメディアで共有する`,
"c1893":``,
"c1258":`SMS通知用のテンプレートを選択してください。`,
"c1272":`すべて隠す`,
"c658":`リッチテキスト`,
"c434":`新規関連コンタクト`,
"c1848":``,
"c641":`画像は4枚までしか選択できません。選択した画像をクリックすると選択解除されます。アップロードする画像のサイズは200kb以下にしてください。`,
"c944":`ドイツ`,
"c1221":`本当に削除するのですか？`,
"c411":`期限オフセット`,
"c1114":`挿入するフィールドを選択する`,
"c1353":`APIキーとAPIシークレットを見つけるには、Vonage APIアカウントにログインし、アカウント名の下にあるSettingsに進みます。
Vonage APIアカウントの電話番号を見つけるには、productsの下にあるnumberに行き、自分の番号をクリックすると、持っているすべての電話番号を見ることができます。`,
"c1776":`デフォルトのリンク有効期限`,
"c1565":`新規カスタムオブジェクト`,
"c1619":`オンライン決済の設定`,
"c1115":`ワークフロールールの名称を入力する`,
"c624":`すべてのアカウント`,
"label.twitter.title":`TwitterH5 MiniApp`,
"c1319":`制限解除`,
"c1696":`インストールされているソフトウェアパッケージ`,
"c1746":`認定された発行者`,
"c791":`スタンダードサイン`,
"c1965":``,
"c1728":`スコア・フィールドの特性`,
"c306":`同意`,
"c14":`現在のユーザーには、削除する権限がありません。`,
"c176":`アップロードできる画像は、png, jpg, jpegのみです。アップロードする画像は2Mを超えることはできません。`,
"c1335":`スタートキャラクター`,
"c997":`SKU機能一覧`,
"c1233":`すべての未割り当てユーザー`,
"c1566":`文字で始まり、大文字と小文字、数字、アンダースコアのみ使用可能、最大長30、最小2桁、データベース内のキーワードは使用不可`,
"c166":`ルールに従って、最大注文長を入力してください。`,
"c731":`選択したプライスブックを変更すると、既存の商品もすべて削除されます。本当に新しいプライスブックに変更しますか？`,
"c237":`{ServiceResource.name}は注文を受け付けました。番号: "{!ServiceAppointment.name}"(サービスアポイントメントネーム)`,
"c887":`ユーザー再招待に成功`,
"c1418":`ステップ1: コントロールフィールドと従属フィールドを選択します。
終了後、Continueをクリックします。`,
"c227":`サブタスクの編集`,
"c1674":`評価項目`,
"c257":`利用可能な連絡先`,
"c1867":``,
"c1864":`ユーザー1`,
"c712":`ネットワーク、投稿、キャンペーン全体のパフォーマンスをレポートし、比較することができます。`,
"c107":`名前、アカウント、携帯電話番号からユーザーを検索することができます。`,
"c1767":`リンク有効期限`,
"c1310":`タスクコンフリクト行動`,
"c1627":`WeChatミニプログラム`,
"c1266":`カスタムアプリケーションに追加`,
"c1262":`最終編集`,
"c370":`契約`,
"c1878":``,
"c1784":`パンチインしてください。(すでにパンチインされている場合は無視します)`,
"c895":`距離の計算に失敗しました。完全な住所を入力してください。`,
"c1029":`製品構成`,
"c693":`オートレギュレーション`,
"c763":`サイン入り`,
"c302":`正当な利益`,
"c577":`スタックドコラムチャート`,
"c258":`お問い合わせ`,
"c1757":`写真に関する制限を許可する`,
"c1879":``,
"c676":`センター`,
"c1609":`電子メールフィールドのプロパティ`,
"c868":`このアカウントを無効にした後、システムはあなたのポータルでのアクセスまたは操作を制限します。続ける？`,
"c53":`比率(%)`,
"c527":`#ユーザー名から承認タスクが割り当てられました。`,
"c1816":``,
"c1579":`やまと`,
"c984":`ネットワークが接続されている`,
"c1021":`2.価格表は、商談、見積書、注文書、請求書、発注書の商品価格に影響を与える可能性があります。上記の5つのオブジェクトが価格表に関連付けられている場合、営業担当者は価格表でデフォルトの価格とされている商品のみを選択することができます。`,
"label.facebook.title.setting":`Facebook統合情報`,
"c1888":``,
"c340":`プロジェクト計画書の所有者を変更する`,
"c1764":`オンラインケースのQRコード`,
"c1868":`正しいメールアドレスを入力してください`,
"c706":`チャートについて`,
"label.mobile.used":`携帯電話の番号が使用されている`,
"c328":`アセットQRコード`,
"c1761":`個人のお客様`,
"c337":`連絡先  破棄`,
"c1605":`電話番号フィールドのプロパティ`,
"c1935":`許可されていません。管理者に連絡してください。`,
"c642":`最近の画像`
}